export const TOKEN_LIST = [
  {
    chainId: 1,
    name: 'Peercoin',
    address: '0x044d078F1c86508e13328842Cc75AC021B272958',
    decimals: 18,
    symbol: 'PPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5.png',
  },
  {
    chainId: 1,
    name: 'Public Index Network',
    address: '0xc1f976B91217E240885536aF8b63bc8b5269a9BE',
    decimals: 18,
    symbol: 'PIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/64.png',
  },
  {
    chainId: 1,
    name: 'Magic Internet Money',
    address: '0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3',
    decimals: 18,
    symbol: 'MIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/162.png',
  },
  {
    chainId: 1,
    name: 'Bela',
    address: '0x2e98a6804e4b6c832ed0ca876a943abd3400b224',
    decimals: 18,
    symbol: 'BELA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/217.png',
  },
  {
    chainId: 1,
    name: 'SolarCoin',
    address: '0x4e9e4ab99cfc14b852f552f5fb3aa68617825b6c',
    decimals: 18,
    symbol: 'SLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/233.png',
  },
  {
    chainId: 1,
    name: 'Scotcoin',
    address: '0x28ed4FD6DeDB226B16b92CE6997f7CdfDf0c519B',
    decimals: 6,
    symbol: 'SCOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/346.png',
  },
  {
    chainId: 1,
    name: 'GameCredits',
    address: '0x63f88a2298a5c4aee3c216aa6d926b184a4b2437',
    decimals: 18,
    symbol: 'GAME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/576.png',
  },
  {
    chainId: 1,
    name: 'Okcash',
    address: '0xd3Ac016b1B8C80EeAdDe4D186A9138C9324e4189',
    decimals: 18,
    symbol: 'OK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/760.png',
  },
  {
    chainId: 1,
    name: 'Circuits of Value',
    address: '0x3d658390460295fb963f54dc0899cfb1c30776df',
    decimals: 18,
    symbol: 'COVAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/788.png',
  },
  {
    chainId: 1,
    name: 'Tether USDt',
    address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    decimals: 18,
    symbol: 'USDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
  },
  {
    chainId: 1,
    name: 'Xaurum',
    address: '0x4DF812F6064def1e5e029f1ca858777CC98D2D81',
    decimals: 8,
    symbol: 'XAUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/895.png',
  },
  {
    chainId: 1,
    name: 'Gambit',
    address: '0xf67451dc8421f0e0afeb52faa8101034ed081ed9',
    decimals: 8,
    symbol: 'GAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/939.png',
  },
  {
    chainId: 1,
    name: 'Manna',
    address: '0xf3b92739d5c8C88281D44c91BEb2F4E8E5E5cB7E',
    decimals: 18,
    symbol: 'MANNA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1019.png',
  },
  {
    chainId: 1,
    name: 'Agoras: Currency of Tau',
    address: '0x738865301a9b7dd80dc3666dd48cf034ec42bdda',
    decimals: 8,
    symbol: 'AGRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1037.png',
  },
  {
    chainId: 1,
    name: 'KWD',
    address: '0x24B4440c60B512eadd0D093367A46dbbE2f6540E',
    decimals: 18,
    symbol: 'KWD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1044.png',
  },
  {
    chainId: 1,
    name: 'BitCrystals',
    address: '0xadbbb02e20c44779e87f7ea90c47c9a7a8a93fee',
    decimals: 8,
    symbol: 'BCY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1063.png',
  },
  {
    chainId: 1,
    name: 'Augur',
    address: '0x1985365e9f78359a9B6AD760e32412f4a445E862',
    decimals: 18,
    symbol: 'REP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1104.png',
  },
  {
    chainId: 1,
    name: 'Creditbit',
    address: '0xAef38fBFBF932D1AeF3B808Bc8fBd8Cd8E1f8BC5',
    decimals: 8,
    symbol: 'CRB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1153.png',
  },
  {
    chainId: 1,
    name: 'DigixDAO',
    address: '0xe0b7927c4af23765cb51314a0e0521a9645f0e2a',
    decimals: 9,
    symbol: 'DGD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1229.png',
  },
  {
    chainId: 1,
    name: 'AquariusCoin',
    address: '0x9ad4d28cf045deb68377bab20f2b652ae41c9bce',
    decimals: 18,
    symbol: 'ARCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1247.png',
  },
  {
    chainId: 1,
    name: 'Alphabit',
    address: '0x036407F23D5E1C1486F7488332CF54bf06E5F09F',
    decimals: 18,
    symbol: 'ABC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1256.png',
  },
  {
    chainId: 1,
    name: 'ION',
    address: '0xee59B43149CEAD680aedF8778163ce8CB8c8A6fB',
    decimals: 6,
    symbol: 'ION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1281.png',
  },
  {
    chainId: 1,
    name: 'Golfcoin',
    address: '0x020c710646e23ab868dbe5b88004892797fe4efb',
    decimals: 18,
    symbol: 'GOLF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1375.png',
  },
  {
    chainId: 1,
    name: 'Pluton',
    address: '0xd8912c10681d8b21fd3742244f44658dba12264e',
    decimals: 18,
    symbol: 'PLU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1392.png',
  },
  {
    chainId: 1,
    name: 'FirstBlood',
    address: '0xaf30d2a7e90d7dc361c8c4585e9bb7d2f6f15bc7',
    decimals: 18,
    symbol: '1ST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1403.png',
  },
  {
    chainId: 1,
    name: 'Golem',
    address: '0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429',
    decimals: 18,
    symbol: 'GLM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1455.png',
  },
  {
    chainId: 1,
    name: 'Round',
    address: '0x4993CB95c7443bdC06155c5f5688Be9D8f6999a5',
    decimals: 18,
    symbol: 'ROUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1461.png',
  },
  {
    chainId: 1,
    name: 'Hydraledger',
    address: '0x9b932B4fDD6747c341A71A564C7073fd4d0354D5',
    decimals: 18,
    symbol: 'HYD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1464.png',
  },
  {
    chainId: 1,
    name: 'Veros',
    address: '0xAbC430136A4dE71c9998242de8c1b4B97D2b9045',
    decimals: 6,
    symbol: 'VRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1465.png',
  },
  {
    chainId: 1,
    name: 'Arcade Token',
    address: '0xac709fcb44a43c35f0da4e3163b117a17f3770f5',
    decimals: 18,
    symbol: 'ARC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1467.png',
  },
  {
    chainId: 1,
    name: 'Nexium',
    address: '0x45e42D659D9f9466cD5DF622506033145a9b89Bc',
    decimals: 3,
    symbol: 'NXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1481.png',
  },
  {
    chainId: 1,
    name: 'Obyte',
    address: '0x31F69dE127C8A0fF10819C0955490a4Ae46fcc2a',
    decimals: 18,
    symbol: 'GBYTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1492.png',
  },
  {
    chainId: 1,
    name: 'Bitpark Coin',
    address: '0xf3d29fb98d2dc5e78c87198deef99377345fd6f1',
    decimals: 8,
    symbol: 'BPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1494.png',
  },
  {
    chainId: 1,
    name: 'Wings',
    address: '0x667088b212ce3d06a1b553a7221E1fD19000d9aF',
    decimals: 18,
    symbol: 'WINGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1500.png',
  },
  {
    chainId: 1,
    name: 'Jupiter',
    address: '0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8',
    decimals: 18,
    symbol: 'JUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1503.png',
  },
  {
    chainId: 1,
    name: 'Maker',
    address: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
    decimals: 18,
    symbol: 'MKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1518.png',
  },
  {
    chainId: 1,
    name: 'Centurion',
    address: '0x23c90dbf4fC282e352B75CC13d095Cc2496D3271',
    decimals: 18,
    symbol: 'CNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1546.png',
  },
  {
    chainId: 1,
    name: 'Enzyme',
    address: '0xec67005c4e498ec7f55e092bd1d35cbc47c91892',
    decimals: 18,
    symbol: 'MLN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1552.png',
  },
  {
    chainId: 1,
    name: 'Chrono.tech',
    address: '0x485d17A6f1B8780392d53D64751824253011A260',
    decimals: 18,
    symbol: 'TIME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1556.png',
  },
  {
    chainId: 1,
    name: 'Swarm City',
    address: '0xb9e7f8568e08d5659f5d29c4997173d84cdf2607',
    decimals: 18,
    symbol: 'SWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1562.png',
  },
  {
    chainId: 1,
    name: 'TaaS',
    address: '0xe7775a6e9bcf904eb39da2b68c5efb4f9360e08c',
    decimals: 6,
    symbol: 'TAAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1592.png',
  },
  {
    chainId: 1,
    name: 'Soarcoin',
    address: '0xD65960FAcb8E4a2dFcb2C2212cb2e44a02e2a57E',
    decimals: 6,
    symbol: 'SOAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1595.png',
  },
  {
    chainId: 1,
    name: 'Matchpool',
    address: '0xf7b098298f7c69fc14610bf71d5e02c60792894c',
    decimals: 3,
    symbol: 'GUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1616.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Movie Venture',
    address: '0xB802b24E0637c2B87D2E8b7784C055BBE921011a',
    decimals: 2,
    symbol: 'EMV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1625.png',
  },
  {
    chainId: 1,
    name: 'HappyPay',
    address: '0xEeE690AAA67d1eE33365c02C3Bf477A93867052f',
    decimals: 18,
    symbol: 'HPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1628.png',
  },
  {
    chainId: 1,
    name: 'iExec RLC',
    address: '0x607f4c5bb672230e8672085532f7e901544a7375',
    decimals: 9,
    symbol: 'RLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1637.png',
  },
  {
    chainId: 1,
    name: 'WeTrust',
    address: '0xcb94be6f13a1182e4a4b6140cb7bf2025d28e41b',
    decimals: 6,
    symbol: 'TRST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1638.png',
  },
  {
    chainId: 1,
    name: 'AMIS',
    address: '0x949bEd886c739f1A3273629b3320db0C5024c719',
    decimals: 9,
    symbol: 'AMIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1639.png',
  },
  {
    chainId: 1,
    name: 'GoldUnionCoin',
    address: '0xfd399192a8dc99aad26052be7db95ffacc17f11c',
    decimals: 16,
    symbol: 'GUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1648.png',
  },
  {
    chainId: 1,
    name: 'SpeedCash',
    address: '0x81995ff7AEe5c780192b47e0B42a7a86692d1415',
    decimals: 18,
    symbol: 'SCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1651.png',
  },
  {
    chainId: 1,
    name: 'Lunyr',
    address: '0xfa05A73FfE78ef8f1a739473e462c54bae6567D9',
    decimals: 18,
    symbol: 'LUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1658.png',
  },
  {
    chainId: 1,
    name: 'Gnosis',
    address: '0x6810e776880c02933d47db1b9fc05908e5386b96',
    decimals: 18,
    symbol: 'GNO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1659.png',
  },
  {
    chainId: 1,
    name: 'Monolith',
    address: '0xaaaf91d9b90df800df4f55c205fd6989c977e73a',
    decimals: 8,
    symbol: 'TKN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1660.png',
  },
  {
    chainId: 1,
    name: 'Unity Ingot',
    address: '0x1a986F1659e11E2AE7CC6543F307bAE5cDe1C761',
    decimals: 2,
    symbol: 'UNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1667.png',
  },
  {
    chainId: 1,
    name: 'Humaniq',
    address: '0xcbcc0f036ed4788f63fc0fee32873d6a7487b908',
    decimals: 8,
    symbol: 'HMQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1669.png',
  },
  {
    chainId: 1,
    name: 'Minereum',
    address: '0x426ca1ea2406c07d75db9585f22781c096e3d0e0',
    decimals: 8,
    symbol: 'MNE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1673.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Palladium',
    address: '0xEd376501F61046A3f43Dac6d5Ab51A700dda46fc',
    decimals: 18,
    symbol: 'BTCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1674.png',
  },
  {
    chainId: 1,
    name: 'Etheroll',
    address: '0x2e071D2966Aa7D8dECB1005885bA1977D6038A65',
    decimals: 16,
    symbol: 'DICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1677.png',
  },
  {
    chainId: 1,
    name: 'Aragon',
    address: '0xa117000000f279d81a1d3cc75430faa017fa5a2e',
    decimals: 18,
    symbol: 'ANT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1680.png',
  },
  {
    chainId: 1,
    name: 'RouletteToken',
    address: '0xcced5b8288086be8c38e23567e684c3740be4d48',
    decimals: 10,
    symbol: 'RLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1683.png',
  },
  {
    chainId: 1,
    name: 'EcoCoin',
    address: '0x081271acda8ef14047a35cd5f2a66544e51d431b',
    decimals: 18,
    symbol: 'ECO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1685.png',
  },
  {
    chainId: 1,
    name: 'MCAP',
    address: '0x93e682107d1e9defb0b5ee701c71707a4b2e46bc',
    decimals: 8,
    symbol: 'MCAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1690.png',
  },
  {
    chainId: 1,
    name: 'Basic Attention Token',
    address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
    decimals: 18,
    symbol: 'BAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1697.png',
  },
  {
    chainId: 1,
    name: 'Ethbits',
    address: '0x1b9743f556d65e757c4c650b4555baf354cb8bd3',
    decimals: 12,
    symbol: 'ETBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1699.png',
  },
  {
    chainId: 1,
    name: 'Patientory',
    address: '0x8ae4bf2c33a8e667de34b54938b0ccd03eb8cc06',
    decimals: 8,
    symbol: 'PTOY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1708.png',
  },
  {
    chainId: 1,
    name: 'Quantum',
    address: '0x671abbe5ce652491985342e85428eb1b07bc6c64',
    decimals: 8,
    symbol: 'QAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1709.png',
  },
  {
    chainId: 1,
    name: 'Veritaseum',
    address: '0x8f3470A7388c05eE4e7AF3d01D8C722b0FF52374',
    decimals: 18,
    symbol: 'VERI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1710.png',
  },
  {
    chainId: 1,
    name: 'MobileGo',
    address: '0x40395044Ac3c0C57051906dA938B54BD6557F212',
    decimals: 8,
    symbol: 'MGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1715.png',
  },
  {
    chainId: 1,
    name: 'Mysterium',
    address: '0x4Cf89ca06ad997bC732Dc876ed2A7F26a9E7f361',
    decimals: 18,
    symbol: 'MYST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1721.png',
  },
  {
    chainId: 1,
    name: 'More Coin',
    address: '0x305DE070488C8469dFAC957226c9c900c4BFbA22',
    decimals: 8,
    symbol: 'MORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1722.png',
  },
  {
    chainId: 1,
    name: 'Adelphoi',
    address: '0x660e71483785f66133548B10f6926dC332b06e61',
    decimals: 18,
    symbol: 'ADL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1725.png',
  },
  {
    chainId: 1,
    name: 'Bancor',
    address: '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c',
    decimals: 18,
    symbol: 'BNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1727.png',
  },
  {
    chainId: 1,
    name: 'Cofound.it',
    address: '0x12fef5e57bf45873cd9b62e9dbd7bfb99e32d73e',
    decimals: 18,
    symbol: 'CFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1729.png',
  },
  {
    chainId: 1,
    name: 'Numeraire',
    address: '0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671',
    decimals: 18,
    symbol: 'NMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1732.png',
  },
  {
    chainId: 1,
    name: 'iDice',
    address: '0x5a84969bb663fb64F6d015DcF9F622Aedc796750',
    decimals: 18,
    symbol: 'ICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1735.png',
  },
  {
    chainId: 1,
    name: 'ATC Coin',
    address: '0xddaaf4a0702a03a4505f2352a1aba001ffc344be',
    decimals: 18,
    symbol: 'ATCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1751.png',
  },
  {
    chainId: 1,
    name: 'Goodomy',
    address: '0xaE616e72D3d89e847f74E8ace41Ca68bbF56af79',
    decimals: 6,
    symbol: 'GOOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1752.png',
  },
  {
    chainId: 1,
    name: 'FUNToken',
    address: '0x419d0d8bdd9af5e606ae2232ed285aff190e711b',
    decimals: 18,
    symbol: 'FUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1757.png',
  },
  {
    chainId: 1,
    name: 'TenX',
    address: '0xb97048628db6b661d4c2aa833e95dbe1a905b280',
    decimals: 18,
    symbol: 'PAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1758.png',
  },
  {
    chainId: 1,
    name: 'Status',
    address: '0x744d70fdbe2ba4cf95131626614a1763df805b9e',
    decimals: 18,
    symbol: 'SNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1759.png',
  },
  {
    chainId: 1,
    name: 'AdEx',
    address: '0xade00c28244d5ce17d72e40330b1c318cd12b7c3',
    decimals: 18,
    symbol: 'ADX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1768.png',
  },
  {
    chainId: 1,
    name: 'Remicoin',
    address: '0x7Dc4f41294697a7903C4027f6Ac528C5d14cd7eB',
    decimals: 8,
    symbol: 'RMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1770.png',
  },
  {
    chainId: 1,
    name: 'Storj',
    address: '0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac',
    decimals: 8,
    symbol: 'STORJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1772.png',
  },
  {
    chainId: 1,
    name: 'adToken',
    address: '0xd0d6d6c5fe4a677d343cc433536bb717bae167dd',
    decimals: 9,
    symbol: 'ADT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1775.png',
  },
  {
    chainId: 1,
    name: 'MCO',
    address: '0xb63b606ac810a52cca15e44bb630fd42d8d1d83d',
    decimals: 8,
    symbol: 'MCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1776.png',
  },
  {
    chainId: 1,
    name: 'CryptoPing',
    address: '0x21cd6af01383651ed10554394c0497f9db5e5dbc',
    decimals: 8,
    symbol: 'PING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1777.png',
  },
  {
    chainId: 1,
    name: 'Useless Ethereum Token',
    address: '0x27f706edde3aD952EF647Dd67E24e38CD0803DD6',
    decimals: 18,
    symbol: 'UET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1778.png',
  },
  {
    chainId: 1,
    name: 'Wagerr',
    address: '0xc237868a9c5729bdf3173dddacaa336a0a5bb6e0',
    decimals: 8,
    symbol: 'WGR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1779.png',
  },
  {
    chainId: 1,
    name: 'E4ROW',
    address: '0xce5c603c78d047ef43032e96b5b785324f753a4f',
    decimals: 2,
    symbol: 'E4ROW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1780.png',
  },
  {
    chainId: 1,
    name: 'Polybius',
    address: '0x0affa06e7fbe5bc9a764c979aa66e8256a631f02',
    decimals: 6,
    symbol: 'PLBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1784.png',
  },
  {
    chainId: 1,
    name: 'SunContract',
    address: '0xF4134146AF2d511Dd5EA8cDB1C4AC88C57D60404',
    decimals: 18,
    symbol: 'SNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1786.png',
  },
  {
    chainId: 1,
    name: 'Jetcoin',
    address: '0x8727c112c712c4a03371ac87a74dd6ab104af768',
    decimals: 18,
    symbol: 'JET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1787.png',
  },
  {
    chainId: 1,
    name: 'Metal DAO',
    address: '0xF433089366899D83a9f26A773D59ec7eCF30355e',
    decimals: 18,
    symbol: 'MTL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1788.png',
  },
  {
    chainId: 1,
    name: 'Populous',
    address: '0xd4fa1460f537bb9085d22c7bccb5dd450ef28e3a',
    decimals: 8,
    symbol: 'PPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1789.png',
  },
  {
    chainId: 1,
    name: 'ICO',
    address: '0xa33e729bf4fdeb868b534e1f20523463d9c46bee',
    decimals: 10,
    symbol: 'ICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1791.png',
  },
  {
    chainId: 1,
    name: 'Sphere Identity',
    address: '0xb110ec7b1dcb8fab8dedbf28f53bc63ea5bedd84',
    decimals: 8,
    symbol: 'XID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1795.png',
  },
  {
    chainId: 1,
    name: 'FuturXe',
    address: '0x9653cfd0865ad8313bea2f0c2ec0584bfd05115b',
    decimals: 8,
    symbol: 'FXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1798.png',
  },
  {
    chainId: 1,
    name: 'Santiment Network Token',
    address: '0x7c5a0ce9267ed19b22f8cae653f198e3e8daf098',
    decimals: 18,
    symbol: 'SAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1807.png',
  },
  {
    chainId: 1,
    name: 'OMG Network',
    address: '0xd26114cd6ee289accf82350c8d8487fedb8a0c07',
    decimals: 18,
    symbol: 'OMG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1808.png',
  },
  {
    chainId: 1,
    name: 'Rialto',
    address: '0xb24754be79281553dc1adc160ddf5cd9b74361a4',
    decimals: 9,
    symbol: 'XRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1812.png',
  },
  {
    chainId: 1,
    name: 'FuckToken',
    address: '0x65be44c747988fbf606207698c944df4442efe19',
    decimals: 4,
    symbol: 'FUCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1813.png',
  },
  {
    chainId: 1,
    name: 'Metrix Coin',
    address: '0xd38b1159c8aee064af2d869afa1c2c1632da8b97',
    decimals: 18,
    symbol: 'MRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1814.png',
  },
  {
    chainId: 1,
    name: 'Civic',
    address: '0x41e5560054824ea6b0732e656e3ad64e20e94e45',
    decimals: 8,
    symbol: 'CVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1816.png',
  },
  {
    chainId: 1,
    name: 'Voyager Token',
    address: '0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d',
    decimals: 8,
    symbol: 'VGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1817.png',
  },
  {
    chainId: 1,
    name: 'Link Platform',
    address: '0xe2e6d4be086c6938b53b22144855eef674281639',
    decimals: 18,
    symbol: 'LNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1820.png',
  },
  {
    chainId: 1,
    name: 'SkinCoin',
    address: '0x2bdc0d42996017fce214b21607a515da41a9e0c5',
    decimals: 6,
    symbol: 'SKIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1830.png',
  },
  {
    chainId: 1,
    name: 'Pillar',
    address: '0xe3818504c1b32bf1557b16c238b2e01fd3149c17',
    decimals: 18,
    symbol: 'PLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1834.png',
  },
  {
    chainId: 1,
    name: 'BNB',
    address: '0xb8c77482e45f1f44de1745f52c74426c631bdd52',
    decimals: 18,
    symbol: 'BNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
  },
  {
    chainId: 1,
    name: '300 Token',
    address: '0xaec98a708810414878c3bcdf46aad31ded4a4557',
    decimals: 18,
    symbol: '300',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1840.png',
  },
  {
    chainId: 1,
    name: 'IXT',
    address: '0xfca47962d45adfdfd1ab2d972315db4ce7ccf094',
    decimals: 8,
    symbol: 'IXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1845.png',
  },
  {
    chainId: 1,
    name: 'Mothership',
    address: '0x68aa3f232da9bdc2343465545794ef3eea5209bd',
    decimals: 18,
    symbol: 'MSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1847.png',
  },
  {
    chainId: 1,
    name: 'OAX',
    address: '0x701c244b988a513c945973defa05de933b23fe1d',
    decimals: 18,
    symbol: 'OAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1853.png',
  },
  {
    chainId: 1,
    name: 'district0x',
    address: '0x0abdace70d3790235af448c88547603b945604ea',
    decimals: 18,
    symbol: 'DNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1856.png',
  },
  {
    chainId: 1,
    name: 'Stox',
    address: '0x006BeA43Baa3f7A6f765F14f10A1a1b08334EF45',
    decimals: 18,
    symbol: 'STX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1861.png',
  },
  {
    chainId: 1,
    name: 'Etherx',
    address: '0x11025bAcDbF00e033880c95262bF501a62235F2E',
    decimals: 16,
    symbol: 'ETX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1862.png',
  },
  {
    chainId: 1,
    name: 'Blox',
    address: '0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af',
    decimals: 18,
    symbol: 'CDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1864.png',
  },
  {
    chainId: 1,
    name: 'Bytom',
    address: '0x4951beC6F4DFc23935C0Ec8Af92f231F4C20ea03',
    decimals: 8,
    symbol: 'BTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1866.png',
  },
  {
    chainId: 1,
    name: 'NEVERDIE',
    address: '0xa54ddc7b3cce7fc8b1e3fa0256d0db80d2c10970',
    decimals: 18,
    symbol: 'NDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1872.png',
  },
  {
    chainId: 1,
    name: 'Blocktix',
    address: '0xea1f346faf023f974eb5adaf088bbcdf02d761f4',
    decimals: 18,
    symbol: 'TIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1873.png',
  },
  {
    chainId: 1,
    name: 'Nexxus',
    address: '0x7627de4b93263a6a7570b8dafa64bae812e5c394',
    decimals: 8,
    symbol: 'NXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1875.png',
  },
  {
    chainId: 1,
    name: 'Dentacoin',
    address: '0x08d32b0da63e2C3bcF8019c9c5d849d7a9d791e6',
    decimals: 18,
    symbol: 'DCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1876.png',
  },
  {
    chainId: 1,
    name: 'BlockCAT',
    address: '0x56ba2Ee7890461f463F7be02aAC3099f6d5811A8',
    decimals: 18,
    symbol: 'CAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1882.png',
  },
  {
    chainId: 1,
    name: 'Adshares',
    address: '0xcfcecfe2bd2fed07a9145222e8a7ad9cf1ccd22a',
    decimals: 18,
    symbol: 'ADS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1883.png',
  },
  {
    chainId: 1,
    name: 'DigitalDevelopersFund',
    address: '0xcc4ef9eeaf656ac1a2ab886743e98e97e090ed38',
    decimals: 18,
    symbol: 'DDF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1884.png',
  },
  {
    chainId: 1,
    name: 'BitAsean',
    address: '0x2a05d22db079bc40c2f77a1d1ff703a56e631cc1',
    decimals: 8,
    symbol: 'BAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1885.png',
  },
  {
    chainId: 1,
    name: 'Dent',
    address: '0x3597bfd533a99c9aa083587b074434e61eb0a258',
    decimals: 8,
    symbol: 'DENT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1886.png',
  },
  {
    chainId: 1,
    name: 'InvestFeed',
    address: '0x7654915a1b82d6d2d0afc37c52af556ea8983c7e',
    decimals: 18,
    symbol: 'IFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1888.png',
  },
  {
    chainId: 1,
    name: 'Etheriya',
    address: '0x0b1724cc9fda0186911ef6a75949e9c0d3f0f2f3',
    decimals: 8,
    symbol: 'RIYA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1890.png',
  },
  {
    chainId: 1,
    name: '0x Protocol',
    address: '0xe41d2489571d322189246dafa5ebde1f4699f498',
    decimals: 18,
    symbol: 'ZRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1896.png',
  },
  {
    chainId: 1,
    name: 'Bolenum',
    address: '0x0C658Fa2eAA292E8dcA085Dab0E5CBD2da21C494',
    decimals: 18,
    symbol: 'BLN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1897.png',
  },
  {
    chainId: 1,
    name: 'MyBit',
    address: '0x5d60d8d7ef6d37e16ebabc324de3be57f135e0bc',
    decimals: 18,
    symbol: 'MYB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1902.png',
  },
  {
    chainId: 1,
    name: 'TFL.io',
    address: '0xa7f976c360ebbed4465c2855684d1aae5271efa9',
    decimals: 18,
    symbol: 'TFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1905.png',
  },
  {
    chainId: 1,
    name: 'Dochain',
    address: '0x450bbc727100D806797CD617c88d1319563F8416',
    decimals: 8,
    symbol: 'DOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1909.png',
  },
  {
    chainId: 1,
    name: 'Dalecoin',
    address: '0x07d9e49ea402194bf48a8276dafb16e4ed633317',
    decimals: 8,
    symbol: 'DALC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1912.png',
  },
  {
    chainId: 1,
    name: 'OX Fina',
    address: '0x65a15014964f2102ff58647e16a16a6b9e14bcf6',
    decimals: 3,
    symbol: 'OX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1914.png',
  },
  {
    chainId: 1,
    name: 'bitqy',
    address: '0xf0f8b0b8dbb1124261fc8d778e2287e3fd2cf4f5',
    decimals: 3,
    symbol: 'BQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1917.png',
  },
  {
    chainId: 1,
    name: 'Waltonchain',
    address: '0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74',
    decimals: 18,
    symbol: 'WTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1925.png',
  },
  {
    chainId: 1,
    name: 'BROTHER',
    address: '0x9e77d5a1251b6f7d456722a6eac6d2d5980bd891',
    decimals: 8,
    symbol: 'BRAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1926.png',
  },
  {
    chainId: 1,
    name: 'Primas',
    address: '0x5d4abc77b8405ad177d8ac6682d584ecbfd46cec',
    decimals: 18,
    symbol: 'PST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1930.png',
  },
  {
    chainId: 1,
    name: 'Opus',
    address: '0x4355fC160f74328f9b383dF2EC589bB3dFd82Ba0',
    decimals: 18,
    symbol: 'OPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1931.png',
  },
  {
    chainId: 1,
    name: 'UG Token',
    address: '0x43ee79e379e7b78d871100ed696e803e7893b644',
    decimals: 18,
    symbol: 'UGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1932.png',
  },
  {
    chainId: 1,
    name: 'Suretly',
    address: '0xe120c1ecbfdfea7f0a8f0ee30063491e8c26fedf',
    decimals: 8,
    symbol: 'SUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1933.png',
  },
  {
    chainId: 1,
    name: 'Loopring',
    address: '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd',
    decimals: 18,
    symbol: 'LRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1934.png',
  },
  {
    chainId: 1,
    name: 'LLToken',
    address: '0x6d5cac36c1ae39f41d52393b7a425d0a610ad9f2',
    decimals: 8,
    symbol: 'LLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1936.png',
  },
  {
    chainId: 1,
    name: 'Po.et',
    address: '0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195',
    decimals: 8,
    symbol: 'POE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1937.png',
  },
  {
    chainId: 1,
    name: 'Fujinto',
    address: '0x8a99ed8a1b204903ee46e733f2c1286f6d20b177',
    decimals: 18,
    symbol: 'NTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1938.png',
  },
  {
    chainId: 1,
    name: 'Blockchain Index',
    address: '0xe5a7c12972f3bbfe70ed29521c8949b8af6a0970',
    decimals: 18,
    symbol: 'BLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1939.png',
  },
  {
    chainId: 1,
    name: 'StarCredits',
    address: '0x46492473755e8df960f8034877f61732d718ce96',
    decimals: 8,
    symbol: 'STRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1942.png',
  },
  {
    chainId: 1,
    name: 'Monetha',
    address: '0xaf4dce16da2877f8c9e00544c93b62ac40631f16',
    decimals: 18,
    symbol: 'MTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1947.png',
  },
  {
    chainId: 1,
    name: 'Aventus',
    address: '0x0d88ed6e74bbfd96b831231638b66c05571e824f',
    decimals: 18,
    symbol: 'AVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1948.png',
  },
  {
    chainId: 1,
    name: 'Agrello',
    address: '0x07e3c70653548B04f0A75970C1F81B4CBbFB606f',
    decimals: 18,
    symbol: 'DLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1949.png',
  },
  {
    chainId: 1,
    name: 'Hiveterminal Token',
    address: '0xC0Eb85285d83217CD7c891702bcbC0FC401E2D9D',
    decimals: 8,
    symbol: 'HVN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1950.png',
  },
  {
    chainId: 1,
    name: 'Facecoin',
    address: '0xe6923E9b56Db1EeD1c9f430Ea761DA7565e260Fe',
    decimals: 2,
    symbol: 'FC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1953.png',
  },
  {
    chainId: 1,
    name: 'Moeda Loyalty Points',
    address: '0x51db5ad35c671a87207d88fc11d593ac0c8415bd',
    decimals: 18,
    symbol: 'MDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1954.png',
  },
  {
    chainId: 1,
    name: 'TRON',
    address: '0x50327c6c5a14dcade707abad2e27eb517df87ab5',
    decimals: 18,
    symbol: 'TRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
  },
  {
    chainId: 1,
    name: 'imbrex',
    address: '0xf05a9382A4C3F29E2784502754293D88b835109C',
    decimals: 18,
    symbol: 'REX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1961.png',
  },
  {
    chainId: 1,
    name: 'Credo',
    address: '0x4e0603e2a27a30480e5e3a4fe548e29ef12f64be',
    decimals: 18,
    symbol: 'CREDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1963.png',
  },
  {
    chainId: 1,
    name: 'Decentraland',
    address: '0x0f5d2fb29fb7d3cfee444a200298f468908cc942',
    decimals: 18,
    symbol: 'MANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1966.png',
  },
  {
    chainId: 1,
    name: 'Indorse Token',
    address: '0xf8e386eda857484f5a12e4b5daa9984e06e73705',
    decimals: 18,
    symbol: 'IND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1967.png',
  },
  {
    chainId: 1,
    name: 'XPA',
    address: '0x90528aeb3a2b736b780fd1b6c478bb7e1d643170',
    decimals: 18,
    symbol: 'XPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1968.png',
  },
  {
    chainId: 1,
    name: 'Sociall',
    address: '0xd7631787b4dcc87b1254cfd1e5ce48e96823dee8',
    decimals: 8,
    symbol: 'SCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1969.png',
  },
  {
    chainId: 1,
    name: 'iQuant',
    address: '0x51ee82641ac238bde34b9859f98f5f311d6e4954',
    decimals: 8,
    symbol: 'IQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1971.png',
  },
  {
    chainId: 1,
    name: 'Propy',
    address: '0x226bb599a12c826476e3a771454697ea52e9e220',
    decimals: 8,
    symbol: 'PRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1974.png',
  },
  {
    chainId: 1,
    name: 'Chainlink',
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    decimals: 18,
    symbol: 'LINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1975.png',
  },
  {
    chainId: 1,
    name: 'Blackmoon',
    address: '0xdf6ef343350780bf8c3410bf062e0c015b1dd671',
    decimals: 8,
    symbol: 'BMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1976.png',
  },
  {
    chainId: 1,
    name: 'Wi Coin',
    address: '0x5e4abe6419650ca839ce5bb7db422b881a6064bb',
    decimals: 18,
    symbol: 'WIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1979.png',
  },
  {
    chainId: 1,
    name: 'Elixir',
    address: '0xc8c6a31a4a806d3710a7b38b7b296d2fabccdba8',
    decimals: 18,
    symbol: 'ELIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1980.png',
  },
  {
    chainId: 1,
    name: 'Kyber Network Crystal Legacy',
    address: '0xdd974d5c2e2928dea5f71b9825b8b646686bd200',
    decimals: 18,
    symbol: 'KNCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1982.png',
  },
  {
    chainId: 1,
    name: 'VIBE',
    address: '0xe8ff5c9c75deb346acac493c463c8950be03dfba',
    decimals: 18,
    symbol: 'VIBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1983.png',
  },
  {
    chainId: 1,
    name: 'Substratum',
    address: '0x8D75959f1E61EC2571aa72798237101F084DE63a',
    decimals: 18,
    symbol: 'SUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1984.png',
  },
  {
    chainId: 1,
    name: 'Chronologic',
    address: '0xE814aeE960a85208C3dB542C53E7D4a6C8D5f60F',
    decimals: 18,
    symbol: 'DAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1985.png',
  },
  {
    chainId: 1,
    name: 'CryptoInsight',
    address: '0xb45a50545beeab73f38f31e5973768c421805e5e',
    decimals: 18,
    symbol: 'TKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1987.png',
  },
  {
    chainId: 1,
    name: 'COS',
    address: '0x7d3cb11f8c13730c24d01826d8f2005f0e1b348f',
    decimals: 18,
    symbol: 'COS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1989.png',
  },
  {
    chainId: 1,
    name: 'BitDice',
    address: '0x29d75277ac7f0335b2165d0895e8725cbf658d73',
    decimals: 8,
    symbol: 'CSNO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1990.png',
  },
  {
    chainId: 1,
    name: 'Rivetz',
    address: '0x3d1ba9be9f66b8ee101911bc36d3fb562eac2244',
    decimals: 18,
    symbol: 'RVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1991.png',
  },
  {
    chainId: 1,
    name: 'Target Coin',
    address: '0xac3da587eac229c9896d919abc235ca4fd7f72c1',
    decimals: 1,
    symbol: 'TGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1995.png',
  },
  {
    chainId: 1,
    name: 'SALT',
    address: '0x4156D3342D5c385a87D264F90653733592000581',
    decimals: 8,
    symbol: 'SALT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1996.png',
  },
  {
    chainId: 1,
    name: 'Ormeus Coin',
    address: '0xc96df921009b790dffca412375251ed1a2b75c60',
    decimals: 8,
    symbol: 'ORMEUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1998.png',
  },
  {
    chainId: 1,
    name: 'Musiconomi',
    address: '0x138a8752093f4f9a79aaedf48d4b9248fab93c9c',
    decimals: 18,
    symbol: 'MCI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2000.png',
  },
  {
    chainId: 1,
    name: 'ColossusXT',
    address: '0x95bf7e307bc1ab0ba38ae10fc27084bc36fcd605',
    decimals: 8,
    symbol: 'COLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2001.png',
  },
  {
    chainId: 1,
    name: 'HODL Bucks',
    address: '0xad6714bd97cbbd29788f8838bc865ee71b843eb8',
    decimals: 8,
    symbol: 'HDLB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2004.png',
  },
  {
    chainId: 1,
    name: 'Cobinhood',
    address: '0xb2f7eb1f2c37645be61d73953035360e768d81e6',
    decimals: 18,
    symbol: 'COB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2006.png',
  },
  {
    chainId: 1,
    name: 'Bismuth',
    address: '0xf5cb350b40726b5bcf170d12e162b6193b291b41',
    decimals: 18,
    symbol: 'BIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2009.png',
  },
  {
    chainId: 1,
    name: 'Voise',
    address: '0x83eEA00D838f92dEC4D1475697B9f4D3537b56E3',
    decimals: 8,
    symbol: 'VOISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2012.png',
  },
  {
    chainId: 1,
    name: 'ATMChain',
    address: '0x9B11EFcAAA1890f6eE52C6bB7CF8153aC5d74139',
    decimals: 8,
    symbol: 'ATM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2015.png',
  },
  {
    chainId: 1,
    name: 'Viberate',
    address: '0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724',
    decimals: 18,
    symbol: 'VIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2019.png',
  },
  {
    chainId: 1,
    name: 'Internxt',
    address: '0x4a8f5f96d5436e43112c2fbc6a9f70da9e4e16d4',
    decimals: 8,
    symbol: 'INXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2022.png',
  },
  {
    chainId: 1,
    name: 'Prospectors Gold',
    address: '0x089a6d83282fb8988a656189f1e7a73fa6c1cac2',
    decimals: 18,
    symbol: 'PGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2023.png',
  },
  {
    chainId: 1,
    name: 'FLiK',
    address: '0x17fd666fa0784885fa1afec8ac624d9b7e72b752',
    decimals: 14,
    symbol: 'FLIK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2025.png',
  },
  {
    chainId: 1,
    name: 'EthBet',
    address: '0x7D5Edcd23dAa3fB94317D32aE253eE1Af08Ba14d',
    decimals: 2,
    symbol: 'EBET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2026.png',
  },
  {
    chainId: 1,
    name: 'Wild Crypto',
    address: '0xd3c00772b24d997a812249ca637a921e81357701',
    decimals: 18,
    symbol: 'WILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2029.png',
  },
  {
    chainId: 1,
    name: 'REAL',
    address: '0x9214ec02cb71cba0ada6896b8da260736a67ab10',
    decimals: 18,
    symbol: 'REAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2030.png',
  },
  {
    chainId: 1,
    name: 'Hubii Network',
    address: '0xdd6c68bb32462e01705011a4e2ad1a60740f217f',
    decimals: 15,
    symbol: 'HBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2031.png',
  },
  {
    chainId: 1,
    name: 'Crystal Clear ',
    address: '0x336f646f87d9f6bc6ed42dd46e8b3fd9dbd15c22',
    decimals: 18,
    symbol: 'CCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2032.png',
  },
  {
    chainId: 1,
    name: 'Everex',
    address: '0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8',
    decimals: 4,
    symbol: 'EVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2034.png',
  },
  {
    chainId: 1,
    name: 'eLTC',
    address: '0x7e9d62e1ff4e34096f91ee0153222ab81f7184f0',
    decimals: 8,
    symbol: 'ELTC2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2035.png',
  },
  {
    chainId: 1,
    name: 'PayPie',
    address: '0xc42209aCcC14029c1012fB5680D95fBd6036E2a0',
    decimals: 18,
    symbol: 'PPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2036.png',
  },
  {
    chainId: 1,
    name: 'AirToken',
    address: '0x27dce1ec4d3f72c3e457cc50354f1f975ddef488',
    decimals: 8,
    symbol: 'AIR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2037.png',
  },
  {
    chainId: 1,
    name: 'PoSToken',
    address: '0xee609fe292128cad03b786dbb9bc2634ccdbe7fc',
    decimals: 18,
    symbol: 'POS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2038.png',
  },
  {
    chainId: 1,
    name: 'Senderon',
    address: '0x73b534fb6f07381a29a60b01eed5ae57d4ee24d7',
    decimals: 18,
    symbol: 'SDRN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2039.png',
  },
  {
    chainId: 1,
    name: 'ALIS',
    address: '0xEA610B1153477720748DC13ED378003941d84fAB',
    decimals: 18,
    symbol: 'ALIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2040.png',
  },
  {
    chainId: 1,
    name: 'HelloGold',
    address: '0xba2184520a1cc49a6159c57e61e1844e085615b6',
    decimals: 8,
    symbol: 'HGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2042.png',
  },
  {
    chainId: 1,
    name: 'Cindicator',
    address: '0xd4c435f5b09f855c3317c8524cb1f586e42795fa',
    decimals: 18,
    symbol: 'CND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2043.png',
  },
  {
    chainId: 1,
    name: 'Enigma',
    address: '0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4',
    decimals: 8,
    symbol: 'ENG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2044.png',
  },
  {
    chainId: 1,
    name: 'Coimatic 3.0',
    address: '0x430fee8ea3df2a9a34fa6621dac5a9d5ccac355a',
    decimals: 18,
    symbol: 'CTIC3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2045.png',
  },
  {
    chainId: 1,
    name: 'Zeusshield',
    address: '0x7A41e0517a5ecA4FdbC7FbebA4D4c47B9fF6DC63',
    decimals: 18,
    symbol: 'ZSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2047.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Cash',
    address: '0x5d21ef5f25a985380b65c8e943a0082feda0db84',
    decimals: 18,
    symbol: 'ECASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2048.png',
  },
  {
    chainId: 1,
    name: 'Authorship',
    address: '0x2dAEE1AA61D60A252DC80564499A69802853583A',
    decimals: 4,
    symbol: 'ATS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2051.png',
  },
  {
    chainId: 1,
    name: 'EtherDoge',
    address: '0x8a7b7B9B2f7d0c63F66171721339705A6188a7D5',
    decimals: 18,
    symbol: 'EDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2052.png',
  },
  {
    chainId: 1,
    name: 'Royal Kingdom Coin',
    address: '0x6ccb56947ea1d6efdc81acfbacd8263ddfa9b202',
    decimals: 18,
    symbol: 'RKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2053.png',
  },
  {
    chainId: 1,
    name: 'ExchangeN',
    address: '0x0766e79a6fd74469733e8330b3b461c0320ff059',
    decimals: 18,
    symbol: 'EXN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2055.png',
  },
  {
    chainId: 1,
    name: 'PiplCoin',
    address: '0xe64509f0bf07ce2d29a7ef19a8a9bc065477c1b4',
    decimals: 8,
    symbol: 'PIPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2056.png',
  },
  {
    chainId: 1,
    name: 'AirSwap',
    address: '0x27054b13b1b798b345b591a4d22e6562d47ea75a',
    decimals: 4,
    symbol: 'AST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2058.png',
  },
  {
    chainId: 1,
    name: 'Change',
    address: '0x7d4b8cce0591c9044a22ee543533b72e976e36c3',
    decimals: 18,
    symbol: 'CAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2060.png',
  },
  {
    chainId: 1,
    name: 'Blockmason Credit Protocol',
    address: '0x1c4481750daa5ff521a2a7490d9981ed46465dbd',
    decimals: 18,
    symbol: 'BCPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2061.png',
  },
  {
    chainId: 1,
    name: 'Tracto',
    address: '0x30cecb5461a449a90081f5a5f55db4e048397bab',
    decimals: 8,
    symbol: 'TRCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2063.png',
  },
  {
    chainId: 1,
    name: 'Maecenas',
    address: '0xfec0cf7fe078a500abf15f1284958f22049c2c7e',
    decimals: 18,
    symbol: 'ART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2064.png',
  },
  {
    chainId: 1,
    name: 'Everus',
    address: '0x3137619705b5fc22a3048989f983905e456b59ab',
    decimals: 8,
    symbol: 'EVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2066.png',
  },
  {
    chainId: 1,
    name: 'Open Trading Network',
    address: '0x881ef48211982d01e2cb7092c915e647cd40d85c',
    decimals: 18,
    symbol: 'OTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2069.png',
  },
  {
    chainId: 1,
    name: 'DomRaider',
    address: '0x9af4f26941677c706cfecf6d3379ff01bb85d5ab',
    decimals: 8,
    symbol: 'DRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2070.png',
  },
  {
    chainId: 1,
    name: 'Request',
    address: '0x8f8221afbb33998d8584a2b05749ba73c37a938a',
    decimals: 18,
    symbol: 'REQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2071.png',
  },
  {
    chainId: 1,
    name: 'eUSD',
    address: '0x87611ca3403a3878dfef0da2a786e209abfc1eff',
    decimals: 8,
    symbol: 'EUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2075.png',
  },
  {
    chainId: 1,
    name: 'Blue Protocol',
    address: '0x539efe69bcdd21a83efd9122571a64cc25e0282b',
    decimals: 8,
    symbol: 'BLUE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2076.png',
  },
  {
    chainId: 1,
    name: 'LIFE',
    address: '0xff18dbc487b4c2e3222d115952babfda8ba52f5f',
    decimals: 18,
    symbol: 'LIFE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2078.png',
  },
  {
    chainId: 1,
    name: 'Hedge',
    address: '0xffe8196bc259e8dedc544d935786aa4709ec3e64',
    decimals: 18,
    symbol: 'HDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2079.png',
  },
  {
    chainId: 1,
    name: 'AirDAO',
    address: '0xf4fb9bf10e489ea3edb03e094939341399587b0c',
    decimals: 18,
    symbol: 'AMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2081.png',
  },
  {
    chainId: 1,
    name: 'ICOS',
    address: '0x014b50466590340d41307cc54dcee990c8d58aa8',
    decimals: 6,
    symbol: 'ICOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2082.png',
  },
  {
    chainId: 1,
    name: '10M Token',
    address: '0xe701cd3329057aea9d54300ddd05e41b8d74727a',
    decimals: 10,
    symbol: '10MT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2085.png',
  },
  {
    chainId: 1,
    name: 'KuCoin Token',
    address: '0xf34960d9d60be18cc1d5afc1a6f012a723a28811',
    decimals: 6,
    symbol: 'KCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2087.png',
  },
  {
    chainId: 1,
    name: 'ClearPoll',
    address: '0x705EE96c1c160842C92c1aeCfCFfccc9C412e3D9',
    decimals: 18,
    symbol: 'POLL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2089.png',
  },
  {
    chainId: 1,
    name: 'LATOKEN',
    address: '0xe50365f5d679cb98a1dd62d6f6e58e59321bcddf',
    decimals: 18,
    symbol: 'LA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2090.png',
  },
  {
    chainId: 1,
    name: 'Exchange Union',
    address: '0xc324a2f6b05880503444451b8b27e6f9e63287cb',
    decimals: 18,
    symbol: 'XUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2091.png',
  },
  {
    chainId: 1,
    name: 'NULS',
    address: '0xa2791bdf2d5055cda4d46ec17f9f429568275047',
    decimals: 18,
    symbol: 'NULS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2092.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Red',
    address: '0x6aac8cb9861e42bf8259f5abdc6ae3ae89909e11',
    decimals: 8,
    symbol: 'BTCRED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2093.png',
  },
  {
    chainId: 1,
    name: 'Paragon',
    address: '0x7728dFEF5aBd468669EB7f9b48A7f70a501eD29D',
    decimals: 6,
    symbol: 'PRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2094.png',
  },
  {
    chainId: 1,
    name: 'Ripio Credit Network',
    address: '0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6',
    decimals: 18,
    symbol: 'RCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2096.png',
  },
  {
    chainId: 1,
    name: 'Mercury Protocol',
    address: '0xb3bd49e28f8f832b8d1e246106991e546c323502',
    decimals: 18,
    symbol: 'GMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2098.png',
  },
  {
    chainId: 1,
    name: 'JavaScript Token',
    address: '0x5046e860ff274fb8c66106b0ffb8155849fb0787',
    decimals: 8,
    symbol: 'JS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2100.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Lite',
    address: '0x0a76aad21948ea1ef447d26dee91a54370e151e0',
    decimals: 18,
    symbol: 'ELITE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2101.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Silver',
    address: '0xd96b9fd7586d9ea24c950d24399be4fb65372fdd',
    decimals: 18,
    symbol: 'BTCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2102.png',
  },
  {
    chainId: 1,
    name: 'Intelligent Trading Foundation',
    address: '0x0aef06dcccc531e581f0440059e6ffcc206039ee',
    decimals: 8,
    symbol: 'ITT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2103.png',
  },
  {
    chainId: 1,
    name: 'iEthereum',
    address: '0x859a9c0b44cb7066d956a958b0b82e54c9e44b4b',
    decimals: 8,
    symbol: 'IETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2104.png',
  },
  {
    chainId: 1,
    name: 'Xenon',
    address: '0xab95e915c123fded5bdfb6325e35ef5515f1ea69',
    decimals: 18,
    symbol: 'XNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2106.png',
  },
  {
    chainId: 1,
    name: 'eREAL',
    address: '0x15f173b7aca7cd4a01d6f8360e65fb4491d270c1',
    decimals: 18,
    symbol: 'EREAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2108.png',
  },
  {
    chainId: 1,
    name: 'Network Token',
    address: '0x2233799ee2683d75dfefacbcd2a26c78d34b470d',
    decimals: 18,
    symbol: 'NTWK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2109.png',
  },
  {
    chainId: 1,
    name: 'HOPE',
    address: '0xac3211a5025414af2866ff09c23fc18bc97e79b1',
    decimals: 18,
    symbol: 'HOPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2110.png',
  },
  {
    chainId: 1,
    name: 'Cash Poker Pro',
    address: '0xa8f93faee440644f89059a2c88bdc9bf3be5e2ea',
    decimals: 18,
    symbol: 'CASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2111.png',
  },
  {
    chainId: 1,
    name: 'PlayerCoin',
    address: '0x4da2a6d0b300d0fb66d5064fd34479404ca50274',
    decimals: 8,
    symbol: 'PEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2115.png',
  },
  {
    chainId: 1,
    name: 'Natcoin',
    address: '0x8d5a69dc82a47594881256f2eef81770274fa30f',
    decimals: 18,
    symbol: 'NTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2116.png',
  },
  {
    chainId: 1,
    name: 'FAPcoin',
    address: '0x6467882316dc6e206feef05fba6deaa69277f155',
    decimals: 18,
    symbol: 'FAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2118.png',
  },
  {
    chainId: 1,
    name: 'BTCMoon',
    address: '0xa9aad2dc3a8315caeee5f458b1d8edc31d8467bd',
    decimals: 18,
    symbol: 'BTCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2119.png',
  },
  {
    chainId: 1,
    name: 'Etherparty',
    address: '0xea38eaa3c86c8f9b751533ba2e562deb9acded40',
    decimals: 18,
    symbol: 'FUEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2120.png',
  },
  {
    chainId: 1,
    name: 'Gimli',
    address: '0xae4f56f072c34c0a65b3ae3e4db797d831439d93',
    decimals: 8,
    symbol: 'GIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2121.png',
  },
  {
    chainId: 1,
    name: 'Qvolta',
    address: '0x1183f92a5624d68e85ffb9170f16bf0443b4c242',
    decimals: 18,
    symbol: 'QVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2124.png',
  },
  {
    chainId: 1,
    name: 'FlypMe',
    address: '0x8f0921f30555624143d427b340b1156914882c10',
    decimals: 18,
    symbol: 'FYP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2126.png',
  },
  {
    chainId: 1,
    name: 'eBitcoin',
    address: '0xeb7c20027172e5d143fb030d50f91cece2d1485d',
    decimals: 8,
    symbol: 'EBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2127.png',
  },
  {
    chainId: 1,
    name: 'iBTC',
    address: '0xb7c4a82936194fee52a4e3d4cec3415f74507532',
    decimals: 18,
    symbol: 'IBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2131.png',
  },
  {
    chainId: 1,
    name: 'Powerledger',
    address: '0x595832f8fc6bf59c85c527fec3740a1b7a361269',
    decimals: 18,
    symbol: 'POWR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2132.png',
  },
  {
    chainId: 1,
    name: 'eGold',
    address: '0x6025f65f6b2f93d8ed1efedc752acfd4bdbcec3e',
    decimals: 18,
    symbol: 'EGOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2133.png',
  },
  {
    chainId: 1,
    name: 'Grid+',
    address: '0x12b19d3e2ccc14da04fae33e63652ce469b3f2fd',
    decimals: 12,
    symbol: 'GRID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2134.png',
  },
  {
    chainId: 1,
    name: 'Revain',
    address: '0x2ef52Ed7De8c5ce03a4eF0efbe9B7450F2D7Edc9',
    decimals: 6,
    symbol: 'REV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2135.png',
  },
  {
    chainId: 1,
    name: 'ATLANT',
    address: '0x78b7fada55a64dd895d8c8c35779dd8b67fa8a05',
    decimals: 18,
    symbol: 'ATL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2136.png',
  },
  {
    chainId: 1,
    name: 'Streamr',
    address: '0x8f693ca8d21b157107184d29d398a8d082b38b76',
    decimals: 18,
    symbol: 'DATA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2143.png',
  },
  {
    chainId: 1,
    name: 'ELTCOIN',
    address: '0x44197a4c44d6a059297caf6be4f7e172bd56caaf',
    decimals: 8,
    symbol: 'ELTCOIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2147.png',
  },
  {
    chainId: 1,
    name: 'Unikoin Gold',
    address: '0x24692791bc444c5cd0b81e3cbcaba4b04acd1f3b',
    decimals: 18,
    symbol: 'UKG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2149.png',
  },
  {
    chainId: 1,
    name: 'Autonio',
    address: '0xc813EA5e3b48BEbeedb796ab42A30C5599b01740',
    decimals: 4,
    symbol: 'NIOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2151.png',
  },
  {
    chainId: 1,
    name: 'CarTaxi Token',
    address: '0x662aBcAd0b7f345AB7FfB1b1fbb9Df7894f18e66',
    decimals: 18,
    symbol: 'CTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2152.png',
  },
  {
    chainId: 1,
    name: 'Aeron',
    address: '0x0C37Bcf456bC661C14D596683325623076D7e283',
    decimals: 18,
    symbol: 'ARNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2153.png',
  },
  {
    chainId: 1,
    name: 'Yellow Token',
    address: '0x8633e144f2d9b9b8bDD12ddB58e4bEF1E163a0cE',
    decimals: 18,
    symbol: 'YEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2154.png',
  },
  {
    chainId: 1,
    name: 'Confido',
    address: '0x14839bf22810F09fb163AF69BD21Bd5476F445Cd',
    decimals: 18,
    symbol: 'CFD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2155.png',
  },
  {
    chainId: 1,
    name: 'Rasputin Online Coin',
    address: '0x1bcbc54166f6ba149934870b60506199b6c9db6d',
    decimals: 10,
    symbol: 'ROC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2156.png',
  },
  {
    chainId: 1,
    name: 'Farad',
    address: '0x0abefb7611cb3a01ea3fad85f33c3c934f8e2cf4',
    decimals: 18,
    symbol: 'FRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2159.png',
  },
  {
    chainId: 1,
    name: 'Raiden Network Token',
    address: '0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6',
    decimals: 18,
    symbol: 'RDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2161.png',
  },
  {
    chainId: 1,
    name: 'Delphy',
    address: '0x6c2adc2073994fb2ccc5032cc2906fa221e9b391',
    decimals: 18,
    symbol: 'DPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2162.png',
  },
  {
    chainId: 1,
    name: 'DCORP',
    address: '0x621d78f2ef2fd937bfca696cabaf9a779f59b3ed',
    decimals: 2,
    symbol: 'DRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2164.png',
  },
  {
    chainId: 1,
    name: 'ERC20',
    address: '0xCDD981ef3330E159029e6E226dbD73d99F868f4d',
    decimals: 18,
    symbol: 'ERC20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2165.png',
  },
  {
    chainId: 1,
    name: 'Ties.DB',
    address: '0x999967e2ec8a74b7c8e9db19e039d920b31d39d0',
    decimals: 18,
    symbol: 'TIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2166.png',
  },
  {
    chainId: 1,
    name: 'Zlancer',
    address: '0x180e5087935a94fd5bbab00fd2249c5be0473381',
    decimals: 8,
    symbol: 'ZCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2169.png',
  },
  {
    chainId: 1,
    name: 'Emphy',
    address: '0x50ee674689d75c0f88e8f83cfe8c4b69e8fd590d',
    decimals: 8,
    symbol: 'EPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2172.png',
  },
  {
    chainId: 1,
    name: 'DecentBet',
    address: '0x9b68bfae21df5a510931a262cecf63f41338f264',
    decimals: 18,
    symbol: 'DBET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2175.png',
  },
  {
    chainId: 1,
    name: 'Decision Token',
    address: '0x554c20b7c486beee439277b4540a434566dc4c02',
    decimals: 18,
    symbol: 'HST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2176.png',
  },
  {
    chainId: 1,
    name: 'Sharechain',
    address: '0x7d3e7d41da367b4fdce7cbe06502b13294deb758',
    decimals: 8,
    symbol: 'SSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2177.png',
  },
  {
    chainId: 1,
    name: 'Upfiring',
    address: '0xea097a2b1db00627b2fa17460ad260c016016977',
    decimals: 18,
    symbol: 'UFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2178.png',
  },
  {
    chainId: 1,
    name: 'Hat.Exchange',
    address: '0x9002d4485b7594e3e850f0a206713b305113f69e',
    decimals: 12,
    symbol: 'HAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2179.png',
  },
  {
    chainId: 1,
    name: 'bitJob',
    address: '0x0371a82e4a9d0a4312f3ee2ac9c6958512891372',
    decimals: 18,
    symbol: 'STU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2180.png',
  },
  {
    chainId: 1,
    name: 'Genesis Vision',
    address: '0x103c3a209da59d3e7c4a89307e66521e081cfdf0',
    decimals: 18,
    symbol: 'GVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2181.png',
  },
  {
    chainId: 1,
    name: 'EagleCoin',
    address: '0x994f0dffdbae0bbf09b652d6f11a493fd33f42b9',
    decimals: 18,
    symbol: 'EAGLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2182.png',
  },
  {
    chainId: 1,
    name: 'Privatix',
    address: '0x3adfc4999f77d04c8341bac5f3a76f58dff5b37a',
    decimals: 8,
    symbol: 'PRIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2184.png',
  },
  {
    chainId: 1,
    name: 'PlusCoin',
    address: '0x0835ecd15ddf08d4786304d71b4672dc5c40f011',
    decimals: 18,
    symbol: 'PLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2186.png',
  },
  {
    chainId: 1,
    name: 'EBCH',
    address: '0xafc39788c51f0c1ff7b55317f3e70299e521fff6',
    decimals: 8,
    symbol: 'EBCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2187.png',
  },
  {
    chainId: 1,
    name: 'Faceblock',
    address: '0xc0c2ee1ce1fed8f6e2764363a36db3dd4cf10022',
    decimals: 2,
    symbol: 'FBL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2188.png',
  },
  {
    chainId: 1,
    name: 'SISA',
    address: '0xA0aa85b54F8A7b09C845F13a09172B08925f3d54',
    decimals: 18,
    symbol: 'SISA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2189.png',
  },
  {
    chainId: 1,
    name: 'Astro',
    address: '0x7b22938ca841aa392c93dbb7f4c42178e3d65e88',
    decimals: 4,
    symbol: 'ASTRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2190.png',
  },
  {
    chainId: 1,
    name: 'Paypex',
    address: '0x62a56a4a2ef4d355d34d10fbf837e747504d38d4',
    decimals: 2,
    symbol: 'PAYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2191.png',
  },
  {
    chainId: 1,
    name: 'GOLD Reward Token',
    address: '0x219218f117dc9348b358b8471c55a073e5e0da0b',
    decimals: 18,
    symbol: 'GRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2192.png',
  },
  {
    chainId: 1,
    name: 'BitSerial',
    address: '0x6733d909e10ddedb8d6181b213de32a30ceac7ed',
    decimals: 18,
    symbol: 'BTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2194.png',
  },
  {
    chainId: 1,
    name: 'BitBoost',
    address: '0x1500205f50bf3fd976466d0662905c9ff254fc9c',
    decimals: 4,
    symbol: 'BBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2195.png',
  },
  {
    chainId: 1,
    name: 'Sugar Exchange',
    address: '0xCB5A05beF3257613E984C17DbcF039952B6d883F',
    decimals: 8,
    symbol: 'SGR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2196.png',
  },
  {
    chainId: 1,
    name: 'Corethum',
    address: '0xa119f0f5fd06ebadff8883c0f3c40b2d22e7a44f',
    decimals: 8,
    symbol: 'CRTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2197.png',
  },
  {
    chainId: 1,
    name: 'Viuly',
    address: '0x464baddce9bd32581a7d59d9bb8350c7c7764668',
    decimals: 18,
    symbol: 'VIU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2198.png',
  },
  {
    chainId: 1,
    name: 'Oyster',
    address: '0x1844b21593262668b7248d0f57a220caaba46ab9',
    decimals: 18,
    symbol: 'PRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2202.png',
  },
  {
    chainId: 1,
    name: 'Infinity Pay',
    address: '0x2cfd4c10c075fa51649744245ec1d0aa3d567e23',
    decimals: 8,
    symbol: 'IPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2203.png',
  },
  {
    chainId: 1,
    name: 'B2BX',
    address: '0x5d51fcced3114a8bb5e90cdd0f9d682bcbcc5393',
    decimals: 18,
    symbol: 'B2B',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2204.png',
  },
  {
    chainId: 1,
    name: 'DigiPulse',
    address: '0xf6cfe53d6febaeea051f400ff5fc14f0cbbdaca1',
    decimals: 18,
    symbol: 'DGPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2207.png',
  },
  {
    chainId: 1,
    name: 'EncrypGen',
    address: '0xef6344de1fcfC5F48c30234C16c1389e8CdC572C',
    decimals: 18,
    symbol: 'DNA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2208.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin2x',
    address: '0x15ef5b9447710eab904e63e6233ff540400d603f',
    decimals: 8,
    symbol: 'BTC2X',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2210.png',
  },
  {
    chainId: 1,
    name: 'QASH',
    address: '0x618e75ac90b12c6049ba3b27f5d5f8651b0037f6',
    decimals: 6,
    symbol: 'QASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2213.png',
  },
  {
    chainId: 1,
    name: 'Publica',
    address: '0x55648de19836338549130b1af587f16bea46f66b',
    decimals: 18,
    symbol: 'PBL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2217.png',
  },
  {
    chainId: 1,
    name: 'SpankChain',
    address: '0x42d6622dece394b54999fbd73d108123806f6a18',
    decimals: 18,
    symbol: 'SPANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2219.png',
  },
  {
    chainId: 1,
    name: 'BLOCKv',
    address: '0x340d2bde5eb28c1eed91b2f790723e3b160613b7',
    decimals: 18,
    symbol: 'VEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2223.png',
  },
  {
    chainId: 1,
    name: 'POLY AI',
    address: '0x5121e348e897daef1eef23959ab290e5557cf274',
    decimals: 18,
    symbol: 'AI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2224.png',
  },
  {
    chainId: 1,
    name: 'Accelerator Network',
    address: '0x13f1b7fdfbe1fc66676d56483e21b1ecb40b58e2',
    decimals: 18,
    symbol: 'ACC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2225.png',
  },
  {
    chainId: 1,
    name: 'Triaconta',
    address: '0x3293cc907fde439b39aedaf1b982785adaff186b',
    decimals: 10,
    symbol: 'TRIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2226.png',
  },
  {
    chainId: 1,
    name: 'DimonCoin',
    address: '0xde39e5e5a1b0eeb3afe717d6d011cae88d19451e',
    decimals: 8,
    symbol: 'FUDD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2227.png',
  },
  {
    chainId: 1,
    name: 'PlexCoin',
    address: '0xb3203DB25a01fa7950a860B42b899Ad7Da52DDD6',
    decimals: 8,
    symbol: 'PLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2228.png',
  },
  {
    chainId: 1,
    name: 'Divi Exchange Token',
    address: '0x13f11c9905a08ca76e3e853be63d4f0944326c72',
    decimals: 18,
    symbol: 'DIVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2229.png',
  },
  {
    chainId: 1,
    name: 'Flixxo',
    address: '0xf04a8ac553fcedb5ba99a64799155826c136b0be',
    decimals: 18,
    symbol: 'FLIXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2231.png',
  },
  {
    chainId: 1,
    name: 'Hyper TV',
    address: '0x7259fddca8d5f0184b3b12aa7e8401964b703a4f',
    decimals: 3,
    symbol: 'HYTV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2233.png',
  },
  {
    chainId: 1,
    name: 'Time New Bank',
    address: '0xf7920b0768ecb20a123fac32311d07d193381d6f',
    decimals: 18,
    symbol: 'TNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2235.png',
  },
  {
    chainId: 1,
    name: 'MyWish',
    address: '0xd123575D94A7aD9Bff3ad037aE9d4d52f41a7518',
    decimals: 8,
    symbol: 'WISH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2236.png',
  },
  {
    chainId: 1,
    name: 'EventChain',
    address: '0xb62d18dea74045e822352ce4b3ee77319dc5ff2f',
    decimals: 18,
    symbol: 'EVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2237.png',
  },
  {
    chainId: 1,
    name: 'UAHPay',
    address: '0x5c5413bad5f6fdb0f4fcd1457e46ead8e01d73d3',
    decimals: 18,
    symbol: 'UAHPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2238.png',
  },
  {
    chainId: 1,
    name: 'Ccore',
    address: '0x679badc551626e01b23ceecefbc9b877ea18fc46',
    decimals: 18,
    symbol: 'CCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2241.png',
  },
  {
    chainId: 1,
    name: 'Dragonchain',
    address: '0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e',
    decimals: 18,
    symbol: 'DRGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2243.png',
  },
  {
    chainId: 1,
    name: 'Payfair',
    address: '0xB41422D5a1d5d5C73c229686935b40F881502785',
    decimals: 8,
    symbol: 'PFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2244.png',
  },
  {
    chainId: 1,
    name: 'Presearch',
    address: '0xEC213F83defB583af3A000B1c0ada660b1902A0F',
    decimals: 18,
    symbol: 'PRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2245.png',
  },
  {
    chainId: 1,
    name: 'BlockCDN',
    address: '0x1e797Ce986C3CFF4472F7D38d5C4aba55DfEFE40',
    decimals: 15,
    symbol: 'BCDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2247.png',
  },
  {
    chainId: 1,
    name: 'Cappasity',
    address: '0x11613b1f840bb5A40F8866d857e24DA126B79D73',
    decimals: 18,
    symbol: 'CAPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2248.png',
  },
  {
    chainId: 1,
    name: 'Eroscoin',
    address: '0x74ceda77281b339142a36817fa5f9e29412bab85',
    decimals: 8,
    symbol: 'ERO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2249.png',
  },
  {
    chainId: 1,
    name: 'IoT Chain',
    address: '0x5e6b6d9abad9093fdc861ea1600eba1b355cd940',
    decimals: 18,
    symbol: 'ITC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2251.png',
  },
  {
    chainId: 1,
    name: 'Bonpay',
    address: '0xcc34366e3842ca1bd36c1f324d15257960fcc801',
    decimals: 18,
    symbol: 'BON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2256.png',
  },
  {
    chainId: 1,
    name: 'Snovian.Space',
    address: '0xbdc5bac39dbe132b1e030e898ae3830017d7d969',
    decimals: 18,
    symbol: 'SNOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2258.png',
  },
  {
    chainId: 1,
    name: 'Datamine',
    address: '0xf80d589b3dbe130c270a69f1a69d050f268786df',
    decimals: 18,
    symbol: 'DAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2260.png',
  },
  {
    chainId: 1,
    name: 'Wabi',
    address: '0x286bda1413a2df81731d4930ce2f862a35a609fe',
    decimals: 18,
    symbol: 'WABI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2267.png',
  },
  {
    chainId: 1,
    name: 'WandX',
    address: '0x27f610bf36eca0939093343ac28b1534a721dbb4',
    decimals: 18,
    symbol: 'WAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2269.png',
  },
  {
    chainId: 1,
    name: 'SportyCo',
    address: '0x85089389c14bd9c77fc2b8f0c3d1dc3363bf06ef',
    decimals: 18,
    symbol: 'SPF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2270.png',
  },
  {
    chainId: 1,
    name: 'Verify',
    address: '0x672a1ad4f667fb18a333af13667aa0af1f5b5bdd',
    decimals: 18,
    symbol: 'CRED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2271.png',
  },
  {
    chainId: 1,
    name: 'Soma',
    address: '0x63b992e6246d88f07fc35a056d2c365e6d441a3d',
    decimals: 18,
    symbol: 'SCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2272.png',
  },
  {
    chainId: 1,
    name: 'Uquid Coin',
    address: '0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2',
    decimals: 18,
    symbol: 'UQC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2273.png',
  },
  {
    chainId: 1,
    name: 'MediShares',
    address: '0x66186008C1050627F979d464eABb258860563dbE',
    decimals: 18,
    symbol: 'MDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2274.png',
  },
  {
    chainId: 1,
    name: 'ProChain',
    address: '0x9041Fe5B3FDEA0f5e4afDC17e75180738D877A01',
    decimals: 18,
    symbol: 'PRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2275.png',
  },
  {
    chainId: 1,
    name: 'SmartMesh',
    address: '0x55f93985431fc9304077687a35a1ba103dc1e081',
    decimals: 18,
    symbol: 'SMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2277.png',
  },
  {
    chainId: 1,
    name: 'Playkey',
    address: '0x2604fa406be957e542beb89e6754fcde6815e83f',
    decimals: 18,
    symbol: 'PKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2279.png',
  },
  {
    chainId: 1,
    name: 'Datum',
    address: '0x81c9151de0c8bafcd325a57e3db5a5df1cebf79c',
    decimals: 18,
    symbol: 'DAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2283.png',
  },
  {
    chainId: 1,
    name: 'Bitair',
    address: '0x02725836ebf3ecdb1cdf1c7b02fcbbfaa2736af8',
    decimals: 8,
    symbol: 'BTCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2285.png',
  },
  {
    chainId: 1,
    name: 'MicroMoney',
    address: '0x8b1f49491477e0fb46a29fef53f1ea320d13c349',
    decimals: 6,
    symbol: 'AMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2286.png',
  },
  {
    chainId: 1,
    name: 'LockTrip',
    address: '0x5e3346444010135322268a4630d2ed5f8d09446c',
    decimals: 18,
    symbol: 'LOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2287.png',
  },
  {
    chainId: 1,
    name: 'Worldcore',
    address: '0x72adadb447784dd7ab1f472467750fc485e4cb2d',
    decimals: 6,
    symbol: 'WRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2288.png',
  },
  {
    chainId: 1,
    name: 'Genaro Network',
    address: '0x6ec8a24cabdc339a06a172f8223ea557055adaa5',
    decimals: 9,
    symbol: 'GNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2291.png',
  },
  {
    chainId: 1,
    name: 'Starbase',
    address: '0xf70a642bd387f94380ffb90451c2c81d4eb82cbc',
    decimals: 18,
    symbol: 'STAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2295.png',
  },
  {
    chainId: 1,
    name: 'OST',
    address: '0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca',
    decimals: 18,
    symbol: 'OST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2296.png',
  },
  {
    chainId: 1,
    name: 'StormX',
    address: '0xa62cc35625b0c8dc1faea39d33625bb4c15bd71c',
    decimals: 18,
    symbol: 'STMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2297.png',
  },
  {
    chainId: 1,
    name: 'Dynamic Trading Rights',
    address: '0xd234bf2410a0009df9c3c63b610c09738f18ccd7',
    decimals: 8,
    symbol: 'DTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2298.png',
  },
  {
    chainId: 1,
    name: 'aelf',
    address: '0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e',
    decimals: 18,
    symbol: 'ELF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2299.png',
  },
  {
    chainId: 1,
    name: 'WAX',
    address: '0x2a79324c19ef2b89ea98b23bc669b7e7c9f8a517',
    decimals: 8,
    symbol: 'WAXP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2300.png',
  },
  {
    chainId: 1,
    name: 'Crypto Tickets',
    address: '0x233cea452c8b2e46f54d3772592edfeb8edbb763',
    decimals: 18,
    symbol: 'TKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2301.png',
  },
  {
    chainId: 1,
    name: 'DEW',
    address: '0x20e94867794dba030ee287f1406e100d03c84cd3',
    decimals: 18,
    symbol: 'DEW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2304.png',
  },
  {
    chainId: 1,
    name: 'NAGA',
    address: '0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131',
    decimals: 18,
    symbol: 'NGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2305.png',
  },
  {
    chainId: 1,
    name: 'Bread',
    address: '0x558ec3152e2eb2174905cd19aea4e34a23de9ad6',
    decimals: 18,
    symbol: 'BRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2306.png',
  },
  {
    chainId: 1,
    name: 'Bibox Token',
    address: '0x009c43b42aefac590c719e971020575974122803',
    decimals: 18,
    symbol: 'BIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2307.png',
  },
  {
    chainId: 1,
    name: 'Single Collateral DAI ',
    address: '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359',
    decimals: 18,
    symbol: 'SAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2308.png',
  },
  {
    chainId: 1,
    name: 'Bounty0x',
    address: '0xd2d6158683aee4cc838067727209a0aaf4359de3',
    decimals: 18,
    symbol: 'BNTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2310.png',
  },
  {
    chainId: 1,
    name: 'SIRIN LABS Token',
    address: '0x68d57c9a1c35f63e2c83ee8e49a64e9d70528d25',
    decimals: 18,
    symbol: 'SRN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2313.png',
  },
  {
    chainId: 1,
    name: 'Neumark',
    address: '0xa823e6722006afe99e91c30ff5295052fe6b8e32',
    decimals: 18,
    symbol: 'NEU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2318.png',
  },
  {
    chainId: 1,
    name: 'xMoney',
    address: '0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c',
    decimals: 18,
    symbol: 'UTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2320.png',
  },
  {
    chainId: 1,
    name: 'HEROcoin',
    address: '0xe477292f1b3268687a29376116b0ed27a9c76170',
    decimals: 18,
    symbol: 'PLAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2323.png',
  },
  {
    chainId: 1,
    name: 'BigONE Token',
    address: '0x946551dd05c5abd7cc808927480225ce36d8c475',
    decimals: 18,
    symbol: 'ONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2324.png',
  },
  {
    chainId: 1,
    name: 'Matryx',
    address: '0x0af44e2784637218dd1d32a322d44e603a8f0c6a',
    decimals: 18,
    symbol: 'MTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2325.png',
  },
  {
    chainId: 1,
    name: 'Olympus Labs',
    address: '0x263c618480dbe35c300d8d5ecda19bbb986acaed',
    decimals: 18,
    symbol: 'MOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2327.png',
  },
  {
    chainId: 1,
    name: 'Leek Coin',
    address: '0x42c41dabf7962be4f510d54aa9eb0d2240634842',
    decimals: 8,
    symbol: 'LEEK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2328.png',
  },
  {
    chainId: 1,
    name: 'Pylon Network',
    address: '0xd8924385cd46e6af6f377871c732bde2f8e9dd18',
    decimals: 18,
    symbol: 'PYLNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2330.png',
  },
  {
    chainId: 1,
    name: 'FidentiaX',
    address: '0x52a7cb918c11a16958be40cba7e31e32a499a465',
    decimals: 18,
    symbol: 'FDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2333.png',
  },
  {
    chainId: 1,
    name: 'BitClave',
    address: '0x1234567461d3f8db7496581774bd869c83d51c93',
    decimals: 18,
    symbol: 'CAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2334.png',
  },
  {
    chainId: 1,
    name: 'Game.com',
    address: '0xB70835D7822eBB9426B56543E391846C107bd32C',
    decimals: 18,
    symbol: 'GTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2336.png',
  },
  {
    chainId: 1,
    name: 'Nimfamoney',
    address: '0xe26517a9967299453d3f1b48aa005e6127e67210',
    decimals: 18,
    symbol: 'NIMFA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2339.png',
  },
  {
    chainId: 1,
    name: 'Bloom',
    address: '0x107c4504cd79c5d2696ea0030a8dd4e92601b82e',
    decimals: 18,
    symbol: 'BLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2340.png',
  },
  {
    chainId: 1,
    name: 'SwftCoin',
    address: '0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e',
    decimals: 18,
    symbol: 'SWFTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2341.png',
  },
  {
    chainId: 1,
    name: 'Covesting',
    address: '0xada86b1b313d1d5267e3fc0bb303f0a2b66d0ea7',
    decimals: 18,
    symbol: 'COV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2342.png',
  },
  {
    chainId: 1,
    name: 'CanYaCoin',
    address: '0x1d462414fe14cf489c7a21cac78509f4bf8cd7c0',
    decimals: 6,
    symbol: 'CAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2343.png',
  },
  {
    chainId: 1,
    name: 'AppCoins',
    address: '0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db',
    decimals: 18,
    symbol: 'APPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2344.png',
  },
  {
    chainId: 1,
    name: 'Measurable Data Token',
    address: '0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26',
    decimals: 18,
    symbol: 'MDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2348.png',
  },
  {
    chainId: 1,
    name: 'Mixin',
    address: '0xa974c709cfb4566686553a20790685a47aceaa33',
    decimals: 18,
    symbol: 'XIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2349.png',
  },
  {
    chainId: 1,
    name: 'GameChain System',
    address: '0x86949dc8043a5fd7619a1289d65964ad5ec3d25c',
    decimals: 8,
    symbol: 'GCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2350.png',
  },
  {
    chainId: 1,
    name: 'Coinlancer',
    address: '0xe81d72d14b1516e68ac3190a46c93302cc8ed60f',
    decimals: 18,
    symbol: 'CL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2352.png',
  },
  {
    chainId: 1,
    name: 'GET Protocol',
    address: '0x8a854288a5976036a725879164ca3e91d30c6a1b',
    decimals: 18,
    symbol: 'GET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2354.png',
  },
  {
    chainId: 1,
    name: 'AI Doctor',
    address: '0x584b44853680ee34a0f337b712a8f66d816df151',
    decimals: 18,
    symbol: 'AIDOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2357.png',
  },
  {
    chainId: 1,
    name: 'Content and AD Network',
    address: '0x5f3789907b35DCe5605b00C0bE0a7eCDBFa8A841',
    decimals: 18,
    symbol: 'CAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2358.png',
  },
  {
    chainId: 1,
    name: 'Show',
    address: '0xf41861f194e7ba8de95144a89e0c6ed16ee0b3a0',
    decimals: 18,
    symbol: 'SHOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2361.png',
  },
  {
    chainId: 1,
    name: 'Zap',
    address: '0x6781a0f84c7e9e846dcb84a9a5bd49333067b104',
    decimals: 18,
    symbol: 'ZAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2363.png',
  },
  {
    chainId: 1,
    name: 'TokenClub',
    address: '0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7',
    decimals: 18,
    symbol: 'TCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2364.png',
  },
  {
    chainId: 1,
    name: 'LendConnect',
    address: '0x05c7065d644096a4e4c3fe24af86e36de021074b',
    decimals: 18,
    symbol: 'LCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2365.png',
  },
  {
    chainId: 1,
    name: 'FairGame',
    address: '0x9b20dabcec77f6289113e61893f7beefaeb1990a',
    decimals: 18,
    symbol: 'FAIR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2366.png',
  },
  {
    chainId: 1,
    name: 'Aigang',
    address: '0x1063ce524265d5a3a624f4914acd573dd89ce988',
    decimals: 18,
    symbol: 'AIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2367.png',
  },
  {
    chainId: 1,
    name: 'REBL',
    address: '0x5f53f7a8075614b699baad0bc2c899f4bad8fbbf',
    decimals: 18,
    symbol: 'REBL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2368.png',
  },
  {
    chainId: 1,
    name: 'United Traders Token',
    address: '0x16f812be7fff02caf662b85d5d58a5da6572d4df',
    decimals: 8,
    symbol: 'UTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2371.png',
  },
  {
    chainId: 1,
    name: 'CDX Network',
    address: '0x6fff3806bbac52a20e0d79bc538d527f6a22c96b',
    decimals: 18,
    symbol: 'CDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2372.png',
  },
  {
    chainId: 1,
    name: 'Trade Token',
    address: '0x80bc5512561c7f85a3a9508c7df7901b370fa1df',
    decimals: 18,
    symbol: 'TIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2373.png',
  },
  {
    chainId: 1,
    name: 'BitDegree',
    address: '0x1961b3331969ed52770751fc718ef530838b6dee',
    decimals: 18,
    symbol: 'BDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2374.png',
  },
  {
    chainId: 1,
    name: 'QunQun',
    address: '0x264Dc2DedCdcbb897561A57CBa5085CA416fb7b4',
    decimals: 18,
    symbol: 'QUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2375.png',
  },
  {
    chainId: 1,
    name: 'TopChain',
    address: '0x1b6c5864375b34af3ff5bd2e5f40bc425b4a8d79',
    decimals: 6,
    symbol: 'TOPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2376.png',
  },
  {
    chainId: 1,
    name: 'Leverj',
    address: '0x0f4ca92660efad97a9a70cb0fe969c755439772c',
    decimals: 9,
    symbol: 'LEV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2377.png',
  },
  {
    chainId: 1,
    name: 'Kcash',
    address: '0x32d74896f05204d1b6ae7b0a3cebd7fc0cd8f9c7',
    decimals: 18,
    symbol: 'KCASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2379.png',
  },
  {
    chainId: 1,
    name: 'ATN',
    address: '0x461733c17b0755ca5649b6db08b3e213fcf22546',
    decimals: 18,
    symbol: 'ATN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2380.png',
  },
  {
    chainId: 1,
    name: 'Spectre.ai Dividend Token',
    address: '0x12b306fa98f4cbb8d4457fdff3a0a0a56f07ccdf',
    decimals: 18,
    symbol: 'SXDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2381.png',
  },
  {
    chainId: 1,
    name: 'Spectre.ai Utility Token',
    address: '0x2c82c73d5b34aa015989462b2948cd616a37641f',
    decimals: 18,
    symbol: 'SXUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2382.png',
  },
  {
    chainId: 1,
    name: 'Cloud',
    address: '0xc3951d77737733174152532e8b0f27e2c4e9f0dc',
    decimals: 6,
    symbol: 'CLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2385.png',
  },
  {
    chainId: 1,
    name: 'KemCredit',
    address: '0x4b3eacb500955d22ee8bcdd8dd3d9009e29f2d24',
    decimals: 8,
    symbol: 'KMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2388.png',
  },
  {
    chainId: 1,
    name: 'ugChain',
    address: '0xf485c5e679238f9304d986bb2fc28fe3379200e5',
    decimals: 18,
    symbol: 'UGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2389.png',
  },
  {
    chainId: 1,
    name: 'BANKEX',
    address: '0x45245bc59219eeaaf6cd3f382e078a461ff9de7b',
    decimals: 18,
    symbol: 'BKX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2390.png',
  },
  {
    chainId: 1,
    name: 'EchoLink',
    address: '0x1cf3e03f7360288dd01d0a9cfab266cfcdb3e0c1',
    decimals: 18,
    symbol: 'EKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2391.png',
  },
  {
    chainId: 1,
    name: 'AWARE',
    address: '0xaa26931ebba45b69834eb35fe3315cab4b1e97fe',
    decimals: 8,
    symbol: 'AT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2393.png',
  },
  {
    chainId: 1,
    name: 'Telcoin',
    address: '0x467bccd9d29f223bce8043b84e8c8b282827790f',
    decimals: 2,
    symbol: 'TEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2394.png',
  },
  {
    chainId: 1,
    name: 'WETH',
    address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    decimals: 18,
    symbol: 'WETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png',
  },
  {
    chainId: 1,
    name: 'Hackspace Capital',
    address: '0x43567eb78638A55bbE51E9f9FB5B2D7AD1F125aa',
    decimals: 4,
    symbol: 'HAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2397.png',
  },
  {
    chainId: 1,
    name: 'SelfKey',
    address: '0x4cc19356f2d37338b9802aa8e8fc58b0373296e7',
    decimals: 18,
    symbol: 'KEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2398.png',
  },
  {
    chainId: 1,
    name: 'INT',
    address: '0xbe038a2fdfec62cf1bed852f141a43005035edcc',
    decimals: 18,
    symbol: 'INT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2399.png',
  },
  {
    chainId: 1,
    name: 'OneRoot Network',
    address: '0xff603f43946a3a28df5e6a73172555d8c8b02386',
    decimals: 18,
    symbol: 'RNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2400.png',
  },
  {
    chainId: 1,
    name: 'Global Jobcoin',
    address: '0x2ae965cd3d2b6d186e87d9586fc3bdbfc667cacc',
    decimals: 18,
    symbol: 'GJC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2401.png',
  },
  {
    chainId: 1,
    name: 'InvestDigital',
    address: '0x02c4c78c462e32cca4a90bc499bf411fb7bc6afb',
    decimals: 18,
    symbol: 'IDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2406.png',
  },
  {
    chainId: 1,
    name: 'AICHAIN',
    address: '0x79650799e7899a802cb96c0bc33a6a8d4ce4936c',
    decimals: 18,
    symbol: 'AIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2407.png',
  },
  {
    chainId: 1,
    name: 'Qube',
    address: '0x57838ff342f36a1ec18224981ea8715a4667fb3a',
    decimals: 18,
    symbol: 'QUBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2408.png',
  },
  {
    chainId: 1,
    name: 'EtherDelta Token',
    address: '0xce53a179047ebed80261689367c093c90a94cc08',
    decimals: 8,
    symbol: 'EDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2409.png',
  },
  {
    chainId: 1,
    name: 'SpaceChain',
    address: '0x86ed939b500e121c0c5f493f399084db596dad20',
    decimals: 18,
    symbol: 'SPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2410.png',
  },
  {
    chainId: 1,
    name: 'Ethouse',
    address: '0x5b0751713b2527d7f002c0c4e2a37e1219610a6b',
    decimals: 18,
    symbol: 'HORSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2413.png',
  },
  {
    chainId: 1,
    name: 'RealChain',
    address: '0x13f25cd52b21650caa8225C9942337d914C9B030',
    decimals: 18,
    symbol: 'RCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2414.png',
  },
  {
    chainId: 1,
    name: 'ArbitrageCT',
    address: '0x1245ef80f4d9e02ed9425375e8f649b9221b31d8',
    decimals: 8,
    symbol: 'ARCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2415.png',
  },
  {
    chainId: 1,
    name: 'Purpose',
    address: '0x7641b2Ca9DDD58adDf6e3381c1F994Aac5f1A32f',
    decimals: 18,
    symbol: 'PRPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2417.png',
  },
  {
    chainId: 1,
    name: 'Maverick Chain',
    address: '0xb17df9a3b09583a9bdcf757d6367171476d4d8a3',
    decimals: 18,
    symbol: 'MVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2418.png',
  },
  {
    chainId: 1,
    name: 'Nitro',
    address: '0xec46f8207d766012454c408de210bcbc2243e71c',
    decimals: 18,
    symbol: 'NOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2420.png',
  },
  {
    chainId: 1,
    name: 'VouchForMe',
    address: '0x64CdF819d3E75Ac8eC217B3496d7cE167Be42e80',
    decimals: 18,
    symbol: 'IPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2421.png',
  },
  {
    chainId: 1,
    name: 'IDEX Membership',
    address: '0xcc13fc627effd6e35d2d2706ea3c4d7396c610ea',
    decimals: 8,
    symbol: 'IDXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2422.png',
  },
  {
    chainId: 1,
    name: 'Aurora DAO',
    address: '0xcdcfc0f66c522fd086a1b725ea3c0eeb9f9e8814',
    decimals: 18,
    symbol: 'AURA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2423.png',
  },
  {
    chainId: 1,
    name: 'SingularityNET',
    address: '0x5B7533812759B45C2B44C19e320ba2cD2681b542',
    decimals: 18,
    symbol: 'AGIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2424.png',
  },
  {
    chainId: 1,
    name: 'Global Awards Token',
    address: '0x687174f8c49ceb7729d925c3a961507ea4ac7b28',
    decimals: 18,
    symbol: 'GAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2425.png',
  },
  {
    chainId: 1,
    name: 'ShareX',
    address: '0x2567c677473d110d75a8360c35309e63b1d52429',
    decimals: 8,
    symbol: 'SEXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2426.png',
  },
  {
    chainId: 1,
    name: 'Scry.info',
    address: '0x9F5F3CFD7a32700C93F971637407ff17b91c7342',
    decimals: 18,
    symbol: 'DDD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2428.png',
  },
  {
    chainId: 1,
    name: 'Hydro Protocol',
    address: '0x9af839687f6c94542ac5ece2e317daae355493a1',
    decimals: 18,
    symbol: 'HOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2430.png',
  },
  {
    chainId: 1,
    name: 'Titanium Blockchain',
    address: '0xc7579bb99af590ec71c316e1ac4436c535039594',
    decimals: 18,
    symbol: 'BAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2431.png',
  },
  {
    chainId: 1,
    name: 'StarChain',
    address: '0x8f136cc8bef1fea4a7b71aa2301ff1a52f084384',
    decimals: 8,
    symbol: 'STC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2432.png',
  },
  {
    chainId: 1,
    name: 'LightChain',
    address: '0xd97579Cea3fE2473682a4C42648134BB982433B9',
    decimals: 8,
    symbol: 'LIGHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2435.png',
  },
  {
    chainId: 1,
    name: 'RefToken',
    address: '0x89303500a7abfb178b274fd89f2469c264951e1f',
    decimals: 8,
    symbol: 'REF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2436.png',
  },
  {
    chainId: 1,
    name: 'YEE',
    address: '0x922105fad8153f516bcfb829f56dc097a0e1d705',
    decimals: 18,
    symbol: 'YEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2437.png',
  },
  {
    chainId: 1,
    name: 'Double-A Chain',
    address: '0xe75ad3aab14e4b0df8c5da4286608dabb21bd864',
    decimals: 5,
    symbol: 'AAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2438.png',
  },
  {
    chainId: 1,
    name: 'Read',
    address: '0x13d0bf45e5f319fa0b58900807049f23cae7c40d',
    decimals: 8,
    symbol: 'READ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2440.png',
  },
  {
    chainId: 1,
    name: 'CRYPTO20',
    address: '0x26e75307fc0c021472feb8f727839531f112f317',
    decimals: 18,
    symbol: 'C20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2444.png',
  },
  {
    chainId: 1,
    name: 'Block Array',
    address: '0xa5f8fc0921880cb7342368bd128eb8050442b1a1',
    decimals: 18,
    symbol: 'ARY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2445.png',
  },
  {
    chainId: 1,
    name: 'DATA',
    address: '0x69b148395ce0015c13e36bffbad63f49ef874e03',
    decimals: 18,
    symbol: 'DTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2446.png',
  },
  {
    chainId: 1,
    name: 'Crypterium',
    address: '0x08389495D7456E1951ddF7c3a1314A4bfb646d8B',
    decimals: 18,
    symbol: 'CRPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2447.png',
  },
  {
    chainId: 1,
    name: 'carVertical',
    address: '0x50bc2ecc0bfdf5666640048038c1aba7b7525683',
    decimals: 18,
    symbol: 'CV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2450.png',
  },
  {
    chainId: 1,
    name: 'Pundi X',
    address: '0x358d12436080a01a16f711014610f8a4c2c2d233',
    decimals: 18,
    symbol: 'PXS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2451.png',
  },
  {
    chainId: 1,
    name: 'Tokenbox',
    address: '0x3a92bd396aef82af98ebc0aa9030d25a23b11c6b',
    decimals: 18,
    symbol: 'TBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2452.png',
  },
  {
    chainId: 1,
    name: 'EDUCare',
    address: '0x4ecdb6385f3db3847f9c4a9bf3f9917bb27a5452',
    decimals: 8,
    symbol: 'EKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2453.png',
  },
  {
    chainId: 1,
    name: 'PressOne',
    address: '0xe0d95530820aafc51b1d98023aa1ff000b78d8b2',
    decimals: 18,
    symbol: 'PRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2455.png',
  },
  {
    chainId: 1,
    name: 'Odyssey',
    address: '0x4092678e4E78230F46A1534C0fbc8fA39780892B',
    decimals: 18,
    symbol: 'OCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2458.png',
  },
  {
    chainId: 1,
    name: 'indaHash',
    address: '0x5136C98A80811C3f46bDda8B5c4555CFd9f812F0',
    decimals: 6,
    symbol: 'IDH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2459.png',
  },
  {
    chainId: 1,
    name: 'Peerguess',
    address: '0xbdcfbf5c4d91abc0bc9709c7286d00063c0e6f22',
    decimals: 2,
    symbol: 'GUESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2461.png',
  },
  {
    chainId: 1,
    name: 'AidCoin',
    address: '0x37e8789bb9996cac9156cd5f5fd32599e6b91289',
    decimals: 18,
    symbol: 'AID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2462.png',
  },
  {
    chainId: 1,
    name: 'Devery',
    address: '0x923108a439c4e8c2315c4f6521e5ce95b44e9b4c',
    decimals: 18,
    symbol: 'EVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2464.png',
  },
  {
    chainId: 1,
    name: 'BUX Token',
    address: '0x9A584ca70FF5fa46c511B7Bd1A953d5a4BFFC3B8',
    decimals: 18,
    symbol: 'BUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2465.png',
  },
  {
    chainId: 1,
    name: 'Moola',
    address: '0xdD0020B1D5Ba47A54E2EB16800D73Beb6546f91A',
    decimals: 18,
    symbol: 'AXPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2466.png',
  },
  {
    chainId: 1,
    name: 'OriginTrail',
    address: '0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f',
    decimals: 18,
    symbol: 'TRAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2467.png',
  },
  {
    chainId: 1,
    name: 'LinkEye',
    address: '0xfa3118b34522580c35ae27f6cf52da1dbb756288',
    decimals: 6,
    symbol: 'LET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2468.png',
  },
  {
    chainId: 1,
    name: 'CoinMeet',
    address: '0x7f121d4EC6c2C07eB6BC7989d91d2d4fF654c068',
    decimals: 18,
    symbol: 'MEET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2470.png',
  },
  {
    chainId: 1,
    name: 'All Sports',
    address: '0x2d0e95bd4795d7ace0da3c0ff7b706a5970eb9d3',
    decimals: 18,
    symbol: 'SOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2473.png',
  },
  {
    chainId: 1,
    name: 'Garlicoin',
    address: '0x58f7345b5295e43aa454911571f13be186655be9',
    decimals: 18,
    symbol: 'GRLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2475.png',
  },
  {
    chainId: 1,
    name: 'Ruff',
    address: '0xf278c1ca969095ffddded020290cf8b5c424ace2',
    decimals: 18,
    symbol: 'RUFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2476.png',
  },
  {
    chainId: 1,
    name: 'Nework',
    address: '0x5a1a29dbb6ad6153db764568c1289076bc876df6',
    decimals: 18,
    symbol: 'NKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2477.png',
  },
  {
    chainId: 1,
    name: 'CoinFi',
    address: '0x3136ef851592acf49ca4c825131e364170fa32b3',
    decimals: 18,
    symbol: 'COFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2478.png',
  },
  {
    chainId: 1,
    name: 'HalalChain',
    address: '0x58c69ed6cd6887c0225d1fccecc055127843c69b',
    decimals: 9,
    symbol: 'HLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2480.png',
  },
  {
    chainId: 1,
    name: 'CPChain',
    address: '0xfae4ee59cdd86e3be9e8b90b53aa866327d7c090',
    decimals: 18,
    symbol: 'CPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2482.png',
  },
  {
    chainId: 1,
    name: 'Hi Mutual Society',
    address: '0xAa0bb10CEc1fa372eb3Abc17C933FC6ba863DD9E',
    decimals: 18,
    symbol: 'HMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2484.png',
  },
  {
    chainId: 1,
    name: 'Candy',
    address: '0xf2eab3a2034d3f6b63734d2e08262040e3ff7b48',
    decimals: 18,
    symbol: 'CANDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2485.png',
  },
  {
    chainId: 1,
    name: 'Speed Mining Service',
    address: '0x39013f961c378f02c2b82a6e1d31e9812786fd9d',
    decimals: 3,
    symbol: 'SMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2486.png',
  },
  {
    chainId: 1,
    name: 'ValueChain',
    address: '0x8f7b0b40e27e357540f90f187d90ce06366ac5a5',
    decimals: 18,
    symbol: 'VLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2488.png',
  },
  {
    chainId: 1,
    name: 'CargoX',
    address: '0xb6ee9668771a79be7967ee29a63d4184f8097143',
    decimals: 18,
    symbol: 'CXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2490.png',
  },
  {
    chainId: 1,
    name: 'Elastos',
    address: '0xe6fd75ff38adca4b97fbcd938c86b98772431867',
    decimals: 18,
    symbol: 'ELA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2492.png',
  },
  {
    chainId: 1,
    name: 'STK',
    address: '0xaE73B38d1c9A8b274127ec30160a4927C4d71824',
    decimals: 18,
    symbol: 'STK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2493.png',
  },
  {
    chainId: 1,
    name: 'Monero Gold',
    address: '0x0f598112679b78e17a4a9febc83703710d33489c',
    decimals: 8,
    symbol: 'XMRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2494.png',
  },
  {
    chainId: 1,
    name: 'PARETO Rewards',
    address: '0xea5f88e54d982cbb0c441cde4e79bc305e5b43bc',
    decimals: 18,
    symbol: 'PARETO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2495.png',
  },
  {
    chainId: 1,
    name: 'Polymath',
    address: '0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec',
    decimals: 18,
    symbol: 'POLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2496.png',
  },
  {
    chainId: 1,
    name: 'Medicalchain',
    address: '0x41dbecc1cdc5517c6f76f6a6e836adbee2754de3',
    decimals: 18,
    symbol: 'MTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2497.png',
  },
  {
    chainId: 1,
    name: 'Jibrel Network',
    address: '0xa5fd1a791c4dfcaacc963d4f73c6ae5824149ea7',
    decimals: 18,
    symbol: 'JNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2498.png',
  },
  {
    chainId: 1,
    name: 'SwissBorg',
    address: '0x64d0f55cd8c7133a9d7102b13987235f486f2224',
    decimals: 18,
    symbol: 'BORG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2499.png',
  },
  {
    chainId: 1,
    name: 'Zilla',
    address: '0xfd8971d5e8e1740ce2d0a84095fca4de729d0c16',
    decimals: 18,
    symbol: 'ZLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2500.png',
  },
  {
    chainId: 1,
    name: 'adbank',
    address: '0x2baac9330cf9ac479d819195794d79ad0c7616e3',
    decimals: 18,
    symbol: 'ADB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2501.png',
  },
  {
    chainId: 1,
    name: 'Huobi Token',
    address: '0x6f259637dcd74c767781e37bc6133cd6a68aa161',
    decimals: 18,
    symbol: 'HT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2502.png',
  },
  {
    chainId: 1,
    name: 'DMarket',
    address: '0x2ccbff3a042c68716ed2a2cb0c544a9f1d1935e1',
    decimals: 8,
    symbol: 'DMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2503.png',
  },
  {
    chainId: 1,
    name: 'Iungo',
    address: '0x24ddff6d8b8a42d835af3b440de91f3386554aa4',
    decimals: 18,
    symbol: 'ING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2504.png',
  },
  {
    chainId: 1,
    name: 'Bluzelle',
    address: '0x5732046a883704404f284ce41ffadd5b007fd668',
    decimals: 18,
    symbol: 'BLZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2505.png',
  },
  {
    chainId: 1,
    name: 'Swarm',
    address: '0x3505f494c3f0fed0b594e01fa41dd3967645ca39',
    decimals: 18,
    symbol: 'SWM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2506.png',
  },
  {
    chainId: 1,
    name: 'DCORP Utility',
    address: '0xe30e02f049957e2a5907589e06ba646fb2c321ba',
    decimals: 8,
    symbol: 'DRPU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2508.png',
  },
  {
    chainId: 1,
    name: 'EtherSportz',
    address: '0xe8a1df958be379045e2b46a31a98b93a2ecdfded',
    decimals: 18,
    symbol: 'ESZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2509.png',
  },
  {
    chainId: 1,
    name: 'Datawallet',
    address: '0x8db54ca569d3019a2ba126d03c37c44b5ef81ef6',
    decimals: 8,
    symbol: 'DXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2510.png',
  },
  {
    chainId: 1,
    name: 'WePower',
    address: '0x4CF488387F035FF08c371515562CBa712f9015d4',
    decimals: 18,
    symbol: 'WPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2511.png',
  },
  {
    chainId: 1,
    name: 'UNIVERSAL CASH',
    address: '0x92e52a1a235d9a103d970901066ce910aacefd37',
    decimals: 18,
    symbol: 'UCASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2512.png',
  },
  {
    chainId: 1,
    name: 'GoldMint',
    address: '0x83cee9e086a77e492ee0bb93c2b0437ad6fdeccc',
    decimals: 18,
    symbol: 'MNTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2513.png',
  },
  {
    chainId: 1,
    name: 'Animation Vision Cash',
    address: '0xd7cddd45629934c2f6ed3b63217bd8085d7c14a8',
    decimals: 18,
    symbol: 'AVH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2517.png',
  },
  {
    chainId: 1,
    name: 'LOCIcoin',
    address: '0x9c23d67aea7b95d80942e3836bcdf7e708a747c2',
    decimals: 18,
    symbol: 'LOCI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2518.png',
  },
  {
    chainId: 1,
    name: 'Indicoin',
    address: '0xe8c09672cfb9cfce6e2edbb01057d9fa569f97c1',
    decimals: 18,
    symbol: 'INDI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2519.png',
  },
  {
    chainId: 1,
    name: 'Jesus Coin',
    address: '0xe2d82dc7da0e6f882e96846451f4fabcc8f90528',
    decimals: 18,
    symbol: 'JC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2520.png',
  },
  {
    chainId: 1,
    name: 'Tigereum',
    address: '0xeee2d00eb7deb8dd6924187f5aa3496b7d06e62a',
    decimals: 18,
    symbol: 'TIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2523.png',
  },
  {
    chainId: 1,
    name: 'Universa',
    address: '0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7',
    decimals: 18,
    symbol: 'UTNP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2524.png',
  },
  {
    chainId: 1,
    name: 'Envion',
    address: '0xd780ae2bf04cd96e577d3d014762f831d97129d0',
    decimals: 18,
    symbol: 'EVN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2526.png',
  },
  {
    chainId: 1,
    name: 'Dether',
    address: '0x5adc961d6ac3f7062d2ea45fefb8d8167d44b190',
    decimals: 18,
    symbol: 'DTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2528.png',
  },
  {
    chainId: 1,
    name: 'Fusion',
    address: '0x9AfC975EdB8a0B57f066e8e0A72A5e2ADbdCb605',
    decimals: 18,
    symbol: 'FSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2530.png',
  },
  {
    chainId: 1,
    name: 'Etherecash',
    address: '0xcde86186866ca04a5da9240cbfae4306499a2125',
    decimals: 18,
    symbol: 'ECH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2532.png',
  },
  {
    chainId: 1,
    name: 'Restart Energy MWAT',
    address: '0x6425c6be902d692ae2db752b3c268afadb099d3b',
    decimals: 18,
    symbol: 'MWAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2533.png',
  },
  {
    chainId: 1,
    name: 'Gladius Token',
    address: '0x71D01dB8d6a2fBEa7f8d434599C237980C234e4C',
    decimals: 8,
    symbol: 'GLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2534.png',
  },
  {
    chainId: 1,
    name: 'Edge',
    address: '0x4ec1b60b96193a64acae44778e51f7bff2007831',
    decimals: 18,
    symbol: 'EDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2535.png',
  },
  {
    chainId: 1,
    name: 'Neurotoken',
    address: '0x69beab403438253f13b6e92db91f7fb849258263',
    decimals: 18,
    symbol: 'NTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2536.png',
  },
  {
    chainId: 1,
    name: 'Gems',
    address: '0xc7bba5b765581efb2cdd2679db5bea9ee79b201f',
    decimals: 18,
    symbol: 'GEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2537.png',
  },
  {
    chainId: 1,
    name: 'Nectar',
    address: '0xcc80c051057b774cd75067dc48f8987c4eb97a5e',
    decimals: 18,
    symbol: 'NEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2538.png',
  },
  {
    chainId: 1,
    name: 'Ren',
    address: '0x408e41876cccdc0f92210600ef50372656052a38',
    decimals: 18,
    symbol: 'REN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2539.png',
  },
  {
    chainId: 1,
    name: 'Storiqa',
    address: '0x5c3a228510d246b78a3765c20221cbf3082b44a4',
    decimals: 18,
    symbol: 'STQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2541.png',
  },
  {
    chainId: 1,
    name: 'Tidex Token',
    address: '0x317eb4ad9cfac6232f0046831322e895507bcbeb',
    decimals: 18,
    symbol: 'TDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2542.png',
  },
  {
    chainId: 1,
    name: 'Arcblock',
    address: '0xb98d4c97425d9908e66e53a6fdf673acca0be986',
    decimals: 18,
    symbol: 'ABT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2545.png',
  },
  {
    chainId: 1,
    name: 'Remme',
    address: '0x83984d6142934bb535793a82adb0a46ef0f66b6d',
    decimals: 4,
    symbol: 'REM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2546.png',
  },
  {
    chainId: 1,
    name: 'Experty',
    address: '0x5c743a35e903f6c584514ec617acee0611cf44f3',
    decimals: 18,
    symbol: 'EXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2547.png',
  },
  {
    chainId: 1,
    name: 'POA Network',
    address: '0x6758b7d441a9739b98552b373703d8d3d14f9e62',
    decimals: 18,
    symbol: 'POA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2548.png',
  },
  {
    chainId: 1,
    name: 'Ink Protocol',
    address: '0xbc86727e770de68b1060c91f6bb6945c73e10388',
    decimals: 18,
    symbol: 'XNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2549.png',
  },
  {
    chainId: 1,
    name: 'Rock',
    address: '0x106aa49295b525fcf959aa75ec3f7dcbf5352f1c',
    decimals: 18,
    symbol: 'RKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2550.png',
  },
  {
    chainId: 1,
    name: 'Bezop',
    address: '0x8a1e3930fde1f151471c368fdbb39f3f63a65b55',
    decimals: 18,
    symbol: 'BEZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2551.png',
  },
  {
    chainId: 1,
    name: 'IHT Real Estate Protocol',
    address: '0xEda8B016efA8b1161208Cf041cD86972eeE0F31E',
    decimals: 18,
    symbol: 'IHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2552.png',
  },
  {
    chainId: 1,
    name: 'Refereum',
    address: '0xd0929d411954c47438dc1d871dd6081f5c5e149c',
    decimals: 4,
    symbol: 'RFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2553.png',
  },
  {
    chainId: 1,
    name: 'Lympo',
    address: '0xc690f7c7fcffa6a82b79fab7508c466fefdfc8c5',
    decimals: 18,
    symbol: 'LYM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2554.png',
  },
  {
    chainId: 1,
    name: 'Sether',
    address: '0x78b039921e84e726eb72e7b1212bb35504c645ca',
    decimals: 18,
    symbol: 'SETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2555.png',
  },
  {
    chainId: 1,
    name: 'Bee Token',
    address: '0x4d8fc1453a0f359e99c9675954e656d80d996fbf',
    decimals: 18,
    symbol: 'BEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2557.png',
  },
  {
    chainId: 1,
    name: 'Cube',
    address: '0x622dFfCc4e83C64ba959530A5a5580687a57581b',
    decimals: 18,
    symbol: 'AUTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2559.png',
  },
  {
    chainId: 1,
    name: 'EZToken',
    address: '0x5e6016ae7d7c49d347dcf834860b9f3ee282812b',
    decimals: 8,
    symbol: 'EZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2560.png',
  },
  {
    chainId: 1,
    name: 'TrueUSD',
    address: '0x0000000000085d4780B73119b644AE5ecd22b376',
    decimals: 18,
    symbol: 'TUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2563.png',
  },
  {
    chainId: 1,
    name: 'HOQU',
    address: '0x1b957dc4aefeed3b4a2351a6a6d5cbfbba0cecfa',
    decimals: 18,
    symbol: 'HQX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2564.png',
  },
  {
    chainId: 1,
    name: 'StarterCoin',
    address: '0x9a005c9a89bd72a4bd27721e7a09a3c11d2b03c4',
    decimals: 18,
    symbol: 'STAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2565.png',
  },
  {
    chainId: 1,
    name: 'Ontology',
    address: '0xcb46C550539ac3DB72dc7aF7c89B11c306C727c2',
    decimals: 18,
    symbol: 'ONT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2566.png',
  },
  {
    chainId: 1,
    name: 'DATx',
    address: '0xabbbb6447b68ffd6141da77c18c7b5876ed6c5ab',
    decimals: 18,
    symbol: 'DATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2567.png',
  },
  {
    chainId: 1,
    name: 'JET8',
    address: '0x0d262e5dc4a06a0f1c90ce79c7a60c09dfc884e4',
    decimals: 8,
    symbol: 'J8T',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2568.png',
  },
  {
    chainId: 1,
    name: 'Viction',
    address: '0x05d3606d5c81eb9b7b18530995ec9b29da05faba',
    decimals: 18,
    symbol: 'VIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2570.png',
  },
  {
    chainId: 1,
    name: 'BABB',
    address: '0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135',
    decimals: 18,
    symbol: 'BAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2572.png',
  },
  {
    chainId: 1,
    name: 'Electrify.Asia',
    address: '0xd49ff13661451313ca1553fd6954bd1d9b6e02b9',
    decimals: 18,
    symbol: 'ELEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2573.png',
  },
  {
    chainId: 1,
    name: 'SpherePay',
    address: '0xa9ec9f5c1547bd5b0247cf6ae3aab666d10948be',
    decimals: 18,
    symbol: 'SAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2574.png',
  },
  {
    chainId: 1,
    name: 'Tokenomy',
    address: '0xdd16ec0f66e54d453e6756713e533355989040e4',
    decimals: 18,
    symbol: 'TEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2576.png',
  },
  {
    chainId: 1,
    name: 'TE-FOOD',
    address: '0x2ab6bb8408ca3199b8fa6c92d5b455f820af03c4',
    decimals: 18,
    symbol: 'TONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2578.png',
  },
  {
    chainId: 1,
    name: 'ShipChain',
    address: '0xe25b0bba01dc5630312b6a21927e578061a13f55',
    decimals: 18,
    symbol: 'SHIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2579.png',
  },
  {
    chainId: 1,
    name: 'Leadcoin',
    address: '0x5102791ca02fc3595398400bfe0e33d7b6c82267',
    decimals: 18,
    symbol: 'LDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2580.png',
  },
  {
    chainId: 1,
    name: 'Sharpe Platform Token',
    address: '0xef2463099360a085f1f10b076ed72ef625497a06',
    decimals: 18,
    symbol: 'SHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2581.png',
  },
  {
    chainId: 1,
    name: 'LALA World',
    address: '0xfd107b473ab90e8fbd89872144a3dc92c40fa8c9',
    decimals: 18,
    symbol: 'LALA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2582.png',
  },
  {
    chainId: 1,
    name: 'Debitum',
    address: '0x151202c9c18e495656f372281f493eb7698961d5',
    decimals: 18,
    symbol: 'DEB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2584.png',
  },
  {
    chainId: 1,
    name: 'Synthetix',
    address: '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
    decimals: 18,
    symbol: 'SNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2586.png',
  },
  {
    chainId: 1,
    name: 'Fluz Fluz',
    address: '0x954b5de09a55e59755acbda29e1eb74a45d30175',
    decimals: 18,
    symbol: 'FLUZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2587.png',
  },
  {
    chainId: 1,
    name: 'Loom Network',
    address: '0x42476F744292107e34519F9c357927074Ea3F75D',
    decimals: 18,
    symbol: 'LOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2588.png',
  },
  {
    chainId: 1,
    name: 'Guaranteed Ethurance Token Extra',
    address: '0x07a58629aaf3e1a0d07d8f43114b76bd5eee3b91',
    decimals: 18,
    symbol: 'GETX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2589.png',
  },
  {
    chainId: 1,
    name: 'HireMatch',
    address: '0x865e3707a580f9db89304005cddd050ade8873eb',
    decimals: 18,
    symbol: 'HIRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2590.png',
  },
  {
    chainId: 1,
    name: 'Dropil',
    address: '0x4672bad527107471cb5067a887f4656d585a8a31',
    decimals: 18,
    symbol: 'DROP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2591.png',
  },
  {
    chainId: 1,
    name: 'Banca',
    address: '0x998b3b82bc9dba173990be7afb772788b5acb8bd',
    decimals: 18,
    symbol: 'BANCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2592.png',
  },
  {
    chainId: 1,
    name: 'Dragon Coins',
    address: '0x814f67fa286f7572b041d041b1d99b432c9155ee',
    decimals: 8,
    symbol: 'DRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2593.png',
  },
  {
    chainId: 1,
    name: 'LatiumX',
    address: '0x2f85e502a988af76f7ee6d83b7db8d6c0a823bf9',
    decimals: 8,
    symbol: 'LATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2594.png',
  },
  {
    chainId: 1,
    name: 'NANJCOIN',
    address: '0xffe02ee4c69edf1b340fcad64fbd6b37a7b9e265',
    decimals: 8,
    symbol: 'NANJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2595.png',
  },
  {
    chainId: 1,
    name: 'UpToken',
    address: '0x6ba460ab75cd2c56343b3517ffeba60748654d26',
    decimals: 8,
    symbol: 'UP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2597.png',
  },
  {
    chainId: 1,
    name: 'Banyan Network',
    address: '0x35a69642857083ba2f30bfab735dacc7f0bac969',
    decimals: 18,
    symbol: 'BBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2598.png',
  },
  {
    chainId: 1,
    name: 'Noah Coin',
    address: '0x41b3F18c6384Dc9A39c33AFEcA60d9b8e61eAa9F',
    decimals: 18,
    symbol: 'NOAHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2599.png',
  },
  {
    chainId: 1,
    name: 'LGO Token',
    address: '0x0a50c93c762fdd6e56d86215c24aaad43ab629aa',
    decimals: 8,
    symbol: 'LGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2600.png',
  },
  {
    chainId: 1,
    name: '1World',
    address: '0xfdbc1adc26f0f8f8606a5d63b7d3a3cd21c22b23',
    decimals: 8,
    symbol: '1WO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2601.png',
  },
  {
    chainId: 1,
    name: 'NaPoleonX',
    address: '0x28b5e12cce51f15594b0b91d5b5adaa70f684a02',
    decimals: 2,
    symbol: 'NPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2602.png',
  },
  {
    chainId: 1,
    name: 'BnkToTheFuture',
    address: '0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f',
    decimals: 18,
    symbol: 'BFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2605.png',
  },
  {
    chainId: 1,
    name: 'AMLT',
    address: '0xca0e7269600d353f70b14ad118a49575455c0f2f',
    decimals: 18,
    symbol: 'AMLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2607.png',
  },
  {
    chainId: 1,
    name: 'Mithril',
    address: '0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb',
    decimals: 18,
    symbol: 'MITH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2608.png',
  },
  {
    chainId: 1,
    name: 'Lendroid Support Token',
    address: '0x4de2573e27e648607b50e1cfff921a33e4a34405',
    decimals: 18,
    symbol: 'LST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2609.png',
  },
  {
    chainId: 1,
    name: 'Spectiv',
    address: '0x6888a16ea9792c15a4dcf2f6c623d055c8ede792',
    decimals: 18,
    symbol: 'SIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2611.png',
  },
  {
    chainId: 1,
    name: 'BitRent',
    address: '0x1fe70be734e473e5721ea57c8b5b01e6caa52686',
    decimals: 18,
    symbol: 'RNTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2612.png',
  },
  {
    chainId: 1,
    name: 'Titanium BAR',
    address: '0xee8bd1502c3e9f6c543781467c01592ac51cfbb8',
    decimals: 18,
    symbol: 'TBAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2613.png',
  },
  {
    chainId: 1,
    name: 'BlitzPick',
    address: '0x28dee01d53fed0edf5f6e310bf8ef9311513ae40',
    decimals: 18,
    symbol: 'XBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2614.png',
  },
  {
    chainId: 1,
    name: 'Blocklancer',
    address: '0x63e634330a20150dbb61b15648bc73855d6ccf07',
    decimals: 18,
    symbol: 'LNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2615.png',
  },
  {
    chainId: 1,
    name: 'IP Exchange',
    address: '0x001f0aa5da15585e5b2305dbab2bac425ea71007',
    decimals: 18,
    symbol: 'IPSX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2617.png',
  },
  {
    chainId: 1,
    name: 'StockChain',
    address: '0x355a458d555151d3b27f94227960ade1504e526a',
    decimals: 18,
    symbol: 'SCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2618.png',
  },
  {
    chainId: 1,
    name: 'BitStation',
    address: '0x2f8472dd7ecf7ca760c8f6b45db20ca7cf52f8d7',
    decimals: 18,
    symbol: 'BSTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2619.png',
  },
  {
    chainId: 1,
    name: 'Carbon Protocol',
    address: '0xb4371da53140417cbb3362055374b10d97e420bb',
    decimals: 18,
    symbol: 'SWTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2620.png',
  },
  {
    chainId: 1,
    name: 'ClearCoin',
    address: '0x1E26b3D07E57F453caE30F7DDd2f945f5bF3EF33',
    decimals: 8,
    symbol: 'XCLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2622.png',
  },
  {
    chainId: 1,
    name: 'Sentinel Chain',
    address: '0xa13f0743951b4f6e3e3aa039f682e17279f52bc3',
    decimals: 18,
    symbol: 'SENC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2624.png',
  },
  {
    chainId: 1,
    name: 'Friendz',
    address: '0x23352036e911a22cfc692b5e2e196692658aded9',
    decimals: 18,
    symbol: 'FDZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2626.png',
  },
  {
    chainId: 1,
    name: 'Rentberry',
    address: '0x6aeb95f06cda84ca345c2de0f3b7f96923a44f4c',
    decimals: 14,
    symbol: 'BERRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2628.png',
  },
  {
    chainId: 1,
    name: 'PolySwarm',
    address: '0x9e46a38f5daabe8683e10793b06749eef7d733d1',
    decimals: 18,
    symbol: 'NCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2630.png',
  },
  {
    chainId: 1,
    name: 'ODEM',
    address: '0xbf52f2ab39e26e0951d2a02b49b7702abe30406a',
    decimals: 18,
    symbol: 'ODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2631.png',
  },
  {
    chainId: 1,
    name: 'TokenDesk',
    address: '0x6295Ab2BE04A617747481B292c390BfcA592Cf28',
    decimals: 18,
    symbol: 'TDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2635.png',
  },
  {
    chainId: 1,
    name: 'BelugaPay',
    address: '0x37d40510a2f5bc98aa7a0f7bf4b3453bcfb90ac1',
    decimals: 18,
    symbol: 'BBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2636.png',
  },
  {
    chainId: 1,
    name: 'Fidelium',
    address: '0x52fb36C83ad33C1824912FC81071cA5eEB8AB390',
    decimals: 18,
    symbol: 'FID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2637.png',
  },
  {
    chainId: 1,
    name: 'WCOIN',
    address: '0x899338b84d25ac505a332adce7402d697d947494',
    decimals: 8,
    symbol: 'WIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2640.png',
  },
  {
    chainId: 1,
    name: 'CyberVein',
    address: '0xbe428c3867f05dea2a89fc76a102b544eac7f772',
    decimals: 18,
    symbol: 'CVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2642.png',
  },
  {
    chainId: 1,
    name: 'Sentinel',
    address: '0xc81978862b6cE566400579a5F8975732D42BD410',
    decimals: 6,
    symbol: 'DVPN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2643.png',
  },
  {
    chainId: 1,
    name: 'eosDAC',
    address: '0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba',
    decimals: 18,
    symbol: 'EOSDAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2644.png',
  },
  {
    chainId: 1,
    name: 'U Network',
    address: '0x3543638ed4a9006e4840b105944271bcea15605d',
    decimals: 18,
    symbol: 'UUU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2645.png',
  },
  {
    chainId: 1,
    name: 'AdHive',
    address: '0xe69a353b3152dd7b706ff7dd40fe1d18b7802d31',
    decimals: 18,
    symbol: 'ADH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2646.png',
  },
  {
    chainId: 1,
    name: 'SnipCoin',
    address: '0x44f588aeeb8c44471439d1270b3603c66a9262f1',
    decimals: 18,
    symbol: 'SNIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2647.png',
  },
  {
    chainId: 1,
    name: 'CommerceBlock',
    address: '0x076C97e1c869072eE22f8c91978C99B4bcB02591',
    decimals: 18,
    symbol: 'CBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2650.png',
  },
  {
    chainId: 1,
    name: 'GreenMed',
    address: '0xb444208cb0516c150178fcf9a52604bc04a1acea',
    decimals: 18,
    symbol: 'GRMD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2651.png',
  },
  {
    chainId: 1,
    name: 'Curriculum Vitae',
    address: '0x52DB8ebF894036ec997Da693C5fa237A4fb69d10',
    decimals: 18,
    symbol: 'CVH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2652.png',
  },
  {
    chainId: 1,
    name: 'Auctus',
    address: '0xc12d099be31567add4e4e4d0d45691c3f58f5663',
    decimals: 18,
    symbol: 'AUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2653.png',
  },
  {
    chainId: 1,
    name: 'Budbo Token',
    address: '0xccbf21ba6ef00802ab06637896b799f7101f54a2',
    decimals: 18,
    symbol: 'BUBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2654.png',
  },
  {
    chainId: 1,
    name: 'Daneel',
    address: '0x9b70740e708a083c6ff38df52297020f5dfaa5ee',
    decimals: 10,
    symbol: 'DAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2656.png',
  },
  {
    chainId: 1,
    name: 'BrahmaOS',
    address: '0xD7732e3783b0047aa251928960063f863AD022D8',
    decimals: 18,
    symbol: 'BRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2657.png',
  },
  {
    chainId: 1,
    name: 'Smart MFG',
    address: '0x6710c63432a2de02954fc0f851db07146a6c0312',
    decimals: 18,
    symbol: 'MFG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2658.png',
  },
  {
    chainId: 1,
    name: 'Dignity',
    address: '0xaf446174961cd544e51b89310581669e8fc00d16',
    decimals: 8,
    symbol: 'DIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2659.png',
  },
  {
    chainId: 1,
    name: 'Aditus',
    address: '0x8810c63470d38639954c6b41aac545848c46484a',
    decimals: 18,
    symbol: 'ADI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2660.png',
  },
  {
    chainId: 1,
    name: 'Tripio',
    address: '0x8b40761142b9aa6dc8964e61d0585995425c3d94',
    decimals: 18,
    symbol: 'TRIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2661.png',
  },
  {
    chainId: 1,
    name: 'CryCash',
    address: '0xf41e5fbc2f6aac200dd8619e121ce1f05d150077',
    decimals: 18,
    symbol: 'CRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2664.png',
  },
  {
    chainId: 1,
    name: 'FintruX Network',
    address: '0xd559f20296FF4895da39b5bd9ADd54b442596a61',
    decimals: 18,
    symbol: 'FTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2667.png',
  },
  {
    chainId: 1,
    name: 'Earth Token',
    address: '0x900b4449236a7bb26b286601dd14d2bde7a6ac6c',
    decimals: 8,
    symbol: 'EARTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2668.png',
  },
  {
    chainId: 1,
    name: 'MARK.SPACE',
    address: '0xf453b5b9d4e0b5c62ffb256bb2378cc2bc8e8a89',
    decimals: 8,
    symbol: 'MRK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2669.png',
  },
  {
    chainId: 1,
    name: 'Pixie Coin',
    address: '0xc27c95350ecd634c80df89db0f10cd5c24b7b11f',
    decimals: 2,
    symbol: 'PXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2670.png',
  },
  {
    chainId: 1,
    name: 'SRCOIN',
    address: '0xef8cf79c21637fc6f951bcac348915508a639a41',
    decimals: 18,
    symbol: 'SRCOIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2672.png',
  },
  {
    chainId: 1,
    name: 'PHI Token',
    address: '0x13c2fab6354d3790d8ece4f0f1a3280b4a25ad96',
    decimals: 18,
    symbol: 'PHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2676.png',
  },
  {
    chainId: 1,
    name: 'Linker Coin',
    address: '0x6BEB418Fc6E1958204aC8baddCf109B8E9694966',
    decimals: 18,
    symbol: 'LNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2677.png',
  },
  {
    chainId: 1,
    name: 'TraDove B2BCoin',
    address: '0xe7D3e4413E29ae35B0893140F4500965c74365e5',
    decimals: 18,
    symbol: 'BBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2678.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Machine Learning',
    address: '0xbcdfe338d55c061c084d81fd793ded00a27f226d',
    decimals: 18,
    symbol: 'DML',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2679.png',
  },
  {
    chainId: 1,
    name: 'HBZ coin',
    address: '0xe34e1944e776f39b9252790a0527ebda647ae668',
    decimals: 18,
    symbol: 'HBZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2680.png',
  },
  {
    chainId: 1,
    name: 'Origami',
    address: '0xd2fa8f92ea72abb35dbd6deca57173d22db2ba49',
    decimals: 18,
    symbol: 'ORI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2681.png',
  },
  {
    chainId: 1,
    name: 'Holo',
    address: '0x6c6ee5e31d828de241282b9606c8e98ea48526e2',
    decimals: 18,
    symbol: 'HOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2682.png',
  },
  {
    chainId: 1,
    name: 'TrakInvest',
    address: '0x12759512d326303b45f1cec8f7b6fd96f387778e',
    decimals: 18,
    symbol: 'TRAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2683.png',
  },
  {
    chainId: 1,
    name: 'Lendingblock',
    address: '0x0947b0e6d821378805c9598291385ce7c791a6b2',
    decimals: 18,
    symbol: 'LND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2686.png',
  },
  {
    chainId: 1,
    name: 'Proxeus',
    address: '0xa017ac5fac5941f95010b12570b812c974469c2c',
    decimals: 18,
    symbol: 'XES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2687.png',
  },
  {
    chainId: 1,
    name: 'Rublix',
    address: '0xFc2C4D8f95002C14eD0a7aA65102Cac9e5953b5E',
    decimals: 18,
    symbol: 'RBLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2689.png',
  },
  {
    chainId: 1,
    name: 'Biotron',
    address: '0x03c780cd554598592b97b7256ddaad759945b125',
    decimals: 18,
    symbol: 'BTRN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2690.png',
  },
  {
    chainId: 1,
    name: 'Penta',
    address: '0x53066cddbc0099eb6c96785d9b3df2aaeede5da3',
    decimals: 18,
    symbol: 'PNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2691.png',
  },
  {
    chainId: 1,
    name: 'Nexo',
    address: '0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206',
    decimals: 18,
    symbol: 'NEXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2694.png',
  },
  {
    chainId: 1,
    name: 'TrueVett',
    address: '0xc343f099d3e41aa5c1b59470450e21e92e2d840b',
    decimals: 18,
    symbol: 'VME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2695.png',
  },
  {
    chainId: 1,
    name: 'DAEX',
    address: '0x0b4bdc478791897274652dc15ef5c135cae61e60',
    decimals: 18,
    symbol: 'DAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2696.png',
  },
  {
    chainId: 1,
    name: 'Hade Platform',
    address: '0x7b171c08d812f9c642dcf61f7e080610cbca64b3',
    decimals: 18,
    symbol: 'HADE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2697.png',
  },
  {
    chainId: 1,
    name: 'Sharder',
    address: '0xbbff862d906e348e9946bfb2132ecb157da3d4b4',
    decimals: 18,
    symbol: 'SS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2699.png',
  },
  {
    chainId: 1,
    name: 'Celsius',
    address: '0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d',
    decimals: 4,
    symbol: 'CEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2700.png',
  },
  {
    chainId: 1,
    name: 'BetterBetting',
    address: '0x763186eb8d4856d536ed4478302971214febc6a9',
    decimals: 18,
    symbol: 'BETR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2703.png',
  },
  {
    chainId: 1,
    name: 'Transcodium',
    address: '0xb0280743b44bf7db4b6be482b2ba7b75e5da096c',
    decimals: 18,
    symbol: 'TNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2704.png',
  },
  {
    chainId: 1,
    name: 'Amon',
    address: '0x737f98ac8ca59f2c68ad658e3c3d8c8963e40a4c',
    decimals: 18,
    symbol: 'AMN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2705.png',
  },
  {
    chainId: 1,
    name: 'FLIP',
    address: '0x3a1bda28adb5b0a812a7cf10a1950c920f79bcd3',
    decimals: 18,
    symbol: 'FLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2707.png',
  },
  {
    chainId: 1,
    name: 'Crowd Machine',
    address: '0x47bc01597798dcd7506dcca36ac4302fc93a8cfb',
    decimals: 8,
    symbol: 'CMCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2708.png',
  },
  {
    chainId: 1,
    name: 'Morpheus Labs',
    address: '0x4a527d8fc13c5203ab24ba0944f4cb14658d1db6',
    decimals: 18,
    symbol: 'MITX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2709.png',
  },
  {
    chainId: 1,
    name: 'Live Stars',
    address: '0x24a77c1f17c547105e14813e517be06b0040aa76',
    decimals: 18,
    symbol: 'LIVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2710.png',
  },
  {
    chainId: 1,
    name: 'DOC.COM',
    address: '0x905E337c6c8645263D3521205Aa37bf4d034e745',
    decimals: 18,
    symbol: 'MTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2711.png',
  },
  {
    chainId: 1,
    name: 'MyToken',
    address: '0x9b4e2b4b13d125238aa0480dd42b4f6fc71b37cc',
    decimals: 18,
    symbol: 'MT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2712.png',
  },
  {
    chainId: 1,
    name: 'KEY',
    address: '0x4cd988afbad37289baaf53c13e98e2bd46aaea8c',
    decimals: 18,
    symbol: 'KEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2713.png',
  },
  {
    chainId: 1,
    name: 'ConnectJob',
    address: '0x3abdff32f76b42e7635bdb7e425f0231a5f3ab17',
    decimals: 18,
    symbol: 'CJT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2715.png',
  },
  {
    chainId: 1,
    name: 'Galaxy eSolutions',
    address: '0xfb1e5f5e984c28ad7e228cdaa1f8a0919bb6a09b',
    decimals: 18,
    symbol: 'GES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2716.png',
  },
  {
    chainId: 1,
    name: 'BoutsPro',
    address: '0x139d9397274bb9e2c29a9aa8aa0b5874d30d62e3',
    decimals: 18,
    symbol: 'BOUTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2717.png',
  },
  {
    chainId: 1,
    name: 'Cybereits',
    address: '0x61f33Da40594cEc1E3Dc900FaF99F861D01e2e7D',
    decimals: 18,
    symbol: 'CRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2719.png',
  },
  {
    chainId: 1,
    name: 'Parkgene',
    address: '0x6dd4e4aad29a40edd6a409b9c1625186c9855b4d',
    decimals: 8,
    symbol: 'GENE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2720.png',
  },
  {
    chainId: 1,
    name: 'FuzeX',
    address: '0x1829aa045e21e0d59580024a951db48096e01782',
    decimals: 18,
    symbol: 'FXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2723.png',
  },
  {
    chainId: 1,
    name: 'Zippie',
    address: '0xedd7c94fd7b4971b916d15067bc454b9e1bad980',
    decimals: 18,
    symbol: 'ZIPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2724.png',
  },
  {
    chainId: 1,
    name: 'Skrumble Network',
    address: '0x048fe49be32adfc9ed68c37d32b5ec9df17b3603',
    decimals: 18,
    symbol: 'SKM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2725.png',
  },
  {
    chainId: 1,
    name: 'DAOstack',
    address: '0x543ff227f64aa17ea132bf9886cab5db55dcaddf',
    decimals: 18,
    symbol: 'GEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2726.png',
  },
  {
    chainId: 1,
    name: 'Bezant',
    address: '0xe1aee98495365fc179699c1bb3e761fa716bee62',
    decimals: 18,
    symbol: 'BZNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2727.png',
  },
  {
    chainId: 1,
    name: 'Winding Tree',
    address: '0x9C38688E5ACB9eD6049c8502650db5Ac8Ef96465',
    decimals: 18,
    symbol: 'LIF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2728.png',
  },
  {
    chainId: 1,
    name: 'Fitrova',
    address: '0x48df4e0296f908ceab0428a5182d19b31fc037d6',
    decimals: 8,
    symbol: 'FRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2730.png',
  },
  {
    chainId: 1,
    name: 'Aston',
    address: '0x1a0f2ab46ec630f9fd638029027b552afa64b94c',
    decimals: 18,
    symbol: 'ATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2732.png',
  },
  {
    chainId: 1,
    name: 'Freyrchain',
    address: '0x17e67d1cb4e349b9ca4bc3e17c7df2a397a7bb64',
    decimals: 18,
    symbol: 'FREC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2733.png',
  },
  {
    chainId: 1,
    name: 'EduCoin',
    address: '0xf263292e14d9d8ecd55b58dad1f1df825a874b7c',
    decimals: 18,
    symbol: 'EDU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2734.png',
  },
  {
    chainId: 1,
    name: 'Content Neutrality Network',
    address: '0x8713d26637cf49e1b6b4a7ce57106aabc9325343',
    decimals: 18,
    symbol: 'CNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2735.png',
  },
  {
    chainId: 1,
    name: 'InsurChain',
    address: '0x6ea6531b603f270d23d9edd2d8279135dc5d6773',
    decimals: 18,
    symbol: 'INSUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2736.png',
  },
  {
    chainId: 1,
    name: 'Global Social Chain',
    address: '0x228ba514309ffdf03a81a205a6d040e429d6e80c',
    decimals: 18,
    symbol: 'GSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2737.png',
  },
  {
    chainId: 1,
    name: 'Super Game Chain',
    address: '0xec985525f3f22c7fa9c9ff4a49e37589a76d86d4',
    decimals: 18,
    symbol: 'SGCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2738.png',
  },
  {
    chainId: 1,
    name: 'Digix Gold Token',
    address: '0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf',
    decimals: 9,
    symbol: 'DGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2739.png',
  },
  {
    chainId: 1,
    name: 'Influence Chain',
    address: '0x4bffc9b4d4dcf730820a2edcad48ff5d7e0ae807',
    decimals: 18,
    symbol: 'INC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2740.png',
  },
  {
    chainId: 1,
    name: 'Intelligent Investment Chain',
    address: '0xb6f43025b29196af2dddd69b0a58afba079cd600',
    decimals: 18,
    symbol: 'IIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2741.png',
  },
  {
    chainId: 1,
    name: 'Sakura Bloom',
    address: '0x4af328c52921706dcb739f25786210499169afe6',
    decimals: 8,
    symbol: 'SKB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2742.png',
  },
  {
    chainId: 1,
    name: 'NPER',
    address: '0x4ce6b362bc77a24966dda9078f9cef81b3b886a7',
    decimals: 18,
    symbol: 'NPER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2744.png',
  },
  {
    chainId: 1,
    name: 'Joint Ventures',
    address: '0x347c099f110ca6761779329d2879957b606b6ace',
    decimals: 18,
    symbol: 'JOINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2745.png',
  },
  {
    chainId: 1,
    name: 'BlockMesh',
    address: '0xf03045a4c8077e38f3b8e2ed33b8aee69edf869f',
    decimals: 18,
    symbol: 'BMH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2747.png',
  },
  {
    chainId: 1,
    name: 'Oxen',
    address: '0xd1e2d5085b39b80c9948aeb1b9aa83af6756bcc5',
    decimals: 9,
    symbol: 'OXEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2748.png',
  },
  {
    chainId: 1,
    name: 'Signals Network',
    address: '0xb2135ab9695a7678dd590b1a996cb0f37bcb0718',
    decimals: 9,
    symbol: 'SGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2749.png',
  },
  {
    chainId: 1,
    name: 'Oyster Shell',
    address: '0x8542325b72c6d9fc0ad2ca965a78435413a915a0',
    decimals: 18,
    symbol: 'SHL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2750.png',
  },
  {
    chainId: 1,
    name: 'FundRequest',
    address: '0x4df47b4969b2911c966506e3592c41389493953b',
    decimals: 18,
    symbol: 'FND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2751.png',
  },
  {
    chainId: 1,
    name: 'Datarius Credit',
    address: '0xc20464e0c373486d2b3335576e83a218b1618a5e',
    decimals: 18,
    symbol: 'DTRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2752.png',
  },
  {
    chainId: 1,
    name: 'Colu Local Network',
    address: '0x4162178b78d6985480a308b2190ee5517460406d',
    decimals: 18,
    symbol: 'CLN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2753.png',
  },
  {
    chainId: 1,
    name: 'HeroNode',
    address: '0x491c9a23db85623eed455a8efdd6aba9b911c5df',
    decimals: 18,
    symbol: 'HER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2754.png',
  },
  {
    chainId: 1,
    name: 'Raise',
    address: '0x10ba8c420e912bf07bedac03aa6908720db04e0c',
    decimals: 18,
    symbol: 'RAISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2755.png',
  },
  {
    chainId: 1,
    name: 'Tokia',
    address: '0xdae1baf249964bc4b6ac98c3122f0e3e785fd279',
    decimals: 18,
    symbol: 'TKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2756.png',
  },
  {
    chainId: 1,
    name: 'Callisto Network',
    address: '0xccbf1c9e8b4f2cdf3bfba1098b8f56f97d219d53',
    decimals: 18,
    symbol: 'CLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2757.png',
  },
  {
    chainId: 1,
    name: 'Unibright',
    address: '0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e',
    decimals: 8,
    symbol: 'UBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2758.png',
  },
  {
    chainId: 1,
    name: 'Patron',
    address: '0xF3b3Cad094B89392fcE5faFD40bC03b80F2Bc624',
    decimals: 18,
    symbol: 'PAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2759.png',
  },
  {
    chainId: 1,
    name: 'Cred',
    address: '0xfe5f141bf94fe84bc28ded0ab966c16b17490657',
    decimals: 18,
    symbol: 'LBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2760.png',
  },
  {
    chainId: 1,
    name: 'Open Platform',
    address: '0x9d86b1b2554ec410eccffbf111a6994910111340',
    decimals: 8,
    symbol: 'OPEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2762.png',
  },
  {
    chainId: 1,
    name: 'Morpheus.Network',
    address: '0xd3E4Ba569045546D09CF021ECC5dFe42b1d7f6E4',
    decimals: 18,
    symbol: 'MNW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2763.png',
  },
  {
    chainId: 1,
    name: 'Silent Notary',
    address: '0x86EFc496DcA70bcFD92D19194290e8457a375773',
    decimals: 18,
    symbol: 'UBSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2764.png',
  },
  {
    chainId: 1,
    name: 'XYO',
    address: '0x55296f69f40ea6d20e478533c15a6b08b654e758',
    decimals: 18,
    symbol: 'XYO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2765.png',
  },
  {
    chainId: 1,
    name: 'Cryptaur',
    address: '0x88d50B466BE55222019D71F9E8fAe17f5f45FCA1',
    decimals: 8,
    symbol: 'CPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2766.png',
  },
  {
    chainId: 1,
    name: 'Fabric Token',
    address: '0x78a73B6CBc5D183CE56e786f6e905CaDEC63547B',
    decimals: 18,
    symbol: 'FT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2768.png',
  },
  {
    chainId: 1,
    name: 'RED',
    address: '0x76960dccd5a1fe799f7c29be9f19ceb4627aeb2f',
    decimals: 18,
    symbol: 'RED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2771.png',
  },
  {
    chainId: 1,
    name: 'Digitex',
    address: '0xc666081073e8dff8d3d1c2292a29ae1a2153ec09',
    decimals: 18,
    symbol: 'DGTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2772.png',
  },
  {
    chainId: 1,
    name: 'Faceter',
    address: '0x1ccaa0f2a7210d76e1fdec740d5f323e2e1b1672',
    decimals: 18,
    symbol: 'FACE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2775.png',
  },
  {
    chainId: 1,
    name: 'AVA',
    address: '0xa6C0c097741D55ECd9a3A7DeF3A8253fD022ceB9',
    decimals: 18,
    symbol: 'AVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2776.png',
  },
  {
    chainId: 1,
    name: 'IoTeX',
    address: '0x6fb3e0a217407efff7ca062d46c26e5d60a14d69',
    decimals: 18,
    symbol: 'IOTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2777.png',
  },
  {
    chainId: 1,
    name: 'Eximchain',
    address: '0x00c4b398500645eb5da00a1a379a88b11683ba01',
    decimals: 18,
    symbol: 'EXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2778.png',
  },
  {
    chainId: 1,
    name: 'Level Up Coin',
    address: '0x5dbe296f97b23c4a6aa6183d73e574d02ba5c719',
    decimals: 18,
    symbol: 'LUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2779.png',
  },
  {
    chainId: 1,
    name: 'Naviaddress',
    address: '0x588047365df5ba589f923604aac23d673555c623',
    decimals: 18,
    symbol: 'NAVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2825.png',
  },
  {
    chainId: 1,
    name: 'Zipper',
    address: '0xa9d2927d3a04309e008b6af6e2e282ae2952e7fd',
    decimals: 18,
    symbol: 'ZIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2826.png',
  },
  {
    chainId: 1,
    name: 'Phantasma',
    address: '0x75858677e27C930FB622759FeafFeE2b754Af07F',
    decimals: 18,
    symbol: 'SOUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2827.png',
  },
  {
    chainId: 1,
    name: 'SPINDLE',
    address: '0x1dEa979ae76f26071870F824088dA78979eb91C8',
    decimals: 18,
    symbol: 'SPD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2828.png',
  },
  {
    chainId: 1,
    name: 'Seele-N',
    address: '0xb1e93236ab6073fdac58ada5564897177d4bcc43',
    decimals: 18,
    symbol: 'SEELE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2830.png',
  },
  {
    chainId: 1,
    name: 'EJOY',
    address: '0xaC0741127CAC11E4455C7943b654bcCeD7FDD5A4',
    decimals: 18,
    symbol: 'EJOY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2831.png',
  },
  {
    chainId: 1,
    name: 'Ivy',
    address: '0xa4ea687a2a7f29cf2dc66b39c68e4411c0d00c49',
    decimals: 18,
    symbol: 'IVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2833.png',
  },
  {
    chainId: 1,
    name: 'Endor Protocol',
    address: '0xc528c28fec0a90c083328bc45f587ee215760a0f',
    decimals: 18,
    symbol: 'EDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2835.png',
  },
  {
    chainId: 1,
    name: 'Bigbom',
    address: '0x84f7c44b6fed1080f647e354d552595be2cc602f',
    decimals: 18,
    symbol: 'BBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2836.png',
  },
  {
    chainId: 1,
    name: '0xBitcoin',
    address: '0xb6ed7644c69416d67b522e20bc294a9a9b405b31',
    decimals: 8,
    symbol: '0xBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2837.png',
  },
  {
    chainId: 1,
    name: 'Shopin',
    address: '0x6175f6f85339f1e56affac5a68cbf8297969004d',
    decimals: 9,
    symbol: 'SHOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2839.png',
  },
  {
    chainId: 1,
    name: 'QuarkChain',
    address: '0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664',
    decimals: 18,
    symbol: 'QKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2840.png',
  },
  {
    chainId: 1,
    name: 'Bankera',
    address: '0xc80c5e40220172b36adee2c951f26f2a577810c5',
    decimals: 18,
    symbol: 'BNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2842.png',
  },
  {
    chainId: 1,
    name: 'Omix',
    address: '0xb5dbc6d3cf380079df3b27135664b6bcf45d1869',
    decimals: 8,
    symbol: 'OMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2844.png',
  },
  {
    chainId: 1,
    name: 'Abyss',
    address: '0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6',
    decimals: 18,
    symbol: 'ABYSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2847.png',
  },
  {
    chainId: 1,
    name: 'Paymon',
    address: '0x81b4d08645da11374a03749ab170836e4e539767',
    decimals: 9,
    symbol: 'PMNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2848.png',
  },
  {
    chainId: 1,
    name: 'Hurify',
    address: '0xcdb7ecfd3403eef3882c65b761ef9b5054890a47',
    decimals: 18,
    symbol: 'HUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2849.png',
  },
  {
    chainId: 1,
    name: 'CGC Token',
    address: '0x2d9765a94FF22e0CA3AfC3E3F4B116dE2b67582a',
    decimals: 16,
    symbol: 'CGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2851.png',
  },
  {
    chainId: 1,
    name: 'Engine',
    address: '0xaf8a215e81faea7c180ce22b72483525121813bd',
    decimals: 18,
    symbol: 'EGCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2852.png',
  },
  {
    chainId: 1,
    name: 'CBC.network',
    address: '0x26DB5439F651CAF491A87d48799dA81F191bDB6b',
    decimals: 18,
    symbol: 'CBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2855.png',
  },
  {
    chainId: 1,
    name: 'CEEK VR',
    address: '0xb056c38f6b7dc4064367403e26424cd2c60655e1',
    decimals: 18,
    symbol: 'CEEK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2856.png',
  },
  {
    chainId: 1,
    name: 'SalPay',
    address: '0x75c5ee419331b6150879530d06f9ba054755f1da',
    decimals: 18,
    symbol: 'SAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2857.png',
  },
  {
    chainId: 1,
    name: 'Couchain',
    address: '0xf091cf09c51811819db705710e9634b8bf18f164',
    decimals: 18,
    symbol: 'COU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2858.png',
  },
  {
    chainId: 1,
    name: 'XMax',
    address: '0x0f8c45b896784a1e408526b9300519ef8660209c',
    decimals: 8,
    symbol: 'XMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2859.png',
  },
  {
    chainId: 1,
    name: 'Smartshare',
    address: '0x624d520bab2e4ad83935fa503fb130614374e850',
    decimals: 4,
    symbol: 'SSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2862.png',
  },
  {
    chainId: 1,
    name: 'HOLD',
    address: '0xd6e1401a079922469e9b965cb090ea6ff64c6839',
    decimals: 18,
    symbol: 'HOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2863.png',
  },
  {
    chainId: 1,
    name: 'Sentinel Protocol',
    address: '0xc86d054809623432210c107af2e3f619dcfbf652',
    decimals: 18,
    symbol: 'UPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2866.png',
  },
  {
    chainId: 1,
    name: 'Bittwatt',
    address: '0xf53c580bc4065405bc649cc077ff4f2f28528f4b',
    decimals: 18,
    symbol: 'BWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2867.png',
  },
  {
    chainId: 1,
    name: 'Merculet',
    address: '0x8a77e40936bbc27e80e9a3f526368c967869c86d',
    decimals: 18,
    symbol: 'MVP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2869.png',
  },
  {
    chainId: 1,
    name: 'FantasyGold',
    address: '0x41E025EA850bB4d0DCbb5b1F4353aF099CbD026a',
    decimals: 18,
    symbol: 'FGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2870.png',
  },
  {
    chainId: 1,
    name: 'Ubique Chain Of Things',
    address: '0x3c4bEa627039F0B7e7d21E34bB9C9FE962977518',
    decimals: 18,
    symbol: 'UCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2871.png',
  },
  {
    chainId: 1,
    name: 'EnergiToken',
    address: '0x3c4a3ffd813a107febd57b2f01bc344264d90fde',
    decimals: 2,
    symbol: 'ETK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2872.png',
  },
  {
    chainId: 1,
    name: 'Metronome',
    address: '0x2Ebd53d035150f328bd754D6DC66B99B0eDB89aa',
    decimals: 18,
    symbol: 'MET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2873.png',
  },
  {
    chainId: 1,
    name: 'Aurora',
    address: '0x9ab165d795019b6d8b3e971dda91071421305e5a',
    decimals: 18,
    symbol: 'AOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2874.png',
  },
  {
    chainId: 1,
    name: 'DigiFinexToken',
    address: '0xa2a54f1ec1f09316ef12c1770d32ed8f21b1fb6a',
    decimals: 8,
    symbol: 'DFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2878.png',
  },
  {
    chainId: 1,
    name: 'Origin Sport',
    address: '0xeb9a4b185816c354db92db09cc3b50be60b901b6',
    decimals: 18,
    symbol: 'ORS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2879.png',
  },
  {
    chainId: 1,
    name: 'Rate3',
    address: '0x436f0f3a982074c4a05084485d421466a994fe53',
    decimals: 18,
    symbol: 'RTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2880.png',
  },
  {
    chainId: 1,
    name: 'Distributed Credit Chain',
    address: '0xffa93aacf49297d51e211817452839052fdfb961',
    decimals: 18,
    symbol: 'DCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2881.png',
  },
  {
    chainId: 1,
    name: 'Zus',
    address: '0xb9ef770b6a5e12e45983c5d80545258aa38f3b78',
    decimals: 18,
    symbol: 'ZCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2882.png',
  },
  {
    chainId: 1,
    name: 'ZINC',
    address: '0x4aac461c86abfa71e9d00d9a2cde8d74e4e1aeea',
    decimals: 18,
    symbol: 'ZINC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2883.png',
  },
  {
    chainId: 1,
    name: 'FSBT API Token',
    address: '0x1ed7ae1f0e2fa4276dd7ddc786334a3df81d50c0',
    decimals: 18,
    symbol: 'FSBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2884.png',
  },
  {
    chainId: 1,
    name: 'Egretia',
    address: '0x8e1b448ec7adfc7fa35fc2e885678bd323176e34',
    decimals: 18,
    symbol: 'EGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2885.png',
  },
  {
    chainId: 1,
    name: 'TaTaTu',
    address: '0x9cda8a60dd5afa156c95bd974428d91a0812e054',
    decimals: 18,
    symbol: 'TTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2886.png',
  },
  {
    chainId: 1,
    name: 'Dorado',
    address: '0x906b3f8b7845840188eab53c3f5ad348a787752f',
    decimals: 15,
    symbol: 'DOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2887.png',
  },
  {
    chainId: 1,
    name: 'CarBlock',
    address: '0x4d9e23a3842fe7eb7682b9725cf6c507c424a41b',
    decimals: 18,
    symbol: 'CAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2888.png',
  },
  {
    chainId: 1,
    name: "Bob's Repair",
    address: '0xdf347911910b6c9a4286ba8e2ee5ea4a39eb2134',
    decimals: 18,
    symbol: 'BOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2889.png',
  },
  {
    chainId: 1,
    name: 'KanadeCoin',
    address: '0x8E5610ab5E39d26828167640EA29823fe1dD5843',
    decimals: 8,
    symbol: 'KNDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2890.png',
  },
  {
    chainId: 1,
    name: 'Cardstack',
    address: '0x954b890704693af242613edef1b603825afcd708',
    decimals: 18,
    symbol: 'CARD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2891.png',
  },
  {
    chainId: 1,
    name: 'On.Live',
    address: '0x6863be0e7cf7ce860a574760e9020d519a8bdc47',
    decimals: 18,
    symbol: 'ONL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2893.png',
  },
  {
    chainId: 1,
    name: 'OTCBTC Token',
    address: '0xa86a0da9d05d0771955df05b44ca120661af16de',
    decimals: 18,
    symbol: 'OTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2894.png',
  },
  {
    chainId: 1,
    name: 'Coni',
    address: '0x695db6508d66bf111d8d96adaffc5356b7f4581f',
    decimals: 8,
    symbol: 'CONI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2895.png',
  },
  {
    chainId: 1,
    name: 'Mainframe',
    address: '0xdf2c7238198ad8b389666574f2d8bc411a4b7428',
    decimals: 18,
    symbol: 'MFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2896.png',
  },
  {
    chainId: 1,
    name: 'Clipper Coin',
    address: '0xbf59e6fe2bc4ee8d303e493390b4aacab16fcc91',
    decimals: 18,
    symbol: 'CCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2897.png',
  },
  {
    chainId: 1,
    name: 'GoNetwork',
    address: '0x423b5f62b328d0d6d44870f4eee316befa0b2df5',
    decimals: 18,
    symbol: 'GOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2898.png',
  },
  {
    chainId: 1,
    name: 'Thrive Token',
    address: '0x4f27053f32eda8af84956437bc00e5ffa7003287',
    decimals: 18,
    symbol: 'THRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2899.png',
  },
  {
    chainId: 1,
    name: 'FansTime',
    address: '0x943ed852dadb5c3938ecdc6883718df8142de4c8',
    decimals: 18,
    symbol: 'FTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2901.png',
  },
  {
    chainId: 1,
    name: 'POPCHAIN',
    address: '0xe3f4b4a5d91e5cb9435b947f090a319737036312',
    decimals: 18,
    symbol: 'PCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2902.png',
  },
  {
    chainId: 1,
    name: 'SEER',
    address: '0x0f1ed66c251bcb52ecf7e67ac64bb72482048adb',
    decimals: 18,
    symbol: 'SEER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2903.png',
  },
  {
    chainId: 1,
    name: 'FToken',
    address: '0xd37532d304214d588aeeac4c365e8f1d72e2304a',
    decimals: 18,
    symbol: 'FT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2904.png',
  },
  {
    chainId: 1,
    name: 'Qurito',
    address: '0x076a93a40bf9e0d21d3f75dd1e0584ddbe0f9d1a',
    decimals: 18,
    symbol: 'QURO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2905.png',
  },
  {
    chainId: 1,
    name: 'Essentia',
    address: '0xfc05987bd2be489ACCF0f509E44B0145d68240f7',
    decimals: 18,
    symbol: 'ESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2906.png',
  },
  {
    chainId: 1,
    name: 'Karatgold Coin',
    address: '0xf3586684107ce0859c44aa2b2e0fb8cd8731a15a',
    decimals: 7,
    symbol: 'KBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2907.png',
  },
  {
    chainId: 1,
    name: 'HashCoin',
    address: '0x2bba3cf6de6058cc1b4457ce00deb359e2703d7f',
    decimals: 18,
    symbol: 'HSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2908.png',
  },
  {
    chainId: 1,
    name: 'Crowdholding',
    address: '0xd9a12cde03a86e800496469858de8581d3a5353d',
    decimals: 18,
    symbol: 'YUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2910.png',
  },
  {
    chainId: 1,
    name: 'ORS Group',
    address: '0xac2e58a06e6265f1cf5084ee58da68e5d75b49ca',
    decimals: 18,
    symbol: 'ORS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2911.png',
  },
  {
    chainId: 1,
    name: 'Databroker',
    address: '0x765f0c16d1ddc279295c1a7c24b0883f62d33f75',
    decimals: 18,
    symbol: 'DTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2913.png',
  },
  {
    chainId: 1,
    name: 'BeeKan',
    address: '0x6a27348483d59150ae76ef4c0f3622a78b0ca698',
    decimals: 18,
    symbol: 'BKBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2914.png',
  },
  {
    chainId: 1,
    name: 'Moss Coin',
    address: '0xBeE20B9Df360B8442534Ed8059f3e5bAEeB74EaF',
    decimals: 18,
    symbol: 'MOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2915.png',
  },
  {
    chainId: 1,
    name: 'Saifu',
    address: '0x5b135d7e2774c801a73208f258123d7623e07784',
    decimals: 18,
    symbol: 'SFU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2917.png',
  },
  {
    chainId: 1,
    name: 'BitZ Token',
    address: '0x4375e7ad8a01b8ec3ed041399f62d9cd120e0063',
    decimals: 18,
    symbol: 'BZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2918.png',
  },
  {
    chainId: 1,
    name: 'DWS',
    address: '0xf4b54874cd8a6c863e3a904c18fda964661ec363',
    decimals: 18,
    symbol: 'DWS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2919.png',
  },
  {
    chainId: 1,
    name: '0xcert',
    address: '0x83e2be8d114f9661221384b3a50d24b96a5653f5',
    decimals: 18,
    symbol: 'ZXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2920.png',
  },
  {
    chainId: 1,
    name: 'Atonomi',
    address: '0x97aeb5066e1a590e868b511457beb6fe99d329f5',
    decimals: 18,
    symbol: 'ATMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2922.png',
  },
  {
    chainId: 1,
    name: 'XMCT',
    address: '0x44449Fa4d607F807d1eD4a69ad942971728391C8',
    decimals: 18,
    symbol: 'XMCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2923.png',
  },
  {
    chainId: 1,
    name: 'FNKOS',
    address: '0x0707681f344deb24184037fc0228856f2137b02e',
    decimals: 18,
    symbol: 'FNKOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2924.png',
  },
  {
    chainId: 1,
    name: 'RECORD',
    address: '0x57e299ee8f1c5a92a9ed54f934acc7ff5f159699',
    decimals: 18,
    symbol: 'RCD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2925.png',
  },
  {
    chainId: 1,
    name: 'PRASM',
    address: '0x1a66e09f7dccc10eae46e27cfa6b8d44a50df1e7',
    decimals: 18,
    symbol: 'PSM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2926.png',
  },
  {
    chainId: 1,
    name: 'sUSD',
    address: '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
    decimals: 18,
    symbol: 'SUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2927.png',
  },
  {
    chainId: 1,
    name: 'Truegame',
    address: '0xf8e06e4e4a80287fdca5b02dccecaa9d0954840f',
    decimals: 18,
    symbol: 'TGAME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2929.png',
  },
  {
    chainId: 1,
    name: 'IQ',
    address: '0x579cea1889991f68acc35ff5c3dd0621ff29b0c9',
    decimals: 18,
    symbol: 'IQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2930.png',
  },
  {
    chainId: 1,
    name: 'Engagement Token',
    address: '0x5dbac24e98e2a4f43adc0dc82af403fca063ce2c',
    decimals: 18,
    symbol: 'ENGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2931.png',
  },
  {
    chainId: 1,
    name: 'No BS Crypto',
    address: '0xf4faea455575354d2699bc209b0a65ca99f69982',
    decimals: 18,
    symbol: 'NOBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2932.png',
  },
  {
    chainId: 1,
    name: 'BitMart Token',
    address: '0x986EE2B944c42D017F52Af21c4c69B84DBeA35d8',
    decimals: 18,
    symbol: 'BMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2933.png',
  },
  {
    chainId: 1,
    name: 'BitKan',
    address: '0x1410434b0346f5be678d0fb554e5c7ab620f8f4a',
    decimals: 18,
    symbol: 'KAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2934.png',
  },
  {
    chainId: 1,
    name: 'MTC Mesh Network',
    address: '0xdfdc0d82d96f8fd40ca0cfb4a288955becec2088',
    decimals: 18,
    symbol: 'MTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2936.png',
  },
  {
    chainId: 1,
    name: 'VITE',
    address: '0xadd5e881984783dd432f80381fb52f45b53f3e70',
    decimals: 18,
    symbol: 'VITE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2937.png',
  },
  {
    chainId: 1,
    name: 'Hashgard',
    address: '0x5c64031c62061865e5fd0f53d3cdaef80f72e99d',
    decimals: 18,
    symbol: 'GARD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2938.png',
  },
  {
    chainId: 1,
    name: 'Sp8de',
    address: '0x05aaaa829afa407d83315cded1d45eb16025910c',
    decimals: 18,
    symbol: 'SPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2940.png',
  },
  {
    chainId: 1,
    name: 'CoinEx Token',
    address: '0x081f67afa0ccf8c7b17540767bbe95df2ba8d97f',
    decimals: 18,
    symbol: 'CET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2941.png',
  },
  {
    chainId: 1,
    name: 'Rocket Pool',
    address: '0xd33526068d116ce69f19a9ee46f0bd304f21a51f',
    decimals: 18,
    symbol: 'RPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2943.png',
  },
  {
    chainId: 1,
    name: 'Elysian',
    address: '0xa95592dcffa3c080b4b40e459c5f5692f67db7f8',
    decimals: 18,
    symbol: 'ELY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2944.png',
  },
  {
    chainId: 1,
    name: 'ContentBox',
    address: '0x63f584fa56e60e4d0fe8802b27c7e6e3b33e007f',
    decimals: 18,
    symbol: 'BOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2945.png',
  },
  {
    chainId: 1,
    name: 'Proton Token',
    address: '0x4689a4e169eb39cc9078c0940e21ff1aa8a39b9c',
    decimals: 18,
    symbol: 'PTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2946.png',
  },
  {
    chainId: 1,
    name: 'SoPay',
    address: '0x076641af1b8f06b7f8c92587156143c109002cbe',
    decimals: 18,
    symbol: 'SOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2947.png',
  },
  {
    chainId: 1,
    name: 'Jury.Online Token',
    address: '0xdb455c71c1bc2de4e80ca451184041ef32054001',
    decimals: 18,
    symbol: 'JOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2948.png',
  },
  {
    chainId: 1,
    name: 'Kryll',
    address: '0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0',
    decimals: 18,
    symbol: 'KRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2949.png',
  },
  {
    chainId: 1,
    name: 'LemoChain',
    address: '0x60c24407d01782c2175d32fe7c8921ed732371d1',
    decimals: 18,
    symbol: 'LEMO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2950.png',
  },
  {
    chainId: 1,
    name: 'EDU Token',
    address: '0x2a22e5cca00a3d63308fa39f29202eb1b39eef52',
    decimals: 18,
    symbol: 'EDU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2951.png',
  },
  {
    chainId: 1,
    name: 'Gold Bits Coin',
    address: '0xc8058d59e208399b76e66da1ec669dd6b1bee2ea',
    decimals: 10,
    symbol: 'GBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2952.png',
  },
  {
    chainId: 1,
    name: 'Blue Whale EXchange',
    address: '0xce5114d7fa8361f0c088ee26fa3a5446c4a1f50b',
    decimals: 18,
    symbol: 'BWX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2953.png',
  },
  {
    chainId: 1,
    name: 'wys Token',
    address: '0xd8950fdeaa10304b7a7fd03a2fc66bc39f3c711a',
    decimals: 18,
    symbol: 'WYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2954.png',
  },
  {
    chainId: 1,
    name: 'Cosmo Coin',
    address: '0xd1e10c37a27d95d95720291b1dc6f12f74c71443',
    decimals: 18,
    symbol: 'COSM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2955.png',
  },
  {
    chainId: 1,
    name: 'Olive',
    address: '0x9d9223436ddd466fc247e9dbbd20207e640fef58',
    decimals: 18,
    symbol: 'OLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2957.png',
  },
  {
    chainId: 1,
    name: 'WeToken',
    address: '0xaae81c0194d6459f320b70ca0cedf88e11a242ce',
    decimals: 18,
    symbol: 'WT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2959.png',
  },
  {
    chainId: 1,
    name: 'Tourist Token',
    address: '0xe3278df3eb2085ba9b6899812a99a10f9ca5e0df',
    decimals: 8,
    symbol: 'TOTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2960.png',
  },
  {
    chainId: 1,
    name: 'Relex',
    address: '0x4a42d2c580f83dce404acad18dab26db11a1750e',
    decimals: 18,
    symbol: 'RLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2961.png',
  },
  {
    chainId: 1,
    name: 'CHEX',
    address: '0xfbc3c8aad80b5934d134e2cce065702ff254ad7d',
    decimals: 18,
    symbol: 'CHEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2962.png',
  },
  {
    chainId: 1,
    name: 'View',
    address: '0xf03f8d65bafa598611c3495124093c56e8f638f0',
    decimals: 18,
    symbol: 'VIEW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2963.png',
  },
  {
    chainId: 1,
    name: 'ValueCyberToken',
    address: '0x9746953f5b1324a78132895cfd263f417b0faae3',
    decimals: 18,
    symbol: 'VCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2964.png',
  },
  {
    chainId: 1,
    name: 'VikkyToken',
    address: '0xd2946be786f35c3cc402c29b323647abda799071',
    decimals: 8,
    symbol: 'VIKKY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2965.png',
  },
  {
    chainId: 1,
    name: 'AB-Chain RTB',
    address: '0xec491c1088eae992b7a214efb0a266ad0927a72a',
    decimals: 18,
    symbol: 'RTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2967.png',
  },
  {
    chainId: 1,
    name: 'Globalvillage Ecosystem',
    address: '0x81705082ef9f0d660f07be80093d46d826d48b25',
    decimals: 18,
    symbol: 'GVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2969.png',
  },
  {
    chainId: 1,
    name: 'LocalCoinSwap',
    address: '0xaa19961b6b858d9f18a115f25aa1d98abc1fdba8',
    decimals: 18,
    symbol: 'LCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2970.png',
  },
  {
    chainId: 1,
    name: 'Original Crypto Coin',
    address: '0x0235fe624e044a05eed7a43e16e3083bc8a4287a',
    decimals: 18,
    symbol: 'OCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2971.png',
  },
  {
    chainId: 1,
    name: 'ZPER',
    address: '0xb5b8f5616fe42d5ceca3e87f3fddbdd8f496d760',
    decimals: 18,
    symbol: 'ZPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2972.png',
  },
  {
    chainId: 1,
    name: 'empowr coin',
    address: '0xe7d7b37e72510309db27c460378f957b1b04bd5d',
    decimals: 18,
    symbol: 'EMPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2973.png',
  },
  {
    chainId: 1,
    name: 'FundToken',
    address: '0xbf5496122cf1bb778e0cbe5eab936f2be5fc0940',
    decimals: 18,
    symbol: 'FUNDZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2975.png',
  },
  {
    chainId: 1,
    name: 'BitRewards',
    address: '0x47da42696a866cdc61a4c809a515500a242909c1',
    decimals: 18,
    symbol: 'BIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2977.png',
  },
  {
    chainId: 1,
    name: 'Linfinity',
    address: '0x95c9bd1f81cee7391da3eac81693e60f3292c1e0',
    decimals: 18,
    symbol: 'LFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2979.png',
  },
  {
    chainId: 1,
    name: 'WABnetwork',
    address: '0x4bbbc57af270138ef2ff2c50dbfad684e9e0e604',
    decimals: 18,
    symbol: 'WAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2980.png',
  },
  {
    chainId: 1,
    name: 'Consentium',
    address: '0xd8698a985b89650d0a70f99ad2909bd0c0b4b51c',
    decimals: 18,
    symbol: 'CSM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2981.png',
  },
  {
    chainId: 1,
    name: 'MVL',
    address: '0xa849eaae994fb86afa73382e9bd88c2b6b18dc71',
    decimals: 18,
    symbol: 'MVL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2982.png',
  },
  {
    chainId: 1,
    name: 'ARBITRAGE',
    address: '0xafbec4d65bc7b116d85107fd05d912491029bf46',
    decimals: 18,
    symbol: 'ARB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2985.png',
  },
  {
    chainId: 1,
    name: 'DACC',
    address: '0xf8c595d070d104377f58715ce2e6c93e49a87f3c',
    decimals: 6,
    symbol: 'DACC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2986.png',
  },
  {
    chainId: 1,
    name: 'ThingsOperatingSystem',
    address: '0xfb5a551374b656c6e39787b1d3a03feab7f3a98e',
    decimals: 18,
    symbol: 'TOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2987.png',
  },
  {
    chainId: 1,
    name: 'STASIS EURO',
    address: '0xdb25f211ab05b1c97d595516f45794528a807ad8',
    decimals: 2,
    symbol: 'EURS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2989.png',
  },
  {
    chainId: 1,
    name: 'EXMR FDN',
    address: '0x331fa6c97c64e47475164b9fc8143b533c5ef529',
    decimals: 18,
    symbol: 'EXMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2990.png',
  },
  {
    chainId: 1,
    name: 'Wavebase',
    address: '0x8f66a173696502a0ad280781c3e55928a06c1312',
    decimals: 18,
    symbol: 'PWV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2995.png',
  },
  {
    chainId: 1,
    name: 'KWHCoin',
    address: '0xb8ddc930c2bab6c71610a2be639036e829f9c10b',
    decimals: 18,
    symbol: 'KWH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3001.png',
  },
  {
    chainId: 1,
    name: 'Volt',
    address: '0xfc44ec51c80e35a87bc2140299b1636ec83dfb04',
    decimals: 18,
    symbol: 'ACDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3004.png',
  },
  {
    chainId: 1,
    name: 'Coinsuper Ecosystem Network',
    address: '0x0bc61dded5f6710c637cf8288eb6058766ce1921',
    decimals: 18,
    symbol: 'CEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3010.png',
  },
  {
    chainId: 1,
    name: 'BitScreener Token',
    address: '0xff2b3353c3015e9f1fbf95b9bda23f58aa7ce007',
    decimals: 18,
    symbol: 'BITX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3011.png',
  },
  {
    chainId: 1,
    name: 'RightMesh',
    address: '0x8d5682941ce456900b12d47ac06a88b47c764ce1',
    decimals: 18,
    symbol: 'RMESH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3014.png',
  },
  {
    chainId: 1,
    name: 'Brickblock',
    address: '0x4a6058666cf1057eac3cd3a5a614620547559fc9',
    decimals: 18,
    symbol: 'BBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3015.png',
  },
  {
    chainId: 1,
    name: 'NeuroChain',
    address: '0x5d48f293baed247a2d0189058ba37aa238bd4725',
    decimals: 18,
    symbol: 'NCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3016.png',
  },
  {
    chainId: 1,
    name: 'Coinvest',
    address: '0x5e8f855966d638135a968861e80dda722291b06d',
    decimals: 18,
    symbol: 'COIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3017.png',
  },
  {
    chainId: 1,
    name: 'Luna Stars',
    address: '0xc80dae9129389c4ef6e7dbfaee40f28de49de3a6',
    decimals: 18,
    symbol: 'LSTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3019.png',
  },
  {
    chainId: 1,
    name: 'InternationalCryptoX',
    address: '0xa984a92731c088f1ea4d53b71a2565a399f7d8d5',
    decimals: 18,
    symbol: 'INCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3021.png',
  },
  {
    chainId: 1,
    name: 'IOV BlockChain',
    address: '0x0e69d0a2bbb30abcb7e5cfea0e4fde19c00a8d47',
    decimals: 8,
    symbol: 'IOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3026.png',
  },
  {
    chainId: 1,
    name: 'Webcoin',
    address: '0xf344490abd414dafa97f34c8ca501b0aa5bf8873',
    decimals: 1,
    symbol: 'WEB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3027.png',
  },
  {
    chainId: 1,
    name: 'Formosa Financial',
    address: '0xb4d0fdfc8497aef97d3c2892ae682ee06064a2bc',
    decimals: 18,
    symbol: 'FMF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3028.png',
  },
  {
    chainId: 1,
    name: 'Flux',
    address: '0x720cd16b011b987da3518fbf38c3071d4f0d1495',
    decimals: 18,
    symbol: 'FLUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3029.png',
  },
  {
    chainId: 1,
    name: 'BrokerNekoNetwork',
    address: '0xda80b20038bdf968c7307bb5907a469482cf6251',
    decimals: 8,
    symbol: 'BNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3030.png',
  },
  {
    chainId: 1,
    name: 'Latino Token',
    address: '0x567287d4f42086beab4b36de9af21c70adec6760',
    decimals: 4,
    symbol: 'LATINO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3033.png',
  },
  {
    chainId: 1,
    name: 'PDX',
    address: '0x5f33d158ca7275848f70a3f149b421190df85b32',
    decimals: 18,
    symbol: 'PDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3034.png',
  },
  {
    chainId: 1,
    name: 'Blocksquare Token',
    address: '0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a',
    decimals: 18,
    symbol: 'BST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3035.png',
  },
  {
    chainId: 1,
    name: 'Bengoshi Coin',
    address: '0x5808fb823d720e91f1564cd9c9081af7136f73db',
    decimals: 8,
    symbol: 'BENGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3038.png',
  },
  {
    chainId: 1,
    name: 'Excaliburcoin',
    address: '0x2c594e1cb006e86c3879b1d8191a8b059af52be7',
    decimals: 8,
    symbol: 'EXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3039.png',
  },
  {
    chainId: 1,
    name: 'CanonChain',
    address: '0x0223fc70574214f65813fe336d870ac47e147fae',
    decimals: 18,
    symbol: 'CZR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3040.png',
  },
  {
    chainId: 1,
    name: 'FoodCoin',
    address: '0x2a093bcf0c98ef744bb6f69d74f2f85605324290',
    decimals: 8,
    symbol: 'FOOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3041.png',
  },
  {
    chainId: 1,
    name: 'IDOL COIN',
    address: '0x2cc114bbe7b551d62b15c465c7bdcccd9125b182',
    decimals: 8,
    symbol: 'IDOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3042.png',
  },
  {
    chainId: 1,
    name: 'PitisCoin',
    address: '0x540e5fff293f523acd26291b5bc7ac5713991feb',
    decimals: 8,
    symbol: 'PTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3043.png',
  },
  {
    chainId: 1,
    name: 'YOU COIN',
    address: '0x34364BEe11607b1963d66BCA665FDE93fCA666a8',
    decimals: 18,
    symbol: 'YOU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3053.png',
  },
  {
    chainId: 1,
    name: 'DACSEE',
    address: '0xa31108e5bab5494560db34c95492658af239357c',
    decimals: 18,
    symbol: 'DACS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3054.png',
  },
  {
    chainId: 1,
    name: 'EBCoin',
    address: '0x31f3d9d1bece0c033ff78fa6da60a6048f3e13c5',
    decimals: 18,
    symbol: 'EBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3055.png',
  },
  {
    chainId: 1,
    name: 'eSDChain',
    address: '0x4212fea9fec90236ecc51e41e2096b16ceb84555',
    decimals: 18,
    symbol: 'SDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3058.png',
  },
  {
    chainId: 1,
    name: 'Yuan Chain Coin',
    address: '0x37e1160184f7dd29f00b78c050bf13224780b0b0',
    decimals: 8,
    symbol: 'YCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3060.png',
  },
  {
    chainId: 1,
    name: 'Promotion Coin',
    address: '0xa6714a2e5f0b1bdb97b895b0913b4fcd3a775e4d',
    decimals: 5,
    symbol: 'PC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3061.png',
  },
  {
    chainId: 1,
    name: 'EPLUS Coin',
    address: '0x02e3083a51e8632e571fbd6a62ac396c10c653ba',
    decimals: 8,
    symbol: 'EPLUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3064.png',
  },
  {
    chainId: 1,
    name: 'BitCapitalVendor',
    address: '0x1014613e2b3cbc4d575054d4982e580d9b99d7b1',
    decimals: 8,
    symbol: 'BCV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3066.png',
  },
  {
    chainId: 1,
    name: 'XTRD',
    address: '0x9c794f933b4dd8b49031a79b0f924d68bef43992',
    decimals: 18,
    symbol: 'XTRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3067.png',
  },
  {
    chainId: 1,
    name: 'NAM COIN',
    address: '0x05984006707585f66465e8a6505341f46b64fa7a',
    decimals: 18,
    symbol: 'NAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3069.png',
  },
  {
    chainId: 1,
    name: 'Litex',
    address: '0xbc46d9961a3932f7d6b64abfdec80c1816c4b835',
    decimals: 18,
    symbol: 'LXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3070.png',
  },
  {
    chainId: 1,
    name: 'Esports Token',
    address: '0x18f5b4908e8861e3114ba9a0a9a4e84c5f180cc0',
    decimals: 9,
    symbol: 'EST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3073.png',
  },
  {
    chainId: 1,
    name: 'Kind Ads Token',
    address: '0x4618519de4c304f3444ffa7f812dddc2971cc688',
    decimals: 8,
    symbol: 'KIND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3078.png',
  },
  {
    chainId: 1,
    name: 'X8X Token',
    address: '0x910dfc18d6ea3d6a7124a6f8b5458f281060fa4c',
    decimals: 18,
    symbol: 'X8X',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3079.png',
  },
  {
    chainId: 1,
    name: 'Omnitude',
    address: '0x171d750d42d661b62c277a6b486adb82348c3eca',
    decimals: 18,
    symbol: 'ECOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3081.png',
  },
  {
    chainId: 1,
    name: 'Lina Network',
    address: '0xc05d14442a510de4d3d71a3d316585aa0ce32b50',
    decimals: 18,
    symbol: 'LINA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3083.png',
  },
  {
    chainId: 1,
    name: 'Blocktrade Token',
    address: '0xfa456cf55250a839088b27ee32a424d7dacb54ff',
    decimals: 18,
    symbol: 'BTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3084.png',
  },
  {
    chainId: 1,
    name: 'Kora Network Token',
    address: '0xff5c25d2f40b47c4a37f989de933e26562ef0ac0',
    decimals: 16,
    symbol: 'KNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3086.png',
  },
  {
    chainId: 1,
    name: 'AVINOC',
    address: '0xf1ca9cb74685755965c7458528a36934df52a3ef',
    decimals: 18,
    symbol: 'AVINOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3089.png',
  },
  {
    chainId: 1,
    name: 'Wiki Token',
    address: '0x66bad545596fb17a0b4ebdc003a85def10e8f6ae',
    decimals: 18,
    symbol: 'WIKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3090.png',
  },
  {
    chainId: 1,
    name: 'Sapien',
    address: '0x20f7a3ddf244dc9299975b4da1c39f8d5d75f05a',
    decimals: 6,
    symbol: 'SPN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3091.png',
  },
  {
    chainId: 1,
    name: 'Nuggets',
    address: '0x245ef47d4d0505ecf3ac463f4d81f41ade8f1fd1',
    decimals: 18,
    symbol: 'NUG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3092.png',
  },
  {
    chainId: 1,
    name: 'XOVBank',
    address: '0x153ed9cc1b792979d2bde0bbf45cc2a7e436a5f9',
    decimals: 18,
    symbol: 'XOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3097.png',
  },
  {
    chainId: 1,
    name: 'Ultra Salescloud',
    address: '0x2bdbf15d055899a767f5459a151bed15fb8fd2f6',
    decimals: 18,
    symbol: 'UST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3100.png',
  },
  {
    chainId: 1,
    name: 'OptiToken',
    address: '0x832904863978b94802123106e6eb491bdf0df928',
    decimals: 18,
    symbol: 'OPTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3101.png',
  },
  {
    chainId: 1,
    name: 'Unicorn Candy Coin',
    address: '0xcd3673af09e76c74d889aabab68ca0645566a3a1',
    decimals: 18,
    symbol: 'CANDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3102.png',
  },
  {
    chainId: 1,
    name: 'Swytch Energy Token',
    address: '0xfa75b65e52a6cbc5503f45f4abba2c5df4688875',
    decimals: 18,
    symbol: 'SET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3103.png',
  },
  {
    chainId: 1,
    name: 'PKG Token',
    address: '0x02f2d4a04e6e01ace88bd2cd632875543b2ef577',
    decimals: 18,
    symbol: 'PKG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3106.png',
  },
  {
    chainId: 1,
    name: 'BingoCoin',
    address: '0x4b317864a05c91225ab8f401ec7be0aeb87e9c12',
    decimals: 18,
    symbol: 'BOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3107.png',
  },
  {
    chainId: 1,
    name: 'Ordocoin',
    address: '0x7a74c427c833bad2a638e0fb203ba2c728f557c1',
    decimals: 18,
    symbol: 'RDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3109.png',
  },
  {
    chainId: 1,
    name: 'NewsToken',
    address: '0x29536b7ca7029b5cddeb03c0451715615aca35ba',
    decimals: 8,
    symbol: 'NEWOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3110.png',
  },
  {
    chainId: 1,
    name: 'Bitnation',
    address: '0xBB1fA4FdEB3459733bF67EbC6f893003fA976a82',
    decimals: 18,
    symbol: 'XPAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3112.png',
  },
  {
    chainId: 1,
    name: 'RusGas',
    address: '0x4c383bdcae52a6e1cb810c76c70d6f31a249ec9b',
    decimals: 8,
    symbol: 'RGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3114.png',
  },
  {
    chainId: 1,
    name: 'Maximine Coin',
    address: '0x8e766f57f7d16ca50b4a0b90b88f6468a09b0439',
    decimals: 18,
    symbol: 'MXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3115.png',
  },
  {
    chainId: 1,
    name: 'Insight Chain',
    address: '0x17aa18a4b64a55abed7fa543f2ba4e91f2dce482',
    decimals: 18,
    symbol: 'INB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3116.png',
  },
  {
    chainId: 1,
    name: 'Social Lending Token',
    address: '0x851017523ae205adc9195e7f97d029f4cfe7794c',
    decimals: 9,
    symbol: 'SLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3117.png',
  },
  {
    chainId: 1,
    name: 'OWNDATA',
    address: '0x170b275ced089fffaebfe927f445a350ed9160dc',
    decimals: 8,
    symbol: 'OWN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3120.png',
  },
  {
    chainId: 1,
    name: 'IGToken',
    address: '0x8a88f04e0c905054d2f33b26bb3a46d7091a039a',
    decimals: 18,
    symbol: 'IG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3121.png',
  },
  {
    chainId: 1,
    name: 'GSENetwork',
    address: '0xe530441f4f73bDB6DC2fA5aF7c3fC5fD551Ec838',
    decimals: 4,
    symbol: 'GSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3123.png',
  },
  {
    chainId: 1,
    name: 'Themis',
    address: '0x60c68a87be1e8a84144b543aacfa77199cd3d024',
    decimals: 18,
    symbol: 'GET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3127.png',
  },
  {
    chainId: 1,
    name: 'SiaCashCoin',
    address: '0x74fd51a98a4a1ecbef8cc43be801cce630e260bd',
    decimals: 18,
    symbol: 'SCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3128.png',
  },
  {
    chainId: 1,
    name: 'Thingschain',
    address: '0x72430a612adc007c50e3b6946dbb1bb0fd3101d1',
    decimals: 8,
    symbol: 'TIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3131.png',
  },
  {
    chainId: 1,
    name: 'ETERNAL TOKEN',
    address: '0x054c64741dbafdc19784505494029823d89c3b13',
    decimals: 8,
    symbol: 'XET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3134.png',
  },
  {
    chainId: 1,
    name: 'CEDEX Coin',
    address: '0xf4065e4477e91c177ded71a7a6fb5ee07dc46bc9',
    decimals: 18,
    symbol: 'CEDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3135.png',
  },
  {
    chainId: 1,
    name: 'Noku',
    address: '0x8167D3B1024cB51A2DD1B4d889ddf7023420796a',
    decimals: 18,
    symbol: 'NOKU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3138.png',
  },
  {
    chainId: 1,
    name: 'DxChain Token',
    address: '0x973e52691176d36453868D9d86572788d27041A9',
    decimals: 18,
    symbol: 'DX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3139.png',
  },
  {
    chainId: 1,
    name: 'Ubex',
    address: '0x6704b673c70de9bf74c8fba4b4bd748f0e2190e1',
    decimals: 18,
    symbol: 'UBEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3140.png',
  },
  {
    chainId: 1,
    name: 'Blockpass',
    address: '0xee4458e052b533b1aabd493b5f8c4d85d7b263dc',
    decimals: 6,
    symbol: 'PASS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3141.png',
  },
  {
    chainId: 1,
    name: 'BaaSid',
    address: '0x5d929AA919E489505CcAAd8A199619c6DCA0c2de',
    decimals: 18,
    symbol: 'BAAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3142.png',
  },
  {
    chainId: 1,
    name: 'Pecunio',
    address: '0xf5b815344641412401d8e868790dbd125e6761ca',
    decimals: 8,
    symbol: 'PCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3143.png',
  },
  {
    chainId: 1,
    name: 'HYCON',
    address: '0x07c9eEFd9059381144265600d3Cbf4974312861b',
    decimals: 18,
    symbol: 'HYC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3147.png',
  },
  {
    chainId: 1,
    name: 'MetaMorph',
    address: '0xfef3884b603c33ef8ed4183346e093a173c94da6',
    decimals: 18,
    symbol: 'METM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3148.png',
  },
  {
    chainId: 1,
    name: 'Netkoin',
    address: '0x5d4d57cd06fa7fe99e26fdc481b468f77f05073c',
    decimals: 18,
    symbol: 'NTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3149.png',
  },
  {
    chainId: 1,
    name: 'Obitan Chain',
    address: '0x8fC01E6CbDfFaf09B54F423f9Bb1F856b22e47b2',
    decimals: 8,
    symbol: 'OBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3152.png',
  },
  {
    chainId: 1,
    name: 'Twinkle',
    address: '0x13e9ec660d872f55405d70e5c52d872136f0970c',
    decimals: 18,
    symbol: 'TKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3153.png',
  },
  {
    chainId: 1,
    name: 'Davinci Coin',
    address: '0xaad54c9f27b876d2538455dda69207279ff673a5',
    decimals: 18,
    symbol: 'DAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3154.png',
  },
  {
    chainId: 1,
    name: 'Quant',
    address: '0x4a220e6096b25eadb88358cb44068a3248254675',
    decimals: 18,
    symbol: 'QNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3155.png',
  },
  {
    chainId: 1,
    name: 'Airbloc',
    address: '0xf8b358b3397a8ea5464f8cc753645d42e14b79ea',
    decimals: 18,
    symbol: 'ABL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3156.png',
  },
  {
    chainId: 1,
    name: 'Smart Application Chain',
    address: '0xabc1280a0187a2020cc675437aed400185f86db6',
    decimals: 18,
    symbol: 'SAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3157.png',
  },
  {
    chainId: 1,
    name: 'YoloCash',
    address: '0x21d5678a62dfe63a47062469ebb2fac2817d8832',
    decimals: 18,
    symbol: 'YLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3162.png',
  },
  {
    chainId: 1,
    name: 'PumaPay',
    address: '0x846c66cf71c43f80403b51fe3906b3599d63336f',
    decimals: 18,
    symbol: 'PMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3164.png',
  },
  {
    chainId: 1,
    name: 'SGPay',
    address: '0x33c623a2baafeb8d15dfaf3ce44095efec83d72c',
    decimals: 18,
    symbol: 'SGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3167.png',
  },
  {
    chainId: 1,
    name: 'FarmaTrust',
    address: '0x2aec18c5500f21359ce1bea5dc1777344df4c0dc',
    decimals: 18,
    symbol: 'FTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3168.png',
  },
  {
    chainId: 1,
    name: 'Hybrid Block',
    address: '0x6059f55751603ead7dc6d280ad83a7b33d837c90',
    decimals: 18,
    symbol: 'HYB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3169.png',
  },
  {
    chainId: 1,
    name: 'Talao',
    address: '0x1d4ccc31dab6ea20f461d329a0562c1c58412515',
    decimals: 18,
    symbol: 'TALAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3170.png',
  },
  {
    chainId: 1,
    name: 'HeartBout',
    address: '0xe2492f8d2a2618d8709ca99b1d8d75713bd84089',
    decimals: 18,
    symbol: 'HB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3171.png',
  },
  {
    chainId: 1,
    name: 'Trendercoin',
    address: '0x80e82dd8707a68d9f26a3035c1bbf2b704549801',
    decimals: 3,
    symbol: 'TDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3173.png',
  },
  {
    chainId: 1,
    name: 'Fintab',
    address: '0xbD4B60a138b3fce3584EA01f50c0908c18f9677A',
    decimals: 8,
    symbol: 'FNTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3174.png',
  },
  {
    chainId: 1,
    name: 'Alttex',
    address: '0xb1ed41dc1fe9b723a31137afdd1201d17917fe91',
    decimals: 8,
    symbol: 'ALTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3176.png',
  },
  {
    chainId: 1,
    name: 'Seal Network',
    address: '0xd7b3669c7d3e38ab5a441383d41f25e003e02148',
    decimals: 18,
    symbol: 'SEAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3177.png',
  },
  {
    chainId: 1,
    name: 'Arbidex',
    address: '0x9a794dc1939f1d78fa48613b89b8f9d0a20da00e',
    decimals: 18,
    symbol: 'ABX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3179.png',
  },
  {
    chainId: 1,
    name: 'HitChain',
    address: '0x7995ab36bB307Afa6A683C24a25d90Dc1Ea83566',
    decimals: 6,
    symbol: 'HIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3182.png',
  },
  {
    chainId: 1,
    name: 'Mozo Token',
    address: '0x44bf22949f9cc84b61b9328a9d885d1b5c806b41',
    decimals: 2,
    symbol: 'MOZO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3187.png',
  },
  {
    chainId: 1,
    name: 'SuperEdge',
    address: '0x4CcC3759eB48fAF1c6cfadaD2619E7038db6b212',
    decimals: 8,
    symbol: 'ECT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3188.png',
  },
  {
    chainId: 1,
    name: 'Mainstream For The Underground',
    address: '0xbA745513ACEbcBb977497C569D4F7d340f2A936B',
    decimals: 18,
    symbol: 'MFTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3189.png',
  },
  {
    chainId: 1,
    name: 'Rentledger',
    address: '0xb92f51ce4045212eef8008c2f665da713035267b',
    decimals: 18,
    symbol: 'RTL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3191.png',
  },
  {
    chainId: 1,
    name: 'RRCoin',
    address: '0xB6259685685235c1eF4B8529e7105f00BD42b9f8',
    decimals: 2,
    symbol: 'RRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3193.png',
  },
  {
    chainId: 1,
    name: 'DPRating',
    address: '0xe8663a64a96169ff4d95b4299e7ae9a76b905b31',
    decimals: 8,
    symbol: 'RATING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3194.png',
  },
  {
    chainId: 1,
    name: 'KNOW',
    address: '0xb41f09a973a85c7f497c10b00a939de667b55a78',
    decimals: 10,
    symbol: 'KNOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3196.png',
  },
  {
    chainId: 1,
    name: 'KingXChain',
    address: '0x016396044709eb3edc69c44f4d5fa6996917e4e8',
    decimals: 18,
    symbol: 'KXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3198.png',
  },
  {
    chainId: 1,
    name: 'Mithril Ore',
    address: '0x501262281b2ba043e2fbf14904980689cddb0c78',
    decimals: 2,
    symbol: 'MORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3206.png',
  },
  {
    chainId: 1,
    name: 'Social Activity Token',
    address: '0xc56b13ebbcffa67cfb7979b900b736b3fb480d78',
    decimals: 8,
    symbol: 'SAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3207.png',
  },
  {
    chainId: 1,
    name: 'YUKI',
    address: '0x5ab793e36070f0fac928ea15826b0c1bc5365119',
    decimals: 8,
    symbol: 'YUKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3208.png',
  },
  {
    chainId: 1,
    name: '4NEW',
    address: '0x241ba672574a78a3a604cdd0a94429a73a84a324',
    decimals: 18,
    symbol: 'KWATT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3209.png',
  },
  {
    chainId: 1,
    name: 'Soniq',
    address: '0x1c62aca2b7605db3606eacda7bc67a1857ddb8ff',
    decimals: 18,
    symbol: 'SONIQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3214.png',
  },
  {
    chainId: 1,
    name: 'DeltaChain',
    address: '0xde1e0ae6101b46520cf66fdc0b1059c5cc3d106c',
    decimals: 8,
    symbol: 'DELTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3216.png',
  },
  {
    chainId: 1,
    name: 'Energi',
    address: '0x1416946162b1c2c871a73b07e932d2fb6c932069',
    decimals: 18,
    symbol: 'NRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3218.png',
  },
  {
    chainId: 1,
    name: 'FUTURAX',
    address: '0x41875c2332b0877cdfaa699b641402b7d4642c32',
    decimals: 8,
    symbol: 'FTXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3219.png',
  },
  {
    chainId: 1,
    name: 'DAV Coin',
    address: '0xd82df0abd3f51425eb15ef7580fda55727875f14',
    decimals: 18,
    symbol: 'DAV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3220.png',
  },
  {
    chainId: 1,
    name: 'ABLE',
    address: '0x865bfd8232778f00cae81315bf75ef1fe6e30cdd',
    decimals: 18,
    symbol: 'ABLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3221.png',
  },
  {
    chainId: 1,
    name: 'Bionic',
    address: '0xef51c9377feb29856e61625caf9390bd0b67ea18',
    decimals: 8,
    symbol: 'BNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3222.png',
  },
  {
    chainId: 1,
    name: 'DOWCOIN',
    address: '0x76974c7b79dc8a6a109fd71fd7ceb9e40eff5382',
    decimals: 18,
    symbol: 'DOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3223.png',
  },
  {
    chainId: 1,
    name: 'Qubitica',
    address: '0x1602af2C782cC03F9241992E243290Fccf73Bb13',
    decimals: 18,
    symbol: 'QBIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3224.png',
  },
  {
    chainId: 1,
    name: 'Traceability Chain',
    address: '0xca694eb79ef355ea0999485d211e68f39ae98493',
    decimals: 8,
    symbol: 'TAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3227.png',
  },
  {
    chainId: 1,
    name: 'Cryptosolartech',
    address: '0xbb49a51ee5a66ca3a8cbe529379ba44ba67e6771',
    decimals: 18,
    symbol: 'CST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3228.png',
  },
  {
    chainId: 1,
    name: 'Centaure',
    address: '0x5301eae39a4cba1cc2a74e861fded062ca3e3420',
    decimals: 18,
    symbol: 'CEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3229.png',
  },
  {
    chainId: 1,
    name: 'Quoxent',
    address: '0xefd720c94659f2ccb767809347245f917a145ed8',
    decimals: 18,
    symbol: 'QUO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3230.png',
  },
  {
    chainId: 1,
    name: 'Blockchain Quotations Index Token',
    address: '0x5eb87caa0105a63aa87a36c7bd2573bd13e84fae',
    decimals: 18,
    symbol: 'BQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3231.png',
  },
  {
    chainId: 1,
    name: 'Staker',
    address: '0xbae235823d7255d9d48635ced4735227244cd583',
    decimals: 18,
    symbol: 'STR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3232.png',
  },
  {
    chainId: 1,
    name: 'Xriba',
    address: '0x7025bab2ec90410de37f488d1298204cd4d6b29d',
    decimals: 18,
    symbol: 'XRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3234.png',
  },
  {
    chainId: 1,
    name: 'WinToken',
    address: '0xbfaa8cf522136c6fafc1d53fe4b85b4603c765b8',
    decimals: 18,
    symbol: 'WIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3236.png',
  },
  {
    chainId: 1,
    name: 'ABCC Token',
    address: '0xbf8fb919a8bbf28e590852aef2d284494ebc0657',
    decimals: 18,
    symbol: 'AT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3238.png',
  },
  {
    chainId: 1,
    name: 'EliteShipperToken',
    address: '0x06bead2ead661b51307b646f7419d5284330c135',
    decimals: 8,
    symbol: 'ESHIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3239.png',
  },
  {
    chainId: 1,
    name: 'FortKnoxster',
    address: '0x16484d73ac08d2355f466d448d2b79d2039f6ebb',
    decimals: 18,
    symbol: 'FKX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3241.png',
  },
  {
    chainId: 1,
    name: 'Moneytoken',
    address: '0x13119e34e140097a507b07a5564bde1bc375d9e6',
    decimals: 18,
    symbol: 'IMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3243.png',
  },
  {
    chainId: 1,
    name: 'Ubcoin Market',
    address: '0x2d3e7d4870a51b918919e7b851fe19983e4c38d5',
    decimals: 18,
    symbol: 'UBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3245.png',
  },
  {
    chainId: 1,
    name: 'Fire Lotto',
    address: '0x049399a6b048d52971f7d122ae21a1532722285f',
    decimals: 18,
    symbol: 'FLOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3247.png',
  },
  {
    chainId: 1,
    name: 'AiLink Token',
    address: '0x4289c043a12392f1027307fb58272d8ebd853912',
    decimals: 18,
    symbol: 'ALI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3248.png',
  },
  {
    chainId: 1,
    name: 'Usechain Token',
    address: '0xd9485499499d66b175cf5ed54c0a19f1a6bcb61a',
    decimals: 18,
    symbol: 'USE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3249.png',
  },
  {
    chainId: 1,
    name: 'ParkinGo',
    address: '0x613fa2a6e6daa70c659060e86ba1443d2679c9d7',
    decimals: 18,
    symbol: 'GOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3251.png',
  },
  {
    chainId: 1,
    name: 'ShineChain',
    address: '0x9064c91e51d7021A85AD96817e1432aBf6624470',
    decimals: 18,
    symbol: 'SHE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3252.png',
  },
  {
    chainId: 1,
    name: 'CyberMusic',
    address: '0x78c292d1445e6b9558bf42e8bc369271ded062ea',
    decimals: 8,
    symbol: 'CYMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3255.png',
  },
  {
    chainId: 1,
    name: 'Bitether',
    address: '0x499a6b77bc25c26bcf8265e2102b1b3dd1617024',
    decimals: 18,
    symbol: 'BTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3256.png',
  },
  {
    chainId: 1,
    name: 'GazeCoin',
    address: '0x4ac00f287f36a6aad655281fe1ca6798c9cb727b',
    decimals: 18,
    symbol: 'GZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3257.png',
  },
  {
    chainId: 1,
    name: 'BitUP Token',
    address: '0xb2e260f12406c401874ecc960893c0f74cd6afcd',
    decimals: 18,
    symbol: 'BUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3258.png',
  },
  {
    chainId: 1,
    name: 'YouLive Coin',
    address: '0xF84df2db2C87dd650641f8904aF71EbFC3ddE0Ea',
    decimals: 18,
    symbol: 'UC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3259.png',
  },
  {
    chainId: 1,
    name: 'EvenCoin',
    address: '0x68909e586eeac8f47315e84b4c9788dd54ef65bb',
    decimals: 18,
    symbol: 'EVN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3261.png',
  },
  {
    chainId: 1,
    name: 'CYCLEAN',
    address: '0x749f35ff65932e68267dd82f6cd85eea735d700e',
    decimals: 18,
    symbol: 'CCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3262.png',
  },
  {
    chainId: 1,
    name: 'Digital Insurance Token',
    address: '0xf14922001a2fb8541a433905437ae954419c2439',
    decimals: 8,
    symbol: 'DIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3264.png',
  },
  {
    chainId: 1,
    name: 'Havy',
    address: '0x7c2e5b7ec572199d3841f6a38f7d4868bd0798f1',
    decimals: 8,
    symbol: 'HAVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3265.png',
  },
  {
    chainId: 1,
    name: 'DarexTravel',
    address: '0xe689a257e070b13a08104aeb995c95fee1d87673',
    decimals: 18,
    symbol: 'DART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3268.png',
  },
  {
    chainId: 1,
    name: 'e-Chat',
    address: '0x1a2277c83930b7a64c3e3d5544eaa8c4f946b1b7',
    decimals: 18,
    symbol: 'ECHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3270.png',
  },
  {
    chainId: 1,
    name: 'Ether Kingdoms Token',
    address: '0x48ff53777f747cfb694101222a944de070c15d36',
    decimals: 7,
    symbol: 'IMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3271.png',
  },
  {
    chainId: 1,
    name: 'vSportCoin',
    address: '0x36b4b58de030e93775e151a78d796039a11a2548',
    decimals: 8,
    symbol: 'VSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3277.png',
  },
  {
    chainId: 1,
    name: 'Rotharium',
    address: '0x3fd8f39a962efda04956981c31ab89fab5fb8bc8',
    decimals: 18,
    symbol: 'RTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3279.png',
  },
  {
    chainId: 1,
    name: 'RealTract',
    address: '0xd7394087e1dbbe477fe4f1cf373b9ac9459565ff',
    decimals: 8,
    symbol: 'RET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3280.png',
  },
  {
    chainId: 1,
    name: 'Quanta Utility Token',
    address: '0x4234f63b1d202f6c016ca3b6a0d41d7d85f17716',
    decimals: 18,
    symbol: 'QNTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3281.png',
  },
  {
    chainId: 1,
    name: 'MEX',
    address: '0x2ba6b1e4424e19816382d15937739959f7da5fd8',
    decimals: 18,
    symbol: 'MEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3286.png',
  },
  {
    chainId: 1,
    name: 'Abulaba',
    address: '0xd938137e6d96c72e4a6085412ada2dad78ff89c4',
    decimals: 8,
    symbol: 'AAA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3287.png',
  },
  {
    chainId: 1,
    name: 'Digital Asset Exchange Token',
    address: '0x61725f3db4004afe014745b21dab1e1677cc328b',
    decimals: 18,
    symbol: 'DAXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3288.png',
  },
  {
    chainId: 1,
    name: 'CariNet',
    address: '0xc54083e77f913a4f99e1232ae80c318ff03c9d17',
    decimals: 18,
    symbol: 'CIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3292.png',
  },
  {
    chainId: 1,
    name: 'MINDOL',
    address: '0x5d64d850c8368008afb39224e92ad0dceff3cf38',
    decimals: 18,
    symbol: 'MIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3296.png',
  },
  {
    chainId: 1,
    name: 'Gene Source Code Chain',
    address: '0x884181554dfa9e578d36379919c05c25dc4a15bb',
    decimals: 18,
    symbol: 'GENE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3297.png',
  },
  {
    chainId: 1,
    name: 'XRT Token',
    address: '0x37d404a072056eda0cd10cb714d35552329f8500',
    decimals: 18,
    symbol: 'XRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3299.png',
  },
  {
    chainId: 1,
    name: 'BFFDoom',
    address: '0xcabf96a41a4d98ee91d4fb1004dc4b3b8548cb53',
    decimals: 8,
    symbol: 'BFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3300.png',
  },
  {
    chainId: 1,
    name: 'Invictus Hyperion Fund',
    address: '0xaf1250fa68d7decd34fd75de8742bc03b29bd58e',
    decimals: 18,
    symbol: 'IHF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3301.png',
  },
  {
    chainId: 1,
    name: 'UChain',
    address: '0xaaf37055188feee4869de63464937e683d61b2a1',
    decimals: 18,
    symbol: 'UCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3302.png',
  },
  {
    chainId: 1,
    name: 'Cruisebit',
    address: '0x2cf618c19041d9db330d8222b860a624021f30fb',
    decimals: 18,
    symbol: 'CRBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3303.png',
  },
  {
    chainId: 1,
    name: 'MobilinkToken',
    address: '0x97cb5cc1b2e10cc56dc16ab9179f06dfedbe41a2',
    decimals: 18,
    symbol: 'MOLK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3304.png',
  },
  {
    chainId: 1,
    name: 'Eden',
    address: '0x89020f0d5c5af4f3407eb5fe185416c457b0e93e',
    decimals: 18,
    symbol: 'EDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3305.png',
  },
  {
    chainId: 1,
    name: 'Gemini Dollar',
    address: '0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd',
    decimals: 18,
    symbol: 'GUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3306.png',
  },
  {
    chainId: 1,
    name: 'Spendcoin',
    address: '0xddd460bbd9f79847ea08681563e8a9696867210c',
    decimals: 18,
    symbol: 'SPND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3307.png',
  },
  {
    chainId: 1,
    name: 'ALLCOIN',
    address: '0xa958e706fc1934e26a3d0c32f471b54f733d0009',
    decimals: 18,
    symbol: 'ALC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3310.png',
  },
  {
    chainId: 1,
    name: 'Evimeria',
    address: '0x920db6c38cf5a2a12554e812d4b3ac2daa8eba4d',
    decimals: 18,
    symbol: 'EVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3312.png',
  },
  {
    chainId: 1,
    name: 'Playgroundz',
    address: '0x1c4b7d0e1885bd7667af3378e0c538f74e712006',
    decimals: 18,
    symbol: 'IOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3315.png',
  },
  {
    chainId: 1,
    name: 'smARTOFGIVING',
    address: '0x8578530205cecbe5db83f7f29ecfeec860c297c2',
    decimals: 18,
    symbol: 'AOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3316.png',
  },
  {
    chainId: 1,
    name: 'Cryptrust',
    address: '0x8606a8f28e1e2fd50b9074d65c01548b1f040b32',
    decimals: 8,
    symbol: 'CTRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3317.png',
  },
  {
    chainId: 1,
    name: 'Countinghouse',
    address: '0x799d214d7143b766cdd4979cd0280939288ba931',
    decimals: 2,
    symbol: 'CHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3318.png',
  },
  {
    chainId: 1,
    name: 'BunnyToken',
    address: '0x755eb14D2fefF2939EB3026f5CaD9D03775b9fF4',
    decimals: 18,
    symbol: 'BUNNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3321.png',
  },
  {
    chainId: 1,
    name: 'Robotina',
    address: '0x574f84108a98c575794f75483d801d1d5dc861a5',
    decimals: 18,
    symbol: 'ROX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3325.png',
  },
  {
    chainId: 1,
    name: 'Crypto Harbor Exchange',
    address: '0x632f62fcf63cb56380ffd27d63afcf5f1349f73f',
    decimals: 8,
    symbol: 'CHE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3326.png',
  },
  {
    chainId: 1,
    name: 'SIX',
    address: '0x61c6ebf443ad613c9648762585b3cfd3ba1f3fa8',
    decimals: 18,
    symbol: 'SIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3327.png',
  },
  {
    chainId: 1,
    name: 'CMITCOIN',
    address: '0xe11609b9a51caf7d32a55896386ac52ed90e66f1',
    decimals: 8,
    symbol: 'CMIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3328.png',
  },
  {
    chainId: 1,
    name: 'Fantasy Sports',
    address: '0xcec38306558a31cdbb2a9d6285947c5b44a24f3e',
    decimals: 18,
    symbol: 'DFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3329.png',
  },
  {
    chainId: 1,
    name: 'Pax Dollar',
    address: '0x8e870d67f660d95d5be530380d0ec0bd388289e1',
    decimals: 18,
    symbol: 'USDP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3330.png',
  },
  {
    chainId: 1,
    name: 'CrowdWiz',
    address: '0x2f9b6779c37df5707249eeb3734bbfc94763fbe2',
    decimals: 18,
    symbol: 'WIZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3331.png',
  },
  {
    chainId: 1,
    name: 'Sola Token',
    address: '0x1f54638b7737193ffd86c19ec51907a7c41755d8',
    decimals: 6,
    symbol: 'SOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3333.png',
  },
  {
    chainId: 1,
    name: 'Shard',
    address: '0xbebdab6da046bc49ffbb61fbd7b33157eb270d05',
    decimals: 18,
    symbol: 'SHARD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3335.png',
  },
  {
    chainId: 1,
    name: 'IQeon',
    address: '0x0db8d8b76bc361bacbb72e2c491e06085a97ab31',
    decimals: 18,
    symbol: 'IQN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3336.png',
  },
  {
    chainId: 1,
    name: 'QChi',
    address: '0x687bfc3e73f6af55f0ccca8450114d107e781a0e',
    decimals: 18,
    symbol: 'QCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3337.png',
  },
  {
    chainId: 1,
    name: 'Puregold Token',
    address: '0x9b3e946e1a8ea0112b147af4e6e020752f2446bc',
    decimals: 18,
    symbol: 'PGTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3339.png',
  },
  {
    chainId: 1,
    name: 'Mallcoin',
    address: '0xc72ed4445b3fe9f0863106e344e241530d338906',
    decimals: 18,
    symbol: 'MLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3340.png',
  },
  {
    chainId: 1,
    name: 'Archetypal Network',
    address: '0x7b2df125567815ac9b57da04b620f50bc93b320c',
    decimals: 8,
    symbol: 'ACTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3342.png',
  },
  {
    chainId: 1,
    name: 'Ecoreal Estate',
    address: '0x7ECbb21346C501Fd07eb165E406120fA32381C16',
    decimals: 18,
    symbol: 'ECOREAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3344.png',
  },
  {
    chainId: 1,
    name: 'Vestoria',
    address: '0x9363e6eadf5e307b96f26dfd94f355b95a0e2498',
    decimals: 8,
    symbol: 'VSTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3346.png',
  },
  {
    chainId: 1,
    name: 'CARAT',
    address: '0x19ea630bcbc1a511a16e65b6ecd447c92e1c087c',
    decimals: 18,
    symbol: 'CARAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3347.png',
  },
  {
    chainId: 1,
    name: 'GoldenPyrex',
    address: '0x3e3CdA3218212503883C79F6D2FeEF29E6Bbb87d',
    decimals: 18,
    symbol: 'GPYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3349.png',
  },
  {
    chainId: 1,
    name: 'ZB Token',
    address: '0xbd0793332e9fb844a52a205a233ef27a5b34b927',
    decimals: 18,
    symbol: 'ZB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3351.png',
  },
  {
    chainId: 1,
    name: 'MidasProtocol',
    address: '0x23ccc43365d9dd3882eab88f43d515208f832430',
    decimals: 18,
    symbol: 'MAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3352.png',
  },
  {
    chainId: 1,
    name: 'WELL',
    address: '0x684e2dcb12bb755237e07242529c82f78a84ea61',
    decimals: 18,
    symbol: 'WELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3353.png',
  },
  {
    chainId: 1,
    name: 'The Midas Touch Gold',
    address: '0x10086399dd8c1e3de736724af52587a2044c9fa2',
    decimals: 18,
    symbol: 'TMTG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3356.png',
  },
  {
    chainId: 1,
    name: 'Digital Asset Guarantee Token',
    address: '0x56D1aE30c97288DA4B58BC39F026091778e4E316',
    decimals: 18,
    symbol: 'DAGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3357.png',
  },
  {
    chainId: 1,
    name: 'Helper Search Token',
    address: '0x567300e14f8d67e1f6720a95291dce2511a86723',
    decimals: 18,
    symbol: 'HSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3358.png',
  },
  {
    chainId: 1,
    name: 'WITChain',
    address: '0xe13ef257cf4d5df928ca11d230427c037666d466',
    decimals: 6,
    symbol: 'WIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3359.png',
  },
  {
    chainId: 1,
    name: 'Eristica',
    address: '0x92A5B04D0ED5D94D7a193d1d334D3D16996f4E13',
    decimals: 18,
    symbol: 'ERT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3360.png',
  },
  {
    chainId: 1,
    name: 'VeriSafe',
    address: '0xba3a79d758f19efe588247388754b8e4d6edda81',
    decimals: 18,
    symbol: 'VSF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3365.png',
  },
  {
    chainId: 1,
    name: 'CRD Network',
    address: '0xcaaa93712bdac37f736c323c93d4d5fdefcc31cc',
    decimals: 18,
    symbol: 'CRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3367.png',
  },
  {
    chainId: 1,
    name: 'Kuende',
    address: '0xdf1338fbafe7af1789151627b886781ba556ef9a',
    decimals: 18,
    symbol: 'KUE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3369.png',
  },
  {
    chainId: 1,
    name: 'Nerves',
    address: '0xee5dfb5ddd54ea2fb93b796a8a1b83c3fe38e0e6',
    decimals: 18,
    symbol: 'NER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3370.png',
  },
  {
    chainId: 1,
    name: 'Bethereum',
    address: '0x14c926f2290044b647e1bf2072e67b495eff1905',
    decimals: 18,
    symbol: 'BETHER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3373.png',
  },
  {
    chainId: 1,
    name: 'ImmVRse Token',
    address: '0x7878424e994d8a2b8e329d31096922b7ceabe660',
    decimals: 18,
    symbol: 'IMVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3375.png',
  },
  {
    chainId: 1,
    name: 'Darico Ecosystem Coin',
    address: '0x89c6c856a6db3e46107163d0cda7a7ff211bd655',
    decimals: 18,
    symbol: 'DEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3376.png',
  },
  {
    chainId: 1,
    name: 'Wisepass',
    address: '0x77761e63c05aee6648fdaeaa9b94248351af9bcd',
    decimals: 18,
    symbol: 'PASS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3379.png',
  },
  {
    chainId: 1,
    name: 'Knekted',
    address: '0x7CC62d8E80Be9bEa3947F3443aD136f50f75b505',
    decimals: 18,
    symbol: 'KNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3383.png',
  },
  {
    chainId: 1,
    name: 'FREEdom Coin',
    address: '0x2f141ce366a2462f02cea3d12cf93e4dca49e4fd',
    decimals: 18,
    symbol: 'FREE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3388.png',
  },
  {
    chainId: 1,
    name: 'Tolar',
    address: '0xd07d9fe2d2cc067015e2b4917d24933804f42cfa',
    decimals: 18,
    symbol: 'TOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3389.png',
  },
  {
    chainId: 1,
    name: 'Bostoken',
    address: '0x3c0cac8290e2a6241814f812259278bea9050838',
    decimals: 18,
    symbol: 'BOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3392.png',
  },
  {
    chainId: 1,
    name: 'MASTERNET',
    address: '0xa0d440c6da37892dc06ee7930b2eede0634fd681',
    decimals: 8,
    symbol: 'MASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3393.png',
  },
  {
    chainId: 1,
    name: 'Neural Protocol',
    address: '0x3918c42f14f2eb1168365f911f63e540e5a306b5',
    decimals: 8,
    symbol: 'NRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3397.png',
  },
  {
    chainId: 1,
    name: 'Ifoods Chain',
    address: '0x81e74a3ea4bab2277aa3b941e9d9f37b08ac5374',
    decimals: 18,
    symbol: 'IFOOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3402.png',
  },
  {
    chainId: 1,
    name: 'Wixlar',
    address: '0x7ba19b7f7d106a9a1e0985397b94f38eee0b555e',
    decimals: 2,
    symbol: 'WIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3404.png',
  },
  {
    chainId: 1,
    name: 'Block-Chain.com',
    address: '0x2ecb13a8c458c379c4d9a7259e202de03c8f3d19',
    decimals: 18,
    symbol: 'BC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3406.png',
  },
  {
    chainId: 1,
    name: 'USDC',
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    decimals: 6,
    symbol: 'USDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
  },
  {
    chainId: 1,
    name: 'Etheera',
    address: '0x9195e00402abe385f2d00a32af40b271f2e87925',
    decimals: 18,
    symbol: 'ETA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3409.png',
  },
  {
    chainId: 1,
    name: 'Welltrado',
    address: '0x9a0587eae7ef64b2b38a10442a44cfa43edd7d2a',
    decimals: 18,
    symbol: 'WTL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3411.png',
  },
  {
    chainId: 1,
    name: 'Simmitri',
    address: '0x7528e3040376edd5db8263db2f5bd1bed91467fb',
    decimals: 18,
    symbol: 'SIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3412.png',
  },
  {
    chainId: 1,
    name: 'nDEX',
    address: '0x1966d718A565566e8E202792658D7b5Ff4ECe469',
    decimals: 18,
    symbol: 'NDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3413.png',
  },
  {
    chainId: 1,
    name: 'ZeusNetwork',
    address: '0xe7e4279b80d319ede2889855135a22021baf0907',
    decimals: 18,
    symbol: 'ZEUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3414.png',
  },
  {
    chainId: 1,
    name: 'Buggyra Coin Zero',
    address: '0xd45247c07379d94904e0a87b4481f0a1ddfa0c64',
    decimals: 18,
    symbol: 'BCZERO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3415.png',
  },
  {
    chainId: 1,
    name: 'Future1coin',
    address: '0xb0a0a070640b450eb136dc377208469ee4f49fbc',
    decimals: 18,
    symbol: 'F1C',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3417.png',
  },
  {
    chainId: 1,
    name: 'Metadium',
    address: '0xde2f7766c8bf14ca67193128535e5c7454f8387c',
    decimals: 18,
    symbol: 'META',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3418.png',
  },
  {
    chainId: 1,
    name: 'SHPING',
    address: '0x7c84e62859d0715eb77d1b1c4154ecd6abb21bec',
    decimals: 18,
    symbol: 'SHPING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3422.png',
  },
  {
    chainId: 1,
    name: 'Sharpay',
    address: '0x96b0bf939d9460095c15251f71fda11e41dcbddb',
    decimals: 18,
    symbol: 'S',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3423.png',
  },
  {
    chainId: 1,
    name: 'Incodium',
    address: '0x4d8bfe7ea0f46486fd40fc4df60cf39f7568bee8',
    decimals: 18,
    symbol: 'INCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3426.png',
  },
  {
    chainId: 1,
    name: 'Agrolot',
    address: '0x72c9fb7ed19d3ce51cea5c56b3e023cd918baadf',
    decimals: 18,
    symbol: 'AGLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3427.png',
  },
  {
    chainId: 1,
    name: 'Cyber Movie Chain',
    address: '0x7abc60b3290f68c85f495fd2e0c3bd278837a313',
    decimals: 8,
    symbol: 'CMCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3429.png',
  },
  {
    chainId: 1,
    name: 'SURETY',
    address: '0x95382ac82e886a367bac9e1e23beabe569bcfed8',
    decimals: 6,
    symbol: 'SURE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3430.png',
  },
  {
    chainId: 1,
    name: 'Iconic Token',
    address: '0xb3e2cb7cccfe139f8ff84013823bf22da6b6390a',
    decimals: 18,
    symbol: 'ICNQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3431.png',
  },
  {
    chainId: 1,
    name: 'EUNOMIA',
    address: '0x0f612a09ead55bb81b6534e80ed5a21bf0a27b16',
    decimals: 8,
    symbol: 'ENTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3433.png',
  },
  {
    chainId: 1,
    name: 'Snetwork',
    address: '0xff19138b039d938db46bdda0067dc4ba132ec71c',
    decimals: 8,
    symbol: 'SNET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3435.png',
  },
  {
    chainId: 1,
    name: 'ABBC Coin',
    address: '0xe83ce6bfb580583bd6a62b4be7b34fc25f02910d',
    decimals: 18,
    symbol: 'ABBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3437.png',
  },
  {
    chainId: 1,
    name: 'Oxycoin',
    address: '0x869b1f57380ae501d387b19262efd3c0eb7501b0',
    decimals: 18,
    symbol: 'OXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3438.png',
  },
  {
    chainId: 1,
    name: 'Divi',
    address: '0x246908BfF0b1ba6ECaDCF57fb94F6AE2FcD43a77',
    decimals: 8,
    symbol: 'DIVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3441.png',
  },
  {
    chainId: 1,
    name: 'Zenswap Network Token',
    address: '0xe95990825aab1a7f0af4cc648f76a3bcc99f25b2',
    decimals: 18,
    symbol: 'ZNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3446.png',
  },
  {
    chainId: 1,
    name: 'Commerce Data Connection',
    address: '0x87026f792d09960232ca406e80c89bd35bafe566',
    decimals: 18,
    symbol: 'CDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3448.png',
  },
  {
    chainId: 1,
    name: 'Etho Protocol',
    address: '0x0b5326Da634f9270FB84481DD6F94d3dC2cA7096',
    decimals: 18,
    symbol: 'ETHO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3452.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Asset Trading Platform',
    address: '0x813b428af3920226e059b68a62e4c04933d4ea7a',
    decimals: 8,
    symbol: 'DATP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3454.png',
  },
  {
    chainId: 1,
    name: 'ZBG Token',
    address: '0xfe39e6a32acd2af7955cb3d406ba2b55c901f247',
    decimals: 18,
    symbol: 'ZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3458.png',
  },
  {
    chainId: 1,
    name: 'Bitcoinus',
    address: '0xc38f1fb49acdf2f1213caf3319f6eb3ea2cb7527',
    decimals: 18,
    symbol: 'BITS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3460.png',
  },
  {
    chainId: 1,
    name: 'IXTUS Edutainment',
    address: '0x7a07e1a0c2514d51132183ecfea2a880ec3b7648',
    decimals: 18,
    symbol: 'IXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3462.png',
  },
  {
    chainId: 1,
    name: 'Alt.Estate token',
    address: '0x419b8ed155180a8c9c64145e76dad49c0a4efb97',
    decimals: 18,
    symbol: 'ALT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3465.png',
  },
  {
    chainId: 1,
    name: 'TrueDeck',
    address: '0x5b11aacb6bddb9ffab908fdce739bf4aed554327',
    decimals: 18,
    symbol: 'TDP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3469.png',
  },
  {
    chainId: 1,
    name: 'Dragon Token',
    address: '0x1da015ea4ad2d3e5586e54b9fb0682ca3ca8a17a',
    decimals: 8,
    symbol: 'DT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3470.png',
  },
  {
    chainId: 1,
    name: 'RoBET',
    address: '0x2344871f523cbb28a4f60045531184cf1f03ad24',
    decimals: 18,
    symbol: 'ROBET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3471.png',
  },
  {
    chainId: 1,
    name: 'JSECOIN',
    address: '0x2d184014b5658c453443aa87c8e9c4d57285620b',
    decimals: 18,
    symbol: 'JSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3472.png',
  },
  {
    chainId: 1,
    name: 'OBXcoin',
    address: '0xad29d26b081204ba2d1da9e86101dda69ec835d5',
    decimals: 18,
    symbol: 'OBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3473.png',
  },
  {
    chainId: 1,
    name: 'YGGDRASH',
    address: '0xca2796f9f61dc7b238aab043971e49c6164df375',
    decimals: 18,
    symbol: 'YEED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3474.png',
  },
  {
    chainId: 1,
    name: 'BOX Token',
    address: '0xe1A178B681BD05964d3e3Ed33AE731577d9d96dD',
    decimals: 18,
    symbol: 'BOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3475.png',
  },
  {
    chainId: 1,
    name: 'Italian Lira',
    address: '0x122A86b5DFF2D085AfB49600b4cd7375D0d94A5f',
    decimals: 8,
    symbol: 'ITL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3476.png',
  },
  {
    chainId: 1,
    name: 'MODEL-X-coin',
    address: '0x3c6Da7763cAA0e4b684BbC733f04a8EC08Af3762',
    decimals: 8,
    symbol: 'MODX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3479.png',
  },
  {
    chainId: 1,
    name: 'Waletoken',
    address: '0x0ea984e789302b7b612147e4e4144e64f21425eb',
    decimals: 8,
    symbol: 'WTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3484.png',
  },
  {
    chainId: 1,
    name: 'Game Stars',
    address: '0x67a9099f0008c35c61c00042cd9fb03684451097',
    decimals: 18,
    symbol: 'GST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3485.png',
  },
  {
    chainId: 1,
    name: 'Escroco Emerald',
    address: '0x49614661737efbfc6a102efaeefdc8e197f7cc0e',
    decimals: 18,
    symbol: 'ESCE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3489.png',
  },
  {
    chainId: 1,
    name: 'EZOOW',
    address: '0x78a2a1029e3168b49d3a276c787050ff5106dcf2',
    decimals: 18,
    symbol: 'EZW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3491.png',
  },
  {
    chainId: 1,
    name: 'Vetri',
    address: '0x922ac473a3cc241fd3a0049ed14536452d58d73c',
    decimals: 18,
    symbol: 'VLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3492.png',
  },
  {
    chainId: 1,
    name: 'SAKECOIN',
    address: '0x705051bbfd9f287869a412cba8bc7d112de48e69',
    decimals: 8,
    symbol: 'SAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3493.png',
  },
  {
    chainId: 1,
    name: 'ModulTrade',
    address: '0x1e49ff77c355a3e38d6651ce8404af0e48c5395f',
    decimals: 18,
    symbol: 'MTRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3495.png',
  },
  {
    chainId: 1,
    name: 'CapdaxToken',
    address: '0xca00bc15f67ebea4b20dfaaa847cace113cc5501',
    decimals: 18,
    symbol: 'XCD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3498.png',
  },
  {
    chainId: 1,
    name: 'Liquidity Network',
    address: '0xD29F0b5b3F50b07Fe9a9511F7d86F4f4bAc3f8c4',
    decimals: 18,
    symbol: 'LQD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3499.png',
  },
  {
    chainId: 1,
    name: 'CryptoSoul',
    address: '0xbb1f24c0c1554b9990222f036b0aad6ee4caec29',
    decimals: 18,
    symbol: 'SOUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3501.png',
  },
  {
    chainId: 1,
    name: 'Molecule',
    address: '0x32b7a3018e4b832dea848786348164667ec030f3',
    decimals: 18,
    symbol: 'MOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3502.png',
  },
  {
    chainId: 1,
    name: 'Typerium',
    address: '0xeaf61fc150cd5c3bea75744e830d916e60ea5a9f',
    decimals: 4,
    symbol: 'TYPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3505.png',
  },
  {
    chainId: 1,
    name: 'IONChain',
    address: '0xbc647aad10114b89564c0a7aabe542bd0cf2c5af',
    decimals: 18,
    symbol: 'IONC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3506.png',
  },
  {
    chainId: 1,
    name: 'Reakoin',
    address: '0xa5b2dbba9a3c04ec4f56cbe16520debecbf35545',
    decimals: 18,
    symbol: 'REAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3508.png',
  },
  {
    chainId: 1,
    name: 'Provoco Token',
    address: '0xb5ca46cf1da09248126682a7bd72401fd7a6b151',
    decimals: 18,
    symbol: 'VOCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3509.png',
  },
  {
    chainId: 1,
    name: 'Bitibu Coin',
    address: '0xc429e7b63dc30b51f5a7e4be23fd5eb4baf8a1c3',
    decimals: 18,
    symbol: 'BTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3511.png',
  },
  {
    chainId: 1,
    name: 'Alpha Coin',
    address: '0x15bda08c3afbf5955d6e9b235fd55a1fd0dbc829',
    decimals: 6,
    symbol: 'APC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3512.png',
  },
  {
    chainId: 1,
    name: 'Fantom',
    address: '0x4e15361fd6b4bb609fa63c81a2be19d873717870',
    decimals: 18,
    symbol: 'FTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3513.png',
  },
  {
    chainId: 1,
    name: 'DEX',
    address: '0x497bAEF294c11a5f0f5Bea3f2AdB3073DB448B56',
    decimals: 18,
    symbol: 'DEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3515.png',
  },
  {
    chainId: 1,
    name: 'SONDER',
    address: '0x47d1a59cbdd19aee060c859c0009277e245328ae',
    decimals: 18,
    symbol: 'SNR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3517.png',
  },
  {
    chainId: 1,
    name: 'Breezecoin',
    address: '0x77c07555af5ffdc946fb47ce15ea68620e4e7170',
    decimals: 18,
    symbol: 'BRZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3519.png',
  },
  {
    chainId: 1,
    name: 'VisionX',
    address: '0x1563D521ba309e2Ad9f4aFfD6f4dE9759E8d4F21',
    decimals: 18,
    symbol: 'VNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3520.png',
  },
  {
    chainId: 1,
    name: 'MESSE TOKEN',
    address: '0x5874548c51822da642661b235e101d6d636b6feb',
    decimals: 18,
    symbol: 'MESSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3522.png',
  },
  {
    chainId: 1,
    name: 'APOT',
    address: '0x16c1e5baf21b9fa4bc9f2c374e4dc19fab5ac5dc',
    decimals: 18,
    symbol: 'APOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3579.png',
  },
  {
    chainId: 1,
    name: 'Crystal Token',
    address: '0x26CB3641aaA43911f1D4cB2ce544eb652AAc7c47',
    decimals: 18,
    symbol: 'CYL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3580.png',
  },
  {
    chainId: 1,
    name: 'Kleros',
    address: '0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d',
    decimals: 18,
    symbol: 'PNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3581.png',
  },
  {
    chainId: 1,
    name: 'MediBit',
    address: '0x737fa0372c8d001904ae6acaf0552d4015f9c947',
    decimals: 18,
    symbol: 'MEDIBIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3582.png',
  },
  {
    chainId: 1,
    name: 'Posscoin',
    address: '0x6b193e107a773967bd821bcf8218f3548cfa2503',
    decimals: 18,
    symbol: 'POSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3583.png',
  },
  {
    chainId: 1,
    name: 'TV-TWO',
    address: '0xa838be6e4b760e6061d4732d6b9f11bf578f9a76',
    decimals: 18,
    symbol: 'TTV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3584.png',
  },
  {
    chainId: 1,
    name: 'WeShow Token',
    address: '0x36d10c6800d569bb8c4fe284a05ffe3b752f972c',
    decimals: 18,
    symbol: 'WET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3585.png',
  },
  {
    chainId: 1,
    name: 'Bgogo Token',
    address: '0xea54c81fe0f72de8e86b6dc78a9271aa3925e3b5',
    decimals: 18,
    symbol: 'BGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3587.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Meta',
    address: '0x37F04733C7E1C762f0Ed86533c9052bE5822c1fd',
    decimals: 18,
    symbol: 'ETHM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3589.png',
  },
  {
    chainId: 1,
    name: 'Coin Lion',
    address: '0x2167fb82309cf76513e83b25123f8b0559d6b48f',
    decimals: 18,
    symbol: 'LION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3592.png',
  },
  {
    chainId: 1,
    name: 'PalletOne',
    address: '0xfe76be9cec465ed3219a9972c21655d57d21aec6',
    decimals: 18,
    symbol: 'PTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3595.png',
  },
  {
    chainId: 1,
    name: 'InterValue',
    address: '0xdac4ae188ace3c8985765edc6c9b4739d4845ddc',
    decimals: 18,
    symbol: 'INVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3597.png',
  },
  {
    chainId: 1,
    name: 'OSA Token',
    address: '0xc6abf3c09341741ac6041b0b08195701bdfd460c',
    decimals: 18,
    symbol: 'OSA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3598.png',
  },
  {
    chainId: 1,
    name: 'Hippocrat',
    address: '0xfE39C384D702914127a005523f9915ADDB9bd59b',
    decimals: 18,
    symbol: 'HPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3600.png',
  },
  {
    chainId: 1,
    name: 'Menlo One',
    address: '0x4d807509aece24c0fa5a102b6a3b059ec6e14392',
    decimals: 18,
    symbol: 'ONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3603.png',
  },
  {
    chainId: 1,
    name: 'VestChain',
    address: '0x37f04d2c3ae075fad5483bb918491f656b12bdb6',
    decimals: 8,
    symbol: 'VEST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3607.png',
  },
  {
    chainId: 1,
    name: 'Hyprr',
    address: '0x12f649a9e821f90bb143089a6e56846945892ffb',
    decimals: 18,
    symbol: 'UDOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3608.png',
  },
  {
    chainId: 1,
    name: 'CWV Chain',
    address: '0xed494c9e2f8e34e53bdd0ea9b4d80305cb15c5c2',
    decimals: 18,
    symbol: 'CWV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3609.png',
  },
  {
    chainId: 1,
    name: 'Micromines',
    address: '0xbe6c8f2810ef39420d2dc2901b8414c8c45fee6d',
    decimals: 18,
    symbol: 'MICRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3610.png',
  },
  {
    chainId: 1,
    name: 'Business Credit Alliance Chain',
    address: '0x1abdb309aa592f00a101c545168bfdf9a6ec61ce',
    decimals: 18,
    symbol: 'BCAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3612.png',
  },
  {
    chainId: 1,
    name: 'HyperQuant',
    address: '0x3e1d5a855ad9d948373ae68e4fe1f094612b1322',
    decimals: 18,
    symbol: 'HQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3615.png',
  },
  {
    chainId: 1,
    name: 'EvidenZ',
    address: '0xacfa209fb73bf3dd5bbfb1101b9bc999c49062a5',
    decimals: 18,
    symbol: 'BCDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3616.png',
  },
  {
    chainId: 1,
    name: 'GATE',
    address: '0x9d7630adf7ab0b0cb00af747db76864df0ec82e4',
    decimals: 18,
    symbol: 'GATE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3618.png',
  },
  {
    chainId: 1,
    name: 'BEAT',
    address: '0x2fb12bccf6f5dd338b76be784a93ade072425690',
    decimals: 18,
    symbol: 'BEAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3619.png',
  },
  {
    chainId: 1,
    name: 'Online',
    address: '0xa3efef1a1e3d1ad72b9d0f4253e7c9c084c2c08b',
    decimals: 18,
    symbol: 'OIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3623.png',
  },
  {
    chainId: 1,
    name: 'QuadrantProtocol',
    address: '0xc28e931814725bbeb9e670676fabbcb694fe7df2',
    decimals: 18,
    symbol: 'EQUAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3625.png',
  },
  {
    chainId: 1,
    name: 'Moonchain',
    address: '0x5ca381bbfb58f0092df149bd3d243b08b9a8386e',
    decimals: 18,
    symbol: 'MXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3628.png',
  },
  {
    chainId: 1,
    name: 'Hercules',
    address: '0x6251583e7d997df3604bc73b9779196e94a090ce',
    decimals: 18,
    symbol: 'HERC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3630.png',
  },
  {
    chainId: 1,
    name: 'FOAM',
    address: '0x4946fcea7c692606e8908002e55a582af44ac121',
    decimals: 18,
    symbol: 'FOAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3631.png',
  },
  {
    chainId: 1,
    name: 'Opacity',
    address: '0xDb05EA0877A2622883941b939f0bb11d1ac7c400',
    decimals: 18,
    symbol: 'OPCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3632.png',
  },
  {
    chainId: 1,
    name: 'Kambria',
    address: '0x14da230d6726C50F759Bc1838717F8CE6373509C',
    decimals: 18,
    symbol: 'KAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3634.png',
  },
  {
    chainId: 1,
    name: 'Cronos',
    address: '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
    decimals: 18,
    symbol: 'CRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png',
  },
  {
    chainId: 1,
    name: 'Link Machine Learning',
    address: '0x25b6325f5bb1c1e03cfbc3e53f470e1f1ca022e3',
    decimals: 18,
    symbol: 'LML',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3636.png',
  },
  {
    chainId: 1,
    name: 'Aergo',
    address: '0x91af0fbb28aba7e31403cb457106ce79397fd4e6',
    decimals: 18,
    symbol: 'AERGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3637.png',
  },
  {
    chainId: 1,
    name: 'Skychain',
    address: '0x70c621f949b6556c4545707a2d5d73a776b98359',
    decimals: 6,
    symbol: 'SKCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3638.png',
  },
  {
    chainId: 1,
    name: 'PlayGame',
    address: '0x47e67ba66b0699500f18a53f94e2b9db3d47437e',
    decimals: 18,
    symbol: 'PXG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3639.png',
  },
  {
    chainId: 1,
    name: 'Livepeer',
    address: '0x58b6a8a3302369daec383334672404ee733ab239',
    decimals: 18,
    symbol: 'LPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3640.png',
  },
  {
    chainId: 1,
    name: 'Trade Token X',
    address: '0xd947b0ceab2a8885866b9a04a06ae99de852a3d4',
    decimals: 18,
    symbol: 'TIOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3642.png',
  },
  {
    chainId: 1,
    name: 'TravelNote',
    address: '0x5635ddeabf9cdda686995fe90beb5411831563fc',
    decimals: 8,
    symbol: 'TVNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3644.png',
  },
  {
    chainId: 1,
    name: 'Shivers',
    address: '0xd5f788ca0de8f17cbde1d1e35aa8f005a87fa00b',
    decimals: 8,
    symbol: 'SHVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3645.png',
  },
  {
    chainId: 1,
    name: 'Herbalist Token',
    address: '0x04a020325024f130988782bd5276e53595e8d16e',
    decimals: 8,
    symbol: 'HERB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3646.png',
  },
  {
    chainId: 1,
    name: 'CoinUs',
    address: '0x722f2f3eac7e9597c73a593f7cf3de33fbfc3308',
    decimals: 18,
    symbol: 'CNUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3648.png',
  },
  {
    chainId: 1,
    name: 'Plus-Coin',
    address: '0x97fb6fc2ad532033af97043b563131c5204f8a35',
    decimals: 18,
    symbol: 'NPLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3649.png',
  },
  {
    chainId: 1,
    name: 'COVA',
    address: '0xb37a769b37224449d92aac57de379e1267cd3b00',
    decimals: 18,
    symbol: 'COVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3650.png',
  },
  {
    chainId: 1,
    name: 'NEXT',
    address: '0x377d552914e7a104bc22b4f3b6268ddc69615be7',
    decimals: 18,
    symbol: 'NEXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3651.png',
  },
  {
    chainId: 1,
    name: 'DataOnBlock',
    address: '0x526ccc90191a9472299323816bd2c784c0a1bcde',
    decimals: 18,
    symbol: 'DBLK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3654.png',
  },
  {
    chainId: 1,
    name: 'Lambda',
    address: '0x8971f9fd7196e5cee2c1032b50f656855af7dd26',
    decimals: 18,
    symbol: 'LAMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3657.png',
  },
  {
    chainId: 1,
    name: 'Fountain',
    address: '0x56325d180ec3878a9028afc7b0edcee7486cc9df',
    decimals: 18,
    symbol: 'FTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3658.png',
  },
  {
    chainId: 1,
    name: 'QUINADS',
    address: '0x86e44543164d9b97b14ef7f6f3ab7ba670cab346',
    decimals: 18,
    symbol: 'QUIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3659.png',
  },
  {
    chainId: 1,
    name: 'Stronghold Token',
    address: '0xee7527841a932d2912224e20a405e1a1ff747084',
    decimals: 18,
    symbol: 'SHX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3661.png',
  },
  {
    chainId: 1,
    name: 'HedgeTrade',
    address: '0xF1290473E210b2108A85237fbCd7b6eb42Cc654F',
    decimals: 18,
    symbol: 'HEDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3662.png',
  },
  {
    chainId: 1,
    name: 'AgaveCoin',
    address: '0x8b79656FC38a04044E495e22fAD747126ca305C4',
    decimals: 18,
    symbol: 'AGVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3664.png',
  },
  {
    chainId: 1,
    name: 'Ultiledger',
    address: '0xe884cc2795b9c45beeac0607da9539fd571ccf85',
    decimals: 18,
    symbol: 'ULT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3666.png',
  },
  {
    chainId: 1,
    name: 'Atomic Wallet Coin',
    address: '0xad22f63404f7305e4713ccbd4f296f34770513f4',
    decimals: 18,
    symbol: 'AWC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3667.png',
  },
  {
    chainId: 1,
    name: 'Winco',
    address: '0xd44bb6663936cab1310584a277f7daa6943d4904',
    decimals: 8,
    symbol: 'WCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3669.png',
  },
  {
    chainId: 1,
    name: 'ROMToken',
    address: '0xacACa5b8805636608e14C64b0bFFfC2Deb2C6cEc',
    decimals: 18,
    symbol: 'ROM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3670.png',
  },
  {
    chainId: 1,
    name: 'Almeela',
    address: '0x8de67d55c58540807601dbf1259537bc2dffc84d',
    decimals: 18,
    symbol: 'KZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3671.png',
  },
  {
    chainId: 1,
    name: 'ASD',
    address: '0xff742d05420b6aca4481f635ad8341f81a6300c2',
    decimals: 18,
    symbol: 'ASD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3673.png',
  },
  {
    chainId: 1,
    name: 'Globatalent',
    address: '0xd8bd3958725f216eb236e9dc65b169de48101c6a',
    decimals: 8,
    symbol: 'GBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3674.png',
  },
  {
    chainId: 1,
    name: 'Crowdvilla Ownership',
    address: '0x69f64d814aa278825997e71738120392993973a4',
    decimals: 8,
    symbol: 'CRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3675.png',
  },
  {
    chainId: 1,
    name: 'Crowdvilla Point',
    address: '0x26c0e6f69b18125f68ac55f439b1e10c2a2e5c03',
    decimals: 8,
    symbol: 'CROWD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3676.png',
  },
  {
    chainId: 1,
    name: 'ICOBay',
    address: '0x791425156956e39f2ab8ab06b79de189c18e95e5',
    decimals: 18,
    symbol: 'IBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3678.png',
  },
  {
    chainId: 1,
    name: 'XRP Classic',
    address: '0xd4ca5c2aff1eefb0bea9e9eab16f88db2990c183',
    decimals: 8,
    symbol: 'XRPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3680.png',
  },
  {
    chainId: 1,
    name: 'AEN Smart Token',
    address: '0xD38dE88687172BDE440755b5237987e4A87c23A7',
    decimals: 8,
    symbol: 'AENS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3683.png',
  },
  {
    chainId: 1,
    name: 'BTC Lite',
    address: '0x5acd19b9c91e596b1f062f18e3d02da7ed8d1e50',
    decimals: 8,
    symbol: 'BTCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3685.png',
  },
  {
    chainId: 1,
    name: 'BitBall',
    address: '0x06e0feb0d74106c7ada8497754074d222ec6bcdf',
    decimals: 18,
    symbol: 'BTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3687.png',
  },
  {
    chainId: 1,
    name: 'Mocrow',
    address: '0x33b919f54692ddbf702065763ea2b50ca02e6bff',
    decimals: 18,
    symbol: 'MCW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3689.png',
  },
  {
    chainId: 1,
    name: 'Bulleon',
    address: '0x0775c81a273b355e6a5b76e240bf708701f00279',
    decimals: 18,
    symbol: 'BUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3690.png',
  },
  {
    chainId: 1,
    name: 'Kuai Token',
    address: '0x26DDF6CabADcBF4F013841BD8d914830BeB0d984',
    decimals: 8,
    symbol: 'KT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3691.png',
  },
  {
    chainId: 1,
    name: 'TOKOK',
    address: '0x9a49f02e128a8e989b443a8f94843c0918bf45e7',
    decimals: 8,
    symbol: 'TOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3692.png',
  },
  {
    chainId: 1,
    name: 'M2O',
    address: '0x658d79c02a4829b5efa49254f627287e92458ecd',
    decimals: 18,
    symbol: 'M2O',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3693.png',
  },
  {
    chainId: 1,
    name: 'INMAX',
    address: '0x018d7d179350f1bb9853d04982820e37cce13a92',
    decimals: 8,
    symbol: 'INX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3694.png',
  },
  {
    chainId: 1,
    name: 'Hyperion',
    address: '0xe99a894a69d7c2e3c92e61b64c505a6a57d2bc07',
    decimals: 18,
    symbol: 'HYN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3695.png',
  },
  {
    chainId: 1,
    name: 'Gamblica',
    address: '0xfe1d71498da3261844ec14325bdbc93c0f7579f0',
    decimals: 18,
    symbol: 'GMBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3697.png',
  },
  {
    chainId: 1,
    name: 'Nexy',
    address: '0x49de436ea25be263cb3e8ff1401931c6f9b70660',
    decimals: 18,
    symbol: 'NXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3699.png',
  },
  {
    chainId: 1,
    name: 'DEXTER',
    address: '0xfff3ada5a2555a2b59bff4f44dfad90146cce8cb',
    decimals: 18,
    symbol: 'DXR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3705.png',
  },
  {
    chainId: 1,
    name: 'ALBOS',
    address: '0xf3e70642c28f3f707408c56624c2f30ea9f9fce3',
    decimals: 18,
    symbol: 'ALB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3706.png',
  },
  {
    chainId: 1,
    name: 'TiOS',
    address: '0xd50649aab1d39d68bc965e0f6d1cfe0010e4908b',
    decimals: 18,
    symbol: 'TOSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3707.png',
  },
  {
    chainId: 1,
    name: 'Wibson',
    address: '0x3f17dd476faf0a4855572f0b6ed5115d9bba22ad',
    decimals: 9,
    symbol: 'WIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3713.png',
  },
  {
    chainId: 1,
    name: 'LTO Network',
    address: '0xd01409314acb3b245cea9500ece3f6fd4d70ea30',
    decimals: 18,
    symbol: 'LTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3714.png',
  },
  {
    chainId: 1,
    name: 'Cajutel',
    address: '0x3c6a7ab47b5f058be0e7c7fe1a4b7925b8aca40e',
    decimals: 18,
    symbol: 'CAJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3715.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Bitcoin',
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    decimals: 8,
    symbol: 'WBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png',
  },
  {
    chainId: 1,
    name: 'Stably USD Classic',
    address: '0xa4bdb11dc0a2bec88d24a3aa1e6bb17201112ebe',
    decimals: 6,
    symbol: 'USDSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3719.png',
  },
  {
    chainId: 1,
    name: 'Huobi Pool Token',
    address: '0xa66daa57432024023db65477ba87d4e7f5f95213',
    decimals: 18,
    symbol: 'HPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3721.png',
  },
  {
    chainId: 1,
    name: 'COZ',
    address: '0x65c9f3bc25370cd91fd7a1badc7352cae2d8031b',
    decimals: 18,
    symbol: 'COZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3723.png',
  },
  {
    chainId: 1,
    name: 'SOLVE',
    address: '0x446c9033e7516d820cc9a2ce2d0b7328b579406f',
    decimals: 18,
    symbol: 'SOLVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3724.png',
  },
  {
    chainId: 1,
    name: 'Bidooh DOOH Token',
    address: '0x18c525cce3ad9a48d82f91b874754be78e9d0f85',
    decimals: 18,
    symbol: 'DOOH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3726.png',
  },
  {
    chainId: 1,
    name: 'Flowchain',
    address: '0x32C4ADB9cF57f972bc375129de91C897b4F364F1',
    decimals: 18,
    symbol: 'FLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3727.png',
  },
  {
    chainId: 1,
    name: 'The Currency Analytics',
    address: '0xaff84e86d72edb971341a6a66eb2da209446fa14',
    decimals: 18,
    symbol: 'TCAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3730.png',
  },
  {
    chainId: 1,
    name: 'PlayChip',
    address: '0x0198f46f520F33cd4329bd4bE380a25a90536CD5',
    decimals: 18,
    symbol: 'PLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3731.png',
  },
  {
    chainId: 1,
    name: 'S4FE',
    address: '0xaec7d1069e3a914a3eb50f0bfb1796751f2ce48a',
    decimals: 18,
    symbol: 'S4F',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3733.png',
  },
  {
    chainId: 1,
    name: 'Elamachain',
    address: '0xfb444c1f2b718ddfc385cb8fd9f2d1d776b24668',
    decimals: 18,
    symbol: 'ELAMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3734.png',
  },
  {
    chainId: 1,
    name: 'VegaWallet Token',
    address: '0x94236591125e935f5ac128bb3d5062944c24958c',
    decimals: 5,
    symbol: 'VGW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3735.png',
  },
  {
    chainId: 1,
    name: 'Marginless',
    address: '0x1254e59712e6e727dc71e0e3121ae952b2c4c3b6',
    decimals: 18,
    symbol: 'MRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3736.png',
  },
  {
    chainId: 1,
    name: 'BTU Protocol',
    address: '0xb683d83a532e2cb7dfa5275eed3698436371cc9f',
    decimals: 18,
    symbol: 'BTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3737.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Crypto Token',
    address: '0x9ccbd05d4d25c745d49f5e6bf17e09113eb4c769',
    decimals: 18,
    symbol: 'DCTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3738.png',
  },
  {
    chainId: 1,
    name: 'Constant',
    address: '0x4983f767b1bc44328e434729ddabea0a064ca1ac',
    decimals: 2,
    symbol: 'CONST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3739.png',
  },
  {
    chainId: 1,
    name: 'EurocoinToken',
    address: '0xe9fa21e671bcfb04e6868784b89c19d5aa2424ea',
    decimals: 18,
    symbol: 'ECTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3741.png',
  },
  {
    chainId: 1,
    name: 'Chimpion',
    address: '0x07ef9e82721ac16809d24dafbe1792ce01654db4',
    decimals: 18,
    symbol: 'BNANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3742.png',
  },
  {
    chainId: 1,
    name: 'QUSD',
    address: '0xd6875274b000462f59e9327cbde2cef637914569',
    decimals: 6,
    symbol: 'QUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3743.png',
  },
  {
    chainId: 1,
    name: 'WEBN token',
    address: '0x15a664416e42766a6cc0a1221d9c088548a6e731',
    decimals: 8,
    symbol: 'WEBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3744.png',
  },
  {
    chainId: 1,
    name: 'BiNGO.Fun',
    address: '0xd8002cd05d5b2a85557e1caaa179cc2408d5ad42',
    decimals: 8,
    symbol: '777',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3745.png',
  },
  {
    chainId: 1,
    name: 'BitcoinClassic XT',
    address: '0x796e47b85a0d759f300f1de96a3583004235d4d8',
    decimals: 18,
    symbol: 'BXCXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3746.png',
  },
  {
    chainId: 1,
    name: 'HXRO',
    address: '0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3',
    decimals: 18,
    symbol: 'HXRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3748.png',
  },
  {
    chainId: 1,
    name: 'IceChain',
    address: '0xa573661b5fb2063d7ab12336ee24589f7a79fdab',
    decimals: 18,
    symbol: 'ICHX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3749.png',
  },
  {
    chainId: 1,
    name: 'PlatonCoin',
    address: '0x429D83Bb0DCB8cdd5311e34680ADC8B12070a07f',
    decimals: 18,
    symbol: 'PLTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3753.png',
  },
  {
    chainId: 1,
    name: 'EveryCoin ',
    address: '0xeed3ae7b0f8b5b9bb8c035a9941382b1822671cd',
    decimals: 12,
    symbol: 'EVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3754.png',
  },
  {
    chainId: 1,
    name: 'Moneynet',
    address: '0xbac7a1798350cdf2dbfe0c210c2c9861223f4b31',
    decimals: 18,
    symbol: 'MNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3755.png',
  },
  {
    chainId: 1,
    name: 'GMB',
    address: '0x1b148b90442826375e864b71165a18b4d9256097',
    decimals: 18,
    symbol: 'GMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3757.png',
  },
  {
    chainId: 1,
    name: 'Jinbi Token',
    address: '0x21d5a14e625d767ce6b7a167491c2d18e0785fda',
    decimals: 18,
    symbol: 'JNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3759.png',
  },
  {
    chainId: 1,
    name: 'Scanetchain',
    address: '0xadf8b8050639b6236915f7516d69de714672f0bf',
    decimals: 18,
    symbol: 'SWC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3760.png',
  },
  {
    chainId: 1,
    name: '1SG',
    address: '0x0f72714b35a366285df85886a2ee174601292a17',
    decimals: 18,
    symbol: '1SG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3762.png',
  },
  {
    chainId: 1,
    name: 'Save Environment Token',
    address: '0x0a2d9370cf74da3fd3df5d764e394ca8205c50b6',
    decimals: 18,
    symbol: 'SET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3764.png',
  },
  {
    chainId: 1,
    name: 'Serve',
    address: '0xe1F4328DEF6AE4aE2EEAc62D58BaEaEcF05E8d30',
    decimals: 18,
    symbol: 'SERV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3765.png',
  },
  {
    chainId: 1,
    name: 'Fatcoin',
    address: '0x2ec95b8eda549b79a1248335a39d299d00ed314c',
    decimals: 18,
    symbol: 'FAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3766.png',
  },
  {
    chainId: 1,
    name: 'PIBBLE',
    address: '0x1864ce27e9f7517047933caae530674e8c70b8a7',
    decimals: 18,
    symbol: 'PIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3768.png',
  },
  {
    chainId: 1,
    name: 'CustomContractNetwork',
    address: '0x17b26400621695c2d8c2d8869f6259e82d7544c4',
    decimals: 18,
    symbol: 'CCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3770.png',
  },
  {
    chainId: 1,
    name: 'Fetch.ai',
    address: '0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85',
    decimals: 18,
    symbol: 'FET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3773.png',
  },
  {
    chainId: 1,
    name: 'GoldFund',
    address: '0x919d3a363776b1ceec9352610c82dfaf80edc32d',
    decimals: 18,
    symbol: 'GFUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3776.png',
  },
  {
    chainId: 1,
    name: 'Spectrum',
    address: '0x01cc4151fe5f00efb8df2f90ff833725d3a482a3',
    decimals: 8,
    symbol: 'SPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3777.png',
  },
  {
    chainId: 1,
    name: 'CoTrader',
    address: '0x5c872500c00565505f3624ab435c222e558e9ff8',
    decimals: 18,
    symbol: 'COT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3779.png',
  },
  {
    chainId: 1,
    name: 'Sparkle Loyalty',
    address: '0x4b7ad3a56810032782afce12d7d27122bdb96eff',
    decimals: 8,
    symbol: 'SPRKL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3780.png',
  },
  {
    chainId: 1,
    name: 'Alphaslot',
    address: '0xaee7474c3713ece228aa5ec43c89c708f2ec7ed2',
    decimals: 18,
    symbol: 'SLOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3781.png',
  },
  {
    chainId: 1,
    name: 'ONOToken',
    address: '0xb31c219959e06f9afbeb36b388a4bad13e802725',
    decimals: 18,
    symbol: 'ONOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3782.png',
  },
  {
    chainId: 1,
    name: 'Ankr',
    address: '0x8290333cef9e6d528dd5618fb97a76f268f3edd4',
    decimals: 18,
    symbol: 'ANKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3783.png',
  },
  {
    chainId: 1,
    name: 'OVCODE',
    address: '0x49d09cda1deb8a1680f1270c5ed15218fc4b18f0',
    decimals: 18,
    symbol: 'OVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3784.png',
  },
  {
    chainId: 1,
    name: 'AIDUS TOKEN',
    address: '0xec5980b1361127287f64fdd41f88c75dd244cfda',
    decimals: 18,
    symbol: 'AIDUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3785.png',
  },
  {
    chainId: 1,
    name: 'Innovative Bioresearch Classic',
    address: '0x0Cc9FCCFF81252F4bd8C5c6b359B14ae2Ed851cf',
    decimals: 6,
    symbol: 'INNBCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3787.png',
  },
  {
    chainId: 1,
    name: 'NEXT',
    address: '0xF29226914595052a04F5AFbe6410D0C3eD707548',
    decimals: 18,
    symbol: 'NET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3788.png',
  },
  {
    chainId: 1,
    name: 'Boltt Coin ',
    address: '0x688478f003b8d0f10b8af2122bf20378555ef958',
    decimals: 8,
    symbol: 'BOLTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3789.png',
  },
  {
    chainId: 1,
    name: 'RoboCalls',
    address: '0x61b2d3ea9f1c6b387c985c73d40e8fbfb284e5c7',
    decimals: 18,
    symbol: 'RC20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3790.png',
  },
  {
    chainId: 1,
    name: 'Jewel',
    address: '0x8275ebf521dc217aa79c88132017a5bcef001dd9',
    decimals: 18,
    symbol: 'JWL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3791.png',
  },
  {
    chainId: 1,
    name: 'Cosmos',
    address: '0x8D983cb9388EaC77af0474fA441C4815500Cb7BB',
    decimals: 6,
    symbol: 'ATOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3794.png',
  },
  {
    chainId: 1,
    name: 'ZEON',
    address: '0xe5b826ca2ca02f09c1725e9bd98d9a8874c30532',
    decimals: 18,
    symbol: 'ZEON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3795.png',
  },
  {
    chainId: 1,
    name: 'MESG',
    address: '0x420167d87d35c3a249b32ef6225872fbd9ab85d2',
    decimals: 18,
    symbol: 'MESG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3796.png',
  },
  {
    chainId: 1,
    name: 'Bitex Global XBX Coin',
    address: '0x57C09A8de0b0F471F8567609777aDdFfb5c46a08',
    decimals: 18,
    symbol: 'XBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3797.png',
  },
  {
    chainId: 1,
    name: 'FidexToken',
    address: '0x1c1c14a6b5074905ce5d367b0a7e098b58ebfd47',
    decimals: 8,
    symbol: 'FEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3800.png',
  },
  {
    chainId: 1,
    name: 'SpectrumNetwork',
    address: '0x259059f137cb9b8f60ae27bd199d97abb69e539b',
    decimals: 18,
    symbol: 'SPEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3804.png',
  },
  {
    chainId: 1,
    name: 'BoatPilot Token',
    address: '0xc15a399c4ea7815fe36857c9e290ee452a5d6b21',
    decimals: 18,
    symbol: 'NAVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3805.png',
  },
  {
    chainId: 1,
    name: 'TigerCash',
    address: '0x9b39a0b97319a9bd5fed217c1db7b030453bac91',
    decimals: 18,
    symbol: 'TCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3806.png',
  },
  {
    chainId: 1,
    name: 'LitecoinToken',
    address: '0x8a732bc91c33c167f868e0af7e6f31e0776d0f71',
    decimals: 18,
    symbol: 'LTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3807.png',
  },
  {
    chainId: 1,
    name: 'DOS Network',
    address: '0x0A913beaD80F321E7Ac35285Ee10d9d922659cB7',
    decimals: 18,
    symbol: 'DOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3809.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Gold Project',
    address: '0xa96f31f1c187c28980176c3a27ba7069f48abde4',
    decimals: 8,
    symbol: 'ETGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3810.png',
  },
  {
    chainId: 1,
    name: 'IntelliShare',
    address: '0x86e6a4f512b1290c043970b04e0b570d4fc98291',
    decimals: 18,
    symbol: 'INE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3811.png',
  },
  {
    chainId: 1,
    name: 'Flexacoin',
    address: '0x4a57e687b9126435a9b19e4a802113e266adebde',
    decimals: 18,
    symbol: 'FXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3812.png',
  },
  {
    chainId: 1,
    name: 'PTON',
    address: '0x4946583c5b86e01ccd30c71a05617d06e3e73060',
    decimals: 18,
    symbol: 'PTON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3813.png',
  },
  {
    chainId: 1,
    name: 'Celer Network',
    address: '0x4f9254c83eb525f9fcf346490bbb3ed28a81c667',
    decimals: 18,
    symbol: 'CELR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3814.png',
  },
  {
    chainId: 1,
    name: 'Eterbase Utility Token',
    address: '0x5bdC00B6676579b301B276198Db1ea9AffB94329',
    decimals: 18,
    symbol: 'XBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3815.png',
  },
  {
    chainId: 1,
    name: 'Verasity',
    address: '0xf411903cbc70a74d22900a5de66a2dda66507255',
    decimals: 18,
    symbol: 'VRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3816.png',
  },
  {
    chainId: 1,
    name: 'Solareum',
    address: '0x56ee8c9bd1d445a3324ad83e86d8be309db8f85d',
    decimals: 18,
    symbol: 'SLRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3817.png',
  },
  {
    chainId: 1,
    name: 'GoPower',
    address: '0xa00425d3e2d3e9ff74f3e112b4d3a7978d7d88c2',
    decimals: 18,
    symbol: 'GPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3818.png',
  },
  {
    chainId: 1,
    name: 'GAMB',
    address: '0x9488936e4a36e3585afeb63377e2393aeac253ea',
    decimals: 18,
    symbol: 'GMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3819.png',
  },
  {
    chainId: 1,
    name: 'BuckHathCoin',
    address: '0x996229D0c6a485c7F4B52E092EAa907cB2def5C6',
    decimals: 18,
    symbol: 'BHIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3820.png',
  },
  {
    chainId: 1,
    name: 'OLXA',
    address: '0x5925f67d2767d937f47141dac24166b469558222',
    decimals: 2,
    symbol: 'OLXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3823.png',
  },
  {
    chainId: 1,
    name: 'Vanta Network',
    address: '0xfdf574766ba1a96a553e175aeffa85ad78063f0b',
    decimals: 18,
    symbol: 'VANTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3824.png',
  },
  {
    chainId: 1,
    name: 'TOP',
    address: '0xdcD85914b8aE28c1E62f1C488E1D968D5aaFfE2b',
    decimals: 18,
    symbol: 'TOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3826.png',
  },
  {
    chainId: 1,
    name: 'BUDDY',
    address: '0x4257d9c82767d0bf1e53e14cdee1e9ce50ebdc3b',
    decimals: 18,
    symbol: 'BUD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3827.png',
  },
  {
    chainId: 1,
    name: 'Japan Content Token',
    address: '0x7fe92ec600f15cd25253b421bc151c51b0276b7d',
    decimals: 8,
    symbol: 'JCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3828.png',
  },
  {
    chainId: 1,
    name: 'Nash',
    address: '0xe2dc070524a6e305ddb64d8513dc444b6a1ec845',
    decimals: 8,
    symbol: 'NEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3829.png',
  },
  {
    chainId: 1,
    name: 'Safe Haven',
    address: '0x40fEd5691e547885cABd7A2990De719DCc8497FC',
    decimals: 18,
    symbol: 'SHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3831.png',
  },
  {
    chainId: 1,
    name: 'Big Bang Game Coin',
    address: '0x4FBb0B4cD8f960aC3428194F1c94c805D5b35836',
    decimals: 8,
    symbol: 'BBGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3832.png',
  },
  {
    chainId: 1,
    name: 'HYPNOXYS',
    address: '0xd35833f9255fb28cc6b91acb8a66ba6429d6ef5a',
    decimals: 18,
    symbol: 'HYPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3833.png',
  },
  {
    chainId: 1,
    name: 'Dexter G',
    address: '0x4571f3a386d1bd18E25d70d117e7067FA0Bd9D08',
    decimals: 18,
    symbol: 'DXG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3834.png',
  },
  {
    chainId: 1,
    name: 'Orbs',
    address: '0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa',
    decimals: 18,
    symbol: 'ORBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3835.png',
  },
  {
    chainId: 1,
    name: 'Esportbits',
    address: '0xa809d363a66c576a2a814cdbfefc107c600a55f0',
    decimals: 18,
    symbol: 'HLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3838.png',
  },
  {
    chainId: 1,
    name: '1irstcoin',
    address: '0x310c93dfc1c5e34cdf51678103f63c41762089cd',
    decimals: 6,
    symbol: 'FST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3840.png',
  },
  {
    chainId: 1,
    name: 'Caspian',
    address: '0xa6446d655a0c34bc4f05042ee88170d056cbaf45',
    decimals: 18,
    symbol: 'CSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3842.png',
  },
  {
    chainId: 1,
    name: 'BOLT',
    address: '0xd5930c307d7395ff807f2921f12c5eb82131a789',
    decimals: 18,
    symbol: 'BOLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3843.png',
  },
  {
    chainId: 1,
    name: 'Xtock',
    address: '0x1822126feedb4c7d61eecdbe3682fe61e91383d6',
    decimals: 18,
    symbol: 'XTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3844.png',
  },
  {
    chainId: 1,
    name: 'VIDT Datalink',
    address: '0xfef4185594457050cc9c23980d301908fe057bb1',
    decimals: 18,
    symbol: 'VIDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3845.png',
  },
  {
    chainId: 1,
    name: 'Contents Protocol',
    address: '0x9b62513c8a27290cf6a7a9e29386e600245ea819',
    decimals: 18,
    symbol: 'CPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3847.png',
  },
  {
    chainId: 1,
    name: 'OOOBTC TOKEN',
    address: '0x1367d4a67c1719b58c7e05df8768226fa768279a',
    decimals: 18,
    symbol: 'OBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3848.png',
  },
  {
    chainId: 1,
    name: 'WHEN Token',
    address: '0xf4fe95603881d0e07954fd7605e0e9a916e42c44',
    decimals: 18,
    symbol: 'WHEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3849.png',
  },
  {
    chainId: 1,
    name: 'HUDDL',
    address: '0x5137a403dd25e48de528912a4af62881e625d801',
    decimals: 18,
    symbol: 'HUDDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3852.png',
  },
  {
    chainId: 1,
    name: 'MultiVAC',
    address: '0x6226e00bcac68b0fe55583b90a1d727c14fab77f',
    decimals: 18,
    symbol: 'MTV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3853.png',
  },
  {
    chainId: 1,
    name: 'Unification',
    address: '0xe9B076B476D8865cDF79D1Cf7DF420EE397a7f75',
    decimals: 9,
    symbol: 'FUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3854.png',
  },
  {
    chainId: 1,
    name: 'Locus Chain',
    address: '0xc64500dd7b0f1794807e67802f8abbf5f8ffb054',
    decimals: 18,
    symbol: 'LOCUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3855.png',
  },
  {
    chainId: 1,
    name: 'SF Capital',
    address: '0x8b6cda5cc518c904e8844f445e1a7c7d2db0ff16',
    decimals: 18,
    symbol: 'SFCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3856.png',
  },
  {
    chainId: 1,
    name: 'FNB Protocol',
    address: '0x47b28f365bf4cb38db4b6356864bde7bc4b35129',
    decimals: 18,
    symbol: 'FNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3858.png',
  },
  {
    chainId: 1,
    name: 'Blockcloud',
    address: '0x6f919d67967a97ea36195a2346d9244e60fe0ddb',
    decimals: 18,
    symbol: 'BLOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3860.png',
  },
  {
    chainId: 1,
    name: 'Infinitus Token',
    address: '0x00e150d741eda1d49d341189cae4c08a73a49c95',
    decimals: 18,
    symbol: 'INF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3861.png',
  },
  {
    chainId: 1,
    name: 'UGAS',
    address: '0x8716fc5da009d3a208f0178b637a50f4ef42400f',
    decimals: 18,
    symbol: 'UGAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3863.png',
  },
  {
    chainId: 1,
    name: 'UTEMIS',
    address: '0x979ebc09e55ea0ab563cf7175e4c4b1a03afc19a',
    decimals: 18,
    symbol: 'UTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3864.png',
  },
  {
    chainId: 1,
    name: 'BIZKEY',
    address: '0xd28cfec79db8d0a225767d06140aee280718ab7e',
    decimals: 16,
    symbol: 'BZKY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3865.png',
  },
  {
    chainId: 1,
    name: 'CONUN',
    address: '0x4Dd672e77c795844fe3A464eF8eF0FAAe617C8fB',
    decimals: 18,
    symbol: 'CON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3866.png',
  },
  {
    chainId: 1,
    name: 'NeoWorld Cash',
    address: '0x4b94c8567763654101f690cf4d54957206383b75',
    decimals: 18,
    symbol: 'NASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3867.png',
  },
  {
    chainId: 1,
    name: 'Alpha Token',
    address: '0xffc63b9146967a1ba33066fb057ee3722221acf0',
    decimals: 18,
    symbol: 'A',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3869.png',
  },
  {
    chainId: 1,
    name: 'Lition',
    address: '0x763fa6806e1acf68130d2d0f0df754c93cc546b2',
    decimals: 18,
    symbol: 'LIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3870.png',
  },
  {
    chainId: 1,
    name: 'Bilaxy Token',
    address: '0x40d52577830e01aaefa80659aa90ee8b34685f4e',
    decimals: 18,
    symbol: 'BIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3872.png',
  },
  {
    chainId: 1,
    name: 'botXcoin',
    address: '0xEF19F4E48830093Ce5bC8b3Ff7f903A0AE3E9Fa1',
    decimals: 18,
    symbol: 'BOTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3873.png',
  },
  {
    chainId: 1,
    name: 'IRISnet',
    address: '0x76C4A2B59523eaE19594c630aAb43288dBB1463f',
    decimals: 6,
    symbol: 'IRIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3874.png',
  },
  {
    chainId: 1,
    name: 'Valor Token',
    address: '0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a',
    decimals: 18,
    symbol: 'VALOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3875.png',
  },
  {
    chainId: 1,
    name: 'EnterCoin',
    address: '0xd9d01d4cb824219a8f482a0fad479cb971fd0628',
    decimals: 8,
    symbol: 'ENTRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3876.png',
  },
  {
    chainId: 1,
    name: 'BitStash',
    address: '0xe4f356ecce6fbda81ecdea2e38527e59422861c2',
    decimals: 18,
    symbol: 'STASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3881.png',
  },
  {
    chainId: 1,
    name: 'QuickX Protocol',
    address: '0xf9e5af7b42d31d51677c75bbbd37c1986ec79aee',
    decimals: 8,
    symbol: 'QCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3883.png',
  },
  {
    chainId: 1,
    name: 'Function X',
    address: '0x8c15ef5b4b21951d50e53e4fbda8298ffad25057',
    decimals: 18,
    symbol: 'FX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3884.png',
  },
  {
    chainId: 1,
    name: 'WPP TOKEN',
    address: '0x1955d744F9435522Be508D1Ba60E3c12D0690B6A',
    decimals: 18,
    symbol: 'WPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3885.png',
  },
  {
    chainId: 1,
    name: 'ICOCalendar.Today',
    address: '0x2d71983e810b9e95258966b9c164c4d61a829ba9',
    decimals: 6,
    symbol: 'ICT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3886.png',
  },
  {
    chainId: 1,
    name: 'Serenity',
    address: '0xbc7942054f77b82e8a71ace170e4b00ebae67eb6',
    decimals: 18,
    symbol: 'SRNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3887.png',
  },
  {
    chainId: 1,
    name: 'bitCEO',
    address: '0x19ca83a13b4c4be43fa82c5e415e16f1d86f57f7',
    decimals: 18,
    symbol: 'BCEO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3888.png',
  },
  {
    chainId: 1,
    name: 'Natmin Pure Escrow',
    address: '0x90d46a9636b973f18186541d1b04ed3621a49cb0',
    decimals: 18,
    symbol: 'NAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3889.png',
  },
  {
    chainId: 1,
    name: 'Polygon',
    address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
    decimals: 18,
    symbol: 'MATIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png',
  },
  {
    chainId: 1,
    name: 'ChangeNOW Token',
    address: '0xe9a95d175a5f4c9369f3b74222402eb1b837693b',
    decimals: 18,
    symbol: 'NOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3893.png',
  },
  {
    chainId: 1,
    name: 'HoryouToken',
    address: '0xcfac2916ec118a0252a7766c513ee7c71b384b5e',
    decimals: 18,
    symbol: 'HYT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3896.png',
  },
  {
    chainId: 1,
    name: 'OKB',
    address: '0x75231f58b43240c9718dd58b4967c5114342a86c',
    decimals: 18,
    symbol: 'OKB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png',
  },
  {
    chainId: 1,
    name: 'Zloadr',
    address: '0xbdfa65533074b0b23ebc18c7190be79fa74b30c2',
    decimals: 18,
    symbol: 'ZDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3899.png',
  },
  {
    chainId: 1,
    name: 'Fanfare',
    address: '0x90162f41886c0946d09999736f1c15c8a105a421',
    decimals: 18,
    symbol: 'FAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3903.png',
  },
  {
    chainId: 1,
    name: 'DUO Network Token',
    address: '0x56e0b2c7694e6e10391e870774daa45cf6583486',
    decimals: 18,
    symbol: 'DUO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3905.png',
  },
  {
    chainId: 1,
    name: 'Ocean Protocol',
    address: '0x967da4048cd07ab37855c090aaf366e4ce1b9f48',
    decimals: 18,
    symbol: 'OCEAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3911.png',
  },
  {
    chainId: 1,
    name: 'W Green Pay',
    address: '0xdd94842c15abfe4c9bafe4222ade02896beb064c',
    decimals: 18,
    symbol: 'WGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3912.png',
  },
  {
    chainId: 1,
    name: 'Sentivate',
    address: '0x7865af71cf0b288b4e7f654f4f7851eb46a2b7f8',
    decimals: 18,
    symbol: 'SNTVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3917.png',
  },
  {
    chainId: 1,
    name: 'Diamond Platform Token',
    address: '0x10c71515602429c19d53011ea7040b87a4894838',
    decimals: 18,
    symbol: 'DPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3920.png',
  },
  {
    chainId: 1,
    name: 'VENJOCOIN',
    address: '0x5c62da804298d5972a323c80b539b8e7517a0dde',
    decimals: 18,
    symbol: 'VJC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3923.png',
  },
  {
    chainId: 1,
    name: 'Tratok',
    address: '0xe225aca29524bb65fd82c79a9602f3b4f9c6fe3f',
    decimals: 5,
    symbol: 'TRAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3925.png',
  },
  {
    chainId: 1,
    name: 'Atlas Token',
    address: '0xd36e9f8f194a47b10af16c7656a68eba1dfe88e4',
    decimals: 18,
    symbol: 'ATLS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3927.png',
  },
  {
    chainId: 1,
    name: 'IDEX',
    address: '0xb705268213d593b8fd88d3fdeff93aff5cbdcfae',
    decimals: 18,
    symbol: 'IDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3928.png',
  },
  {
    chainId: 1,
    name: 'BQT',
    address: '0x9d8be94d0612170ce533ac4d7b43cc3cd91e5a1a',
    decimals: 18,
    symbol: 'BQTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3929.png',
  },
  {
    chainId: 1,
    name: 'ThunderCore',
    address: '0x1E053D89E08c24aA2CE5C5B4206744Dc2D7BD8F5',
    decimals: 18,
    symbol: 'TT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3930.png',
  },
  {
    chainId: 1,
    name: 'Elementeum',
    address: '0x6c37bf4f042712c978a73e3fd56d1f5738dd7c43',
    decimals: 18,
    symbol: 'ELET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3931.png',
  },
  {
    chainId: 1,
    name: 'Connect Coin',
    address: '0x0f237d5ea7876e0e2906034d98fdb20d43666ad4',
    decimals: 18,
    symbol: 'XCON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3932.png',
  },
  {
    chainId: 1,
    name: 'CNNS',
    address: '0x6c3be406174349cfa4501654313d97e6a31072e1',
    decimals: 18,
    symbol: 'CNNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3934.png',
  },
  {
    chainId: 1,
    name: 'SparkPoint',
    address: '0x0488401c3f535193fa8df029d9ffe615a06e74e6',
    decimals: 18,
    symbol: 'SRK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3935.png',
  },
  {
    chainId: 1,
    name: 'GNY',
    address: '0xb1f871Ae9462F1b2C6826E88A7827e76f86751d4',
    decimals: 18,
    symbol: 'GNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3936.png',
  },
  {
    chainId: 1,
    name: 'NNB Token',
    address: '0xb66a2131a6b840dd020151f80723caed603efb51',
    decimals: 18,
    symbol: 'NNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3937.png',
  },
  {
    chainId: 1,
    name: 'Muzika',
    address: '0x1f35a281036be57e64e7e7a2a556b4f888a1b829',
    decimals: 18,
    symbol: 'MZK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3938.png',
  },
  {
    chainId: 1,
    name: 'Tronipay',
    address: '0x9b1e1fc958b83e801d1342f9f9ba7da3a55ba1ef',
    decimals: 8,
    symbol: 'TRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3939.png',
  },
  {
    chainId: 1,
    name: 'P2P Global Network',
    address: '0xcecede5a20645eac6ca2032eeeb1063572d63c29',
    decimals: 18,
    symbol: 'P2PX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3940.png',
  },
  {
    chainId: 1,
    name: 'Fast Access Blockchain',
    address: '0xf2260Ed15c59C9437848AfeD04645044A8d5e270',
    decimals: 18,
    symbol: 'FAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3941.png',
  },
  {
    chainId: 1,
    name: 'Artfinity',
    address: '0xe54b3458c47e44c37a267e7c633afef88287c294',
    decimals: 5,
    symbol: 'AT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3944.png',
  },
  {
    chainId: 1,
    name: 'Carry',
    address: '0x115eC79F1de567eC68B7AE7eDA501b406626478e',
    decimals: 18,
    symbol: 'CRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3946.png',
  },
  {
    chainId: 1,
    name: 'HashNet BitEco',
    address: '0x9c197c4b58527faaab67cb35e3145166b23d242e',
    decimals: 18,
    symbol: 'HNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3947.png',
  },
  {
    chainId: 1,
    name: 'Asian Fintech',
    address: '0xee9e5eff401ee921b138490d00ca8d1f13f67a72',
    decimals: 18,
    symbol: 'AFIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3949.png',
  },
  {
    chainId: 1,
    name: 'IOTW',
    address: '0x4fe327c5a809fa721d47b80c5038a0b393e61305',
    decimals: 6,
    symbol: 'IOTW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3952.png',
  },
  {
    chainId: 1,
    name: 'Evedo',
    address: '0x5aaefe84e0fb3dd1f0fcff6fa7468124986b91bd',
    decimals: 18,
    symbol: 'EVED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3953.png',
  },
  {
    chainId: 1,
    name: 'One DEX',
    address: '0xa960d2ba7000d58773e7fa5754dec3bb40a069d5',
    decimals: 18,
    symbol: 'ODEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3954.png',
  },
  {
    chainId: 1,
    name: 'UNUS SED LEO',
    address: '0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3',
    decimals: 18,
    symbol: 'LEO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3957.png',
  },
  {
    chainId: 1,
    name: 'ALLUVA',
    address: '0x744c9c36d1cc3268a4b9b2e28c60b1752c85e97d',
    decimals: 18,
    symbol: 'ALV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3959.png',
  },
  {
    chainId: 1,
    name: 'Coineal Token',
    address: '0xacce88f5a63a5e65db9aa7303720be16b556e751',
    decimals: 18,
    symbol: 'NEAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3960.png',
  },
  {
    chainId: 1,
    name: 'Vodi X',
    address: '0x91e64f39c1fe14492e8fdf5a8b0f305bd218c8a1',
    decimals: 18,
    symbol: 'VDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3962.png',
  },
  {
    chainId: 1,
    name: 'DreamTeam Token',
    address: '0x82f4ded9cec9b5750fbff5c2185aee35afc16587',
    decimals: 6,
    symbol: 'DREAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3963.png',
  },
  {
    chainId: 1,
    name: 'Reserve Rights',
    address: '0x320623b8e4ff03373931769a31fc52a4e78b5d70',
    decimals: 18,
    symbol: 'RSR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3964.png',
  },
  {
    chainId: 1,
    name: 'TouchCon',
    address: '0x549905519f9e06d55d7dfcd4d54817780f6b93e8',
    decimals: 18,
    symbol: 'TOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3965.png',
  },
  {
    chainId: 1,
    name: 'Eva Cash',
    address: '0xba14b245d449965bdbeb630ebe135b569474f5b1',
    decimals: 6,
    symbol: 'EVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3967.png',
  },
  {
    chainId: 1,
    name: 'Elitium',
    address: '0x6aB4A7d75B0A42B6Bc83E852daB9E121F9C610Aa',
    decimals: 18,
    symbol: 'EUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3968.png',
  },
  {
    chainId: 1,
    name: 'Aryacoin',
    address: '0x86e5775f5c46304939c40959812bc220dd1c0333',
    decimals: 18,
    symbol: 'AYA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3973.png',
  },
  {
    chainId: 1,
    name: 'Neutral Dollar',
    address: '0x0c6144c16af288948c8fdb37fd8fec94bff3d1d9',
    decimals: 6,
    symbol: 'nUSD-EXCLUDE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3975.png',
  },
  {
    chainId: 1,
    name: 'Sport and Leisure',
    address: '0xa806b3fed6891136940cf81c4085661500aa2709',
    decimals: 6,
    symbol: 'SNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3977.png',
  },
  {
    chainId: 1,
    name: 'Chromia',
    address: '0x8a2279d4a90b6fe1c4b30fa660cc9f926797baa2',
    decimals: 6,
    symbol: 'CHR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3978.png',
  },
  {
    chainId: 1,
    name: 'GUNTHY',
    address: '0x3684b581db1f94b721ee0022624329feb16ab653',
    decimals: 18,
    symbol: 'GUNTHY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3979.png',
  },
  {
    chainId: 1,
    name: 'TCASH',
    address: '0x7051620d11042c4335069AaA4f10Cd3B4290C681',
    decimals: 8,
    symbol: 'TCASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3980.png',
  },
  {
    chainId: 1,
    name: 'Toqqn',
    address: '0x6613876533bc69b9dd628611a4d5dd2ccd8c7638',
    decimals: 18,
    symbol: 'TQN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3981.png',
  },
  {
    chainId: 1,
    name: 'Cryptoxygen',
    address: '0x66149b85cbd202eaf4a93713702a7e94fc1121a7',
    decimals: 5,
    symbol: 'OXY2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3982.png',
  },
  {
    chainId: 1,
    name: 'PATHHIVE ',
    address: '0x25200235ca7113c2541e70de737c41f5e9acd1f6',
    decimals: 18,
    symbol: 'PHV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3983.png',
  },
  {
    chainId: 1,
    name: 'Lucky Block Network',
    address: '0xb9843e5de0f37d1e22c8075e5814e13565fe7c22',
    decimals: 18,
    symbol: 'LBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3984.png',
  },
  {
    chainId: 1,
    name: 'Origo',
    address: '0xff0e5e014cf97e0615cb50f6f39da6388e2fae6e',
    decimals: 18,
    symbol: 'OGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3985.png',
  },
  {
    chainId: 1,
    name: 'VNT Chain',
    address: '0x69d2779533a4d2c780639713558b2cc98c46a9b7',
    decimals: 8,
    symbol: 'VNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3988.png',
  },
  {
    chainId: 1,
    name: 'LevelApp Token',
    address: '0xa8eda9d4aee0eb882f8752c6ba7e16d9233c9ad2',
    decimals: 8,
    symbol: 'LVL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3989.png',
  },
  {
    chainId: 1,
    name: 'Webflix Token',
    address: '0xd111BCb8C30a600c12F4AF8314235F628EA2Cb3C',
    decimals: 18,
    symbol: 'WFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3990.png',
  },
  {
    chainId: 1,
    name: 'Alphacon',
    address: '0x454b9f249bc1492ee995793bbc3e57b830f1a5e9',
    decimals: 18,
    symbol: 'ALP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3991.png',
  },
  {
    chainId: 1,
    name: 'COTI',
    address: '0xDDB3422497E61e13543BeA06989C0789117555c5',
    decimals: 18,
    symbol: 'COTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3992.png',
  },
  {
    chainId: 1,
    name: 'Emanate',
    address: '0x893700a1a86ee68b92536bf6fd4d3200d7369f7d',
    decimals: 18,
    symbol: 'EMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3993.png',
  },
  {
    chainId: 1,
    name: 'Smartup',
    address: '0x78f5bbc74fb9137a75d85f3c9c3c599be49f0a56',
    decimals: 18,
    symbol: 'SMARTUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3994.png',
  },
  {
    chainId: 1,
    name: 'Gosama',
    address: '0xd2bfec3f80b7d966d7657a2ecc5982ee2f49336a',
    decimals: 18,
    symbol: 'GOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3995.png',
  },
  {
    chainId: 1,
    name: 'IOU',
    address: '0x8ad6739649f1fbf079882c14d27862d5c2206660',
    decimals: 18,
    symbol: 'IOUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3996.png',
  },
  {
    chainId: 1,
    name: 'Krios',
    address: '0x838d8e11B160deC88Fe62BF0f743FB7000941e13',
    decimals: 18,
    symbol: 'GIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3998.png',
  },
  {
    chainId: 1,
    name: 'TAGZ',
    address: '0x5d8cE06A40fB101895bE5b6560931b92a1b3444F',
    decimals: 8,
    symbol: 'TAGZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3999.png',
  },
  {
    chainId: 1,
    name: 'Coin Controller Cash',
    address: '0x94cb815f4b601b00b363b3177b4d8ed8e0eb7cf2',
    decimals: 18,
    symbol: 'CCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4000.png',
  },
  {
    chainId: 1,
    name: 'MenaPay',
    address: '0x3810a4ddf41e586fa0dba1463a7951b748cecfca',
    decimals: 18,
    symbol: 'MPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4001.png',
  },
  {
    chainId: 1,
    name: 'SealBlock Token',
    address: '0x82bdfb4c6f488fc47700cef12c448a2f13f8ff4f',
    decimals: 18,
    symbol: 'SKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4002.png',
  },
  {
    chainId: 1,
    name: 'Zenon',
    address: '0xb2e96a63479c2edd2fd62b382c89d5ca79f572d3',
    decimals: 8,
    symbol: 'ZNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4003.png',
  },
  {
    chainId: 1,
    name: 'Zerobank',
    address: '0x182a603541a4483c308475147d621bbb4e2587c6',
    decimals: 18,
    symbol: 'ZB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4004.png',
  },
  {
    chainId: 1,
    name: 'Tratin',
    address: '0x3eb55d5b22ee0f9b03d59b4994c5ae7fe811be92',
    decimals: 8,
    symbol: 'TRAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4005.png',
  },
  {
    chainId: 1,
    name: 'STP',
    address: '0xde7d85157d9714eadf595045cc12ca4a5f3e2adb',
    decimals: 18,
    symbol: 'STPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4006.png',
  },
  {
    chainId: 1,
    name: 'B91',
    address: '0x1519aff03b3e23722511d2576c769a77baf09580',
    decimals: 18,
    symbol: 'B91',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4007.png',
  },
  {
    chainId: 1,
    name: 'IZIChain',
    address: '0xdf59c8ba19b4d1437d80836b45f1319d9a429eed',
    decimals: 4,
    symbol: 'IZI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4009.png',
  },
  {
    chainId: 1,
    name: 'Sparkster',
    address: '0x971d048e737619884f2df75e31c7eb6412392328',
    decimals: 18,
    symbol: 'SPRK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4010.png',
  },
  {
    chainId: 1,
    name: 'Bitsdaq',
    address: '0x1b80eeeadcc590f305945bcc258cfa770bbe1890',
    decimals: 18,
    symbol: 'BQQQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4011.png',
  },
  {
    chainId: 1,
    name: 'InnovaMinex',
    address: '0xae353daeed8dcc7a9a12027f7e070c0a50b7b6a4',
    decimals: 18,
    symbol: 'MINX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4012.png',
  },
  {
    chainId: 1,
    name: 'ESTATE Token',
    address: '0x6671c24dd5b8e4ced34033991418e4bc0cca05af',
    decimals: 8,
    symbol: 'ESTATE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4015.png',
  },
  {
    chainId: 1,
    name: 'Webercoin ',
    address: '0xb4e3362ee28105cd6d99278424d2176c4f3d76ce',
    decimals: 18,
    symbol: 'WBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4019.png',
  },
  {
    chainId: 1,
    name: 'USDQ',
    address: '0x4954db6391f4feb5468b6b943d4935353596aec9',
    decimals: 18,
    symbol: 'USDQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4020.png',
  },
  {
    chainId: 1,
    name: 'Bitreal',
    address: '0x8040d35ed6c82f75b1078cf5eb93a2cfd34b2bd8',
    decimals: 18,
    symbol: 'BTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4021.png',
  },
  {
    chainId: 1,
    name: 'LiquidApps',
    address: '0x939B462ee3311f8926c047D2B576C389092b1649',
    decimals: 4,
    symbol: 'DAPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4026.png',
  },
  {
    chainId: 1,
    name: 'Jarvis+',
    address: '0xa249de6948022783765fee4850d7b85e43118fcc',
    decimals: 18,
    symbol: 'JAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4034.png',
  },
  {
    chainId: 1,
    name: 'Garuda Token',
    address: '0x610740af3f25b72892ba21b98bfb8595f2cde386',
    decimals: 8,
    symbol: 'GAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4037.png',
  },
  {
    chainId: 1,
    name: 'ARPA',
    address: '0xba50933c268f567bdc86e1ac131be072c6b0b71a',
    decimals: 18,
    symbol: 'ARPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4039.png',
  },
  {
    chainId: 1,
    name: 'Hut34 Entropy',
    address: '0x5bc7e5f0ab8b2e10d2d0a3f21739fce62459aef3',
    decimals: 18,
    symbol: 'ENTRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4040.png',
  },
  {
    chainId: 1,
    name: 'MX TOKEN',
    address: '0x11eef04c884e24d9b7b4760e7476d06ddf797f36',
    decimals: 18,
    symbol: 'MX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4041.png',
  },
  {
    chainId: 1,
    name: 'COINBIG',
    address: '0x01E45B8D0c51f05F17385DD3416fE3aA5BFd89aC',
    decimals: 18,
    symbol: 'CB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4042.png',
  },
  {
    chainId: 1,
    name: 'HubrisOne',
    address: '0x432555e5c898f83fc5f00df631bd9c2801fea289',
    decimals: 18,
    symbol: 'HBRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4044.png',
  },
  {
    chainId: 1,
    name: 'Catex Token',
    address: '0x6e605c269e0c92e70beeb85486f1fc550f9380bd',
    decimals: 18,
    symbol: 'CATT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4045.png',
  },
  {
    chainId: 1,
    name: 'Naka Bodhi Token',
    address: '0x09Ccd2DA5dCDd0510268d4979e792381337138b8',
    decimals: 18,
    symbol: 'NBOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4047.png',
  },
  {
    chainId: 1,
    name: 'MGC Token',
    address: '0x174BfA6600Bf90C885c7c01C7031389ed1461Ab9',
    decimals: 18,
    symbol: 'MGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4048.png',
  },
  {
    chainId: 1,
    name: 'Bitbook Gambling',
    address: '0xeb6985acd6d0cbff60b88032b0b29ac1d9d66a1b',
    decimals: 18,
    symbol: 'BXK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4049.png',
  },
  {
    chainId: 1,
    name: 'Parachute',
    address: '0x1beef31946fbbb40b877a72e4ae04a8d1a5cee06',
    decimals: 18,
    symbol: 'PAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4051.png',
  },
  {
    chainId: 1,
    name: 'GivingToServices',
    address: '0x9cec686ba6f07d6135b2091140c795166ef5b761',
    decimals: 18,
    symbol: 'SVCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4052.png',
  },
  {
    chainId: 1,
    name: 'Q DAO Governance token v1.0',
    address: '0x3166c570935a7d8554c8f4ea792ff965d2efe1f2',
    decimals: 18,
    symbol: 'QDAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4053.png',
  },
  {
    chainId: 1,
    name: 'IG Gold',
    address: '0x8ffe40a3d0f80c0ce6b203d5cdc1a6a86d9acaea',
    decimals: 6,
    symbol: 'IGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4054.png',
  },
  {
    chainId: 1,
    name: 'FRELDO',
    address: '0xd8b8e1eca89da014e67fdbc2014eaa8e171079bf',
    decimals: 18,
    symbol: 'FRECNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4055.png',
  },
  {
    chainId: 1,
    name: 'Ampleforth',
    address: '0xd46ba6d942050d489dbd938a2c909a5d5039a161',
    decimals: 9,
    symbol: 'AMPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4056.png',
  },
  {
    chainId: 1,
    name: 'Aladdin',
    address: '0x95a41fB80ca70306e9Ecf4e51ceA31bD18379C18',
    decimals: 18,
    symbol: 'ADN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4057.png',
  },
  {
    chainId: 1,
    name: 'TrustVerse',
    address: '0x72955ecff76e48f2c8abcce11d54e5734d6f3657',
    decimals: 18,
    symbol: 'TRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4060.png',
  },
  {
    chainId: 1,
    name: 'Bayan Token',
    address: '0x68d3af29a900d21d092778a9d0aa4f73b1367141',
    decimals: 2,
    symbol: 'BYT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4062.png',
  },
  {
    chainId: 1,
    name: '7Eleven',
    address: '0x186a33d4dbcd700086a26188dcb74e69be463665',
    decimals: 8,
    symbol: '7E',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4063.png',
  },
  {
    chainId: 1,
    name: 'USDK',
    address: '0x1c48f86ae57291f7686349f12601910bd8d470bb',
    decimals: 18,
    symbol: 'USDK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4064.png',
  },
  {
    chainId: 1,
    name: 'TuneTradeX',
    address: '0x1cfa16ab69b187f9fe0227e069c9a25ef1b25243',
    decimals: 18,
    symbol: 'TXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4065.png',
  },
  {
    chainId: 1,
    name: 'Chiliz',
    address: '0x3506424f91fd33084466f402d5d97f05f8e3b4af',
    decimals: 18,
    symbol: 'CHZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4066.png',
  },
  {
    chainId: 1,
    name: 'Cryptoindex.com 100',
    address: '0x6393e822874728f8afa7e1c9944e417d37ca5878',
    decimals: 18,
    symbol: 'CIX100',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4067.png',
  },
  {
    chainId: 1,
    name: 'Blockburn',
    address: '0x8515cD0f00aD81996d24b9A9C35121a3b759D6Cd',
    decimals: 18,
    symbol: 'BURN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4069.png',
  },
  {
    chainId: 1,
    name: 'Ubricoin',
    address: '0xdb13025b219db5e4529f48b65ff009a26b6ae733',
    decimals: 18,
    symbol: 'UBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4071.png',
  },
  {
    chainId: 1,
    name: 'COZ Plus',
    address: '0x9975f96efa232679d7e36af6760e2c7b91bfc828',
    decimals: 18,
    symbol: 'COZP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4072.png',
  },
  {
    chainId: 1,
    name: 'SPIN Protocol',
    address: '0x4f22310c27ef39feaa4a756027896dc382f0b5e2',
    decimals: 18,
    symbol: 'SPIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4073.png',
  },
  {
    chainId: 1,
    name: 'CryptoFranc',
    address: '0xb4272071ecadd69d933adcd19ca99fe80664fc08',
    decimals: 18,
    symbol: 'XCHF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4075.png',
  },
  {
    chainId: 1,
    name: 'ETHplode',
    address: '0xe0c6ce3e73029f201e5c0bedb97f67572a93711c',
    decimals: 6,
    symbol: 'ETHPLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4076.png',
  },
  {
    chainId: 1,
    name: 'Maya Preferred',
    address: '0x7CDA79830Faf07Ed696Fe220566116951CED36A7',
    decimals: 18,
    symbol: 'MAYP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4077.png',
  },
  {
    chainId: 1,
    name: 'Silverway',
    address: '0x4c1c4957d22d8f373aed54d0853b090666f6f9de',
    decimals: 18,
    symbol: 'SLV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4079.png',
  },
  {
    chainId: 1,
    name: 'HireGo',
    address: '0xaaa89105dab822dbc9a6de64a23d045d99d5fd36',
    decimals: 18,
    symbol: 'HGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4080.png',
  },
  {
    chainId: 1,
    name: 'LydianCoin',
    address: '0x8260aa7b903fa1746820ebf674f2f837b22f016b',
    decimals: 8,
    symbol: 'LDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4083.png',
  },
  {
    chainId: 1,
    name: 'Thar Token',
    address: '0x757703bD5B2c4BBCfde0BE2C0b0E7C2f31FCf4E9',
    decimals: 18,
    symbol: 'THAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4084.png',
  },
  {
    chainId: 1,
    name: 'SPIRIT',
    address: '0x92d7a89405ea3cc605a467e834236e09df60bf16',
    decimals: 18,
    symbol: 'SPIRIT1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4085.png',
  },
  {
    chainId: 1,
    name: 'PDATA',
    address: '0x0db03b6cde0b2d427c64a04feafd825938368f1f',
    decimals: 18,
    symbol: 'PDATA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4088.png',
  },
  {
    chainId: 1,
    name: 'Blockmason Link',
    address: '0x42bedd647e387dabec65a7dc3a3babcc68bb664d',
    decimals: 18,
    symbol: 'BLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4089.png',
  },
  {
    chainId: 1,
    name: 'Wirex Token',
    address: '0xa02120696c7B8fE16C09C749E4598819b2B0E915',
    decimals: 18,
    symbol: 'WXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4090.png',
  },
  {
    chainId: 1,
    name: 'PIXEL',
    address: '0xf88951d7b676798705fd3a362ba5b1dbca2b233b',
    decimals: 18,
    symbol: 'PXL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4091.png',
  },
  {
    chainId: 1,
    name: 'Dusk',
    address: '0x940a2db1b7008b6c776d4faaca729d6d4a4aa551',
    decimals: 18,
    symbol: 'DUSK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4092.png',
  },
  {
    chainId: 1,
    name: 'Uranus',
    address: '0xff8be4b22cedc440591dcb1e641eb2a0dd9d25a5',
    decimals: 18,
    symbol: 'URAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4093.png',
  },
  {
    chainId: 1,
    name: 'Spiking',
    address: '0xa7fc5d2453e3f68af0cc1b78bcfee94a1b293650',
    decimals: 10,
    symbol: 'SPIKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4094.png',
  },
  {
    chainId: 1,
    name: 'Switch',
    address: '0xd6a55c63865affd67e2fb9f284f87b7a9e5ff3bd',
    decimals: 18,
    symbol: 'ESH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4096.png',
  },
  {
    chainId: 1,
    name: 'x42 Protocol',
    address: '0xf49fcdb92c7438b54edb4f1021abe3e3b4b15c92',
    decimals: 8,
    symbol: 'X42',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4097.png',
  },
  {
    chainId: 1,
    name: 'DEPRECATED-Tapcoin',
    address: '0x9f599410d207f3d2828a8712e5e543ac2e040382',
    decimals: 18,
    symbol: 'deprecated-TTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4098.png',
  },
  {
    chainId: 1,
    name: 'Intimate',
    address: '0x7e9bf742acd4af1f419104cf6d22a36315142b87',
    decimals: 18,
    symbol: 'ITM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4099.png',
  },
  {
    chainId: 1,
    name: 'qiibeeCoin',
    address: '0x26E1f9F817b3b5FC2146c01ae34826593E593962',
    decimals: 18,
    symbol: 'QBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4100.png',
  },
  {
    chainId: 1,
    name: 'FLETA',
    address: '0x40897C872214303b6F479a37E549eE1516B264A2',
    decimals: 18,
    symbol: 'FLETA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4103.png',
  },
  {
    chainId: 1,
    name: 'FUZE Token',
    address: '0x187d1018e8ef879be4194d6ed7590987463ead85',
    decimals: 18,
    symbol: 'FUZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4104.png',
  },
  {
    chainId: 1,
    name: 'Coinmetro Token',
    address: '0x36ac219f90f5a6a3c77f2a7b660e3cc701f68e25',
    decimals: 18,
    symbol: 'XCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4105.png',
  },
  {
    chainId: 1,
    name: 'ReceiptCoin',
    address: '0xd6e49800decb64c0e195f791348c1e87a5864fd7',
    decimals: 9,
    symbol: 'RC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4107.png',
  },
  {
    chainId: 1,
    name: 'En-Tan-Mo',
    address: '0x6020da0f7c1857dbe4431ec92a15cc318d933eaa',
    decimals: 18,
    symbol: 'ETM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4108.png',
  },
  {
    chainId: 1,
    name: 'IDEALCOIN',
    address: '0x2d153f2adccbe9364f9e4ed5843308abd0bf93da',
    decimals: 18,
    symbol: 'IDEAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4111.png',
  },
  {
    chainId: 1,
    name: 'Eco Value Coin',
    address: '0xaa843f65872a25d6e9552ea0b360fb1d5e333124',
    decimals: 18,
    symbol: 'EVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4112.png',
  },
  {
    chainId: 1,
    name: 'UNI COIN',
    address: '0xe6877ea9c28fbdec631ffbc087956d0023a76bf2',
    decimals: 18,
    symbol: 'UNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4113.png',
  },
  {
    chainId: 1,
    name: 'Golden Token',
    address: '0x34d6a0f5c2f5d0082141fe73d93b9dd00ca7ce11',
    decimals: 18,
    symbol: 'GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4114.png',
  },
  {
    chainId: 1,
    name: 'TOKPIE',
    address: '0xd31695a1d35e489252ce57b129fd4b1b05e6acac',
    decimals: 18,
    symbol: 'TKP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4116.png',
  },
  {
    chainId: 1,
    name: 'simplyBrand',
    address: '0xECB8F588EAf5A8ce9d964b0acece5D954E130e2f',
    decimals: 18,
    symbol: 'SBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4117.png',
  },
  {
    chainId: 1,
    name: 'ForTube',
    address: '0x1fcdce58959f536621d76f5b7ffb955baa5a672f',
    decimals: 18,
    symbol: 'FOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4118.png',
  },
  {
    chainId: 1,
    name: 'Prom',
    address: '0xfc82bb4ba86045af6f327323a46e80412b91b27d',
    decimals: 18,
    symbol: 'PROM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4120.png',
  },
  {
    chainId: 1,
    name: 'Armacoin',
    address: '0x0a680e503fd9ae14b62444c75ffb4bef1f105666',
    decimals: 8,
    symbol: 'GZM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4123.png',
  },
  {
    chainId: 1,
    name: 'EOS TRUST',
    address: '0x87210f1d3422ba75b6c40c63c78d79324dabcd55',
    decimals: 18,
    symbol: 'EOST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4124.png',
  },
  {
    chainId: 1,
    name: 'NOIZ',
    address: '0x36151737b45017234e9570cf9a1cac97138953c2',
    decimals: 18,
    symbol: 'NOIZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4125.png',
  },
  {
    chainId: 1,
    name: 'BOOM',
    address: '0xdb7eab9ba6be88b869f738f6deeba96d49fe13fd',
    decimals: 18,
    symbol: 'BOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4128.png',
  },
  {
    chainId: 1,
    name: 'YottaChain',
    address: '0x5edc1a266e8b2c5e8086d373725df0690af7e3ea',
    decimals: 18,
    symbol: 'YTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4133.png',
  },
  {
    chainId: 1,
    name: 'Akropolis',
    address: '0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7',
    decimals: 18,
    symbol: 'AKRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4134.png',
  },
  {
    chainId: 1,
    name: 'WinStars.live',
    address: '0xcfbf70e33d5163e25b0dad73955c1bd9e8cd8ba2',
    decimals: 18,
    symbol: 'WNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4138.png',
  },
  {
    chainId: 1,
    name: 'Brazilian Digital Token',
    address: '0x01d33FD36ec67c6Ada32cf36b31e88EE190B1839',
    decimals: 18,
    symbol: 'BRZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4139.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Fast',
    address: '0x225927f8fa71d16ee07968b8746364d1d9f839bd',
    decimals: 8,
    symbol: 'BTCF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4141.png',
  },
  {
    chainId: 1,
    name: 'Cubiex',
    address: '0x122f96d596384885b54bccdddf2125018c421d83',
    decimals: 8,
    symbol: 'CBIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4142.png',
  },
  {
    chainId: 1,
    name: 'TrueFeedBack',
    address: '0x4057db5bd9f67a566aa10e5587b1a964affc6a16',
    decimals: 18,
    symbol: 'TFBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4144.png',
  },
  {
    chainId: 1,
    name: 'Miracle Tele',
    address: '0xb363a3c584b1f379c79fbf09df015da5529d4dac',
    decimals: 18,
    symbol: 'TELE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4145.png',
  },
  {
    chainId: 1,
    name: 'GameXCoin',
    address: '0x953e22945b416730bad05009af05b420e598e412',
    decimals: 18,
    symbol: 'GXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4148.png',
  },
  {
    chainId: 1,
    name: 'QOS Chain',
    address: '0x7b188a8b3a2113621895fb35fc67a779caffa92d',
    decimals: 4,
    symbol: 'QOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4149.png',
  },
  {
    chainId: 1,
    name: 'GLOBEX',
    address: '0x66142b81db17d7c0bd91f502d00382e326a24c2a',
    decimals: 8,
    symbol: 'GEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4150.png',
  },
  {
    chainId: 1,
    name: 'Five Star Coin Pro',
    address: '0x2c31c747e0d1eb1f662b619461dced4ce5ca22ea',
    decimals: 8,
    symbol: 'FSCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4158.png',
  },
  {
    chainId: 1,
    name: 'Storeum',
    address: '0xcb39c3502415152b2ec90ff07ee18cc94f681a72',
    decimals: 18,
    symbol: 'STO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4162.png',
  },
  {
    chainId: 1,
    name: 'Hype Token',
    address: '0x2630997aab62fa1030a8b975e1aa2dc573b18a13',
    decimals: 18,
    symbol: 'HYPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4163.png',
  },
  {
    chainId: 1,
    name: 'PLUSQO Token',
    address: '0x2bf9671f00643afc813a6623074e0ddf6db4fc2b',
    decimals: 18,
    symbol: 'PSQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4164.png',
  },
  {
    chainId: 1,
    name: 'CREDIT',
    address: '0x0667D72e77D899A81965FFD415A5ea45D4A1275A',
    decimals: 18,
    symbol: 'CREDIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4165.png',
  },
  {
    chainId: 1,
    name: 'Realio Network',
    address: '0xf21661d0d1d76d3ecb8e1b9f1c923dbfffae4097',
    decimals: 18,
    symbol: 'RIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4166.png',
  },
  {
    chainId: 1,
    name: 'Bitrue Coin',
    address: '0xd433138d12beB9929FF6fd583DC83663eea6Aaa5',
    decimals: 18,
    symbol: 'BTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4167.png',
  },
  {
    chainId: 1,
    name: 'Cashpayz Token',
    address: '0x28ea81fac7b1719138cbf61267198155b433e00e',
    decimals: 8,
    symbol: 'CPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4168.png',
  },
  {
    chainId: 1,
    name: 'Infireum',
    address: '0x0e7f19c634709559a3743d52d78a369b08cb6fef',
    decimals: 8,
    symbol: 'IFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4171.png',
  },
  {
    chainId: 1,
    name: 'Terra Classic',
    address: '0xbd31ea8212119f94a611fa969881cba3ea06fa3d',
    decimals: 18,
    symbol: 'LUNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4172.png',
  },
  {
    chainId: 1,
    name: 'Levolution',
    address: '0x09970aec766b6f3223aca9111555e99dc50ff13a',
    decimals: 18,
    symbol: 'LEVL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4173.png',
  },
  {
    chainId: 1,
    name: 'BitcoinRegular',
    address: '0x388fd8a5145d6ef85aae14d494f93df9d1c7c00c',
    decimals: 8,
    symbol: 'BTRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4174.png',
  },
  {
    chainId: 1,
    name: 'SkyMap',
    address: '0x7297862b9670ff015192799cc849726c88bf1d77',
    decimals: 18,
    symbol: 'SKYM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4175.png',
  },
  {
    chainId: 1,
    name: 'Dapp Token',
    address: '0x386cabc0b14a507a4e024dea15554342865b20de',
    decimals: 18,
    symbol: 'DAPPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4176.png',
  },
  {
    chainId: 1,
    name: 'CBEX Token',
    address: '0x280daacbd812725baf46e273b84426b1e10ab410',
    decimals: 18,
    symbol: 'CBEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4177.png',
  },
  {
    chainId: 1,
    name: 'Partner',
    address: '0xcaa05e82bdcBA9e25CD1A3Bf1AfB790C1758943d',
    decimals: 8,
    symbol: 'PRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4181.png',
  },
  {
    chainId: 1,
    name: 'GoWithMi',
    address: '0xa110eeebc0751407bdcaea4cd230f04a2b82a33a',
    decimals: 18,
    symbol: 'GMAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4182.png',
  },
  {
    chainId: 1,
    name: 'Binance GBP Stable Coin',
    address: '0xc9a2c4868f0f96faaa739b59934dc9cb304112ec',
    decimals: 8,
    symbol: 'BGBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4186.png',
  },
  {
    chainId: 1,
    name: 'Volume Network',
    address: '0x2e2e0a28f6585e895dd646a363bae29b77b88a31',
    decimals: 18,
    symbol: 'VOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4187.png',
  },
  {
    chainId: 1,
    name: 'Coinchase Token',
    address: '0x40AdFc7c23c22Cc06f94F199a4750D7196F46fbe',
    decimals: 6,
    symbol: 'CCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4188.png',
  },
  {
    chainId: 1,
    name: 'Ultra',
    address: '0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c',
    decimals: 4,
    symbol: 'UOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4189.png',
  },
  {
    chainId: 1,
    name: 'Multicoin',
    address: '0xf6117cc92d7247f605f11d4c942f0feda3399cb5',
    decimals: 18,
    symbol: 'MTCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4190.png',
  },
  {
    chainId: 1,
    name: 'Synternet',
    address: '0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca',
    decimals: 18,
    symbol: 'NOIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4191.png',
  },
  {
    chainId: 1,
    name: 'Populous XBRL Token',
    address: '0xc14830e53aa344e8c14603a91229a0b925b0b262',
    decimals: 8,
    symbol: 'PXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4192.png',
  },
  {
    chainId: 1,
    name: 'Dynamite',
    address: '0x3b7f247f21bf3a07088c2d3423f64233d4b069f7',
    decimals: 2,
    symbol: 'DYNMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4193.png',
  },
  {
    chainId: 1,
    name: 'FTX Token',
    address: '0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9',
    decimals: 18,
    symbol: 'FTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4195.png',
  },
  {
    chainId: 1,
    name: 'Pledge Coin',
    address: '0x85ca6710D0F1D511d130f6935eDDA88ACBD921bD',
    decimals: 18,
    symbol: 'PLG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4196.png',
  },
  {
    chainId: 1,
    name: 'ShareToken',
    address: '0xd98f75b1a3261dab9eed4956c93f33749027a964',
    decimals: 2,
    symbol: 'SHR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4197.png',
  },
  {
    chainId: 1,
    name: 'Swace',
    address: '0x03b155af3f4459193a276395dd76e357bb472da1',
    decimals: 18,
    symbol: 'SWACE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4199.png',
  },
  {
    chainId: 1,
    name: 'Opennity',
    address: '0xa829f97373069ee5d23175e4105df8fd49238be7',
    decimals: 18,
    symbol: 'OPNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4202.png',
  },
  {
    chainId: 1,
    name: 'Oasis City',
    address: '0x24700a297960e8477ce3ca6c58b70a7af3410398',
    decimals: 18,
    symbol: 'OSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4203.png',
  },
  {
    chainId: 1,
    name: 'Xenoverse',
    address: '0xdf2705d4368cd2ee3bbff73594ae47244064dffb',
    decimals: 18,
    symbol: 'XENO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4205.png',
  },
  {
    chainId: 1,
    name: 'Birdchain',
    address: '0x026e62dded1a6ad07d93d39f96b9eabd59665e0d',
    decimals: 18,
    symbol: 'BIRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4207.png',
  },
  {
    chainId: 1,
    name: 'JOOS',
    address: '0x05F9Abf4B0C5661E83B92c056A8791d5CCd7Ca52',
    decimals: 18,
    symbol: 'JOOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4208.png',
  },
  {
    chainId: 1,
    name: 'EURO TOKEN',
    address: '0x7a0e91c4204355e0a6bbf746dc0b7e32dfefdecf',
    decimals: 8,
    symbol: 'SREUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4210.png',
  },
  {
    chainId: 1,
    name: 'Uptrennd',
    address: '0x07597255910a51509ca469568b048f2597e72504',
    decimals: 18,
    symbol: '1UP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4213.png',
  },
  {
    chainId: 1,
    name: 'Agrocoin',
    address: '0x1fd27f0cfc6f273b87a5e0f6fcf063422e7bcd6a',
    decimals: 18,
    symbol: 'AGRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4214.png',
  },
  {
    chainId: 1,
    name: 'Eminer',
    address: '0x35b08722aa26be119c1608029ccbc976ac5c1082',
    decimals: 18,
    symbol: 'EM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4215.png',
  },
  {
    chainId: 1,
    name: 'E-BANK Token',
    address: '0x23aab5e8cdafca91849f0c8fab42500fbdfed9bd',
    decimals: 18,
    symbol: 'EBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4216.png',
  },
  {
    chainId: 1,
    name: 'BOSagora',
    address: '0x746dda2ea243400d5a63e0700f190ab79f06489e',
    decimals: 18,
    symbol: 'BOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4217.png',
  },
  {
    chainId: 1,
    name: 'Ninios',
    address: '0x09a701a2513bc2244af6f2f279f1a53682778d4c',
    decimals: 18,
    symbol: 'NNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4218.png',
  },
  {
    chainId: 1,
    name: 'Parinita Bansode Coin',
    address: '0xad808ba4eb817a968889ec0e93130c4fde8e71b8',
    decimals: 8,
    symbol: 'PBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4219.png',
  },
  {
    chainId: 1,
    name: 'General Attention Currency',
    address: '0xde4c5a791913838027a2185709e98c5c6027ea63',
    decimals: 8,
    symbol: 'XAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4220.png',
  },
  {
    chainId: 1,
    name: 'Petcoin',
    address: '0xd1d3b662d91faaa4a5d809d804fa70550b2b3e9c',
    decimals: 18,
    symbol: 'PETC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4221.png',
  },
  {
    chainId: 1,
    name: '1Million Token',
    address: '0x5467ca08e0a02c54b873aafef216157873bfaffd',
    decimals: 7,
    symbol: '1MT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4222.png',
  },
  {
    chainId: 1,
    name: 'CoinLim Token',
    address: '0xab6257fab118222751b339cc199145b29661ed7c',
    decimals: 8,
    symbol: 'CLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4223.png',
  },
  {
    chainId: 1,
    name: 'Volcanoes',
    address: '0xd5e38d2ef4ad5e38942e6234e2cec0dac38e124a',
    decimals: 18,
    symbol: 'VOLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4226.png',
  },
  {
    chainId: 1,
    name: 'Ferrum Network',
    address: '0xe5caef4af8780e59df925470b050fb23c43ca68c',
    decimals: 18,
    symbol: 'FRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4228.png',
  },
  {
    chainId: 1,
    name: 'Yobit Token',
    address: '0xebf4ca5319f406602eeff68da16261f1216011b5',
    decimals: 18,
    symbol: 'YO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4229.png',
  },
  {
    chainId: 1,
    name: 'JungleToken',
    address: '0x285ce65705d26c28f7a720cf3bfe8b868c82a48f',
    decimals: 18,
    symbol: 'JT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4232.png',
  },
  {
    chainId: 1,
    name: 'Membrana',
    address: '0x4eeea7b48b9c3ac8f70a9c932a8b1e8a5cb624c7',
    decimals: 18,
    symbol: 'MBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4233.png',
  },
  {
    chainId: 1,
    name: 'LORDLESS',
    address: '0x7ca121b093e2fbd4bb9a894bd5ff487d16f1f83b',
    decimals: 18,
    symbol: 'LESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4235.png',
  },
  {
    chainId: 1,
    name: 'Asgard',
    address: '0x7a3d3c4f30c46f51b814bee23d970a7c9b757a32',
    decimals: 18,
    symbol: 'ASG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4236.png',
  },
  {
    chainId: 1,
    name: 'Bitcloud Pro',
    address: '0x197e6bca6bc2f488ec760a6ce46b1399cd2954b0',
    decimals: 8,
    symbol: 'BPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4239.png',
  },
  {
    chainId: 1,
    name: 'Custody Token',
    address: '0xf6abff616043c2da572573dcc583b656297b30e7',
    decimals: 18,
    symbol: 'CUST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4240.png',
  },
  {
    chainId: 1,
    name: 'AORA',
    address: '0x971d42406b8ff73fbedbaacc9e65bf9f37169b98',
    decimals: 18,
    symbol: 'AORA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4241.png',
  },
  {
    chainId: 1,
    name: 'PLANET',
    address: '0x307d45afbb7e84f82ef3d251a6bb0f00edf632e4',
    decimals: 18,
    symbol: 'PLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4242.png',
  },
  {
    chainId: 1,
    name: 'Blockium',
    address: '0x27c743954bce1bfaef8bcbd685527531001d88d7',
    decimals: 18,
    symbol: 'BOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4247.png',
  },
  {
    chainId: 1,
    name: 'ZeuxCoin',
    address: '0x6b4689e4514957699edeb2ee91c947f18e439806',
    decimals: 18,
    symbol: 'ZUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4250.png',
  },
  {
    chainId: 1,
    name: 'DeepCloud AI',
    address: '0x6cbedec4f1ac9d874987d2769596544e0d9161ab',
    decimals: 18,
    symbol: 'DEEP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4251.png',
  },
  {
    chainId: 1,
    name: 'Stellar Classic',
    address: '0x1e66008a24a486456a796e0c771fdc0cdf43cad9',
    decimals: 18,
    symbol: 'XLMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4252.png',
  },
  {
    chainId: 1,
    name: 'CryptoBonusMiles',
    address: '0x95efd1fe6099f65a7ed524def487483221094947',
    decimals: 18,
    symbol: 'CBM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4253.png',
  },
  {
    chainId: 1,
    name: 'CryptoAds Marketplace',
    address: '0x608f006b6813f97097372d0d31fb0f11d1ca3e4e',
    decimals: 18,
    symbol: 'CRAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4255.png',
  },
  {
    chainId: 1,
    name: 'Bitball Treasure',
    address: '0x73c9275c3a2dd84b5741fd59aebf102c91eb033f',
    decimals: 18,
    symbol: 'BTRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4257.png',
  },
  {
    chainId: 1,
    name: 'Aitheon',
    address: '0xd536bbd5414a8c2beed82a63737b9327d2fa35a6',
    decimals: 18,
    symbol: 'ACU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4260.png',
  },
  {
    chainId: 1,
    name: 'UltrAlpha',
    address: '0x01c0987e88f778df6640787226bc96354e1a9766',
    decimals: 18,
    symbol: 'UAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4262.png',
  },
  {
    chainId: 1,
    name: 'BitCanna',
    address: '0xeB5Bea778339e5F0C8D9419cf9891445af823A29',
    decimals: 6,
    symbol: 'BCNA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4263.png',
  },
  {
    chainId: 1,
    name: 'Monarch',
    address: '0x4442556a08a841227bef04c67a7ba7acf01b6fc8',
    decimals: 18,
    symbol: 'MT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4266.png',
  },
  {
    chainId: 1,
    name: 'NewYork Exchange',
    address: '0x6f5e77cea0abdda40013a8ef53639c96972fb745',
    decimals: 18,
    symbol: 'NYE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4268.png',
  },
  {
    chainId: 1,
    name: 'GateToken',
    address: '0xe66747a101bff2dba3697199dcce5b743b454759',
    decimals: 18,
    symbol: 'GT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4269.png',
  },
  {
    chainId: 1,
    name: 'Taklimakan Network',
    address: '0x2c36204a0712a2a50e54a62f7c4f01867e78cb53',
    decimals: 18,
    symbol: 'TAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4272.png',
  },
  {
    chainId: 1,
    name: 'Sessia',
    address: '0xd91a6162f146ef85922d9a15ee6eb14a00344586',
    decimals: 18,
    symbol: 'KICKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4273.png',
  },
  {
    chainId: 1,
    name: 'COMBO',
    address: '0xc03fbf20a586fa89c2a5f6f941458e1fbc40c661',
    decimals: 18,
    symbol: 'COMBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4275.png',
  },
  {
    chainId: 1,
    name: 'Defi',
    address: '0x98b2de885e916b598f65ded2fdbb63187eaef184',
    decimals: 18,
    symbol: 'DEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4276.png',
  },
  {
    chainId: 1,
    name: '12Ships',
    address: '0x525794473f7ab5715c81d06d10f52d11cc052804',
    decimals: 18,
    symbol: 'TSHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4280.png',
  },
  {
    chainId: 1,
    name: 'BHEX Token',
    address: '0xfc29b6e626b67776675fff55d5bc0452d042f434',
    decimals: 18,
    symbol: 'BHC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4281.png',
  },
  {
    chainId: 1,
    name: 'Orom Token',
    address: '0xe3b05c42667de42ca4a4ea1e9682eb590b6a65d1',
    decimals: 18,
    symbol: 'OROM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4282.png',
  },
  {
    chainId: 1,
    name: 'BitForex Token',
    address: '0x5b71bee9d961b1b848f8485eec8d8787f80217f5',
    decimals: 18,
    symbol: 'BF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4283.png',
  },
  {
    chainId: 1,
    name: 'DABANKING',
    address: '0x5e7ebea68ab05198f771d77a875480314f1d0aae',
    decimals: 18,
    symbol: 'DAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4284.png',
  },
  {
    chainId: 1,
    name: 'Lukki Operating Token',
    address: '0x6556d2ec4d96da39cf75cbe50d58fae90079800a',
    decimals: 18,
    symbol: 'LOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4285.png',
  },
  {
    chainId: 1,
    name: 'Jobchain',
    address: '0xdfbc9050f5b01df53512dcc39b4f2b2bbacd517a',
    decimals: 8,
    symbol: 'JOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4287.png',
  },
  {
    chainId: 1,
    name: 'Krypton Galaxy Coin',
    address: '0xa8262eb913fccea4c3f77fc95b8b4043b384cfbb',
    decimals: 18,
    symbol: 'KGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4291.png',
  },
  {
    chainId: 1,
    name: 'PERL.eco',
    address: '0xeca82185adce47f39c684352b0439f030f860318',
    decimals: 18,
    symbol: 'PERL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4293.png',
  },
  {
    chainId: 1,
    name: 'ALLDEX ALLIANCE',
    address: '0xf8ed6c51762208ff26f8f3e4efd4e06af2da649c',
    decimals: 18,
    symbol: 'AXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4295.png',
  },
  {
    chainId: 1,
    name: 'Ladder Network Token',
    address: '0x4129d3b7a6a2c5c997774077ac02bdafd1af1d6a',
    decimals: 18,
    symbol: 'LAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4296.png',
  },
  {
    chainId: 1,
    name: 'Rapidz',
    address: '0x68350d30d9f58c81aaaa41929f1bfc52fff4ea49',
    decimals: 18,
    symbol: 'RPZX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4298.png',
  },
  {
    chainId: 1,
    name: 'Tokoin',
    address: '0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675',
    decimals: 18,
    symbol: 'TOKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4299.png',
  },
  {
    chainId: 1,
    name: 'Vivid Labs',
    address: '0x2c9023bbc572ff8dc1228c7858a280046ea8c9e5',
    decimals: 18,
    symbol: 'VID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4300.png',
  },
  {
    chainId: 1,
    name: "Tutor's Diary",
    address: '0x5e3002dff591c5e75bb9dedae268049742e6b13a',
    decimals: 8,
    symbol: 'TUDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4301.png',
  },
  {
    chainId: 1,
    name: 'UDAP',
    address: '0x5f778ec4b31a506c1dfd8b06f131e9b451a61d39',
    decimals: 18,
    symbol: 'UPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4304.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Platinums',
    address: '0xd26fb114401ec86887cd09f62eccd95fcf20b571',
    decimals: 8,
    symbol: 'BCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4305.png',
  },
  {
    chainId: 1,
    name: 'BSOV Token',
    address: '0x26946ada5ecb57f3a1f91605050ce45c482c9eb1',
    decimals: 18,
    symbol: 'BSOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4306.png',
  },
  {
    chainId: 1,
    name: 'UNICORN Token',
    address: '0x2730d6fdc86c95a74253beffaa8306b40fedecbb',
    decimals: 8,
    symbol: 'UNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4307.png',
  },
  {
    chainId: 1,
    name: 'CrowdSaleNetworkPlatform',
    address: '0x96ee9b27f822d71ae9cbf06773a878b41308c396',
    decimals: 18,
    symbol: 'CSNP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4308.png',
  },
  {
    chainId: 1,
    name: 'CREDITCOIN',
    address: '0x5e51f6841d2f188c42c7c33a6a5e77fb05cfbabe',
    decimals: 2,
    symbol: 'CCOIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4310.png',
  },
  {
    chainId: 1,
    name: 'NoFakeCoin',
    address: '0xb0866289e870d2efc282406cf4123df6e5bcb652',
    decimals: 18,
    symbol: 'NFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4312.png',
  },
  {
    chainId: 1,
    name: 'BCGame',
    address: '0xd24e56f02ee723a443575836b9668587ffd6204f',
    decimals: 18,
    symbol: 'BCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4314.png',
  },
  {
    chainId: 1,
    name: 'Ledgerium',
    address: '0x3c51210c25e2f053ee02ea46ed9a66b587574b58',
    decimals: 8,
    symbol: 'XLG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4316.png',
  },
  {
    chainId: 1,
    name: 'OCP',
    address: '0xadebeafcdcf5de0a5a7f7dfdd467b0e9fb205be9',
    decimals: 18,
    symbol: 'OCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4318.png',
  },
  {
    chainId: 1,
    name: 'AgroTechFarm',
    address: '0x014e42ae89b24738591e2f695e1ef6d95bd38619',
    decimals: 18,
    symbol: 'ATF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4319.png',
  },
  {
    chainId: 1,
    name: 'SwagChain',
    address: '0x7040a8245eea5dc0af3c43264167a02d939303eb',
    decimals: 18,
    symbol: 'SWAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4321.png',
  },
  {
    chainId: 1,
    name: 'Gold',
    address: '0xe081b71ed098fbe1108ea48e235b74f122272e68',
    decimals: 8,
    symbol: 'GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4322.png',
  },
  {
    chainId: 1,
    name: 'Bitscoin',
    address: '0x9388f54fa978aa9e24395a8b69033304eccea4df',
    decimals: 4,
    symbol: 'BTCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4325.png',
  },
  {
    chainId: 1,
    name: 'Treasure Financial Coin',
    address: '0x8694ee05b45c9fe1058ce532de8dbcf1d84a4154',
    decimals: 5,
    symbol: 'TFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4326.png',
  },
  {
    chainId: 1,
    name: 'SLT',
    address: '0xe9f3cb0229eb8d0aaf03ec84883950134ed20ddc',
    decimals: 8,
    symbol: 'SLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4327.png',
  },
  {
    chainId: 1,
    name: 'IMPERIVMCoin',
    address: '0x1d2aee5eaf5e4352965b710293513a5ad99796ff',
    decimals: 6,
    symbol: 'IMPCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4333.png',
  },
  {
    chainId: 1,
    name: 'CreaEther',
    address: '0x3d166dd13dfdca66879bdd45dc224d07c8855cdb',
    decimals: 18,
    symbol: 'CETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4338.png',
  },
  {
    chainId: 1,
    name: 'RusGas Infinity',
    address: '0xe7c0c266d9794498a426db063934c00fa374367e',
    decimals: 8,
    symbol: 'RGSI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4346.png',
  },
  {
    chainId: 1,
    name: 'EpinToken',
    address: '0xa91ff20bd37d9275498aa468351c14ff2c290a99',
    decimals: 8,
    symbol: 'EPTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4348.png',
  },
  {
    chainId: 1,
    name: 'Ethereum wizard',
    address: '0xfbd86312f156b0cc976e558b62da068bbafcaf9c',
    decimals: 12,
    symbol: 'ETHW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4349.png',
  },
  {
    chainId: 1,
    name: 'ENECT',
    address: '0x27ce70a584c085712cd42f20181237178ddc5a45',
    decimals: 18,
    symbol: 'ENC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4350.png',
  },
  {
    chainId: 1,
    name: 'GoDigit',
    address: '0x1d0582fa759e4b9beab4f6f82cc539ac62c49250',
    decimals: 18,
    symbol: 'GIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4351.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Money',
    address: '0xbf4a2ddaa16148a9d0fa2093ffac450adb7cd4aa',
    decimals: 2,
    symbol: 'ETHMNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4356.png',
  },
  {
    chainId: 1,
    name: 'Twogap',
    address: '0xf96aa656ec0e0ac163590db372b430cf3c0d61ca',
    decimals: 18,
    symbol: 'TGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4358.png',
  },
  {
    chainId: 1,
    name: 'Aeryus',
    address: '0xac4d22e40bf0b8ef4750a99ed4e935b99a42685e',
    decimals: 18,
    symbol: 'AER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4359.png',
  },
  {
    chainId: 1,
    name: 'FABRK',
    address: '0x12683dc9eec95a5f742d40206e73319e6b9d8a91',
    decimals: 18,
    symbol: 'FAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4360.png',
  },
  {
    chainId: 1,
    name: 'Bitpanda Ecosystem Token',
    address: '0x1b073382e63411e3bcffe90ac1b9a43fefa1ec6f',
    decimals: 18,
    symbol: 'BEST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4361.png',
  },
  {
    chainId: 1,
    name: 'Shuffle Monster',
    address: '0x3a9fff453d50d4ac52a6890647b823379ba36b9e',
    decimals: 18,
    symbol: 'SHUF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4362.png',
  },
  {
    chainId: 1,
    name: 'TokenWiz',
    address: '0x3685ee91777e3ed4ba4122c429c504df833c3b26',
    decimals: 8,
    symbol: 'BZH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4363.png',
  },
  {
    chainId: 1,
    name: 'MixMarvel',
    address: '0x5d285f735998f36631f678ff41fb56a10a4d0429',
    decimals: 18,
    symbol: 'MIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4366.png',
  },
  {
    chainId: 1,
    name: 'ExtremeBTC',
    address: '0x30f5919849514be54d11941e90cc529099267f02',
    decimals: 19,
    symbol: 'EBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4368.png',
  },
  {
    chainId: 1,
    name: 'concertVR-Token',
    address: '0x24b47299e756af0571f512232a3629e0dabb52ed',
    decimals: 18,
    symbol: 'CVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4370.png',
  },
  {
    chainId: 1,
    name: 'Reality Clash Coin',
    address: '0x9b6443b0fb9c241a7fdac375595cea13e6b7807a',
    decimals: 18,
    symbol: 'RCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4371.png',
  },
  {
    chainId: 1,
    name: 'PITSTOP',
    address: '0xa44fb3aa5c8465512b806145a8f9b60e74f3f851',
    decimals: 18,
    symbol: 'PIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4373.png',
  },
  {
    chainId: 1,
    name: 'Raisex Token',
    address: '0x7d34c87c34a12f80912c452c528dbd24d8520e69',
    decimals: 18,
    symbol: 'RSX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4375.png',
  },
  {
    chainId: 1,
    name: 'CONNECT',
    address: '0x54a9ed327f2614316914c3f3a782a77d0aa47aee',
    decimals: 18,
    symbol: 'CNCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4377.png',
  },
  {
    chainId: 1,
    name: 'Blockchain Poland',
    address: '0x72e203a17add19a3099137c9d7015fd3e2b7dba9',
    decimals: 18,
    symbol: 'BCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4378.png',
  },
  {
    chainId: 1,
    name: 'Forte Coin',
    address: '0xd9a1fe8b4d6de4f41c8a1b6ad3b6457916e546b4',
    decimals: 18,
    symbol: 'FOTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4390.png',
  },
  {
    chainId: 1,
    name: 'Arorex',
    address: '0x156969d609b7811ecae26b656218ef03734ad946',
    decimals: 18,
    symbol: 'ARXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4396.png',
  },
  {
    chainId: 1,
    name: 'Korbot',
    address: '0xcd64aa18ddbce84411adbfe6da49354ba5187a45',
    decimals: 8,
    symbol: 'KBOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4404.png',
  },
  {
    chainId: 1,
    name: 'BITIFEX',
    address: '0xa0ed4c4acbf07c03365d6bbe28150a819aff700f',
    decimals: 18,
    symbol: 'BITX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4405.png',
  },
  {
    chainId: 1,
    name: 'ClapClap Token',
    address: '0x0f00c8dd21da51bc6a6ac07f491a7dbe69746f16',
    decimals: 18,
    symbol: 'CCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4408.png',
  },
  {
    chainId: 1,
    name: 'TenUp',
    address: '0x7714f320Adca62B149df2579361AfEC729c5FE6A',
    decimals: 18,
    symbol: 'TUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4411.png',
  },
  {
    chainId: 1,
    name: 'Genesis Token',
    address: '0x0f767338244418310342d49b02183715691d988f',
    decimals: 18,
    symbol: 'GENT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4412.png',
  },
  {
    chainId: 1,
    name: 'TurkeyEnergyToken',
    address: '0x347a39127ae0730817b0caf177c4684e16a038fc',
    decimals: 8,
    symbol: 'XTLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4413.png',
  },
  {
    chainId: 1,
    name: 'Game Fanz',
    address: '0x3930e4ddb4d24ef2f4cb54c1f009a3694b708428',
    decimals: 8,
    symbol: 'GFN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4416.png',
  },
  {
    chainId: 1,
    name: 'Vey',
    address: '0x70a63225bcadacc4430919f0c1a4f0f5fcffbaac',
    decimals: 4,
    symbol: 'VEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4419.png',
  },
  {
    chainId: 1,
    name: 'ejob',
    address: '0x4ca811010053a3d1bc643eadbf5c91c4f896b06b',
    decimals: 18,
    symbol: 'EJOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4420.png',
  },
  {
    chainId: 1,
    name: 'Bitre Mining',
    address: '0x956cdac781389d259de92e427ecd86e1cc273f7f',
    decimals: 8,
    symbol: 'BTGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4426.png',
  },
  {
    chainId: 1,
    name: 'COMET14',
    address: '0x4cee978c126c43522765de9ed02d9373c72ac290',
    decimals: 18,
    symbol: 'COMET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4429.png',
  },
  {
    chainId: 1,
    name: 'VNX',
    address: '0x00fc270c9cc13e878ab5363d00354bebf6f05c15',
    decimals: 18,
    symbol: 'VNXLU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4430.png',
  },
  {
    chainId: 1,
    name: 'VIDY',
    address: '0xc77b230f31b517f1ef362e59c173c2be6540b5e8',
    decimals: 18,
    symbol: 'VIDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4431.png',
  },
  {
    chainId: 1,
    name: 'AgentNotNeeded',
    address: '0xe0e73e8fc3a0fa161695be1d75e1bc3e558957c4',
    decimals: 18,
    symbol: 'ANN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4433.png',
  },
  {
    chainId: 1,
    name: 'STARS',
    address: '0x33227687626914030c8213e31d021ce9940728ea',
    decimals: 8,
    symbol: 'STRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4436.png',
  },
  {
    chainId: 1,
    name: 'Kripton',
    address: '0x2cc71c048a804da930e28e93f3211dc03c702995',
    decimals: 18,
    symbol: 'LPK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4439.png',
  },
  {
    chainId: 1,
    name: 'Vectorspace AI',
    address: '0x7D29A64504629172a429e64183D6673b9dAcbFCe',
    decimals: 18,
    symbol: 'VXV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4441.png',
  },
  {
    chainId: 1,
    name: 'Bitcar',
    address: '0x08b4c866ae9d1be56a06e0c302054b4ffe067b43',
    decimals: 8,
    symbol: 'BITCAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4447.png',
  },
  {
    chainId: 1,
    name: 'Erosion',
    address: '0x0218c4e3aad7ecf71ccc5d5aaa43c02245f45ccd',
    decimals: 18,
    symbol: 'EROS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4450.png',
  },
  {
    chainId: 1,
    name: 'BidiPass',
    address: '0x593114f03a0a575aece9ed675e52ed68d2172b8c',
    decimals: 18,
    symbol: 'BDP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4452.png',
  },
  {
    chainId: 1,
    name: 'Grabity',
    address: '0xcbd49182346421d3b410b04aeb1789346da6ce43',
    decimals: 18,
    symbol: 'GBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4454.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Cash Pro',
    address: '0x945f171de4ea81a213dcc7a1e8c4f6feb3b4b806',
    decimals: 18,
    symbol: 'ECP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4456.png',
  },
  {
    chainId: 1,
    name: 'Zethereum',
    address: '0xd55e5ea9e6c055708ec01c881cb12907d33b21d4',
    decimals: 18,
    symbol: 'ZETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4458.png',
  },
  {
    chainId: 1,
    name: 'Wemark Token',
    address: '0xbfbe5332f172d77811bc6c272844f3e54a7b23bb',
    decimals: 18,
    symbol: 'WMK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4461.png',
  },
  {
    chainId: 1,
    name: 'Wibcoin',
    address: '0x195a179bbfe539bb8a485d944ac60d3a0329f0ec',
    decimals: 18,
    symbol: 'WBBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4462.png',
  },
  {
    chainId: 1,
    name: 'Kingcuan',
    address: '0xedf44412b47a76e452fd133794e45d9485e4cd4b',
    decimals: 18,
    symbol: 'CUAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4463.png',
  },
  {
    chainId: 1,
    name: 'Enkronos',
    address: '0x92b914f1ddcbb1d117a718e83c9ed7eb32fc44d1',
    decimals: 18,
    symbol: 'ENK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4464.png',
  },
  {
    chainId: 1,
    name: 'Ormeus Ecosystem',
    address: '0x191557728e4d8caa4ac94f86af842148c0fa8f7e',
    decimals: 8,
    symbol: 'ECO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4466.png',
  },
  {
    chainId: 1,
    name: 'Nestree',
    address: '0x65ccd72c0813ce6f2703593b633202a0f3ca6a0c',
    decimals: 18,
    symbol: 'EGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4467.png',
  },
  {
    chainId: 1,
    name: 'ADAB',
    address: '0x034b0dd380b5f6f8123b8d0d0e42329b67772792',
    decimals: 18,
    symbol: 'ADAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4468.png',
  },
  {
    chainId: 1,
    name: 'MineBee',
    address: '0x8d8129963291740dddd917ab01af18c7aed4ba58',
    decimals: 18,
    symbol: 'MB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4469.png',
  },
  {
    chainId: 1,
    name: 'Netkoin Liquid',
    address: '0xac2385e183d9301dd5e2bb08da932cbf9800dc9c',
    decimals: 18,
    symbol: 'LIQUID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4470.png',
  },
  {
    chainId: 1,
    name: 'AlphabetX',
    address: '0x11fb25cccc8f25ff993e802f506b530d20e65e12',
    decimals: 18,
    symbol: 'ALP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4471.png',
  },
  {
    chainId: 1,
    name: 'Zayka Token',
    address: '0xffb5531e6a916d228958016441146299ab5eddd0',
    decimals: 18,
    symbol: 'ZAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4472.png',
  },
  {
    chainId: 1,
    name: 'FIC',
    address: '0x0dd83b5013b2ad7094b1a7783d96ae0168f82621',
    decimals: 18,
    symbol: 'FIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4475.png',
  },
  {
    chainId: 1,
    name: 'Muxe',
    address: '0x515669d308f887fd83a471c7764f5d084886d34d',
    decimals: 18,
    symbol: 'MUXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4476.png',
  },
  {
    chainId: 1,
    name: 'GEIMCOIN',
    address: '0x2e9ef342f50a10e87ddad06d0fc6d3f0223726c9',
    decimals: 18,
    symbol: 'GMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4477.png',
  },
  {
    chainId: 1,
    name: 'RiseCoin Token',
    address: '0xc275865a6cce78398e94cb2af29fa0d787b7f7eb',
    decimals: 18,
    symbol: 'RSCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4478.png',
  },
  {
    chainId: 1,
    name: 'GemVault Coin',
    address: '0xa57392548087453dec6106e670bbfb849276b358',
    decimals: 8,
    symbol: 'GVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4479.png',
  },
  {
    chainId: 1,
    name: 'FingerPrint',
    address: '0xd9a8cfe21c232d485065cb62a96866799d4645f7',
    decimals: 18,
    symbol: 'FGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4480.png',
  },
  {
    chainId: 1,
    name: 'UZURAS',
    address: '0x66e5d4063219a54a8244078affb49e23982d9640',
    decimals: 8,
    symbol: 'UZZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4483.png',
  },
  {
    chainId: 1,
    name: 'Skraps',
    address: '0xfdfe8b7ab6cf1bd1e3d14538ef40686296c42052',
    decimals: 18,
    symbol: 'SKRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4486.png',
  },
  {
    chainId: 1,
    name: 'Green Coin',
    address: '0x091094d324005054e49608d2d29069eb9cb6c7a2',
    decimals: 18,
    symbol: 'GREC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4489.png',
  },
  {
    chainId: 1,
    name: 'Emirex Token',
    address: '0xbdbC2a5B32F3a5141ACd18C39883066E4daB9774',
    decimals: 8,
    symbol: 'EMRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4490.png',
  },
  {
    chainId: 1,
    name: 'Amino Network',
    address: '0x2e68dfb3f50ea302c88f8db74096d57565d9970a',
    decimals: 18,
    symbol: 'AMIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4493.png',
  },
  {
    chainId: 1,
    name: 'NSS Coin',
    address: '0x4e3bddd468abfc6c88bc25daa5d894380ced5bc8',
    decimals: 18,
    symbol: 'NSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4494.png',
  },
  {
    chainId: 1,
    name: 'xCrypt Token',
    address: '0xd2bb16cf38ca086cab5128d5c25de9477ebd596b',
    decimals: 18,
    symbol: 'XCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4496.png',
  },
  {
    chainId: 1,
    name: 'Xevenue Shares',
    address: '0xf4bbd1f932bda87c24fe13a50912a13b06ed2601',
    decimals: 18,
    symbol: 'XEV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4498.png',
  },
  {
    chainId: 1,
    name: 'ESCB',
    address: '0x5e365a320779acc2c72f5dcd2ba8a81e4a34569f',
    decimals: 18,
    symbol: 'ESCB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4499.png',
  },
  {
    chainId: 1,
    name: 'Cryptlo',
    address: '0xe4707dac5f8a942f98b2181129346ef37d075a69',
    decimals: 18,
    symbol: 'CLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4503.png',
  },
  {
    chainId: 1,
    name: 'Midas',
    address: '0x97e6e31afb2d93d437301e006d9da714616766a5',
    decimals: 18,
    symbol: 'MIDAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4505.png',
  },
  {
    chainId: 1,
    name: 'Hotbit Token',
    address: '0x6be61833fc4381990e82d7d4a9f4c9b3f67ea941',
    decimals: 18,
    symbol: 'HTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4506.png',
  },
  {
    chainId: 1,
    name: 'Voltz',
    address: '0x60715e436c37444e29772c0d26a98ae1e8e1a989',
    decimals: 18,
    symbol: 'VOLTZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4508.png',
  },
  {
    chainId: 1,
    name: 'Tranium',
    address: '0xbffe4fdcd397e7942fd7c9f99255e0aa34e4b3fb',
    decimals: 8,
    symbol: 'TRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4509.png',
  },
  {
    chainId: 1,
    name: 'Tether CNHt',
    address: '0x6e109e9dd7fa1a58bc3eff667e8e41fc3cc07aef',
    decimals: 6,
    symbol: 'CNHt',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4513.png',
  },
  {
    chainId: 1,
    name: 'Fructus',
    address: '0x5f5f8a9c9775499b783171ac1979b4327ab60447',
    decimals: 18,
    symbol: 'XFRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4516.png',
  },
  {
    chainId: 1,
    name: 'WooshCoin',
    address: '0xb5351d809062cf8e2238bbd2c54af905fb55e42d',
    decimals: 18,
    symbol: 'XWO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4517.png',
  },
  {
    chainId: 1,
    name: 'Pindex',
    address: '0xc50948bac01116f246259070ea6084c04649efdf',
    decimals: 6,
    symbol: 'PDI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4519.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Vulnerability Platform',
    address: '0x8e30ea2329d95802fd804f4291220b0e2f579812',
    decimals: 18,
    symbol: 'DVP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4520.png',
  },
  {
    chainId: 1,
    name: 'Bitsrent',
    address: '0x945192524c6605d20be6c529dd318666b74078bc',
    decimals: 18,
    symbol: 'BTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4521.png',
  },
  {
    chainId: 1,
    name: 'BITCOINSVGOLD',
    address: '0x8013d06a86f341afab95f82f6487e44c4dc0c655',
    decimals: 18,
    symbol: 'BSVG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4526.png',
  },
  {
    chainId: 1,
    name: 'GOLD RUBLE',
    address: '0x9f9efdd09e915c1950c5ca7252fa5c4f65ab049b',
    decimals: 18,
    symbol: 'GRUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4527.png',
  },
  {
    chainId: 1,
    name: 'ALPAGO',
    address: '0x4ed25d8577feb83946b1548998fb7b157ead8bb9',
    decimals: 18,
    symbol: 'APG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4528.png',
  },
  {
    chainId: 1,
    name: 'Tercet Network',
    address: '0x28d7f432d24ba6020d1cbd4f28bedc5a82f24320',
    decimals: 18,
    symbol: 'TCNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4529.png',
  },
  {
    chainId: 1,
    name: 'HavEtherToken',
    address: '0xf0998faebc12188172310403814e0399f7af3f73',
    decimals: 18,
    symbol: 'HET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4532.png',
  },
  {
    chainId: 1,
    name: 'BITTO',
    address: '0x55a290f08bb4cae8dcf1ea5635a3fcfd4da60456',
    decimals: 18,
    symbol: 'BITTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4534.png',
  },
  {
    chainId: 1,
    name: 'ARROUND',
    address: '0xcb089b8ae76b5df461d40e957603f7a59aea9e0d',
    decimals: 18,
    symbol: 'ARR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4535.png',
  },
  {
    chainId: 1,
    name: 'DEFLAT COIN',
    address: '0xe1e0db951844e7fb727574d7daca68d1c5d1525b',
    decimals: 18,
    symbol: 'DEFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4536.png',
  },
  {
    chainId: 1,
    name: 'VertexMarket',
    address: '0x0cdcda4e7fcdd461ba82b61cbc4163e1022f22e4',
    decimals: 5,
    symbol: 'VTEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4537.png',
  },
  {
    chainId: 1,
    name: 'Pitch',
    address: '0x87f56ee356b434187105b40f96b230f5283c0ab4',
    decimals: 9,
    symbol: 'PITCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4539.png',
  },
  {
    chainId: 1,
    name: 'WCX',
    address: '0x282ee54f8ecda53d6bb77df4a4134738375a0664',
    decimals: 18,
    symbol: 'XT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4541.png',
  },
  {
    chainId: 1,
    name: 'EverySave',
    address: '0xa14516ff788338f34db1a591497a616e3a759e23',
    decimals: 8,
    symbol: 'EVS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4550.png',
  },
  {
    chainId: 1,
    name: 'Cybergame',
    address: '0xea5eb17d519a9165fd2d7e024d83856f314958d1',
    decimals: 18,
    symbol: 'CYBG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4551.png',
  },
  {
    chainId: 1,
    name: 'Aircoins',
    address: '0x8cb1d155a5a1d5d667611b7710920fD9D1CD727F',
    decimals: 8,
    symbol: 'AIRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4552.png',
  },
  {
    chainId: 1,
    name: 'TVT',
    address: '0x98e0438d3ee1404fea48e38e92853bb08cfa68bd',
    decimals: 8,
    symbol: 'TVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4553.png',
  },
  {
    chainId: 1,
    name: 'Poker.io',
    address: '0xbc8deee89f1cf4b661514185aa1ab780336c4c4a',
    decimals: 18,
    symbol: 'POK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4556.png',
  },
  {
    chainId: 1,
    name: 'Flow',
    address: '0x5c147e74D63B1D31AA3Fd78Eb229B65161983B2b',
    decimals: 18,
    symbol: 'FLOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4558.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Galaxy',
    address: '0xcde3ef6cacf84ad36d8a6eccc964f25351296d36',
    decimals: 8,
    symbol: 'BTCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4559.png',
  },
  {
    chainId: 1,
    name: 'Tchain',
    address: '0x59c337ef937d0ba9cb1cc47d4e6ded632d22d623',
    decimals: 18,
    symbol: 'TCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4560.png',
  },
  {
    chainId: 1,
    name: 'JMTIME',
    address: '0xda022ca91df99413e8cb0caab4d1cba4e9018bea',
    decimals: 18,
    symbol: 'JMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4561.png',
  },
  {
    chainId: 1,
    name: 'UOS Network',
    address: '0x430bd07726423A54f6d82Ab0F578CE62A3b8054D',
    decimals: 4,
    symbol: 'UOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4563.png',
  },
  {
    chainId: 1,
    name: 'Oath Protocol',
    address: '0x19c9872640ec38c2cf36c0f04d1365ef067869b3',
    decimals: 18,
    symbol: 'OATH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4567.png',
  },
  {
    chainId: 1,
    name: 'JFIN Coin',
    address: '0x940bdcb99a0ee5fb008a606778ae87ed9789f257',
    decimals: 18,
    symbol: 'JFIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4568.png',
  },
  {
    chainId: 1,
    name: 'MularPay',
    address: '0x4a48a334906f1a323628ee3eec33e8cce7bd2cfc',
    decimals: 18,
    symbol: 'MP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4570.png',
  },
  {
    chainId: 1,
    name: 'TrueVND',
    address: '0x3dc0501c32bee0cc1e629d590302a4b909797474',
    decimals: 18,
    symbol: 'TVND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4573.png',
  },
  {
    chainId: 1,
    name: 'HARON',
    address: '0xf000ca9fbb684bfa2f5f8b36fdf222970fc93763',
    decimals: 8,
    symbol: 'HARON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4574.png',
  },
  {
    chainId: 1,
    name: 'Swiftlance',
    address: '0x8cd480260a47f04589670a313d27a15b321ad266',
    decimals: 8,
    symbol: 'SWL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4576.png',
  },
  {
    chainId: 1,
    name: 'LunchMoney',
    address: '0x66fd97a78d8854fec445cd1c80a07896b0b4851f',
    decimals: 18,
    symbol: 'LMY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4577.png',
  },
  {
    chainId: 1,
    name: 'X-Reis',
    address: '0x5f12f33d0a36fd369e4fffae3d82eff9160013ce',
    decimals: 8,
    symbol: 'XRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4578.png',
  },
  {
    chainId: 1,
    name: 'Prove Token',
    address: '0x95db29acce0db3d3c9b0a1772ec13bd13138cf3f',
    decimals: 18,
    symbol: 'PROVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4579.png',
  },
  {
    chainId: 1,
    name: 'Demetracoin',
    address: '0x229d1ed07310a9aaaf7bda570825b0c4089b88ad',
    decimals: 18,
    symbol: 'DEMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4582.png',
  },
  {
    chainId: 1,
    name: 'TITAM',
    address: '0x557722700d3919d774981fce950af909481ac3ac',
    decimals: 3,
    symbol: 'TITAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4583.png',
  },
  {
    chainId: 1,
    name: 'Lirasis TRY',
    address: '0x005f977f633d1c23748294671b0e69f3512e6702',
    decimals: 2,
    symbol: 'TRYL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4585.png',
  },
  {
    chainId: 1,
    name: 'ProBit Token',
    address: '0xfb559ce67ff522ec0b9ba7f5dc9dc7ef6c139803',
    decimals: 18,
    symbol: 'PROB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4586.png',
  },
  {
    chainId: 1,
    name: 'SWYFT',
    address: '0xA1248c718d52752b2cC257eeb0eBa900408dAeB8',
    decimals: 18,
    symbol: 'SWYFTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4588.png',
  },
  {
    chainId: 1,
    name: 'STK Coin',
    address: '0x5c5887e55bbe41472acdba5fae989788c6f7ab59',
    decimals: 18,
    symbol: 'STK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4595.png',
  },
  {
    chainId: 1,
    name: 'Cryptyk Token',
    address: '0x42a501903afaa1086b5975773375c80e363f4063',
    decimals: 8,
    symbol: 'CTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4596.png',
  },
  {
    chainId: 1,
    name: 'ONEPAY',
    address: '0xb2458f815aa3d0279f2bc456b7db95b13dfa5ed4',
    decimals: 18,
    symbol: 'ONEPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4597.png',
  },
  {
    chainId: 1,
    name: 'Acash Coin',
    address: '0x63d958d765f5bd88efdbd8afd32445393b24907f',
    decimals: 8,
    symbol: 'ACA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4598.png',
  },
  {
    chainId: 1,
    name: 'Japan Brand Coin',
    address: '0x3635e381c67252405c1c0e550973155832d5e490',
    decimals: 18,
    symbol: 'JBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4599.png',
  },
  {
    chainId: 1,
    name: 'AMCBLUE',
    address: '0xd6c7576b735def0d8ea12d6a21332d8c37fc0fbb',
    decimals: 18,
    symbol: 'AMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4601.png',
  },
  {
    chainId: 1,
    name: 'AIMS',
    address: '0x9a1c7577a69ea9e296ef99bfb0eb6bedbe352a36',
    decimals: 8,
    symbol: 'AIMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4602.png',
  },
  {
    chainId: 1,
    name: 'Eastar',
    address: '0x5f63e1b59a164a119e673ad4186f521cc44594c2',
    decimals: 8,
    symbol: 'ETR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4603.png',
  },
  {
    chainId: 1,
    name: 'Bitcratic',
    address: '0x9ec251401eafb7e98f37a1d911c0aea02cb63a80',
    decimals: 18,
    symbol: 'BCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4608.png',
  },
  {
    chainId: 1,
    name: 'IGFToken',
    address: '0xa261e1facd9e90233dc08f785c2b1fb1691024ba',
    decimals: 8,
    symbol: 'IGF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4610.png',
  },
  {
    chainId: 1,
    name: 'BitpakcoinToken',
    address: '0xdf22da9a8c1d80095175ae601d182a734923f01a',
    decimals: 8,
    symbol: 'BPAKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4611.png',
  },
  {
    chainId: 1,
    name: 'Pahoo',
    address: '0x9954ff0295443c01f562dccb1f893be464e01986',
    decimals: 18,
    symbol: 'PAHOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4614.png',
  },
  {
    chainId: 1,
    name: 'TOP.ONE COIN',
    address: '0x0e6bb94b7f25b96f13e0baf5bc04b8ba39b897a8',
    decimals: 18,
    symbol: 'TOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4615.png',
  },
  {
    chainId: 1,
    name: 'FaithCoin',
    address: '0xe531642e9bb5d027e9c20e03284287b97919a9a5',
    decimals: 8,
    symbol: 'FAITH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4617.png',
  },
  {
    chainId: 1,
    name: 'CYBR Token',
    address: '0xaeaabb69dcb0fe926b1979f0b032fcd17fd7b2e0',
    decimals: 18,
    symbol: 'CYBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4620.png',
  },
  {
    chainId: 1,
    name: 'dForce USDx',
    address: '0xeb269732ab75a6fd61ea60b06fe994cd32a83549',
    decimals: 18,
    symbol: 'USDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4621.png',
  },
  {
    chainId: 1,
    name: 'VITA',
    address: '0xb2d8e647ee55cc58a2b408e38f433238498853da',
    decimals: 18,
    symbol: 'VITA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4622.png',
  },
  {
    chainId: 1,
    name: 'Gomics',
    address: '0xb8c6ad2586bb71d518c2aaf510efe91f82022f58',
    decimals: 18,
    symbol: 'GOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4623.png',
  },
  {
    chainId: 1,
    name: 'LOTEU',
    address: '0xf8a3dc13b7a8da473f80660f513c4343e4edd7f7',
    decimals: 8,
    symbol: 'LOTEU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4624.png',
  },
  {
    chainId: 1,
    name: 'Trent',
    address: '0x38f22479795a1A51Ccd1E5A41F09C7525fb27318',
    decimals: 15,
    symbol: 'TTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4625.png',
  },
  {
    chainId: 1,
    name: 'Smathium',
    address: '0x4b4787aace23eb70da046bcc0ccfe28d4e4fb899',
    decimals: 18,
    symbol: 'SMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4627.png',
  },
  {
    chainId: 1,
    name: 'CannDollar',
    address: '0xf43401ea8ac4b86155b929e1a5a5e46626c23842',
    decimals: 18,
    symbol: 'CDAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4628.png',
  },
  {
    chainId: 1,
    name: 'Blockchain.io',
    address: '0xcdc412f306e0c51e3249b88c65423cd16b322673',
    decimals: 18,
    symbol: 'BCIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4631.png',
  },
  {
    chainId: 1,
    name: 'Bankcoin Cash',
    address: '0xc88be04c809856b75e3dfe19eb4dcf0a3b15317a',
    decimals: 8,
    symbol: 'BKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4632.png',
  },
  {
    chainId: 1,
    name: 'CryptoBossCoin',
    address: '0x790bfacae71576107c068f494c8a6302aea640cb',
    decimals: 18,
    symbol: 'CBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4633.png',
  },
  {
    chainId: 1,
    name: 'AERUM',
    address: '0xa249f0e9a464b9685f66992f41e1012388e39e81',
    decimals: 18,
    symbol: 'XRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4634.png',
  },
  {
    chainId: 1,
    name: 'Midex token',
    address: '0xeb72f169016fec42b63ae5e87207f0fb274408c7',
    decimals: 18,
    symbol: 'MDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4636.png',
  },
  {
    chainId: 1,
    name: 'OmnesCoin',
    address: '0xc29004ab38334dc7a9eca1b89d6d4bf9f564d5cf',
    decimals: 18,
    symbol: 'OMNES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4638.png',
  },
  {
    chainId: 1,
    name: 'Robot Trading',
    address: '0x003ffefefbc4a6f34a62a3ca7b7937a880065bcb',
    decimals: 18,
    symbol: 'RTD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4639.png',
  },
  {
    chainId: 1,
    name: 'BGX',
    address: '0xbf3f09e4eba5f7805e5fac0ee09fd6ee8eebe4cb',
    decimals: 18,
    symbol: 'BGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4641.png',
  },
  {
    chainId: 1,
    name: 'Poseidon Network',
    address: '0x2822f6D1B2f41F93f33d937bc7d84A8Dfa4f4C21',
    decimals: 18,
    symbol: 'QQQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4644.png',
  },
  {
    chainId: 1,
    name: 'Carnomic',
    address: '0x2e0c40beb655a988e087ad71ca191a2806ac55ef',
    decimals: 18,
    symbol: 'CARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4645.png',
  },
  {
    chainId: 1,
    name: 'Beaxy',
    address: '0x827d53c8170af52625f414bde00326fc8a085e86',
    decimals: 18,
    symbol: 'BXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4646.png',
  },
  {
    chainId: 1,
    name: 'PUBLISH',
    address: '0x777fd20c983d6658c1d50b3958b3a1733d1cd1e1',
    decimals: 18,
    symbol: 'NEWS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4647.png',
  },
  {
    chainId: 1,
    name: 'Projecton',
    address: '0x13df4d4521a09f45554475bb086c099e3732cb99',
    decimals: 18,
    symbol: 'XN35',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4649.png',
  },
  {
    chainId: 1,
    name: 'DONOCLE',
    address: '0xe5e744eb231f85ed330bce49522cdd6e2f5d5b83',
    decimals: 18,
    symbol: 'DNKL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4652.png',
  },
  {
    chainId: 1,
    name: 'Saturn',
    address: '0x0d9e614937a308438337a2999acf64fc86bf098a',
    decimals: 18,
    symbol: 'XSAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4654.png',
  },
  {
    chainId: 1,
    name: 'Cryptool',
    address: '0x84CD9d75Af2786d20504FB50bDE9F2c2339390B3',
    decimals: 18,
    symbol: 'TOOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4655.png',
  },
  {
    chainId: 1,
    name: 'BioCrypt',
    address: '0xf18432ef894ef4b2a5726f933718f5a8cf9ff831',
    decimals: 8,
    symbol: 'BIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4657.png',
  },
  {
    chainId: 1,
    name: 'Telos',
    address: '0x7825e833d495f3d1c28872415a4aee339d26ac88',
    decimals: 18,
    symbol: 'TLOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png',
  },
  {
    chainId: 1,
    name: 'RCCCToken',
    address: '0x33bfd20660eeaf952e8d5bc3236e1918701f17d0',
    decimals: 18,
    symbol: 'RCCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4664.png',
  },
  {
    chainId: 1,
    name: 'RealAssetChain ',
    address: '0x5b86b0d1c304c246282dea0e0f21db2baa429b31',
    decimals: 8,
    symbol: 'RAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4665.png',
  },
  {
    chainId: 1,
    name: 'BitRabbit-Coin',
    address: '0x61d24aabb3e5e800d8f3d3d43dcbd66ae6cab51e',
    decimals: 18,
    symbol: 'BRB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4667.png',
  },
  {
    chainId: 1,
    name: 'Regium',
    address: '0x9996a0b4d0d7ed1b7e41ad08bdc4acb198e232a9',
    decimals: 18,
    symbol: 'REGI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4669.png',
  },
  {
    chainId: 1,
    name: 'Poverty Eradication Coin',
    address: '0x432bf73443909c33b545efed536a5246c9a722ca',
    decimals: 18,
    symbol: 'PEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4671.png',
  },
  {
    chainId: 1,
    name: "King's Global Token",
    address: '0xfda1f5278b9aa923b5e581565d599810c78c71f5',
    decimals: 18,
    symbol: 'KSG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4673.png',
  },
  {
    chainId: 1,
    name: 'Whole Network',
    address: '0x0c3ef32f802967db75b9d49fe1e76620151ccb81',
    decimals: 5,
    symbol: 'NODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4674.png',
  },
  {
    chainId: 1,
    name: 'MEXC Token',
    address: '0x7de2d123042994737105802d2abd0a10a7bde276',
    decimals: 18,
    symbol: 'MEXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4676.png',
  },
  {
    chainId: 1,
    name: 'Tepleton',
    address: '0x2e65e12b5f0fd1d58738c6f38da7d57f5f183d1c',
    decimals: 8,
    symbol: 'TEP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4677.png',
  },
  {
    chainId: 1,
    name: 'Global Digital Content',
    address: '0x301C755bA0fcA00B1923768Fffb3Df7f4E63aF31',
    decimals: 18,
    symbol: 'GDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4678.png',
  },
  {
    chainId: 1,
    name: 'Band Protocol',
    address: '0xba11d00c5f74255f56a5e366f4f77f5a186d7f55',
    decimals: 18,
    symbol: 'BAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4679.png',
  },
  {
    chainId: 1,
    name: 'Color Platform',
    address: '0x2396fbc0e2e3ae4b7206ebdb5706e2a5920349cb',
    decimals: 18,
    symbol: 'CLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4681.png',
  },
  {
    chainId: 1,
    name: 'Hyper Speed Network',
    address: '0x365542df3c8c9d096c5f0de24a0d8cf33c19c8fd',
    decimals: 8,
    symbol: 'HSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4682.png',
  },
  {
    chainId: 1,
    name: 'ECPN Token',
    address: '0xb55732a15b3dc5d6e8d4adf40634f37470da71fa',
    decimals: 8,
    symbol: 'ECPN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4684.png',
  },
  {
    chainId: 1,
    name: 'Rally App',
    address: '0xe947b388fbe682784170b62f2bd4665f9719a285',
    decimals: 18,
    symbol: 'RALLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4685.png',
  },
  {
    chainId: 1,
    name: 'BUSD',
    address: '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
    decimals: 18,
    symbol: 'BUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png',
  },
  {
    chainId: 1,
    name: 'EGYPT',
    address: '0xa8f74d0ddfa590ba7e0794e9742846eb52f2acac',
    decimals: 18,
    symbol: 'EGY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4690.png',
  },
  {
    chainId: 1,
    name: 'Zano',
    address: '0xdb85f6685950e285b1e611037bebe5b34e2b7d78',
    decimals: 18,
    symbol: 'ZANO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4691.png',
  },
  {
    chainId: 1,
    name: 'XUSB',
    address: '0x59a2EB1675F31406e3bc00262a6dC0D98E0376B1',
    decimals: 2,
    symbol: 'XUSB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4692.png',
  },
  {
    chainId: 1,
    name: 'Global X Change Token',
    address: '0x60c87297a1feadc3c25993ffcadc54e99971e307',
    decimals: 18,
    symbol: 'GXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4693.png',
  },
  {
    chainId: 1,
    name: 'GAPS',
    address: '0xcd8544defedec7c6b60b5a4232320365b1b21fcc',
    decimals: 18,
    symbol: 'GAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4694.png',
  },
  {
    chainId: 1,
    name: 'Echoin',
    address: '0x12fd19dac0fab61bed5e0f09091b470c452d4d61',
    decimals: 18,
    symbol: 'EC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4695.png',
  },
  {
    chainId: 1,
    name: 'SPOCHAIN',
    address: '0x400bb3cab5164f42a14b24e1c90bc018eb68423a',
    decimals: 18,
    symbol: 'SPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4698.png',
  },
  {
    chainId: 1,
    name: 'KOI',
    address: '0x0be34c15f069663FF05eF5EA1E99ab3Dd2d0Fdce',
    decimals: 8,
    symbol: 'KOI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4700.png',
  },
  {
    chainId: 1,
    name: 'CoinHe Token',
    address: '0x3277dd536471a3cBEB0c9486aCad494C95A31E73',
    decimals: 18,
    symbol: 'CHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4701.png',
  },
  {
    chainId: 1,
    name: 'Rupiah Token',
    address: '0x998FFE1E43fAcffb941dc337dD0468d52bA5b48A',
    decimals: 18,
    symbol: 'IDRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4702.png',
  },
  {
    chainId: 1,
    name: 'BonusCloud',
    address: '0xdeCF7Be29F8832E9C2Ddf0388c9778B8Ba76af43',
    decimals: 18,
    symbol: 'BXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4703.png',
  },
  {
    chainId: 1,
    name: 'PAX Gold',
    address: '0x45804880de22913dafe09f4980848ece6ecbaf78',
    decimals: 18,
    symbol: 'PAXG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4705.png',
  },
  {
    chainId: 1,
    name: 'AZ Fundchain',
    address: '0xef7f1aae6f60de9f353dc170a35b8f7c7814e32b',
    decimals: 18,
    symbol: 'AZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4706.png',
  },
  {
    chainId: 1,
    name: 'Nexxo',
    address: '0xd98BD7bbd9cA9b4323448388AEC1f7c67F733980',
    decimals: 18,
    symbol: 'NEXXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4707.png',
  },
  {
    chainId: 1,
    name: 'Colletrix',
    address: '0x93065b5c7eb63333b8e57a73012d25f687895785',
    decimals: 18,
    symbol: 'CIPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4708.png',
  },
  {
    chainId: 1,
    name: 'XcelToken Plus',
    address: '0x8c4e7f814d40f8929f9112c5d09016f923d34472',
    decimals: 18,
    symbol: 'XLAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4709.png',
  },
  {
    chainId: 1,
    name: 'Cere Network',
    address: '0x2da719db753dfa10a62e140f436e1d67f2ddb0d6',
    decimals: 18,
    symbol: 'CERE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4710.png',
  },
  {
    chainId: 1,
    name: 'AmonD',
    address: '0x00059ae69c1622a7542edc15e8d17b060fe307b6',
    decimals: 18,
    symbol: 'AMON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4712.png',
  },
  {
    chainId: 1,
    name: 'Business Credit Substitute',
    address: '0x31274db8b609df99e5988ee527071643b5160fc3',
    decimals: 18,
    symbol: 'BCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4714.png',
  },
  {
    chainId: 1,
    name: 'Tokenize Xchange',
    address: '0x667102BD3413bFEaa3Dffb48fa8288819E480a88',
    decimals: 8,
    symbol: 'TKX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4715.png',
  },
  {
    chainId: 1,
    name: 'Juriseum',
    address: '0x34dd5edfed51c632d1d4d2502bc901efb5fdfcd4',
    decimals: 18,
    symbol: 'JURM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4717.png',
  },
  {
    chainId: 1,
    name: 'LENS Platform',
    address: '0x13cb835c47782dad075ce7faa1f8439b548b712d',
    decimals: 8,
    symbol: 'LENS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4722.png',
  },
  {
    chainId: 1,
    name: 'Scaltinof',
    address: '0x296EC7B2b224ea122F8f8F9be2A824dF092Fc82c',
    decimals: 8,
    symbol: 'SCAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4725.png',
  },
  {
    chainId: 1,
    name: 'Bryllite',
    address: '0x8f7a9b503aa7f9255368bd34d01aea2b502164c2',
    decimals: 18,
    symbol: 'BRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4729.png',
  },
  {
    chainId: 1,
    name: 'Boldman Capital',
    address: '0x2d4de3c744d43cf77cb12399921faf0d78b7415b',
    decimals: 18,
    symbol: 'BOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4731.png',
  },
  {
    chainId: 1,
    name: 'Madbyte Coin',
    address: '0x41ef76C0A19F2e31dA593D86ce26A2CBB8462851',
    decimals: 18,
    symbol: 'MADX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4733.png',
  },
  {
    chainId: 1,
    name: 'Bitcomo ',
    address: '0xe2fe5e7e206e7b46cad6a5146320e5b4b9a18e97',
    decimals: 2,
    symbol: 'BM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4739.png',
  },
  {
    chainId: 1,
    name: 'CoinPlace ',
    address: '0x4b3c89e986b12f83eed896f02410429a7289526e',
    decimals: 9,
    symbol: 'CPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4741.png',
  },
  {
    chainId: 1,
    name: 'CIChain',
    address: '0xad640689e6950b7453729a4686edb3fdfd754616',
    decimals: 18,
    symbol: 'CIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4743.png',
  },
  {
    chainId: 1,
    name: 'Cai Token',
    address: '0x4fe9f52ec23f6805f2fd0332a34da4f1c135b024',
    decimals: 18,
    symbol: 'CAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4745.png',
  },
  {
    chainId: 1,
    name: 'Quiztok',
    address: '0xa00a4d5786a6e955e9539d01d78bf68f3271c050',
    decimals: 18,
    symbol: 'QTCON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4746.png',
  },
  {
    chainId: 1,
    name: 'Velas',
    address: '0x8c543aed163909142695f2d2acd0d55791a9edb9',
    decimals: 18,
    symbol: 'VLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4747.png',
  },
  {
    chainId: 1,
    name: 'INLOCK',
    address: '0xf784682c82526e245f50975190ef0fff4e4fc077',
    decimals: 18,
    symbol: 'ILK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4754.png',
  },
  {
    chainId: 1,
    name: 'Robonomics.network',
    address: '0x7de91b204c1c737bcee6f000aaa6569cf7061cb7',
    decimals: 9,
    symbol: 'XRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4757.png',
  },
  {
    chainId: 1,
    name: 'dForce',
    address: '0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0',
    decimals: 18,
    symbol: 'DF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4758.png',
  },
  {
    chainId: 1,
    name: 'Pantheon',
    address: '0x5622e69e195baf4caac7b0a5f6a656f8af04fc56',
    decimals: 18,
    symbol: 'PTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4759.png',
  },
  {
    chainId: 1,
    name: 'PANTHEON X',
    address: '0x3b9e094d56103611f0acefdab43182347ba60df4',
    decimals: 18,
    symbol: 'XPN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4760.png',
  },
  {
    chainId: 1,
    name: 'NuCypher',
    address: '0x4fe83213d56308330ec302a8bd641f1d0113a4cc',
    decimals: 18,
    symbol: 'NU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4761.png',
  },
  {
    chainId: 1,
    name: 'Bitbarg',
    address: '0x36d38e232659dea52f5fdb1a0f90709e6dc6994a',
    decimals: 2,
    symbol: 'BARG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4763.png',
  },
  {
    chainId: 1,
    name: 'Treelion',
    address: '0x70968feaf13299d0dbf78f66860bab9dbe3856bc',
    decimals: 18,
    symbol: 'TRN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4765.png',
  },
  {
    chainId: 1,
    name: 'KAASO',
    address: '0xf6bf74a97d78f2242376769ef1e79885cf1f0c1c',
    decimals: 18,
    symbol: 'KAASO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4766.png',
  },
  {
    chainId: 1,
    name: 'KRW Token',
    address: '0x7f64f1a1491f6a714ce616f21975e68fb14e33dd',
    decimals: 2,
    symbol: 'KRWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4767.png',
  },
  {
    chainId: 1,
    name: 'GSTAR',
    address: '0xa49f2a94c6658f48a7a38f71af968043ddd18d1c',
    decimals: 18,
    symbol: 'GOXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4770.png',
  },
  {
    chainId: 1,
    name: 'ESAX Token',
    address: '0xc2058F5D9736E8df8Ba03ca3582B7CD6aC613658',
    decimals: 18,
    symbol: 'ESAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4771.png',
  },
  {
    chainId: 1,
    name: 'QPay',
    address: '0x6911270d4bc1915744aedd785d41d44f47245bd0',
    decimals: 18,
    symbol: 'QPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4772.png',
  },
  {
    chainId: 1,
    name: 'PocketNode',
    address: '0x435d664F72D6F194ef67d63B5f3936650187b131',
    decimals: 18,
    symbol: 'NODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4773.png',
  },
  {
    chainId: 1,
    name: '1irstGold',
    address: '0xda4129919f964a3a526d3182bb03e6449e5a8872',
    decimals: 4,
    symbol: '1GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4774.png',
  },
  {
    chainId: 1,
    name: 'Bancacy',
    address: '0x86149c67e57c749d0a12e6d6c2bf1b616619bb29',
    decimals: 18,
    symbol: 'BNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4775.png',
  },
  {
    chainId: 1,
    name: 'ABACOIN',
    address: '0xdaf76716996052aff7edb66ef0edb301bf001b6f',
    decimals: 18,
    symbol: 'ABA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4776.png',
  },
  {
    chainId: 1,
    name: 'ebakus',
    address: '0xbddab785b306bcd9fb056da189615cc8ece1d823',
    decimals: 18,
    symbol: 'EBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4778.png',
  },
  {
    chainId: 1,
    name: 'HUSD',
    address: '0xdf574c24545e5ffecb9a659c229253d4111d87e1',
    decimals: 8,
    symbol: 'HUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4779.png',
  },
  {
    chainId: 1,
    name: 'UCBI Banking',
    address: '0x2adba23cf1252de095aced801e758b369ec10426',
    decimals: 8,
    symbol: 'UCBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4780.png',
  },
  {
    chainId: 1,
    name: 'Tree Token Gold',
    address: '0xf4a9562b4bae2de5d0e3801120aa2d6c79c91b5a',
    decimals: 8,
    symbol: 'TTG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4781.png',
  },
  {
    chainId: 1,
    name: 'DCS TOKEN',
    address: '0xbded3f7537e75d6c38c036a3a788a549afde12b1',
    decimals: 8,
    symbol: 'DCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4784.png',
  },
  {
    chainId: 1,
    name: 'Bitfex',
    address: '0xdb096cc19b8227e2115855c5b39dcc247470013c',
    decimals: 18,
    symbol: 'BFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4785.png',
  },
  {
    chainId: 1,
    name: 'D Community',
    address: '0x37f74e99794853777a10ea1dc08a64c86958f06a',
    decimals: 18,
    symbol: 'DILI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4793.png',
  },
  {
    chainId: 1,
    name: 'FinexboxToken',
    address: '0xe6d2c3cb986db66818c14c7032db05d1d2a6ee74',
    decimals: 8,
    symbol: 'FNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4794.png',
  },
  {
    chainId: 1,
    name: 'Pegasus',
    address: '0x931ad0628aa11791c26ff4d41ce23e40c31c5e4e',
    decimals: 8,
    symbol: 'PGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4795.png',
  },
  {
    chainId: 1,
    name: 'TBT',
    address: '0x62a7da217d6a55a983455e5fd6c4a025ac786879',
    decimals: 6,
    symbol: 'TBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4798.png',
  },
  {
    chainId: 1,
    name: 'Mogu',
    address: '0xbdec45952b5e234eddc2981b43eed360826d5087',
    decimals: 18,
    symbol: 'MOGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4800.png',
  },
  {
    chainId: 1,
    name: 'Xeonbit Token',
    address: '0x79c71d3436f39ce382d0f58f1b011d88100b9d91',
    decimals: 18,
    symbol: 'XNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4802.png',
  },
  {
    chainId: 1,
    name: 'ROOBEE',
    address: '0xa31b1767e09f842ecfd4bc471fe44f830e3891aa',
    decimals: 18,
    symbol: 'ROOBEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4804.png',
  },
  {
    chainId: 1,
    name: 'VNDC',
    address: '0x1f3f677ecc58f6a1f9e2cf410df4776a8546b5de',
    decimals: 18,
    symbol: 'VNDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4805.png',
  },
  {
    chainId: 1,
    name: 'Tesra',
    address: '0x58959e0c71080434f237bd42d07cd84b74cef438',
    decimals: 5,
    symbol: 'TSR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4806.png',
  },
  {
    chainId: 1,
    name: 'Bincentive',
    address: '0x9669890e48f330acd88b78d63e1a6b3482652cd9',
    decimals: 18,
    symbol: 'BCNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4808.png',
  },
  {
    chainId: 1,
    name: 'Project WITH',
    address: '0xb7e77aebbe0687d2eff24cc90c41a3b6ea74bdab',
    decimals: 18,
    symbol: 'WIKEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4809.png',
  },
  {
    chainId: 1,
    name: 'BRL Coin',
    address: '0x84e1c8823850d8adc3286f31bc1178f14d243168',
    decimals: 6,
    symbol: 'BRLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4811.png',
  },
  {
    chainId: 1,
    name: 'Attention Mining',
    address: '0x3dc9a42fa7afe57be03c58fd7f4411b1e466c508',
    decimals: 18,
    symbol: 'CLL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4812.png',
  },
  {
    chainId: 1,
    name: 'RON',
    address: '0x23f043426b2336e723b32fb3bf4a1ca410f7c49a',
    decimals: 18,
    symbol: 'RON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4814.png',
  },
  {
    chainId: 1,
    name: 'EURBASE',
    address: '0x86fadb80d8d2cff3c3680819e4da99c10232ba0f',
    decimals: 18,
    symbol: 'EBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4815.png',
  },
  {
    chainId: 1,
    name: 'Xensor',
    address: '0x6bC1F3A1ae56231DbB64d3E82E070857EAe86045',
    decimals: 18,
    symbol: 'XSR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4818.png',
  },
  {
    chainId: 1,
    name: 'DMme',
    address: '0x9556f8ee795d991ff371f547162d5efb2769425f',
    decimals: 18,
    symbol: 'DMME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4819.png',
  },
  {
    chainId: 1,
    name: 'ALP Coin',
    address: '0x37d6e7f287200c740012747d2a79295caed2db35',
    decimals: 8,
    symbol: 'ALP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4820.png',
  },
  {
    chainId: 1,
    name: 'Appeal dollar',
    address: '0x64CFC7428621B2B118896670c0b4d52aB020Ee6a',
    decimals: 18,
    symbol: 'AUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4821.png',
  },
  {
    chainId: 1,
    name: 'Kappi Network',
    address: '0xf39f19565b8d937ec30f1db5bd42f558d1e312a6',
    decimals: 18,
    symbol: 'KAPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4822.png',
  },
  {
    chainId: 1,
    name: 'SymVerse',
    address: '0x79b4D12Fa63A8d1202b26c5Ba6d62136A4A09dDa',
    decimals: 18,
    symbol: 'SYM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4824.png',
  },
  {
    chainId: 1,
    name: 'SYMMA',
    address: '0xeaad4375703479fb97e1202a1e28ae1058050669',
    decimals: 2,
    symbol: 'SYM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4825.png',
  },
  {
    chainId: 1,
    name: 'ZUM TOKEN',
    address: '0xe0b9bcd54bf8a730ea5d3f1ffce0885e911a502c',
    decimals: 8,
    symbol: 'ZUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4826.png',
  },
  {
    chainId: 1,
    name: 'TICOEX Token',
    address: '0x36b60a425b82483004487abc7adcb0002918fc56',
    decimals: 8,
    symbol: 'TICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4828.png',
  },
  {
    chainId: 1,
    name: 'Kino Token ETH',
    address: '0x2f90599ab7d47a7eeb25017b5429d7305794257b',
    decimals: 8,
    symbol: 'KTETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4829.png',
  },
  {
    chainId: 1,
    name: 'VERA',
    address: '0x166f1a7ecae00bd43876a25b10a63c575e05c0e7',
    decimals: 18,
    symbol: 'VERA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4830.png',
  },
  {
    chainId: 1,
    name: 'Ethlyte Crypto',
    address: '0x1d8ca7baf0895da8afcf153657be064b5092a274',
    decimals: 18,
    symbol: 'EtLyteT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4831.png',
  },
  {
    chainId: 1,
    name: 'LegalBot',
    address: '0xb2e285cb55667afe30f6cc39b9454f3bf35eee3a',
    decimals: 18,
    symbol: 'LBOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4832.png',
  },
  {
    chainId: 1,
    name: 'V-Members Coin',
    address: '0xa3afe717038d4e12133d84088754811220af9329',
    decimals: 18,
    symbol: 'VMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4833.png',
  },
  {
    chainId: 1,
    name: 'NOVA',
    address: '0xB48B7E5bF6563B3e0A85055821A83Deb8CFc12f6',
    decimals: 3,
    symbol: 'NOVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4835.png',
  },
  {
    chainId: 1,
    name: 'LIVEEN',
    address: '0x5206186997fec1951482c2304a246bef34dcee12',
    decimals: 18,
    symbol: 'VEEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4837.png',
  },
  {
    chainId: 1,
    name: 'W12',
    address: '0xbf799a2f71d020a4a8c10e7406e2bf970b3d734b',
    decimals: 18,
    symbol: 'W12',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4838.png',
  },
  {
    chainId: 1,
    name: 'suterusu',
    address: '0xAA2ce7Ae64066175E0B90497CE7d9c190c315DB4',
    decimals: 18,
    symbol: 'SUTER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4841.png',
  },
  {
    chainId: 1,
    name: 'MeconCash',
    address: '0xa5e262ec733051b14b38901901a82f2684637e78',
    decimals: 8,
    symbol: 'MCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4844.png',
  },
  {
    chainId: 1,
    name: 'ESCX Token',
    address: '0xa8ebb13b9895e52ab7d815ce7f63591402581624',
    decimals: 8,
    symbol: 'ESCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4845.png',
  },
  {
    chainId: 1,
    name: 'Kava',
    address: '0x0C356B7fD36a5357E5A017EF11887ba100C9AB76',
    decimals: 18,
    symbol: 'KAVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png',
  },
  {
    chainId: 1,
    name: 'Block 18',
    address: '0x5A9bF6bADCd24Fe0d58E1087290c2FE2c728736a',
    decimals: 18,
    symbol: '18C',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4849.png',
  },
  {
    chainId: 1,
    name: 'LINKA',
    address: '0x578b49c45961f98d8df92854b53f1641af0a5036',
    decimals: 18,
    symbol: 'LINKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4850.png',
  },
  {
    chainId: 1,
    name: 'Sai',
    address: '0xf5b403abd806eff15b339909943e2c22ecbac54c',
    decimals: 18,
    symbol: 'SAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4851.png',
  },
  {
    chainId: 1,
    name: 'Coindy',
    address: '0x9509ab39e86b0c369bc09e6f67c7585efcbd58d9',
    decimals: 18,
    symbol: 'CODY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4852.png',
  },
  {
    chainId: 1,
    name: 'Infinito',
    address: '0x83d60e7aed59c6829fb251229061a55f35432c4d',
    decimals: 6,
    symbol: 'INFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4853.png',
  },
  {
    chainId: 1,
    name: 'Lambda Space Token',
    address: '0x142ac3bd1c94898be6e311b020b547a11dc03990',
    decimals: 18,
    symbol: 'LAMBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4854.png',
  },
  {
    chainId: 1,
    name: 'Deflacoin',
    address: '0x4ec2efb9cbd374786a03261e46ffce1a67756f3b',
    decimals: 18,
    symbol: 'DEFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4857.png',
  },
  {
    chainId: 1,
    name: 'BITFXT COIN',
    address: '0x24d77c210a014b1e123a0878f6c903df74a2317b',
    decimals: 8,
    symbol: 'BXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4858.png',
  },
  {
    chainId: 1,
    name: 'Bichip',
    address: '0xbbe5f5aa4d39d6c3cc1e4f03a1d96adc8940cf3a',
    decimals: 16,
    symbol: 'BCHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4859.png',
  },
  {
    chainId: 1,
    name: 'Era Swap',
    address: '0xef1344bdf80bef3ff4428d8becec3eea4a2cf574',
    decimals: 18,
    symbol: 'ES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4860.png',
  },
  {
    chainId: 1,
    name: 'SHUAACHAIN',
    address: '0xAc4294e71A2F6B5847BecEE48ff334aA719F8fb9',
    decimals: 18,
    symbol: 'SHUAA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4861.png',
  },
  {
    chainId: 1,
    name: 'DAD',
    address: '0x5b322514ff727253292637d9054301600c2c81e8',
    decimals: 9,
    symbol: 'DAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4862.png',
  },
  {
    chainId: 1,
    name: 'EvenToken',
    address: '0xD427c628C5f72852965fADAf1231b618c0C82395',
    decimals: 18,
    symbol: 'EST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4863.png',
  },
  {
    chainId: 1,
    name: 'Nahmii',
    address: '0x7c8155909cd385F120A56eF90728dD50F9CcbE52',
    decimals: 15,
    symbol: 'NII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4865.png',
  },
  {
    chainId: 1,
    name: 'Lukiu',
    address: '0xbaca8d824f471a6b20fdbac25e9e8943b9cd743b',
    decimals: 18,
    symbol: 'LKU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4868.png',
  },
  {
    chainId: 1,
    name: 'MesChain',
    address: '0x8f1135eA4f8946949441716d66e5390C5A990DF0',
    decimals: 8,
    symbol: 'MES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4870.png',
  },
  {
    chainId: 1,
    name: 'Secrets of Zurich',
    address: '0x3a10b7a22ae98e0f53276923f19f99b259f61778',
    decimals: 18,
    symbol: 'SOZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4871.png',
  },
  {
    chainId: 1,
    name: 'BenePit Protocol',
    address: '0xd27d76a1ba55ce5c0291ccd04febbe793d22ebf4',
    decimals: 18,
    symbol: 'BNP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4872.png',
  },
  {
    chainId: 1,
    name: 'Goat Cash',
    address: '0x9f452e458b024e82d6e3ff50a07b8de74c988523',
    decimals: 18,
    symbol: 'GOAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4873.png',
  },
  {
    chainId: 1,
    name: 'Openaurum',
    address: '0x534479d1f4e31bc8f3265009b2b05f89dc3b9af1',
    decimals: 8,
    symbol: 'OA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4875.png',
  },
  {
    chainId: 1,
    name: 'Ekon Gold',
    address: '0x6a9b3e36436b7abde8c4e2e2a98ea40455e615cf',
    decimals: 18,
    symbol: 'EKG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4876.png',
  },
  {
    chainId: 1,
    name: 'TokenTuber',
    address: '0xd1766a85b0d6f81185782dc07f15326d63c3cbaa',
    decimals: 18,
    symbol: 'TUBER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4880.png',
  },
  {
    chainId: 1,
    name: 'Guider',
    address: '0x874d4c9b980f1a13dd44cbcdb912e24ef0671ed0',
    decimals: 18,
    symbol: 'GDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4881.png',
  },
  {
    chainId: 1,
    name: 'GastroAdvisor',
    address: '0x5bb1632fa0023e1aa76a1ae92b4635c8dba49fa2',
    decimals: 18,
    symbol: 'FORK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4882.png',
  },
  {
    chainId: 1,
    name: 'GoldeNugget',
    address: '0x7b3296198f8a548edf89bdb16864da8f37b7d9cb',
    decimals: 18,
    symbol: 'GNTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4883.png',
  },
  {
    chainId: 1,
    name: 'Crypto Market Ads',
    address: '0xE968aD47B1C071Ea3905ef982833552a495D6213',
    decimals: 18,
    symbol: 'CMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4884.png',
  },
  {
    chainId: 1,
    name: 'Diligence',
    address: '0xade7b5f4a421d81ddad8ce86f77a0efe8921e9cc',
    decimals: 8,
    symbol: 'IRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4885.png',
  },
  {
    chainId: 1,
    name: 'InfluWay',
    address: '0x29c9e65e9e976bbd18721f942e90c2089a931221',
    decimals: 8,
    symbol: 'IWAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4886.png',
  },
  {
    chainId: 1,
    name: 'Receive Access Ecosystem',
    address: '0xE5a3229CCb22b6484594973A03a3851dCd948756',
    decimals: 18,
    symbol: 'RAE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4887.png',
  },
  {
    chainId: 1,
    name: 'EcoEarthCoin',
    address: '0xe1d4d57b24dbfc5dd814f852749c34d37f5b898d',
    decimals: 18,
    symbol: 'ECOEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4889.png',
  },
  {
    chainId: 1,
    name: 'Newscrypto',
    address: '0x968f6f898a6df937fc1859b323ac2f14643e3fed',
    decimals: 18,
    symbol: 'NWC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4890.png',
  },
  {
    chainId: 1,
    name: 'YAPSTONE',
    address: '0x245392ee7Ce736eC6A0908B67dC5d0a218230005',
    decimals: 18,
    symbol: 'YAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4893.png',
  },
  {
    chainId: 1,
    name: 'RING X PLATFORM',
    address: '0x7f86c782ec802ac402e0369d2e6d500256f7abc5',
    decimals: 18,
    symbol: 'RINGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4894.png',
  },
  {
    chainId: 1,
    name: 'MARKYT',
    address: '0xa9080bf7c8e55f2af5c6603243d5865f4f328715',
    decimals: 18,
    symbol: 'MAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4897.png',
  },
  {
    chainId: 1,
    name: 'Anchor',
    address: '0x5456bc77dd275c45c3c15f0cf936b763cf57c3b5',
    decimals: 8,
    symbol: 'ANCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4901.png',
  },
  {
    chainId: 1,
    name: 'MargiX',
    address: '0x1412f6Aa5ADC77C620715BB2a020AA690B85F68A',
    decimals: 18,
    symbol: 'MGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4902.png',
  },
  {
    chainId: 1,
    name: 'Infinity Esaham',
    address: '0x193408ca0576b73156ed42a2ea7d6fd3f6507162',
    decimals: 18,
    symbol: 'INFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4903.png',
  },
  {
    chainId: 1,
    name: 'FMex',
    address: '0x20c3d4e5c17578250fc4f350f2afee6c6ebea06a',
    decimals: 18,
    symbol: 'FMEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4904.png',
  },
  {
    chainId: 1,
    name: 'Pcore',
    address: '0x6aa27b3a8aab51745b7eaf53e61aba833b0f9400',
    decimals: 8,
    symbol: 'PCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4906.png',
  },
  {
    chainId: 1,
    name: 'CoinDeal Token',
    address: '0xcb17cd357c7acd594717d899ecb9df540f633f27',
    decimals: 18,
    symbol: 'CDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4910.png',
  },
  {
    chainId: 1,
    name: 'Banklife',
    address: '0x3fd2e747cea0e8a78f1827ea2ffd3334628a600b',
    decimals: 18,
    symbol: 'LIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4911.png',
  },
  {
    chainId: 1,
    name: 'SOLBIT',
    address: '0x0b664581D2d41F6810d2eF9ecd98bFcFF7EE6A58',
    decimals: 18,
    symbol: 'SBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4913.png',
  },
  {
    chainId: 1,
    name: 'UCX',
    address: '0x3D3af44cf092a49280e316f09c8f20ecf97BC933',
    decimals: 18,
    symbol: 'UCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4915.png',
  },
  {
    chainId: 1,
    name: 'Modex',
    address: '0x4bcea5e4d0f6ed53cf45e7a28febb2d3621d7438',
    decimals: 18,
    symbol: 'MODEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4916.png',
  },
  {
    chainId: 1,
    name: 'DEXA COIN',
    address: '0x725440512cb7b78bf56b334e50e31707418231cb',
    decimals: 18,
    symbol: 'DEXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4917.png',
  },
  {
    chainId: 1,
    name: 'Cereneum',
    address: '0xd9d4a7ca154fe137c808f7eedbe24b639b7af5a6',
    decimals: 8,
    symbol: 'CER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4919.png',
  },
  {
    chainId: 1,
    name: 'Aerotoken',
    address: '0x8c9e4cf756b9d01d791b95bc2d0913ef2bf03784',
    decimals: 18,
    symbol: 'AET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4920.png',
  },
  {
    chainId: 1,
    name: 'WBF Token',
    address: '0x2b81f9668f4a5fdeba51b53a759de46fb59a5c91',
    decimals: 18,
    symbol: 'WT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4921.png',
  },
  {
    chainId: 1,
    name: 'ICURY',
    address: '0x8903e8f101d86ea097efe104a3d53f4c42cb44bc',
    decimals: 18,
    symbol: 'ICY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4922.png',
  },
  {
    chainId: 1,
    name: 'Privateers',
    address: '0x28a40acf39b1d3c932f42dd8068ad00a5ad6448f',
    decimals: 18,
    symbol: 'LDM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4923.png',
  },
  {
    chainId: 1,
    name: 'PingPaid',
    address: '0xbf8c75e09e459e122a974c1815314210adfeaa51',
    decimals: 18,
    symbol: 'PPD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4924.png',
  },
  {
    chainId: 1,
    name: 'PROMETEO',
    address: '0x8276ad69acdAacB17f981B780FDEF80b95f7e764',
    decimals: 18,
    symbol: 'PPT7',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4925.png',
  },
  {
    chainId: 1,
    name: 'Pandroyty',
    address: '0x4e8e8eb5a4ed17170b646d33b8ef3e7352585607',
    decimals: 18,
    symbol: 'PDRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4926.png',
  },
  {
    chainId: 1,
    name: 'RigoBlock',
    address: '0x4fbb350052bca5417566f188eb2ebce5b19bc964',
    decimals: 18,
    symbol: 'GRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4927.png',
  },
  {
    chainId: 1,
    name: 'Medium',
    address: '0xd24DFf6117936B6ff97108CF26c1dD8865743d87',
    decimals: 18,
    symbol: 'MDM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4928.png',
  },
  {
    chainId: 1,
    name: 'JD Coin',
    address: '0x2fe39f22eac6d3c1c86dd9d143640ebb94609fce',
    decimals: 18,
    symbol: 'JDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4929.png',
  },
  {
    chainId: 1,
    name: 'DEN',
    address: '0xa39edf106c4fe96b734205f52eec92a05735c8e9',
    decimals: 18,
    symbol: 'DEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4932.png',
  },
  {
    chainId: 1,
    name: 'Arena Match Gold',
    address: '0xf1ac7a375429719de0dde33528e2639b9a206eba',
    decimals: 18,
    symbol: 'AMGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4933.png',
  },
  {
    chainId: 1,
    name: 'LOLTOKEN',
    address: '0x5978708d6ccE1CC9640Eed47422D64c91BbD5171',
    decimals: 18,
    symbol: 'LOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4936.png',
  },
  {
    chainId: 1,
    name: 'Moozicore',
    address: '0xfe4455fd433ed3ca025ec7c43cb8686ed89826cd',
    decimals: 18,
    symbol: 'MZG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4937.png',
  },
  {
    chainId: 1,
    name: 'Kuverit',
    address: '0xf70d160102cf7a22c1e432d6928a9d625db91170',
    decimals: 18,
    symbol: 'KUV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4940.png',
  },
  {
    chainId: 1,
    name: 'Bispex',
    address: '0x2AA4a3E8bB72BE68a31c9c3C98CA7BeC723C6222',
    decimals: 18,
    symbol: 'BPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4941.png',
  },
  {
    chainId: 1,
    name: 'Digital Gold',
    address: '0x0d16450d347c12c086d6c94c76c5aaac35ea07e0',
    decimals: 3,
    symbol: 'GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4942.png',
  },
  {
    chainId: 1,
    name: 'Dai',
    address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    decimals: 18,
    symbol: 'DAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
  },
  {
    chainId: 1,
    name: 'Tellor',
    address: '0x88dF592F8eb5D7Bd38bFeF7dEb0fBc02cf3778a0',
    decimals: 18,
    symbol: 'TRB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4944.png',
  },
  {
    chainId: 1,
    name: 'BtcEX Coin',
    address: '0x1bbe0d2d0a284ef9118ee69d356fcdd5948bacf4',
    decimals: 18,
    symbol: 'BXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4945.png',
  },
  {
    chainId: 1,
    name: 'Vinci',
    address: '0x3db99ab08006aefcc9600972eca8c202396b4300',
    decimals: 18,
    symbol: 'VINCI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4946.png',
  },
  {
    chainId: 1,
    name: '999',
    address: '0xbf05571988daab22d33c28bbb13566eae9dee626',
    decimals: 3,
    symbol: '999',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4949.png',
  },
  {
    chainId: 1,
    name: 'LCX',
    address: '0x037a54aab062628c9bbae1fdb1583c195585fe41',
    decimals: 18,
    symbol: 'LCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4950.png',
  },
  {
    chainId: 1,
    name: 'Zynecoin',
    address: '0x94ec918ddeecfdfcbf8c8d3e848b7c3e8d8ceaa1',
    decimals: 18,
    symbol: 'ZYN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4951.png',
  },
  {
    chainId: 1,
    name: 'Global Duck Tour',
    address: '0xaed3c5146a3797dbc8fffbe8953175e95a5b620c',
    decimals: 4,
    symbol: 'GDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4952.png',
  },
  {
    chainId: 1,
    name: 'FirmaChain',
    address: '0xe1bad922f84b198a08292fb600319300ae32471b',
    decimals: 18,
    symbol: 'FCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4953.png',
  },
  {
    chainId: 1,
    name: 'MAP Protocol',
    address: '0x66D79B8f60ec93Bfce0b56F5Ac14A2714E509a99',
    decimals: 18,
    symbol: 'MAPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4956.png',
  },
  {
    chainId: 1,
    name: 'Minter Network',
    address: '0xcafe34bae6f1b23a6b575303edcc0578d2188131',
    decimals: 18,
    symbol: 'BIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4957.png',
  },
  {
    chainId: 1,
    name: 'Precium',
    address: '0x6096d2460cf5177e40b515223428dc005ad35123',
    decimals: 18,
    symbol: 'PCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4958.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Neo',
    address: '0x2976ac3d0bb67c6307a73df852c61c14cdda9863',
    decimals: 18,
    symbol: 'BTCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4959.png',
  },
  {
    chainId: 1,
    name: 'Bimin Token',
    address: '0x4b02c21f7712a4af8020a4590d95f4cf8bac1faf',
    decimals: 18,
    symbol: 'BM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4960.png',
  },
  {
    chainId: 1,
    name: 'ELDORADO TOKEN',
    address: '0x12dc767728105aa415dd720dfbd0ea1d85841172',
    decimals: 2,
    symbol: 'ERD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4961.png',
  },
  {
    chainId: 1,
    name: 'Yellow Tether',
    address: '0x0622769D566B3c4C1C58cA4FAbee8E60bb3163e5',
    decimals: 6,
    symbol: 'YUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4962.png',
  },
  {
    chainId: 1,
    name: 'Pride',
    address: '0x7cb97a776a49e272baccad31396405a94f3fb3f8',
    decimals: 18,
    symbol: 'LGBTQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4963.png',
  },
  {
    chainId: 1,
    name: 'USDG',
    address: '0xf906997808f73b09c1007b98ab539b189282b192',
    decimals: 3,
    symbol: 'USDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4964.png',
  },
  {
    chainId: 1,
    name: 'BuschCoin',
    address: '0xe0c3223ae0cb8b5a47ff7f4994f5fbcde58496f8',
    decimals: 6,
    symbol: 'BUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4968.png',
  },
  {
    chainId: 1,
    name: 'NairaX',
    address: '0xf0ccca32cd300356629216eb301ec6649c7c6adb',
    decimals: 18,
    symbol: 'NIRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4971.png',
  },
  {
    chainId: 1,
    name: 'Traders Token',
    address: '0x9ad685a3eaa6b0a1ea601f48b7797a12011fdeb0',
    decimals: 3,
    symbol: 'TRDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4972.png',
  },
  {
    chainId: 1,
    name: 'HorseChain',
    address: '0xe0bb2ba6abfe69eef1b0828e090a3abd5863c7ad',
    decimals: 6,
    symbol: 'HRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4973.png',
  },
  {
    chainId: 1,
    name: 'EXMO Coin',
    address: '0x83869de76b9ad8125e22b857f519f001588c0f62',
    decimals: 8,
    symbol: 'EXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4974.png',
  },
  {
    chainId: 1,
    name: 'Newsolution',
    address: '0xd89040ac9823b72f64d71f66fa2deae7c8520671',
    decimals: 18,
    symbol: 'NST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4975.png',
  },
  {
    chainId: 1,
    name: 'SPORTSPLEX',
    address: '0x13599cf04afd22f2fe7d7cf77cc41410dfcf532a',
    decimals: 8,
    symbol: 'SPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4976.png',
  },
  {
    chainId: 1,
    name: 'JamaiCoin',
    address: '0xc2856a8310af421a2a65de16428c2dec6ceacb36',
    decimals: 18,
    symbol: 'YAH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4977.png',
  },
  {
    chainId: 1,
    name: 'TAGZ5',
    address: '0x4d0425e47ee2d16b94c036715dfcb52a0cebc4dc',
    decimals: 8,
    symbol: 'TAGZ5',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4981.png',
  },
  {
    chainId: 1,
    name: 'Demeter Chain',
    address: '0x3be6e7bf2cd8e1a0a95597e72ca6d3709bbeff76',
    decimals: 18,
    symbol: 'DMTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4983.png',
  },
  {
    chainId: 1,
    name: 'MACH Project',
    address: '0xB119Ce94D098C18fe380904c24e358bd887F00BE',
    decimals: 18,
    symbol: 'MACH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4984.png',
  },
  {
    chainId: 1,
    name: 'ArdCoin',
    address: '0x4039075fe3607F064129458299a616c8723efd97',
    decimals: 18,
    symbol: 'ARDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4985.png',
  },
  {
    chainId: 1,
    name: 'TBC Mart Token',
    address: '0x6F02055E3541DD74A1aBD8692116c22fFAFaDc5D',
    decimals: 18,
    symbol: 'TMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4986.png',
  },
  {
    chainId: 1,
    name: 'Crespo',
    address: '0x5ecb025e51415dba9fd272c551076357cf4069f5',
    decimals: 18,
    symbol: 'CSO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4988.png',
  },
  {
    chainId: 1,
    name: 'HGH Token',
    address: '0x40c6f861a08f97dfbc3c0931485bff4921975a56',
    decimals: 18,
    symbol: 'HGH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4989.png',
  },
  {
    chainId: 1,
    name: 'Bitpara',
    address: '0xb5bae50c084a2f99c8f990463c5eff12957a81d7',
    decimals: 6,
    symbol: 'BTRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4990.png',
  },
  {
    chainId: 1,
    name: 'Web Token Pay',
    address: '0x1680cfdad75da2bb56ded4f36bb9423c86ffa7b7',
    decimals: 18,
    symbol: 'WTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4993.png',
  },
  {
    chainId: 1,
    name: 'Blockzero Labs',
    address: '0x0f7F961648aE6Db43C75663aC7E5414Eb79b5704',
    decimals: 18,
    symbol: 'XIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4997.png',
  },
  {
    chainId: 1,
    name: 'Davion',
    address: '0x5d56962db8e35197f8e50d76f1f9285a6d7d7619',
    decimals: 18,
    symbol: 'DAVP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4999.png',
  },
  {
    chainId: 1,
    name: 'Gric Coin',
    address: '0x720c2c93F5f9A6b82226e84095558B10F399b0FA',
    decimals: 18,
    symbol: 'GC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5001.png',
  },
  {
    chainId: 1,
    name: 'ARCS',
    address: '0x7d8DafF6d70CEAd12c6f077048552Cf89130A2B1',
    decimals: 18,
    symbol: 'ARX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5005.png',
  },
  {
    chainId: 1,
    name: 'TROY',
    address: '0x4574562e9310a94f9ca962bd23168d8a06875b1a',
    decimals: 18,
    symbol: 'TROY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5007.png',
  },
  {
    chainId: 1,
    name: 'Artis Turba',
    address: '0x082e13494f12ebb7206fbf67e22a6e1975a1a669',
    decimals: 8,
    symbol: 'ARTIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5008.png',
  },
  {
    chainId: 1,
    name: 'LuckySevenToken',
    address: '0x6b9F1F092E0B10015a4391A80cD3E6B6cefD1728',
    decimals: 18,
    symbol: 'LST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5009.png',
  },
  {
    chainId: 1,
    name: 'ALLY',
    address: '0x9d5686eadea7327f5a0c4820dca90457a0e88763',
    decimals: 18,
    symbol: 'ALY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5011.png',
  },
  {
    chainId: 1,
    name: 'Hashshare',
    address: '0x8c0296be0c5ee8cbdbd6ca4c0f2d2e3640729300',
    decimals: 8,
    symbol: 'HSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5012.png',
  },
  {
    chainId: 1,
    name: 'AuditStarter',
    address: '0xaE692832294409d0f2a8C56a1459b76e97F7eD92',
    decimals: 18,
    symbol: 'AUDIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5013.png',
  },
  {
    chainId: 1,
    name: 'Cloudbit Classic',
    address: '0xfd3305e1c7cb5d269fb6ced8eb8240255a50e7a4',
    decimals: 8,
    symbol: 'CDBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5014.png',
  },
  {
    chainId: 1,
    name: 'HEX',
    address: '0x2b591e99afe9f32eaa6214f7b7629768c40eeb39',
    decimals: 8,
    symbol: 'HEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5015.png',
  },
  {
    chainId: 1,
    name: 'Innovative Bioresearch Coin',
    address: '0xB67718b98d52318240c52E71A898335da4A28c42',
    decimals: 18,
    symbol: 'INNBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5016.png',
  },
  {
    chainId: 1,
    name: 'BCNX',
    address: '0x27403b58ac43be5a9f422962b4cdd5ffbdb60639',
    decimals: 18,
    symbol: 'BCNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5017.png',
  },
  {
    chainId: 1,
    name: 'Global Crypto Alliance',
    address: '0xbbe761ea1447a20b75aa485b7bcad4837415d7d7',
    decimals: 18,
    symbol: 'CALL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5019.png',
  },
  {
    chainId: 1,
    name: 'EmhmCoin',
    address: '0x61a53c07c8d3159bfc6845a8f0bdab88ca7ac9b4',
    decimals: 2,
    symbol: 'EMHMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5020.png',
  },
  {
    chainId: 1,
    name: 'ALL BEST ICO',
    address: '0x0425e5bf7f52591a04fbe24c454ac004179c4318',
    decimals: 18,
    symbol: 'ALLBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5024.png',
  },
  {
    chainId: 1,
    name: 'Orchid',
    address: '0x4575f41308EC1483f3d399aa9a2826d74Da13Deb',
    decimals: 18,
    symbol: 'OXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5026.png',
  },
  {
    chainId: 1,
    name: 'Barbarossa Invest Token',
    address: '0x9c2d9be4bb7352d2eca65675067f9e6194e597b5',
    decimals: 18,
    symbol: 'BITBITBITBIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5027.png',
  },
  {
    chainId: 1,
    name: 'VianeX',
    address: '0x86c31e6da2190a1ffd39a36990a44174d0a8be15',
    decimals: 18,
    symbol: 'VIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5029.png',
  },
  {
    chainId: 1,
    name: 'BLOCKTV',
    address: '0xe08854b668958657064fa20f309F6BA7a19D5Af2',
    decimals: 18,
    symbol: 'BLTV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5030.png',
  },
  {
    chainId: 1,
    name: 'Cherry Payment',
    address: '0x48a487b5386cfcecc07e05511175e0cbdc6132f3',
    decimals: 18,
    symbol: 'CPMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5032.png',
  },
  {
    chainId: 1,
    name: 'Creatanium',
    address: '0xe541b34f73a4789a033a962ad43655221b4e516e',
    decimals: 18,
    symbol: 'CMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5033.png',
  },
  {
    chainId: 1,
    name: 'BitcoinKasi',
    address: '0x54fD25447A3B435cb0D8e0666EaD4493322d5482',
    decimals: 18,
    symbol: 'BCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5035.png',
  },
  {
    chainId: 1,
    name: 'Huptex',
    address: '0x38a0df9a08d18dc06cd91fc7ec94a0acdf28d994',
    decimals: 2,
    symbol: 'HTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5037.png',
  },
  {
    chainId: 1,
    name: 'SBank',
    address: '0x4c14114c107d6374ec31981f5f6cc27a13e22f9a',
    decimals: 18,
    symbol: 'STS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5039.png',
  },
  {
    chainId: 1,
    name: 'PazCoin',
    address: '0x8B554bF7304065e60F89915a4eb1aBa7E7EB301c',
    decimals: 18,
    symbol: 'PAZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5042.png',
  },
  {
    chainId: 1,
    name: 'Yattaqi',
    address: '0x5ceb8c7f189e694b326310694ac6df98e5ced66e',
    decimals: 18,
    symbol: 'YAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5044.png',
  },
  {
    chainId: 1,
    name: 'QURA GLOBAL',
    address: '0x4eE6E959d460dE47DfE58E5E6fBAB330Ce8484b6',
    decimals: 18,
    symbol: 'QURA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5045.png',
  },
  {
    chainId: 1,
    name: 'Streamity',
    address: '0x0e22734e078d6e399bcee40a549db591c4ea46cb',
    decimals: 18,
    symbol: 'STM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5046.png',
  },
  {
    chainId: 1,
    name: 'Litbinex Coin',
    address: '0xa105C740BC012A43a342Ab4A0Ef40143452C8E89',
    decimals: 18,
    symbol: 'LTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5047.png',
  },
  {
    chainId: 1,
    name: 'Baz Token',
    address: '0xb020ed54651831878e5c967e0953a900786178f9',
    decimals: 18,
    symbol: 'BAZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5050.png',
  },
  {
    chainId: 1,
    name: 'Apple Network',
    address: '0x3c45b24359fb0e107a4eaa56bd0f2ce66c99a0e5',
    decimals: 18,
    symbol: 'ANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5052.png',
  },
  {
    chainId: 1,
    name: 'Coupon Chain',
    address: '0xfc4b9e2d71a7795102Eb0C0e8b5DA992946a62De',
    decimals: 18,
    symbol: 'CCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5054.png',
  },
  {
    chainId: 1,
    name: 'SpaceGold',
    address: '0x5cac3991e1d10d62df007a3559f652887735aedb',
    decimals: 18,
    symbol: 'SGOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5055.png',
  },
  {
    chainId: 1,
    name: 'Helex',
    address: '0x8F8e787989BC652eeA01A6C88a19f0f379BDF4FD',
    decimals: 5,
    symbol: 'HLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5057.png',
  },
  {
    chainId: 1,
    name: 'USDA',
    address: '0x3c7b464376db7c9927930cf50eefdea2eff3a66a',
    decimals: 8,
    symbol: 'USDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5058.png',
  },
  {
    chainId: 1,
    name: 'Mnoer',
    address: '0xe4e2daf5f7f0c1c35df922c5d9340913edecc8e8',
    decimals: 18,
    symbol: 'MNR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5059.png',
  },
  {
    chainId: 1,
    name: 'Bepro',
    address: '0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a',
    decimals: 18,
    symbol: 'BEPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5062.png',
  },
  {
    chainId: 1,
    name: 'WowSecret',
    address: '0x843131b15f2ec5bea850ac5164d2e4a3749ad87f',
    decimals: 18,
    symbol: 'WOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5064.png',
  },
  {
    chainId: 1,
    name: 'Axial Entertainment Digital Asset',
    address: '0x4fac0ccd9e2ed9fd462d42b66fb81ba9a1f6f25e',
    decimals: 18,
    symbol: 'AXL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5065.png',
  },
  {
    chainId: 1,
    name: 'MAX Exchange Token',
    address: '0xe7976c4Efc60d9f4C200Cc1bCEF1A1e3B02c73e7',
    decimals: 18,
    symbol: 'MAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5067.png',
  },
  {
    chainId: 1,
    name: 'Neutrino Index',
    address: '0x674C6Ad92Fd080e4004b2312b45f796a192D27a0',
    decimals: 18,
    symbol: 'XTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5068.png',
  },
  {
    chainId: 1,
    name: 'Flit Token',
    address: '0xb351da6ffebd5dddd1da037929fcf334d6b4a8d5',
    decimals: 18,
    symbol: 'FLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5069.png',
  },
  {
    chainId: 1,
    name: 'Tap',
    address: '0x6368e1E18c4C419DDFC608A0BEd1ccb87b9250fc',
    decimals: 18,
    symbol: 'XTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5070.png',
  },
  {
    chainId: 1,
    name: 'Rakon',
    address: '0x6e5a43db10b04701385a34afb670e404bc7ea597',
    decimals: 12,
    symbol: 'RKN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5072.png',
  },
  {
    chainId: 1,
    name: 'Chanecoin',
    address: '0x3ac17408da720189d2bd82d02759b91492c64de8',
    decimals: 18,
    symbol: 'CHANE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5073.png',
  },
  {
    chainId: 1,
    name: 'UBU',
    address: '0x6b74dd5d01f8320081247f5cf1f7a48324700db6',
    decimals: 8,
    symbol: 'UBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5074.png',
  },
  {
    chainId: 1,
    name: 'Global Reserve System',
    address: '0x45f2ab0ca2116b2e1a70bf5e13293947b25d0272',
    decimals: 18,
    symbol: 'GLOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5076.png',
  },
  {
    chainId: 1,
    name: 'THENODE',
    address: '0xb4a677b0e363c3815d46326954a4e4d2b1ace357',
    decimals: 18,
    symbol: 'THE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5078.png',
  },
  {
    chainId: 1,
    name: 'apM Coin',
    address: '0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c',
    decimals: 18,
    symbol: 'APM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5079.png',
  },
  {
    chainId: 1,
    name: 'MYTHIC',
    address: '0x74658fB5f7fF3Bc7d70f7F792d53fd74f89dC055',
    decimals: 18,
    symbol: 'MTCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5080.png',
  },
  {
    chainId: 1,
    name: 'Curio',
    address: '0x13339fd07934cd674269726edf3b5ccee9dd93de',
    decimals: 18,
    symbol: 'CUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5083.png',
  },
  {
    chainId: 1,
    name: 'PlayFuel',
    address: '0xaDA62f7CCd6af6cAcff04ACCBC4f56f3D4FFd4Ef',
    decimals: 18,
    symbol: 'PLF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5084.png',
  },
  {
    chainId: 1,
    name: 'Pawtocol',
    address: '0x70d2b7c19352bb76e4409858ff5746e500f2b67c',
    decimals: 18,
    symbol: 'UPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5086.png',
  },
  {
    chainId: 1,
    name: 'CRYPTOBUCKS',
    address: '0x0d2BB9D68dD4451A09ec94C05E20Bd395022bd8e',
    decimals: 2,
    symbol: 'CBUCKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5087.png',
  },
  {
    chainId: 1,
    name: 'Global Game Coin',
    address: '0x7f969c4d388ca0ae39a4fddb1a6f89878ca2fbf8',
    decimals: 18,
    symbol: 'GGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5090.png',
  },
  {
    chainId: 1,
    name: 'SpeedKingtoken',
    address: '0xa7c8d7a1c894e51dbb7c680b5b1dbdc845bfbdab',
    decimals: 5,
    symbol: 'SKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5092.png',
  },
  {
    chainId: 1,
    name: 'VOMER',
    address: '0x063b98a414eaa1d4a5d4fc235a22db1427199024',
    decimals: 18,
    symbol: 'VMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5093.png',
  },
  {
    chainId: 1,
    name: 'Level01',
    address: '0x261638EC8ee8100484130EBD2fEBfDAdC0D8742a',
    decimals: 18,
    symbol: 'LVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5094.png',
  },
  {
    chainId: 1,
    name: 'Green World Project',
    address: '0x4ffe33e525042cc84c503db5842ecda280f4a805',
    decimals: 18,
    symbol: 'GWP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5096.png',
  },
  {
    chainId: 1,
    name: 'Arch Crypton Game',
    address: '0xf5774f42b28f35429aac35f8eb57541c511fdd49',
    decimals: 18,
    symbol: 'ARCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5098.png',
  },
  {
    chainId: 1,
    name: 'Orbit',
    address: '0x248aDE18435f7B5E39d855CC98C42D8f6840a386',
    decimals: 3,
    symbol: 'ORBIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5100.png',
  },
  {
    chainId: 1,
    name: 'myBlockchain Certificate',
    address: '0x0b1683b742976a46603453a918773e46e666b12c',
    decimals: 8,
    symbol: 'MBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5101.png',
  },
  {
    chainId: 1,
    name: 'Enzo',
    address: '0x94eea9a484f0bae03d19623cfe389e2cba56b72f',
    decimals: 18,
    symbol: 'NZO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5102.png',
  },
  {
    chainId: 1,
    name: '1AI Token',
    address: '0x208bbb6bCEA22ef2011789331405347394EbAa51',
    decimals: 18,
    symbol: '1AI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5105.png',
  },
  {
    chainId: 1,
    name: 'BitKAM',
    address: '0xbdbb0ee6144544ec814d417b0ad41f16fc8b858e',
    decimals: 8,
    symbol: 'KAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5107.png',
  },
  {
    chainId: 1,
    name: '808TA',
    address: '0x5b535edfa75d7cb706044da0171204e1c48d00e8',
    decimals: 18,
    symbol: '808TA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5108.png',
  },
  {
    chainId: 1,
    name: 'RIFT Token',
    address: '0xadeee1bcb63f3477c45400249e78bc4f565a59e0',
    decimals: 18,
    symbol: 'RIFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5110.png',
  },
  {
    chainId: 1,
    name: 'MAFER',
    address: '0xa9aa40627C6B989F97A6656a4AD658275479361C',
    decimals: 8,
    symbol: 'MFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5112.png',
  },
  {
    chainId: 1,
    name: 'inSure DeFi',
    address: '0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e',
    decimals: 18,
    symbol: 'SURE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5113.png',
  },
  {
    chainId: 1,
    name: 'Coinsbit Token',
    address: '0xC538143202f3b11382D8606aae90a96b042a19DB',
    decimals: 18,
    symbol: 'CNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5114.png',
  },
  {
    chainId: 1,
    name: 'Origin Protocol',
    address: '0x8207c1ffc5b6804f6024322ccf34f29c3541ae26',
    decimals: 18,
    symbol: 'OGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5117.png',
  },
  {
    chainId: 1,
    name: 'DGLD',
    address: '0xa9299c296d7830a99414d1e5546f5171fa01e9c8',
    decimals: 18,
    symbol: 'DGLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5119.png',
  },
  {
    chainId: 1,
    name: 'PEG Network',
    address: '0x8ae56a6850a7cbeac3c3ab2cb311e7620167eac8',
    decimals: 18,
    symbol: 'PEG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5120.png',
  },
  {
    chainId: 1,
    name: 'CapitalShareToken',
    address: '0x2466ba59e474c46639ceb4eb9b7248638443560d',
    decimals: 18,
    symbol: 'CSTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5121.png',
  },
  {
    chainId: 1,
    name: 'Nuclear Coin',
    address: '0x3c04ff86492ce16ccb306acb9226a1064cafad07',
    decimals: 6,
    symbol: 'NCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5122.png',
  },
  {
    chainId: 1,
    name: 'Egoras Dollar',
    address: '0xa90c43e0d6c92b8e6171a829beb38be28a0ad073',
    decimals: 18,
    symbol: 'EUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5124.png',
  },
  {
    chainId: 1,
    name: 'Soda Coin',
    address: '0xcaD49C39B72c37B32cEe8b14F33F316D3a8bC335',
    decimals: 18,
    symbol: 'SOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5126.png',
  },
  {
    chainId: 1,
    name: 'Syariahcoin',
    address: '0x0598C2Fdd3a0564970A86B69C72a6C57077c84bb',
    decimals: 8,
    symbol: 'SYCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5128.png',
  },
  {
    chainId: 1,
    name: 'KNL Ecosystem',
    address: '0x5ba4d3e350acf0ca8d27a1052e55609998bef947',
    decimals: 8,
    symbol: 'KNLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5129.png',
  },
  {
    chainId: 1,
    name: 'K-Tune',
    address: '0x14cc8dfaf2258e1b8b2869300dba1b734dc0fe43',
    decimals: 18,
    symbol: 'KTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5130.png',
  },
  {
    chainId: 1,
    name: 'Universe Coin',
    address: '0xedc87cab8bd12ca39088deaf9fdfb63503f19f85',
    decimals: 18,
    symbol: 'UNIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5132.png',
  },
  {
    chainId: 1,
    name: 'TLS Token',
    address: '0x4AFAdB32b8fdB334cF9f20AFb476A06c1F5b111A',
    decimals: 8,
    symbol: 'TLS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5133.png',
  },
  {
    chainId: 1,
    name: 'AfroDex',
    address: '0x08130635368AA28b217a4dfb68E1bF8dC525621C',
    decimals: 4,
    symbol: 'AfroX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5135.png',
  },
  {
    chainId: 1,
    name: 'AfroDex Labs Token',
    address: '0xd8a8843b0a5aba6b030e92b3f4d669fad8a5be50',
    decimals: 4,
    symbol: 'AFDLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5136.png',
  },
  {
    chainId: 1,
    name: 'Encubate',
    address: '0x70071514015D9a52d979789C629d77566B838D8a',
    decimals: 18,
    symbol: 'ENBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5139.png',
  },
  {
    chainId: 1,
    name: 'Decentralize Currency Assets',
    address: '0xa6281838f4a9c5736b2aa1cba9260d3f879623ca',
    decimals: 18,
    symbol: 'DCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5140.png',
  },
  {
    chainId: 1,
    name: 'Sceptercash',
    address: '0x790304309388C417ff8AaB454B8d27e79CAd1Df5',
    decimals: 18,
    symbol: 'SCPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5141.png',
  },
  {
    chainId: 1,
    name: 'technoCoins',
    address: '0xC1165d1FB3C8eCfF35CeFA0a03864F9A6a802C9C',
    decimals: 18,
    symbol: 'tCoins',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5142.png',
  },
  {
    chainId: 1,
    name: 'EXVA',
    address: '0x8e483b016cb4ba8a0dc17c2ece61a16e480712e1',
    decimals: 18,
    symbol: 'EVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5147.png',
  },
  {
    chainId: 1,
    name: 'MIPS Project',
    address: '0x772b1692e87f8df4625c43b9ea20ee098b57b726',
    decimals: 18,
    symbol: 'MIPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5151.png',
  },
  {
    chainId: 1,
    name: 'Benscoin',
    address: '0xcfAD57a67689809CdA997f655802a119838c9ceC',
    decimals: 7,
    symbol: 'BSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5152.png',
  },
  {
    chainId: 1,
    name: 'Yattaqi Pro',
    address: '0x39043aae9c48a628f5184af7a5bb925137757b15',
    decimals: 8,
    symbol: 'YATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5153.png',
  },
  {
    chainId: 1,
    name: 'BKEX Chain',
    address: '0x1df7aa5551e801e280007dc0fc0454e2d06c1a89',
    decimals: 18,
    symbol: 'BKK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5154.png',
  },
  {
    chainId: 1,
    name: 'HeartBout Pay',
    address: '0x5a4b14aea23a605abc463f04a6b8aaf52dd3e7c6',
    decimals: 18,
    symbol: 'HP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5156.png',
  },
  {
    chainId: 1,
    name: '3X Long Bitcoin Token',
    address: '0x68eb95dc9934e19b86687a10df8e364423240e94',
    decimals: 18,
    symbol: 'BULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5157.png',
  },
  {
    chainId: 1,
    name: '3X Short Bitcoin Token',
    address: '0x016ee7373248a80bde1fd6baa001311d233b3cfa',
    decimals: 18,
    symbol: 'BEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5158.png',
  },
  {
    chainId: 1,
    name: 'GoldenHand',
    address: '0x1ec52a7a6048c1ca8b8afd8ef97051acfe755e35',
    decimals: 18,
    symbol: 'GCPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5163.png',
  },
  {
    chainId: 1,
    name: 'Crypto Dash',
    address: '0x86b300ef935284a99fa5d148a9a6ccc5103b21a8',
    decimals: 18,
    symbol: 'CDASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5164.png',
  },
  {
    chainId: 1,
    name: 'TORO',
    address: '0x36e35d710134d8cfe104300ee123067ca6d841e3',
    decimals: 8,
    symbol: 'TORO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5167.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Classic',
    address: '0x16467F88F41Fe323324084BEd682E10f937eF10C',
    decimals: 18,
    symbol: 'BXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5168.png',
  },
  {
    chainId: 1,
    name: 'PYRO Network',
    address: '0x14409b0fc5c7f87b5dad20754fe22d29a3de8217',
    decimals: 18,
    symbol: 'PYRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5169.png',
  },
  {
    chainId: 1,
    name: 'IFX24',
    address: '0xc962ad021a69D457564e985738C719aE3f79B707',
    decimals: 18,
    symbol: 'IFX24',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5170.png',
  },
  {
    chainId: 1,
    name: 'Aurei',
    address: '0x92afba413bf9e5da3919a522e371884beac76309',
    decimals: 8,
    symbol: 'ARE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5172.png',
  },
  {
    chainId: 1,
    name: 'PAMMCOIN',
    address: '0x30a9dab82f8fa64fdfea43665546e24aba7280db',
    decimals: 8,
    symbol: 'PAMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5173.png',
  },
  {
    chainId: 1,
    name: 'Tether Gold',
    address: '0x68749665FF8D2d112Fa859AA293F07A622782F38',
    decimals: 18,
    symbol: 'XAUt',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5176.png',
  },
  {
    chainId: 1,
    name: 'Celeum',
    address: '0x9f8f7ea504588a58b8b24b832b5d25a4aeb4706f',
    decimals: 18,
    symbol: 'CLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5179.png',
  },
  {
    chainId: 1,
    name: 'Bitcoffeen',
    address: '0x708aA4e8AaeAaD6074dD09cc4e5C52A70452eB39',
    decimals: 8,
    symbol: 'BFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5180.png',
  },
  {
    chainId: 1,
    name: 'BiLira',
    address: '0x2c537e5624e4af88a7ae4060c022609376c8d0eb',
    decimals: 18,
    symbol: 'TRYB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5181.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Message Search',
    address: '0x17e6616c45d267bc20a9892b58a01621c592b72d',
    decimals: 18,
    symbol: 'EMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5182.png',
  },
  {
    chainId: 1,
    name: 'ORCA Alliance',
    address: '0x6f59e0461ae5e2799f1fb3847f05a63b16d0dbf8',
    decimals: 18,
    symbol: 'ORCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5183.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Pro',
    address: '0x723cbfc05e2cfcc71d3d89e770d32801a5eef5ab',
    decimals: 8,
    symbol: 'BTCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5184.png',
  },
  {
    chainId: 1,
    name: 'KOK',
    address: '0x9b9647431632af44be02ddd22477ed94d14aacaa',
    decimals: 18,
    symbol: 'KOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5185.png',
  },
  {
    chainId: 1,
    name: 'ExtStock Token',
    address: '0xef65887a05415bf6316204b5ffb350d4d1a19bba',
    decimals: 18,
    symbol: 'XT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5186.png',
  },
  {
    chainId: 1,
    name: 'Jarvis Network',
    address: '0x8a9c67fee641579deba04928c4bc45f66e26343a',
    decimals: 18,
    symbol: 'JRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5187.png',
  },
  {
    chainId: 1,
    name: 'FLEX',
    address: '0xfcf8eda095e37a41e002e266daad7efc1579bc0a',
    decimals: 18,
    symbol: 'FLEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5190.png',
  },
  {
    chainId: 1,
    name: 'Unochain',
    address: '0x1fff4dd33105054e853955c6d0dba82859c01cff',
    decimals: 18,
    symbol: 'UNOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5193.png',
  },
  {
    chainId: 1,
    name: 'MEETtoken',
    address: '0xe54bed429c033bae5cb0747efa0f41beefd9e99a',
    decimals: 18,
    symbol: 'MTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5194.png',
  },
  {
    chainId: 1,
    name: 'Creditcoin',
    address: '0xa3ee21c306a700e682abcdfe9baa6a08f3820419',
    decimals: 18,
    symbol: 'CTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5198.png',
  },
  {
    chainId: 1,
    name: 'Rhea Protocol',
    address: '0xf7a219fffeade6cd98789da5642b687f743270eb',
    decimals: 18,
    symbol: 'RHEA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5202.png',
  },
  {
    chainId: 1,
    name: 'Perth Mint Gold Token',
    address: '0xaffcdd96531bcd66faed95fc61e443d08f79efef',
    decimals: 18,
    symbol: 'PMGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5203.png',
  },
  {
    chainId: 1,
    name: 'CitiOs',
    address: '0x688ff43c3c19e4714f0beb76df8ee394207ab411',
    decimals: 18,
    symbol: 'R2R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5204.png',
  },
  {
    chainId: 1,
    name: 'cryptomall',
    address: '0xd39aee2f2b6660ad6e86db6b3cb21cce6b0cd01f',
    decimals: 18,
    symbol: 'XMALL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5205.png',
  },
  {
    chainId: 1,
    name: 'StonieCoin BETA',
    address: '0x600606697fc8f644dfffcab1efd084d80b5f10bf',
    decimals: 18,
    symbol: 'STCB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5207.png',
  },
  {
    chainId: 1,
    name: 'Wallet Plus X',
    address: '0xb3BACe433288645114FE8e8aA91F87659CBF665b',
    decimals: 18,
    symbol: 'WPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5208.png',
  },
  {
    chainId: 1,
    name: 'NERVE',
    address: '0x4fd414c5ac6f8a17834d704ab431921ee93a4f2d',
    decimals: 18,
    symbol: 'NRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5209.png',
  },
  {
    chainId: 1,
    name: 'Doblone',
    address: '0xC9aFDea326c109D441519d355756f4e88465f94d',
    decimals: 8,
    symbol: 'DOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5212.png',
  },
  {
    chainId: 1,
    name: 'Elevation Token',
    address: '0x5aaa2182459377b6ca18b10712f9f602140764af',
    decimals: 8,
    symbol: 'EVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5215.png',
  },
  {
    chainId: 1,
    name: '3X Short Ethereum Token',
    address: '0x2f5e2c9002c058c063d21a06b6cabb50950130c8',
    decimals: 18,
    symbol: 'ETHBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5216.png',
  },
  {
    chainId: 1,
    name: '3X Long Ethereum Token',
    address: '0x871baed4088b863fd6407159f3672d70cd34837d',
    decimals: 18,
    symbol: 'ETHBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5217.png',
  },
  {
    chainId: 1,
    name: 'iShop Token',
    address: '0x7a4d70528c0b8d376c206b0fb2c9db1d26315c2d',
    decimals: 18,
    symbol: 'IST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5218.png',
  },
  {
    chainId: 1,
    name: 'USD Bancor',
    address: '0x309627af60f0926daa6041b8279484312f2bf060',
    decimals: 18,
    symbol: 'USDB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5219.png',
  },
  {
    chainId: 1,
    name: 'QURAS',
    address: '0x70da48f4b7e83c386ef983d4cef4e58c2c09d8ac',
    decimals: 8,
    symbol: 'XQC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5220.png',
  },
  {
    chainId: 1,
    name: 'Keep Calm and Hodl',
    address: '0xdb80734b094a3f964dedfd10e8946753ae0ac04c',
    decimals: 18,
    symbol: 'KCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5223.png',
  },
  {
    chainId: 1,
    name: 'Drip Inu',
    address: '0x4CCE2bB41a2B11D7746732DF21d48cAADB7Ab3ba',
    decimals: 18,
    symbol: 'ICY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5231.png',
  },
  {
    chainId: 1,
    name: 'FoPay',
    address: '0xAd966EC9087526F00019Ddc7d2e0284D72E80194',
    decimals: 3,
    symbol: 'FOPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5235.png',
  },
  {
    chainId: 1,
    name: 'UsPay',
    address: '0x452f6DE535f613B92443F5446AE4e7C1c4Ad01f2',
    decimals: 3,
    symbol: 'UPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5237.png',
  },
  {
    chainId: 1,
    name: 'Internet Of Things Future',
    address: '0xc3b4da2e8bcd06efe9993ae964666bb8be3068d1',
    decimals: 8,
    symbol: 'IOTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5239.png',
  },
  {
    chainId: 1,
    name: 'Dobuy',
    address: '0x7c82a76db0166b0e153a66b1a4c331970b2b0ee2',
    decimals: 18,
    symbol: 'DBY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5240.png',
  },
  {
    chainId: 1,
    name: 'BulkHead',
    address: '0x5d3dc0fdba0477b906ad4a36f95035b252060434',
    decimals: 8,
    symbol: 'BULK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5241.png',
  },
  {
    chainId: 1,
    name: 'Global Rental Token',
    address: '0x620fA2993046A53dF1f365fa3fDC9e6c7763AF96',
    decimals: 8,
    symbol: 'GRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5243.png',
  },
  {
    chainId: 1,
    name: 'Ethash',
    address: '0x90F08Cc8ddc43f5C01224F67fDf4640995139e8F',
    decimals: 8,
    symbol: 'HETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5244.png',
  },
  {
    chainId: 1,
    name: 'Zuflo Coin',
    address: '0x19fFfd124CD9089E21026d10dA97f8cD6B442Bff',
    decimals: 8,
    symbol: 'ZFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5247.png',
  },
  {
    chainId: 1,
    name: 'LinkArt',
    address: '0x6226caa1857afbc6dfb6ca66071eb241228031a1',
    decimals: 18,
    symbol: 'LAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5251.png',
  },
  {
    chainId: 1,
    name: 'The Hustle App',
    address: '0x56be94d29e1125d2d61d06629c1b251d72c1b3b3',
    decimals: 18,
    symbol: 'HUSL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5253.png',
  },
  {
    chainId: 1,
    name: 'Super Black Hole',
    address: '0x03fb52d4ee633ab0d06c833e32efdd8d388f3e6a',
    decimals: 18,
    symbol: 'HOLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5254.png',
  },
  {
    chainId: 1,
    name: 'LegalBlock',
    address: '0xd9af2d11d788da0097076f4eb21bd1c5533743d9',
    decimals: 18,
    symbol: 'LBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5255.png',
  },
  {
    chainId: 1,
    name: 'APIX',
    address: '0xf51EBf9a26DbC02B13F8B3a9110dac47a4d62D78',
    decimals: 18,
    symbol: 'APIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5258.png',
  },
  {
    chainId: 1,
    name: 'cUSD Currency',
    address: '0x5C406D99E04B8494dc253FCc52943Ef82bcA7D75',
    decimals: 6,
    symbol: 'CUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5260.png',
  },
  {
    chainId: 1,
    name: 'RideNode',
    address: '0x1D6364000DCae6C800AfF1a7086a2cD7c56f88c1',
    decimals: 18,
    symbol: 'RIDE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5261.png',
  },
  {
    chainId: 1,
    name: 'Hubi Token',
    address: '0xba5160ba66b286f1b9b6f3a57a6abcfa440e7aa2',
    decimals: 18,
    symbol: 'HUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5262.png',
  },
  {
    chainId: 1,
    name: 'Compound Dai',
    address: '0x5d3a536e4d6dbd6114cc1ead35777bab948e3643',
    decimals: 8,
    symbol: 'CDAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5263.png',
  },
  {
    chainId: 1,
    name: 'Compound SAI',
    address: '0xf5dce57282a584d2746faf1593d3121fcac444dc',
    decimals: 8,
    symbol: 'CSAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5264.png',
  },
  {
    chainId: 1,
    name: 'Compound USD Coin',
    address: '0x39aa39c021dfbae8fac545936693ac917d5e7563',
    decimals: 8,
    symbol: 'CUSDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5265.png',
  },
  {
    chainId: 1,
    name: 'QUEENBEE',
    address: '0x38bC89cF1f634C71896620bcD807Af235cBdEcd1',
    decimals: 18,
    symbol: 'QBZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5267.png',
  },
  {
    chainId: 1,
    name: 'Syntera',
    address: '0xffa9817f20ab5742ad016e094b42716cdd4fcb90',
    decimals: 18,
    symbol: 'SYNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5269.png',
  },
  {
    chainId: 1,
    name: 'SubSudio',
    address: '0xD7D7e034b5a9037A88659F734Bc216e7DF56e6FD',
    decimals: 8,
    symbol: 'SUBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5271.png',
  },
  {
    chainId: 1,
    name: 'Okschain',
    address: '0x7b68d272eda2185ea2f9283f241b1c44c51e712a',
    decimals: 18,
    symbol: 'OKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5272.png',
  },
  {
    chainId: 1,
    name: 'Paycoin',
    address: '0x3C2A309d9005433c1BC2C92EF1bE06489e5bf258',
    decimals: 18,
    symbol: 'PCI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5275.png',
  },
  {
    chainId: 1,
    name: 'Asac Coin',
    address: '0x6913ccabbc337f0ea7b4109dd8200d61c704d332',
    decimals: 8,
    symbol: 'ASAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5276.png',
  },
  {
    chainId: 1,
    name: 'SynchroBitcoin',
    address: '0x179e31fb25e433441a2839389a7b8ec9c4654b7b',
    decimals: 18,
    symbol: 'SNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5277.png',
  },
  {
    chainId: 1,
    name: 'Bloomzed Loyalty Club Ticket',
    address: '0x6d2c508fc4a588a41713ff59212f85489291d244',
    decimals: 18,
    symbol: 'BLCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5280.png',
  },
  {
    chainId: 1,
    name: 'FC Bitcoin',
    address: '0x4c6e796Bbfe5EB37F9E3E0f66C009C8Bf2A5f428',
    decimals: 8,
    symbol: 'FCBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5281.png',
  },
  {
    chainId: 1,
    name: 'Woonkly',
    address: '0x5a386eb0fcbfee3f0d759e263053c09162ff102d',
    decimals: 18,
    symbol: 'WOONK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5283.png',
  },
  {
    chainId: 1,
    name: 'LootUp',
    address: '0x4d138BEC0F79B729BE475443a1Eeb8557294d536',
    decimals: 18,
    symbol: 'LOOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5284.png',
  },
  {
    chainId: 1,
    name: 'Tweebaa',
    address: '0x2b6ff53fc2493ccd5202d80a6c439741414c5ff2',
    decimals: 18,
    symbol: 'TWEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5285.png',
  },
  {
    chainId: 1,
    name: 'Bidesk',
    address: '0xbfc1502ebc37475b940ced8f036b91018a73c8f6',
    decimals: 18,
    symbol: 'BDK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5288.png',
  },
  {
    chainId: 1,
    name: 'Odyssey',
    address: '0x026f8d523d49f36db657e012c96488465d8d88f9',
    decimals: 18,
    symbol: 'ODY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5289.png',
  },
  {
    chainId: 1,
    name: 'TradecoinX',
    address: '0x8648F07c8e367f4C71F63A523Bb222c397FaA196',
    decimals: 18,
    symbol: 'TDCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5290.png',
  },
  {
    chainId: 1,
    name: 'The Tokenized Bitcoin',
    address: '0x3212b29E33587A00FB1C83346f5dBFA69A458923',
    decimals: 8,
    symbol: 'imBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5292.png',
  },
  {
    chainId: 1,
    name: '3X Short BNB Token',
    address: '0x6febdfc0a9d9502c45343fce0df08828def44795',
    decimals: 18,
    symbol: 'BNBBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5294.png',
  },
  {
    chainId: 1,
    name: '3X Long BNB Token',
    address: '0x9d1a62c2ad99019768b9126fda004a9952853f6e',
    decimals: 18,
    symbol: 'BNBBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5295.png',
  },
  {
    chainId: 1,
    name: 'SuperSkynet',
    address: '0xa5b46ff9a887180c8fb2d97146398ddfc5fef1cd',
    decimals: 18,
    symbol: 'SSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5298.png',
  },
  {
    chainId: 1,
    name: 'HyperDAO',
    address: '0x74faab6986560fd1140508e4266d8a7b87274ffd',
    decimals: 18,
    symbol: 'HDAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5299.png',
  },
  {
    chainId: 1,
    name: 'Inex Project',
    address: '0xa2d77f8353cb2afd709aba4a967257511ecff716',
    decimals: 8,
    symbol: 'INEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5300.png',
  },
  {
    chainId: 1,
    name: 'Fail Token',
    address: '0x931a7ca74e35f35a46881a4f968d5fbd095a0279',
    decimals: 18,
    symbol: 'FAIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5301.png',
  },
  {
    chainId: 1,
    name: 'Saturn DAO Token',
    address: '0xb9440022a095343b440d590fcd2d7a3794bd76c8',
    decimals: 4,
    symbol: 'SATURN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5302.png',
  },
  {
    chainId: 1,
    name: 'MorCrypto Coin',
    address: '0xae746520ffdb15d0505e32f1d6e9a2b4ab866572',
    decimals: 18,
    symbol: 'MOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5304.png',
  },
  {
    chainId: 1,
    name: 'BTSE Token',
    address: '0x666d875c600aa06ac1cf15641361dec3b00432ef',
    decimals: 18,
    symbol: 'BTSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5305.png',
  },
  {
    chainId: 1,
    name: 'CoinJanitor',
    address: '0xaf80e6612d9c2e883122e7f2292ee6c34176ad4f',
    decimals: 18,
    symbol: 'JAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5306.png',
  },
  {
    chainId: 1,
    name: 'AIVIA',
    address: '0xc35aAea6dD561A9976E1745A22F8CC5A762354BB',
    decimals: 18,
    symbol: 'AIV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5307.png',
  },
  {
    chainId: 1,
    name: 'digitalUSD',
    address: '0x556eA1fE7Cb0964e7De8Dfe6CdE63F1E40908541',
    decimals: 18,
    symbol: 'DUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5308.png',
  },
  {
    chainId: 1,
    name: 'Instantily',
    address: '0x834625F5D8B006D70a6CaAEeF73C29442F156dAF',
    decimals: 18,
    symbol: 'TILY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5310.png',
  },
  {
    chainId: 1,
    name: 'CambuCoin',
    address: '0x61126afd2640efd6eb78bf7f2d23f09844079257',
    decimals: 2,
    symbol: 'CAMBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5311.png',
  },
  {
    chainId: 1,
    name: 'CONTRACOIN',
    address: '0xfd6c31bb6f05fc8db64f4b740ab758605c271fd8',
    decimals: 18,
    symbol: 'CTCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5313.png',
  },
  {
    chainId: 1,
    name: 'Seed Venture',
    address: '0xc969e16e63ff31ad4bcac3095c616644e6912d79',
    decimals: 18,
    symbol: 'SEED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5317.png',
  },
  {
    chainId: 1,
    name: 'ECXX',
    address: '0x820db309d58e67d98dadd0956837562461b76261',
    decimals: 8,
    symbol: 'ECXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5318.png',
  },
  {
    chainId: 1,
    name: 'FITCASH',
    address: '0xb414f8ec2d14c64f37b1559cbe43746284514596',
    decimals: 18,
    symbol: 'FTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5321.png',
  },
  {
    chainId: 1,
    name: 'GermanCoin',
    address: '0x44a67c8570a61a28bafd0035042f2f0a73a64428',
    decimals: 6,
    symbol: 'GCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5322.png',
  },
  {
    chainId: 1,
    name: 'Ethereum eRush',
    address: '0x3cC5EB07E0e1227613F1DF58f38b549823d11cB9',
    decimals: 18,
    symbol: 'EER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5323.png',
  },
  {
    chainId: 1,
    name: 'BIKI',
    address: '0x70debcdab2ef20be3d1dbff6a845e9ccb6e46930',
    decimals: 8,
    symbol: 'BIKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5325.png',
  },
  {
    chainId: 1,
    name: 'Orbit Chain',
    address: '0x662b67d00a13faf93254714dd601f5ed49ef2f51',
    decimals: 18,
    symbol: 'ORC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5326.png',
  },
  {
    chainId: 1,
    name: 'Oldtimer',
    address: '0x6e514de4c2675feeb51d759977b4222dc65556af',
    decimals: 4,
    symbol: 'OLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5327.png',
  },
  {
    chainId: 1,
    name: 'WOM Protocol',
    address: '0xBd356a39BFf2cAda8E9248532DD879147221Cf76',
    decimals: 18,
    symbol: 'WOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5328.png',
  },
  {
    chainId: 1,
    name: 'Shardus',
    address: '0x09617f6fd6cf8a71278ec86e23bbab29c04353a7',
    decimals: 18,
    symbol: 'ULT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5330.png',
  },
  {
    chainId: 1,
    name: 'RAKUN',
    address: '0x51bc0deaf7bbe82bc9006b0c3531668a4206d27f',
    decimals: 18,
    symbol: 'RAKU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5334.png',
  },
  {
    chainId: 1,
    name: 'Homeros',
    address: '0xB1A30851E3f7d841b231B086479608e17198363A',
    decimals: 18,
    symbol: 'HMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5336.png',
  },
  {
    chainId: 1,
    name: 'Somnium Space Cubes',
    address: '0xdf801468a808a32656d2ed2d2d80b72a129739f4',
    decimals: 8,
    symbol: 'CUBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5338.png',
  },
  {
    chainId: 1,
    name: 'RAKSUR',
    address: '0x393fac0773c765c80dc887451377d553c46f83b1',
    decimals: 18,
    symbol: 'RAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5339.png',
  },
  {
    chainId: 1,
    name: 'Fleshy Tender ONE',
    address: '0xae98dfab7a1dcc624f1431276a8b94b75dad70bc',
    decimals: 18,
    symbol: 'FT1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5340.png',
  },
  {
    chainId: 1,
    name: 'Easy Coin DIgital Freedom',
    address: '0x406ab55c0bab2d4a3361f87f251211c3090d80bc',
    decimals: 18,
    symbol: 'ECDF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5341.png',
  },
  {
    chainId: 1,
    name: 'IG Crypto Holding',
    address: '0x0d6f4A17A7864Cb7222eBF41373305fB629C199a',
    decimals: 18,
    symbol: 'IGCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5342.png',
  },
  {
    chainId: 1,
    name: 'VianeXGold',
    address: '0x566ff8d8bd6de69d2af4e3cf9153e2cc77c7972f',
    decimals: 18,
    symbol: 'VIXG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5344.png',
  },
  {
    chainId: 1,
    name: 'AdsByWiFi',
    address: '0x24b80fba4b2ecaf0c4df522354408f0a59a775c8',
    decimals: 8,
    symbol: 'WADS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5347.png',
  },
  {
    chainId: 1,
    name: 'XPR Network',
    address: '0xd7efb00d12c2c13131fd319336fdf952525da2af',
    decimals: 18,
    symbol: 'XPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5350.png',
  },
  {
    chainId: 1,
    name: 'PEAKDEFI',
    address: '0x630d98424efe0ea27fb1b3ab7741907dffeaad78',
    decimals: 8,
    symbol: 'PEAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5354.png',
  },
  {
    chainId: 1,
    name: 'ABB token',
    address: '0xc1c7883ea017b083b6167040dbb9c156a8e6b9e9',
    decimals: 18,
    symbol: 'ABB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5357.png',
  },
  {
    chainId: 1,
    name: 'KingCoin',
    address: '0xac5470280C680956b1851F4ef9330F32E6fd243F',
    decimals: 18,
    symbol: 'KNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5360.png',
  },
  {
    chainId: 1,
    name: 'ZXTH',
    address: '0xF9933cb5f0397bf020Bb950C307e30dd8f62080f',
    decimals: 18,
    symbol: 'ZXTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5361.png',
  },
  {
    chainId: 1,
    name: 'Cryptobuyer',
    address: '0x08aa0ed0040736dd28d4c8b16ab453b368248d19',
    decimals: 18,
    symbol: 'XPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5363.png',
  },
  {
    chainId: 1,
    name: 'GoalTime N',
    address: '0x916885426255235DA7a0BD90447986c00675f9EC',
    decimals: 18,
    symbol: 'GTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5366.png',
  },
  {
    chainId: 1,
    name: 'ODE',
    address: '0x6f6d15e2dabd182c7c0830db1bdff1f920b57ffa',
    decimals: 18,
    symbol: 'ODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5367.png',
  },
  {
    chainId: 1,
    name: 'Amazing Unit',
    address: '0x1e9421331f19e6c4ba79bce22582e3f34c4cf506',
    decimals: 18,
    symbol: 'AMU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5371.png',
  },
  {
    chainId: 1,
    name: 'IVOCoin',
    address: '0x39a82cff617804bd2432ae8acb849c2e2faef1d9',
    decimals: 18,
    symbol: 'IVO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5372.png',
  },
  {
    chainId: 1,
    name: 'IZEROIUM',
    address: '0xab5c04bbe42667610a2da07ac98ea9fa6e4a9514',
    decimals: 8,
    symbol: 'IZER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5373.png',
  },
  {
    chainId: 1,
    name: 'Hashthereum',
    address: '0x500d15aA5b01E7eb77e4D4C8283Df3E6c49Da754',
    decimals: 18,
    symbol: 'HETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5374.png',
  },
  {
    chainId: 1,
    name: 'CryptoEnergy',
    address: '0xc21dBEE65D62770953035f0434C532d578a666c9',
    decimals: 18,
    symbol: 'CNRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5376.png',
  },
  {
    chainId: 1,
    name: 'OZAPHYRE',
    address: '0x5a2cb3a4c215a0e869acdba7ebde0fa1c899523f',
    decimals: 18,
    symbol: 'OZP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5377.png',
  },
  {
    chainId: 1,
    name: '3X Long TRX Token',
    address: '0xc175E77b04F2341517334Ea3Ed0b198A01A97383',
    decimals: 18,
    symbol: 'TRXBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5378.png',
  },
  {
    chainId: 1,
    name: '3X Short TRX Token',
    address: '0x86807Da5B92d31F67E128771CAcb85F3579646eA',
    decimals: 18,
    symbol: 'TRXBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5379.png',
  },
  {
    chainId: 1,
    name: 'Hunt Town',
    address: '0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5',
    decimals: 18,
    symbol: 'HUNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5380.png',
  },
  {
    chainId: 1,
    name: 'ELYSIA',
    address: '0x2781246fe707bb15cee3e5ea354e2154a2877b16',
    decimals: 18,
    symbol: 'EL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5382.png',
  },
  {
    chainId: 1,
    name: 'B ONE PAYMENT',
    address: '0x4b742b5bdb1d252907ae7f399a891d4a178dbc24',
    decimals: 18,
    symbol: 'B1P',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5383.png',
  },
  {
    chainId: 1,
    name: 'ALA',
    address: '0xbcc7026cde024c6a97d2df6e40613217d946279c',
    decimals: 18,
    symbol: 'ALA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5384.png',
  },
  {
    chainId: 1,
    name: 'Xaviera Tech',
    address: '0x36232b1328e49a043434e71c02c0dc2be278e975',
    decimals: 18,
    symbol: 'XTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5385.png',
  },
  {
    chainId: 1,
    name: 'CelCoin',
    address: '0x19b58d95929586ad750893caad43e77aa6e8ce9e',
    decimals: 8,
    symbol: 'CELC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5388.png',
  },
  {
    chainId: 1,
    name: 'Insula',
    address: '0x697ef32b4a3f5a4c39de1cb7563f24ca7bfc5947',
    decimals: 18,
    symbol: 'ISLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5389.png',
  },
  {
    chainId: 1,
    name: 'Wallabee',
    address: '0xb8e2e9dddc504688cfe925b9ace8017d48d3e095',
    decimals: 18,
    symbol: 'WLB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5390.png',
  },
  {
    chainId: 1,
    name: 'Ethash Miner',
    address: '0x7a5e6ca9d335e343d1ed12239f67248e056afe2f',
    decimals: 6,
    symbol: 'HETM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5391.png',
  },
  {
    chainId: 1,
    name: 'Touch Social',
    address: '0xd9bae39c725a1864b1133ad0ef1640d02f79b78c',
    decimals: 18,
    symbol: 'TST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5393.png',
  },
  {
    chainId: 1,
    name: 'Work Force Coin',
    address: '0x3f038991d7359daaeb8290483e6cd7d7bd6a6df2',
    decimals: 2,
    symbol: 'WFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5394.png',
  },
  {
    chainId: 1,
    name: 'FEEX',
    address: '0xbb21e4dfefcbd0cc5c39883ca69414510607ff9b',
    decimals: 8,
    symbol: 'FEEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5395.png',
  },
  {
    chainId: 1,
    name: 'Castweet',
    address: '0x1a4743cf1af4c289351390a2b3fe7c13d2f7c235',
    decimals: 18,
    symbol: 'CTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5397.png',
  },
  {
    chainId: 1,
    name: 'SappChain',
    address: '0x4df76a9dab9bb8310e4ad3dc4336a8e26ed24ebb',
    decimals: 18,
    symbol: 'SAPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5398.png',
  },
  {
    chainId: 1,
    name: 'TILWIKI',
    address: '0x06f3cdabae564b0546529b4dd8fef1bcd4235753',
    decimals: 8,
    symbol: 'TLW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5399.png',
  },
  {
    chainId: 1,
    name: 'Charg Coin',
    address: '0xc4a86561cb0b7ea1214904f26e6d50fd357c7986',
    decimals: 18,
    symbol: 'CHG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5400.png',
  },
  {
    chainId: 1,
    name: 'CoinLoan',
    address: '0x2001f2a0cf801ecfda622f6c28fb6e10d803d969',
    decimals: 18,
    symbol: 'CLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5401.png',
  },
  {
    chainId: 1,
    name: 'Bitcurate',
    address: '0x0371f7b219fff864b437bcfb564810f323fffcca',
    decimals: 4,
    symbol: 'BTCR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5404.png',
  },
  {
    chainId: 1,
    name: '4P FOUR',
    address: '0x4730fb1463a6f1f44aeb45f6c5c422427f37f4d0',
    decimals: 18,
    symbol: 'FOUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5409.png',
  },
  {
    chainId: 1,
    name: 'PARSIQ',
    address: '0x362bc847A3a9637d3af6624EeC853618a43ed7D2',
    decimals: 18,
    symbol: 'PRQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5410.png',
  },
  {
    chainId: 1,
    name: '3x Long XRP Token',
    address: '0x27c1bA4F85b8dC1c150157816623A6Ce80b7F187',
    decimals: 18,
    symbol: 'XRPBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5412.png',
  },
  {
    chainId: 1,
    name: '3x Short XRP Token',
    address: '0x94FC5934cF5970E944a67de806eEB5a4b493c6E6',
    decimals: 18,
    symbol: 'XRPBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5413.png',
  },
  {
    chainId: 1,
    name: '3x Long EOS Token',
    address: '0xeaD7F3ae4e0Bb0D8785852Cc37CC9d0B5e75c06a',
    decimals: 18,
    symbol: 'EOSBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5414.png',
  },
  {
    chainId: 1,
    name: '3x Short EOS Token',
    address: '0x3d3dd61b0F9A558759a21dA42166042B114E12D5',
    decimals: 18,
    symbol: 'EOSBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5415.png',
  },
  {
    chainId: 1,
    name: 'Greeneum Network',
    address: '0xe0a16435df493bd17a58cb2ee58675f5ea069517',
    decimals: 18,
    symbol: 'GREEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5417.png',
  },
  {
    chainId: 1,
    name: 'Latamcash',
    address: '0x9205c049c231dda51bace0ba569f047e3e1e9979',
    decimals: 18,
    symbol: 'LMCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5418.png',
  },
  {
    chainId: 1,
    name: 'SonoCoin',
    address: '0x0D15009896EfE9972F8E086bdD3BcBa5c1f74bF3',
    decimals: 18,
    symbol: 'SONO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5420.png',
  },
  {
    chainId: 1,
    name: 'Pyrrhos Gold',
    address: '0xf02dab52205aff6bb3d47cc7b21624a5064f9fba',
    decimals: 4,
    symbol: 'PGOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5421.png',
  },
  {
    chainId: 1,
    name: 'Hinto',
    address: '0x24fb4c36a83cbdbcd670856406f622e09a643d4d',
    decimals: 5,
    symbol: 'HNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5422.png',
  },
  {
    chainId: 1,
    name: 'DSLA Protocol',
    address: '0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe',
    decimals: 18,
    symbol: 'DSLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5423.png',
  },
  {
    chainId: 1,
    name: 'Mesefa',
    address: '0x27201232579491Ce9b116Ac6F37D354Cc723A2f3',
    decimals: 18,
    symbol: 'SEFA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5425.png',
  },
  {
    chainId: 1,
    name: 'Vid',
    address: '0x8b6c3b7C01D9dB4393f9aa734750F36df1543E9A',
    decimals: 18,
    symbol: 'VI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5428.png',
  },
  {
    chainId: 1,
    name: 'DEAPcoin',
    address: '0x1a3496c18d558bd9c6c8f609e1b129f67ab08163',
    decimals: 18,
    symbol: 'DEP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5429.png',
  },
  {
    chainId: 1,
    name: 'SatoExchange Token',
    address: '0xe96f2c381e267a96c29bbb8ab05ab7d3527b45ab',
    decimals: 8,
    symbol: 'SATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5430.png',
  },
  {
    chainId: 1,
    name: 'SINERGIA',
    address: '0xcFD6Ae8BF13f42DE14867351eAff7A8A3b9FbBe7',
    decimals: 18,
    symbol: 'SNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5431.png',
  },
  {
    chainId: 1,
    name: 'pTokens BTC',
    address: '0x62199B909FB8B8cf870f97BEf2cE6783493c4908',
    decimals: 18,
    symbol: 'pBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5434.png',
  },
  {
    chainId: 1,
    name: 'Hug Oxytocin',
    address: '0x956eaaaacb521558cd4485115df412aa01f1057e',
    decimals: 18,
    symbol: 'HOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5438.png',
  },
  {
    chainId: 1,
    name: 'Entherfound',
    address: '0xc2b58812c24020ea924c3d7c241c441605f12e75',
    decimals: 8,
    symbol: 'ETF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5441.png',
  },
  {
    chainId: 1,
    name: 'Cartesi',
    address: '0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d',
    decimals: 18,
    symbol: 'CTSI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5444.png',
  },
  {
    chainId: 1,
    name: 'LBK',
    address: '0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6',
    decimals: 8,
    symbol: 'LBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5445.png',
  },
  {
    chainId: 1,
    name: 'Metaprediction',
    address: '0x108d27f9c4b2a98c025c94c76ca78c6ce6c7a4eb',
    decimals: 18,
    symbol: 'METP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5448.png',
  },
  {
    chainId: 1,
    name: 'Wibx',
    address: '0xbb97e381f1d1e94ffa2a5844f6875e6146981009',
    decimals: 18,
    symbol: 'WBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5450.png',
  },
  {
    chainId: 1,
    name: 'Puregold',
    address: '0xc949fc82a15964fb5b97e5cf8f9ffed139086821',
    decimals: 18,
    symbol: 'PGPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5451.png',
  },
  {
    chainId: 1,
    name: 'InTime',
    address: '0x293B0Cd0991DB07c8529fEBb01bc7D052315C5Ab',
    decimals: 18,
    symbol: 'ITO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5452.png',
  },
  {
    chainId: 1,
    name: 'KardiaChain',
    address: '0xD9Ec3ff1f8be459Bb9369b4E79e9Ebcf7141C093',
    decimals: 18,
    symbol: 'KAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5453.png',
  },
  {
    chainId: 1,
    name: 'OnTime',
    address: '0x028CE5EA3298a50c0D8a27b937b1F48Cf0d68b56',
    decimals: 18,
    symbol: 'OTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5454.png',
  },
  {
    chainId: 1,
    name: 'Two Prime FF1 Token',
    address: '0x59af0356cdebd1fa23ae5dadff9170bbfc31278c',
    decimals: 18,
    symbol: 'FF1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5457.png',
  },
  {
    chainId: 1,
    name: 'WONCOIN',
    address: '0xbe68b4645ab798ed4db88192a444898ff4fda5ae',
    decimals: 8,
    symbol: 'WON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5458.png',
  },
  {
    chainId: 1,
    name: '3x Short Bitcoin SV Token',
    address: '0xCe49c3c92b33a1653F34811a9d7e34502bF12B89',
    decimals: 18,
    symbol: 'BSVBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5459.png',
  },
  {
    chainId: 1,
    name: '3x Long Bitcoin SV Token',
    address: '0x6e13A9e4AE3d0678E511Fb6d2ad531fcF0e247bf',
    decimals: 18,
    symbol: 'BSVBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5460.png',
  },
  {
    chainId: 1,
    name: '3x Short Litecoin Token',
    address: '0xB422e605fBd765B80D2C4b5d8196C2f94144438B',
    decimals: 18,
    symbol: 'LTCBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5461.png',
  },
  {
    chainId: 1,
    name: '3x Long Litecoin Token',
    address: '0xDB61354E9cf2217a29770E9811832B360a8DAad3',
    decimals: 18,
    symbol: 'LTCBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5462.png',
  },
  {
    chainId: 1,
    name: '3x Short Tezos Token',
    address: '0xbc41d05287498DEc58129560De6bd1b8d4E3aC1d',
    decimals: 18,
    symbol: 'XTZBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5463.png',
  },
  {
    chainId: 1,
    name: '3x Long Tezos Token',
    address: '0x8AF17a6396c8f315f6b6DBC6AA686C85f9b3E554',
    decimals: 18,
    symbol: 'XTZBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5464.png',
  },
  {
    chainId: 1,
    name: 'Alchemy',
    address: '0xB62D46A21fef0fADb5b92fC5eF7077E71e65631c',
    decimals: 18,
    symbol: 'ACOIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5465.png',
  },
  {
    chainId: 1,
    name: '3x Short Bitcoin Cash Token',
    address: '0xa9fC65Da36064cE545e87690e06f5de10C52C690',
    decimals: 18,
    symbol: 'BCHBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5466.png',
  },
  {
    chainId: 1,
    name: '3x Long Bitcoin Cash Token',
    address: '0x4C133E081dFB5858e39ccA74E69bf603d409e57A',
    decimals: 18,
    symbol: 'BCHBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5467.png',
  },
  {
    chainId: 1,
    name: 'Isiklar Coin',
    address: '0x4339befb55cfa65344ef6f4bb7f05fae3458670a',
    decimals: 4,
    symbol: 'ISIKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5468.png',
  },
  {
    chainId: 1,
    name: 'AMATEN',
    address: '0x2509ee05b8df07ec75046e24bbf1cfcdb8b2a183',
    decimals: 18,
    symbol: 'AMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5469.png',
  },
  {
    chainId: 1,
    name: 'CRDT',
    address: '0xDaab5E695bb0E8Ce8384ee56BA38fA8290618e52',
    decimals: 18,
    symbol: 'CRDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5473.png',
  },
  {
    chainId: 1,
    name: 'ECOSC',
    address: '0x8fc9b6354E839AB1c8B31F4afa53607092B8C2e5',
    decimals: 18,
    symbol: 'ECU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5478.png',
  },
  {
    chainId: 1,
    name: 'Bali Coin',
    address: '0x013a06558f07d9e6f9a00c95a33f3a0e0255176b',
    decimals: 18,
    symbol: 'BALI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5480.png',
  },
  {
    chainId: 1,
    name: 'BASIC',
    address: '0xf25c91c87e0b1fd9b4064af0f427157aab0193a7',
    decimals: 18,
    symbol: 'BASIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5481.png',
  },
  {
    chainId: 1,
    name: 'Bitcollar Max',
    address: '0xf5bb691215fd2839bc14aa93335e13d839a4767f',
    decimals: 18,
    symbol: 'BORX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5484.png',
  },
  {
    chainId: 1,
    name: 'Jack Token',
    address: '0x4e12eb8e506ccd1427f6b8f7faa3e88fb698eb28',
    decimals: 18,
    symbol: 'JACK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5486.png',
  },
  {
    chainId: 1,
    name: 'EarnBet',
    address: '0xfdd4e938bb067280a52ac4e02aaf1502cc882ba6',
    decimals: 4,
    symbol: 'BET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5487.png',
  },
  {
    chainId: 1,
    name: 'Sudan Gold Coin',
    address: '0x80bD0cc689c206e3F642919244c4251c7Ef19852',
    decimals: 18,
    symbol: 'SGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5489.png',
  },
  {
    chainId: 1,
    name: 'Lux Bio Cell',
    address: '0xffe510a92434a0df346c5e72a3494b043cf249eb',
    decimals: 18,
    symbol: 'LBXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5490.png',
  },
  {
    chainId: 1,
    name: 'eToro United States Dollar',
    address: '0x4e3856c37b2fe7ff2fe34510cda82a1dffd63cd0',
    decimals: 18,
    symbol: 'USDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5491.png',
  },
  {
    chainId: 1,
    name: 'eToro Canadian Dollar',
    address: '0x8ed876e408959643479534a21970ec023d0fb51e',
    decimals: 18,
    symbol: 'CADX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5492.png',
  },
  {
    chainId: 1,
    name: 'eToro Pound Sterling',
    address: '0xf85ef57fcdb36d628d063fa663e61e44d35ae661',
    decimals: 18,
    symbol: 'GBPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5493.png',
  },
  {
    chainId: 1,
    name: 'eToro New Zealand Dollar',
    address: '0x6871799a4866bb9068b36b7a9bb93475ac77ac5d',
    decimals: 18,
    symbol: 'NZDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5494.png',
  },
  {
    chainId: 1,
    name: 'eToro Swiss Franc',
    address: '0xe435502c85a4e7e79cfab4167af566c27a7a0784',
    decimals: 18,
    symbol: 'CHFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5495.png',
  },
  {
    chainId: 1,
    name: 'eToro Hong Kong Dollar',
    address: '0x1Af20b8D1eDe928F437B3A86801796B167840d2b',
    decimals: 18,
    symbol: 'HKDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5496.png',
  },
  {
    chainId: 1,
    name: 'eToro Turkish Lira',
    address: '0x6faff971d9248e7d398a98fdbe6a81f6d7489568',
    decimals: 18,
    symbol: 'TRYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5497.png',
  },
  {
    chainId: 1,
    name: 'eToro South African Rand',
    address: '0x29ec3ff4e1dcad5a207dbd5d14e48073abba0bd3',
    decimals: 18,
    symbol: 'ZARX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5498.png',
  },
  {
    chainId: 1,
    name: 'eToro Chinese Yuan',
    address: '0x319ad3ff82bedddb3bc85fd7943002d25cdb3cb9',
    decimals: 18,
    symbol: 'CNYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5499.png',
  },
  {
    chainId: 1,
    name: 'eToro Singapore Dollar',
    address: '0x0e3e965aCFfB719e2f5dD4309969E2Debe6215dD',
    decimals: 18,
    symbol: 'SGDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5500.png',
  },
  {
    chainId: 1,
    name: 'eToro Polish Zloty',
    address: '0xaAce6480798b4A7b596ec4ce3A26b8de9b9Ae2E2',
    decimals: 18,
    symbol: 'PLNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5501.png',
  },
  {
    chainId: 1,
    name: 'eToro Russian Ruble',
    address: '0xd6d69a3d5e51dbc2636dc332338765fcca71d5d5',
    decimals: 18,
    symbol: 'RUBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5502.png',
  },
  {
    chainId: 1,
    name: 'eToro Japanese Yen',
    address: '0x743c79f88dcadc6e7cfd7fa2bd8e2bfc68dae053',
    decimals: 18,
    symbol: 'JPYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5503.png',
  },
  {
    chainId: 1,
    name: 'eToro Australian Dollar',
    address: '0xdf1e9e1a218cff9888faef311d6fbb472e4175ce',
    decimals: 18,
    symbol: 'AUDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5504.png',
  },
  {
    chainId: 1,
    name: 'eToro Gold',
    address: '0x7d2bebd6e41b05384f0a8eb8ff228daac6f39c96',
    decimals: 18,
    symbol: 'GOLDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5505.png',
  },
  {
    chainId: 1,
    name: 'eToro Silver',
    address: '0x8e4d222dbd4f8f9e7c175e77d6e71715c3da78e0',
    decimals: 18,
    symbol: 'SLVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5506.png',
  },
  {
    chainId: 1,
    name: 'eToro Euro',
    address: '0x05ac103f68e05da35e78f6165b9082432fe64b58',
    decimals: 18,
    symbol: 'EURX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5507.png',
  },
  {
    chainId: 1,
    name: 'Algory Project',
    address: '0x16b0a1a87ae8af5c792fabc429c4fe248834842b',
    decimals: 18,
    symbol: 'ALG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5508.png',
  },
  {
    chainId: 1,
    name: 'AAX Token',
    address: '0x686c650dbcfeaa75d09b883621ad810f5952bd5d',
    decimals: 18,
    symbol: 'AAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5509.png',
  },
  {
    chainId: 1,
    name: 'Crypto Holding Frank Token',
    address: '0x58002a6b6e659a16de9f02f529b10536e307b0d9',
    decimals: 18,
    symbol: 'CHFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5513.png',
  },
  {
    chainId: 1,
    name: 'The Transfer Token',
    address: '0x2494a68C1484376fEf880b4c24D91f049d29B02A',
    decimals: 18,
    symbol: 'TTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5514.png',
  },
  {
    chainId: 1,
    name: 'LOA Protocol',
    address: '0x7458fd786B2fe8CD801C0381f88b61C5071A006F',
    decimals: 18,
    symbol: 'LOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5516.png',
  },
  {
    chainId: 1,
    name: 'Ourbloc',
    address: '0x78a685e0762096ed0f98107212e98f8c35a9d1d8',
    decimals: 10,
    symbol: 'DAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5517.png',
  },
  {
    chainId: 1,
    name: 'Torex',
    address: '0x9ea20fbfaa44efbc60c6728fcdba17f01b7e04fe',
    decimals: 8,
    symbol: 'TOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5518.png',
  },
  {
    chainId: 1,
    name: 'SetoCoin',
    address: '0xc1a29a42876ff31D6c30341f5CF400dD8e766d91',
    decimals: 8,
    symbol: 'SET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5519.png',
  },
  {
    chainId: 1,
    name: 'EzyStayz',
    address: '0xA6D5C720a9af5A405dFB6b9F44Fc44FaB5D4A58D',
    decimals: 18,
    symbol: 'EZY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5521.png',
  },
  {
    chainId: 1,
    name: 'Aragon Court',
    address: '0xcD62b1C403fa761BAadFC74C525ce2B51780b184',
    decimals: 18,
    symbol: 'ANJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5523.png',
  },
  {
    chainId: 1,
    name: 'GlobalEdu',
    address: '0xd0464A1985edB76Ba82602534a2d89d8cCf3B7Ec',
    decimals: 2,
    symbol: 'GEFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5525.png',
  },
  {
    chainId: 1,
    name: 'Becaz',
    address: '0x08399ab5eBBE96870B289754A7bD21E7EC8c6FCb',
    decimals: 18,
    symbol: 'BCZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5527.png',
  },
  {
    chainId: 1,
    name: 'Xenon',
    address: '0x5fbdb42bb048c685c990a37f2c87fe087c586655',
    decimals: 8,
    symbol: 'XEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5528.png',
  },
  {
    chainId: 1,
    name: 'REBIT',
    address: '0xcE13aBCE0DB5A8224616ef24D3979d466F19CF90',
    decimals: 18,
    symbol: 'KEYT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5530.png',
  },
  {
    chainId: 1,
    name: 'SKINCHAIN',
    address: '0x0fE156436F203B114C6c562Cb1a2A81aa2801090',
    decimals: 18,
    symbol: 'SKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5533.png',
  },
  {
    chainId: 1,
    name: 'Inverse Bitcoin Volatility Token',
    address: '0x627e2ee3dbda546e168eaaff25a2c5212e4a95a0',
    decimals: 18,
    symbol: 'IBVOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5534.png',
  },
  {
    chainId: 1,
    name: 'AtromG8',
    address: '0x0a8b16b27d5219c8c6b57d5442ce31d81573eee4',
    decimals: 18,
    symbol: 'AG8',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5536.png',
  },
  {
    chainId: 1,
    name: 'Buzzshow',
    address: '0x594207c791afd06a8d087d84d99d1da53ccbd45f',
    decimals: 18,
    symbol: 'GLDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5538.png',
  },
  {
    chainId: 1,
    name: 'VeraOne',
    address: '0x10BC518c32fbAE5e38Ecb50A612160571bD81e44',
    decimals: 8,
    symbol: 'VRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5539.png',
  },
  {
    chainId: 1,
    name: 'Mt Pelerin Shares',
    address: '0x96c645d3d3706f793ef52c19bbace441900ed47d',
    decimals: 18,
    symbol: 'MPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5540.png',
  },
  {
    chainId: 1,
    name: 'Xaya',
    address: '0x6DC02164d75651758aC74435806093E421b64605',
    decimals: 18,
    symbol: 'CHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5541.png',
  },
  {
    chainId: 1,
    name: '1x Long Bitcoin Implied Volatility Token',
    address: '0x81824663353a9d29b01b2de9dd9a2bb271d298cd',
    decimals: 18,
    symbol: 'BVOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5542.png',
  },
  {
    chainId: 1,
    name: 'Aluna.Social',
    address: '0x8185bc4757572da2a610f887561c32298f1a5748',
    decimals: 18,
    symbol: 'ALN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5544.png',
  },
  {
    chainId: 1,
    name: 'NFX Coin',
    address: '0x2d39ec4da54329d28d230b4973f5aa27886c3aee',
    decimals: 18,
    symbol: 'NFXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5545.png',
  },
  {
    chainId: 1,
    name: 'United Bull Traders',
    address: '0xcabec58a571979f9fe825885fcb8f7a93892eab0',
    decimals: 18,
    symbol: 'UNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5546.png',
  },
  {
    chainId: 1,
    name: 'Cronos Coin',
    address: '0xddf993bebbd397f2a42de7c39f09f9c8e34ef322',
    decimals: 18,
    symbol: 'CRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5547.png',
  },
  {
    chainId: 1,
    name: 'BeeEx',
    address: '0x1763ad73694d4d64fb71732b068e32ac72a345b1',
    decimals: 18,
    symbol: 'BEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5550.png',
  },
  {
    chainId: 1,
    name: 'Vanywhere',
    address: '0x4edd66235349e353eb8cb8e40596599644bfe91c',
    decimals: 18,
    symbol: 'VANY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5554.png',
  },
  {
    chainId: 1,
    name: 'Universal Protocol Token',
    address: '0x6ca88cc8d9288f5cad825053b6a1b179b05c76fc',
    decimals: 18,
    symbol: 'UPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5555.png',
  },
  {
    chainId: 1,
    name: 'Resfinex Token',
    address: '0x0a9f693fce6f00a51a8e0db4351b5a8078b4242e',
    decimals: 5,
    symbol: 'RES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5556.png',
  },
  {
    chainId: 1,
    name: 'Trustlines Network',
    address: '0x679131F591B4f369acB8cd8c51E68596806c3916',
    decimals: 18,
    symbol: 'TLN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5557.png',
  },
  {
    chainId: 1,
    name: 'Idea Chain Coin',
    address: '0xf8483E2d6560585C02D46bF7B3186Bf154a96166',
    decimals: 8,
    symbol: 'ICH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5560.png',
  },
  {
    chainId: 1,
    name: 'Palmes',
    address: '0x80d211718f9b9ba31959a14328acd8d8c9d5382f',
    decimals: 6,
    symbol: 'PLM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5562.png',
  },
  {
    chainId: 1,
    name: 'ARMTOKEN',
    address: '0xcDd0A6B15B49A9eb3Ce011CCE22FAc2ccf09ecE6',
    decimals: 18,
    symbol: 'TARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5564.png',
  },
  {
    chainId: 1,
    name: 'EANTO',
    address: '0xB4742e2013f96850a5CeF850A3bB74cF63B9a5D5',
    decimals: 18,
    symbol: 'EAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5565.png',
  },
  {
    chainId: 1,
    name: 'Keep Network',
    address: '0x85eee30c52b0b379b046fb0f85f4f3dc3009afec',
    decimals: 18,
    symbol: 'KEEP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5566.png',
  },
  {
    chainId: 1,
    name: 'Cash Per Scan',
    address: '0xb5a52519426ec6d88784cc80e621062498306734',
    decimals: 18,
    symbol: 'CPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5568.png',
  },
  {
    chainId: 1,
    name: 'Cannadrix',
    address: '0x91E84EC6101547C1FA39Dd565dd8b020E3c20CF2',
    decimals: 18,
    symbol: 'CND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5569.png',
  },
  {
    chainId: 1,
    name: 'Astra Network',
    address: '0x212fa406fd28663ee6110d863a18e80960300e5c',
    decimals: 18,
    symbol: 'ANX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5571.png',
  },
  {
    chainId: 1,
    name: 'newstokens',
    address: '0x94B593002a327f2A3f1B190c50D3bcc8b869B5F5',
    decimals: 18,
    symbol: 'news',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5574.png',
  },
  {
    chainId: 1,
    name: 'BeNative Digital Voucher',
    address: '0xbbdce056cbe561ee004094c75099172e7e3b34df',
    decimals: 18,
    symbol: 'BNV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5576.png',
  },
  {
    chainId: 1,
    name: 'Litecoin SV',
    address: '0xee059f0ca1507e4e20c689b20cff71b5e924f7bd',
    decimals: 18,
    symbol: 'LSV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5577.png',
  },
  {
    chainId: 1,
    name: 'Video Games Token',
    address: '0xb52fc0f17df38ad76f290467aab57cabaeeada14',
    decimals: 18,
    symbol: 'VGTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5579.png',
  },
  {
    chainId: 1,
    name: 'IDK',
    address: '0x61fd1c62551850d0c04c76fce614cbced0094498',
    decimals: 8,
    symbol: 'IDK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5580.png',
  },
  {
    chainId: 1,
    name: 'SmartChain Protocol',
    address: '0x4df2c7ec048f69BBA12098BF71a15aFeeAAf0c4B',
    decimals: 18,
    symbol: 'XSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5581.png',
  },
  {
    chainId: 1,
    name: 'DollarLite',
    address: '0x656a8685729a22d043735392523E6Ce660428099',
    decimals: 18,
    symbol: 'DLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5582.png',
  },
  {
    chainId: 1,
    name: 'Hacken Token',
    address: '0x05Fb86775Fd5c16290f1E838F5caaa7342bD9a63',
    decimals: 18,
    symbol: 'HAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5583.png',
  },
  {
    chainId: 1,
    name: 'Valireum',
    address: '0x3989F36540052668c340a53aaeAcB46D6cF0Dd6C',
    decimals: 18,
    symbol: 'VLM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5586.png',
  },
  {
    chainId: 1,
    name: '2key.network',
    address: '0xe48972fcd82a274411c01834e2f031d4377fa2c0',
    decimals: 18,
    symbol: '2KEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5587.png',
  },
  {
    chainId: 1,
    name: 'DXdao',
    address: '0xa1d65e8fb6e87b60feccbc582f7f97804b725521',
    decimals: 18,
    symbol: 'DXD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5589.png',
  },
  {
    chainId: 1,
    name: 'GeoDB',
    address: '0x147faf8de9d8d8daae129b187f0d02d819126750',
    decimals: 18,
    symbol: 'GEO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5590.png',
  },
  {
    chainId: 1,
    name: 'Frinkcoin',
    address: '0xf938c9a22c6fc9e6b81b24b68db94b92dc4a7976',
    decimals: 8,
    symbol: 'FRNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5593.png',
  },
  {
    chainId: 1,
    name: 'ZCore Token',
    address: '0xC7e43A1c8E118aA2965F5EAbe0e718D83DB7A63C',
    decimals: 18,
    symbol: 'ZCRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5594.png',
  },
  {
    chainId: 1,
    name: 'Bluekey',
    address: '0x646b41183bb0d18c01f75f630688d613a5774dc7',
    decimals: 8,
    symbol: 'BKY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5597.png',
  },
  {
    chainId: 1,
    name: 'Teccoin',
    address: '0x7dEe371A788f9BD6c546dF83F0d74fBe37cbf006',
    decimals: 18,
    symbol: 'Tecn',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5598.png',
  },
  {
    chainId: 1,
    name: 'Attila',
    address: '0x89Fb927240750c1B15d4743cd58440fc5f14A11C',
    decimals: 18,
    symbol: 'ATT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5600.png',
  },
  {
    chainId: 1,
    name: 'STAKE',
    address: '0x0Ae055097C6d159879521C384F1D2123D1f195e6',
    decimals: 18,
    symbol: 'STAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5601.png',
  },
  {
    chainId: 1,
    name: 'Zapaygo',
    address: '0x4a61988e2d412a0d1983f1685a0ddc9356be3751',
    decimals: 18,
    symbol: 'ZHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5603.png',
  },
  {
    chainId: 1,
    name: 'TrustUSD',
    address: '0xDD436a0Dce9244B36599AE7b22f0373b4e33992d',
    decimals: 18,
    symbol: 'TRUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5605.png',
  },
  {
    chainId: 1,
    name: 'AZBI CORE',
    address: '0x82f39cd08a942f344ca7e7034461cc88c2009199',
    decimals: 18,
    symbol: 'AZBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5611.png',
  },
  {
    chainId: 1,
    name: 'Agricoin',
    address: '0x25d9Bef26b6F7018D24d18144fe3C8bFD0d48a53',
    decimals: 18,
    symbol: 'AGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5613.png',
  },
  {
    chainId: 1,
    name: 'Zelwin',
    address: '0x5319e86F0e41a06E49eb37046b8c11D78bcAd68C',
    decimals: 18,
    symbol: 'ZLW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5614.png',
  },
  {
    chainId: 1,
    name: 'Money Token',
    address: '0x310da5e1e61cd9d6eced092f085941089267e71e',
    decimals: 18,
    symbol: 'MNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5615.png',
  },
  {
    chainId: 1,
    name: 'MATH',
    address: '0x08d967bb0134f2d07f7cfb6e246680c53927dd30',
    decimals: 18,
    symbol: 'MATH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5616.png',
  },
  {
    chainId: 1,
    name: 'UMA',
    address: '0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828',
    decimals: 18,
    symbol: 'UMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5617.png',
  },
  {
    chainId: 1,
    name: 'Dawn Protocol',
    address: '0x580c8520deda0a441522aeae0f9f7a5f29629afa',
    decimals: 18,
    symbol: 'DAWN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5618.png',
  },
  {
    chainId: 1,
    name: 'VEHICLE DATA ARTIFICIAL INTELLIGENCE PLA',
    address: '0x4457dc5a9e71b975a8e0f855bbe795f5cbdcc10f',
    decimals: 18,
    symbol: 'VAIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5619.png',
  },
  {
    chainId: 1,
    name: '8X8 PROTOCOL',
    address: '0x412d397ddca07d753e3e0c61e367fb1b474b3e7d',
    decimals: 18,
    symbol: 'EXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5620.png',
  },
  {
    chainId: 1,
    name: 'Skillchain',
    address: '0x996dc5dfc819408dd98cd92c9a76f64b0738dc3d',
    decimals: 18,
    symbol: 'SKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5623.png',
  },
  {
    chainId: 1,
    name: 'VEDX TOKEN',
    address: '0xd64904232b4674c24fa59170d12fc7df20f5880e',
    decimals: 18,
    symbol: 'VEDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5624.png',
  },
  {
    chainId: 1,
    name: 'King DAG',
    address: '0x95e40e065afb3059dcabe4aaf404c1f92756603a',
    decimals: 18,
    symbol: 'KDAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5626.png',
  },
  {
    chainId: 1,
    name: 'SableAssent',
    address: '0x3e27A81e83567aD1A24ae67dEec3dAda8ce2c3ec',
    decimals: 18,
    symbol: 'SAC1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5627.png',
  },
  {
    chainId: 1,
    name: 'VARC',
    address: '0x3f694635ab69b1b5e7f001de26892cc63ba94bad',
    decimals: 18,
    symbol: 'VARC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5628.png',
  },
  {
    chainId: 1,
    name: 'NDN Link',
    address: '0x6ec47a178a9d50d4ec4683003d8324f19ca35382',
    decimals: 18,
    symbol: 'NDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5629.png',
  },
  {
    chainId: 1,
    name: 'Orion',
    address: '0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a',
    decimals: 18,
    symbol: 'ORN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5631.png',
  },
  {
    chainId: 1,
    name: 'Fuse',
    address: '0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d',
    decimals: 18,
    symbol: 'FUSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5634.png',
  },
  {
    chainId: 1,
    name: 'Paparazzi',
    address: '0xbcd8756ea481608ea3dd5a555493305cf0a79640',
    decimals: 18,
    symbol: 'PAZZI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5635.png',
  },
  {
    chainId: 1,
    name: 'Compound Ether',
    address: '0x4ddc2d193948926d02f9b1fe9e1daa0718270ed5',
    decimals: 8,
    symbol: 'CETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5636.png',
  },
  {
    chainId: 1,
    name: 'Wonder',
    address: '0x69DC5556A91DFab39f8D50f6FE552296F2268Dda',
    decimals: 5,
    symbol: 'WND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5637.png',
  },
  {
    chainId: 1,
    name: 'NoyodCoin',
    address: '0x7f7cac26a300cb2e911b0241f71a5c18f6481c9d',
    decimals: 18,
    symbol: 'OYO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5638.png',
  },
  {
    chainId: 1,
    name: 'CreekEx Token',
    address: '0x76e9623b10ab5138bad31f57353b7d32a1edb5db',
    decimals: 18,
    symbol: 'CRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5639.png',
  },
  {
    chainId: 1,
    name: 'BlockNoteX',
    address: '0x8b61F7aFe322372940dc4512BE579f0a55367650',
    decimals: 18,
    symbol: 'BNOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5648.png',
  },
  {
    chainId: 1,
    name: 'BITWAY',
    address: '0xac1a32e3aea383ba94f9e28e63a122277e4ccb18',
    decimals: 18,
    symbol: 'WAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5650.png',
  },
  {
    chainId: 1,
    name: 'CryptoBet',
    address: '0x35dd2ebf20746C6e658fac75cd80D4722fae62f6',
    decimals: 18,
    symbol: 'CBET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5651.png',
  },
  {
    chainId: 1,
    name: 'Amun Short Bitcoin Token',
    address: '0xcbe79ceca09092648995b2ccdf91ca5ecd1edec9',
    decimals: 18,
    symbol: 'BTCSHORT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5652.png',
  },
  {
    chainId: 1,
    name: 'DOCH COIN',
    address: '0x4a73e60adbb8575500ffc6aaea6128954011c8af',
    decimals: 18,
    symbol: 'DCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5653.png',
  },
  {
    chainId: 1,
    name: 'Vesta Space Technology',
    address: '0xf048da62320f14d0335daf048019bf8c82f11737',
    decimals: 18,
    symbol: 'VESTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5654.png',
  },
  {
    chainId: 1,
    name: '1x Short Bitcoin Token',
    address: '0x1FA3bc860bF823d792f04F662f3AA3a500a68814',
    decimals: 18,
    symbol: 'HEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5656.png',
  },
  {
    chainId: 1,
    name: 'Vether',
    address: '0x4ba6ddd7b89ed838fed25d208d4f644106e34279',
    decimals: 18,
    symbol: 'VETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5657.png',
  },
  {
    chainId: 1,
    name: '1X Short Ethereum Token',
    address: '0x10e1E953DDBa597011f8bFA806aB0cC3415a622b',
    decimals: 18,
    symbol: 'ETHHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5658.png',
  },
  {
    chainId: 1,
    name: 'Xank',
    address: '0x0e7f79e89ba8c4a13431129fb2db0d4f444b5b9a',
    decimals: 16,
    symbol: 'XANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5659.png',
  },
  {
    chainId: 1,
    name: 'UniPower',
    address: '0xf2f9a7e93f845b3ce154efbeb64fb9346fcce509',
    decimals: 18,
    symbol: 'POWER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5660.png',
  },
  {
    chainId: 1,
    name: 'Sylo',
    address: '0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4',
    decimals: 18,
    symbol: 'SYLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5662.png',
  },
  {
    chainId: 1,
    name: 'Japan Excitement Coin',
    address: '0xcd56fc21564fba45c17d0bf663cced37f5e22d7e',
    decimals: 4,
    symbol: 'JPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5664.png',
  },
  {
    chainId: 1,
    name: 'Codeo Token',
    address: '0x46b4a7d906F1A943b7744Df23625E63726d79035',
    decimals: 18,
    symbol: 'CODEO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5666.png',
  },
  {
    chainId: 1,
    name: '0xMonero',
    address: '0x035df12e0f3ac6671126525f1015e47d79dfeddf',
    decimals: 18,
    symbol: '0xMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5668.png',
  },
  {
    chainId: 1,
    name: 'Blood',
    address: '0xd2727e4259BBa31955FD582986334AEA4fBA8C52',
    decimals: 8,
    symbol: 'BLOOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5671.png',
  },
  {
    chainId: 1,
    name: 'EYES Protocol',
    address: '0xe42B7A17336B343569C82f682a493a837B7e0755',
    decimals: 18,
    symbol: 'EYES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5673.png',
  },
  {
    chainId: 1,
    name: 'PhoenixDAO',
    address: '0x38A2fDc11f526Ddd5a607C1F251C065f40fBF2f7',
    decimals: 18,
    symbol: 'PHNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5674.png',
  },
  {
    chainId: 1,
    name: 'BNC TOKEN',
    address: '0xbe5b336ef62d1626940363cf34be079e0ab89f20',
    decimals: 18,
    symbol: 'BNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5675.png',
  },
  {
    chainId: 1,
    name: 'IZE',
    address: '0x6944d3e38973C4831dA24E954fbD790c7E688bDd',
    decimals: 18,
    symbol: 'IZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5677.png',
  },
  {
    chainId: 1,
    name: 'Coin Fella Token',
    address: '0xf989e16233ad1ad0f2af739547ef92745341f52b',
    decimals: 18,
    symbol: 'CFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5678.png',
  },
  {
    chainId: 1,
    name: 'PLAAS FARMERS TOKEN',
    address: '0x60571e95e12c78cba5223042692908f0649435a5',
    decimals: 18,
    symbol: 'PLAAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5679.png',
  },
  {
    chainId: 1,
    name: 'Future Human Resources',
    address: '0xd446e2875AC510648398debBc1f013A6F79ace4e',
    decimals: 18,
    symbol: 'FHR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5680.png',
  },
  {
    chainId: 1,
    name: 'Alrightcoin',
    address: '0x95d82ba91256db995c80bed690d0a779191af62b',
    decimals: 18,
    symbol: 'ALC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5681.png',
  },
  {
    chainId: 1,
    name: 'ANALYSX',
    address: '0xfa91f4177476633f100c59d336c0f2ffad414cba',
    decimals: 18,
    symbol: 'XYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5684.png',
  },
  {
    chainId: 1,
    name: 'Global Human Trust',
    address: '0xbe30f684d62c9f7883a75a29c162c332c0d98f23',
    decimals: 18,
    symbol: 'GHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5688.png',
  },
  {
    chainId: 1,
    name: 'Render',
    address: '0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24',
    decimals: 18,
    symbol: 'RNDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5690.png',
  },
  {
    chainId: 1,
    name: 'SKALE',
    address: '0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7',
    decimals: 18,
    symbol: 'SKL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5691.png',
  },
  {
    chainId: 1,
    name: 'Compound',
    address: '0xc00e94cb662c3520282e6f5717214004a7f26888',
    decimals: 18,
    symbol: 'COMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5692.png',
  },
  {
    chainId: 1,
    name: 'Unifier',
    address: '0xEC02cEc4eDD54196D2767b61F43b29A49b056fe6',
    decimals: 7,
    symbol: 'UNIF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5693.png',
  },
  {
    chainId: 1,
    name: 'UniDollar',
    address: '0x256845e721c0c46d54e6afbd4fa3b52cb72353ea',
    decimals: 18,
    symbol: 'UNIUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5694.png',
  },
  {
    chainId: 1,
    name: 'Bitanium',
    address: '0x5b5bb9765eff8d26c24b9ff0daa09838a3cd78e9',
    decimals: 4,
    symbol: 'BI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5696.png',
  },
  {
    chainId: 1,
    name: 'GM Holding',
    address: '0xEC73A0F098073C4F43E393B9B2f36073a0484401',
    decimals: 18,
    symbol: 'GM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5698.png',
  },
  {
    chainId: 1,
    name: 'HXY Money',
    address: '0xf3a2ace8e48751c965ea0a1d064303aca53842b9',
    decimals: 8,
    symbol: 'HXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5699.png',
  },
  {
    chainId: 1,
    name: 'Yang Dividend',
    address: '0xfa57cea2f244c607e2ba7ba258af7cb3d0ebd64f',
    decimals: 2,
    symbol: 'MATH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5700.png',
  },
  {
    chainId: 1,
    name: 'MONNOS',
    address: '0x53884b61963351C283118a8E1Fc05BA464a11959',
    decimals: 18,
    symbol: 'MNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5702.png',
  },
  {
    chainId: 1,
    name: 'Neuromorphic.io',
    address: '0x4D6b9f281AF31916a0f16D1cEA2ec7384851EAAb',
    decimals: 18,
    symbol: 'NMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5703.png',
  },
  {
    chainId: 1,
    name: 'DFOhub',
    address: '0x7b123f53421b1bf8533339bfbdc7c98aa94163db',
    decimals: 18,
    symbol: 'BUIDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5704.png',
  },
  {
    chainId: 1,
    name: 'tGOLD',
    address: '0xe4a6f23fb9e00fca037aa0ea0a6954de0a6c53bf',
    decimals: 18,
    symbol: 'TXAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5705.png',
  },
  {
    chainId: 1,
    name: 'Golden Ratio Token',
    address: '0xb83cd8d39462b761bb0092437d38b37812dd80a2',
    decimals: 18,
    symbol: 'GRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5711.png',
  },
  {
    chainId: 1,
    name: 'FinNexus',
    address: '0xeF9Cd7882c067686691B6fF49e650b43AFBBCC6B',
    decimals: 18,
    symbol: 'FNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5712.png',
  },
  {
    chainId: 1,
    name: 'PieDAO USD++',
    address: '0x9a48bd0ec040ea4f1d3147c025cd4076a2e71e3e',
    decimals: 18,
    symbol: 'USD++',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5714.png',
  },
  {
    chainId: 1,
    name: 'PieDAO BTC++',
    address: '0x0327112423f3a68efdf1fcf402f6c5cb9f7c33fd',
    decimals: 18,
    symbol: 'BTC++',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5715.png',
  },
  {
    chainId: 1,
    name: 'Gas Token Two',
    address: '0x0000000000b3f879cb30fe243b4dfee438691c04',
    decimals: 2,
    symbol: 'GST2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5716.png',
  },
  {
    chainId: 1,
    name: 'CACHE Gold',
    address: '0xf5238462e7235c7b62811567e63dd17d12c2eaa0',
    decimals: 18,
    symbol: 'CGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5719.png',
  },
  {
    chainId: 1,
    name: 'HOMT',
    address: '0xeF7A985E4FF9B5DcCD6eDdF58577486887288711',
    decimals: 15,
    symbol: 'HOMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5722.png',
  },
  {
    chainId: 1,
    name: 'Axion Hex2T',
    address: '0xed1199093b1abd07a368dd1c0cdc77d8517ba2a0',
    decimals: 18,
    symbol: 'HEX2T',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5723.png',
  },
  {
    chainId: 1,
    name: 'Nimfex Token',
    address: '0x19f3e6521f73a0184cc171c8ccbe1e21f93f4b3b',
    decimals: 18,
    symbol: 'NFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5724.png',
  },
  {
    chainId: 1,
    name: 'Bitsonic',
    address: '0xe541504417670fb76b612b41b4392d967a1956c7',
    decimals: 18,
    symbol: 'BSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5725.png',
  },
  {
    chainId: 1,
    name: 'iBBT',
    address: '0x691c25C461DaFC47792b6E4d674FBB637bca1C6F',
    decimals: 18,
    symbol: 'iBBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5727.png',
  },
  {
    chainId: 1,
    name: 'Balancer',
    address: '0xba100000625a3754423978a60c9317c58a424e3D',
    decimals: 18,
    symbol: 'BAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5728.png',
  },
  {
    chainId: 1,
    name: 'ChainZ Arena',
    address: '0x72DC3D52b7EF107a7CFFb6953eaa8A2aD6a204Cd',
    decimals: 6,
    symbol: 'SOUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5729.png',
  },
  {
    chainId: 1,
    name: 'Intuz',
    address: '0x72a8eaead0b6f735361a0a6b9402b13dd7081048',
    decimals: 6,
    symbol: 'INZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5731.png',
  },
  {
    chainId: 1,
    name: 'BITCOINHEDGE',
    address: '0x5547136b913b68881596275ace01e9a589c5b16b',
    decimals: 18,
    symbol: 'BTCHG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5732.png',
  },
  {
    chainId: 1,
    name: 'IOOX System',
    address: '0xf6923F7d96fc22c4b8010a865e41cF7edfB6379C',
    decimals: 8,
    symbol: 'IOOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5733.png',
  },
  {
    chainId: 1,
    name: 'MoCo Token',
    address: '0x06a8f2bcc622ac55d596ea02ce5bb5f318f485e9',
    decimals: 18,
    symbol: 'MoCo',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5734.png',
  },
  {
    chainId: 1,
    name: 'ORYX',
    address: '0x5C0Bc243Fb13632c4D247F4f0bC27f2f58982C39',
    decimals: 18,
    symbol: 'ORX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5740.png',
  },
  {
    chainId: 1,
    name: 'DMM: Governance',
    address: '0xEd91879919B71bB6905f23af0A68d231EcF87b14',
    decimals: 18,
    symbol: 'DMG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5741.png',
  },
  {
    chainId: 1,
    name: 'Compound Basic Attention Token',
    address: '0x6c8c6b02e7b2be14d4fa6022dfd6d75921d90e4e',
    decimals: 8,
    symbol: 'CBAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5742.png',
  },
  {
    chainId: 1,
    name: 'Compound 0x',
    address: '0xb3319f5d18bc0d84dd1b4825dcde5d5f7266d407',
    decimals: 8,
    symbol: 'CZRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5743.png',
  },
  {
    chainId: 1,
    name: 'Compound Wrapped BTC',
    address: '0xc11b1268c1a384e55c48c2391d8d480264a3a7f4',
    decimals: 8,
    symbol: 'CWBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5744.png',
  },
  {
    chainId: 1,
    name: 'Compound USDT',
    address: '0xf650c3d88d12db855b8bf7d11be6c55a4e07dcc9',
    decimals: 8,
    symbol: 'CUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5745.png',
  },
  {
    chainId: 1,
    name: 'Compound Augur',
    address: '0x158079ee67fce2f58472a96584a73c7ab9ac95c1',
    decimals: 8,
    symbol: 'CREP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5746.png',
  },
  {
    chainId: 1,
    name: 'mStable USD',
    address: '0xe2f2a5c287993345a840db3b0845fbc70f5935a5',
    decimals: 18,
    symbol: 'MUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5747.png',
  },
  {
    chainId: 1,
    name: 'Aave TUSD',
    address: '0x4da9b813057d04baef4e5800e36083717b4a0341',
    decimals: 18,
    symbol: 'ATUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5749.png',
  },
  {
    chainId: 1,
    name: 'Aave BAT',
    address: '0xe1ba0fb44ccb0d11b80f92f4f8ed94ca3ff51d00',
    decimals: 18,
    symbol: 'ABAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5754.png',
  },
  {
    chainId: 1,
    name: 'Aave MANA',
    address: '0x6FCE4A401B6B80ACe52baAefE4421Bd188e76F6f',
    decimals: 18,
    symbol: 'AMANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5757.png',
  },
  {
    chainId: 1,
    name: 'Aave USDT',
    address: '0x71fc860F7D3A592A4a98740e39dB31d25db65ae8',
    decimals: 6,
    symbol: 'AUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5761.png',
  },
  {
    chainId: 1,
    name: 'Aave DAI',
    address: '0xfC1E690f61EFd961294b3e1Ce3313fBD8aa4f85d',
    decimals: 18,
    symbol: 'ADAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5763.png',
  },
  {
    chainId: 1,
    name: 'sBTC',
    address: '0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6',
    decimals: 18,
    symbol: 'SBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5764.png',
  },
  {
    chainId: 1,
    name: 'sETH',
    address: '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb',
    decimals: 18,
    symbol: 'SETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5765.png',
  },
  {
    chainId: 1,
    name: 'sEOS',
    address: '0x88C8Cf3A212c0369698D13FE98Fcb76620389841',
    decimals: 18,
    symbol: 'SEOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5766.png',
  },
  {
    chainId: 1,
    name: 'sXMR',
    address: '0x5299d6F7472DCc137D7f3C4BcfBBB514BaBF341A',
    decimals: 18,
    symbol: 'SXMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5767.png',
  },
  {
    chainId: 1,
    name: 'sBCH',
    address: '0x36a2422a863D5B950882190Ff5433E513413343a',
    decimals: 18,
    symbol: 'SBCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5768.png',
  },
  {
    chainId: 1,
    name: 'sADA',
    address: '0xe36E2D3c7c34281FA3bC737950a68571736880A1',
    decimals: 18,
    symbol: 'SADA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5769.png',
  },
  {
    chainId: 1,
    name: 'rDAI',
    address: '0x261b45d85ccfeabb11f022eba346ee8d1cd488c0',
    decimals: 18,
    symbol: 'RDAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5770.png',
  },
  {
    chainId: 1,
    name: 'iADA',
    address: '0x8A8079c7149B8A1611e5C5d978DCA3bE16545F83',
    decimals: 18,
    symbol: 'IADA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5771.png',
  },
  {
    chainId: 1,
    name: 'iXMR',
    address: '0x4AdF728E2Df4945082cDD6053869f51278fae196',
    decimals: 18,
    symbol: 'IXMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5772.png',
  },
  {
    chainId: 1,
    name: 'iBCH',
    address: '0xf6E9b246319ea30e8C2fA2d1540AAEBF6f9E1B89',
    decimals: 18,
    symbol: 'IBCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5773.png',
  },
  {
    chainId: 1,
    name: 'iEOS',
    address: '0xF4EebDD0704021eF2a6Bbe993fdf93030Cd784b4',
    decimals: 18,
    symbol: 'IEOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5774.png',
  },
  {
    chainId: 1,
    name: 'tBTC',
    address: '0x8daebade922df735c38c80c7ebd708af50815faa',
    decimals: 18,
    symbol: 'TBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5776.png',
  },
  {
    chainId: 1,
    name: 'renBTC',
    address: '0xeb4c2781e4eba804ce9a9803c67d0893436bb27d',
    decimals: 8,
    symbol: 'RENBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5777.png',
  },
  {
    chainId: 1,
    name: 'ETHPlus',
    address: '0xEED736b2b809550D89A941C2005dE93588c628e2',
    decimals: 18,
    symbol: 'ETHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5778.png',
  },
  {
    chainId: 1,
    name: 'Pamp Network',
    address: '0xf0fac7104aac544e4a7ce1a55adf2b5a25c65bd1',
    decimals: 18,
    symbol: 'PAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5780.png',
  },
  {
    chainId: 1,
    name: 'Bestay',
    address: '0x7a647637e75d34a7798ba06bd1adf5c084bb5dd5',
    decimals: 18,
    symbol: 'BSY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5782.png',
  },
  {
    chainId: 1,
    name: 'Medalte',
    address: '0x625687081ba9fcbffb0ae6bfe8d7fad6f616f494',
    decimals: 18,
    symbol: 'MDTL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5783.png',
  },
  {
    chainId: 1,
    name: 'STPAY',
    address: '0x5c250ff9b993c6991cc4a3cc543716e53b478018',
    decimals: 18,
    symbol: 'STP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5785.png',
  },
  {
    chainId: 1,
    name: 'SaveToken',
    address: '0xc1eecf1f4af8eb9a2a19f6c26b434aa96ce859e1',
    decimals: 8,
    symbol: 'SAVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5789.png',
  },
  {
    chainId: 1,
    name: 'Destiny Success',
    address: '0x36c85687eeDAe01C50eB7d04d74C0ec74f930c54',
    decimals: 18,
    symbol: 'DXTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5790.png',
  },
  {
    chainId: 1,
    name: 'VoyageCoin',
    address: '0xbf6ea1a8690acfee6933bf8525fae13bf2cd3b02',
    decimals: 8,
    symbol: 'VAGA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5791.png',
  },
  {
    chainId: 1,
    name: 'Bananatok',
    address: '0x20910e5b5f087f6439dfcb0dda4e27d1014ac2b8',
    decimals: 18,
    symbol: 'BNA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5792.png',
  },
  {
    chainId: 1,
    name: 'Kublaicoin',
    address: '0xc59cb23295e2DEEB66bd090ACB6B02BE8d30A11F',
    decimals: 10,
    symbol: 'KUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5793.png',
  },
  {
    chainId: 1,
    name: 'pNetwork',
    address: '0x89ab32156e46f46d02ade3fecbe5fc4243b9aaed',
    decimals: 18,
    symbol: 'PNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5794.png',
  },
  {
    chainId: 1,
    name: 'Doctors Coin',
    address: '0xbf13FF395D686Ed7C705A5411CC8E4E21Ff2Ceb2',
    decimals: 18,
    symbol: 'DRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5796.png',
  },
  {
    chainId: 1,
    name: 'HEIDI',
    address: '0x58a3520d738b268c2353ecee518a1ad8e28e4ae5',
    decimals: 2,
    symbol: 'HDI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5797.png',
  },
  {
    chainId: 1,
    name: 'Darwinia Network',
    address: '0x9469d013805bffb7d3debe5e7839237e535ec483',
    decimals: 18,
    symbol: 'RING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5798.png',
  },
  {
    chainId: 1,
    name: 'SORA',
    address: '0x40FD72257597aA14C7231A7B1aaa29Fce868F677',
    decimals: 18,
    symbol: 'XOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5802.png',
  },
  {
    chainId: 1,
    name: 'BitCherry',
    address: '0x2ab05b915c30093679165bcdba9c26d8cd8bee99',
    decimals: 18,
    symbol: 'BCHC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5803.png',
  },
  {
    chainId: 1,
    name: 'DeFiChain',
    address: '0x8fc8f8269ebca376d046ce292dc7eac40c8d358a',
    decimals: 18,
    symbol: 'DFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5804.png',
  },
  {
    chainId: 1,
    name: 'Imsmart',
    address: '0xbfe03707adb75b478add9a01978057803f480e44',
    decimals: 8,
    symbol: 'IMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5806.png',
  },
  {
    chainId: 1,
    name: 'Release Project',
    address: '0x61bfc979ea8160ede9b862798b7833a97bafa02a',
    decimals: 18,
    symbol: 'REL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5807.png',
  },
  {
    chainId: 1,
    name: 'DeCash',
    address: '0x95ba34760ac3d7fbe98ee8b2ab33b4f1a6d18878',
    decimals: 18,
    symbol: 'DESH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5808.png',
  },
  {
    chainId: 1,
    name: 'Cap',
    address: '0x43044f861ec040DB59A7e324c40507adDb673142',
    decimals: 18,
    symbol: 'CAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5809.png',
  },
  {
    chainId: 1,
    name: 'bZx Protocol',
    address: '0x56d811088235F11C8920698a204A5010a788f4b3',
    decimals: 18,
    symbol: 'BZRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5810.png',
  },
  {
    chainId: 1,
    name: 'ENTONE',
    address: '0xEc1a718D1A6F8F8d94eCEc6fe91465697bb2b88C',
    decimals: 8,
    symbol: 'ENTONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5811.png',
  },
  {
    chainId: 1,
    name: 'DecenTradex',
    address: '0x199c3ddedb0e91db3897039af27c23286269f088',
    decimals: 8,
    symbol: 'DCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5812.png',
  },
  {
    chainId: 1,
    name: 'CHALLENGE',
    address: '0x839961692c56270b73538F9906f8736fC1DA4fA6',
    decimals: 18,
    symbol: 'CLG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5813.png',
  },
  {
    chainId: 1,
    name: 'Rivermount',
    address: '0x5AB55ec290BeacAE98f54c3eB70860460B167C3C',
    decimals: 18,
    symbol: 'RM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5814.png',
  },
  {
    chainId: 1,
    name: 'Rewardiqa',
    address: '0x3FFfFA8F3cc943e43f9f17a83Cbb18f4Bbb9f4AC',
    decimals: 18,
    symbol: 'REW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5816.png',
  },
  {
    chainId: 1,
    name: 'LOTTO9',
    address: '0x33Afa6514ad44594B1886859165B9AA641bDaBA9',
    decimals: 18,
    symbol: 'L9',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5817.png',
  },
  {
    chainId: 1,
    name: 'Ormeus Cash',
    address: '0xd6bd97a26232ba02172ff86b055d5d7be789335b',
    decimals: 18,
    symbol: 'OMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5818.png',
  },
  {
    chainId: 1,
    name: 'Travel1Click',
    address: '0xa7C71d444bf9aF4bfEd2adE75595d7512Eb4DD39',
    decimals: 16,
    symbol: 'T1C',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5819.png',
  },
  {
    chainId: 1,
    name: 'Aleph.im',
    address: '0x27702a26126e0b3702af63ee09ac4d1a084ef628',
    decimals: 18,
    symbol: 'ALEPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5821.png',
  },
  {
    chainId: 1,
    name: 'RAIN Network',
    address: '0x61cdb66e56fad942a7b5ce3f419ffe9375e31075',
    decimals: 18,
    symbol: 'RAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5822.png',
  },
  {
    chainId: 1,
    name: 'Smooth Love Potion',
    address: '0xCC8Fa225D80b9c7D42F96e9570156c65D6cAAa25',
    decimals: 18,
    symbol: 'SLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5824.png',
  },
  {
    chainId: 1,
    name: 'Politicoin',
    address: '0x6fFbd6B41b802550C57D4661d81A1700A502f2AB',
    decimals: 9,
    symbol: 'PBLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5825.png',
  },
  {
    chainId: 1,
    name: 'EtherBone',
    address: '0x96b52B5BF8D902252D0714A1BD2651A785Fd2660',
    decimals: 18,
    symbol: 'ETHBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5826.png',
  },
  {
    chainId: 1,
    name: 'AntiscamToken',
    address: '0xa872e0a44bbd66c1486a756cb5bd3f0beec4e32e',
    decimals: 18,
    symbol: 'AST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5827.png',
  },
  {
    chainId: 1,
    name: 'TrustSwap',
    address: '0xcc4304a31d09258b0029ea7fe63d032f52e44efe',
    decimals: 18,
    symbol: 'SWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5829.png',
  },
  {
    chainId: 1,
    name: 'NXM',
    address: '0xd7c49cee7e9188cca6ad8ff264c1da2e69d4cf3b',
    decimals: 18,
    symbol: 'NXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5830.png',
  },
  {
    chainId: 1,
    name: 'ASKO',
    address: '0xeEEE2a622330E6d2036691e983DEe87330588603',
    decimals: 18,
    symbol: 'ASKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5833.png',
  },
  {
    chainId: 1,
    name: 'Add.xyz',
    address: '0x635d081fD8F6670135D8a3640E2cF78220787d56',
    decimals: 18,
    symbol: 'ADD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5834.png',
  },
  {
    chainId: 1,
    name: 'Decentr',
    address: '0x30f271c9e86d2b7d00a6376cd96a1cfbd5f0b9b3',
    decimals: 18,
    symbol: 'DEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5835.png',
  },
  {
    chainId: 1,
    name: 'CEREAL',
    address: '0x4168BbC34BaEa34e55721809911bcA5baAEF6ba6',
    decimals: 18,
    symbol: 'CEP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5837.png',
  },
  {
    chainId: 1,
    name: 'AnimalGo',
    address: '0x6bEC0cb45494e7019EE6dFa94439C660b2373944',
    decimals: 18,
    symbol: 'GOM2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5839.png',
  },
  {
    chainId: 1,
    name: 'Insight Protocol',
    address: '0x84fE25f3921f3426395c883707950d0c00367576',
    decimals: 18,
    symbol: 'INX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5840.png',
  },
  {
    chainId: 1,
    name: 'NEST Protocol',
    address: '0xcd6926193308d3B371FdD6A6219067E550000000',
    decimals: 18,
    symbol: 'NEST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5841.png',
  },
  {
    chainId: 1,
    name: 'STONK',
    address: '0xb4058411967d5046f3510943103805be61f0600e',
    decimals: 18,
    symbol: 'STONK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5843.png',
  },
  {
    chainId: 1,
    name: 'Cipher Core Token',
    address: '0x83eB94cB563146a42Fe0a8b3D051F2387A7FB81f',
    decimals: 8,
    symbol: 'CIPHC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5844.png',
  },
  {
    chainId: 1,
    name: 'Walleteum',
    address: '0x3071a55a0f7916d796b54a2d095db85df693d956',
    decimals: 13,
    symbol: 'EUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5845.png',
  },
  {
    chainId: 1,
    name: 'Bitpayer Token',
    address: '0x283669123bd83da2536bb534e20512101c18e5d8',
    decimals: 9,
    symbol: 'BPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5850.png',
  },
  {
    chainId: 1,
    name: 'invoxfinance',
    address: '0x4485561db76614ff727f8e0a3ea95690b8b16022',
    decimals: 18,
    symbol: 'INVOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5851.png',
  },
  {
    chainId: 1,
    name: 'Coinsto',
    address: '0x2a469a22101f1f672b745d729d13ab8dbd203c9b',
    decimals: 8,
    symbol: 'CSO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5852.png',
  },
  {
    chainId: 1,
    name: 'LivenPay',
    address: '0xc8cac7672f4669685817cf332a33eb249f085475',
    decimals: 18,
    symbol: 'LVN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5853.png',
  },
  {
    chainId: 1,
    name: 'CRYPTOFOREX',
    address: '0x226f15cdbaa36814ce3cb287563069c32cc1a293',
    decimals: 2,
    symbol: 'CFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5854.png',
  },
  {
    chainId: 1,
    name: 'Bankroll Vault',
    address: '0x6b785a0322126826d8226d77e173d75dafb84d11',
    decimals: 18,
    symbol: 'VLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5856.png',
  },
  {
    chainId: 1,
    name: 'FLAMA',
    address: '0x0f8794f66C7170c4f9163a8498371A747114f6C4',
    decimals: 18,
    symbol: 'FMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5857.png',
  },
  {
    chainId: 1,
    name: 'QANplatform',
    address: '0xAAA9214F675316182Eaa21C85f0Ca99160CC3AAA',
    decimals: 18,
    symbol: 'QANX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5858.png',
  },
  {
    chainId: 1,
    name: 'iCEX',
    address: '0x336213e1DDFC69f4701Fc3F86F4ef4A160c1159d',
    decimals: 18,
    symbol: 'ICEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5859.png',
  },
  {
    chainId: 1,
    name: 'iDeFi',
    address: '0x14d10003807AC60d07BB0ba82cAeaC8d2087c157',
    decimals: 18,
    symbol: 'IDEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5860.png',
  },
  {
    chainId: 1,
    name: 'sCEX',
    address: '0xeABACD844A196D7Faf3CE596edeBF9900341B420',
    decimals: 18,
    symbol: 'SCEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5861.png',
  },
  {
    chainId: 1,
    name: 'sDEFI',
    address: '0xe1aFe1Fd76Fd88f78cBf599ea1846231B8bA3B6B',
    decimals: 18,
    symbol: 'SDEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5862.png',
  },
  {
    chainId: 1,
    name: 'sXAG',
    address: '0x6A22e5e94388464181578Aa7A6B869e00fE27846',
    decimals: 18,
    symbol: 'SXAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5863.png',
  },
  {
    chainId: 1,
    name: 'yearn.finance',
    address: '0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e',
    decimals: 18,
    symbol: 'YFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5864.png',
  },
  {
    chainId: 1,
    name: 'DEXTools',
    address: '0xfb7b4564402e5500db5bb6d63ae671302777c75a',
    decimals: 18,
    symbol: 'DEXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5866.png',
  },
  {
    chainId: 1,
    name: 'STATERA',
    address: '0xa7DE087329BFcda5639247F96140f9DAbe3DeED1',
    decimals: 18,
    symbol: 'STA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5868.png',
  },
  {
    chainId: 1,
    name: 'SafePost',
    address: '0x43afc9058a3DeBF37eaDf99138e449cE8a480A8a',
    decimals: 18,
    symbol: 'STAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5869.png',
  },
  {
    chainId: 1,
    name: 'Originate Coin',
    address: '0x1C09EF4493465569f6d704A5CC4f9864BCD2E56a',
    decimals: 18,
    symbol: 'ORC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5870.png',
  },
  {
    chainId: 1,
    name: 'Falcon Project',
    address: '0xdc5864ede28bd4405aa04d93e05a0531797d9d59',
    decimals: 6,
    symbol: 'FNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5871.png',
  },
  {
    chainId: 1,
    name: 'Red Box Dapp Token',
    address: '0x7105eC15995A97496eC25de36CF7eEc47b703375',
    decimals: 18,
    symbol: 'RBD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5875.png',
  },
  {
    chainId: 1,
    name: 'Datamine FLUX',
    address: '0x469eda64aed3a3ad6f868c44564291aa415cb1d9',
    decimals: 18,
    symbol: 'FLUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5876.png',
  },
  {
    chainId: 1,
    name: 'RARI',
    address: '0xfca59cd816ab1ead66534d82bc21e7515ce441cf',
    decimals: 18,
    symbol: 'RARI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5877.png',
  },
  {
    chainId: 1,
    name: 'NIAX',
    address: '0xf71982762D141f8679Eb944fAec8cEC415fB5E23',
    decimals: 18,
    symbol: 'NIAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5878.png',
  },
  {
    chainId: 1,
    name: 'bZx Vesting Token',
    address: '0xb72b31907c1c95f3650b64b2469e08edacee5e8f',
    decimals: 18,
    symbol: 'VBZRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5879.png',
  },
  {
    chainId: 1,
    name: 'Props Token',
    address: '0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41',
    decimals: 18,
    symbol: 'PROPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5880.png',
  },
  {
    chainId: 1,
    name: 'Balloon-X',
    address: '0x48fa42D579CE56Cc2797E4d678AD7345A27999B9',
    decimals: 18,
    symbol: 'BLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5881.png',
  },
  {
    chainId: 1,
    name: 'StaFi',
    address: '0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d',
    decimals: 18,
    symbol: 'FIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5882.png',
  },
  {
    chainId: 1,
    name: 'Decurian',
    address: '0xd3cdc4e75750dc1e59f8342200742b6b29490e70',
    decimals: 3,
    symbol: 'ECU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5884.png',
  },
  {
    chainId: 1,
    name: 'snglsDAO',
    address: '0xc4199fB6FFDb30A829614becA030f9042f1c3992',
    decimals: 18,
    symbol: 'SGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5889.png',
  },
  {
    chainId: 1,
    name: 'Unit Protocol',
    address: '0xC76FB75950536d98FA62ea968E1D6B45ffea2A55',
    decimals: 18,
    symbol: 'COL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5890.png',
  },
  {
    chainId: 1,
    name: 'Anyswap',
    address: '0xf99d58e463a2e07e5692127302c20a191861b4d6',
    decimals: 18,
    symbol: 'ANY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5892.png',
  },
  {
    chainId: 1,
    name: 'Frontier',
    address: '0xf8C3527CC04340b208C854E985240c02F7B7793f',
    decimals: 18,
    symbol: 'FRONT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5893.png',
  },
  {
    chainId: 1,
    name: 'DoYourTip',
    address: '0x740623d2c797b7D8D1EcB98e9b4Afcf99Ec31E14',
    decimals: 18,
    symbol: 'DYT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5894.png',
  },
  {
    chainId: 1,
    name: 'Pool of Stake',
    address: '0x1c5f43710a1776b0ea7191b7ead75d4b98d69858',
    decimals: 18,
    symbol: 'PSK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5896.png',
  },
  {
    chainId: 1,
    name: 'FXBarterCoin',
    address: '0x29ff3479e15b6ceede73858e169983afb83d36a6',
    decimals: 18,
    symbol: 'FXBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5897.png',
  },
  {
    chainId: 1,
    name: 'Union Fair Coin',
    address: '0x995de3d961b40ec6cdee0009059d48768ccbdd48',
    decimals: 8,
    symbol: 'UFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5901.png',
  },
  {
    chainId: 1,
    name: 'DragonVein',
    address: '0x00d46727c2E4A6E358A8c0D638137a3d91B19BE6',
    decimals: 18,
    symbol: 'DVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5902.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin True',
    address: '0x820a8481451e893bc66dce50c84d45617cac3705',
    decimals: 18,
    symbol: 'BTCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5903.png',
  },
  {
    chainId: 1,
    name: 'BLOCKCLOUT',
    address: '0xa10ae543db5d967a73e9abcc69c81a18a7fc0a78',
    decimals: 18,
    symbol: 'CLOUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5904.png',
  },
  {
    chainId: 1,
    name: 'NerveNetwork',
    address: '0x7b6f71c8b123b38aa8099e0098bec7fbc35b8a13',
    decimals: 18,
    symbol: 'NVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5906.png',
  },
  {
    chainId: 1,
    name: 'Crypto Cricket Club',
    address: '0x4f56221252d117f35E2f6Ab937A3F77CAd38934D',
    decimals: 18,
    symbol: '3Cs',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5907.png',
  },
  {
    chainId: 1,
    name: 'dKargo',
    address: '0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0',
    decimals: 18,
    symbol: 'DKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5908.png',
  },
  {
    chainId: 1,
    name: 'Fesschain',
    address: '0xe09394f8ba642430ed448ca20f342ec7aa1ba2e1',
    decimals: 18,
    symbol: 'FESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5910.png',
  },
  {
    chainId: 1,
    name: '4ART Coin',
    address: '0xff44b5719f0b77a9951636fc5e69d3a1fc9e7d73',
    decimals: 18,
    symbol: '4ART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5912.png',
  },
  {
    chainId: 1,
    name: 'Intexcoin',
    address: '0x7533D63A2558965472398Ef473908e1320520AE2',
    decimals: 9,
    symbol: 'INTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5914.png',
  },
  {
    chainId: 1,
    name: 'Bone',
    address: '0x5C84bc60a796534bfeC3439Af0E6dB616A966335',
    decimals: 18,
    symbol: 'BONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5915.png',
  },
  {
    chainId: 1,
    name: 'Satoshivisioncoin',
    address: '0x64EA2c6104F1CF3035E28Be0f781B6286d50934D',
    decimals: 18,
    symbol: 'SVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5916.png',
  },
  {
    chainId: 1,
    name: 'ZBank Token',
    address: '0x29257908879c5792f1bb25449a7209205434dc3f',
    decimals: 18,
    symbol: 'ZBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5917.png',
  },
  {
    chainId: 1,
    name: 'Meter Governance',
    address: '0xBd2949F67DcdC549c6Ebe98696449Fa79D988A9F',
    decimals: 18,
    symbol: 'MTRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5919.png',
  },
  {
    chainId: 1,
    name: 'AICON',
    address: '0xE7FB3559358A99df54466d0350e4aD6DC7093da3',
    decimals: 8,
    symbol: 'AICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5920.png',
  },
  {
    chainId: 1,
    name: 'Cybercoin',
    address: '0x4ba012f6e411a1be55b98e9e62c3a4ceb16ec88b',
    decimals: 18,
    symbol: 'CBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5921.png',
  },
  {
    chainId: 1,
    name: 'Swingby',
    address: '0x8287c7b963b405b7b8d467db9d79eec40625b13a',
    decimals: 18,
    symbol: 'SWINGBY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5922.png',
  },
  {
    chainId: 1,
    name: 'Crypto User Base',
    address: '0xa8892bfc33fa44053a9e402b1839966f4fec74a4',
    decimals: 18,
    symbol: 'CUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5923.png',
  },
  {
    chainId: 1,
    name: 'Pantos',
    address: '0x536381a8628dbcc8c70ac9a30a7258442eab4c92',
    decimals: 18,
    symbol: 'PAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5924.png',
  },
  {
    chainId: 1,
    name: 'CoinZoom',
    address: '0x69cf3091c91eb72db05e45c76e58225177dea742',
    decimals: 18,
    symbol: 'ZOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5926.png',
  },
  {
    chainId: 1,
    name: 'BMToken',
    address: '0xc6363c1a05f840be2d185d7084b28af84c543d40',
    decimals: 18,
    symbol: 'BMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5928.png',
  },
  {
    chainId: 1,
    name: 'CR Coin',
    address: '0xfb19c03a02a519a44542343803f3d42578cbc243',
    decimals: 8,
    symbol: 'CRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5930.png',
  },
  {
    chainId: 1,
    name: 'Darwinia Commitment Token',
    address: '0x9f284e1337a815fe77d2ff4ae46544645b20c5ff',
    decimals: 18,
    symbol: 'KTON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5931.png',
  },
  {
    chainId: 1,
    name: 'Fireball',
    address: '0x3F8A2f7bcD70e7F7Bdd3FbB079c11d073588DEA2',
    decimals: 18,
    symbol: 'FIRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5933.png',
  },
  {
    chainId: 1,
    name: 'Hey Bitcoin',
    address: '0x737945b6429c28d6b9c86f391d41c0418ee2361a',
    decimals: 18,
    symbol: 'HYBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5934.png',
  },
  {
    chainId: 1,
    name: 'Karma DAO',
    address: '0xdfe691F37b6264a90Ff507EB359C45d55037951C',
    decimals: 4,
    symbol: 'KARMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5935.png',
  },
  {
    chainId: 1,
    name: 'Robonomics Web Services',
    address: '0x08ad83d779bdf2bbe1ad9cc0f78aa0d24ab97802',
    decimals: 18,
    symbol: 'RWS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5936.png',
  },
  {
    chainId: 1,
    name: 'Vibz8',
    address: '0x53db6b7fee89383435e424764a8478acda4dd2cd',
    decimals: 18,
    symbol: 'VIBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5938.png',
  },
  {
    chainId: 1,
    name: 'Wrapped NXM',
    address: '0x0d438f3b5175bebc262bf23753c1e53d03432bde',
    decimals: 18,
    symbol: 'WNXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5939.png',
  },
  {
    chainId: 1,
    name: 'ZOM',
    address: '0x5091aed52ad421969254e48d29aa1d1807e1870b',
    decimals: 18,
    symbol: 'ZOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5940.png',
  },
  {
    chainId: 1,
    name: 'RYM PROJECT',
    address: '0x9f31200553d74a8632f2ca30aa95d8cd7730a878',
    decimals: 6,
    symbol: 'RYM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5944.png',
  },
  {
    chainId: 1,
    name: 'South African Tether',
    address: '0x48f07301e9e29c3c38a80ae8d9ae771f224f1054',
    decimals: 18,
    symbol: 'xZAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5946.png',
  },
  {
    chainId: 1,
    name: 'Unicrypt',
    address: '0xf29e46887ffae92f1ff87dfe39713875da541373',
    decimals: 18,
    symbol: 'UNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5948.png',
  },
  {
    chainId: 1,
    name: 'Ulgen Hash Power',
    address: '0x9135D92e3A34e2A94e4474B74b9DC2d51118eeD5',
    decimals: 18,
    symbol: 'UHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5949.png',
  },
  {
    chainId: 1,
    name: 'DeFi Nation Signals DAO',
    address: '0x1e3a2446c729d34373b87fd2c9cbb39a93198658',
    decimals: 18,
    symbol: 'DSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5950.png',
  },
  {
    chainId: 1,
    name: 'Equus',
    address: '0xd57a41edb1956d4710286f9086352178d49a9b4a',
    decimals: 18,
    symbol: 'EQUUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5951.png',
  },
  {
    chainId: 1,
    name: 'DMScript',
    address: '0xF29992D7b589A0A6bD2de7Be29a97A6EB73EaF85',
    decimals: 18,
    symbol: 'DMST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5952.png',
  },
  {
    chainId: 1,
    name: 'LP-cCurve',
    address: '0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2',
    decimals: 18,
    symbol: 'CCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5953.png',
  },
  {
    chainId: 1,
    name: 'LP-sCurve',
    address: '0xC25a3A3b969415c80451098fa907EC722572917F',
    decimals: 18,
    symbol: 'SCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5954.png',
  },
  {
    chainId: 1,
    name: 'FME',
    address: '0x947938339bf61c84669e303bc39c794d65a525d0',
    decimals: 18,
    symbol: 'FME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5955.png',
  },
  {
    chainId: 1,
    name: 'MUX Protocol',
    address: '0x4e352cf164e64adcbad318c3a1e222e9eba4ce42',
    decimals: 18,
    symbol: 'MCB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5956.png',
  },
  {
    chainId: 1,
    name: 'DFI.Money',
    address: '0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83',
    decimals: 18,
    symbol: 'YFII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5957.png',
  },
  {
    chainId: 1,
    name: 'MOTIV Protocol',
    address: '0x40284109c3309a7c3439111bfd93bf5e0fbb706c',
    decimals: 18,
    symbol: 'MOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5958.png',
  },
  {
    chainId: 1,
    name: 'IdleDAI Yield',
    address: '0x78751b12da02728f467a44eac40f5cbc16bd7934',
    decimals: 18,
    symbol: 'IDLEDAIYIELD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5962.png',
  },
  {
    chainId: 1,
    name: 'Student Coin',
    address: '0x15b543e986b8c34074dfc9901136d9355a537e7e',
    decimals: 18,
    symbol: 'STC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5966.png',
  },
  {
    chainId: 1,
    name: 'Trendering',
    address: '0xc3dd23a0a854b4f9ae80670f528094e9eb607ccb',
    decimals: 18,
    symbol: 'TRND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5967.png',
  },
  {
    chainId: 1,
    name: 'KIWI TOKEN',
    address: '0x2BF91c18Cd4AE9C2f2858ef9FE518180F7B5096D',
    decimals: 8,
    symbol: 'KIWI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5969.png',
  },
  {
    chainId: 1,
    name: 'INFLIV',
    address: '0x3656bd0f3f07623bb7f429b390d208f894e44ece',
    decimals: 18,
    symbol: 'IFV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5970.png',
  },
  {
    chainId: 1,
    name: 'Tendies',
    address: '0x1453dbb8a29551ade11d89825ca812e05317eaeb',
    decimals: 18,
    symbol: 'TEND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5971.png',
  },
  {
    chainId: 1,
    name: 'TrustDAO',
    address: '0x57700244B20f84799a31c6C96DadFF373ca9D6c5',
    decimals: 18,
    symbol: 'TRUST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5972.png',
  },
  {
    chainId: 1,
    name: 'Vision Network',
    address: '0x456ae45c0ce901e2e7c99c0718031cec0a7a59ff',
    decimals: 18,
    symbol: 'VSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5973.png',
  },
  {
    chainId: 1,
    name: 'RealToken 15634 Liberal St Detroit MI',
    address: '0xbecaea7aa3629d4b7ddccf3a973bef09ff34d4b6',
    decimals: 18,
    symbol: 'REALTOKEN-15634-LIBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5974.png',
  },
  {
    chainId: 1,
    name: 'RealToken 18900 Mansfield St Detroit MI',
    address: '0x22cabb38295eaeccfede4e99af508052e3b74ca0',
    decimals: 18,
    symbol: 'REALTOKEN-18900-MANS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5975.png',
  },
  {
    chainId: 1,
    name: 'RealToken 10024 10028 Appoline St Detroi',
    address: '0x5807CA447851C98569c567963B25B1C83D41BeBc',
    decimals: 18,
    symbol: 'REALTOKEN-10024-1002',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5976.png',
  },
  {
    chainId: 1,
    name: 'RealToken16200 Fullerton Avenue Detroit ',
    address: '0x22c8ecf727c23422f47093b562ec53c139805301',
    decimals: 18,
    symbol: 'REALTOKEN-16200-FULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5977.png',
  },
  {
    chainId: 1,
    name: 'RealToken 18276 Appoline St Detroit MI',
    address: '0xfC89f1b932079b462Ef9C8757dE5A28E387b847b',
    decimals: 18,
    symbol: 'REALTOKEN-18276-APPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5978.png',
  },
  {
    chainId: 1,
    name: 'RealToken 20200 Lesure Street Detroit MI',
    address: '0x395c47a421c254ae42253764a7f56e0ee0cddac5',
    decimals: 18,
    symbol: 'REALTOKEN-20200-LESU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5979.png',
  },
  {
    chainId: 1,
    name: 'RealToken 25097 Andover Dr Dearborn MI',
    address: '0x74d2cb65B1158300c3e6BeA149d68509C7B2425d',
    decimals: 18,
    symbol: 'REALTOKEN-25097-ANDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5980.png',
  },
  {
    chainId: 1,
    name: 'RealToken 5942 Audubon Road Detroit MI',
    address: '0x43688910273f199B8AE2cA018c13918fb3D37B58',
    decimals: 18,
    symbol: 'REALTOKEN-5942-AUDUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5981.png',
  },
  {
    chainId: 1,
    name: 'RealToken 8342 Schaefer Hwy Detroit MI',
    address: '0x6Fd016CCc4611F7BAB1DD3267334cB0216Ef47f9',
    decimals: 18,
    symbol: 'REALTOKEN-8342-SCHAE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5982.png',
  },
  {
    chainId: 1,
    name: 'RealToken 9336 Patton Street Detroit MI',
    address: '0xeD42CeDcADbFbCAA3E6F411B09567C2C0b5AD28F',
    decimals: 18,
    symbol: 'REALTOKEN-9336-PATTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5983.png',
  },
  {
    chainId: 1,
    name: 'FreeTip',
    address: '0x174bea2cb8b20646681e855196cf34fcecec2489',
    decimals: 18,
    symbol: 'FTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5984.png',
  },
  {
    chainId: 1,
    name: 'Limestone Network',
    address: '0x400b1d8a7dd8C471026B2c8CBe1062b27d120538',
    decimals: 8,
    symbol: 'LIMEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5985.png',
  },
  {
    chainId: 1,
    name: 'Liquidity Dividends Protocol',
    address: '0x0417912b3a7af768051765040a55bb0925d4ddcf',
    decimals: 18,
    symbol: 'LID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5986.png',
  },
  {
    chainId: 1,
    name: 'SIMBA Storage Token',
    address: '0x2863916c6ebdbbf0c6f02f87b7eb478509299868',
    decimals: 18,
    symbol: 'SST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5987.png',
  },
  {
    chainId: 1,
    name: 'BNS Token',
    address: '0xd996035Db82cae33Ba1f16fDF23B816E5E9fAaBb',
    decimals: 18,
    symbol: 'BNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5989.png',
  },
  {
    chainId: 1,
    name: 'Dev Protocol',
    address: '0x5caf454ba92e6f2c929df14667ee360ed9fd5b26',
    decimals: 18,
    symbol: 'DEV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5990.png',
  },
  {
    chainId: 1,
    name: 'Lung Protocol',
    address: '0xee0f286776639cd363da810daf3e0623f82576b0',
    decimals: 18,
    symbol: 'L2P',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5993.png',
  },
  {
    chainId: 1,
    name: 'Shiba Inu',
    address: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
    decimals: 18,
    symbol: 'SHIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5994.png',
  },
  {
    chainId: 1,
    name: 'Kids Cash',
    address: '0x2c50ba1ed5e4574c1b613b044bd1876f0b0b87a9',
    decimals: 18,
    symbol: 'KASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5995.png',
  },
  {
    chainId: 1,
    name: 'Marblecoin',
    address: '0x8888889213dd4da823ebdd1e235b09590633c150',
    decimals: 18,
    symbol: 'MBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5996.png',
  },
  {
    chainId: 1,
    name: 'Libertas Token',
    address: '0x49184e6dae8c8ecd89d8bdc1b950c597b8167c90',
    decimals: 2,
    symbol: 'LIBERTAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5997.png',
  },
  {
    chainId: 1,
    name: 'Antiample',
    address: '0xf911a7ec46a2c6fa49193212fe4a2a9b95851c27',
    decimals: 9,
    symbol: 'XAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5998.png',
  },
  {
    chainId: 1,
    name: 'XT.com Token',
    address: '0x4be10da47a07716af28ad199fbe020501bddd7af',
    decimals: 18,
    symbol: 'XT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5999.png',
  },
  {
    chainId: 1,
    name: 'FOCV',
    address: '0xbBa1DA8aFF34eBEF5Ce4d68312B33ef629548b06',
    decimals: 2,
    symbol: 'FOCV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6002.png',
  },
  {
    chainId: 1,
    name: 'Crypto Village Accelerator',
    address: '0x78a52e12c7b63d05c12f9608307587cf654ec3d0',
    decimals: 18,
    symbol: 'CVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6005.png',
  },
  {
    chainId: 1,
    name: 'Game Currency Coin',
    address: '0xb627d12f7024c78b1139cbb31348393b3d37774d',
    decimals: 8,
    symbol: 'GCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6006.png',
  },
  {
    chainId: 1,
    name: 'Second Exchange Alliance',
    address: '0x72ebd62060f78d91dc4bc33e8d88f39307365f87',
    decimals: 4,
    symbol: 'SEA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6007.png',
  },
  {
    chainId: 1,
    name: 'CSC JACKPOT',
    address: '0xd375eed3549cbc8243358ef3bd6026e2c2dc8e53',
    decimals: 9,
    symbol: 'CSCJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6008.png',
  },
  {
    chainId: 1,
    name: 'BTC-Alpha Token',
    address: '0x7dc59729b0adf4ae34721a1e06ef82a19e690b04',
    decimals: 8,
    symbol: 'BAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6009.png',
  },
  {
    chainId: 1,
    name: 'SXC Token',
    address: '0x6a48ba795e3289b9151036e189e352e3ee2c7798',
    decimals: 18,
    symbol: 'SXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6013.png',
  },
  {
    chainId: 1,
    name: 'BTEcoin',
    address: '0xfd62247943f94c3910a4922af2c62c2d3fac2a8f',
    decimals: 18,
    symbol: 'BTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6015.png',
  },
  {
    chainId: 1,
    name: 'FEX Token',
    address: '0x271220fbefd584a6b0a6ad457721c076321646a1',
    decimals: 18,
    symbol: 'FEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6016.png',
  },
  {
    chainId: 1,
    name: 'ArtCoin',
    address: '0x1250b98cbde9f99f4c42dcdacee193221f17eb50',
    decimals: 18,
    symbol: 'AC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6019.png',
  },
  {
    chainId: 1,
    name: 'Brr',
    address: '0x49f941fa7f5731fe302068d79c8604c24c5e7196',
    decimals: 18,
    symbol: 'BRR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6020.png',
  },
  {
    chainId: 1,
    name: 'PolypuX',
    address: '0xe277ac35f9d327a670c1a3f3eec80a83022431e4',
    decimals: 8,
    symbol: 'PUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6022.png',
  },
  {
    chainId: 1,
    name: 'Unibomb',
    address: '0x265Ba42daF2D20F3F358a7361D9f69Cb4E28F0E6',
    decimals: 18,
    symbol: 'UBOMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6023.png',
  },
  {
    chainId: 1,
    name: 'DigiMax DGMT',
    address: '0x0d4b4DA5fb1a7d55E85f8e22f728701cEB6E44C9',
    decimals: 18,
    symbol: 'DGMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6025.png',
  },
  {
    chainId: 1,
    name: 'All.me',
    address: '0x76574c7b61b07ba14eace42e60cc73a08038da85',
    decimals: 18,
    symbol: 'ME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6026.png',
  },
  {
    chainId: 1,
    name: 'TOPBTC Token',
    address: '0xf6317dd9b04097a9e7b016cd23dcaa7cfe19d9c6',
    decimals: 18,
    symbol: 'TOPB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6027.png',
  },
  {
    chainId: 1,
    name: 'CoinBene Future Token',
    address: '0x9b683d81b8334325bcc1802d47de65571993fe89',
    decimals: 8,
    symbol: 'CFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6029.png',
  },
  {
    chainId: 1,
    name: 'To The Moon',
    address: '0x238bf6cFB8Fa1b54429f9BF8ab651D8b99f12aD9',
    decimals: 18,
    symbol: 'TTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6030.png',
  },
  {
    chainId: 1,
    name: 'KVI',
    address: '0x8868ff4893113193313465A0Ccc5F1bd370D7751',
    decimals: 18,
    symbol: 'KVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6031.png',
  },
  {
    chainId: 1,
    name: 'Healing Plus',
    address: '0xab55bdef7057b76482914e79f037999f4ebb6bf1',
    decimals: 8,
    symbol: 'HP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6033.png',
  },
  {
    chainId: 1,
    name: 'Crowd One',
    address: '0x4760e7A401558AA59639161454bb2A41a3c5A90b',
    decimals: 18,
    symbol: 'CRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6034.png',
  },
  {
    chainId: 1,
    name: 'InfinityDeFi',
    address: '0x82dad985afd3708680bac660f4e527da4f0dcfa5',
    decimals: 8,
    symbol: 'INFD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6035.png',
  },
  {
    chainId: 1,
    name: '3X Long Chainlink Token',
    address: '0x83aD87C988aC0c6277C0c6234Cc8108b20bB5d9B',
    decimals: 18,
    symbol: 'LINKBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6037.png',
  },
  {
    chainId: 1,
    name: 'Aave WBTC',
    address: '0xFC4B8ED459e00e5400be803A9BB3954234FD50e3',
    decimals: 8,
    symbol: 'AWBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6038.png',
  },
  {
    chainId: 1,
    name: 'Connectome',
    address: '0x9a1bf361798ef6538ccb8137ea900c4d4b48ca3d',
    decimals: 18,
    symbol: 'CNTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6039.png',
  },
  {
    chainId: 1,
    name: '3X Short Cardano Token',
    address: '0xb3299d4BaB93Bf04d5b11bc49CD6DFAD1f77d23f',
    decimals: 18,
    symbol: 'ADABEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6040.png',
  },
  {
    chainId: 1,
    name: 'LP-yCurve',
    address: '0xdf5e0e81dff6faf3a7e52ba697820c5e32d806a8',
    decimals: 18,
    symbol: 'YDAI+YUSDC+YUSDT+YTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6041.png',
  },
  {
    chainId: 1,
    name: '10X Long Altcoin Index Token',
    address: '0x7574C09a26e781dF694755cEc8aC04AF9d1e1Cc0',
    decimals: 18,
    symbol: 'ALTMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6042.png',
  },
  {
    chainId: 1,
    name: '10X Long Bitcoin Cash Token',
    address: '0x9003ce9E92e1105f235CA59e2BF65ABD36dFdC01',
    decimals: 18,
    symbol: 'BCHMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6043.png',
  },
  {
    chainId: 1,
    name: '10X Long Bitcoin SV Token',
    address: '0x875ef445e0873b6c2d5e58f68113e0937ba8a441',
    decimals: 18,
    symbol: 'BSVMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6044.png',
  },
  {
    chainId: 1,
    name: '10X Long Bitcoin Token',
    address: '0xba7cdd0953e8f950317dda347a716f162713b226',
    decimals: 18,
    symbol: 'MOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6045.png',
  },
  {
    chainId: 1,
    name: '10X Long BNB Token',
    address: '0x7a5Ce2B56dC00Cb7b369Ad2e1b3309ABdc145Bef',
    decimals: 18,
    symbol: 'BNBMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6046.png',
  },
  {
    chainId: 1,
    name: '10X Long EOS Token',
    address: '0x4AaFf81cfe81523b1C4f6B6C075eBF9bBDb094C9',
    decimals: 18,
    symbol: 'EOSMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6047.png',
  },
  {
    chainId: 1,
    name: '10X Long Ethereum Classic Token',
    address: '0x827E75a2C5F3cC0B2fEF9273f6AE4518551ECafB',
    decimals: 18,
    symbol: 'ETCMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6048.png',
  },
  {
    chainId: 1,
    name: '10X Long Exchange Token Index Token',
    address: '0x456bd836910b3853dc22529dbc2cbe072d967141',
    decimals: 18,
    symbol: 'EXCHMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6049.png',
  },
  {
    chainId: 1,
    name: '10X Long Huobi Token Token',
    address: '0xb621bB8064A1B2b2d6c2fD4330293F3E7ACbC15f',
    decimals: 18,
    symbol: 'HTMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6050.png',
  },
  {
    chainId: 1,
    name: '10X Long LEO Token',
    address: '0xcFEB236743Bd4b3789D28bbEa9Dc4ef0792c87f9',
    decimals: 18,
    symbol: 'LEOMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6052.png',
  },
  {
    chainId: 1,
    name: '7Chain',
    address: '0x0D5BB28972e0b2d63732F558b4Af265AA5407467',
    decimals: 4,
    symbol: 'VII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6054.png',
  },
  {
    chainId: 1,
    name: '10X Long Litecoin Token',
    address: '0x08dA69ca2BFe378f384cb76c84D6deD701eC65C7',
    decimals: 18,
    symbol: 'LTCMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6055.png',
  },
  {
    chainId: 1,
    name: '10X Long Midcap Index Token',
    address: '0x24982f160803DaCa0233661d1860de77046519a4',
    decimals: 18,
    symbol: 'MIDMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6056.png',
  },
  {
    chainId: 1,
    name: '10X Long OKB Token',
    address: '0xa160d857fced9436a57c6a405b2f379aceb83186',
    decimals: 18,
    symbol: 'OKBMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6057.png',
  },
  {
    chainId: 1,
    name: '10X Long Shitcoin Index Token',
    address: '0xf5312da58ab6c1706d651ed9fcd3ca000c3a25b7',
    decimals: 18,
    symbol: 'MOONSHIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6058.png',
  },
  {
    chainId: 1,
    name: '10X Long TRX Token',
    address: '0x681f1a3761384109e5bc52f7d479ef27540a5641',
    decimals: 18,
    symbol: 'TRXMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6059.png',
  },
  {
    chainId: 1,
    name: '10X Long XRP Token',
    address: '0x574A37B7244dABB08CE1618193F818f1C85180E6',
    decimals: 18,
    symbol: 'XRPMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6060.png',
  },
  {
    chainId: 1,
    name: '10X Short Bitcoin Cash Token',
    address: '0x2E185eF6684d2D0fE9D311782E0ef738d63861E0',
    decimals: 18,
    symbol: 'BCHDOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6061.png',
  },
  {
    chainId: 1,
    name: '10X Short Bitcoin Token',
    address: '0xE1403e2972145D86F66299380ADe23169580beca',
    decimals: 18,
    symbol: 'DOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6063.png',
  },
  {
    chainId: 1,
    name: '10X Short BNB Token',
    address: '0xc8e69913c0ea5d45bf67e52412eb8bcab5b9875e',
    decimals: 18,
    symbol: 'BNBDOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6064.png',
  },
  {
    chainId: 1,
    name: 'TODA Note',
    address: '0x6d68A12305051291d194162b8406aEA080342645',
    decimals: 18,
    symbol: 'TDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6065.png',
  },
  {
    chainId: 1,
    name: '10X Short Ethereum Token',
    address: '0x03fdf7faddabebd21abf7185d205320d78622b56',
    decimals: 18,
    symbol: 'ETHDOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6066.png',
  },
  {
    chainId: 1,
    name: 'Assemble Protocol',
    address: '0x2565ae0385659badcada1031db704442e1b69982',
    decimals: 18,
    symbol: 'ASM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6069.png',
  },
  {
    chainId: 1,
    name: '10X Short Litecoin Token',
    address: '0x31E15A071A5340F0393eA98dDe3A095D64206A02',
    decimals: 18,
    symbol: 'LTCDOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6071.png',
  },
  {
    chainId: 1,
    name: '10X Short OKB Token',
    address: '0x2474cA2e5A1cE0cA904Ca512530C2555048603bE',
    decimals: 18,
    symbol: 'OKBDOOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6073.png',
  },
  {
    chainId: 1,
    name: '3X Long Algorand Token',
    address: '0x584936357d68f5143f12e2e64f0089db93814dad',
    decimals: 18,
    symbol: 'ALGOBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6074.png',
  },
  {
    chainId: 1,
    name: 'Afri Union Coin',
    address: '0xbeea2890775889c7723e5c0b80527976803b5a99',
    decimals: 18,
    symbol: 'AUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6076.png',
  },
  {
    chainId: 1,
    name: '3X Long Altcoin Index Token',
    address: '0xd829664cdbf3195b2ce76047a65de29e7ed0a9a8',
    decimals: 18,
    symbol: 'ALTBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6077.png',
  },
  {
    chainId: 1,
    name: '3X Long BitMax Token Token',
    address: '0x9885cA101DFd8f23D364874F799554C52BFee820',
    decimals: 18,
    symbol: 'BTMXBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6078.png',
  },
  {
    chainId: 1,
    name: '3X Long Cardano Token',
    address: '0x43dE1145Cd22f0a9Cc99e51c205e6e81161Df6B9',
    decimals: 18,
    symbol: 'ADABULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6079.png',
  },
  {
    chainId: 1,
    name: '3X Long Cosmos Token',
    address: '0x75F0038B8fbfCCAFe2aB9a51431658871bA5182C',
    decimals: 18,
    symbol: 'ATOMBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6080.png',
  },
  {
    chainId: 1,
    name: '3X Long Dogecoin Token',
    address: '0x7AA6b33fB7F395DDBca7b7A33264A3c799Fa626f',
    decimals: 18,
    symbol: 'DOGEBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6081.png',
  },
  {
    chainId: 1,
    name: '3X Long Dragon Index Token',
    address: '0x3335f16AF9008bFd32f1eE6C2Be5d4f84FA0b9da',
    decimals: 18,
    symbol: 'DRGNBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6082.png',
  },
  {
    chainId: 1,
    name: '3X Long Ethereum Classic Token',
    address: '0x974c98Bc2e82FA18de92B7e697A1D9BD25682e80',
    decimals: 18,
    symbol: 'ETCBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6083.png',
  },
  {
    chainId: 1,
    name: '3X Long Huobi Token Token',
    address: '0x0D5E2681D2AaDC91F7DA4146740180A2190f0c79',
    decimals: 18,
    symbol: 'HTBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6084.png',
  },
  {
    chainId: 1,
    name: '3X Long Matic Token',
    address: '0x7e03521b9dA891Ca3F79A8728E2eaeb24886c5f9',
    decimals: 18,
    symbol: 'MATICBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6085.png',
  },
  {
    chainId: 1,
    name: '3X Long Midcap Index Token',
    address: '0x59db60bd41bbc8ca4c1efee6ea2a97eae1e30cf5',
    decimals: 18,
    symbol: 'MIDBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6086.png',
  },
  {
    chainId: 1,
    name: '3X Long OKB Token',
    address: '0x8aF785687ee8D75114B028997c9ca36b5CC67Bc4',
    decimals: 18,
    symbol: 'OKBBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6087.png',
  },
  {
    chainId: 1,
    name: '3X Long Shitcoin Index Token',
    address: '0xd06b25f67a17f12b41f615b34d87ecd716ff55a0',
    decimals: 18,
    symbol: 'BULLSHIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6088.png',
  },
  {
    chainId: 1,
    name: 'VBT',
    address: '0x1ffe24629f1b3df74fc0f6e5d086f2fd09258ff2',
    decimals: 18,
    symbol: 'VBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6089.png',
  },
  {
    chainId: 1,
    name: '3X Long TomoChain Token',
    address: '0xa38920C00D1a5303dB538A3Ea08da7a779e1F751',
    decimals: 18,
    symbol: 'TOMOBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6090.png',
  },
  {
    chainId: 1,
    name: '3X Short Algorand Token',
    address: '0x057fb10e3fec001a40e6b75d3a30b99e23e54107',
    decimals: 18,
    symbol: 'ALGOBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6091.png',
  },
  {
    chainId: 1,
    name: '3X Short Altcoin Index Token',
    address: '0x90b417ab462440cf59767bcf72d0d91ca42f21ed',
    decimals: 18,
    symbol: 'ALTBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6092.png',
  },
  {
    chainId: 1,
    name: '3X Short BitMax Token Token',
    address: '0xdBF637f78624F896B92F801E81f6031b7865eD20',
    decimals: 18,
    symbol: 'BTMXBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6093.png',
  },
  {
    chainId: 1,
    name: '3X Short Chainlink Token',
    address: '0xa209Ba34C01A2713a4453A656630cc9De8A362Bc',
    decimals: 18,
    symbol: 'LINKBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6094.png',
  },
  {
    chainId: 1,
    name: 'Galaxy Wallet',
    address: '0x486a72811ae65c4c814ba929d6da35497d21296f',
    decimals: 18,
    symbol: 'GC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6095.png',
  },
  {
    chainId: 1,
    name: '3X Short Cosmos Token',
    address: '0x3B834A620751A811f65D8f599b3b72617A4418d0',
    decimals: 18,
    symbol: 'ATOMBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6096.png',
  },
  {
    chainId: 1,
    name: '3X Short Dogecoin Token',
    address: '0xF1d32952E2fbB1a91e620b0FD7fBC8a8879A47f3',
    decimals: 18,
    symbol: 'DOGEBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6097.png',
  },
  {
    chainId: 1,
    name: '3X Short Dragon Index Token',
    address: '0x223FB5c14C00Cfb70cF56BB63c2EeF2d74fE1A78',
    decimals: 18,
    symbol: 'DRGNBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6098.png',
  },
  {
    chainId: 1,
    name: '3X Short Ethereum Classic Token',
    address: '0xA340f0937a8c00DB11C83Cc16CEC12310160F0b6',
    decimals: 18,
    symbol: 'ETCBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6099.png',
  },
  {
    chainId: 1,
    name: '3X Short Matic Token',
    address: '0xbE893b4C214DBFfC17ef1E338fBDb7061FF09237',
    decimals: 18,
    symbol: 'MATICBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6100.png',
  },
  {
    chainId: 1,
    name: '3X Short OKB Token',
    address: '0x053e5ba7cb9669dcc2feb2d0e1d3d4a0ad6aae39',
    decimals: 18,
    symbol: 'OKBBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6101.png',
  },
  {
    chainId: 1,
    name: '3X Short Shitcoin Index Token',
    address: '0x48dee19c81b89a9ab473361bae7a19210f2deaa4',
    decimals: 18,
    symbol: 'BEARSHIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6102.png',
  },
  {
    chainId: 1,
    name: '3X Short TomoChain Token',
    address: '0xA1653CB37852249e4f18dfBc473a5cE3F88Fa6aD',
    decimals: 18,
    symbol: 'TOMOBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6103.png',
  },
  {
    chainId: 1,
    name: 'Derivex',
    address: '0x975769557510167d25BEed6E32806537173E292C',
    decimals: 18,
    symbol: 'DVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6104.png',
  },
  {
    chainId: 1,
    name: 'AI Crypto',
    address: '0xa7a5c03399f4739f4afa934bb9053c992b53d7a2',
    decimals: 18,
    symbol: 'AIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6106.png',
  },
  {
    chainId: 1,
    name: 'KING OF CATERING',
    address: '0x677a3f5d699c70c606220382c41fa473f7e2f6bb',
    decimals: 18,
    symbol: 'KOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6108.png',
  },
  {
    chainId: 1,
    name: 'Essek Tov',
    address: '0x4526Dc4AC8F692535eD9bf235a3A20A2b9Ff3328',
    decimals: 18,
    symbol: 'ETO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6109.png',
  },
  {
    chainId: 1,
    name: 'KYSC Token',
    address: '0x7e1a6fb26702ecb0439a641c5c285f7eec430419',
    decimals: 18,
    symbol: 'KYSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6110.png',
  },
  {
    chainId: 1,
    name: 'Lapis Chain',
    address: '0x97bdd9fdfa0b1677a2a353848514d93c108bec85',
    decimals: 10,
    symbol: 'LPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6112.png',
  },
  {
    chainId: 1,
    name: 'BlackPearl Token',
    address: '0x426fc8be95573230f6e6bc4af91873f0c67b21b4',
    decimals: 18,
    symbol: 'BPLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6113.png',
  },
  {
    chainId: 1,
    name: 'European Coin Alliance',
    address: '0xfab25D4469444f28023075Db5932497D70094601',
    decimals: 18,
    symbol: 'ECA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6114.png',
  },
  {
    chainId: 1,
    name: 'Chess Coin',
    address: '0x5f75112bBB4E1aF516fBE3e21528C63DA2B6a1A5',
    decimals: 18,
    symbol: 'CHESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6115.png',
  },
  {
    chainId: 1,
    name: 'megaBONK',
    address: '0xacfe45c352c902ae3a3f9b6bfe6ec994c5d791bf',
    decimals: 18,
    symbol: 'MBONK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6116.png',
  },
  {
    chainId: 1,
    name: 'ArgenPeso',
    address: '0x29917c3b1c2b4779a7b61f08d98b3da0fcf3b6a4',
    decimals: 18,
    symbol: 'ARGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6117.png',
  },
  {
    chainId: 1,
    name: 'BitoPro Exchange Token',
    address: '0x93b1e78a3e652cd2e71c4a767595b77282344932',
    decimals: 18,
    symbol: 'BITO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6118.png',
  },
  {
    chainId: 1,
    name: 'Foundry',
    address: '0x6c972b70c533e2e045f333ee28b9ffb8d717be69',
    decimals: 18,
    symbol: 'FRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6119.png',
  },
  {
    chainId: 1,
    name: 'Anchor Neural World',
    address: '0x7dbdd9dafdc4c1c03d67925a4f85daa398af32b0',
    decimals: 18,
    symbol: 'ANW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6120.png',
  },
  {
    chainId: 1,
    name: 'VINX COIN',
    address: '0x14F0a12A43c36C49D4b403dD6e1A9B8222BE456C',
    decimals: 18,
    symbol: 'VXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6121.png',
  },
  {
    chainId: 1,
    name: 'BTC Network Demand Set II',
    address: '0xac8ea871e2d5f4be618905f36f73c760f8cfdc8e',
    decimals: 18,
    symbol: 'BYTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6126.png',
  },
  {
    chainId: 1,
    name: 'dForce DAI',
    address: '0x02285acaafeb533e03a7306c55ec031297df9224',
    decimals: 18,
    symbol: 'DDAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6127.png',
  },
  {
    chainId: 1,
    name: 'Chad Link Set',
    address: '0x19f4a2f8e21915376f1429c26a3a9b9b1db5ff5a',
    decimals: 18,
    symbol: 'CHADLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6128.png',
  },
  {
    chainId: 1,
    name: 'ETH 20 Day MA Crossover Set',
    address: '0x9ea463Ec4cE9E9E5bc9cFd0187C4Ac3a70DD951D',
    decimals: 18,
    symbol: 'ETH20SMACO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6129.png',
  },
  {
    chainId: 1,
    name: 'ETH 20 Day MA Crossover Yield Set',
    address: '0xeF0fDA1d4bd73DDC2f93A4e46E2E5aDBC2D668f4',
    decimals: 18,
    symbol: 'ETHMACOAPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6130.png',
  },
  {
    chainId: 1,
    name: 'dForce GOLDx',
    address: '0x355c665e101b9da58704a8fddb5feef210ef20c0',
    decimals: 18,
    symbol: 'GOLDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6132.png',
  },
  {
    chainId: 1,
    name: 'ETH 26 EMA Crossover Yield II',
    address: '0x54e8371C1EC43e58fB53D4ef4eD463C17Ba8a6bE',
    decimals: 18,
    symbol: 'ETHEMAAPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6133.png',
  },
  {
    chainId: 1,
    name: 'ETH AI Limit Loss',
    address: '0x7e4d1cd8927ce41bcbfa4f32cada1a6998cb5a51',
    decimals: 18,
    symbol: 'ELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6134.png',
  },
  {
    chainId: 1,
    name: 'ETH/BTC Long-Only Alpha Portfolio',
    address: '0x253444bd9ecf11e5516d6d00974e91c9f0857ccb',
    decimals: 18,
    symbol: 'EBLOAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6135.png',
  },
  {
    chainId: 1,
    name: 'dForce USDC',
    address: '0x16c9cf62d8dac4a38fb50ae5fa5d51e9170f3179',
    decimals: 6,
    symbol: 'DUSDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6136.png',
  },
  {
    chainId: 1,
    name: 'dForce USDT',
    address: '0x868277d475e0e475e38ec5cda2d9c83b5e1d9fc8',
    decimals: 6,
    symbol: 'DUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6137.png',
  },
  {
    chainId: 1,
    name: 'DIA',
    address: '0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419',
    decimals: 18,
    symbol: 'DIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6138.png',
  },
  {
    chainId: 1,
    name: 'ETH/BTC RSI Ratio Trading Set',
    address: '0xbf70A33A13fBe8D0106Df321Da0Cf654d2E9Ab50',
    decimals: 18,
    symbol: 'ETHBTCRSI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6139.png',
  },
  {
    chainId: 1,
    name: 'ETH/LINK Price Action Candlestick Set',
    address: '0x542156d51d10db5accb99f9db7e7c91b74e80a2c',
    decimals: 18,
    symbol: 'LINKETHPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6140.png',
  },
  {
    chainId: 1,
    name: 'ETH Price Action Candlestick Set',
    address: '0x09e4bdfb273245063ef5e800d891eff7d04f9b83',
    decimals: 18,
    symbol: 'ETHPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6141.png',
  },
  {
    chainId: 1,
    name: 'FlashX Advance',
    address: '0xf0B0A13d908253D954BA031a425dFd54f94a2e3D',
    decimals: 8,
    symbol: 'FSXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6142.png',
  },
  {
    chainId: 1,
    name: 'ETH RSI 60/40 Crossover Set',
    address: '0x93E01899c10532d76C0E864537a1D26433dBbDdB',
    decimals: 18,
    symbol: 'ETHRSI6040',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6143.png',
  },
  {
    chainId: 1,
    name: 'ETH RSI 60/40 Yield Set',
    address: '0x136faE4333EA36A24bb751E2d505D6ca4Fd9f00b',
    decimals: 18,
    symbol: 'ETHRSIAPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6144.png',
  },
  {
    chainId: 1,
    name: 'yffi finance',
    address: '0xcee1d3c3a02267e37e6b373060f79d5d7b9e1669',
    decimals: 18,
    symbol: 'YFFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6145.png',
  },
  {
    chainId: 1,
    name: 'FlynnJamm',
    address: '0x56687cf29Ac9751Ce2a4E764680B6aD7E668942e',
    decimals: 4,
    symbol: 'JAMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6146.png',
  },
  {
    chainId: 1,
    name: 'ETH RSI 60/40 Yield Set II',
    address: '0x9f49ed43c90a540d1cf12f6170ace8d0b88a14e6',
    decimals: 18,
    symbol: 'ETHRSIAPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6147.png',
  },
  {
    chainId: 1,
    name: 'FlexETH/BTC Set',
    address: '0xdbf5c7d8ac5007667617a15db2c1b1d616c9d302',
    decimals: 18,
    symbol: 'FLEXETHBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6152.png',
  },
  {
    chainId: 1,
    name: 'Holistic BTC Set',
    address: '0x7510d6fac98a6eca2db7c9357619715a7f5049d4',
    decimals: 18,
    symbol: 'TCAPBTCUSDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6153.png',
  },
  {
    chainId: 1,
    name: 'Holistic ETH Set',
    address: '0x8e4dbf540bf814c044785218b58c930b20a56be1',
    decimals: 18,
    symbol: 'TCAPETHDAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6154.png',
  },
  {
    chainId: 1,
    name: 'Intelligent Ratio Set',
    address: '0xBA8Ea15b647F54D9ff849670FcaAcF35Df21A457',
    decimals: 18,
    symbol: 'INTRATIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6155.png',
  },
  {
    chainId: 1,
    name: 'Donut',
    address: '0xc0f9bd5fa5698b6505f643900ffa515ea5df54a9',
    decimals: 18,
    symbol: 'DONUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6156.png',
  },
  {
    chainId: 1,
    name: 'LINK/ETH RSI Ratio Trading Set',
    address: '0x8933ea1Ce67B946BdF2436cE860fFBb53Ce814d2',
    decimals: 18,
    symbol: 'LINKETHRSI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6158.png',
  },
  {
    chainId: 1,
    name: 'LINK Profit Taker Set',
    address: '0x78e29d35573bea6265aedfcb9f45481b717ebfde',
    decimals: 18,
    symbol: 'LINKPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6159.png',
  },
  {
    chainId: 1,
    name: 'LINK RSI Crossover Set',
    address: '0x0329d23fC7B1b1e6Cca57aFA3F0090F1189069e8',
    decimals: 18,
    symbol: 'LINKRSICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6161.png',
  },
  {
    chainId: 1,
    name: 'WhiteRockCasino',
    address: '0x7c9D8Fb3bDe3D9Ea6e89170618C2dC3d16695D36',
    decimals: 18,
    symbol: 'WRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6163.png',
  },
  {
    chainId: 1,
    name: 'JUIICE',
    address: '0x2CaE31D2Ca104a951654456f46168Bc9F88FDc65',
    decimals: 18,
    symbol: 'JUI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6169.png',
  },
  {
    chainId: 1,
    name: 'LP-bCurve',
    address: '0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B',
    decimals: 18,
    symbol: 'BCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6171.png',
  },
  {
    chainId: 1,
    name: 'LP-paxCurve',
    address: '0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8',
    decimals: 18,
    symbol: 'PAXCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6172.png',
  },
  {
    chainId: 1,
    name: 'LP renBTC Curve',
    address: '0x49849c98ae39fff122806c06791fa73784fb3675',
    decimals: 18,
    symbol: 'RENBTCCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6173.png',
  },
  {
    chainId: 1,
    name: 'LP sBTC Curve',
    address: '0x075b1bb99792c9e1041ba13afef80c91a1e70fb3',
    decimals: 18,
    symbol: 'SBTCCURVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6174.png',
  },
  {
    chainId: 1,
    name: 'Marvrodi Salute Vison',
    address: '0x3d3ab800d105fbd2f97102675a412da3dc934357',
    decimals: 18,
    symbol: 'MSV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6175.png',
  },
  {
    chainId: 1,
    name: 'eXciting Japan Coin',
    address: '0x604026696fDB3C6720AE3049C46d59AC604dEA0A',
    decimals: 18,
    symbol: 'XJP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6177.png',
  },
  {
    chainId: 1,
    name: 'SeChain',
    address: '0xF5717f5DF41eA67Ef67DFD3c1d02F9940bcF5d08',
    decimals: 3,
    symbol: 'SNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6179.png',
  },
  {
    chainId: 1,
    name: 'Suku',
    address: '0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7',
    decimals: 18,
    symbol: 'SUKU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6180.png',
  },
  {
    chainId: 1,
    name: 'USGold',
    address: '0x4000369acfa25c8fe5d17fe3312e30c332bef633',
    decimals: 9,
    symbol: 'USG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6182.png',
  },
  {
    chainId: 1,
    name: 'Useless Eth Token Lite',
    address: '0xa5a283557653f36cf9aA0d5cC74B1e30422349f2',
    decimals: 8,
    symbol: 'UETL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6183.png',
  },
  {
    chainId: 1,
    name: 'BeeStore',
    address: '0xa4fb385820a9eef842a419e08f8540fd7d1bf6e8',
    decimals: 5,
    symbol: 'BHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6184.png',
  },
  {
    chainId: 1,
    name: 'Serum',
    address: '0x476c5e26a75bd202a9683ffd34359c0cc15be0ff',
    decimals: 18,
    symbol: 'SRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6187.png',
  },
  {
    chainId: 1,
    name: 'iETH',
    address: '0xA9859874e1743A32409f75bB11549892138BBA1E',
    decimals: 18,
    symbol: 'IETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6188.png',
  },
  {
    chainId: 1,
    name: 'sTRX',
    address: '0x0944d2C41FEF3088467287e208E5bBB622A0c09C',
    decimals: 18,
    symbol: 'sTRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6189.png',
  },
  {
    chainId: 1,
    name: 'sLINK',
    address: '0xbBC455cb4F1B9e4bFC4B73970d360c8f032EfEE6',
    decimals: 18,
    symbol: 'sLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6190.png',
  },
  {
    chainId: 1,
    name: 'sXAU',
    address: '0x261EfCdD24CeA98652B9700800a13DfBca4103fF',
    decimals: 18,
    symbol: 'SXAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6191.png',
  },
  {
    chainId: 1,
    name: 'sXTZ',
    address: '0xF45B14ddaBF0F0e275E215b94dD24Ae013a27F12',
    decimals: 18,
    symbol: 'SXTZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6192.png',
  },
  {
    chainId: 1,
    name: 'Cream Finance',
    address: '0x2ba592f78db6436527729929aaf6c908497cb200',
    decimals: 18,
    symbol: 'CREAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6193.png',
  },
  {
    chainId: 1,
    name: 'Geeq',
    address: '0x6b9f031d718dded0d681c20cb754f97b3bb81b78',
    decimals: 18,
    symbol: 'GEEQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6194.png',
  },
  {
    chainId: 1,
    name: 'Unitrade',
    address: '0x6f87d756daf0503d08eb8993686c7fc01dc44fb1',
    decimals: 18,
    symbol: 'TRADE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6195.png',
  },
  {
    chainId: 1,
    name: 'TOWB',
    address: '0x73083Eb11FF9b2081d916E0e045428fAC8FAe0d9',
    decimals: 18,
    symbol: 'TWB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6196.png',
  },
  {
    chainId: 1,
    name: 'Rozeus',
    address: '0xe55cc44c0cf9cede2d68f9432cbeeafa6357ed92',
    decimals: 8,
    symbol: 'ROZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6198.png',
  },
  {
    chainId: 1,
    name: 'iLINK',
    address: '0x2d7aC061fc3db53c39fe1607fB8cec1B2C162B01',
    decimals: 18,
    symbol: 'ILINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6199.png',
  },
  {
    chainId: 1,
    name: 'sXRP',
    address: '0xa2B0fDe6D710e201d0d608e924A484d1A5fEd57c',
    decimals: 18,
    symbol: 'SXRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6201.png',
  },
  {
    chainId: 1,
    name: 'sDASH',
    address: '0xfE33ae95A9f0DA8A845aF33516EDc240DCD711d6',
    decimals: 18,
    symbol: 'SDASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6202.png',
  },
  {
    chainId: 1,
    name: 'sLTC',
    address: '0xC14103C2141E842e228FBaC594579e798616ce7A',
    decimals: 18,
    symbol: 'SLTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6203.png',
  },
  {
    chainId: 1,
    name: 'sBNB',
    address: '0x013ae307648f529aa72c5767a334ddd37aab43c3',
    decimals: 18,
    symbol: 'SBNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6204.png',
  },
  {
    chainId: 1,
    name: 'iXRP',
    address: '0x27269b3e45A4D3E79A3D6BFeE0C8fB13d0D711A6',
    decimals: 18,
    symbol: 'IXRP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6205.png',
  },
  {
    chainId: 1,
    name: 'sETC',
    address: '0x22602469d704BfFb0936c7A7cfcD18f7aA269375',
    decimals: 18,
    symbol: 'SETC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6207.png',
  },
  {
    chainId: 1,
    name: 'iXTZ',
    address: '0xc2992b2C22238F296c2f429ee2f7AfB462Ed1750',
    decimals: 18,
    symbol: 'IXTZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6208.png',
  },
  {
    chainId: 1,
    name: 'Spheroid Universe',
    address: '0xa0cf46eb152656c7090e769916eb44a138aaa406',
    decimals: 18,
    symbol: 'SPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6209.png',
  },
  {
    chainId: 1,
    name: 'The Sandbox',
    address: '0x3845badAde8e6dFF049820680d1F14bD3903a5d0',
    decimals: 18,
    symbol: 'SAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6210.png',
  },
  {
    chainId: 1,
    name: 'Black Diamond Rating',
    address: '0x78a5b382b9a83fe042a4f7eb2399d563fda931c3',
    decimals: 2,
    symbol: 'HZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6214.png',
  },
  {
    chainId: 1,
    name: 'Master Coin Point',
    address: '0x63bf0126c6c4d17bb33c362151759ec21b36537b',
    decimals: 18,
    symbol: 'MACPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6215.png',
  },
  {
    chainId: 1,
    name: 'TokenBacon',
    address: '0x18162474734b1eabd795b25d978558c09f9e1807',
    decimals: 8,
    symbol: 'BAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6217.png',
  },
  {
    chainId: 1,
    name: 'Arcona',
    address: '0x0f71b8de197a1c84d31de0f1fa7926c365f052b3',
    decimals: 18,
    symbol: 'ARCONA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6218.png',
  },
  {
    chainId: 1,
    name: 'Bithachi',
    address: '0x8811e4dd5ec5eb8764b97cc814b1339089717ada',
    decimals: 8,
    symbol: 'BITH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6223.png',
  },
  {
    chainId: 1,
    name: 'Blockchain Exchange Alliance',
    address: '0x98d8d146e644171cd47ff8588987b7bdeef72a87',
    decimals: 18,
    symbol: 'BXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6225.png',
  },
  {
    chainId: 1,
    name: 'BMJ Coin',
    address: '0x25ce333B325F02C9720Da526A01b5F5be889b4e3',
    decimals: 18,
    symbol: 'BMJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6228.png',
  },
  {
    chainId: 1,
    name: 'BOOSTO',
    address: '0xdf0041891bda1f911c4243f328f7cf61b37f965b',
    decimals: 18,
    symbol: 'BST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6231.png',
  },
  {
    chainId: 1,
    name: 'Mozox',
    address: '0xea4931bfcf3260da6dbf0550e27f5c214e3c268b',
    decimals: 2,
    symbol: 'MOZOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6232.png',
  },
  {
    chainId: 1,
    name: 'MDsquare',
    address: '0xd32641191578ea9b208125ddd4ec5e7b84fcab4c',
    decimals: 18,
    symbol: 'TMED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6237.png',
  },
  {
    chainId: 1,
    name: '3X Long Tether Gold Token',
    address: '0xc9287623832668432099CEF2FfDEF3CeD14f4315',
    decimals: 18,
    symbol: 'XAUTBULL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6238.png',
  },
  {
    chainId: 1,
    name: '3X Short Tether Gold Token',
    address: '0x31cbf205e26ba63296fdbd254a6b1be3ed28ce47',
    decimals: 18,
    symbol: 'XAUTBEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6240.png',
  },
  {
    chainId: 1,
    name: 'OILage',
    address: '0xa29a8e360c0cba25a3719763fde43a1ee570271d',
    decimals: 8,
    symbol: 'OIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6241.png',
  },
  {
    chainId: 1,
    name: 'DeFiPie',
    address: '0x607C794cDa77efB21F8848B7910ecf27451Ae842',
    decimals: 18,
    symbol: 'PIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6243.png',
  },
  {
    chainId: 1,
    name: 'SocialGood',
    address: '0xddf7fd345d54ff4b40079579d4c4670415dbfd0a',
    decimals: 18,
    symbol: 'SG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6245.png',
  },
  {
    chainId: 1,
    name: 'Yield Farming Token',
    address: '0x26B3038a7Fc10b36c426846a9086Ef87328dA702',
    decimals: 18,
    symbol: 'YFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6247.png',
  },
  {
    chainId: 1,
    name: 'Ziktalk',
    address: '0x88303fed02b31db9c7a9eafb711da9ef4a03e5d3',
    decimals: 18,
    symbol: 'ZIK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6249.png',
  },
  {
    chainId: 1,
    name: 'WeSing Coin',
    address: '0x2dcd9b1a7ed408ff48bd4918a1f9c0535dc54ead',
    decimals: 6,
    symbol: 'WSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6250.png',
  },
  {
    chainId: 1,
    name: 'COST COIN+',
    address: '0x5f02cf3c7ada49DFC4A3645Fc85C8aE86808Dd9b',
    decimals: 18,
    symbol: 'AKM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6251.png',
  },
  {
    chainId: 1,
    name: 'EcoG9coin',
    address: '0xc0ec8caec55f37d47fbfa595727418868a21fd48',
    decimals: 8,
    symbol: 'EGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6252.png',
  },
  {
    chainId: 1,
    name: 'PHILLIPS PAY COIN',
    address: '0x84f710bae3316a74fb0fcb01904d2578a4cc6a26',
    decimals: 1,
    symbol: 'PPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6253.png',
  },
  {
    chainId: 1,
    name: 'THECASH',
    address: '0xcd475371e39c0d94e82fccc9dd0ea710d0dc0c0b',
    decimals: 18,
    symbol: 'TCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6254.png',
  },
  {
    chainId: 1,
    name: 'Thorium',
    address: '0x8cEa63f6383c1C13633F179F1af70ef75701a979',
    decimals: 18,
    symbol: 'TORM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6255.png',
  },
  {
    chainId: 1,
    name: 'SHENG',
    address: '0x22ef3753e3658e81d5a0d0889ce078178fe66595',
    decimals: 18,
    symbol: 'SHENG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6256.png',
  },
  {
    chainId: 1,
    name: 'Berry',
    address: '0x2d787D4f5005Bd66aC910c2E821241625c406ed5',
    decimals: 18,
    symbol: 'BERRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6257.png',
  },
  {
    chainId: 1,
    name: 'Uzone Token',
    address: '0xfa1004e9c0063e59dbf965b9490f3153b87fb45f',
    decimals: 8,
    symbol: 'UZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6260.png',
  },
  {
    chainId: 1,
    name: 'hybrix',
    address: '0x9b53e429b0badd98ef7f01f03702986c516a5715',
    decimals: 18,
    symbol: 'HY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6261.png',
  },
  {
    chainId: 1,
    name: 'Jubi Token',
    address: '0xEb7355C2f217b3485a591332Fe13C8c5A76A581D',
    decimals: 18,
    symbol: 'JT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6262.png',
  },
  {
    chainId: 1,
    name: 'Dark Energy Crystals',
    address: '0x9393fdc77090f31c7db989390d43f454b1a6e7f3',
    decimals: 3,
    symbol: 'DEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6264.png',
  },
  {
    chainId: 1,
    name: 'Kek.finance',
    address: '0x52cffe6dcc78f4853c0a7dc6b63d2ca0a8539d09',
    decimals: 18,
    symbol: 'KEK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6281.png',
  },
  {
    chainId: 1,
    name: 'Blocery',
    address: '0xf8aD7dFe656188A23e89da09506Adf7ad9290D5d',
    decimals: 18,
    symbol: 'BLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6283.png',
  },
  {
    chainId: 1,
    name: 'Evan',
    address: '0x89E3aC6Dd69C15e9223BE7649025d6F68Dab1d6a',
    decimals: 18,
    symbol: 'EVAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6298.png',
  },
  {
    chainId: 1,
    name: '1X Short Algorand Token',
    address: '0xfdc3D57eB7839ca68A2fAD7A93799c8e8aFA61B7',
    decimals: 18,
    symbol: 'ALGOHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6309.png',
  },
  {
    chainId: 1,
    name: '1X Short BNB Token',
    address: '0x2840aD41cf25Ad58303Ba24C416E79dCe4161b4F',
    decimals: 18,
    symbol: 'BNBHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6312.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Data Assets Management',
    address: '0xd5dC8921A5c58FB0ebA6db6b40Eab40283Dc3C01',
    decimals: 9,
    symbol: 'DDAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6315.png',
  },
  {
    chainId: 1,
    name: 'Game Ark',
    address: '0xffd6f608907914975b3713c89211faf2c70ece05',
    decimals: 18,
    symbol: 'GARK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6321.png',
  },
  {
    chainId: 1,
    name: 'LinkCoin Token',
    address: '0x9f549ebfd4974cd4ed4a1550d40394b44a7382aa',
    decimals: 18,
    symbol: 'LKN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6323.png',
  },
  {
    chainId: 1,
    name: '1X Short Ethereum Classic Token',
    address: '0x57e2B08E74B2B2C041e8B7bbB48bf1CDc6b8AfB6',
    decimals: 18,
    symbol: 'ETCHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6324.png',
  },
  {
    chainId: 1,
    name: '1X Short Exchange Token Index Token',
    address: '0xf8CC67e304f8e1A351ED83b4DBBe6B4076d51376',
    decimals: 18,
    symbol: 'EXCHHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6325.png',
  },
  {
    chainId: 1,
    name: 'X-Block',
    address: '0x53f0C9F1b6e283A59bCD672e80e2222b97E534Cb',
    decimals: 18,
    symbol: 'IX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6326.png',
  },
  {
    chainId: 1,
    name: '1X Short Huobi Token Token',
    address: '0x3008186FE6e3bCA6D1362105A48ec618672ce5b3',
    decimals: 18,
    symbol: 'HTHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6327.png',
  },
  {
    chainId: 1,
    name: '1X Short LEO Token',
    address: '0xD83c5c357969628272DEf87DcdB5B66352dFD794',
    decimals: 18,
    symbol: 'LEOHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6329.png',
  },
  {
    chainId: 1,
    name: 'TUNE TOKEN',
    address: '0x6b4e0684806fe53902469b6286024db9c6271f53',
    decimals: 18,
    symbol: 'TUNE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6330.png',
  },
  {
    chainId: 1,
    name: '1X Short OKB Token',
    address: '0x889BC62E94bb6902D022bB82B38f7FCd637Df28C',
    decimals: 18,
    symbol: 'OKBHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6333.png',
  },
  {
    chainId: 1,
    name: '1X Short TRX Token',
    address: '0xe58C8dF0088Cf27b26C7D546A9835deAcC29496c',
    decimals: 18,
    symbol: 'TRXHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6340.png',
  },
  {
    chainId: 1,
    name: '1X Short XRP Token',
    address: '0x55b54D8fB1640d1321D5164590e7B020BA43def2',
    decimals: 18,
    symbol: 'XRPHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6342.png',
  },
  {
    chainId: 1,
    name: 'ForesterX',
    address: '0x002f2264AEec71041Ae5739ecf0a2C80c5EA30FA',
    decimals: 18,
    symbol: 'FEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6367.png',
  },
  {
    chainId: 1,
    name: 'GramGold Coin',
    address: '0x1be7cfd61aa8daaa9ff2f3b8820888f09462d037',
    decimals: 8,
    symbol: 'GGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6368.png',
  },
  {
    chainId: 1,
    name: '1X Short EOS Token',
    address: '0xb38f206615325306dddeb0794a6482486b6b78b8',
    decimals: 18,
    symbol: 'EOSHEDGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6371.png',
  },
  {
    chainId: 1,
    name: 'Apexel Natural Nano',
    address: '0x2d48d03ff3389cc3546931efdff2799017f3420c',
    decimals: 18,
    symbol: 'ANN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6372.png',
  },
  {
    chainId: 1,
    name: 'AAAchain',
    address: '0x6aba1623ea906d1164cbb007e764ebde2514a2ba',
    decimals: 10,
    symbol: 'AAA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6373.png',
  },
  {
    chainId: 1,
    name: 'Armours',
    address: '0xa9ff725189fe00da9c5f27a580dc67fea61e3fb2',
    decimals: 18,
    symbol: 'ARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6374.png',
  },
  {
    chainId: 1,
    name: 'ASTA',
    address: '0xf2ddae89449b7d26309a5d54614b1fc99c608af5',
    decimals: 18,
    symbol: 'ASTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6375.png',
  },
  {
    chainId: 1,
    name: 'Banque Universal',
    address: '0xcef46305d096fa876dd23048bf80f9345282e3fc',
    decimals: 18,
    symbol: 'CBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6377.png',
  },
  {
    chainId: 1,
    name: 'Bavala',
    address: '0x10d88d7495ca381df1391229bdb82d015b9ad17d',
    decimals: 18,
    symbol: 'BVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6378.png',
  },
  {
    chainId: 1,
    name: 'BCAT',
    address: '0xfdeaa4ab9fea519afd74df2257a21e5bca0dfd3f',
    decimals: 18,
    symbol: 'BCAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6379.png',
  },
  {
    chainId: 1,
    name: 'BEEREX',
    address: '0x1138d8b876bb048b72ec7cd222f6a282384b505a',
    decimals: 18,
    symbol: 'BRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6381.png',
  },
  {
    chainId: 1,
    name: 'BIGBANG Coin',
    address: '0x91bd140bf6656228583ce1bb7c04f32609625644',
    decimals: 18,
    symbol: 'BIGB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6384.png',
  },
  {
    chainId: 1,
    name: 'Boolean',
    address: '0x6c929cde908481f3d1d775008791f42b1b89dbb0',
    decimals: 18,
    symbol: 'BOOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6386.png',
  },
  {
    chainId: 1,
    name: 'BoxAxis',
    address: '0xacf3d402e5e2c3edd5b8129e966017d293f12a4c',
    decimals: 18,
    symbol: 'BAXS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6387.png',
  },
  {
    chainId: 1,
    name: 'BPOP',
    address: '0x0452aeD878805514e28Fb5BD0B56Bef92176E32A',
    decimals: 8,
    symbol: 'BPOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6388.png',
  },
  {
    chainId: 1,
    name: 'BQCC Token',
    address: '0x6d3475a51Ef25e210e7f2851Ce4aF528738A975A',
    decimals: 6,
    symbol: 'BQCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6389.png',
  },
  {
    chainId: 1,
    name: 'Braziliex Token',
    address: '0xda5180086461ff6eeb09580181ac160522dcdcd4',
    decimals: 8,
    symbol: 'BRZX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6390.png',
  },
  {
    chainId: 1,
    name: 'BSYS',
    address: '0x3004cf8b4e28d60f4e305df25a57cd5faf37b8d5',
    decimals: 18,
    symbol: 'BSYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6391.png',
  },
  {
    chainId: 1,
    name: 'Bytus',
    address: '0x87f14e9460cecb789f1b125b2e3e353ff8ed6fcd',
    decimals: 18,
    symbol: 'BYTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6393.png',
  },
  {
    chainId: 1,
    name: 'Cherry Token',
    address: '0x5c89736e9454200141b80c37eb28eaceca2ce8cb',
    decimals: 8,
    symbol: 'YT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6395.png',
  },
  {
    chainId: 1,
    name: 'CoinPark Token',
    address: '0xfd45e61e085b3e7a1990a47828d757755b206eee',
    decimals: 18,
    symbol: 'CP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6396.png',
  },
  {
    chainId: 1,
    name: 'Coinzo Token',
    address: '0xc1965d7d18f37062b18ab3d5d1fe7f69873b30dd',
    decimals: 18,
    symbol: 'CNZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6397.png',
  },
  {
    chainId: 1,
    name: 'CREATIVE MEDIA INITIATIVE',
    address: '0xacb53386b1c8015ae9352c8482d10c0d4a03c38a',
    decimals: 18,
    symbol: 'CMID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6399.png',
  },
  {
    chainId: 1,
    name: 'Crebit',
    address: '0xCA8785Ee38A87578bAA7d6B290efC694508D81D9',
    decimals: 18,
    symbol: 'CBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6400.png',
  },
  {
    chainId: 1,
    name: 'Cryptassist',
    address: '0xf7461c8d8e469e9c41a9013dc09ba8abed66ef65',
    decimals: 8,
    symbol: 'CTAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6401.png',
  },
  {
    chainId: 1,
    name: 'Cryptid',
    address: '0x4599836c212CD988EAccc54C820Ee9261cdaAC71',
    decimals: 18,
    symbol: 'CID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6402.png',
  },
  {
    chainId: 1,
    name: 'AGA Token',
    address: '0x2d80f5f5328fdcb6eceb7cacf5dd8aedaec94e20',
    decimals: 18,
    symbol: 'AGA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6404.png',
  },
  {
    chainId: 1,
    name: 'MiniSwap',
    address: '0x4d953cf077c0c95ba090226e59a18fcf97db44ec',
    decimals: 18,
    symbol: 'MINI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6405.png',
  },
  {
    chainId: 1,
    name: 'sBTC',
    address: '0x309013d55fb0e8c17363bcc79f25d92f711a5802',
    decimals: 9,
    symbol: 'sBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6406.png',
  },
  {
    chainId: 1,
    name: 'YF Link',
    address: '0x28cb7e841ee97947a86B06fA4090C8451f64c0be',
    decimals: 18,
    symbol: 'YFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6407.png',
  },
  {
    chainId: 1,
    name: 'Academy Token',
    address: '0x1efc4dfd580df95426a0f04848870bd8cb5a338e',
    decimals: 18,
    symbol: 'ACAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6408.png',
  },
  {
    chainId: 1,
    name: 'Ethverse',
    address: '0xeeeeeeeee2af8d0e1940679860398308e0ef24d6',
    decimals: 18,
    symbol: 'ETHV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6409.png',
  },
  {
    chainId: 1,
    name: 'Feellike',
    address: '0x9235bda06b8807161b8fbb1e102cb654555b212f',
    decimals: 3,
    symbol: 'FLL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6410.png',
  },
  {
    chainId: 1,
    name: 'DTOP Token',
    address: '0x54ad74edeab48e09ccc43ee324f2603071dad72b',
    decimals: 18,
    symbol: 'DTOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6414.png',
  },
  {
    chainId: 1,
    name: 'DAY',
    address: '0xe26668cc7ce5239304b5af8f54b4bd57d11084d2',
    decimals: 18,
    symbol: 'DAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6415.png',
  },
  {
    chainId: 1,
    name: 'Dengba Planet',
    address: '0xec79e0efa4ae3d8b3c9fbcee21683c7f2e507b66',
    decimals: 18,
    symbol: 'DBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6417.png',
  },
  {
    chainId: 1,
    name: 'Digital Rand',
    address: '0x9cb2f26a23b8d89973f08c957c4d7cdf75cd341c',
    decimals: 6,
    symbol: 'DZAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6418.png',
  },
  {
    chainId: 1,
    name: 'Digital Wallet',
    address: '0xc626c9e2247c8a0c863ad6daa97ed939e12786de',
    decimals: 8,
    symbol: 'DWC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6419.png',
  },
  {
    chainId: 1,
    name: 'Distributed Energy Coin',
    address: '0x58379bF685ea2e251AE63d3eE26269c7c3848A17',
    decimals: 8,
    symbol: 'DEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6420.png',
  },
  {
    chainId: 1,
    name: 'Dogz',
    address: '0x82a77710495a35549d2add797412b4a4497d33ef',
    decimals: 18,
    symbol: 'DOGZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6422.png',
  },
  {
    chainId: 1,
    name: 'Dragonbit',
    address: '0x9d3e0892D11f19f5181d4a4C5d04187a9e0d7032',
    decimals: 18,
    symbol: 'DRGB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6423.png',
  },
  {
    chainId: 1,
    name: 'Dreamscape',
    address: '0xf2b87ce9c2ce65e786d6ffee0fdb9629ceff05f2',
    decimals: 18,
    symbol: 'DSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6424.png',
  },
  {
    chainId: 1,
    name: 'EasySwap',
    address: '0xa0471cdd5c0dc2614535fd7505b17a651a8f0dab',
    decimals: 8,
    symbol: 'ESWA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6425.png',
  },
  {
    chainId: 1,
    name: 'DSYS',
    address: '0x10a34bbe9b3c5ad536ca23d5eefa81ca448e92ff',
    decimals: 18,
    symbol: 'DSYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6426.png',
  },
  {
    chainId: 1,
    name: 'ECP+ Technology',
    address: '0x8b8a8a91d7b8ec2e6ab37ed8ffbacee062c6f3c7',
    decimals: 6,
    symbol: 'ECP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6428.png',
  },
  {
    chainId: 1,
    name: 'Efficient Transaction Token',
    address: '0x1212b68d8555cf0b08f3371b926b3e1148b520f1',
    decimals: 18,
    symbol: 'ETT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6429.png',
  },
  {
    chainId: 1,
    name: 'Electric Vehicle Zone',
    address: '0x7a939bb714fd2a48ebeb1e495aa9aaa74ba9fa68',
    decimals: 18,
    symbol: 'EVZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6430.png',
  },
  {
    chainId: 1,
    name: 'EcoBall',
    address: '0x7c2af3a86b4bf47e6ee63ad9bde7b3b0ba7f95da',
    decimals: 18,
    symbol: 'ABA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6431.png',
  },
  {
    chainId: 1,
    name: 'ethArt',
    address: '0x34612903db071e888a4dadcaa416d3ee263a87b9',
    decimals: 18,
    symbol: 'ARTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6437.png',
  },
  {
    chainId: 1,
    name: 'EUP Chain',
    address: '0xe532a2A37b0707b4306B21B412D2E8C22f9824Ec',
    decimals: 18,
    symbol: 'EUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6439.png',
  },
  {
    chainId: 1,
    name: 'Faireum',
    address: '0x437365ffb4c5dd6fd6f9f6ed0b4a9e23d7edc9ce',
    decimals: 18,
    symbol: 'FAIRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6440.png',
  },
  {
    chainId: 1,
    name: 'FANBI TOKEN',
    address: '0x7a9716685f852ee268feb86dffa562d214cc13db',
    decimals: 6,
    symbol: 'FBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6442.png',
  },
  {
    chainId: 1,
    name: 'FIND Token',
    address: '0xdf859c9878ef5e742d7bbe3c22a496c088c89fa9',
    decimals: 18,
    symbol: 'FIND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6443.png',
  },
  {
    chainId: 1,
    name: 'FANZY',
    address: '0xED0e2041BFb5a426e5ED426A73765624E08BbB75',
    decimals: 18,
    symbol: 'FX1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6444.png',
  },
  {
    chainId: 1,
    name: 'FINPLE',
    address: '0x9d5e6b92ba3f75589943372df82dbd3a8a802e80',
    decimals: 18,
    symbol: 'FPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6445.png',
  },
  {
    chainId: 1,
    name: 'Fashion Coin',
    address: '0xB4Ba6C2d54c6aB55233c60dcd018d307112Ab84A',
    decimals: 18,
    symbol: 'FSHN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6446.png',
  },
  {
    chainId: 1,
    name: 'Fisco Coin',
    address: '0x0789dbAE94fb18e5789B8e4489BCB7A1ADB58622',
    decimals: 8,
    symbol: 'FSCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6447.png',
  },
  {
    chainId: 1,
    name: 'Force For Fast',
    address: '0x22f098F08c4eda4bE4ad6B4ba59866F3E98CEF92',
    decimals: 18,
    symbol: 'FFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6448.png',
  },
  {
    chainId: 1,
    name: 'Frenzy',
    address: '0x8720C8429b78df262360b0F39917a03f9B894746',
    decimals: 8,
    symbol: 'FZY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6451.png',
  },
  {
    chainId: 1,
    name: 'Frozencoin Network',
    address: '0xe5aee163513119f4f750376c718766b40fa37a5f',
    decimals: 18,
    symbol: 'FZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6453.png',
  },
  {
    chainId: 1,
    name: 'Ghost Talk',
    address: '0x8bf7326c3fff3a3ba9fcc618641bb8f3cd2eb7f9',
    decimals: 18,
    symbol: 'XSCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6454.png',
  },
  {
    chainId: 1,
    name: 'FunKeyPay',
    address: '0x06404399e748cd83f25ab163711f9f4d61cfd0e6',
    decimals: 18,
    symbol: 'FNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6455.png',
  },
  {
    chainId: 1,
    name: 'GLEX',
    address: '0x0A0DB74Ef8b4480cc29b7D68647727fEeB1ea4eC',
    decimals: 18,
    symbol: 'GLEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6456.png',
  },
  {
    chainId: 1,
    name: 'Gold Mining Members',
    address: '0x7aF89c8A06719271A96e62E290Ea9Ed192E73FC1',
    decimals: 18,
    symbol: 'GMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6458.png',
  },
  {
    chainId: 1,
    name: 'Green Light',
    address: '0x70fadbe1f2cccbaf98ac88fdcf94a0509a48e46d',
    decimals: 8,
    symbol: 'GL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6459.png',
  },
  {
    chainId: 1,
    name: 'GT STAR Token',
    address: '0x951a1070ac39851dcc07b302230a68f81929a5f1',
    decimals: 8,
    symbol: 'GTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6460.png',
  },
  {
    chainId: 1,
    name: 'Hamebi Token',
    address: '0xC3b2140aC3E95EdFea220681EeCA127fC81E4929',
    decimals: 18,
    symbol: 'HMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6461.png',
  },
  {
    chainId: 1,
    name: 'Prepayway',
    address: '0x9c12d9b1223130b641154d8d3db35f91d81c8dfd',
    decimals: 18,
    symbol: 'InBit',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6463.png',
  },
  {
    chainId: 1,
    name: 'Heart Number',
    address: '0x4b4b1d389d4f4e082b30f75c6319c0ce5acbd619',
    decimals: 18,
    symbol: 'HTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6464.png',
  },
  {
    chainId: 1,
    name: 'Super Running Coin',
    address: '0x221F7d0F2Fa0bFbd5F8B0d0340425906F2F9968c',
    decimals: 18,
    symbol: 'SRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6465.png',
  },
  {
    chainId: 1,
    name: 'Hemelios',
    address: '0x19747816A030fECDa3394C6062CDF6b9B4dB0E0b',
    decimals: 8,
    symbol: 'HEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6466.png',
  },
  {
    chainId: 1,
    name: 'Loanburst',
    address: '0x93eCD2ecDFb91aB2fEe28A8779A6adfe2851cda6',
    decimals: 18,
    symbol: 'Lburst',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6467.png',
  },
  {
    chainId: 1,
    name: 'PeerEx',
    address: '0x3c6ff50c9ec362efa359317009428d52115fe643',
    decimals: 18,
    symbol: 'PERX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6468.png',
  },
  {
    chainId: 1,
    name: 'iBNB',
    address: '0xAFD870F32CE54EfdBF677466B612bf8ad164454B',
    decimals: 18,
    symbol: 'IBNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6472.png',
  },
  {
    chainId: 1,
    name: 'Klickl',
    address: '0x73d7e1dcfac94282dfda16c8f369b488580f7408',
    decimals: 18,
    symbol: 'IT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6473.png',
  },
  {
    chainId: 1,
    name: 'iLTC',
    address: '0x79da1431150C9b82D2E5dfc1C68B33216846851e',
    decimals: 18,
    symbol: 'ILTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6474.png',
  },
  {
    chainId: 1,
    name: 'FXPay',
    address: '0x14ddda446688b73161aa1382f4e4343353af6fc8',
    decimals: 8,
    symbol: 'FXP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6477.png',
  },
  {
    chainId: 1,
    name: 'Galaxy Pool Coin',
    address: '0x5cf501e64786444e025c5b24025f98399538ea5d',
    decimals: 18,
    symbol: 'GPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6478.png',
  },
  {
    chainId: 1,
    name: 'JUST NETWORK',
    address: '0x14ca41eecd7d81d5d13098586c0d2314eba285be',
    decimals: 18,
    symbol: 'JUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6483.png',
  },
  {
    chainId: 1,
    name: 'IOTEdge Network',
    address: '0xad7195e2f5e4f104cc2ed31cb719efd95b9eb490',
    decimals: 18,
    symbol: 'IOTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6485.png',
  },
  {
    chainId: 1,
    name: 'KAWANGGAWA',
    address: '0x55eb5288c9b65037a4cd2289637f38a4f9db3a6b',
    decimals: 18,
    symbol: 'KGW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6486.png',
  },
  {
    chainId: 1,
    name: 'Khipu Token',
    address: '0x64E65D352f6A2949463B3a7595911B61BBaFc63E',
    decimals: 18,
    symbol: 'KIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6489.png',
  },
  {
    chainId: 1,
    name: 'Kitcoin',
    address: '0x9827f6e8df0ccc584ff7b37144de8bac7c446385',
    decimals: 18,
    symbol: 'KTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6491.png',
  },
  {
    chainId: 1,
    name: 'KKCOIN',
    address: '0x54318a379935d545eb8e474a191e11faac5a46e8',
    decimals: 8,
    symbol: 'KK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6492.png',
  },
  {
    chainId: 1,
    name: 'KStarCoin',
    address: '0x990e081a7b7d3ccba26a2f49746a68cc4ff73280',
    decimals: 18,
    symbol: 'KSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6493.png',
  },
  {
    chainId: 1,
    name: 'ZJLT Distributed Factoring Network',
    address: '0xBC34985b4d345AeA933d5cAc19F3a86bd1Fb398F',
    decimals: 18,
    symbol: 'ZJLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6494.png',
  },
  {
    chainId: 1,
    name: 'Portal',
    address: '0x8DB90E3e7D04C875a51997092f9178FCac9DefdB',
    decimals: 18,
    symbol: 'PORTAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6496.png',
  },
  {
    chainId: 1,
    name: 'Musk',
    address: '0x5003b168b457b663c3c18ffcf5b6a24bee8f59c7',
    decimals: 18,
    symbol: 'MUSK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6497.png',
  },
  {
    chainId: 1,
    name: 'CBDAO',
    address: '0x4639cd8cd52EC1CF2E496a606ce28D8AfB1C792F',
    decimals: 18,
    symbol: 'BREE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6502.png',
  },
  {
    chainId: 1,
    name: 'RMPL',
    address: '0xe17f017475a709de58e976081eb916081ff4c9d5',
    decimals: 9,
    symbol: 'RMPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6503.png',
  },
  {
    chainId: 1,
    name: 'Aquila Protocol',
    address: '0x423f3da166470030a86fa76280b2d688fce1f722',
    decimals: 18,
    symbol: 'AUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6504.png',
  },
  {
    chainId: 1,
    name: 'FUUPAY',
    address: '0x084da5a9c0e3f086532b98d8568432349b89d9df',
    decimals: 18,
    symbol: 'FPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6505.png',
  },
  {
    chainId: 1,
    name: 'Halving Token',
    address: '0x9e7cb236e43c4bd042fE463df6a175d4479ee186',
    decimals: 18,
    symbol: 'HALV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6506.png',
  },
  {
    chainId: 1,
    name: 'Nexeum Protocol',
    address: '0xd9F7DEaeB3450cd698FD6d45a7B05A18D84BB1e1',
    decimals: 18,
    symbol: 'NEXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6509.png',
  },
  {
    chainId: 1,
    name: 'Strong',
    address: '0x990f341946a3fdb507ae7e52d17851b87168017c',
    decimals: 18,
    symbol: 'STRONG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6511.png',
  },
  {
    chainId: 1,
    name: 'SOULGAME',
    address: '0x86a0835f6b49f633fb1a3fa91b30dae1af4bbb6b',
    decimals: 18,
    symbol: 'SOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6517.png',
  },
  {
    chainId: 1,
    name: 'Aludra Network',
    address: '0xb339FcA531367067e98d7c4f9303Ffeadff7B881',
    decimals: 18,
    symbol: 'ALD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6519.png',
  },
  {
    chainId: 1,
    name: 'HOPR',
    address: '0xf5581dfefd8fb0e4aec526be659cfab1f8c781da',
    decimals: 18,
    symbol: 'HOPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6520.png',
  },
  {
    chainId: 1,
    name: 'Machi X',
    address: '0xd15ecdcf5ea68e3995b2d0527a0ae0a3258302f8',
    decimals: 18,
    symbol: 'MCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6521.png',
  },
  {
    chainId: 1,
    name: 'UniversalEnergyChain',
    address: '0xb3dd5dce850dca7519e74a943568b69f958df52c',
    decimals: 18,
    symbol: 'UENC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6525.png',
  },
  {
    chainId: 1,
    name: 'Ludos Protocol',
    address: '0xe64b47931f28f89cc7a0c6965ecf89eadb4975f5',
    decimals: 18,
    symbol: 'LUD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6527.png',
  },
  {
    chainId: 1,
    name: 'NanTrade',
    address: '0xb393cd041afc1aca4c380c663793fe2c7b8a0212',
    decimals: 18,
    symbol: 'NAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6529.png',
  },
  {
    chainId: 1,
    name: 'ROONEX',
    address: '0x72a6344185B383035d6665C3f44a9DfCC73873c8',
    decimals: 18,
    symbol: 'RNX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6531.png',
  },
  {
    chainId: 1,
    name: 'Mandi Token',
    address: '0x5aA485E6b794bcf5F834BF5c7FF43B9B83322764',
    decimals: 8,
    symbol: 'MANDI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6532.png',
  },
  {
    chainId: 1,
    name: 'SmartX',
    address: '0x1f0f468ee03a6d99cd8a09dd071494a83dc1c0e5',
    decimals: 4,
    symbol: 'SAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6533.png',
  },
  {
    chainId: 1,
    name: 'MANTRA',
    address: '0x3593d125a4f7849a1b059e64f4517a86dd60c95d',
    decimals: 18,
    symbol: 'OM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6536.png',
  },
  {
    chainId: 1,
    name: 'RioDeFi',
    address: '0xaf9f549774ecedbd0966c52f250acc548d3f36e5',
    decimals: 18,
    symbol: 'RFUEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6537.png',
  },
  {
    chainId: 1,
    name: 'Curve DAO Token',
    address: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    decimals: 18,
    symbol: 'CRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6538.png',
  },
  {
    chainId: 1,
    name: 'Showcase',
    address: '0xcc0014ccb39f6e86b1be0f17859a783b6722722f',
    decimals: 18,
    symbol: 'SHO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6540.png',
  },
  {
    chainId: 1,
    name: 'Relevant',
    address: '0xb6c4267c4877bb0d6b1685cfd85b0fbe82f105ec',
    decimals: 18,
    symbol: 'REL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6541.png',
  },
  {
    chainId: 1,
    name: 'Happy Birthday Coin',
    address: '0x39d30828a163713d91c4eadbba2c497a9139ec5c',
    decimals: 18,
    symbol: 'HBDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6542.png',
  },
  {
    chainId: 1,
    name: 'Barter',
    address: '0xF0ACF8949e705E0ebb6CB42c2164B0B986454223',
    decimals: 8,
    symbol: 'BRTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6543.png',
  },
  {
    chainId: 1,
    name: 'Degenerate Platform',
    address: '0x7461c43bb1e96863233d72a09191008ee9217ee8',
    decimals: 18,
    symbol: 'DGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6549.png',
  },
  {
    chainId: 1,
    name: 'MAKCOIN',
    address: '0x49a2e9be4e06c7106c5708bfcabb9322d0ba33db',
    decimals: 18,
    symbol: 'MAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6550.png',
  },
  {
    chainId: 1,
    name: 'Frens Community',
    address: '0x907cb97615b7cd7320bc89bb7cdb46e37432ebe7',
    decimals: 18,
    symbol: 'FRENS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6551.png',
  },
  {
    chainId: 1,
    name: 'Waifu Token',
    address: '0xb2279b6769cfba691416f00609b16244c0cf4b20',
    decimals: 18,
    symbol: 'WAIF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6552.png',
  },
  {
    chainId: 1,
    name: 'GamerCoin',
    address: '0x728f30fa2f100742c7949d1961804fa8e0b1387d',
    decimals: 18,
    symbol: 'GHX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6554.png',
  },
  {
    chainId: 1,
    name: 'MONEY PARTY',
    address: '0x314bd765cab4774b2e547eb0aa15013e03ff74d2',
    decimals: 6,
    symbol: 'PARTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6556.png',
  },
  {
    chainId: 1,
    name: 'Eso Token',
    address: '0xefeb903d013bb8a6d833b36222d2c769be6d7a6c',
    decimals: 18,
    symbol: 'ESOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6557.png',
  },
  {
    chainId: 1,
    name: 'TideBit Token',
    address: '0xc581399be631f060b64df49742626670906fdea9',
    decimals: 18,
    symbol: 'TBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6565.png',
  },
  {
    chainId: 1,
    name: 'Meridian Network',
    address: '0x95172ccBe8344fecD73D0a30F54123652981BD6F',
    decimals: 18,
    symbol: 'LOCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6566.png',
  },
  {
    chainId: 1,
    name: 'OWL',
    address: '0x1a5f9352af8af974bfc03399e3767df6370d82e4',
    decimals: 18,
    symbol: 'OWL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6567.png',
  },
  {
    chainId: 1,
    name: 'PIXBY',
    address: '0xB53e08B97724126Bda6d237B94F766c0b81C90fE',
    decimals: 18,
    symbol: 'PIXBY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6568.png',
  },
  {
    chainId: 1,
    name: 'Kinguin Krowns',
    address: '0xdfb410994b66778bd6cc2c82e8ffe4f7b2870006',
    decimals: 18,
    symbol: 'KRS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6569.png',
  },
  {
    chainId: 1,
    name: 'Based Money',
    address: '0x68A118Ef45063051Eac49c7e647CE5Ace48a68a5',
    decimals: 18,
    symbol: '$BASED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6570.png',
  },
  {
    chainId: 1,
    name: 'Zeb Token',
    address: '0xee98a5c3fd8c9063c5d8777758d3901a88df957b',
    decimals: 18,
    symbol: 'ZEB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6571.png',
  },
  {
    chainId: 1,
    name: 'Equus Mining Token',
    address: '0xa462d0E6Bb788c7807B1B1C96992CE1f7069E195',
    decimals: 18,
    symbol: 'EQMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6572.png',
  },
  {
    chainId: 1,
    name: 'Tacos',
    address: '0x00D1793D7C3aAE506257Ba985b34C76AaF642557',
    decimals: 18,
    symbol: 'TACO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6575.png',
  },
  {
    chainId: 1,
    name: 'Trump Loses Token',
    address: '0x70878b693a57a733a79560e33cf6a828e685d19a',
    decimals: 18,
    symbol: 'TRUMPLOSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6577.png',
  },
  {
    chainId: 1,
    name: 'Trump Wins Token',
    address: '0x073aF3f70516380654Ba7C5812c4Ab0255F081Bc',
    decimals: 18,
    symbol: 'TRUMPWIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6578.png',
  },
  {
    chainId: 1,
    name: 'Ruze Finance',
    address: '0xEb4E33dd1D97407ADD2aFcDcD5dd17851b1695d0',
    decimals: 18,
    symbol: 'RUZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6580.png',
  },
  {
    chainId: 1,
    name: 'zzz.finance',
    address: '0xc75F15AdA581219c95485c578E124df3985e4CE0',
    decimals: 18,
    symbol: 'ZZZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6582.png',
  },
  {
    chainId: 1,
    name: 'Multiplier',
    address: '0x8a6f3bf52a26a21531514e23016eeae8ba7e7018',
    decimals: 8,
    symbol: 'MXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6583.png',
  },
  {
    chainId: 1,
    name: 'WingShop',
    address: '0xcb3df3108635932d912632ef7132d03ecfc39080',
    decimals: 18,
    symbol: 'WING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6584.png',
  },
  {
    chainId: 1,
    name: 'Bintex Futures',
    address: '0x86d1d12523B65203851c571FcC029bF90903fB6d',
    decimals: 18,
    symbol: 'BNTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6586.png',
  },
  {
    chainId: 1,
    name: 'Etherisc DIP Token',
    address: '0xc719d010b63e5bbf2c0551872cd5316ed26acd83',
    decimals: 18,
    symbol: 'DIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6588.png',
  },
  {
    chainId: 1,
    name: 'Sendvibe',
    address: '0x3408B204d67BA2dBcA13b9C50e8a45701d8a1cA6',
    decimals: 18,
    symbol: 'SVB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6589.png',
  },
  {
    chainId: 1,
    name: 'DET Token',
    address: '0xF4e4F9E5BA2B0892c289ef2de60ca44e1f6B2527',
    decimals: 8,
    symbol: 'DET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6590.png',
  },
  {
    chainId: 1,
    name: 'BarterTrade',
    address: '0x54c9ea2e9c9e8ed865db4a4ce6711c2a0d5063ba',
    decimals: 18,
    symbol: 'BART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6592.png',
  },
  {
    chainId: 1,
    name: 'Bitgear',
    address: '0x1b980e05943dE3dB3a459C72325338d327B6F5a9',
    decimals: 18,
    symbol: 'GEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6593.png',
  },
  {
    chainId: 1,
    name: 'MYX Network',
    address: '0x2129fF6000b95A973236020BCd2b2006B0D8E019',
    decimals: 18,
    symbol: 'MYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6594.png',
  },
  {
    chainId: 1,
    name: 'Swagg Network',
    address: '0xa19A40FbD7375431fAB013a4B08F00871B9a2791',
    decimals: 4,
    symbol: 'SWAGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6595.png',
  },
  {
    chainId: 1,
    name: 'cherry',
    address: '0x4eCB692B0fEDeCD7B486b4c99044392784877E8C',
    decimals: 4,
    symbol: 'CHERRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6596.png',
  },
  {
    chainId: 1,
    name: 'Degenerator Meme',
    address: '0xd5525d397898e5502075ea5e830d8914f6f0affe',
    decimals: 8,
    symbol: 'MEME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6597.png',
  },
  {
    chainId: 1,
    name: 'Aureus Nummus Gold',
    address: '0x130914E1B240a7F4c5D460B7d3a2Fd3846b576fa',
    decimals: 18,
    symbol: 'ANG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6598.png',
  },
  {
    chainId: 1,
    name: 'BIGOCOIN',
    address: '0xa6E7dc135Bdf4b3FEe7183EAB2E87C0BB9684783',
    decimals: 8,
    symbol: 'BIGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6599.png',
  },
  {
    chainId: 1,
    name: 'UniTopia Token',
    address: '0x1f8f123bf24849443a56ed9fc42b9265b7f3a39a',
    decimals: 18,
    symbol: 'UTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6603.png',
  },
  {
    chainId: 1,
    name: 'UCX FOUNDATION',
    address: '0xe7cd2c56d3f01f9f8ae542ba5b2f00cf2cf994b1',
    decimals: 18,
    symbol: 'UCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6604.png',
  },
  {
    chainId: 1,
    name: 'Tokens of Babel',
    address: '0x7777770f8a6632ff043c8833310e245eba9209e6',
    decimals: 18,
    symbol: 'TOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6605.png',
  },
  {
    chainId: 1,
    name: 'MixTrust',
    address: '0x6251e725cd45fb1af99354035a414a2c0890b929',
    decimals: 18,
    symbol: 'MXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6607.png',
  },
  {
    chainId: 1,
    name: 'Community Token',
    address: '0x1b4052d98fb1888c2bf3b8d3b930e0aff8a910df',
    decimals: 18,
    symbol: 'COM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6608.png',
  },
  {
    chainId: 1,
    name: 'DuckDaoDime',
    address: '0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20',
    decimals: 18,
    symbol: 'DDIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6611.png',
  },
  {
    chainId: 1,
    name: 'Fera',
    address: '0x539f3615c1dbafa0d008d87504667458acbd16fa',
    decimals: 18,
    symbol: 'FERA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6612.png',
  },
  {
    chainId: 1,
    name: 'Free Tool Box Coin',
    address: '0x1E71034C89dD191ACcB27dC35f18a3d8b6f91311',
    decimals: 18,
    symbol: 'FTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6613.png',
  },
  {
    chainId: 1,
    name: 'UniGraph',
    address: '0x165440036ce972c5f8ebef667086707e48b2623e',
    decimals: 18,
    symbol: 'GRAPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6616.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Vault',
    address: '0x058349297672b6cc7ccb6e59a679c5add74a6898',
    decimals: 18,
    symbol: 'ETHV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6617.png',
  },
  {
    chainId: 1,
    name: 'SiamBitcoin',
    address: '0xb8e103b60a33597136ea9511f46b6dbeb643a3a5',
    decimals: 18,
    symbol: 'sBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6618.png',
  },
  {
    chainId: 1,
    name: 'FightBackCoin',
    address: '0xaC9749c854b31bBa3B3e71B30FDd7AEa4fCC0db9',
    decimals: 18,
    symbol: 'FBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6619.png',
  },
  {
    chainId: 1,
    name: 'Xtake',
    address: '0xF96459323030137703483B46fD59A71D712BF0aa',
    decimals: 6,
    symbol: 'XTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6620.png',
  },
  {
    chainId: 1,
    name: 'Keysians Network',
    address: '0x6a7ef4998eb9d0f706238756949f311a59e05745',
    decimals: 18,
    symbol: 'KEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6621.png',
  },
  {
    chainId: 1,
    name: 'Hakka.Finance',
    address: '0x0e29e5abbb5fd88e28b2d355774e73bd47de3bcd',
    decimals: 18,
    symbol: 'HAKKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6622.png',
  },
  {
    chainId: 1,
    name: 'DOGEFI',
    address: '0x9b9087756eca997c5d595c840263001c9a26646d',
    decimals: 18,
    symbol: 'DOGEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6623.png',
  },
  {
    chainId: 1,
    name: 'Golden Ratio Coin',
    address: '0xcfE4F03C3AFbB9857b29fC706180Bf0044900D59',
    decimals: 8,
    symbol: 'GOLDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6624.png',
  },
  {
    chainId: 1,
    name: 'Innovation Blockchain Payment',
    address: '0x7D14b842630cbc2530cB288109E5719e0C4d67d7',
    decimals: 18,
    symbol: 'IBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6625.png',
  },
  {
    chainId: 1,
    name: 'SPACE-iZ',
    address: '0xa7A5c1058194Af8F00c187adB7FcC0c95f1C6c2d',
    decimals: 18,
    symbol: 'SPIZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6626.png',
  },
  {
    chainId: 1,
    name: 'Meter Stable mapped by Meter.io',
    address: '0x29e9fdf5933824ad21bc6dbb8bf156efa3735e32',
    decimals: 18,
    symbol: 'eMTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6629.png',
  },
  {
    chainId: 1,
    name: 'Shrimp Finance',
    address: '0x38c4102d11893351ced7ef187fcf43d33eb1abe6',
    decimals: 18,
    symbol: 'SHRIMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6630.png',
  },
  {
    chainId: 1,
    name: 'MOST Protocol',
    address: '0x784561b89a160990f46de6db19571ca1b5f14bce',
    decimals: 9,
    symbol: 'MOST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6631.png',
  },
  {
    chainId: 1,
    name: 'Porkchop',
    address: '0x646707246d7d5c2a86d7206f41ca8199ea9ced69',
    decimals: 18,
    symbol: 'CHOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6633.png',
  },
  {
    chainId: 1,
    name: 'Spaghetti',
    address: '0xe54f9e6ab80ebc28515af8b8233c1aee6506a15e',
    decimals: 18,
    symbol: 'PASTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6634.png',
  },
  {
    chainId: 1,
    name: 'EthereumSC',
    address: '0xcfd069247bd5f01a17f1ca76424c9e424256908d',
    decimals: 18,
    symbol: 'ETHSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6637.png',
  },
  {
    chainId: 1,
    name: 'UniLayer',
    address: '0x0fF6ffcFDa92c53F615a4A75D982f399C989366b',
    decimals: 18,
    symbol: 'LAYER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6638.png',
  },
  {
    chainId: 1,
    name: 'xSNXa',
    address: '0x2934443c1749dcc0cdcabbd77098eea31d2ea6c3',
    decimals: 18,
    symbol: 'XSNXA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6639.png',
  },
  {
    chainId: 1,
    name: 'Camouflage.eth',
    address: '0x0bb7db697567178c590efa64a7dcb2ce6213768c',
    decimals: 18,
    symbol: 'CAMO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6642.png',
  },
  {
    chainId: 1,
    name: 'CryptowarriorZ',
    address: '0xd1ceac1d42ce8ce956cc68e4fde3b58a6c41c55b',
    decimals: 18,
    symbol: 'CZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6643.png',
  },
  {
    chainId: 1,
    name: 'AMIX',
    address: '0x564393b8d6deaea8f3d739a3f6d9b441d8ee6198',
    decimals: 18,
    symbol: 'AMIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6644.png',
  },
  {
    chainId: 1,
    name: 'COIL',
    address: '0x3936ad01cf109a36489d93cabda11cf062fd3d48',
    decimals: 9,
    symbol: 'COIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6645.png',
  },
  {
    chainId: 1,
    name: 'Rebased',
    address: '0x87F5F9eBE40786D49D35E1B5997b07cCAA8ADbFF',
    decimals: 9,
    symbol: 'REB2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6647.png',
  },
  {
    chainId: 1,
    name: 'INVIZION',
    address: '0x99963EE76C886fc43D5063428fF8F926E8A50985',
    decimals: 18,
    symbol: 'NVZN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6648.png',
  },
  {
    chainId: 1,
    name: 'Cat Token',
    address: '0x56015bbe3c01fe05bc30a8a9a9fd9a88917e7db3',
    decimals: 18,
    symbol: 'CAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6649.png',
  },
  {
    chainId: 1,
    name: 'NFT',
    address: '0xcB8d1260F9c92A3A545d409466280fFdD7AF7042',
    decimals: 18,
    symbol: 'NFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6650.png',
  },
  {
    chainId: 1,
    name: 'Quick Mining',
    address: '0xb73404280697080da0116cfac0e577fafdf44b37',
    decimals: 8,
    symbol: 'QM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6652.png',
  },
  {
    chainId: 1,
    name: 'Crypto Price Index',
    address: '0x2b67d1a87a8d8b280a23e97bc55095215ee0ec53',
    decimals: 18,
    symbol: 'CPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6654.png',
  },
  {
    chainId: 1,
    name: 'YAM V2',
    address: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a',
    decimals: 24,
    symbol: 'YAMV2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6657.png',
  },
  {
    chainId: 1,
    name: 'Bistox Token',
    address: '0x435b67f0dcae34c046720de42fcdc135b8f90e55',
    decimals: 18,
    symbol: 'BSX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6663.png',
  },
  {
    chainId: 1,
    name: 'GRAP',
    address: '0xC8D2AB2a6FdEbC25432E54941cb85b55b9f152dB',
    decimals: 18,
    symbol: 'GRAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6664.png',
  },
  {
    chainId: 1,
    name: 'LGCY Network',
    address: '0xae697f994fc5ebc000f8e22ebffee04612f98a0d',
    decimals: 18,
    symbol: 'LGCY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6665.png',
  },
  {
    chainId: 1,
    name: 'YMPL',
    address: '0xb7ba8461664dE526A3ae44189727DFC768625902',
    decimals: 9,
    symbol: 'YMPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6666.png',
  },
  {
    chainId: 1,
    name: 'Xiotri',
    address: '0x31024a4c3e9aeeb256b825790f5cb7ac645e7cd5',
    decimals: 3,
    symbol: 'XIOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6667.png',
  },
  {
    chainId: 1,
    name: 'PROXI',
    address: '0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4',
    decimals: 18,
    symbol: 'CREDIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6668.png',
  },
  {
    chainId: 1,
    name: 'PowerPool',
    address: '0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1',
    decimals: 18,
    symbol: 'CVP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6669.png',
  },
  {
    chainId: 1,
    name: 'Axis DeFi',
    address: '0xecc0f1f860a82ab3b442382d93853c02d6384389',
    decimals: 18,
    symbol: 'AXIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6670.png',
  },
  {
    chainId: 1,
    name: 'Davecoin',
    address: '0x56cdbbeec9828962cecb3f1b69517d430295d952',
    decimals: 18,
    symbol: 'DDTG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6671.png',
  },
  {
    chainId: 1,
    name: 'DeFi Omega',
    address: '0xee3b9b531f4c564c70e14b7b3bb7d516f33513ff',
    decimals: 18,
    symbol: 'DFIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6672.png',
  },
  {
    chainId: 1,
    name: 'Fyooz',
    address: '0x6BFf2fE249601ed0Db3a87424a2E923118BB0312',
    decimals: 18,
    symbol: 'FYZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6674.png',
  },
  {
    chainId: 1,
    name: 'MIKS COIN',
    address: '0xFbaf48e57CAB46F4c2E03eDB90a421D9fC6c7cBF',
    decimals: 18,
    symbol: 'MIKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6675.png',
  },
  {
    chainId: 1,
    name: 'Orbicular',
    address: '0x11A2Ab94adE17e96197C78f9D5f057332a19a0b9',
    decimals: 9,
    symbol: 'ORBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6676.png',
  },
  {
    chainId: 1,
    name: 'BitherCash',
    address: '0xa7d10ff962eda41f3b037e3af1d8b4037eba4b86',
    decimals: 18,
    symbol: 'BICAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6677.png',
  },
  {
    chainId: 1,
    name: 'Definance',
    address: '0x84f42bc7cab3932bdf1c77bb08528bff20a44180',
    decimals: 6,
    symbol: 'DFIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6678.png',
  },
  {
    chainId: 1,
    name: 'WHALE',
    address: '0x9355372396e3F6daF13359B7b607a3374cc638e0',
    decimals: 4,
    symbol: 'WHALE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6679.png',
  },
  {
    chainId: 1,
    name: 'Trustmarkethub',
    address: '0xe6db41a000916fa272787348d87dcb51cb8a9a48',
    decimals: 18,
    symbol: 'TMH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6681.png',
  },
  {
    chainId: 1,
    name: 'Dextoken',
    address: '0xb81d70802a816b5dacba06d708b5acf19dcd436d',
    decimals: 18,
    symbol: 'DEXG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6684.png',
  },
  {
    chainId: 1,
    name: 'Newtonium',
    address: '0xae9cbe6ebf72a51c9fcea3830485614486318fd4',
    decimals: 18,
    symbol: 'NEWTON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6685.png',
  },
  {
    chainId: 1,
    name: 'BeautyK',
    address: '0x6682195e2a0048ce38b727a3711802d58244606e',
    decimals: 18,
    symbol: 'BTKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6687.png',
  },
  {
    chainId: 1,
    name: 'DegenVC',
    address: '0x26E43759551333e57F073bb0772F50329A957b30',
    decimals: 18,
    symbol: 'DGVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6689.png',
  },
  {
    chainId: 1,
    name: 'Harrison First',
    address: '0x9903a4cd589da8e434f264deafc406836418578e',
    decimals: 4,
    symbol: 'FIRST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6690.png',
  },
  {
    chainId: 1,
    name: 'MORK',
    address: '0xf552b656022c218C26dAd43ad88881Fc04116F76',
    decimals: 4,
    symbol: 'MORK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6692.png',
  },
  {
    chainId: 1,
    name: 'Open Predict Token',
    address: '0x4FE5851C9af07df9e5AD8217aFAE1ea72737Ebda',
    decimals: 18,
    symbol: 'OPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6694.png',
  },
  {
    chainId: 1,
    name: 'Soft Link',
    address: '0x10bae51262490b4f4af41e12ed52a0e744c1137a',
    decimals: 9,
    symbol: 'SLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6695.png',
  },
  {
    chainId: 1,
    name: 'YFValue',
    address: '0x45f24baeef268bb6d63aee5129015d69702bcdfa',
    decimals: 18,
    symbol: 'YFV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6698.png',
  },
  {
    chainId: 1,
    name: 'Yield Breeder DAO',
    address: '0x11f4c6b3e8f50c50935c7889edc56c96f41b5399',
    decimals: 18,
    symbol: 'YBREE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6699.png',
  },
  {
    chainId: 1,
    name: 'Libera',
    address: '0x0bf6261297198d91d4fa460242c69232146a5703',
    decimals: 18,
    symbol: 'LIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6700.png',
  },
  {
    chainId: 1,
    name: 'Burency',
    address: '0x31fdd1c6607f47c14a2821f599211c67ac20fa96',
    decimals: 18,
    symbol: 'BUY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6701.png',
  },
  {
    chainId: 1,
    name: 'CAPCOIN',
    address: '0xaaff6de0ff6e063dffe772fe509400dc1da7aa61',
    decimals: 8,
    symbol: 'CAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6702.png',
  },
  {
    chainId: 1,
    name: 'CAT.trade Protocol',
    address: '0xC7743bf0B300Ec041E704Cc34d4f43050942099E',
    decimals: 18,
    symbol: 'CATX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6703.png',
  },
  {
    chainId: 1,
    name: 'JBOX',
    address: '0x884e3902c4d5cfa86de4ace7a96aa91ebc25c0ff',
    decimals: 18,
    symbol: 'JBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6704.png',
  },
  {
    chainId: 1,
    name: 'Lien',
    address: '0xab37e1358b639fd877f015027bb62d3ddaa7557e',
    decimals: 8,
    symbol: 'LIEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6705.png',
  },
  {
    chainId: 1,
    name: 'RIZE Token',
    address: '0xF8d778219D253df289dA5F43E2711124FF3953C2',
    decimals: 18,
    symbol: 'RIZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6706.png',
  },
  {
    chainId: 1,
    name: 'YFIEXCHANGE.FINANCE',
    address: '0x8f57e8e38e61975a0433fa792542f453d8ed4d7d',
    decimals: 18,
    symbol: 'YFIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6708.png',
  },
  {
    chainId: 1,
    name: 'Vidya',
    address: '0x3d3d35bb9bec23b06ca00fe472b50e7a4c692c30',
    decimals: 18,
    symbol: 'VIDYA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6709.png',
  },
  {
    chainId: 1,
    name: 'Dice.Finance',
    address: '0xcf67ced76e8356366291246a9222169f4dbdbe64',
    decimals: 18,
    symbol: 'DICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6710.png',
  },
  {
    chainId: 1,
    name: 'AMUSE',
    address: '0x6868639d07ea11402a57aadeebe0598346a80aee',
    decimals: 18,
    symbol: 'AMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6712.png',
  },
  {
    chainId: 1,
    name: 'Cowboy.Finance',
    address: '0xf0be50ed0620e0ba60ca7fc968ed14762e0a5dd3',
    decimals: 9,
    symbol: 'COW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6713.png',
  },
  {
    chainId: 1,
    name: 'Libfx',
    address: '0xc0ea83113038987d974fe667831a36e442e661e7',
    decimals: 18,
    symbol: 'LIBFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6714.png',
  },
  {
    chainId: 1,
    name: 'Sperax',
    address: '0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008',
    decimals: 18,
    symbol: 'SPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6715.png',
  },
  {
    chainId: 1,
    name: 'Zombie.Finance',
    address: '0xd55BD2C12B30075b325Bc35aEf0B46363B3818f8',
    decimals: 18,
    symbol: 'ZOMBIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6716.png',
  },
  {
    chainId: 1,
    name: 'yUSD Synthetic Token Expiring 1 October ',
    address: '0xb2fdd60ad80ca7ba89b9bab3b5336c2601c020b4',
    decimals: 18,
    symbol: 'YUSD-OCT20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6717.png',
  },
  {
    chainId: 1,
    name: 'The Graph',
    address: '0xc944e90c64b2c07662a292be6244bdf05cda44a7',
    decimals: 18,
    symbol: 'GRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6719.png',
  },
  {
    chainId: 1,
    name: 'sensorschain',
    address: '0xC5842a4aC9885E7a6BBefAddCd0d1A56d12fF8FC',
    decimals: 18,
    symbol: 'SSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6720.png',
  },
  {
    chainId: 1,
    name: 'Dextrust',
    address: '0xd379700999f4805ce80aa32db46a94df64561108',
    decimals: 18,
    symbol: 'DETS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6722.png',
  },
  {
    chainId: 1,
    name: 'Blaze Network',
    address: '0x70eFDc485a10210B056eF8e0A32993Bc6529995E',
    decimals: 18,
    symbol: 'BLZN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6723.png',
  },
  {
    chainId: 1,
    name: 'The Globridge Token',
    address: '0x96d1277895466bf41a6be937e0212a61ada714c0',
    decimals: 18,
    symbol: 'TGBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6725.png',
  },
  {
    chainId: 1,
    name: 'Reserve',
    address: '0x196f4727526eA7FB1e17b2071B3d8eAA38486988',
    decimals: 18,
    symbol: 'RSV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6727.png',
  },
  {
    chainId: 1,
    name: 'Wenburn',
    address: '0x46f4e420c75401494a39b70653f4bbb88ad2d728',
    decimals: 6,
    symbol: 'WENB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6728.png',
  },
  {
    chainId: 1,
    name: 'Prime DAI',
    address: '0x9043d4d51c9d2e31e3f169de4551e416970c27ef',
    decimals: 18,
    symbol: 'pDAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6729.png',
  },
  {
    chainId: 1,
    name: 'Zodiac',
    address: '0x1cf402135d7bd27dc9d21c03ae2d8375bc43e9ec',
    decimals: 18,
    symbol: 'ZDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6730.png',
  },
  {
    chainId: 1,
    name: 'Tokamak Network',
    address: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    decimals: 18,
    symbol: 'TON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6731.png',
  },
  {
    chainId: 1,
    name: 'Deonex Token',
    address: '0x50Ae0bc7E167C96B46f58063B2a7a27a26ad63BC',
    decimals: 18,
    symbol: 'DON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6732.png',
  },
  {
    chainId: 1,
    name: 'SYB Coin',
    address: '0x69428bb4272e3181de9e3cab461e19b0131855c8',
    decimals: 8,
    symbol: 'SYBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6733.png',
  },
  {
    chainId: 1,
    name: 'Port of DeFi Network',
    address: '0x6ccd05f73a54359a257fc5649c598a3de75905e7',
    decimals: 18,
    symbol: 'PDF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6737.png',
  },
  {
    chainId: 1,
    name: 'Quantbook',
    address: '0x9403d608515f7346EC44B998984d7741Fd0D9bd4',
    decimals: 18,
    symbol: 'QTBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6738.png',
  },
  {
    chainId: 1,
    name: 'ONBUFF',
    address: '0x410e731c2970Dce3AdD351064AcF5cE9E33FDBf0',
    decimals: 18,
    symbol: 'ONIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6739.png',
  },
  {
    chainId: 1,
    name: 'LORI',
    address: '0x8cd58D4A29aa5461D07F7fe1EDB5F6D3d22D5ADa',
    decimals: 18,
    symbol: 'LORI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6740.png',
  },
  {
    chainId: 1,
    name: 'DxSale.Network',
    address: '0xF063fE1aB7a291c5d06a86e14730b00BF24cB589',
    decimals: 18,
    symbol: 'SALE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6742.png',
  },
  {
    chainId: 1,
    name: 'Falconswap',
    address: '0xfffffffff15abf397da76f1dcc1a1604f45126db',
    decimals: 18,
    symbol: 'FSW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6743.png',
  },
  {
    chainId: 1,
    name: 'Chain Games',
    address: '0xC4C2614E694cF534D407Ee49F8E44D125E4681c4',
    decimals: 18,
    symbol: 'CHAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6744.png',
  },
  {
    chainId: 1,
    name: 'CEDARS',
    address: '0xf256f3ac4176126F55af7c6E25fA5F3Cdf518b38',
    decimals: 18,
    symbol: 'CEDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6745.png',
  },
  {
    chainId: 1,
    name: 'BOA',
    address: '0xf9c36c7ad7fa0f0862589c919830268d1a2581a1',
    decimals: 18,
    symbol: 'BOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6746.png',
  },
  {
    chainId: 1,
    name: 'Crust Network',
    address: '0x32a7C02e79c4ea1008dD6564b35F131428673c41',
    decimals: 18,
    symbol: 'CRU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6747.png',
  },
  {
    chainId: 1,
    name: 'Asure Network',
    address: '0x15dfc197e7ac7d81a07250b5bdebaa96fc1c5dfa',
    decimals: 18,
    symbol: 'ASR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6752.png',
  },
  {
    chainId: 1,
    name: 'Polkaswap',
    address: '0x519C1001D550C0a1DaE7d1fC220f7d14c2A521BB',
    decimals: 18,
    symbol: 'PSWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6754.png',
  },
  {
    chainId: 1,
    name: 'SushiSwap',
    address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
    decimals: 18,
    symbol: 'SUSHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6758.png',
  },
  {
    chainId: 1,
    name: 'Easticoin',
    address: '0xf3924df14812b3d3db29124aa9da4353ed5e04a3',
    decimals: 18,
    symbol: 'ESTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6760.png',
  },
  {
    chainId: 1,
    name: 'ReFork',
    address: '0x6653c0d21507573cc39ead1e609d74d5e0ca16e2',
    decimals: 18,
    symbol: 'EFK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6761.png',
  },
  {
    chainId: 1,
    name: 'DOCH STAR',
    address: '0xb37220a0a874b6ff4b64f3b93740105e68cbe63f',
    decimals: 18,
    symbol: 'DCHS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6762.png',
  },
  {
    chainId: 1,
    name: 'NTON',
    address: '0xcfb152e5b93fc2c9906d4ff41fc8407dfa5e8851',
    decimals: 18,
    symbol: 'NTON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6764.png',
  },
  {
    chainId: 1,
    name: 'Satopay Network',
    address: '0x8c3ee4f778e282b59d42d693a97b80b1ed80f4ee',
    decimals: 18,
    symbol: 'STOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6766.png',
  },
  {
    chainId: 1,
    name: 'COVIR.IO',
    address: '0x89e93789db5f8271e4c4bbc4c0252c2253ff4920',
    decimals: 18,
    symbol: 'CVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6767.png',
  },
  {
    chainId: 1,
    name: 'Flow Protocol',
    address: '0xc6e64729931f60d2c8bc70a27d66d9e0c28d1bf9',
    decimals: 9,
    symbol: 'FLOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6768.png',
  },
  {
    chainId: 1,
    name: 'Money Plant Token',
    address: '0x2cC1bE643e0882fB096f7f96d2b6Ca079ad5270c',
    decimals: 18,
    symbol: 'MPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6769.png',
  },
  {
    chainId: 1,
    name: 'SAHARA',
    address: '0xd1F579cc0a5405D7610346b371371bEd1528D18b',
    decimals: 18,
    symbol: 'IMG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6770.png',
  },
  {
    chainId: 1,
    name: 'FUTUREXCRYPTO',
    address: '0x1e6063b7b3a1c1952ed2c4087fd528998db69ec7',
    decimals: 18,
    symbol: 'FXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6773.png',
  },
  {
    chainId: 1,
    name: 'TimeMiner',
    address: '0xa54c67bd320da4f9725a6f585b7635a0c09b122e',
    decimals: 6,
    symbol: 'TIME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6774.png',
  },
  {
    chainId: 1,
    name: 'Blockkoin',
    address: '0x3AcF9680b5d57994B6570C0eA97bc4d8b25E3F5b',
    decimals: 18,
    symbol: 'BK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6776.png',
  },
  {
    chainId: 1,
    name: 'Streamix',
    address: '0xB0BFB1E2F72511cF8b4D004852E2054d7b9a76e1',
    decimals: 18,
    symbol: 'MIXS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6778.png',
  },
  {
    chainId: 1,
    name: 'Axie Infinity',
    address: '0xbb0e17ef65f82ab018d8edd776e8dd940327b28b',
    decimals: 18,
    symbol: 'AXS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6783.png',
  },
  {
    chainId: 1,
    name: 'Blockchain Cuties Universe Governance',
    address: '0x14da7b27b2e0fedefe0a664118b0c9bc68e2e9af',
    decimals: 18,
    symbol: 'BCUG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6789.png',
  },
  {
    chainId: 1,
    name: 'Aragon China',
    address: '0xbbe319b73744db9d54f5d29df7d8256b7e43995c',
    decimals: 18,
    symbol: 'ANC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6795.png',
  },
  {
    chainId: 1,
    name: 'DeFi of Thrones',
    address: '0xFAb5a05C933f1A2463E334E011992E897D56eF0a',
    decimals: 18,
    symbol: 'DOTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6796.png',
  },
  {
    chainId: 1,
    name: 'Rocket Token',
    address: '0xbD03BD923c7D51019Fd84571D84e4eBcf7213509',
    decimals: 18,
    symbol: 'RCKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6798.png',
  },
  {
    chainId: 1,
    name: 'Swapfolio',
    address: '0xba21ef4c9f433ede00badefcc2754b8e74bd538a',
    decimals: 18,
    symbol: 'SWFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6799.png',
  },
  {
    chainId: 1,
    name: 'Teleport Token',
    address: '0xc596bd09d652827b0106292d3e378d5938df4b12',
    decimals: 18,
    symbol: 'TPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6800.png',
  },
  {
    chainId: 1,
    name: 'TriumphX',
    address: '0x056354F3Ff20743aa4c0DA365603871c7000b081',
    decimals: 18,
    symbol: 'TRIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6801.png',
  },
  {
    chainId: 1,
    name: 'Unifi',
    address: '0x9E78b8274e1D6a76a0dBbf90418894DF27cBCEb5',
    decimals: 18,
    symbol: 'UNIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6802.png',
  },
  {
    chainId: 1,
    name: 'ATTN',
    address: '0xdF3A0a958F5a599Aa8f3071AA6488C22416EFB89',
    decimals: 6,
    symbol: 'ATTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6803.png',
  },
  {
    chainId: 1,
    name: 'MiraQle',
    address: '0x428dc22668e6f3468273634067e5545ed5417a3e',
    decimals: 18,
    symbol: 'MQL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6804.png',
  },
  {
    chainId: 1,
    name: 'Vesta Protocol',
    address: '0x3AeF8e803BD9be47e69b9f36487748d30D940b96',
    decimals: 18,
    symbol: 'VESTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6806.png',
  },
  {
    chainId: 1,
    name: 'YFISCURITY',
    address: '0x86965a86539e2446f9e72634cefca7983cc21a81',
    decimals: 18,
    symbol: 'YFIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6807.png',
  },
  {
    chainId: 1,
    name: 'GolderGames',
    address: '0xf2ba4afcbe22f0e626d67d8f31e96428706282e9',
    decimals: 18,
    symbol: 'GLDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6809.png',
  },
  {
    chainId: 1,
    name: 'Cyclub',
    address: '0x3b58c52C03ca5Eb619EBa171091c86C34d603e5f',
    decimals: 9,
    symbol: 'CYCLUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6810.png',
  },
  {
    chainId: 1,
    name: 'Fee Active Collateral Token',
    address: '0x23aEfF664c1B2bbA98422a0399586e96cc8a1C92',
    decimals: 18,
    symbol: 'FACT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6811.png',
  },
  {
    chainId: 1,
    name: 'YFIVE FINANCE',
    address: '0xd3E8695d2Bef061EAb38B5EF526c0f714108119C',
    decimals: 18,
    symbol: 'YFIVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6812.png',
  },
  {
    chainId: 1,
    name: 'Rug',
    address: '0xd0df3b1cf729a29b7404c40d61c750008e631ba7',
    decimals: 18,
    symbol: 'RUG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6816.png',
  },
  {
    chainId: 1,
    name: 'Standard Crypto Fund',
    address: '0x22eEab2f980E8ed7824f8EA548C9595564a0F0e4',
    decimals: 18,
    symbol: 'QQQF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6817.png',
  },
  {
    chainId: 1,
    name: 'Popcorn',
    address: '0x3080ec2a6960432f179c66d388099a48e82e2047',
    decimals: 18,
    symbol: 'CORN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6818.png',
  },
  {
    chainId: 1,
    name: 'YFI-b',
    address: '0x978E500E1a13fe0a52882d5BdAabc9BEf7Dc95aD',
    decimals: 18,
    symbol: 'YFIb',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6819.png',
  },
  {
    chainId: 1,
    name: 'Bast',
    address: '0x47eb79217f42f92dbd741add1b1a6783a2c873cf',
    decimals: 18,
    symbol: 'BAST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6821.png',
  },
  {
    chainId: 1,
    name: 'DistX',
    address: '0x4b4701f3f827e1331fb22ff8e2beac24b17eb055',
    decimals: 18,
    symbol: 'DISTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6822.png',
  },
  {
    chainId: 1,
    name: 'Semitoken',
    address: '0x6D7917864003a9bb13CBbEC8F1CdD4E36dDf6fc8',
    decimals: 18,
    symbol: 'SEMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6823.png',
  },
  {
    chainId: 1,
    name: 'Epanus',
    address: '0x50ec35d1e18d439f02fa895746fc3e1bef311780',
    decimals: 18,
    symbol: 'EPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6824.png',
  },
  {
    chainId: 1,
    name: 'Social Finance',
    address: '0xaea5e11e22e447fa9837738a0cd2848857748adf',
    decimals: 18,
    symbol: 'SOFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6825.png',
  },
  {
    chainId: 1,
    name: 'YUNo.finance',
    address: '0x4B4F5286e0f93E965292B922B9Cd1677512F1222',
    decimals: 18,
    symbol: 'YUNO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6826.png',
  },
  {
    chainId: 1,
    name: 'Litentry',
    address: '0xb59490ab09a0f526cc7305822ac65f2ab12f9723',
    decimals: 18,
    symbol: 'LIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6833.png',
  },
  {
    chainId: 1,
    name: 'KIMCHI.finance',
    address: '0x1e18821e69b9faa8e6e75dffe54e7e25754beda0',
    decimals: 18,
    symbol: 'KIMCHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6839.png',
  },
  {
    chainId: 1,
    name: 'Phala Network',
    address: '0x6c5bA91642F10282b576d91922Ae6448C9d52f4E',
    decimals: 18,
    symbol: 'PHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6841.png',
  },
  {
    chainId: 1,
    name: 'Radworks',
    address: '0x31c8eacbffdd875c74b94b077895bd78cf1e64a3',
    decimals: 18,
    symbol: 'RAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6843.png',
  },
  {
    chainId: 1,
    name: 'Walnut.finance',
    address: '0x0501e7a02c285b9b520fdbf1badc74ae931ad75d',
    decimals: 18,
    symbol: 'WTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6848.png',
  },
  {
    chainId: 1,
    name: 'Pylon Finance',
    address: '0xD7B7d3C0bdA57723Fb54ab95Fd8F9EA033AF37f2',
    decimals: 18,
    symbol: 'PYLON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6849.png',
  },
  {
    chainId: 1,
    name: 'DeFiat',
    address: '0xb6ee603933e024d8d53dde3faa0bf98fe2a3d6f1',
    decimals: 18,
    symbol: 'DFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6850.png',
  },
  {
    chainId: 1,
    name: 'GrafSound',
    address: '0x7713bCda5106424FF6B0Ae1e7Fa05C3f4ae3ecB0',
    decimals: 8,
    symbol: 'GSMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6851.png',
  },
  {
    chainId: 1,
    name: 'Akropolis Delphi',
    address: '0x94d863173ee77439e4292284ff13fad54b3ba182',
    decimals: 18,
    symbol: 'ADEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6852.png',
  },
  {
    chainId: 1,
    name: 'DeFi Bids',
    address: '0x1dA01e84F3d4e6716F274c987Ae4bEE5DC3C8288',
    decimals: 18,
    symbol: 'BID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6857.png',
  },
  {
    chainId: 1,
    name: 'NOODLE Finance',
    address: '0x420Ab548B18911717Ed7C4CCBF46371EA758458C',
    decimals: 18,
    symbol: 'NOODLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6858.png',
  },
  {
    chainId: 1,
    name: 'Harvest Finance',
    address: '0xa0246c9032bC3A600820415aE600c6388619A14D',
    decimals: 18,
    symbol: 'FARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6859.png',
  },
  {
    chainId: 1,
    name: 'Soft Yearn',
    address: '0x88093840aad42d2621e1a452bf5d7076ff804d61',
    decimals: 9,
    symbol: 'SYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6860.png',
  },
  {
    chainId: 1,
    name: 'ChartEx',
    address: '0x1d37986f252d0e349522ea6c3b98cb935495e63e',
    decimals: 18,
    symbol: 'CHART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6861.png',
  },
  {
    chainId: 1,
    name: 'Boosted Finance',
    address: '0x3e780920601D61cEdb860fe9c4a90c9EA6A35E78',
    decimals: 18,
    symbol: 'BOOST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6862.png',
  },
  {
    chainId: 1,
    name: 'YFFS Finance',
    address: '0x90D702f071d2af33032943137AD0aB4280705817',
    decimals: 18,
    symbol: 'YFFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6863.png',
  },
  {
    chainId: 1,
    name: 'STABLE ASSET',
    address: '0xd7d05bda4bf5876ba1254b3eaaf8b47d2f5676eb',
    decimals: 18,
    symbol: 'STA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6867.png',
  },
  {
    chainId: 1,
    name: 'Seigniorage Shares',
    address: '0x39795344cbcc76cc3fb94b9d1b15c23c2070c66d',
    decimals: 9,
    symbol: 'SHARE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6868.png',
  },
  {
    chainId: 1,
    name: 'BLOCKMAX',
    address: '0x466912baa9430a4a460b141ee8c580d817441449',
    decimals: 18,
    symbol: 'OCB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6869.png',
  },
  {
    chainId: 1,
    name: 'OIN Finance',
    address: '0x9aeB50f542050172359A0e1a25a9933Bc8c01259',
    decimals: 18,
    symbol: 'OIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6870.png',
  },
  {
    chainId: 1,
    name: 'BaconSwap',
    address: '0x175ab41e2cedf3919b2e4426c19851223cf51046',
    decimals: 18,
    symbol: 'BACON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6871.png',
  },
  {
    chainId: 1,
    name: 'YFIBusiness',
    address: '0x47632da9227e322eda59f9e7691eacc6430ac87c',
    decimals: 18,
    symbol: 'YFIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6875.png',
  },
  {
    chainId: 1,
    name: 'Burger money',
    address: '0xeeb92d7e5c0341bc0325a959851c83db51df13a3',
    decimals: 18,
    symbol: 'BURGER2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6877.png',
  },
  {
    chainId: 1,
    name: 'ASIAN MODEL FESTIVAL',
    address: '0x768810937a2d1611f023a1bbfb0bef3025893802',
    decimals: 18,
    symbol: 'AIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6878.png',
  },
  {
    chainId: 1,
    name: 'BTSwap',
    address: '0xCb4336D9aA2027f563437B721b34C56a3E7A23F4',
    decimals: 18,
    symbol: 'BT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6879.png',
  },
  {
    chainId: 1,
    name: 'CryptoBRL',
    address: '0xA6FA6531acDf1f9F96EDdD66a0F9481E35c2e42A',
    decimals: 6,
    symbol: 'CBRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6880.png',
  },
  {
    chainId: 1,
    name: 'DefiDollar',
    address: '0x5bc25f649fc4e26069ddf4cf4010f9f706c23831',
    decimals: 18,
    symbol: 'DUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6881.png',
  },
  {
    chainId: 1,
    name: 'EXNT',
    address: '0xD6c67B93a7b248dF608a653d82a100556144c5DA',
    decimals: 18,
    symbol: 'EXNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6882.png',
  },
  {
    chainId: 1,
    name: 'KittenFinance',
    address: '0x177ba0cac51bfc7ea24bad39d81dcefd59d74faa',
    decimals: 18,
    symbol: 'KIF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6883.png',
  },
  {
    chainId: 1,
    name: 'Obee Network',
    address: '0x3678d8CC9Eb08875A3720f34c1C8d1e1B31F5A11',
    decimals: 18,
    symbol: 'OBEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6884.png',
  },
  {
    chainId: 1,
    name: 'yfBeta',
    address: '0x89ee58af4871b474c30001982c3d7439c933c838',
    decimals: 18,
    symbol: 'YFBETA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6886.png',
  },
  {
    chainId: 1,
    name: 'Archethic',
    address: '0x8a3d77e9d6968b780564936d15B09805827C21fa',
    decimals: 18,
    symbol: 'UCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6887.png',
  },
  {
    chainId: 1,
    name: 'Omega Protocol Money',
    address: '0xf4c17bc4979c1dc7b4ca50115358dec58c67fd9d',
    decimals: 18,
    symbol: 'OPM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6888.png',
  },
  {
    chainId: 1,
    name: 'TON Token',
    address: '0x6a6c2ada3ce053561c2fbc3ee211f23d9b8c520a',
    decimals: 18,
    symbol: 'TON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6890.png',
  },
  {
    chainId: 1,
    name: 'Niftyx Protocol',
    address: '0xed0439eacf4c4965ae4613d77a5c2efe10e5f183',
    decimals: 18,
    symbol: 'SHROOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6891.png',
  },
  {
    chainId: 1,
    name: 'AstroTools',
    address: '0xcbd55d4ffc43467142761a764763652b48b969ff',
    decimals: 18,
    symbol: 'ASTRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6894.png',
  },
  {
    chainId: 1,
    name: 'BlackHoleSwap-Compound DAI/USDC',
    address: '0x35101c731b1548B5e48bb23F99eDBc2f5c341935',
    decimals: 18,
    symbol: 'BHSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6895.png',
  },
  {
    chainId: 1,
    name: 'Good Boy Points',
    address: '0x0cf58006b2400ebec3eb8c05b73170138a340563',
    decimals: 18,
    symbol: 'GBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6897.png',
  },
  {
    chainId: 1,
    name: 'SSS Finance',
    address: '0x8d7db6a562764b437f3248031f886359b4183cc4',
    decimals: 18,
    symbol: 'SSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6899.png',
  },
  {
    chainId: 1,
    name: 'TradePower Dex',
    address: '0xc5e19fd321b9bc49b41d9a3a5ad71bcc21cc3c54',
    decimals: 18,
    symbol: 'TDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6900.png',
  },
  {
    chainId: 1,
    name: 'Swerve',
    address: '0xb8baa0e4287890a5f79863ab62b7f175cecbd433',
    decimals: 18,
    symbol: 'SWRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6901.png',
  },
  {
    chainId: 1,
    name: 'Yield-Farming',
    address: '0x6768063279e2b185dc0c972b97f11f231d0b45ad',
    decimals: 18,
    symbol: 'YIELD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6902.png',
  },
  {
    chainId: 1,
    name: 'Unimonitor',
    address: '0x6dddf4111ad997a8c7be9b2e502aa476bf1f4251',
    decimals: 18,
    symbol: 'UNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6903.png',
  },
  {
    chainId: 1,
    name: 'Unipump',
    address: '0xce25b4271cc4d937a7d9bf75b2068a7892b9961d',
    decimals: 18,
    symbol: 'UPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6904.png',
  },
  {
    chainId: 1,
    name: 'Upper Euro',
    address: '0x6c139349ee94ebaaff55ed52d382673c263b22d6',
    decimals: 18,
    symbol: 'EURU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6905.png',
  },
  {
    chainId: 1,
    name: 'Upper Pound',
    address: '0x27ed129c298c5df130364083f491e2920e5a2f29',
    decimals: 18,
    symbol: 'GBPU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6906.png',
  },
  {
    chainId: 1,
    name: 'Upper Dollar',
    address: '0x41a03e41ef555392c9f0ad60f4f61e263078bf10',
    decimals: 18,
    symbol: 'USDU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6907.png',
  },
  {
    chainId: 1,
    name: 'Yefam.Finance',
    address: '0x2b78c26973545f9fd7ebdb01922966628382e6ba',
    decimals: 18,
    symbol: 'YEFAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6908.png',
  },
  {
    chainId: 1,
    name: 'YFA Finance',
    address: '0xEf327568556310d344c49FB7cE6CBFE7b2bB83e6',
    decimals: 18,
    symbol: 'YFA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6909.png',
  },
  {
    chainId: 1,
    name: 'YUGE',
    address: '0x012ba3ae1074ae43a34a14bca5c4ed0af01b6e53',
    decimals: 18,
    symbol: 'TRUMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6910.png',
  },
  {
    chainId: 1,
    name: 'BNSD Finance',
    address: '0x668DbF100635f593A3847c0bDaF21f0a09380188',
    decimals: 18,
    symbol: 'BNSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6911.png',
  },
  {
    chainId: 1,
    name: 'Yield Stake Finance',
    address: '0x03e4bdce611104289333f35c8177558b04cc99ff',
    decimals: 18,
    symbol: 'YI12',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6912.png',
  },
  {
    chainId: 1,
    name: 'YFUEL',
    address: '0xbd301be09eb78df47019aa833d29edc5d815d838',
    decimals: 18,
    symbol: 'YFUEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6913.png',
  },
  {
    chainId: 1,
    name: 'junca Cash',
    address: '0xea7aa1edd21735a5ab05ee3e90869016191e274e',
    decimals: 18,
    symbol: 'JCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6914.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Protocol',
    address: '0x96d62cdcd1cc49cb6ee99c867cb8812bea86b9fa',
    decimals: 18,
    symbol: 'YFP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6915.png',
  },
  {
    chainId: 1,
    name: 'The Forms',
    address: '0x8b80596660f007342dc590e5c53bbddd2cd550fb',
    decimals: 18,
    symbol: 'FRMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6916.png',
  },
  {
    chainId: 1,
    name: 'Magic Liquidity Rainbow',
    address: '0x33c23d44679433a88b89ca38d3311a9a3d160699',
    decimals: 18,
    symbol: 'RAINBOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6917.png',
  },
  {
    chainId: 1,
    name: 'Foresight',
    address: '0xb1EC548F296270BC96B8A1b3b3C8F3f04b494215',
    decimals: 18,
    symbol: 'FORS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6918.png',
  },
  {
    chainId: 1,
    name: 'Definitex',
    address: '0xf1f5de69c9c8d9be8a7b01773cc1166d4ec6ede2',
    decimals: 18,
    symbol: 'DFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6919.png',
  },
  {
    chainId: 1,
    name: 'Coin Artist',
    address: '0x87b008E57F640D94Ee44Fd893F0323AF933F9195',
    decimals: 18,
    symbol: 'COIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6920.png',
  },
  {
    chainId: 1,
    name: 'Universal Liquidity Union',
    address: '0x035bfe6057e15ea692c0dfdcab3bb41a64dd2ad4',
    decimals: 18,
    symbol: 'ULU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6923.png',
  },
  {
    chainId: 1,
    name: 'FlashSwap',
    address: '0x0128e4fccf5ef86b030b28f0a8a029a3c5397a94',
    decimals: 18,
    symbol: 'FSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6924.png',
  },
  {
    chainId: 1,
    name: 'Fidelity Token',
    address: '0x0f86b24dA64e16d9B21585a8734B8b0c94a43C18',
    decimals: 8,
    symbol: 'FDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6925.png',
  },
  {
    chainId: 1,
    name: 'Sports Betting Marketplace',
    address: '0xdaf8a0e12fc3b109a17ed5cbb943a8f3f86081f7',
    decimals: 18,
    symbol: 'SBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6926.png',
  },
  {
    chainId: 1,
    name: 'Bella Protocol',
    address: '0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14',
    decimals: 18,
    symbol: 'BEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6928.png',
  },
  {
    chainId: 1,
    name: 'Hegic',
    address: '0x584bC13c7D411c00c01A62e8019472dE68768430',
    decimals: 18,
    symbol: 'HEGIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6929.png',
  },
  {
    chainId: 1,
    name: 'KIRA',
    address: '0x16980b3b4a3f9d89e33311b5aa8f80303e5ca4f8',
    decimals: 18,
    symbol: 'KEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6930.png',
  },
  {
    chainId: 1,
    name: 'Token CashPay',
    address: '0x331A4589516EAE384eA5F557853AF6aF73B9534e',
    decimals: 18,
    symbol: 'TCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6931.png',
  },
  {
    chainId: 1,
    name: 'Nuco.cloud',
    address: '0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b',
    decimals: 18,
    symbol: 'NCDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6933.png',
  },
  {
    chainId: 1,
    name: 'Fiscus.fyi',
    address: '0xca76baa777d749de63ca044853d22d56bc70bb47',
    decimals: 18,
    symbol: 'FFYI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6935.png',
  },
  {
    chainId: 1,
    name: 'uUSDrBTC Synthetic Token Expiring 1 Octo',
    address: '0x208D174775dc39fe18B1b374972F77ddEc6c0F73',
    decimals: 18,
    symbol: 'UUSDRBTC-OCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6936.png',
  },
  {
    chainId: 1,
    name: 'JustLiquidity',
    address: '0x5580ab97F226C324c671746a1787524AEF42E415',
    decimals: 18,
    symbol: 'JUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6937.png',
  },
  {
    chainId: 1,
    name: 'YFDAI.FINANCE',
    address: '0xf4CD3d3Fda8d7Fd6C5a500203e38640A70Bf9577',
    decimals: 18,
    symbol: 'YF-DAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6938.png',
  },
  {
    chainId: 1,
    name: 'GOD KIMCHI',
    address: '0x4b7dfae2567181e54776337c840e142acb42aa1f',
    decimals: 18,
    symbol: 'gKIMCHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6939.png',
  },
  {
    chainId: 1,
    name: 'Lead Wallet',
    address: '0x1dd80016e3d4ae146ee2ebb484e8edd92dacc4ce',
    decimals: 18,
    symbol: 'LEAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6940.png',
  },
  {
    chainId: 1,
    name: 'Huobi BTC',
    address: '0x0316EB71485b0Ab14103307bf65a021042c6d380',
    decimals: 18,
    symbol: 'HBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6941.png',
  },
  {
    chainId: 1,
    name: 'Juggernaut',
    address: '0x73374ea518de7addd4c2b624c0e8b113955ee041',
    decimals: 18,
    symbol: 'JGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6942.png',
  },
  {
    chainId: 1,
    name: 'Baguette Token',
    address: '0x7a545Ed3863221A974F327199Ac22F7f12535F11',
    decimals: 18,
    symbol: 'BGTT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6943.png',
  },
  {
    chainId: 1,
    name: 'Amp',
    address: '0xff20817765cb7f73d4bde2e66e067e58d11095c2',
    decimals: 18,
    symbol: 'AMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6945.png',
  },
  {
    chainId: 1,
    name: 'Cowfarm.finance',
    address: '0x0cc4f8735dae4b1ab7682cb05aeb19115e693e98',
    decimals: 18,
    symbol: 'COW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6946.png',
  },
  {
    chainId: 1,
    name: 'Hedget',
    address: '0x7968bc6a03017ea2de509aaa816f163db0f35148',
    decimals: 6,
    symbol: 'HGET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6949.png',
  },
  {
    chainId: 1,
    name: 'Perpetual Protocol',
    address: '0xbc396689893d065f41bc2c6ecbee5e0085233447',
    decimals: 18,
    symbol: 'PERP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6950.png',
  },
  {
    chainId: 1,
    name: 'Reef',
    address: '0xfe3e6a25e6b192a42a44ecddcd13796471735acf',
    decimals: 18,
    symbol: 'REEF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6951.png',
  },
  {
    chainId: 1,
    name: 'Frax',
    address: '0x853d955acef822db058eb8505911ed77f175b99e',
    decimals: 18,
    symbol: 'FRAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png',
  },
  {
    chainId: 1,
    name: 'Frax Share',
    address: '0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0',
    decimals: 18,
    symbol: 'FXS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6953.png',
  },
  {
    chainId: 1,
    name: 'Enceladus Network',
    address: '0x20211ab9388781532fece6c57347a0004a420f16',
    decimals: 18,
    symbol: 'ENCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6954.png',
  },
  {
    chainId: 1,
    name: 'Dollars',
    address: '0x2f6081e3552b1c86ce4479b80062a1dda8ef23e3',
    decimals: 9,
    symbol: 'USDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6955.png',
  },
  {
    chainId: 1,
    name: 'BUILD Finance',
    address: '0x6e36556b3ee5aa28def2a8ec3dae30ec2b208739',
    decimals: 18,
    symbol: 'BUILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6956.png',
  },
  {
    chainId: 1,
    name: 'AllianceBlock',
    address: '0x00a8b738E453fFd858a7edf03bcCfe20412f0Eb0',
    decimals: 18,
    symbol: 'ALBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6957.png',
  },
  {
    chainId: 1,
    name: 'Alchemy Pay',
    address: '0xed04915c23f00a313a544955524eb7dbd823143d',
    decimals: 18,
    symbol: 'ACH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png',
  },
  {
    chainId: 1,
    name: 'GoodDollar',
    address: '0x67C5870b4A41D4Ebef24d2456547A03F1f3e094B',
    decimals: 2,
    symbol: 'G$',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6961.png',
  },
  {
    chainId: 1,
    name: 'DefiKing',
    address: '0xa17de0ab0a97bc5e56fa8b39ebfc81cc3f1f349e',
    decimals: 18,
    symbol: 'DFK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6962.png',
  },
  {
    chainId: 1,
    name: 'YFIKING FINANCE',
    address: '0x5F7fA1a0Ae94b5DD6bb6bD1708b5f3AF01b57908',
    decimals: 18,
    symbol: 'YFIKING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6964.png',
  },
  {
    chainId: 1,
    name: 'i9 Coin',
    address: '0x7cf74238d48ce383db00a1efff8da99303552cb0',
    decimals: 8,
    symbol: 'I9C',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6966.png',
  },
  {
    chainId: 1,
    name: 'LINKUSD',
    address: '0x0e2ec54fc0b509f445631bf4b91ab8168230c752',
    decimals: 18,
    symbol: 'LINKUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6967.png',
  },
  {
    chainId: 1,
    name: 'Mafia.Network',
    address: '0x4889F721f80C5E9fadE6Ea9B85835D405D79a4f4',
    decimals: 18,
    symbol: 'MAFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6968.png',
  },
  {
    chainId: 1,
    name: 'OpenAlexa Protocol',
    address: '0x1788430620960f9a70e3dc14202a3a35dde1a316',
    decimals: 18,
    symbol: 'OAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6970.png',
  },
  {
    chainId: 1,
    name: 'Predix Network',
    address: '0x556148562d5DdeB72545D7EC4B3eC8edc8F55Ba7',
    decimals: 18,
    symbol: 'PRDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6971.png',
  },
  {
    chainId: 1,
    name: 'YEARN2.FINANCE',
    address: '0xf6c151ea50a4f1a50983eb98998a18be0a549ad5',
    decimals: 18,
    symbol: 'YFI2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6973.png',
  },
  {
    chainId: 1,
    name: 'Yeld Finance',
    address: '0x468ab3b1f63A1C14b361bC367c3cC92277588Da1',
    decimals: 18,
    symbol: 'YELD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6974.png',
  },
  {
    chainId: 1,
    name: 'Rari Fund Token',
    address: '0x9366b7c00894c3555c7590b0384e5f6a9d55659f',
    decimals: 18,
    symbol: 'RFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6977.png',
  },
  {
    chainId: 1,
    name: 'Farm House Finance',
    address: '0x5f8a35021f1c9be802000ca141d7eeee577df7fd',
    decimals: 18,
    symbol: 'FHSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6979.png',
  },
  {
    chainId: 1,
    name: 'AladiEx',
    address: '0x564f45b6bb68aded8b660a0d8a0a948dd6d6e4e8',
    decimals: 8,
    symbol: 'ALA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6980.png',
  },
  {
    chainId: 1,
    name: 'New Year Bull',
    address: '0x798A9055a98913835bBFb45a0BbC209438dcFD97',
    decimals: 18,
    symbol: 'NYB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6981.png',
  },
  {
    chainId: 1,
    name: 'OBIC',
    address: '0xa8b6d0bD067ce5B2e4E9e225b2e0fF5eb74DEd8A',
    decimals: 18,
    symbol: 'OBIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6982.png',
  },
  {
    chainId: 1,
    name: 'DOOS TOKEN',
    address: '0x45cde5c8ae6e4a5568e488ef43a173eeeabfcc21',
    decimals: 18,
    symbol: 'DOOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6983.png',
  },
  {
    chainId: 1,
    name: 'FINANCIAL INVESTMENT TOKEN',
    address: '0xaf79C4c4106b7C35c2FeC72D130783524f821D89',
    decimals: 8,
    symbol: 'FIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6984.png',
  },
  {
    chainId: 1,
    name: 'Yakuza DFO',
    address: '0x87047986E8e4961c11d2EdcD94285E3A1331d97B',
    decimals: 18,
    symbol: 'YKZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6987.png',
  },
  {
    chainId: 1,
    name: 'YFILEND.FINANCE',
    address: '0xcec2387e04f9815bf12670dbf6cf03bba26df25f',
    decimals: 18,
    symbol: 'YFILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6988.png',
  },
  {
    chainId: 1,
    name: 'Zeedex',
    address: '0x5150956E082C748Ca837a5dFa0a7C10CA4697f9c',
    decimals: 18,
    symbol: 'ZDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6989.png',
  },
  {
    chainId: 1,
    name: 'Sashimi',
    address: '0xC28E27870558cF22ADD83540d2126da2e4b464c2',
    decimals: 18,
    symbol: 'SASHIMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6991.png',
  },
  {
    chainId: 1,
    name: 'REVV',
    address: '0x557b933a7c2c45672b610f8954a3deb39a51a8ca',
    decimals: 18,
    symbol: 'REVV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6993.png',
  },
  {
    chainId: 1,
    name: 'dRAY',
    address: '0x86642d169db9f57a02c65052049cbbbfb3e3b08c',
    decimals: 4,
    symbol: 'DRAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6994.png',
  },
  {
    chainId: 1,
    name: 'Rebase',
    address: '0x4208D8d500B1643DcA98dD27bA6C0060BcA311c5',
    decimals: 9,
    symbol: 'REBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6995.png',
  },
  {
    chainId: 1,
    name: 'Solarite',
    address: '0x930ed81ad809603baf727117385d01f04354612e',
    decimals: 18,
    symbol: 'SOLARITE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6996.png',
  },
  {
    chainId: 1,
    name: 'SakeToken',
    address: '0x066798d9ef0833ccc719076dab77199ecbd178b0',
    decimals: 18,
    symbol: 'SAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6997.png',
  },
  {
    chainId: 1,
    name: 'YOKcoin',
    address: '0x05Fcc72CFb4150AbAE415c885f7a433Ff523296F',
    decimals: 18,
    symbol: 'YOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6998.png',
  },
  {
    chainId: 1,
    name: 'MoonSwap',
    address: '0x68a3637bA6E75c0f66B61A42639c4e9fCD3D4824',
    decimals: 18,
    symbol: 'MOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7017.png',
  },
  {
    chainId: 1,
    name: 'Creed Finance',
    address: '0x675e7d927af7e6d0082e0153dc3485b687a6f0ad',
    decimals: 18,
    symbol: 'CREED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7018.png',
  },
  {
    chainId: 1,
    name: 'SherLOCK Security',
    address: '0xb9464ef80880c5aea54c7324c0b8dd6ca6d05a90',
    decimals: 18,
    symbol: 'LOCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7019.png',
  },
  {
    chainId: 1,
    name: 'Nyan Finance',
    address: '0xc9ce70a381910d0a90b30d408cc9c7705ee882de',
    decimals: 18,
    symbol: 'NYAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7020.png',
  },
  {
    chainId: 1,
    name: 'OFIN Token',
    address: '0x3b4cAAAF6F3ce5Bee2871C89987cbd825Ac30822',
    decimals: 18,
    symbol: 'ON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7021.png',
  },
  {
    chainId: 1,
    name: 'Pickle Finance',
    address: '0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5',
    decimals: 18,
    symbol: 'PICKLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7022.png',
  },
  {
    chainId: 1,
    name: 'pTokens LTC',
    address: '0x5979f50f1d4c08f9a53863c2f39a7b0492c38d0f',
    decimals: 18,
    symbol: 'PLTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7023.png',
  },
  {
    chainId: 1,
    name: 'Autobahn Network',
    address: '0x8eEF5a82E6Aa222a60F009ac18c24EE12dBf4b41',
    decimals: 18,
    symbol: 'TXL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7024.png',
  },
  {
    chainId: 1,
    name: 'Vybe',
    address: '0x3A1c1d1c06bE03cDDC4d3332F7C20e1B37c97CE9',
    decimals: 18,
    symbol: 'VYBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7025.png',
  },
  {
    chainId: 1,
    name: 'yffc.finance',
    address: '0xea004e8fa3701b8e58e41b78d50996e0f7176cbd',
    decimals: 18,
    symbol: 'YFFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7026.png',
  },
  {
    chainId: 1,
    name: 'yfrb.Finance',
    address: '0x5d1b1019d0afa5e6cc047b9e78081d44cc579fc4',
    decimals: 18,
    symbol: 'YFRB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7027.png',
  },
  {
    chainId: 1,
    name: 'Betherchip',
    address: '0x59c033ec65e6b9c501c1ee34fb42f2575da4b517',
    decimals: 18,
    symbol: 'BEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7030.png',
  },
  {
    chainId: 1,
    name: 'CHADS VC',
    address: '0x69692D3345010a207b759a7D1af6fc7F38b35c5E',
    decimals: 18,
    symbol: 'CHADS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7031.png',
  },
  {
    chainId: 1,
    name: 'Crypto Revolution',
    address: '0x0eb6e56aacae6a21bde99c826ac798d225488c3d',
    decimals: 18,
    symbol: 'CRVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7032.png',
  },
  {
    chainId: 1,
    name: 'Empty Set Dollar',
    address: '0x36f3fd68e7325a35eb768f1aedaae9ea0689d723',
    decimals: 18,
    symbol: 'ESD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7033.png',
  },
  {
    chainId: 1,
    name: 'Golff',
    address: '0x488E0369f9BC5C40C002eA7c1fe4fd01A198801c',
    decimals: 18,
    symbol: 'GOF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7034.png',
  },
  {
    chainId: 1,
    name: 'Jiaozi',
    address: '0x94939D55000B31B7808904a80aA7Bab05eF59Ed6',
    decimals: 18,
    symbol: 'JIAOZI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7035.png',
  },
  {
    chainId: 1,
    name: 'Lottonation',
    address: '0x3a73F6156C4fBC71B8fDF38090A9D99401163644',
    decimals: 18,
    symbol: 'LNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7036.png',
  },
  {
    chainId: 1,
    name: 'Xfinance',
    address: '0x5BEfBB272290dD5b8521D4a938f6c4757742c430',
    decimals: 18,
    symbol: 'XFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7038.png',
  },
  {
    chainId: 1,
    name: 'Ymen.Finance',
    address: '0xd0c59798f986d333554688cd667033d469c2398e',
    decimals: 18,
    symbol: 'YMEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7039.png',
  },
  {
    chainId: 1,
    name: 'Gather',
    address: '0xeb986DA994E4a118d5956b02d8b7c3C7CE373674',
    decimals: 18,
    symbol: 'GTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7041.png',
  },
  {
    chainId: 1,
    name: 'Momentum',
    address: '0x9a7a4c141a3bcce4a31e42c1192ac6add35069b4',
    decimals: 10,
    symbol: 'XMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7042.png',
  },
  {
    chainId: 1,
    name: 'Pofid Dao',
    address: '0x87c4bd3038176301e81e6682ce51a6fdaefabd0c',
    decimals: 18,
    symbol: 'PFID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7043.png',
  },
  {
    chainId: 1,
    name: 'Zyro',
    address: '0x1f6bd8766f8a8AA58F7441C8dd3709aFA3a56202',
    decimals: 8,
    symbol: 'ZYRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7044.png',
  },
  {
    chainId: 1,
    name: 'Yield Farming Known as Ash',
    address: '0x4086692d53262b2be0b13909d804f0491ff6ec3e',
    decimals: 18,
    symbol: 'YFKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7045.png',
  },
  {
    chainId: 1,
    name: 'Aavegotchi',
    address: '0x3F382DbD960E3a9bbCeaE22651E88158d2791550',
    decimals: 18,
    symbol: 'GHST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7046.png',
  },
  {
    chainId: 1,
    name: 'Tribute',
    address: '0x7031ab87dcc46818806ec07af46fa8c2ad2a2bfc',
    decimals: 18,
    symbol: 'TRBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7047.png',
  },
  {
    chainId: 1,
    name: 'Wing Finance',
    address: '0xDb0f18081b505A7DE20B18ac41856BCB4Ba86A1a',
    decimals: 18,
    symbol: 'WING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7048.png',
  },
  {
    chainId: 1,
    name: 'Etherpay',
    address: '0x601938988f0fdd937373ea185c33751462b1d194',
    decimals: 18,
    symbol: 'ETHPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7049.png',
  },
  {
    chainId: 1,
    name: 'Atlantis Token',
    address: '0x821144518dfE9e7b44fCF4d0824e15e8390d4637',
    decimals: 18,
    symbol: 'ATIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7050.png',
  },
  {
    chainId: 1,
    name: 'bXIOT',
    address: '0x5c4ac68aAc56eBe098D621Cd8CE9F43270Aaa355',
    decimals: 6,
    symbol: 'BXIOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7051.png',
  },
  {
    chainId: 1,
    name: 'GemSwap',
    address: '0x90f62B96a62801488b151fF3c65eaC5Fae21a962',
    decimals: 18,
    symbol: 'GEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7053.png',
  },
  {
    chainId: 1,
    name: 'HaloOracle',
    address: '0x0746b8cb6dd33134baf0ead66146f442c098b42e',
    decimals: 8,
    symbol: 'HALO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7054.png',
  },
  {
    chainId: 1,
    name: 'DeFi Pulse Index',
    address: '0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b',
    decimals: 18,
    symbol: 'DPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7055.png',
  },
  {
    chainId: 1,
    name: 'Katana Finance',
    address: '0xe6410569602124506658ff992f258616ea2d4a3d',
    decimals: 18,
    symbol: 'KATANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7056.png',
  },
  {
    chainId: 1,
    name: 'Melecoin',
    address: '0x14449de7937fe1c1207006e92f89dee17bbe418a',
    decimals: 18,
    symbol: 'MELE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7057.png',
  },
  {
    chainId: 1,
    name: 'Hot Potato',
    address: '0x422b727F3d39F655Fa71cF9510c4Ae5f7c13F5c9',
    decimals: 6,
    symbol: 'HOTP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7058.png',
  },
  {
    chainId: 1,
    name: 'Mobilian Coin',
    address: '0xaf80951201a0eff85a0fd3adf4c7043db856d3e6',
    decimals: 18,
    symbol: 'MBN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7059.png',
  },
  {
    chainId: 1,
    name: 'YFarmLand Token',
    address: '0x7B0F66fA5cf5cc28280c1e7051af881E06579362',
    decimals: 18,
    symbol: 'YFARMER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7061.png',
  },
  {
    chainId: 1,
    name: 'Team Finance',
    address: '0xb05AF453011d7ad68a92b0065FFD9d1277eD2741',
    decimals: 18,
    symbol: 'TEAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7062.png',
  },
  {
    chainId: 1,
    name: 'Zoom Protocol',
    address: '0x1a231e75538a931c395785ef5d1a5581ec622b0e',
    decimals: 18,
    symbol: 'ZOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7063.png',
  },
  {
    chainId: 1,
    name: 'Dollar Protocol',
    address: '0x3d61e677944204Cd1002202912a2B7a43A8E2823',
    decimals: 9,
    symbol: 'USDF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7065.png',
  },
  {
    chainId: 1,
    name: 'Justdobet',
    address: '0xCd9b0a6D9990605f66bf5bf22980ADE8476e7740',
    decimals: 8,
    symbol: 'JDB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7066.png',
  },
  {
    chainId: 1,
    name: 'Aave ENJ',
    address: '0x712db54daa836b53ef1ecbb9c6ba3b9efb073f40',
    decimals: 18,
    symbol: 'AENJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7068.png',
  },
  {
    chainId: 1,
    name: 'Aave REN',
    address: '0x69948cc03f478b95283f7dbf1ce764d0fc7ec54c',
    decimals: 18,
    symbol: 'AREN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7069.png',
  },
  {
    chainId: 1,
    name: 'Aave YFI',
    address: '0x12e51E77DAAA58aA0E9247db7510Ea4B46F9bEAd',
    decimals: 18,
    symbol: 'AYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7070.png',
  },
  {
    chainId: 1,
    name: 'Daily Funds',
    address: '0xa73862c5a66cf3be4bf86f60acf085bd927f83f8',
    decimals: 8,
    symbol: 'DF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7071.png',
  },
  {
    chainId: 1,
    name: 'Fame',
    address: '0xf2da15ae6ef94988534bad4b9e646f5911cbd487',
    decimals: 8,
    symbol: 'FAME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7072.png',
  },
  {
    chainId: 1,
    name: 'Hybrid Bank Cash',
    address: '0xFb9553aFa2B5c19c5F8e5b8eE175Fc01abD1555F',
    decimals: 18,
    symbol: 'HBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7073.png',
  },
  {
    chainId: 1,
    name: 'P2P',
    address: '0xabe9b2e4bbd5a8c718752c41254ed81aae7d98bf',
    decimals: 10,
    symbol: 'P2P',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7075.png',
  },
  {
    chainId: 1,
    name: 'UniDexBot',
    address: '0xd03b6ae96cae26b743a6207dcee7cbe60a425c70',
    decimals: 18,
    symbol: 'UNDB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7076.png',
  },
  {
    chainId: 1,
    name: 'YFARM Token',
    address: '0xf5d0fefaab749d8b14c27f0de60cc6e9e7f848d1',
    decimals: 18,
    symbol: 'YFARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7079.png',
  },
  {
    chainId: 1,
    name: 'Gala',
    address: '0xd1d2Eb1B1e90B638588728b4130137D262C87cae',
    decimals: 18,
    symbol: 'GALA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7080.png',
  },
  {
    chainId: 1,
    name: 'WinPlay Token',
    address: '0x4690D8F53E0d367f5b68f7F571e6eb4b72D39ACe',
    decimals: 18,
    symbol: 'WNRZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7081.png',
  },
  {
    chainId: 1,
    name: 'Moon YFI',
    address: '0x1Efb2286BF89F01488C6B2a22B2556C0f45e972b',
    decimals: 18,
    symbol: 'MYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7082.png',
  },
  {
    chainId: 1,
    name: 'Uniswap',
    address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
    decimals: 18,
    symbol: 'UNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7083.png',
  },
  {
    chainId: 1,
    name: 'Dego Finance',
    address: '0x3da932456d082cba208feb0b096d49b202bf89c8',
    decimals: 18,
    symbol: 'DEGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7087.png',
  },
  {
    chainId: 1,
    name: 'MegaSerum',
    address: '0x1320c8c64b9f2eAa851F70702e6C9FC1EE4E8Ce4',
    decimals: 6,
    symbol: 'MSRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7088.png',
  },
  {
    chainId: 1,
    name: 'Printer.Finance',
    address: '0x54b8c98268da0055971652a95f2bfd3a9349a38c',
    decimals: 18,
    symbol: 'PRINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7089.png',
  },
  {
    chainId: 1,
    name: 'StarDEX',
    address: '0xc0e47007e084eef3ee58eb33d777b3b4ca98622f',
    decimals: 18,
    symbol: 'XSTAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7090.png',
  },
  {
    chainId: 1,
    name: 'Walletreum',
    address: '0x15bcdfad12498de8a922e62442ae4cc4bd33bd25',
    decimals: 18,
    symbol: 'WALT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7091.png',
  },
  {
    chainId: 1,
    name: 'Xplosive Ethereum',
    address: '0xaA19673aA1b483a5c4f73B446B4f851629a7e7D6',
    decimals: 18,
    symbol: 'XETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7092.png',
  },
  {
    chainId: 1,
    name: 'YFMoonshot',
    address: '0xfef3bef71a5eb97e097039038776fd967ae5b106',
    decimals: 18,
    symbol: 'YFMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7093.png',
  },
  {
    chainId: 1,
    name: 'dHedge DAO',
    address: '0xca1207647ff814039530d7d35df0e1dd2e91fa84',
    decimals: 18,
    symbol: 'DHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7094.png',
  },
  {
    chainId: 1,
    name: 'Unisocks',
    address: '0x23b608675a2b2fb1890d3abbd85c5775c51691d5',
    decimals: 18,
    symbol: 'SOCKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7095.png',
  },
  {
    chainId: 1,
    name: 'Bridge Oracle',
    address: '0xc9c4fd7579133701fa2769b6955e7e56bb386db1',
    decimals: 18,
    symbol: 'BRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7096.png',
  },
  {
    chainId: 1,
    name: 'Diagon',
    address: '0x7ace84ac394e41f1c01711ed134d9bbcfa770ce7',
    decimals: 6,
    symbol: 'DGN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7097.png',
  },
  {
    chainId: 1,
    name: 'Exchange Payment Coin',
    address: '0x5330A5805b9Db68EbCF5247BbC9097163c1c2442',
    decimals: 18,
    symbol: 'EXP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7099.png',
  },
  {
    chainId: 1,
    name: 'HodlTree',
    address: '0xDea67845A51E24461D5fED8084E69B426AF3D5Db',
    decimals: 18,
    symbol: 'HTRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7100.png',
  },
  {
    chainId: 1,
    name: 'Linear Finance',
    address: '0x3e9bc21c9b189c09df3ef1b824798658d5011937',
    decimals: 18,
    symbol: 'LINA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7102.png',
  },
  {
    chainId: 1,
    name: 'Oracle System',
    address: '0x324af2d5353f2dd138e234b359d30d67c64b1b20',
    decimals: 18,
    symbol: 'ORC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7103.png',
  },
  {
    chainId: 1,
    name: 'VirgoX Token',
    address: '0x8Ba009Cad493C7646e31D69428AB9A54F47B3779',
    decimals: 18,
    symbol: 'VXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7107.png',
  },
  {
    chainId: 1,
    name: 'Yfi Credits',
    address: '0x6C8aAd3100e3fa45AAC799c0c302400900b60302',
    decimals: 18,
    symbol: 'YFIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7108.png',
  },
  {
    chainId: 1,
    name: 'Hatch DAO',
    address: '0x6F3009663470475F0749A6b76195375f95495fcB',
    decimals: 18,
    symbol: 'HATCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7109.png',
  },
  {
    chainId: 1,
    name: 'XSwap',
    address: '0x9b06d48e0529ecf05905ff52dd426ebec0ea3011',
    decimals: 18,
    symbol: 'XSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7111.png',
  },
  {
    chainId: 1,
    name: 'Markaccy',
    address: '0xF3281c539716a08c754EC4C8F2B4cEe0faB64BB9',
    decimals: 18,
    symbol: 'MKCY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7113.png',
  },
  {
    chainId: 1,
    name: 'Bitcratic Revenue',
    address: '0x579353231f3540b218239774422962c64a3693e7',
    decimals: 18,
    symbol: 'BCTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7115.png',
  },
  {
    chainId: 1,
    name: 'Crypto Accept',
    address: '0xcAd2d4C4469fF09aB24d02A63BCeDfCD44bE0645',
    decimals: 18,
    symbol: 'ACPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7116.png',
  },
  {
    chainId: 1,
    name: 'French ICO Coin',
    address: '0x7e442206da059905050ba02be63cbb85c559eb04',
    decimals: 18,
    symbol: 'FICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7117.png',
  },
  {
    chainId: 1,
    name: 'Livenodes Token',
    address: '0xb4ea189499c7722b39cba00443cd9d0e600a8670',
    decimals: 18,
    symbol: 'LNOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7118.png',
  },
  {
    chainId: 1,
    name: 'Pilnette',
    address: '0x6F0b09BFa87410aB993291Ec5f8CDa81f1D2acd9',
    decimals: 18,
    symbol: 'PVG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7119.png',
  },
  {
    chainId: 1,
    name: 'RI Token',
    address: '0x37E808F084101F75783612407e7C3f5F92d8ee3F',
    decimals: 18,
    symbol: 'RI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7120.png',
  },
  {
    chainId: 1,
    name: 'Samurai',
    address: '0x53378825d95281737914a8a2ac0e5a9304ae5ed7',
    decimals: 18,
    symbol: 'SAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7121.png',
  },
  {
    chainId: 1,
    name: 'UNIFI DeFi',
    address: '0x0ef3b2024ae079e6dbc2b37435ce30d2731f0101',
    decimals: 18,
    symbol: 'UNIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7122.png',
  },
  {
    chainId: 1,
    name: 'YMAX',
    address: '0x062f90480551379791FBe2ED74C1fe69821b30d3',
    decimals: 18,
    symbol: 'YMAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7124.png',
  },
  {
    chainId: 1,
    name: 'DEUS Finance',
    address: '0x3b62F3820e0B035cc4aD602dECe6d796BC325325',
    decimals: 18,
    symbol: 'DEUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7125.png',
  },
  {
    chainId: 1,
    name: 'Giftedhands',
    address: '0x3b544e6fcf6c8dce9d8b45a4fdf21c9b02f9fda9',
    decimals: 18,
    symbol: 'GHD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7126.png',
  },
  {
    chainId: 1,
    name: 'Kassia Home',
    address: '0x4CC84b41ECECC387244512242Eec226Eb7948A92',
    decimals: 18,
    symbol: 'KASSIAHOME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7128.png',
  },
  {
    chainId: 1,
    name: 'TerraClassicUSD',
    address: '0xa47c8bf37f92aBed4A126BDA807A7b7498661acD',
    decimals: 18,
    symbol: 'USTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7129.png',
  },
  {
    chainId: 1,
    name: 'Pumpanomics',
    address: '0xf36902f4a2f6ee8ca4f6bd5ecb3eb645b0342217',
    decimals: 18,
    symbol: 'PUMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7130.png',
  },
  {
    chainId: 1,
    name: 'YAM V3',
    address: '0x0aacfbec6a24756c20d41914f2caba817c0d8521',
    decimals: 18,
    symbol: 'YAM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7131.png',
  },
  {
    chainId: 1,
    name: 'Finswap',
    address: '0x3B78dc5736a49BD297Dd2E4d62daA83D35A22749',
    decimals: 18,
    symbol: 'FNSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7134.png',
  },
  {
    chainId: 1,
    name: 'Kush Finance',
    address: '0x3f09400313e83d53366147e3ea0e4e2279d80850',
    decimals: 18,
    symbol: 'KSEED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7135.png',
  },
  {
    chainId: 1,
    name: 'OneSwap DAO Token',
    address: '0x0b342c51d1592c41068d5d4b4da4a68c0a04d5a4',
    decimals: 18,
    symbol: 'ONES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7136.png',
  },
  {
    chainId: 1,
    name: 'Soda Token',
    address: '0x7AfB39837Fd244A651e4F0C5660B4037214D4aDF',
    decimals: 18,
    symbol: 'SODA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7137.png',
  },
  {
    chainId: 1,
    name: 'VN.Finance',
    address: '0x44001a5656baafa5a3359ced8fa38e150a71eea2',
    decimals: 18,
    symbol: 'VFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7138.png',
  },
  {
    chainId: 1,
    name: 'Winstex',
    address: '0x4CAc2515716Ab2531402cA8F992e235189F29C5a',
    decimals: 18,
    symbol: 'WIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7139.png',
  },
  {
    chainId: 1,
    name: 'yTSLA Finance',
    address: '0x5322a3556f979ce2180b30e689a9436fddcb1021',
    decimals: 18,
    symbol: 'yTSLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7140.png',
  },
  {
    chainId: 1,
    name: 'Axioms',
    address: '0x73ee6d7e6b203125add89320e9f343d65ec7c39a',
    decimals: 18,
    symbol: 'AXI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7141.png',
  },
  {
    chainId: 1,
    name: 'tomatos.finance',
    address: '0x2306934CA884CAA042DC595371003093092b2BBf',
    decimals: 18,
    symbol: 'TOMATOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7142.png',
  },
  {
    chainId: 1,
    name: 'DiFy.Finance',
    address: '0x4be40bc9681d0a7c24a99b4c92f85b9053fc2a45',
    decimals: 18,
    symbol: 'YFIII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7143.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Farm',
    address: '0x8be6a6158f6b8a19fe60569c757d16e546c2296d',
    decimals: 18,
    symbol: 'YFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7144.png',
  },
  {
    chainId: 1,
    name: 'Defi Shopping Stake',
    address: '0x213c53c96a01a89e6dcc5683cf16473203e17513',
    decimals: 18,
    symbol: 'DSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7145.png',
  },
  {
    chainId: 1,
    name: 'IYF.finance',
    address: '0x5d762f76b9e91f71cc4f94391bdfe6333db8519c',
    decimals: 18,
    symbol: 'IYF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7146.png',
  },
  {
    chainId: 1,
    name: 'SuperSwap',
    address: '0x058391e75ee8f675c7eeca35fd6d12b11e73b4b6',
    decimals: 18,
    symbol: 'SUPER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7147.png',
  },
  {
    chainId: 1,
    name: 'ISTARDUST',
    address: '0xf2354F740f31704820f6FcfBA70B9dA065459b62',
    decimals: 18,
    symbol: 'ISDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7148.png',
  },
  {
    chainId: 1,
    name: 'Toast.finance',
    address: '0x774fb37e50db4bf53b7c08e6b71007bf1f1d9a47',
    decimals: 18,
    symbol: 'TOAST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7152.png',
  },
  {
    chainId: 1,
    name: 'LYZE',
    address: '0xfe69bc0920fb63c5924cfc322dc4a5cc23d9afed',
    decimals: 18,
    symbol: 'LZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7153.png',
  },
  {
    chainId: 1,
    name: 'ITEN',
    address: '0x65b678936c489A2639036755Aa2107Ec09569198',
    decimals: 18,
    symbol: 'ITEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7154.png',
  },
  {
    chainId: 1,
    name: 'Ternio-ERC20',
    address: '0x24283732C3DF91EE1e4354a3934C14B88B2d9a51',
    decimals: 18,
    symbol: 'TERN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7155.png',
  },
  {
    chainId: 1,
    name: 'Toshify.finance',
    address: '0x9cd39da8f25ec50cf2ee260e464ac23ea23f6bb0',
    decimals: 18,
    symbol: 'YFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7156.png',
  },
  {
    chainId: 1,
    name: 'Basid Coin',
    address: '0xe33f363351186e185470f35F6DeB94ABa44347D8',
    decimals: 18,
    symbol: 'BASID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7157.png',
  },
  {
    chainId: 1,
    name: 'Moon Juice',
    address: '0x889efb523cc39590b8483eb9491890ac71407f64',
    decimals: 18,
    symbol: 'JUICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7163.png',
  },
  {
    chainId: 1,
    name: 'Rotten',
    address: '0xD04785C4d8195e4A54d9dEc3a9043872875ae9E2',
    decimals: 18,
    symbol: 'ROT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7164.png',
  },
  {
    chainId: 1,
    name: 'UnityDAO',
    address: '0xc6bf2a2a43ca360bb0ec6770f57f77cdde64bb3f',
    decimals: 8,
    symbol: 'UTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7165.png',
  },
  {
    chainId: 1,
    name: 'YFIX Finance',
    address: '0xa4f779074850d320b5553c9db5fc6a8ab15bd34a',
    decimals: 18,
    symbol: 'YFIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7166.png',
  },
  {
    chainId: 1,
    name: 'xBTC',
    address: '0xECbF566944250ddE88322581024E611419715f7A',
    decimals: 9,
    symbol: 'xBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7168.png',
  },
  {
    chainId: 1,
    name: 'Chicken',
    address: '0xE63684BcF2987892CEfB4caA79BD21b34e98A291',
    decimals: 18,
    symbol: 'KFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7169.png',
  },
  {
    chainId: 1,
    name: 'Contribute',
    address: '0xe09216f1d343dd39d6aa732a08036fee48555af0',
    decimals: 18,
    symbol: 'TRIB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7170.png',
  },
  {
    chainId: 1,
    name: 'DeFi Firefly',
    address: '0xaF183350bDF8082B486CEE23fBfcCa6eA3258DAC',
    decimals: 8,
    symbol: 'DFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7171.png',
  },
  {
    chainId: 1,
    name: 'MANY',
    address: '0xab7aaf9e485a3bc885985184abe9fc6aba727bd6',
    decimals: 18,
    symbol: 'MANY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7172.png',
  },
  {
    chainId: 1,
    name: 'MOJI Experience Points',
    address: '0xde201daec04ba73166d9917fdf08e1728e270f06',
    decimals: 18,
    symbol: 'MEXP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7173.png',
  },
  {
    chainId: 1,
    name: 'Rope',
    address: '0x9d47894f8becb68b9cf3428d256311affe8b068b',
    decimals: 18,
    symbol: '$ROPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7174.png',
  },
  {
    chainId: 1,
    name: 'Tcbcoin',
    address: '0x36dCffe069a3F2878Fab2A46D81e83D462d0cBF7',
    decimals: 18,
    symbol: 'TCFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7175.png',
  },
  {
    chainId: 1,
    name: 'Bullers Coin',
    address: '0x3f2d8861e8ca9a7649d211dbaa3f3d998c6a254a',
    decimals: 18,
    symbol: 'BLCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7177.png',
  },
  {
    chainId: 1,
    name: 'Combine.finance',
    address: '0x7d36cce46dd2b0d28dde12a859c2ace4a21e3678',
    decimals: 18,
    symbol: 'COMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7178.png',
  },
  {
    chainId: 1,
    name: 'CY Finance',
    address: '0xdB33d49b5a41A97D296B7242a96ebd8AC77B3Bb8',
    decimals: 18,
    symbol: 'CYF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7179.png',
  },
  {
    chainId: 1,
    name: 'HippoFinance',
    address: '0x81313f7c5c9c824236c9e4cba3ac4b049986e756',
    decimals: 18,
    symbol: 'HIPPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7180.png',
  },
  {
    chainId: 1,
    name: 'Hotpot Base Token',
    address: '0x042afd3869a47e2d5d42cc787d5c9e19df32185f',
    decimals: 18,
    symbol: 'pot',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7181.png',
  },
  {
    chainId: 1,
    name: 'PancakeSwap',
    address: '0x152649eA73beAb28c5b49B26eb48f7EAD6d4c898',
    decimals: 18,
    symbol: 'CAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7186.png',
  },
  {
    chainId: 1,
    name: 'S.Finance',
    address: '0x8a6ACA71A218301c7081d4e96D64292D3B275ce0',
    decimals: 18,
    symbol: 'SFG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7187.png',
  },
  {
    chainId: 1,
    name: 'NO Trump Augur Prediction Token',
    address: '0x44ea84a85616f8e9cd719fc843de31d852ad7240',
    decimals: 15,
    symbol: 'ntrump',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7188.png',
  },
  {
    chainId: 1,
    name: 'Origin Dollar',
    address: '0x2A8e1E676Ec238d8A992307B495b45B3fEAa5e86',
    decimals: 18,
    symbol: 'OUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7189.png',
  },
  {
    chainId: 1,
    name: 'PowerTrade Fuel',
    address: '0xC57d533c50bC22247d49a368880fb49a1caA39F7',
    decimals: 18,
    symbol: 'PTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7190.png',
  },
  {
    chainId: 1,
    name: 'SwapShip',
    address: '0x3ac2AB91dDF57e2385089202Ca221C360CED0062',
    decimals: 18,
    symbol: 'SWSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7191.png',
  },
  {
    chainId: 1,
    name: 'Wrapped BNB',
    address: '0x418D75f65a02b3D53B2418FB8E1fe493759c7605',
    decimals: 18,
    symbol: 'WBNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7192.png',
  },
  {
    chainId: 1,
    name: 'YFII Gold',
    address: '0xef8ba8cba86f81b3108f60186fce9c81b5096d5c',
    decimals: 18,
    symbol: 'YFIIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7193.png',
  },
  {
    chainId: 1,
    name: 'SAFE2',
    address: '0x250a3500f48666561386832f1f1f1019b89a2699',
    decimals: 18,
    symbol: 'SAFE2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7194.png',
  },
  {
    chainId: 1,
    name: 'Fanta.Finance',
    address: '0xBf06035C31386d0D024895a97D0cc6eF6884854f',
    decimals: 18,
    symbol: 'FANTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7196.png',
  },
  {
    chainId: 1,
    name: 'Karaganda Token',
    address: '0x32a8cd4d04d5f2e5de30ad73ef0a377eca2fdd98',
    decimals: 18,
    symbol: 'KRG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7197.png',
  },
  {
    chainId: 1,
    name: 'Bidao',
    address: '0x25e1474170c4c0aA64fa98123bdc8dB49D7802fa',
    decimals: 18,
    symbol: 'BID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7200.png',
  },
  {
    chainId: 1,
    name: 'JOON',
    address: '0x174897edd3ce414084a009d22db31c7b7826400d',
    decimals: 4,
    symbol: 'JOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7201.png',
  },
  {
    chainId: 1,
    name: 'OctoFi',
    address: '0x7240aC91f01233BaAf8b064248E80feaA5912BA3',
    decimals: 18,
    symbol: 'OCTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7202.png',
  },
  {
    chainId: 1,
    name: 'Puriever',
    address: '0x2904b9b16652d7d0408eccfa23a19d4a3358230f',
    decimals: 18,
    symbol: 'PURE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7203.png',
  },
  {
    chainId: 1,
    name: 'Safari',
    address: '0x648d19d775a8d4bafba09e189090bdcbf8ef31c1',
    decimals: 8,
    symbol: 'SFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7205.png',
  },
  {
    chainId: 1,
    name: 'TitanSwap',
    address: '0x3A8cCCB969a61532d1E6005e2CE12C200caeCe87',
    decimals: 18,
    symbol: 'TITAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7206.png',
  },
  {
    chainId: 1,
    name: 'UNII Finance',
    address: '0x825130aa1beef07bdf4f389705321816d05b0d0f',
    decimals: 18,
    symbol: 'UNII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7207.png',
  },
  {
    chainId: 1,
    name: 'Polkastarter',
    address: '0x83e6f1e41cdd28eaceb20cb649155049fac3d5aa',
    decimals: 18,
    symbol: 'POLS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7208.png',
  },
  {
    chainId: 1,
    name: 'Eminence',
    address: '0x5ade7ae8660293f2ebfcefaba91d141d72d221e8',
    decimals: 18,
    symbol: 'EMN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7209.png',
  },
  {
    chainId: 1,
    name: 'Buccaneer V2',
    address: '0xd5a7d515fb8b3337acb9b053743e0bc18f50c855',
    decimals: 10,
    symbol: 'BUCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7210.png',
  },
  {
    chainId: 1,
    name: 'Antique Zombie Shards',
    address: '0x78175901e9B04090Bf3B3D3cB7f91CA986fb1aF6',
    decimals: 18,
    symbol: 'ZOMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7211.png',
  },
  {
    chainId: 1,
    name: 'Consensus Cell Network',
    address: '0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f',
    decimals: 18,
    symbol: 'ECELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7212.png',
  },
  {
    chainId: 1,
    name: 'CryptoWater',
    address: '0x13ca8eb6405cfbe2eae5d00207651002083fbc9d',
    decimals: 18,
    symbol: 'C2O',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7214.png',
  },
  {
    chainId: 1,
    name: 'CXN Network',
    address: '0xb48E0F69e6A3064f5498D495F77AD83e0874ab28',
    decimals: 18,
    symbol: 'CXN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7215.png',
  },
  {
    chainId: 1,
    name: 'LuaSwap',
    address: '0xB1f66997A5760428D3a87D68b90BfE0aE64121cC',
    decimals: 18,
    symbol: 'LUA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7216.png',
  },
  {
    chainId: 1,
    name: 'Morpher',
    address: '0x6369c3dadfc00054a42ba8b2c09c48131dd4aa38',
    decimals: 18,
    symbol: 'MPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7217.png',
  },
  {
    chainId: 1,
    name: 'Rubic',
    address: '0x3330bfb7332ca23cd071631837dc289b09c33333',
    decimals: 18,
    symbol: 'RBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7219.png',
  },
  {
    chainId: 1,
    name: 'Vampire Protocol',
    address: '0xb2c822a1b923e06dbd193d2cfc7ad15388ea09dd',
    decimals: 18,
    symbol: 'VAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7220.png',
  },
  {
    chainId: 1,
    name: 'Wrapped LEO',
    address: '0x73a9fb46e228628f8f9bb9004eca4f4f529d3998',
    decimals: 3,
    symbol: 'WLEO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7221.png',
  },
  {
    chainId: 1,
    name: 'yAxis',
    address: '0x0ada190c81b814548ddc2f6adc4a689ce7c1fe73',
    decimals: 18,
    symbol: 'YAXIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7222.png',
  },
  {
    chainId: 1,
    name: 'Dfinance',
    address: '0xE4E822C0d5b329E8BB637972467d2E313824eFA0',
    decimals: 18,
    symbol: 'XFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7223.png',
  },
  {
    chainId: 1,
    name: 'DODO',
    address: '0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd',
    decimals: 18,
    symbol: 'DODO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7224.png',
  },
  {
    chainId: 1,
    name: 'DeFiner',
    address: '0x054f76beed60ab6dbeb23502178c52d6c5debe40',
    decimals: 18,
    symbol: 'FIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7225.png',
  },
  {
    chainId: 1,
    name: 'Injective',
    address: '0xe28b3b32b6c345a34ff64674606124dd5aceca30',
    decimals: 18,
    symbol: 'INJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7226.png',
  },
  {
    chainId: 1,
    name: 'APY.Finance',
    address: '0x95a4492F028aa1fd432Ea71146b433E7B4446611',
    decimals: 18,
    symbol: 'APY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7227.png',
  },
  {
    chainId: 1,
    name: 'DerivaDAO',
    address: '0x3a880652f47bfaa771908c07dd8673a787daed3a',
    decimals: 18,
    symbol: 'DDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7228.png',
  },
  {
    chainId: 1,
    name: 'Gelato',
    address: '0x15b7c0c907e4C6b9AdaAaabC300C08991D6CEA05',
    decimals: 18,
    symbol: 'GEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7229.png',
  },
  {
    chainId: 1,
    name: 'Opium',
    address: '0x888888888889c00c67689029d7856aac1065ec11',
    decimals: 18,
    symbol: 'OPIUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7230.png',
  },
  {
    chainId: 1,
    name: 'Nsure.Network',
    address: '0x20945ca1df56d237fd40036d47e866c7dccd2114',
    decimals: 18,
    symbol: 'NSURE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7231.png',
  },
  {
    chainId: 1,
    name: 'Stella',
    address: '0xa1faa113cbe53436df28ff0aee54275c13b40975',
    decimals: 18,
    symbol: 'ALPHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7232.png',
  },
  {
    chainId: 1,
    name: 'Yearn Land',
    address: '0xd0658324074d6249a51876438916f7c423075451',
    decimals: 18,
    symbol: 'YLAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7234.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Bit',
    address: '0xf0a0f3a6fa6bed75345171a5ea18abcadf6453ba',
    decimals: 18,
    symbol: 'YFBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7237.png',
  },
  {
    chainId: 1,
    name: 'TKN Token',
    address: '0xbce7bd79558dda90b261506768f265c5543a9f90',
    decimals: 18,
    symbol: 'TKNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7238.png',
  },
  {
    chainId: 1,
    name: 'BMJ Master Nodes',
    address: '0x5913D0F34615923552ee913DBe809F9F348e706E',
    decimals: 18,
    symbol: 'BMJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7239.png',
  },
  {
    chainId: 1,
    name: 'cVault.finance',
    address: '0x62359ed7505efc61ff1d56fef82158ccaffa23d7',
    decimals: 18,
    symbol: 'CORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7242.png',
  },
  {
    chainId: 1,
    name: 'QChi Chain',
    address: '0x5df94780f00140FE72d239D0D261f7797E3Fbd1B',
    decimals: 18,
    symbol: 'QHC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7243.png',
  },
  {
    chainId: 1,
    name: 'SaTT',
    address: '0xDF49C9F599A0A9049D97CFF34D0C30E468987389',
    decimals: 18,
    symbol: 'SATT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7244.png',
  },
  {
    chainId: 1,
    name: 'Stobox Token',
    address: '0xa6422e3e219ee6d4c1b18895275fe43556fd50ed',
    decimals: 18,
    symbol: 'STBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7245.png',
  },
  {
    chainId: 1,
    name: 'Tamy Token',
    address: '0xb9cb7905981198add8059114b3b7dc7042b52f7b',
    decimals: 18,
    symbol: 'TMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7246.png',
  },
  {
    chainId: 1,
    name: 'Timers',
    address: '0x8fEEf860E9fA9326ff9d7E0058F637bE8579Cc29',
    decimals: 18,
    symbol: 'IPM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7247.png',
  },
  {
    chainId: 1,
    name: 'TMC',
    address: '0x1c153badb7e54abcdcb65f0a09fcd6f10de36aa3',
    decimals: 18,
    symbol: 'TMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7248.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Passive Income',
    address: '0x05D27CdD23E22ca63e7f9c7C6D1B79ede9C4fCF5',
    decimals: 18,
    symbol: 'YFPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7249.png',
  },
  {
    chainId: 1,
    name: 'YFE Money',
    address: '0x33811d4edbcaed10a685254eb5d3c4e4398520d2',
    decimals: 18,
    symbol: 'YFE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7250.png',
  },
  {
    chainId: 1,
    name: 'YieldWars',
    address: '0xf4a81c18816c9b0ab98fac51b36dcb63b0e58fde',
    decimals: 18,
    symbol: 'WAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7251.png',
  },
  {
    chainId: 1,
    name: 'Yoink',
    address: '0x87c00817abe35ed4c093e59043fae488238d2f74',
    decimals: 18,
    symbol: 'YNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7252.png',
  },
  {
    chainId: 1,
    name: 'Metric Exchange',
    address: '0xefc1c73a3d8728dc4cf2a18ac5705fe93e5914ac',
    decimals: 18,
    symbol: 'METRIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7254.png',
  },
  {
    chainId: 1,
    name: 'Mettalex',
    address: '0x2e1e15c44ffe4df6a0cb7371cd00d5028e571d14',
    decimals: 18,
    symbol: 'MTLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7256.png',
  },
  {
    chainId: 1,
    name: 'Coinwaycoin',
    address: '0x917FD2f7378FF479419dCB56C5cbB445fBbF902A',
    decimals: 10,
    symbol: 'CAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7258.png',
  },
  {
    chainId: 1,
    name: 'Epic',
    address: '0xbcd9e216200369803ed059b7744f6fb4cf3887c7',
    decimals: 18,
    symbol: 'EPIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7261.png',
  },
  {
    chainId: 1,
    name: 'extraDNA',
    address: '0x8e57c27761EBBd381b0f9d09Bb92CeB51a358AbB',
    decimals: 18,
    symbol: 'XDNA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7262.png',
  },
  {
    chainId: 1,
    name: 'HLP Token',
    address: '0x308564dc5217c39386f5eae96545159e1d396661',
    decimals: 18,
    symbol: 'HLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7263.png',
  },
  {
    chainId: 1,
    name: 'Kompass',
    address: '0x41Bc0913ED789428E107C4eA9ED007815c5A8230',
    decimals: 18,
    symbol: 'KOMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7264.png',
  },
  {
    chainId: 1,
    name: 'Steaks Finance',
    address: '0xeed9e4f2450035d6426276a8aa2084966ee3b1bb',
    decimals: 18,
    symbol: 'STEAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7266.png',
  },
  {
    chainId: 1,
    name: 'NTerprise',
    address: '0x462edaa6c1339f98bcb59582af782326603df5f2',
    decimals: 18,
    symbol: 'NTER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7267.png',
  },
  {
    chainId: 1,
    name: 'P2PGO',
    address: '0xA2A19165C17B36a5C753A246c1e188489754A693',
    decimals: 8,
    symbol: 'P2PG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7268.png',
  },
  {
    chainId: 1,
    name: 'Pajama.Finance',
    address: '0x61bc1f530ac6193d73af1e1a6a14cb44b9c3f915',
    decimals: 18,
    symbol: 'PJM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7269.png',
  },
  {
    chainId: 1,
    name: 'Starname',
    address: '0x175D9Dfd6850AA96460E29bC0cEad05756965E91',
    decimals: 18,
    symbol: 'IOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7271.png',
  },
  {
    chainId: 1,
    name: 'The Other Deadness',
    address: '0xf3dd98c8716fe4c8a559eeef84c5fe1fe697cdce',
    decimals: 18,
    symbol: 'DED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7272.png',
  },
  {
    chainId: 1,
    name: 'Unlimited FiscusFYI',
    address: '0x021576770CB3729716CCfb687afdB4c6bF720CB6',
    decimals: 18,
    symbol: 'UFFYI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7273.png',
  },
  {
    chainId: 1,
    name: 'Venom Shards',
    address: '0x1b991b6a41bf3bbc5cbd3b60000f26a8ea9ff9e9',
    decimals: 18,
    symbol: 'VNM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7274.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Ecosystem',
    address: '0x2e6e152d29053b6337e434bc9be17504170f8a5b',
    decimals: 8,
    symbol: 'YFIEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7275.png',
  },
  {
    chainId: 1,
    name: 'Kirobo',
    address: '0xb1191f691a355b43542bea9b8847bc73e7abb137',
    decimals: 18,
    symbol: 'KIRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7276.png',
  },
  {
    chainId: 1,
    name: 'Aave',
    address: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    decimals: 18,
    symbol: 'AAVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7278.png',
  },
  {
    chainId: 1,
    name: '1Click Token',
    address: '0x8cB40391A52412127232747294f737B7882fC873',
    decimals: 8,
    symbol: '1CT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7279.png',
  },
  {
    chainId: 1,
    name: 'Anatha',
    address: '0x3383c5a8969Dc413bfdDc9656Eb80A1408E4bA20',
    decimals: 18,
    symbol: 'wANATHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7280.png',
  },
  {
    chainId: 1,
    name: 'PieDAO DOUGH v2',
    address: '0xad32A8e6220741182940c5aBF610bDE99E737b2D',
    decimals: 18,
    symbol: 'DOUGH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7284.png',
  },
  {
    chainId: 1,
    name: 'Deipool',
    address: '0xd1517663883e2acc154178fb194e80e8bbc29730',
    decimals: 18,
    symbol: 'DIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7285.png',
  },
  {
    chainId: 1,
    name: 'YFOX FINANCE',
    address: '0x706CB9E741CBFee00Ad5b3f5ACc8bd44D1644a74',
    decimals: 6,
    symbol: 'YFOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7286.png',
  },
  {
    chainId: 1,
    name: 'Dragon Network',
    address: '0xee87b220d9b0e762f0643c501fadefd6d9cc5b7e',
    decimals: 18,
    symbol: 'DGNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7287.png',
  },
  {
    chainId: 1,
    name: 'Venus',
    address: '0xd3CC9d8f3689B83c91b7B59cAB4946B063EB894A',
    decimals: 18,
    symbol: 'XVS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7288.png',
  },
  {
    chainId: 1,
    name: 'Satopay Yield Token',
    address: '0xe4883bcb919386bb5f48ef59b7c31c1d93a51a57',
    decimals: 18,
    symbol: 'SPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7289.png',
  },
  {
    chainId: 1,
    name: 'RAC',
    address: '0xc22b30e4cce6b78aaaadae91e44e73593929a3e9',
    decimals: 18,
    symbol: 'RAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7290.png',
  },
  {
    chainId: 1,
    name: 'BullionsChain',
    address: '0x326caf6980d4e9161Cfb3c55f195B3D825c266D4',
    decimals: 18,
    symbol: 'BLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7291.png',
  },
  {
    chainId: 1,
    name: 'YFMoonBeam',
    address: '0x7aFaC1D878C66A47263DCe57976C371Ae2e74882',
    decimals: 18,
    symbol: 'YFMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7292.png',
  },
  {
    chainId: 1,
    name: 'YFET',
    address: '0xc151ca64D66eA44EE4BE9D47c3ce7E031b2fccb7',
    decimals: 18,
    symbol: 'YFET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7293.png',
  },
  {
    chainId: 1,
    name: 'Yearn4 Finance',
    address: '0x38acefad338b870373fb8c810fe705569e1c7225',
    decimals: 18,
    symbol: 'YF4',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7294.png',
  },
  {
    chainId: 1,
    name: 'Truebit',
    address: '0xf65B5C5104c4faFD4b709d9D60a185eAE063276c',
    decimals: 18,
    symbol: 'TRU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7296.png',
  },
  {
    chainId: 1,
    name: 'Street Cred',
    address: '0xED7Fa212E100DFb3b13B834233E4B680332a3420',
    decimals: 18,
    symbol: 'CRED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7297.png',
  },
  {
    chainId: 1,
    name: 'Orb V2',
    address: '0x1b7c4d4f226ccf3211b0f99c4fdfb84a2606bf8e',
    decimals: 18,
    symbol: 'ORB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7299.png',
  },
  {
    chainId: 1,
    name: 'ErcauX',
    address: '0x68496eE825DAFE1cF66D4083f776B9eAAb31e447',
    decimals: 18,
    symbol: 'RAUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7300.png',
  },
  {
    chainId: 1,
    name: 'AurusX',
    address: '0xCB0D82f4DFA503C9e3b8Abc7A3Caa01175b2dA39',
    decimals: 18,
    symbol: 'AX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7301.png',
  },
  {
    chainId: 1,
    name: 'ZAC Finance',
    address: '0x98a90499b62Ae48E151a66B0F647570b5a473B1c',
    decimals: 18,
    symbol: 'ZAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7302.png',
  },
  {
    chainId: 1,
    name: 'YFI Product Token',
    address: '0x8901bed88a57db0eae2bb87d72ced14c6c91164b',
    decimals: 18,
    symbol: 'YFIPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7303.png',
  },
  {
    chainId: 1,
    name: 'Moonbase',
    address: '0x26cF82e4aE43D31eA51e72B663d26e26a75AF729',
    decimals: 18,
    symbol: 'MBBASED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7304.png',
  },
  {
    chainId: 1,
    name: 'Smol',
    address: '0x2216e873ea4282ebef7a02ac5aea220be6391a7c',
    decimals: 18,
    symbol: 'SMOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7306.png',
  },
  {
    chainId: 1,
    name: 'Cyclops Treasure',
    address: '0xbd05cee8741100010d8e93048a80ed77645ac7bf',
    decimals: 18,
    symbol: 'CYTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7307.png',
  },
  {
    chainId: 1,
    name: 'Compound Uni',
    address: '0x35a18000230da775cac24873d00ff85bccded550',
    decimals: 8,
    symbol: 'CUNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7308.png',
  },
  {
    chainId: 1,
    name: 'Bellevue Network',
    address: '0x8DA25B8eD753a5910013167945A676921e864436',
    decimals: 18,
    symbol: 'BLV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7309.png',
  },
  {
    chainId: 1,
    name: 'Gem Exchange and Trading',
    address: '0x4674672bcddda2ea5300f5207e1158185c944bc0',
    decimals: 18,
    symbol: 'GXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7310.png',
  },
  {
    chainId: 1,
    name: 'Beefy',
    address: '0xB1F1ee126e9c96231Cc3d3fAD7C08b4cf873b1f1',
    decimals: 18,
    symbol: 'BIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7311.png',
  },
  {
    chainId: 1,
    name: 'OnigiriSwap',
    address: '0xcf9c692F7e62Af3c571D4173fd4ABf9A3E5330D0',
    decimals: 18,
    symbol: 'ONIGIRI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7313.png',
  },
  {
    chainId: 1,
    name: 'PieDAO DEFI Small Cap',
    address: '0xad6a626ae2b43dcb1b39430ce496d2fa0365ba9c',
    decimals: 18,
    symbol: 'DEFI+S',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7314.png',
  },
  {
    chainId: 1,
    name: 'Polyient Games Governance Token',
    address: '0xeaccb6E0f24d66cF4Aa6cBDa33971b9231d332a1',
    decimals: 18,
    symbol: 'PGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7315.png',
  },
  {
    chainId: 1,
    name: 'YeaFinance',
    address: '0x40b92fCE37CEfA03baf7603e7913C1d34dD1a4EC',
    decimals: 8,
    symbol: 'YEA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7317.png',
  },
  {
    chainId: 1,
    name: 'Zero Utility Token',
    address: '0x83F873388Cd14b83A9f47FabDe3C9850b5C74548',
    decimals: 18,
    symbol: 'ZUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7318.png',
  },
  {
    chainId: 1,
    name: 'YFOS.finance',
    address: '0xCd254568EBF88f088E40f456db9E17731243cb25',
    decimals: 18,
    symbol: 'YFOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7319.png',
  },
  {
    chainId: 1,
    name: 'Neutrino System Base Token',
    address: '0x9d79d5b61de59d882ce90125b18f74af650acb93',
    decimals: 18,
    symbol: 'NSBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7320.png',
  },
  {
    chainId: 1,
    name: 'Stream Protocol',
    address: '0x9b5C2BE869a19e84BDBcb1386dAD83a2ec8DAe82',
    decimals: 18,
    symbol: 'STPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7322.png',
  },
  {
    chainId: 1,
    name: 'XCredit',
    address: '0x6be7e93e45740c314c89a3be52473a0ddf2450fe',
    decimals: 18,
    symbol: 'XFYI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7323.png',
  },
  {
    chainId: 1,
    name: 'Dark.Build',
    address: '0x3108ccFd96816F9E663baA0E8c5951D229E8C6da',
    decimals: 18,
    symbol: 'DARK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7325.png',
  },
  {
    chainId: 1,
    name: 'DeXe',
    address: '0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6',
    decimals: 18,
    symbol: 'DEXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7326.png',
  },
  {
    chainId: 1,
    name: 'LYNC Network',
    address: '0x8f87Ec6aAd3B2A8C44f1298A1af56169B8e574cf',
    decimals: 18,
    symbol: 'LYNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7329.png',
  },
  {
    chainId: 1,
    name: 'YFPRO Finance',
    address: '0x0fdc5313333533cc0c00c22792bff7383d3055f2',
    decimals: 18,
    symbol: 'YFPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7331.png',
  },
  {
    chainId: 1,
    name: 'EasyFi',
    address: '0x00aba6fe5557de1a1d565658cbddddf7c710a1eb',
    decimals: 18,
    symbol: 'EZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7332.png',
  },
  {
    chainId: 1,
    name: 'DeFi Insurance Protocol',
    address: '0xd89A909648e28e8352b63b78007f7fF144f434E9',
    decimals: 8,
    symbol: 'DFIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7333.png',
  },
  {
    chainId: 1,
    name: 'FUD.finance',
    address: '0x2688213fEDd489762a281a67Ae4F2295D8E17ECc',
    decimals: 18,
    symbol: 'FUD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7335.png',
  },
  {
    chainId: 1,
    name: 'Index Cooperative',
    address: '0x0954906da0Bf32d5479e25f46056d22f08464cab',
    decimals: 18,
    symbol: 'INDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7336.png',
  },
  {
    chainId: 1,
    name: 'PieDAO DEFI Large Cap',
    address: '0x78f225869c08d478c34e5f645d07a87d3fe8eb78',
    decimals: 18,
    symbol: 'DEFI+L',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7337.png',
  },
  {
    chainId: 1,
    name: 'TrueCAD',
    address: '0x00000100F2A2bd000715001920eB70D229700085',
    decimals: 18,
    symbol: 'TCAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7339.png',
  },
  {
    chainId: 1,
    name: 'TrueGBP',
    address: '0x00000000441378008ea67f4284a57932b1c000a5',
    decimals: 18,
    symbol: 'TGBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7340.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Origin Axie',
    address: '0xEC0A0915A7c3443862B678B0d4721C7aB133FDCf',
    decimals: 18,
    symbol: 'WOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7342.png',
  },
  {
    chainId: 1,
    name: 'Yfscience',
    address: '0x1df6f1bb7454e5e4ba3bca882d3148fbf9b5697a',
    decimals: 18,
    symbol: 'YFSI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7343.png',
  },
  {
    chainId: 1,
    name: 'Almace Shards',
    address: '0x25a3dcabbf0070cb8e5baaa62d576cf6643afb5b',
    decimals: 18,
    symbol: 'ALMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7344.png',
  },
  {
    chainId: 1,
    name: 'Hauteclere Shards',
    address: '0x3142dad33b1c6e1371d8627365f2ee2095eb6b37',
    decimals: 18,
    symbol: 'HAUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7345.png',
  },
  {
    chainId: 1,
    name: 'Kauri',
    address: '0xe172f366678ec7b559f6c2913a437baadfd4e6c8',
    decimals: 8,
    symbol: 'KAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7346.png',
  },
  {
    chainId: 1,
    name: 'Portion',
    address: '0x6D0F5149c502faf215C89ab306ec3E50b15e2892',
    decimals: 18,
    symbol: 'PRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7348.png',
  },
  {
    chainId: 1,
    name: 'Centaur',
    address: '0x03042482d64577a7bdb282260e2ea4c8a89c064b',
    decimals: 18,
    symbol: 'CNTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7349.png',
  },
  {
    chainId: 1,
    name: 'Crypxie',
    address: '0x79ddbbCc9D7FbDc77b02A960DabD2577144FDD6E',
    decimals: 18,
    symbol: 'CPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7350.png',
  },
  {
    chainId: 1,
    name: 'Heavens Gate',
    address: '0xe75d3b39d017985caf20fac7134ed55b8b47cc26',
    decimals: 18,
    symbol: 'HATE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7352.png',
  },
  {
    chainId: 1,
    name: 'TrueAUD',
    address: '0x00006100f7090010005f1bd7ae6122c3c2cf0090',
    decimals: 18,
    symbol: 'TAUD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7354.png',
  },
  {
    chainId: 1,
    name: 'Reflex',
    address: '0x159A1dFAe19057de57dFfFcbB3DA1aE784678965',
    decimals: 18,
    symbol: 'RFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7355.png',
  },
  {
    chainId: 1,
    name: 'Thirm Protocol',
    address: '0xb526fd41360c98929006f3bdcbd16d55de4b0069',
    decimals: 18,
    symbol: 'THIRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7356.png',
  },
  {
    chainId: 1,
    name: 'Yearn-finance Infrastructure Labs',
    address: '0x454CB9D0845bB4a28462F98C21a4fAFD16ceb25f',
    decimals: 18,
    symbol: 'YLAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7357.png',
  },
  {
    chainId: 1,
    name: 'YFED.Finance',
    address: '0x2DBd330bC9B7f3A822a9173aB52172BdDDcAcE2A',
    decimals: 8,
    symbol: 'YFED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7358.png',
  },
  {
    chainId: 1,
    name: 'Everyonetoken',
    address: '0xd3e7e71d20403a6d0bead558c0bf19452a3fd002',
    decimals: 18,
    symbol: 'EOTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7359.png',
  },
  {
    chainId: 1,
    name: 'Fridn',
    address: '0xe1431643574ba7bac71a3b2ca52b00aca852e4a4',
    decimals: 4,
    symbol: 'EFAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7361.png',
  },
  {
    chainId: 1,
    name: 'POP Network Token',
    address: '0x5d858bcd53e085920620549214a8b27ce2f04670',
    decimals: 18,
    symbol: 'POP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7363.png',
  },
  {
    chainId: 1,
    name: 'USDL',
    address: '0x3e991dbec296e00626e58c33b62e53bec9d54636',
    decimals: 18,
    symbol: 'USDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7364.png',
  },
  {
    chainId: 1,
    name: 'TopCoinFX',
    address: '0x031e0c6a7c91df1bc171d33cccc6988fd2ddeb6f',
    decimals: 18,
    symbol: 'TCFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7365.png',
  },
  {
    chainId: 1,
    name: 'Stabilize',
    address: '0xb987d48ed8f2c468d52d6405624eadba5e76d723',
    decimals: 18,
    symbol: 'STBZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7366.png',
  },
  {
    chainId: 1,
    name: 'SnowSwap',
    address: '0xfe9a29ab92522d14fc65880d817214261d8479ae',
    decimals: 18,
    symbol: 'SNOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7367.png',
  },
  {
    chainId: 1,
    name: 'Power Index Pool Token',
    address: '0x26607ac599266b21d13c7acf7942c7701a8b699c',
    decimals: 18,
    symbol: 'PIPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7368.png',
  },
  {
    chainId: 1,
    name: 'NovaDeFi',
    address: '0xd9a6803f41a006cbf389f21e55d7a6079dfe8df3',
    decimals: 18,
    symbol: 'NMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7369.png',
  },
  {
    chainId: 1,
    name: 'Ivy Mining',
    address: '0x829067d40a8d1233927891d9b3381d6aecee1e80',
    decimals: 18,
    symbol: 'IVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7370.png',
  },
  {
    chainId: 1,
    name: 'Mover',
    address: '0x3FA729B4548beCBAd4EaB6EF18413470e6D5324C',
    decimals: 18,
    symbol: 'MOVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7371.png',
  },
  {
    chainId: 1,
    name: 'Decore',
    address: '0xb944b46bbd4ccca90c962ef225e2804e46691ccf',
    decimals: 18,
    symbol: 'DCORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7372.png',
  },
  {
    chainId: 1,
    name: 'BitTiger',
    address: '0x594e8f548ae1eb5a22b4d48a90ae9bc48e7c4742',
    decimals: 18,
    symbol: 'BTTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7373.png',
  },
  {
    chainId: 1,
    name: 'Doki Doki Finance',
    address: '0x9ceb84f92a0561fa3cc4132ab9c0b76a59787544',
    decimals: 18,
    symbol: 'DOKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7376.png',
  },
  {
    chainId: 1,
    name: 'Dogeswap',
    address: '0xb4fbed161bebcb37afb1cb4a6f7ca18b977ccb25',
    decimals: 18,
    symbol: 'DOGES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7377.png',
  },
  {
    chainId: 1,
    name: 'Seal Finance',
    address: '0x33c2DA7Fd5B125E629B3950f3c38d7f721D7B30D',
    decimals: 18,
    symbol: 'SEAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7378.png',
  },
  {
    chainId: 1,
    name: 'LimitSwap',
    address: '0x1712aad2c773ee04bdc9114b32163c058321cd85',
    decimals: 18,
    symbol: 'LIMIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7379.png',
  },
  {
    chainId: 1,
    name: 'Dracula Token',
    address: '0xb78b3320493a4efaa1028130c5ba26f0b6085ef8',
    decimals: 18,
    symbol: 'DRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7380.png',
  },
  {
    chainId: 1,
    name: 'CoFiX',
    address: '0x1a23a6BfBAdB59fa563008c0fB7cf96dfCF34Ea1',
    decimals: 18,
    symbol: 'COFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7381.png',
  },
  {
    chainId: 1,
    name: 'ACoconut',
    address: '0x9a0aba393aac4dfbff4333b06c407458002c6183',
    decimals: 18,
    symbol: 'AC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7382.png',
  },
  {
    chainId: 1,
    name: 'Dandy Dego',
    address: '0x9dfc4b433d359024eb3e810d77d60fbe8b0d9b82',
    decimals: 18,
    symbol: 'DANDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7384.png',
  },
  {
    chainId: 1,
    name: 'deCraft Finance',
    address: '0xa09ff006c652496e72d648cef2f4ee6777efdf6f',
    decimals: 18,
    symbol: 'CRAFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7385.png',
  },
  {
    chainId: 1,
    name: 'Spaceswap MILK2',
    address: '0x80c8c3dcfb854f9542567c8dac3f44d709ebc1de',
    decimals: 18,
    symbol: 'MILK2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7386.png',
  },
  {
    chainId: 1,
    name: 'Mimidi',
    address: '0xf2fc92ccbd3fe243505497b6474257654164abc7',
    decimals: 18,
    symbol: 'MMD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7387.png',
  },
  {
    chainId: 1,
    name: 'Nobrainer Finance',
    address: '0xea3cb156745a8d281a5fc174186c976f2dd04c2e',
    decimals: 18,
    symbol: 'BRAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7388.png',
  },
  {
    chainId: 1,
    name: 'Non-Fungible Yearn',
    address: '0x1cbb83ebcd552d5ebf8131ef8c9cd9d9bab342bc',
    decimals: 18,
    symbol: 'NFY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7389.png',
  },
  {
    chainId: 1,
    name: 'Spaceswap SHAKE',
    address: '0x6006fc2a849fedaba8330ce36f5133de01f96189',
    decimals: 18,
    symbol: 'SHAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7390.png',
  },
  {
    chainId: 1,
    name: 'Talent Token',
    address: '0x448CF521608F9FBac30DA7746603cBa1B9eFC46F',
    decimals: 18,
    symbol: 'TTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7392.png',
  },
  {
    chainId: 1,
    name: 'Wolfage Finance Governance Token',
    address: '0x31735f0292d42801dce3b0f83b0d9a09bff75b07',
    decimals: 18,
    symbol: 'WEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7393.png',
  },
  {
    chainId: 1,
    name: 'Tavittcoin',
    address: '0xdd690d8824c00c84d64606ffb12640e932c1af56',
    decimals: 8,
    symbol: 'TAVITT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7397.png',
  },
  {
    chainId: 1,
    name: 'Coreto',
    address: '0x9C2dc0c3CC2BADdE84B0025Cf4df1c5aF288D835',
    decimals: 18,
    symbol: 'COR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7398.png',
  },
  {
    chainId: 1,
    name: 'Global Gaming',
    address: '0xcf81e6fdb8d7a743c3d4c3542a5356ff197ea1c0',
    decimals: 8,
    symbol: 'GMNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7399.png',
  },
  {
    chainId: 1,
    name: 'YFi Management',
    address: '0x4B34c0CBeEF271F895d339c5F76322d71A60782B',
    decimals: 18,
    symbol: 'YEFIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7400.png',
  },
  {
    chainId: 1,
    name: 'Load Network',
    address: '0xa883e72c12473ded50a5fbffa60e4000fa5fe3c8',
    decimals: 8,
    symbol: 'LOAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7401.png',
  },
  {
    chainId: 1,
    name: 'Zetaspace',
    address: '0x8bBef1505Ec90E55ea9EBd33dDd41C142dA4eBDA',
    decimals: 18,
    symbol: 'XZT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7402.png',
  },
  {
    chainId: 1,
    name: 'Wrapped BIND',
    address: '0x15334dcb171e8b65d6650321581dca83be870115',
    decimals: 8,
    symbol: 'WBIND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7403.png',
  },
  {
    chainId: 1,
    name: 'Value Liquidity',
    address: '0x49e833337ece7afe375e44f4e3e8481029218e5c',
    decimals: 18,
    symbol: 'VALUE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7404.png',
  },
  {
    chainId: 1,
    name: 'MoonTools',
    address: '0x260e63d91fccc499606bae3fe945c4ed1cf56a56',
    decimals: 18,
    symbol: 'MOONS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7406.png',
  },
  {
    chainId: 1,
    name: 'Payship',
    address: '0x88d59ba796fdf639ded3b5e720988d59fdb71eb8',
    decimals: 18,
    symbol: 'PSHP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7407.png',
  },
  {
    chainId: 1,
    name: 'Sergey Save Link',
    address: '0x0d9227f9c4ab3972f994fccc6eeba3213c0305c4',
    decimals: 18,
    symbol: 'SSL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7408.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance DOT',
    address: '0x2e6539edc3b76f1e21b71d214527faba875f70f3',
    decimals: 18,
    symbol: 'YFDOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7410.png',
  },
  {
    chainId: 1,
    name: 'Covalent',
    address: '0xD417144312DbF50465b1C641d016962017Ef6240',
    decimals: 18,
    symbol: 'CQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7411.png',
  },
  {
    chainId: 1,
    name: 'UniLend',
    address: '0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1',
    decimals: 18,
    symbol: 'UFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7412.png',
  },
  {
    chainId: 1,
    name: 'Behodler',
    address: '0x155ff1A85F440EE0A382eA949f24CE4E0b751c65',
    decimals: 18,
    symbol: 'EYE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7414.png',
  },
  {
    chainId: 1,
    name: 'BonezYard',
    address: '0x014a543f767b3b06e31a811b0a75483ee8dfd72d',
    decimals: 18,
    symbol: 'BNZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7415.png',
  },
  {
    chainId: 1,
    name: 'Dai If Trump Loses The 2020 Election',
    address: '0x40ce0a1d8f4999807b92ec266a025f071814b15d',
    decimals: 18,
    symbol: 'NOTRUMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7417.png',
  },
  {
    chainId: 1,
    name: 'Dai If Trump Wins The 2020 Election',
    address: '0x5963fd7ca9b17b85768476019f81cb43d9d1818e',
    decimals: 18,
    symbol: 'YESTRUMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7418.png',
  },
  {
    chainId: 1,
    name: 'DAOFi',
    address: '0xd82bb924a1707950903e2c0a619824024e254cd1',
    decimals: 18,
    symbol: 'DAOFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7419.png',
  },
  {
    chainId: 1,
    name: 'Digital Reserve Currency',
    address: '0xa150db9b1fa65b44799d4dd949d922c0a33ee606',
    decimals: 18,
    symbol: 'DRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7420.png',
  },
  {
    chainId: 1,
    name: 'PlotX',
    address: '0x72f020f8f3e8fd9382705723cd26380f8d0c66bb',
    decimals: 18,
    symbol: 'PLOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7422.png',
  },
  {
    chainId: 1,
    name: 'RUSH',
    address: '0x395768aeb16484e5785612a98e9408e4cc1269ec',
    decimals: 18,
    symbol: 'RUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7423.png',
  },
  {
    chainId: 1,
    name: 'Hermez Network',
    address: '0xeef9f339514298c6a857efcfc1a762af84438dee',
    decimals: 18,
    symbol: 'HEZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7424.png',
  },
  {
    chainId: 1,
    name: 'PayAccept',
    address: '0x8EF47555856f6Ce2E0cd7C36AeF4FAb317d2e2E2',
    decimals: 18,
    symbol: 'PAYT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7425.png',
  },
  {
    chainId: 1,
    name: 'Qcore.Finance',
    address: '0x82866b4a71ba9d930fe338c386b6a45a7133eb36',
    decimals: 9,
    symbol: 'QCORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7426.png',
  },
  {
    chainId: 1,
    name: 'SWAG Finance',
    address: '0x87edffde3e14c7a66c9b9724747a1c5696b742e6',
    decimals: 18,
    symbol: 'SWAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7428.png',
  },
  {
    chainId: 1,
    name: 'Liquity',
    address: '0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D',
    decimals: 18,
    symbol: 'LQTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7429.png',
  },
  {
    chainId: 1,
    name: 'Zenfuse',
    address: '0xb1e9157c2fdcc5a856c8da8b2d89b6c32b3c1229',
    decimals: 18,
    symbol: 'ZEFU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7430.png',
  },
  {
    chainId: 1,
    name: 'Bit Financial',
    address: '0x4d31200e6d7854c2f664af7fc38a21600960f74d',
    decimals: 18,
    symbol: 'BFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7432.png',
  },
  {
    chainId: 1,
    name: 'Cargo Gems',
    address: '0x30b1efb052205e6ca3c4888c3c50c5b339cc0602',
    decimals: 18,
    symbol: 'GEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7433.png',
  },
  {
    chainId: 1,
    name: 'Pepemon Pepeballs',
    address: '0x4d2ee5dae46c86da2ff521f7657dad98834f97b8',
    decimals: 18,
    symbol: 'PPBLZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7435.png',
  },
  {
    chainId: 1,
    name: 'BonFi',
    address: '0x1DE5e000C41C8d35b9f1f4985C23988f05831057',
    decimals: 18,
    symbol: 'BNF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7436.png',
  },
  {
    chainId: 1,
    name: 'MobieCoin',
    address: '0x71ba91dc68c6a206db0a6a92b4b1de3f9271432d',
    decimals: 18,
    symbol: 'MBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7437.png',
  },
  {
    chainId: 1,
    name: 'ZeroSwap',
    address: '0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5',
    decimals: 18,
    symbol: 'ZEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7438.png',
  },
  {
    chainId: 1,
    name: 'Gallery Finance',
    address: '0x47fd85128312ee72aA0E0382a531a8f848B8B2CB',
    decimals: 18,
    symbol: 'GLF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7439.png',
  },
  {
    chainId: 1,
    name: 'BarnBridge',
    address: '0x0391D2021f89DC339F60Fff84546EA23E337750f',
    decimals: 18,
    symbol: 'BOND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7440.png',
  },
  {
    chainId: 1,
    name: 'yRise Finance',
    address: '0x6051C1354Ccc51b4d561e43b02735DEaE64768B8',
    decimals: 18,
    symbol: 'YRISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7441.png',
  },
  {
    chainId: 1,
    name: 'YFIA',
    address: '0x94373d40135604ce50083Ff282250A9033761E53',
    decimals: 8,
    symbol: 'YFIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7442.png',
  },
  {
    chainId: 1,
    name: 'dXIOT',
    address: '0x8b6dd24bcb2d0aea92c3abd4eb11103a5db6d714',
    decimals: 18,
    symbol: 'DXIOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7443.png',
  },
  {
    chainId: 1,
    name: 'Nice',
    address: '0x53f64be99da00fec224eaf9f8ce2012149d2fc88',
    decimals: 18,
    symbol: 'NICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7444.png',
  },
  {
    chainId: 1,
    name: 'cCOMP',
    address: '0x70e36f6BF80a52b3B46b3aF8e106CC0ed743E8e4',
    decimals: 8,
    symbol: 'CCOMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7445.png',
  },
  {
    chainId: 1,
    name: 'Unicore',
    address: '0x5506861bbb104baa8d8575e88e22084627b192d8',
    decimals: 18,
    symbol: 'UNICORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7446.png',
  },
  {
    chainId: 1,
    name: 'LCG',
    address: '0x6e1a58e7e9e801f32bb82462636a8a2e7b65e036',
    decimals: 18,
    symbol: 'LCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7448.png',
  },
  {
    chainId: 1,
    name: 'YFI Paprika',
    address: '0xB9782532FA7062A6F73df1CE71d75c0E16046ebC',
    decimals: 8,
    symbol: 'YFIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7449.png',
  },
  {
    chainId: 1,
    name: 'PayUSD',
    address: '0x38d389c300357a26beec198f3893fba54fde69c5',
    decimals: 18,
    symbol: 'PUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7450.png',
  },
  {
    chainId: 1,
    name: 'DigiDinar Stable Token',
    address: '0x3ef36D53A168c44ed2Ec7a98129CA0308BC1AE45',
    decimals: 8,
    symbol: 'DDRST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7451.png',
  },
  {
    chainId: 1,
    name: 'ETG Finance',
    address: '0x74603e780545d02C4257E7D2BE19c74dE7BE1952',
    decimals: 18,
    symbol: 'ETGF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7454.png',
  },
  {
    chainId: 1,
    name: 'Audius',
    address: '0x18aaa7115705e8be94bffebde57af9bfc265b998',
    decimals: 18,
    symbol: 'AUDIO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7455.png',
  },
  {
    chainId: 1,
    name: 'Rare',
    address: '0x81B1bFD6CB9Ad42DB395c2a27F73D4DCf5777e2D',
    decimals: 4,
    symbol: 'RARE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7456.png',
  },
  {
    chainId: 1,
    name: 'Super Saiya-jin',
    address: '0xb4ae194a0dcf1b4080b164c1d775ee06e0817305',
    decimals: 18,
    symbol: 'SSJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7457.png',
  },
  {
    chainId: 1,
    name: 'AISF',
    address: '0x8D2FAb1ff34f1c545673a816f1438B02D0a2E32D',
    decimals: 8,
    symbol: 'AGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7459.png',
  },
  {
    chainId: 1,
    name: 'Alpha Quark Token',
    address: '0x2a9bDCFF37aB68B95A53435ADFd8892e86084F93',
    decimals: 18,
    symbol: 'AQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7460.png',
  },
  {
    chainId: 1,
    name: 'PlayDapp',
    address: '0x0D3CbED3f69EE050668ADF3D9Ea57241cBa33A2B',
    decimals: 18,
    symbol: 'PDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7461.png',
  },
  {
    chainId: 1,
    name: 'RAMP',
    address: '0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f',
    decimals: 18,
    symbol: 'RAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7463.png',
  },
  {
    chainId: 1,
    name: 'KORE Vault',
    address: '0xa866f0198208eb07c83081d5136be7f775c2399e',
    decimals: 18,
    symbol: 'KORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7464.png',
  },
  {
    chainId: 1,
    name: 'Vox.Finance',
    address: '0x12D102F06da35cC0111EB58017fd2Cd28537d0e1',
    decimals: 18,
    symbol: 'VOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7465.png',
  },
  {
    chainId: 1,
    name: 'PRIA',
    address: '0xb9871cb10738eada636432e86fc0cb920dc3de24',
    decimals: 18,
    symbol: 'PRIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7466.png',
  },
  {
    chainId: 1,
    name: 'Rari Stable Pool Token',
    address: '0x016bf078abcacb987f0589a6d3beadd4316922b0',
    decimals: 18,
    symbol: 'RSPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7468.png',
  },
  {
    chainId: 1,
    name: 'Apiary Fund Coin',
    address: '0xf576ff0d7e4c1e8f27dbd50321e95e36a965985f',
    decimals: 18,
    symbol: 'AFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7469.png',
  },
  {
    chainId: 1,
    name: 'Charged Finance',
    address: '0x0dafe2b22323dac2940d43cede16cd8790c5d4e6',
    decimals: 18,
    symbol: 'CHARGED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7470.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Virgin Gen-0 CryptoKitties',
    address: '0x25c7b64a93eb1261e130ec21a3e9918caa38b611',
    decimals: 18,
    symbol: 'WVG0',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7471.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Gen-0 CryptoKitties',
    address: '0xa10740ff9ff6852eac84cdcff9184e1d6d27c057',
    decimals: 18,
    symbol: 'WG0',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7472.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Basic CryptoKitties',
    address: '0x09fE5f0236F0Ea5D930197DCE254d77B04128075',
    decimals: 18,
    symbol: 'WCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7473.png',
  },
  {
    chainId: 1,
    name: 'Axia Protocol',
    address: '0x793786e2dd4Cc492ed366a94B88a3Ff9ba5E7546',
    decimals: 18,
    symbol: 'AXIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7474.png',
  },
  {
    chainId: 1,
    name: 'Camp',
    address: '0xE9E73E1aE76D17A16cC53E3e87a9a7dA78834d37',
    decimals: 18,
    symbol: 'CAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7475.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Network',
    address: '0x3dd66732113af9981a861cf489431533aeba33b8',
    decimals: 18,
    symbol: 'YFN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7478.png',
  },
  {
    chainId: 1,
    name: 'BooBank',
    address: '0xa9c44135b3a87e0688c41cf8c27939a22dd437c9',
    decimals: 18,
    symbol: 'BOOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7479.png',
  },
  {
    chainId: 1,
    name: 'TenSpeed Finance',
    address: '0x776ca7ded9474829ea20ad4a5ab7a6ffdb64c796',
    decimals: 18,
    symbol: 'TENS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7480.png',
  },
  {
    chainId: 1,
    name: 'Moonday Finance',
    address: '0x1ad606adde97c0c28bd6ac85554176bc55783c01',
    decimals: 18,
    symbol: 'MOONDAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7481.png',
  },
  {
    chainId: 1,
    name: 'McNetworkDefi',
    address: '0xc047c42554c6495c85108ae8ee66fa4e3b88176d',
    decimals: 18,
    symbol: 'MCN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7482.png',
  },
  {
    chainId: 1,
    name: 'DeFi Gold',
    address: '0xE3a64A3c4216B83255b53Ec7eA078B13f21a7daD',
    decimals: 18,
    symbol: 'DFGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7483.png',
  },
  {
    chainId: 1,
    name: 'Kaiju',
    address: '0x58a5d3e4873a75b07fb3c7cf477eebc44ea73b3b',
    decimals: 4,
    symbol: 'KAIJU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7485.png',
  },
  {
    chainId: 1,
    name: 'Rari Governance Token',
    address: '0xd291e7a03283640fdc51b121ac401383a46cc623',
    decimals: 18,
    symbol: 'RGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7486.png',
  },
  {
    chainId: 1,
    name: 'Chonk',
    address: '0x84679bc467DC6c2c40ab04538813AfF3796351f1',
    decimals: 18,
    symbol: 'CHONK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7487.png',
  },
  {
    chainId: 1,
    name: 'ShareAt',
    address: '0x01c8857057326B8f64DCb5cba6d802DcD132946e',
    decimals: 18,
    symbol: 'XAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7488.png',
  },
  {
    chainId: 1,
    name: 'BananoDOS',
    address: '0x1706c33B9a5B12aeB85B862215378dEe9480EB95',
    decimals: 18,
    symbol: 'yBAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7489.png',
  },
  {
    chainId: 1,
    name: 'LEAF DeFi',
    address: '0xab4f288bcab7c3ff212bc2bd433ba4ba339eb873',
    decimals: 18,
    symbol: 'LAF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7490.png',
  },
  {
    chainId: 1,
    name: 'DXY FINANCE',
    address: '0x39fa206c1648944f92e8f7b626e1cbdf78d7e9db',
    decimals: 18,
    symbol: 'DXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7491.png',
  },
  {
    chainId: 1,
    name: 'Zin Finance',
    address: '0x033e223870f766644f7f7a4B7dc2E91573707d06',
    decimals: 18,
    symbol: 'ZIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7492.png',
  },
  {
    chainId: 1,
    name: 'JustBet',
    address: '0x27460aac4b005de72e2326bd8391c27fb41780f8',
    decimals: 18,
    symbol: 'WINR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7494.png',
  },
  {
    chainId: 1,
    name: 'YieldX',
    address: '0xE52d53c8C9aa7255F8c2FA9f7093FEa7192D2933',
    decimals: 18,
    symbol: 'YIELDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7495.png',
  },
  {
    chainId: 1,
    name: 'Enoki Finance',
    address: '0xa4bad5d040d4464ec5ce130987731f2f428c9307',
    decimals: 18,
    symbol: 'SPORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7496.png',
  },
  {
    chainId: 1,
    name: 'Marlin',
    address: '0x57b946008913b82e4df85f501cbaed910e58d26c',
    decimals: 18,
    symbol: 'POND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7497.png',
  },
  {
    chainId: 1,
    name: 'Yield Protocol',
    address: '0xa8B61CfF52564758A204F841E636265bEBC8db9B',
    decimals: 18,
    symbol: 'YIELD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7498.png',
  },
  {
    chainId: 1,
    name: 'Shell Protocol',
    address: '0x8dcaec45365e5ada5676073a07b418c2f538145a',
    decimals: 18,
    symbol: 'SHELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7499.png',
  },
  {
    chainId: 1,
    name: 'Bonded Finance',
    address: '0x5dc02ea99285e17656b8350722694c35154db1e8',
    decimals: 8,
    symbol: 'BOND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7500.png',
  },
  {
    chainId: 1,
    name: 'WOO',
    address: '0x4691937a7508860f876c9c0a2a617e7d9e945d4b',
    decimals: 18,
    symbol: 'WOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7501.png',
  },
  {
    chainId: 1,
    name: 'Bithao',
    address: '0x6d7c7d764d6f1DFa256C74AbB4C4d7861d8EE64C',
    decimals: 18,
    symbol: 'BHAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7503.png',
  },
  {
    chainId: 1,
    name: 'WeBlock',
    address: '0x1eddee3fa21591a9637f88dab9615c33ee636b9d',
    decimals: 18,
    symbol: 'WON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7504.png',
  },
  {
    chainId: 1,
    name: 'Everscale',
    address: '0x1ffefd8036409cb6d652bd610de465933b226917',
    decimals: 18,
    symbol: 'EVER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7505.png',
  },
  {
    chainId: 1,
    name: 'Neeva Defi',
    address: '0x38f7cd43662d1cff4cc3c2c4b749f7cfed1d1db3',
    decimals: 18,
    symbol: 'NVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7507.png',
  },
  {
    chainId: 1,
    name: 'Swerve.fi USD',
    address: '0x77C6E4a580c0dCE4E5c7a17d0bc077188a83A059',
    decimals: 18,
    symbol: 'SWUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7508.png',
  },
  {
    chainId: 1,
    name: 'BoringDAO',
    address: '0x3c9d6c1c73b31c837832c72e04d3152f051fc1a9',
    decimals: 18,
    symbol: 'BOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7509.png',
  },
  {
    chainId: 1,
    name: 'QuiverX',
    address: '0x6e0dade58d2d89ebbe7afc384e3e4f15b70b14d8',
    decimals: 18,
    symbol: 'QRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7510.png',
  },
  {
    chainId: 1,
    name: 'DogDeFiCoin',
    address: '0x80bb277f4355A43CDbB86a82F9876C946476d9Eb',
    decimals: 18,
    symbol: 'DOGDEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7511.png',
  },
  {
    chainId: 1,
    name: 'Unistake',
    address: '0x9ed8e7c9604790f7ec589f99b94361d8aab64e5e',
    decimals: 18,
    symbol: 'UNISTAKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7512.png',
  },
  {
    chainId: 1,
    name: 'IDall',
    address: '0xce80ce10fa806f4aa8755ab92cd268c51d7fd867',
    decimals: 5,
    symbol: 'IDALL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7514.png',
  },
  {
    chainId: 1,
    name: 'Ubiner',
    address: '0xb9EcEb9F717852Ad0D936B46155cB0c0f43cBE8E',
    decimals: 18,
    symbol: 'UBIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7515.png',
  },
  {
    chainId: 1,
    name: 'Naz Coin',
    address: '0x7723a1d7b939e0a49959363bf057ca57c7215e75',
    decimals: 18,
    symbol: 'NAZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7516.png',
  },
  {
    chainId: 1,
    name: 'YFI CREDITS GROUP',
    address: '0x9080e92296a176883aAB1d7d1B7e50BC055B0cAa',
    decimals: 18,
    symbol: 'YFICG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7517.png',
  },
  {
    chainId: 1,
    name: 'Voice Token',
    address: '0x2e2364966267B5D7D2cE6CD9A9B5bD19d9C7C6A9',
    decimals: 18,
    symbol: 'VOICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7518.png',
  },
  {
    chainId: 1,
    name: 'SynLev',
    address: '0x1695936d6a953df699c38ca21c2140d497c08bd9',
    decimals: 18,
    symbol: 'SYN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7520.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Red Moon',
    address: '0xbE685C5E06866cfB94A4242E3DF8f2fa3E7c2b73',
    decimals: 18,
    symbol: 'YFRM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7530.png',
  },
  {
    chainId: 1,
    name: 'Lumos',
    address: '0x034455C8a9882BF44C9704c780A55198E05BA559',
    decimals: 18,
    symbol: 'LMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7531.png',
  },
  {
    chainId: 1,
    name: 'Oraichain',
    address: '0x4c11249814f11b9346808179cf06e71ac328c1b5',
    decimals: 18,
    symbol: 'ORAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7533.png',
  },
  {
    chainId: 1,
    name: 'Tsunami finance',
    address: '0x7eb4db4dddb16a329c5ade17a8a0178331267e28',
    decimals: 18,
    symbol: 'NAMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7534.png',
  },
  {
    chainId: 1,
    name: 'Keep3rV1',
    address: '0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44',
    decimals: 18,
    symbol: 'KP3R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7535.png',
  },
  {
    chainId: 1,
    name: 'Tatcoin',
    address: '0x505d0ffa350b2687eb8393aebd14632f2990991a',
    decimals: 18,
    symbol: 'TAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7537.png',
  },
  {
    chainId: 1,
    name: 'Degens',
    address: '0xdd039990bd551ce7437d3bf54d155220b7988b71',
    decimals: 18,
    symbol: 'DEGENS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7538.png',
  },
  {
    chainId: 1,
    name: 'Colibri Protocol',
    address: '0x47a60748de6dbd8dce3991adc5751ce0f32279dc',
    decimals: 18,
    symbol: 'CLBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7539.png',
  },
  {
    chainId: 1,
    name: 'MegaCryptoPolis',
    address: '0x3218a02f8f8b5c3894ce30eb255f10bcba13e654',
    decimals: 18,
    symbol: 'MEGA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7540.png',
  },
  {
    chainId: 1,
    name: 'HubDAO',
    address: '0x6ce654ac973d326f89f0685e7459542641410ed9',
    decimals: 18,
    symbol: 'HD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7541.png',
  },
  {
    chainId: 1,
    name: 'Bloody Token',
    address: '0x892F5A0B08BB7B1eeCCCC63EF3916fF201c93664',
    decimals: 18,
    symbol: 'BLOODY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7542.png',
  },
  {
    chainId: 1,
    name: 'Hoo Token',
    address: '0xd241d7b5cb0ef9fc79d9e4eb9e21f5e209f52f7d',
    decimals: 8,
    symbol: 'HOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7543.png',
  },
  {
    chainId: 1,
    name: 'The Luxury Coin',
    address: '0x8ab0565dfe65bf9be754d7b0dadbb42c4ecaec01',
    decimals: 18,
    symbol: 'TLB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7544.png',
  },
  {
    chainId: 1,
    name: 'Warlord Token',
    address: '0xb7bc7b0a32455f7e7a924f832ca4f0a0ac3b6b88',
    decimals: 18,
    symbol: 'WLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7546.png',
  },
  {
    chainId: 1,
    name: 'SURF Finance',
    address: '0xea319e87cf06203dae107dd8e5672175e3ee976c',
    decimals: 18,
    symbol: 'SURF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7547.png',
  },
  {
    chainId: 1,
    name: 'Farm Defi',
    address: '0x6a8C66Cab4F766E5E30b4e9445582094303cc322',
    decimals: 18,
    symbol: 'PFARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7550.png',
  },
  {
    chainId: 1,
    name: 'YYFI.Protocol',
    address: '0xaF20b44C1C651D1d29cFB916eE2A0630B828Eb7A',
    decimals: 18,
    symbol: 'YYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7551.png',
  },
  {
    chainId: 1,
    name: 'Hyve',
    address: '0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4',
    decimals: 18,
    symbol: 'HYVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7552.png',
  },
  {
    chainId: 1,
    name: 'Residual Token',
    address: '0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6',
    decimals: 18,
    symbol: 'eRSDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7553.png',
  },
  {
    chainId: 1,
    name: 'Hiz Finance',
    address: '0xc761D1ccb38a94703675d2cDb15F7F1B3dcFF7B7',
    decimals: 18,
    symbol: 'HIZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7554.png',
  },
  {
    chainId: 1,
    name: 'Tadpole Finance',
    address: '0x9f7229af0c4b9740e207ea283b9094983f78ba04',
    decimals: 18,
    symbol: 'TAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7559.png',
  },
  {
    chainId: 1,
    name: 'Fundamenta',
    address: '0xaa9d866666c2a3748d6b23ff69e63e52f08d9ab4',
    decimals: 18,
    symbol: 'FMTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7560.png',
  },
  {
    chainId: 1,
    name: 'Kper network',
    address: '0xc89b4a8a121dd3e726fe7515e703936cf83e3350',
    decimals: 18,
    symbol: 'KPER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7561.png',
  },
  {
    chainId: 1,
    name: 'DotBased',
    address: '0xe5b0792400a47af372486704eda0f1799ee83f54',
    decimals: 18,
    symbol: 'xDOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7563.png',
  },
  {
    chainId: 1,
    name: 'Pteria',
    address: '0x02eca910cb3a7d43ebc7e8028652ed5c6b70259b',
    decimals: 18,
    symbol: 'PTERIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7564.png',
  },
  {
    chainId: 1,
    name: 'stakedFIRO',
    address: '0x160b1e5aabfd70b2fc40af815014925d71ceed7e',
    decimals: 8,
    symbol: 'stFIRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7566.png',
  },
  {
    chainId: 1,
    name: 'Smpl foundation',
    address: '0x8bf92cad232f72a7c61eb42e9185e8d0ea470f6b',
    decimals: 18,
    symbol: 'SMPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7568.png',
  },
  {
    chainId: 1,
    name: 'King Swap',
    address: '0xd2057d71fE3F5b0dc1E3e7722940E1908Fc72078',
    decimals: 18,
    symbol: '$KING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7569.png',
  },
  {
    chainId: 1,
    name: 'Social Rocket',
    address: '0x0829d2d5cc09d3d341e813c821b0cfae272d9fb2',
    decimals: 18,
    symbol: 'ROCKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7571.png',
  },
  {
    chainId: 1,
    name: 'USDG',
    address: '0xeea9aE787f3A620072d13b2cdC8cabFFb9c0aB96',
    decimals: 18,
    symbol: 'USDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7572.png',
  },
  {
    chainId: 1,
    name: 'Stacy',
    address: '0xf12EC0D3Dab64DdEfBdC96474bDe25af3FE1B327',
    decimals: 18,
    symbol: 'STACY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7574.png',
  },
  {
    chainId: 1,
    name: 'nYFI',
    address: '0x075190c6130ea0a3a7e40802f1d77f4ea8f38fe2',
    decimals: 18,
    symbol: 'N0031',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7575.png',
  },
  {
    chainId: 1,
    name: 'Kava Lend',
    address: '0x1C700F95Df53fc31e83D89AC89e5DD778D4cD310',
    decimals: 6,
    symbol: 'HARD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7576.png',
  },
  {
    chainId: 1,
    name: 'Mars Network',
    address: '0xedd8da5c20eb014e550008df3304213dde5e29f0',
    decimals: 8,
    symbol: 'MARS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7579.png',
  },
  {
    chainId: 1,
    name: 'Goldblock',
    address: '0x3e522d144814bd6149c1f3e0c6cd19d0941372ac',
    decimals: 18,
    symbol: 'GBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7581.png',
  },
  {
    chainId: 1,
    name: 'Keep4r',
    address: '0xa89ac6e529acf391cfbbd377f3ac9d93eae9664e',
    decimals: 18,
    symbol: 'KP4R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7582.png',
  },
  {
    chainId: 1,
    name: 'Auric Network',
    address: '0x1c7bbadc81e18f7177a95eb1593e5f5f35861b10',
    decimals: 18,
    symbol: 'AUSCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7583.png',
  },
  {
    chainId: 1,
    name: 'SwapAll',
    address: '0xf6ed276a69270a895d6e419d99dcb5aaa2f3cb4a',
    decimals: 18,
    symbol: 'SAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7584.png',
  },
  {
    chainId: 1,
    name: 'Freeway Token',
    address: '0x20e7125677311Fca903A8897042b9983f22Ea295',
    decimals: 18,
    symbol: 'FWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7585.png',
  },
  {
    chainId: 1,
    name: 'UTU Protocol',
    address: '0xa58a4f5c4bb043d2cc1e170613b74e767c94189b',
    decimals: 18,
    symbol: 'UTU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7587.png',
  },
  {
    chainId: 1,
    name: 'Gameswap',
    address: '0xaac41ec512808d64625576eddd580e7ea40ef8b2',
    decimals: 18,
    symbol: 'GSWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7588.png',
  },
  {
    chainId: 1,
    name: 'Cryptochrome',
    address: '0x538a151dd910c1d1227719bd400d6c4f99ea06d0',
    decimals: 18,
    symbol: 'CHM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7589.png',
  },
  {
    chainId: 1,
    name: 'Dvision Network',
    address: '0x10633216e7e8281e33c86f02bf8e565a635d9770',
    decimals: 18,
    symbol: 'DVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7590.png',
  },
  {
    chainId: 1,
    name: 'Misbloc',
    address: '0x84c722e6f1363e8d5c6db3ea600bef9a006da824',
    decimals: 18,
    symbol: 'MSB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7591.png',
  },
  {
    chainId: 1,
    name: 'Pepedex',
    address: '0xf1f508c7c9f0d1b15a76fba564eef2d956220cf7',
    decimals: 18,
    symbol: 'PPDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7592.png',
  },
  {
    chainId: 1,
    name: 'DefiDollar DAO',
    address: '0x20c36f062a31865bED8a5B1e512D9a1A20AA333A',
    decimals: 18,
    symbol: 'DFD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7593.png',
  },
  {
    chainId: 1,
    name: 'Smoothy',
    address: '0xbF776e4FCa664D791C4Ee3A71e2722990E003283',
    decimals: 18,
    symbol: 'SMTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7594.png',
  },
  {
    chainId: 1,
    name: 'SERGS',
    address: '0x79BA92DDA26FcE15e1e9af47D5cFdFD2A093E000',
    decimals: 18,
    symbol: 'SERGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7595.png',
  },
  {
    chainId: 1,
    name: 'SmartCredit Token',
    address: '0x72e9d9038ce484ee986fea183f8d8df93f9ada13',
    decimals: 18,
    symbol: 'SMARTCREDIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7596.png',
  },
  {
    chainId: 1,
    name: 'CSP DAO',
    address: '0x7f0c8b125040f707441cad9e5ed8a8408673b455',
    decimals: 18,
    symbol: 'NEBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7597.png',
  },
  {
    chainId: 1,
    name: 'Tessla Coin',
    address: '0x110FE5f21C1EDd4F03a6e0DE0D96D0c2eED0B9CC',
    decimals: 18,
    symbol: 'TSLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7598.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Conceal',
    address: '0x21686F8ce003a95c99aCd297E302FAACf742F7d4',
    decimals: 18,
    symbol: 'WCCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7600.png',
  },
  {
    chainId: 1,
    name: 'zHEGIC',
    address: '0x837010619aeb2AE24141605aFC8f66577f6fb2e7',
    decimals: 18,
    symbol: 'ZHEGIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7601.png',
  },
  {
    chainId: 1,
    name: 'zLOT Finance',
    address: '0xA8e7AD77C60eE6f30BaC54E2E7c0617Bd7B5A03E',
    decimals: 18,
    symbol: 'ZLOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7602.png',
  },
  {
    chainId: 1,
    name: 'Jointer Ethereum',
    address: '0x1368452Bfb5Cd127971C8DE22C58fBE89D35A6BF',
    decimals: 18,
    symbol: 'JNTR/E',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7603.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Diamond',
    address: '0x1378eC93Ab2B07ba5A0eAEf19Cf354A33f64B9FD',
    decimals: 18,
    symbol: 'YFDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7604.png',
  },
  {
    chainId: 1,
    name: 'Morality',
    address: '0x4fd5b9b5dcc9a5d5931d007ba4ae573e760d9b64',
    decimals: 18,
    symbol: 'MO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7606.png',
  },
  {
    chainId: 1,
    name: 'Baroin',
    address: '0x4893a1938df49f4178c37e4e965cc8a1b3882173',
    decimals: 18,
    symbol: 'BRI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7607.png',
  },
  {
    chainId: 1,
    name: 'OLPORTAL',
    address: '0xeeaa34af95b034bada4baf565063132c765b1fa5',
    decimals: 18,
    symbol: 'OLCF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7608.png',
  },
  {
    chainId: 1,
    name: 'Zuplo',
    address: '0x94d8db14831c2c08943798542c450df2844913e5',
    decimals: 18,
    symbol: 'ZLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7611.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Bit2',
    address: '0x59e7b5db9be0bdd26fa048d39e01fee456ab674e',
    decimals: 18,
    symbol: 'YFB2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7612.png',
  },
  {
    chainId: 1,
    name: 'Yfi.mobi',
    address: '0x2e2f3246b6c65ccc4239c9ee556ec143a7e5de2c',
    decimals: 18,
    symbol: 'YFIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7613.png',
  },
  {
    chainId: 1,
    name: 'MTI Finance',
    address: '0x86d3f38edaf7e7959e5d8e6aea5ad3187b78c346',
    decimals: 18,
    symbol: 'MTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7615.png',
  },
  {
    chainId: 1,
    name: 'Lattice Token',
    address: '0xa393473d64d2F9F026B60b6Df7859A689715d092',
    decimals: 8,
    symbol: 'LTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7616.png',
  },
  {
    chainId: 1,
    name: 'saffron.finance',
    address: '0xb753428af26e81097e7fd17f40c88aaa3e04902c',
    decimals: 18,
    symbol: 'SFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7617.png',
  },
  {
    chainId: 1,
    name: 'Alpaca City',
    address: '0x7cA4408137eb639570F8E647d9bD7B7E8717514A',
    decimals: 18,
    symbol: 'ALPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7618.png',
  },
  {
    chainId: 1,
    name: 'Trade.win',
    address: '0xdad26bce7dcf59cd03a2455558e4dd73e1c07b66',
    decimals: 18,
    symbol: 'TWI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7620.png',
  },
  {
    chainId: 1,
    name: 'VROOMGO',
    address: '0x4861B1a0eAD261897174fD849cA0f5154fcF2442',
    decimals: 8,
    symbol: 'VRGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7621.png',
  },
  {
    chainId: 1,
    name: 'UBIX.Network',
    address: '0xf5b5efc906513b4344ebabcf47a04901f99f09f3',
    decimals: 18,
    symbol: 'UBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7622.png',
  },
  {
    chainId: 1,
    name: 'Libartysharetoken',
    address: '0x355376d6471e09a4ffca8790f50da625630c5270',
    decimals: 18,
    symbol: 'LST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7623.png',
  },
  {
    chainId: 1,
    name: 'GoldFinX',
    address: '0xbd434a09191d401da3283a5545bb3515d033b8c4',
    decimals: 18,
    symbol: 'G1X',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7624.png',
  },
  {
    chainId: 1,
    name: 'YFIII',
    address: '0x649eBF73043Ffcc70A59855ecd8a568FD996415a',
    decimals: 18,
    symbol: 'YFIII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7629.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Lightning',
    address: '0x54eFeC15D08428C7Ba31f8F085D4860EE6e38313',
    decimals: 18,
    symbol: 'ETLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7630.png',
  },
  {
    chainId: 1,
    name: 'FRMx Token',
    address: '0xf6832ea221ebfdc2363729721a146e6745354b14',
    decimals: 18,
    symbol: 'FRMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7631.png',
  },
  {
    chainId: 1,
    name: 'Rake Finance',
    address: '0xa8b0f154a688c22142e361707df64277e0a0be66',
    decimals: 18,
    symbol: 'RAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7632.png',
  },
  {
    chainId: 1,
    name: 'wormhole.finance',
    address: '0xe6179bb571d2d69837be731da88c76e377ec4738',
    decimals: 18,
    symbol: 'WHOLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7633.png',
  },
  {
    chainId: 1,
    name: 'Future-Cash Digital',
    address: '0x74db83feba1574fec860413eb509d1ddfb1b730b',
    decimals: 18,
    symbol: 'FCD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7640.png',
  },
  {
    chainId: 1,
    name: 'Medicalveda',
    address: '0xCBe7142F5c16755D8683BA329EFA1ABF7b54482d',
    decimals: 8,
    symbol: 'MVEDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7641.png',
  },
  {
    chainId: 1,
    name: 'BitDEFi',
    address: '0x2b2b0559081c41e962777B5049632fdb30f7E652',
    decimals: 8,
    symbol: 'BFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7642.png',
  },
  {
    chainId: 1,
    name: 'Nyan V2',
    address: '0xbf4a9a37ecfc21825011285222c36ab35de51f14',
    decimals: 18,
    symbol: 'NYAN-2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7643.png',
  },
  {
    chainId: 1,
    name: 'WadzPay Token',
    address: '0x4cff49d0a19ed6ff845a9122fa912abcfb1f68a6',
    decimals: 18,
    symbol: 'WTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7645.png',
  },
  {
    chainId: 1,
    name: 'noob.finance',
    address: '0x1fc05d480b1ef1175a31123bfdbd36bfee256889',
    decimals: 18,
    symbol: '$NOOB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7646.png',
  },
  {
    chainId: 1,
    name: 'Azuki',
    address: '0x910524678C0B1B23FFB9285a81f99C29C11CBaEd',
    decimals: 18,
    symbol: 'AZUKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7647.png',
  },
  {
    chainId: 1,
    name: 'XFII',
    address: '0x1fa21b20222076d7465fb901e5f459289c95f66a',
    decimals: 18,
    symbol: 'XFII',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7648.png',
  },
  {
    chainId: 1,
    name: 'pulltherug.finance',
    address: '0xedfbd6c48c3ddff5612ade14b45bb19f916809ba',
    decimals: 18,
    symbol: 'RUGZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7649.png',
  },
  {
    chainId: 1,
    name: 'LIQUID',
    address: '0x72ca0501427bb8f089c1c4f767cb17d017e803a9',
    decimals: 18,
    symbol: 'LIQUID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7650.png',
  },
  {
    chainId: 1,
    name: 'Oasis',
    address: '0x26B80FBfC01b71495f477d5237071242e0d959d7',
    decimals: 18,
    symbol: 'ROSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7653.png',
  },
  {
    chainId: 1,
    name: 'RFOX',
    address: '0xa1d6df714f91debf4e0802a542e13067f31b8262',
    decimals: 18,
    symbol: 'RFOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7654.png',
  },
  {
    chainId: 1,
    name: 'Mercurity Swap Protocol',
    address: '0xe1b583dc66e0a24fd9af2dc665f6f5e48978e106',
    decimals: 18,
    symbol: 'MEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7656.png',
  },
  {
    chainId: 1,
    name: 'BAEPAY',
    address: '0x6bffa07a1b0cebc474ce6833eaf2be6326252449',
    decimals: 4,
    symbol: 'BAEPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7657.png',
  },
  {
    chainId: 1,
    name: 'Business Platform Tomato Coin',
    address: '0x05237e2bd2dfab39a135d254cabae94b183c8bad',
    decimals: 8,
    symbol: 'BPTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7660.png',
  },
  {
    chainId: 1,
    name: 'GYSR',
    address: '0xbea98c05eeae2f3bc8c3565db7551eb738c8ccab',
    decimals: 18,
    symbol: 'GYSR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7661.png',
  },
  {
    chainId: 1,
    name: 'UNCX Network',
    address: '0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0',
    decimals: 18,
    symbol: 'UNCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7664.png',
  },
  {
    chainId: 1,
    name: 'Pokeswap',
    address: '0x56831a7b5e61d6453c203cb22b7a89e016b05ecb',
    decimals: 18,
    symbol: 'BALLS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7666.png',
  },
  {
    chainId: 1,
    name: 'Liquid Lottery RTC',
    address: '0x59AD6061A0be82155E7aCcE9F0C37Bf59F9c1e3C',
    decimals: 18,
    symbol: 'LIQLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7667.png',
  },
  {
    chainId: 1,
    name: 'UNCL',
    address: '0x2f4eb47a1b1f4488c71fc10e39a4aa56af33dd49',
    decimals: 18,
    symbol: 'UNCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7669.png',
  },
  {
    chainId: 1,
    name: 'Blueshare Token',
    address: '0x336492A0601CC85e08C14D390BF07d960328aaf4',
    decimals: 18,
    symbol: 'BST1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7670.png',
  },
  {
    chainId: 1,
    name: 'SEEN',
    address: '0xCa3FE04C7Ee111F0bbb02C328c699226aCf9Fd33',
    decimals: 18,
    symbol: 'SEEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7671.png',
  },
  {
    chainId: 1,
    name: 'Unifi Protocol DAO',
    address: '0x441761326490cacf7af299725b6292597ee822c2',
    decimals: 18,
    symbol: 'UNFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7672.png',
  },
  {
    chainId: 1,
    name: 'ANSWER Governance',
    address: '0xd1420AF453Fd7bf940573431D416cAcE7fF8280c',
    decimals: 18,
    symbol: 'AGOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7673.png',
  },
  {
    chainId: 1,
    name: 'Volts.Finance',
    address: '0x14d1c83df4decee9deb14ee851f109f0101a6631',
    decimals: 18,
    symbol: 'VOLTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7674.png',
  },
  {
    chainId: 1,
    name: 'Interest Bearing ETH',
    address: '0x67B66C99D3Eb37Fa76Aa3Ed1ff33E8e39F0b9c7A',
    decimals: 18,
    symbol: 'ibETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7675.png',
  },
  {
    chainId: 1,
    name: 'ReapChain',
    address: '0x1fc5ef0337aea85c5f9198853a6e3a579a7a6987',
    decimals: 18,
    symbol: 'REAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7677.png',
  },
  {
    chainId: 1,
    name: 'Rook',
    address: '0xfa5047c9c78b8877af97bdcb85db743fd7313d4a',
    decimals: 18,
    symbol: 'ROOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7678.png',
  },
  {
    chainId: 1,
    name: 'Dtube Coin',
    address: '0xd2be3722B17b616c51ed9B8944A227D1ce579C24',
    decimals: 2,
    symbol: 'DTUBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7679.png',
  },
  {
    chainId: 1,
    name: 'Sav3Token',
    address: '0x6e10aacb89a28d6fa0fe68790777fec7e7f01890',
    decimals: 18,
    symbol: 'SAV3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7680.png',
  },
  {
    chainId: 1,
    name: 'Boboo Token',
    address: '0x0602121722642936150f12ea1e07d62a8bb2aa71',
    decimals: 18,
    symbol: 'BOBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7683.png',
  },
  {
    chainId: 1,
    name: 'ORO',
    address: '0xc3Eb2622190c57429aac3901808994443b64B466',
    decimals: 18,
    symbol: 'ORO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7684.png',
  },
  {
    chainId: 1,
    name: 'Hugeswap Defi Tracking',
    address: '0x33cf48debdcf255b689a7b1d6be5661ec832cc30',
    decimals: 2,
    symbol: 'HUSWP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7685.png',
  },
  {
    chainId: 1,
    name: 'Folder Protocol',
    address: '0xa8580f3363684d76055bdc6660caefe8709744e1',
    decimals: 18,
    symbol: 'FOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7687.png',
  },
  {
    chainId: 1,
    name: 'SOMIDAX',
    address: '0x7e8539d1e5cb91d63e46b8e188403b3f262a949b',
    decimals: 18,
    symbol: 'SMDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7688.png',
  },
  {
    chainId: 1,
    name: 'Your Finance Decentralized',
    address: '0x4f4f0ef7978737ce928bff395529161b44e27ad9',
    decimals: 18,
    symbol: 'YFD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7690.png',
  },
  {
    chainId: 1,
    name: 'e-Radix',
    address: '0x6468e79A80C0eaB0F9A2B574c8d5bC374Af59414',
    decimals: 18,
    symbol: 'EXRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7692.png',
  },
  {
    chainId: 1,
    name: 'Anonyme',
    address: '0x2dcb6f84cc76a888aed21efc86ac7492879866c3',
    decimals: 18,
    symbol: 'ANON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7693.png',
  },
  {
    chainId: 1,
    name: 'Governor DAO',
    address: '0x515d7e9d75e2b76db60f8a051cd890eba23286bc',
    decimals: 18,
    symbol: 'GDAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7694.png',
  },
  {
    chainId: 1,
    name: 'Kanva',
    address: '0x5935ffc231e93ac04daa089c0f1b94d0fb2449de',
    decimals: 8,
    symbol: 'KNV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7695.png',
  },
  {
    chainId: 1,
    name: 'Experty Wisdom Token',
    address: '0xDecade1c6Bf2cD9fb89aFad73e4a519C867adcF5',
    decimals: 18,
    symbol: 'WIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7697.png',
  },
  {
    chainId: 1,
    name: 'CorionX',
    address: '0x26a604DFFE3ddaB3BEE816097F81d3C4a2A4CF97',
    decimals: 18,
    symbol: 'CORX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7698.png',
  },
  {
    chainId: 1,
    name: 'CyberFi Token',
    address: '0x63b4f3e3fa4e438698ce330e365e831f7ccd1ef4',
    decimals: 18,
    symbol: 'CFi',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7699.png',
  },
  {
    chainId: 1,
    name: 'SUP8EME',
    address: '0x47935Edfb3CDd358C50F6c0Add1Cc24662e30F5f',
    decimals: 6,
    symbol: 'SUP8EME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7701.png',
  },
  {
    chainId: 1,
    name: 'MileVerse',
    address: '0x581911b360B6eB3a14eF295a83a91DC2bCE2D6f7',
    decimals: 18,
    symbol: 'MVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7703.png',
  },
  {
    chainId: 1,
    name: 'Mining Core Coin',
    address: '0xaa625d0f31e99dcd1e9ff744073a9d16ce174de4',
    decimals: 18,
    symbol: 'MCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7704.png',
  },
  {
    chainId: 1,
    name: 'ANIVERSE',
    address: '0x3D382228C54736d831FAC2748F4734D9177c7332',
    decimals: 18,
    symbol: 'ANV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7705.png',
  },
  {
    chainId: 1,
    name: 'Compounder',
    address: '0x7ef1081ecc8b5b5b130656a41d4ce4f89dbbcc8c',
    decimals: 18,
    symbol: 'CP3R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7706.png',
  },
  {
    chainId: 1,
    name: 'Fromm Car',
    address: '0x8615BA28D7D66Aef9069119B5F27653ef05eb574',
    decimals: 18,
    symbol: 'FCR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7707.png',
  },
  {
    chainId: 1,
    name: 'YUI Token',
    address: '0x4c10bd19688b906665fbd53415f279f34b44ece7',
    decimals: 18,
    symbol: 'YUI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7709.png',
  },
  {
    chainId: 1,
    name: 'Aworld',
    address: '0x634a7272021ac2d42586dcc00187d82c6f34f110',
    decimals: 4,
    symbol: 'AWO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7711.png',
  },
  {
    chainId: 1,
    name: 'Freedom Reserve',
    address: '0xc626e0619ac79afea9281c8eb9b1a9f9d3fab532',
    decimals: 18,
    symbol: 'FR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7712.png',
  },
  {
    chainId: 1,
    name: 'Order of the Black Rose',
    address: '0x595643d83b35df38e29058976c04000acfa31570',
    decimals: 18,
    symbol: 'OBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7713.png',
  },
  {
    chainId: 1,
    name: 'swiss.finance',
    address: '0x692eb773e0b5b7a79efac5a015c8b36a2577f65c',
    decimals: 18,
    symbol: 'SWISS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7714.png',
  },
  {
    chainId: 1,
    name: 'Earnbase',
    address: '0xa6fb1df483b24eeab569e19447e0e107003b9e15',
    decimals: 18,
    symbol: 'ENB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7716.png',
  },
  {
    chainId: 1,
    name: 'DefHold',
    address: '0xe481f2311c774564d517d015e678c2736a25ddd3',
    decimals: 18,
    symbol: 'DEFO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7720.png',
  },
  {
    chainId: 1,
    name: 'Chemix Ecology Governance Token',
    address: '0x65d9bC970aA9B2413027fA339F7f179B3F3f2604',
    decimals: 18,
    symbol: 'KUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7721.png',
  },
  {
    chainId: 1,
    name: 'QUSD',
    address: '0x59d4CCC94A9C4C3d3b4bA2Aa343a9bDF95145DD1',
    decimals: 18,
    symbol: 'QUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7722.png',
  },
  {
    chainId: 1,
    name: 'Itchiro Games',
    address: '0x21cf09BC065082478Dcc9ccB5fd215A978Dc8d86',
    decimals: 18,
    symbol: 'JEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7723.png',
  },
  {
    chainId: 1,
    name: 'TrueFi',
    address: '0x4c19596f5aaff459fa38b0f7ed92f11ae6543784',
    decimals: 8,
    symbol: 'TRU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7725.png',
  },
  {
    chainId: 1,
    name: 'ICHI',
    address: '0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6',
    decimals: 18,
    symbol: 'ICHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7726.png',
  },
  {
    chainId: 1,
    name: 'UniWhales',
    address: '0xdbdd6f355a37b94e6c7d32fef548e98a280b8df5',
    decimals: 18,
    symbol: 'UWL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7727.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Value',
    address: '0x519083fc539f23131c3b7046992584592772d12a',
    decimals: 18,
    symbol: 'YFIV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7729.png',
  },
  {
    chainId: 1,
    name: 'Defiance',
    address: '0x90e6E082B0aa4bf6AFBA0d11163d920A534EBae4',
    decimals: 18,
    symbol: 'DEF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7731.png',
  },
  {
    chainId: 1,
    name: 'Brother Music Platform',
    address: '0x01b23286ff60a543ec29366ae8d6b6274ca20541',
    decimals: 18,
    symbol: 'BMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7732.png',
  },
  {
    chainId: 1,
    name: 'Light Coin Exchange Token',
    address: '0x34770f06Ae8a9A7b44fd8D636Af6a3fEC2A58b98',
    decimals: 18,
    symbol: 'LCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7733.png',
  },
  {
    chainId: 1,
    name: 'TOM Finance',
    address: '0xf7970499814654cd13cb7b6e7634a12a7a8a9abc',
    decimals: 18,
    symbol: 'TOM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7734.png',
  },
  {
    chainId: 1,
    name: 'Yuan',
    address: '0x4A3e164684812DfB684AC36457E7fA805087c68E',
    decimals: 18,
    symbol: 'YUAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7735.png',
  },
  {
    chainId: 1,
    name: 'Yearnspace',
    address: '0x93a8b61c4707efE76A88caE8dc226D9bf77e9405',
    decimals: 18,
    symbol: 'YFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7736.png',
  },
  {
    chainId: 1,
    name: 'API3',
    address: '0x0b38210ea11411557c13457D4dA7dC6ea731B88a',
    decimals: 18,
    symbol: 'API3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7737.png',
  },
  {
    chainId: 1,
    name: 'DexKit',
    address: '0x7866e48c74cbfb8183cd1a929cd9b95a7a5cb4f4',
    decimals: 18,
    symbol: 'KIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7739.png',
  },
  {
    chainId: 1,
    name: 'Polaris Share',
    address: '0xc691bc298a304d591Ad9b352c7A8D216dE9f2CED',
    decimals: 18,
    symbol: 'POLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7740.png',
  },
  {
    chainId: 1,
    name: 'UnoSwap',
    address: '0xd18A8abED9274eDBEace4B12D86A8633283435Da',
    decimals: 18,
    symbol: 'UNOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7741.png',
  },
  {
    chainId: 1,
    name: '88mph',
    address: '0x8888801af4d980682e47f1a9036e589479e835c5',
    decimals: 18,
    symbol: 'MPH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7742.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Yield',
    address: '0xd1AFBCCC9A2c2187ea544363B986EA0AB6EF08B5',
    decimals: 18,
    symbol: 'ETHY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7743.png',
  },
  {
    chainId: 1,
    name: 'reflect.finance',
    address: '0xa1afffe3f4d611d252010e3eaf6f4d77088b0cd7',
    decimals: 9,
    symbol: 'RFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7747.png',
  },
  {
    chainId: 1,
    name: 'Paypolitan Token',
    address: '0x72630b1e3b42874bf335020ba0249e3e9e47bafc',
    decimals: 18,
    symbol: 'EPAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7749.png',
  },
  {
    chainId: 1,
    name: 'Eden',
    address: '0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559',
    decimals: 18,
    symbol: 'EDEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7750.png',
  },
  {
    chainId: 1,
    name: 'KP2R.Network',
    address: '0x9bde098be22658d057c3f1f185e3fd4653e2fbd1',
    decimals: 18,
    symbol: 'KP2R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7751.png',
  },
  {
    chainId: 1,
    name: 'LibreFreelencer',
    address: '0x449efe48ad7cd423bab056276639f8120cd4f9a3',
    decimals: 18,
    symbol: 'LIBREF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7752.png',
  },
  {
    chainId: 1,
    name: 'BIOKKOIN',
    address: '0x8AF22fBDeFe01b4dC7960EC04Ec73e8502F4a6B0',
    decimals: 8,
    symbol: 'BKKG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7753.png',
  },
  {
    chainId: 1,
    name: 'CitySwap',
    address: '0xf27dc1f57f8c8f57ab7dbbb25ce1747fcb542100',
    decimals: 18,
    symbol: 'CITY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7754.png',
  },
  {
    chainId: 1,
    name: 'Handy',
    address: '0x8bbe1a2961B41340468D0548c2cd5B7DFA9b684c',
    decimals: 18,
    symbol: 'HANDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7755.png',
  },
  {
    chainId: 1,
    name: 'oBTC',
    address: '0x8064d9ae6cdf087b1bcd5bdf3531bd5d8c537a68',
    decimals: 18,
    symbol: 'OBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7756.png',
  },
  {
    chainId: 1,
    name: 'Eauric',
    address: '0xc36c65693ea9e207ad35d4ee2fb6c5f6f43bdec8',
    decimals: 18,
    symbol: 'EAURIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7758.png',
  },
  {
    chainId: 1,
    name: 'Lock3r Network',
    address: '0xe3f3869ddd41c23eff3630f58e5bfa584c770d67',
    decimals: 18,
    symbol: 'LK3R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7759.png',
  },
  {
    chainId: 1,
    name: 'Komet',
    address: '0x6cfb6df56bbdb00226aeffcdb2cd1fe8da1abda7',
    decimals: 18,
    symbol: 'KOMET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7760.png',
  },
  {
    chainId: 1,
    name: 'BuildUp',
    address: '0xB04DFdb8271ed2d5e13858562C44A77D3CEb9e57',
    decimals: 18,
    symbol: 'BUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7761.png',
  },
  {
    chainId: 1,
    name: 'Simbcoin Swap',
    address: '0x53bd789f2cdb846b227d8ffc7b46ed4263231fdf',
    decimals: 18,
    symbol: 'SMBSWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7764.png',
  },
  {
    chainId: 1,
    name: 'Benchmark Protocol',
    address: '0x67c597624b17b16fb77959217360b7cd18284253',
    decimals: 18,
    symbol: 'MARK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7765.png',
  },
  {
    chainId: 1,
    name: 'Divert Finance',
    address: '0xfdb615d6a15f929ddabc6b83a4f1cf9d361b064e',
    decimals: 18,
    symbol: 'DEVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7766.png',
  },
  {
    chainId: 1,
    name: 'Wrapped ZEC',
    address: '0x4A64515E5E1d1073e83f30cB97BEd20400b66E10',
    decimals: 18,
    symbol: 'WZEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7767.png',
  },
  {
    chainId: 1,
    name: 'TheOvOrideA',
    address: '0x96dd2c778fb281294fa9c1d2b8af3b47369306f2',
    decimals: 18,
    symbol: 'OVOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7768.png',
  },
  {
    chainId: 1,
    name: 'Sancoj',
    address: '0x03ec7bb59be036870ef696a2abf124f496d6735a',
    decimals: 18,
    symbol: 'SANC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7769.png',
  },
  {
    chainId: 1,
    name: 'HoldToWin',
    address: '0xEd36482c7F8E5850e91aC0Cf6BF2130A1aA2DF92',
    decimals: 18,
    symbol: '7ADD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7771.png',
  },
  {
    chainId: 1,
    name: 'Leverj Gluon',
    address: '0xBbff34E47E559ef680067a6B1c980639EEb64D24',
    decimals: 18,
    symbol: 'L2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7772.png',
  },
  {
    chainId: 1,
    name: 'Prophet',
    address: '0x8d5db0c1f0681071cb38a382ae6704588d9da587',
    decimals: 9,
    symbol: 'PROPHET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7773.png',
  },
  {
    chainId: 1,
    name: 'Tradebitpay',
    address: '0x2bfAf3598Ee675aF548F2A772488bA5c8946C419',
    decimals: 18,
    symbol: 'TBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7777.png',
  },
  {
    chainId: 1,
    name: 'Metis',
    address: '0xa9598333b99d14d90bc81cad8af82c4c70625e75',
    decimals: 18,
    symbol: 'MTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7778.png',
  },
  {
    chainId: 1,
    name: 'XPToken.io',
    address: '0xf0814d0E47F2390a8082C4a1BD819FDDe50f9bFc',
    decimals: 8,
    symbol: 'XPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7779.png',
  },
  {
    chainId: 1,
    name: 'B2U Coin',
    address: '0x350758e4a1256561fd0ee142dc7e0545f561fadc',
    decimals: 18,
    symbol: 'B2U',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7780.png',
  },
  {
    chainId: 1,
    name: 'LeLeFoodChain',
    address: '0x1b6e4b5ad639efd5733f37f7af22fbe86718c5d8',
    decimals: 18,
    symbol: 'LELE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7781.png',
  },
  {
    chainId: 1,
    name: 'Ethanol',
    address: '0x63D0eEa1D7C0d1e89d7e665708d7e8997C0a9eD6',
    decimals: 18,
    symbol: 'ENOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7782.png',
  },
  {
    chainId: 1,
    name: 'Open Governance Token',
    address: '0x69e8b9528CABDA89fe846C67675B5D73d463a916',
    decimals: 18,
    symbol: 'OPEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7783.png',
  },
  {
    chainId: 1,
    name: 'BundlesBets',
    address: '0x8D3E855f3f55109D473735aB76F753218400fe96',
    decimals: 18,
    symbol: 'BUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7785.png',
  },
  {
    chainId: 1,
    name: 'Yearn Loans Finance',
    address: '0x186af393bf9ceef31ce7eae2b468c46231163cc7',
    decimals: 18,
    symbol: 'YLFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7788.png',
  },
  {
    chainId: 1,
    name: 'Upayment',
    address: '0x795b74b4f69b8f810cf01db284582f75276f3196',
    decimals: 8,
    symbol: 'UPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7792.png',
  },
  {
    chainId: 1,
    name: 'YFI3.money',
    address: '0x09843b9137fc5935b7f3832152f9074db5d2d1ee',
    decimals: 18,
    symbol: 'YFI3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7794.png',
  },
  {
    chainId: 1,
    name: 'Bird.Money',
    address: '0x70401dfd142a16dc7031c56e862fc88cb9537ce0',
    decimals: 18,
    symbol: 'BIRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7795.png',
  },
  {
    chainId: 1,
    name: 'COIN',
    address: '0xe61fdaf474fac07063f2234fb9e60c1163cfa850',
    decimals: 18,
    symbol: '$COIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7796.png',
  },
  {
    chainId: 1,
    name: 'Power Core',
    address: '0x2b6b4030ffae7d710840dcc9ce47788971574851',
    decimals: 18,
    symbol: 'POW3R',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7799.png',
  },
  {
    chainId: 1,
    name: 'AllWin DeFi',
    address: '0xc6358c02a4bafcbcd85360ae046e6bee556429c1',
    decimals: 6,
    symbol: 'ALLWIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7800.png',
  },
  {
    chainId: 1,
    name: 'HRDCOIN',
    address: '0xf8834E39FDf20ACcC5BDBB017B92e20eBeCc9fB2',
    decimals: 2,
    symbol: 'HRD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7801.png',
  },
  {
    chainId: 1,
    name: 'Bitpumps Token',
    address: '0xa44d9f50b0decb13713fc5f0df44b4eb5fb300ca',
    decimals: 18,
    symbol: 'BPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7802.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Stake',
    address: '0xd0d3ebcad6a20ce69bc3bc0e1ec964075425e533',
    decimals: 18,
    symbol: 'ETHYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7803.png',
  },
  {
    chainId: 1,
    name: 'Muse',
    address: '0xb6ca7399b4f9ca56fc27cbff44f4d2e4eef1fc81',
    decimals: 18,
    symbol: 'MUSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7805.png',
  },
  {
    chainId: 1,
    name: 'Cornichon',
    address: '0xa456b515303b2ce344e9d2601f91270f8c2fea5e',
    decimals: 18,
    symbol: 'CORN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7806.png',
  },
  {
    chainId: 1,
    name: 'UniMex',
    address: '0x27af23d8db2a3fbce7d04e84f594285fb0059316',
    decimals: 18,
    symbol: 'UMEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7807.png',
  },
  {
    chainId: 1,
    name: 'Cobwebfinance',
    address: '0x93B5CdC9513fB62F139A34dDD6C9a31E4317a236',
    decimals: 18,
    symbol: 'COB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7808.png',
  },
  {
    chainId: 1,
    name: 'STVKE',
    address: '0x226e390751a2e22449d611bac83bd267f2a2caff',
    decimals: 18,
    symbol: 'STV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7810.png',
  },
  {
    chainId: 1,
    name: 'Bullswap Exchange',
    address: '0xe7d324B2677440608fb871981B220ECa062c3FbF',
    decimals: 18,
    symbol: 'BVL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7811.png',
  },
  {
    chainId: 1,
    name: 'SYNC Network',
    address: '0xB6ff96B8A8d214544Ca0dBc9B33f7AD6503eFD32',
    decimals: 18,
    symbol: 'SYNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7812.png',
  },
  {
    chainId: 1,
    name: 'Basis Cash',
    address: '0x3449FC1Cd036255BA1EB19d65fF4BA2b8903A69a',
    decimals: 18,
    symbol: 'BAC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7813.png',
  },
  {
    chainId: 1,
    name: 'DefiCliq',
    address: '0x0Def8d8addE14c9eF7c2a986dF3eA4Bd65826767',
    decimals: 18,
    symbol: 'CLIQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7815.png',
  },
  {
    chainId: 1,
    name: 'Basis Share',
    address: '0x106538CC16F938776c7c180186975BCA23875287',
    decimals: 18,
    symbol: 'BAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7816.png',
  },
  {
    chainId: 1,
    name: 'Bifrost',
    address: '0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c',
    decimals: 18,
    symbol: 'BFC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7817.png',
  },
  {
    chainId: 1,
    name: 'Wrapped CrescoFin',
    address: '0xa0afaa285ce85974c3c881256cb7f225e3a1178a',
    decimals: 18,
    symbol: 'wCRES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7818.png',
  },
  {
    chainId: 1,
    name: 'Unicap.finance',
    address: '0xbaA70614C7AAfB568a93E62a98D55696bcc85DFE',
    decimals: 18,
    symbol: 'UCAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7819.png',
  },
  {
    chainId: 1,
    name: 'Royale Finance',
    address: '0x7eaf9c89037e4814dc0d9952ac7f888c784548db',
    decimals: 18,
    symbol: 'ROYA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7821.png',
  },
  {
    chainId: 1,
    name: 'Q DeFi Governance Token v2.0',
    address: '0xfee4DBe2751bF8d1B1B861aAF9664961F19Ce91A',
    decimals: 18,
    symbol: 'QDEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7825.png',
  },
  {
    chainId: 1,
    name: 'Zoracles',
    address: '0xD8E3FB3b08eBA982F2754988d70D57eDc0055ae6',
    decimals: 9,
    symbol: 'ZORA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7826.png',
  },
  {
    chainId: 1,
    name: 'PCASH',
    address: '0xc6b771a5998da05e60fc6d42c5248947235ee0fb',
    decimals: 8,
    symbol: 'PCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7827.png',
  },
  {
    chainId: 1,
    name: 'REALPAY',
    address: '0xb23d94fabded02556910ceeb68fe998d66d5822a',
    decimals: 18,
    symbol: 'RAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7832.png',
  },
  {
    chainId: 1,
    name: 'PiSwap Token',
    address: '0xce1298ef635326d9f197963e49e1e67422761897',
    decimals: 8,
    symbol: 'PIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7833.png',
  },
  {
    chainId: 1,
    name: 'PAYZUS',
    address: '0x86690e2613be52EE927d395dB87f69EBCdf88f27',
    decimals: 18,
    symbol: 'PZS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7836.png',
  },
  {
    chainId: 1,
    name: 'Apple Finance',
    address: '0x69275aC5477F3A9DC051180BC559140Bc647F8E9',
    decimals: 18,
    symbol: 'APLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7837.png',
  },
  {
    chainId: 1,
    name: 'Base Protocol',
    address: '0x07150e919b4de5fd6a63de1f9384828396f25fdc',
    decimals: 9,
    symbol: 'BASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7838.png',
  },
  {
    chainId: 1,
    name: 'Degov',
    address: '0x469E66e06fEc34839E5eB1273ba85A119B8D702F',
    decimals: 18,
    symbol: 'DEGOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7839.png',
  },
  {
    chainId: 1,
    name: 'Idle',
    address: '0x875773784Af8135eA0ef43b5a374AaD105c5D39e',
    decimals: 18,
    symbol: 'IDLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7841.png',
  },
  {
    chainId: 1,
    name: 'Multiswap protocol',
    address: '0x929c60295b8ac2e5cbbe8160fa7027c610111146',
    decimals: 18,
    symbol: 'MSWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7842.png',
  },
  {
    chainId: 1,
    name: 'BitOfTrade',
    address: '0x02044C9d2Da3fd33eD800716693396eEEcEEf918',
    decimals: 18,
    symbol: 'BTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7845.png',
  },
  {
    chainId: 1,
    name: 'Unbound',
    address: '0x8dB253a1943DdDf1AF9bcF8706ac9A0Ce939d922',
    decimals: 18,
    symbol: 'UNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7846.png',
  },
  {
    chainId: 1,
    name: 'Unbound Dollar',
    address: '0x0C0F2b41F758d66bB8e694693B0f9e6FaE726499',
    decimals: 18,
    symbol: 'UND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7848.png',
  },
  {
    chainId: 1,
    name: 'PoolStake',
    address: '0x3f84c4184b35c488f7fe4a12469610c9b1cb03c9',
    decimals: 18,
    symbol: 'PSK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7850.png',
  },
  {
    chainId: 1,
    name: 'Adventure Token',
    address: '0xa2ef2757d2ed560c9e3758d1946d7bcccbd5a7fe',
    decimals: 18,
    symbol: 'TWA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7851.png',
  },
  {
    chainId: 1,
    name: 'IterationSyndicate',
    address: '0xc32cc5b70bee4bd54aa62b9aefb91346d18821c4',
    decimals: 18,
    symbol: 'ITS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7852.png',
  },
  {
    chainId: 1,
    name: 'Tro.Network',
    address: '0x3c7a68fb66e7a4a46b6925662818c08ee8ff4d8d',
    decimals: 18,
    symbol: 'TRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7853.png',
  },
  {
    chainId: 1,
    name: 'ACDX Exchange Governance Token',
    address: '0x7be00ed6796b21656732e8f739fc1b8f1c53da0d',
    decimals: 18,
    symbol: 'ACXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7854.png',
  },
  {
    chainId: 1,
    name: 'Gold Coin Reserve',
    address: '0x37F6F8eb409DEB9fEAf032c109A72319F665C79D',
    decimals: 18,
    symbol: 'GCR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7855.png',
  },
  {
    chainId: 1,
    name: 'Greenheart Punt',
    address: '0x6f3Bb1fEBc415183Dec801D78B1F92eDa200Fe3E',
    decimals: 18,
    symbol: 'PUNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7856.png',
  },
  {
    chainId: 1,
    name: 'Mirror Protocol',
    address: '0x09a3EcAFa817268f77BE1283176B946C4ff2E608',
    decimals: 18,
    symbol: 'MIR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7857.png',
  },
  {
    chainId: 1,
    name: 'Badger DAO',
    address: '0x3472a5a71965499acd81997a54bba8d852c6e53d',
    decimals: 18,
    symbol: 'BADGER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7859.png',
  },
  {
    chainId: 1,
    name: 'ClinTex CTi',
    address: '0xcB8fb2438A805664cD8c3e640b85AC473DA5BE87',
    decimals: 18,
    symbol: 'CTI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7860.png',
  },
  {
    chainId: 1,
    name: 'YearnAgnostic Finance',
    address: '0xd40adfF097E3cde2b96D81A4727F3E47093F3405',
    decimals: 18,
    symbol: 'YFIAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7862.png',
  },
  {
    chainId: 1,
    name: 'DGPayment',
    address: '0x927159670C50042109d7C0f4aEd0Cee89452433E',
    decimals: 18,
    symbol: 'DGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7864.png',
  },
  {
    chainId: 1,
    name: 'WaterDrop',
    address: '0xd61b60ccbdaf09c2e036c72734adb3270ed27192',
    decimals: 18,
    symbol: 'WDP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7865.png',
  },
  {
    chainId: 1,
    name: 'Monavale',
    address: '0x275f5Ad03be0Fa221B4C6649B8AeE09a42D9412A',
    decimals: 18,
    symbol: 'MONA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7866.png',
  },
  {
    chainId: 1,
    name: 'Plasma Finance',
    address: '0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2',
    decimals: 18,
    symbol: 'PPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7870.png',
  },
  {
    chainId: 1,
    name: 'Relayer Network',
    address: '0x5b3F693EfD5710106eb2Eac839368364aCB5a70f',
    decimals: 18,
    symbol: 'RLR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7873.png',
  },
  {
    chainId: 1,
    name: 'PieDAO DEFI++',
    address: '0x8d1ce361eb68e9e05573443c407d4a3bed23b033',
    decimals: 18,
    symbol: 'DEFI++',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7874.png',
  },
  {
    chainId: 1,
    name: 'MM Token',
    address: '0xa283aa7cfbb27ef0cfbcb2493dd9f4330e0fd304',
    decimals: 18,
    symbol: 'MM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7875.png',
  },
  {
    chainId: 1,
    name: 'SORA Validator Token',
    address: '0xe88f8313e61a97cec1871ee37fbbe2a8bf3ed1e4',
    decimals: 18,
    symbol: 'VAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7876.png',
  },
  {
    chainId: 1,
    name: 'Debase',
    address: '0x9248c485b0b80f76da451f167a8db30f33c70907',
    decimals: 18,
    symbol: 'DEBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7877.png',
  },
  {
    chainId: 1,
    name: 'Unifty',
    address: '0x7e291890b01e5181f7ecc98d79ffbe12ad23df9e',
    decimals: 18,
    symbol: 'NIF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7879.png',
  },
  {
    chainId: 1,
    name: 'YFIDapp',
    address: '0x61266424B904d65cEb2945a1413Ac322185187D5',
    decimals: 18,
    symbol: 'YFID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7880.png',
  },
  {
    chainId: 1,
    name: 'Efforce',
    address: '0x34950ff2b487d9e5282c5ab342d08a2f712eb79f',
    decimals: 18,
    symbol: 'WOZX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7882.png',
  },
  {
    chainId: 1,
    name: 'WELL',
    address: '0x1b06B43f3b0bBAd73784d858c782e029F3F5Af14',
    decimals: 18,
    symbol: 'WELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7883.png',
  },
  {
    chainId: 1,
    name: 'Elite Swap',
    address: '0x380291a9a8593b39f123cf39cc1cc47463330b1f',
    decimals: 18,
    symbol: 'ELT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7884.png',
  },
  {
    chainId: 1,
    name: 'Katalyo',
    address: '0x24E3794605C84E580EEA4972738D633E8a7127c8',
    decimals: 18,
    symbol: 'KTLYO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7885.png',
  },
  {
    chainId: 1,
    name: 'Glox Finance',
    address: '0x0222bE1F1B8413b2d7d76EBfC9e0285C1300692f',
    decimals: 18,
    symbol: 'GLOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7886.png',
  },
  {
    chainId: 1,
    name: 'WAV3',
    address: '0x14c38e90a593b0bd5b7e9896a8ef4ae0a119d6ae',
    decimals: 18,
    symbol: 'WAV3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7904.png',
  },
  {
    chainId: 1,
    name: 'Groovy Finance',
    address: '0x31be30217989766215672e88ed449913e05bf0f5',
    decimals: 18,
    symbol: 'GVY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7905.png',
  },
  {
    chainId: 1,
    name: 'Elynet',
    address: '0x881a7E25D44591C467a37Da96adf3c3705E7251b',
    decimals: 18,
    symbol: 'ELYX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7906.png',
  },
  {
    chainId: 1,
    name: 'VersoView',
    address: '0x755be920943eA95e39eE2DC437b268917B580D6e',
    decimals: 18,
    symbol: 'VVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7907.png',
  },
  {
    chainId: 1,
    name: 'Guarded Ether',
    address: '0x3802c218221390025bceabbad5d8c59f40eb74b8',
    decimals: 18,
    symbol: 'GETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7908.png',
  },
  {
    chainId: 1,
    name: 'The APIS',
    address: '0xfd4168e642ebd04c3684a6cdb3a5e86de85d3908',
    decimals: 18,
    symbol: 'API',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7909.png',
  },
  {
    chainId: 1,
    name: 'Globitex',
    address: '0x12fcd6463e66974cf7bbc24ffc4d40d6be458283',
    decimals: 8,
    symbol: 'GBX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7910.png',
  },
  {
    chainId: 1,
    name: 'Alpha5',
    address: '0xe8272210954ea85de6d2ae739806ab593b5d9c51',
    decimals: 18,
    symbol: 'A5T',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7933.png',
  },
  {
    chainId: 1,
    name: 'Bet Chips',
    address: '0x83d6a2171f78e8ffe4dfe7680983effc49cff7a0',
    decimals: 4,
    symbol: 'BETC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7934.png',
  },
  {
    chainId: 1,
    name: 'FOMPOUND',
    address: '0x05385abD2a95a8cd9B696F738aed73f1AFbc12E0',
    decimals: 18,
    symbol: 'FOMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7936.png',
  },
  {
    chainId: 1,
    name: 'VINYL RECORDS TOKEN',
    address: '0x24e96809b4e720ea911bc3de8341400e26d6e994',
    decimals: 18,
    symbol: 'VRTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7937.png',
  },
  {
    chainId: 1,
    name: 'Yearn Ecosystem Token Index',
    address: '0xb4bebD34f6DaaFd808f73De0d10235a92Fbb6c3D',
    decimals: 18,
    symbol: 'YETI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7939.png',
  },
  {
    chainId: 1,
    name: 'Grain',
    address: '0x6589fe1271a0f29346796c6baf0cdf619e25e58e',
    decimals: 18,
    symbol: 'GRAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7940.png',
  },
  {
    chainId: 1,
    name: 'Bridge Finance',
    address: '0x244c5276ea5bb927575417156038d7381b44ab2c',
    decimals: 18,
    symbol: 'BFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7941.png',
  },
  {
    chainId: 1,
    name: 'Curate',
    address: '0xE1c7E30C42C24582888C758984f6e382096786bd',
    decimals: 18,
    symbol: 'XCUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7942.png',
  },
  {
    chainId: 1,
    name: 'rbase.finance',
    address: '0xe8b251822d003a2b2466ee0e38391c2db2048739',
    decimals: 9,
    symbol: 'RBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7943.png',
  },
  {
    chainId: 1,
    name: 'New Paradigm Classic',
    address: '0x6BF728A2A12Dd3404eE1d6562Dcd6f12f8326E9C',
    decimals: 18,
    symbol: 'NPC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7944.png',
  },
  {
    chainId: 1,
    name: 'Cyber Network Token',
    address: '0x0b46954c970b47F1C39c4C08167970334675dE51',
    decimals: 18,
    symbol: 'CNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7945.png',
  },
  {
    chainId: 1,
    name: 'Interfinex',
    address: '0xa891cf72aeda692570928efe1a832342e9783cdc',
    decimals: 18,
    symbol: 'IFEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7949.png',
  },
  {
    chainId: 1,
    name: 'ARVO',
    address: '0x629383e682fb83cac57e07bd2a5329ac6e4b48b1',
    decimals: 18,
    symbol: 'ARVO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7951.png',
  },
  {
    chainId: 1,
    name: 'MEME CASH',
    address: '0xA4e7414FCba1AF15203030C6daAC630df8F16AEa',
    decimals: 18,
    symbol: 'MCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7955.png',
  },
  {
    chainId: 1,
    name: 'Stargaze Protocol',
    address: '0xa9a8377287ea9c6b8b4249dd502e75d34148fc5b',
    decimals: 9,
    symbol: 'STGZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7956.png',
  },
  {
    chainId: 1,
    name: '4Bulls',
    address: '0x43b72464a93687dc2f14d5e49086e641d011b890',
    decimals: 18,
    symbol: '4B',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7966.png',
  },
  {
    chainId: 1,
    name: 'AC Index',
    address: '0x47318C3aAA5E8Da19765Eb07D79d937629017980',
    decimals: 9,
    symbol: 'ACX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7967.png',
  },
  {
    chainId: 1,
    name: 'Pluto',
    address: '0xF38011F9153aCFfACa3fBFC42Ddfa766C980d967',
    decimals: 18,
    symbol: 'PLUT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7968.png',
  },
  {
    chainId: 1,
    name: 'XVIX',
    address: '0x4bAE380B5D762D543d426331b8437926443ae9ec',
    decimals: 18,
    symbol: 'XVIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7969.png',
  },
  {
    chainId: 1,
    name: 'VELO Token',
    address: '0x98ad9B32dD10f8D8486927D846D4Df8BAf39Abe2',
    decimals: 18,
    symbol: 'VLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7970.png',
  },
  {
    chainId: 1,
    name: 'yplutus',
    address: '0x40E7705254494a7E61D5b7c86da50225DDc3DaAE',
    decimals: 18,
    symbol: 'YPLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7971.png',
  },
  {
    chainId: 1,
    name: 'Deflect',
    address: '0x3aa5f749d4a6bcf67dac1091ceb69d1f5d86fa53',
    decimals: 9,
    symbol: 'DEFLCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7973.png',
  },
  {
    chainId: 1,
    name: 'Unit Protocol Duck',
    address: '0x92e187a03b6cd19cb6af293ba17f2745fd2357d5',
    decimals: 18,
    symbol: 'DUCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7977.png',
  },
  {
    chainId: 1,
    name: 'Meteorite.network',
    address: '0x765baefcb5418fa9f7dddacb1ccc07bd0e890e4e',
    decimals: 9,
    symbol: 'METEOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7979.png',
  },
  {
    chainId: 1,
    name: 'MinePlex',
    address: '0x717376111a6f1572cF14aA2a236Ec9E743B4b2E7',
    decimals: 18,
    symbol: 'PLEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7980.png',
  },
  {
    chainId: 1,
    name: 'PIGX',
    address: '0x47e820df943170b0e31f9e18ecd5bdd67b77ff1f',
    decimals: 18,
    symbol: 'PIGX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7981.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Bank',
    address: '0xB565CaD9DfDd50D48396672DF7aE4979f7832437',
    decimals: 18,
    symbol: 'DEBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7982.png',
  },
  {
    chainId: 1,
    name: 'YFWorld',
    address: '0x5c710b606e649de021cd54e694dd3c618b8a370c',
    decimals: 18,
    symbol: 'YFW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7983.png',
  },
  {
    chainId: 1,
    name: 'Hub - Human Trust Protocol',
    address: '0xba358b6f5b4c0215650444b8c30d870b55050d2d',
    decimals: 18,
    symbol: 'HUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7986.png',
  },
  {
    chainId: 1,
    name: 'Blaze DeFi',
    address: '0x68e0a48d3bff6633a31d1d100b70f93c3859218b',
    decimals: 18,
    symbol: 'BNFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7987.png',
  },
  {
    chainId: 1,
    name: 'Zugacoin',
    address: '0xf5832512CFDa8083E5b2dd0aA7C1B9265c03BA1F',
    decimals: 8,
    symbol: 'SZCB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7988.png',
  },
  {
    chainId: 1,
    name: 'fyeth.finance',
    address: '0xD387f0E62E3f123A54Ae486056A5D859AFFeD0c8',
    decimals: 18,
    symbol: 'YETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7989.png',
  },
  {
    chainId: 1,
    name: 'Yield',
    address: '0xdcb01cc464238396e213a6fdd933e36796eaff9f',
    decimals: 18,
    symbol: 'YLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7991.png',
  },
  {
    chainId: 1,
    name: 'Ludena Protocol',
    address: '0xb29663Aa4E2e81e425294193616c1B102B70a158',
    decimals: 18,
    symbol: 'LDN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7992.png',
  },
  {
    chainId: 1,
    name: 'Node Runners',
    address: '0x739763a258640919981F9bA610AE65492455bE53',
    decimals: 18,
    symbol: 'NDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7993.png',
  },
  {
    chainId: 1,
    name: 'Spartan',
    address: '0x167e2a574669b0eeb552aaf3da47c728cb348a41',
    decimals: 7,
    symbol: '300',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7994.png',
  },
  {
    chainId: 1,
    name: 'Trinity Protocol',
    address: '0xc299004a310303d1c0005cb14c70ccc02863924d',
    decimals: 9,
    symbol: 'TRI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7995.png',
  },
  {
    chainId: 1,
    name: 'Buy-Sell',
    address: '0xa30189d8255322a2f8b2a77906b000aeb005570c',
    decimals: 18,
    symbol: 'BSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7996.png',
  },
  {
    chainId: 1,
    name: 'renFIL',
    address: '0xD5147bc8e386d91Cc5DBE72099DAC6C9b99276F5',
    decimals: 18,
    symbol: 'RENFIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7997.png',
  },
  {
    chainId: 1,
    name: 'Predictz',
    address: '0x4e085036a1b732cbe4ffb1c12ddfdd87e7c3664d',
    decimals: 18,
    symbol: 'PRDZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7998.png',
  },
  {
    chainId: 1,
    name: 'Rizen Coin',
    address: '0xd8c82fbc4d8ed0644a7ec04cf973e84c6153c1d7',
    decimals: 18,
    symbol: 'RZN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7999.png',
  },
  {
    chainId: 1,
    name: 'Lido DAO',
    address: '0x5a98fcbea516cf06857215779fd812ca3bef1b32',
    decimals: 18,
    symbol: 'LDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8000.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Apple',
    address: '0xd36932143F6eBDEDD872D5Fb0651f4B72Fd15a84',
    decimals: 18,
    symbol: 'mAAPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8001.png',
  },
  {
    chainId: 1,
    name: 'SpiderDAO',
    address: '0xbcd4b7de6fde81025f74426d43165a5b0d790fdd',
    decimals: 18,
    symbol: 'SPDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8002.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Google',
    address: '0x59A921Db27Dd6d4d974745B7FfC5c33932653442',
    decimals: 18,
    symbol: 'mGOOGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8003.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Tesla',
    address: '0x21cA39943E91d704678F5D00b6616650F066fD63',
    decimals: 18,
    symbol: 'mTSLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8004.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Netflix',
    address: '0xC8d674114bac90148d11D3C1d33C61835a0F9DCD',
    decimals: 18,
    symbol: 'mNFLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8005.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Alibaba',
    address: '0x56aA298a19C93c6801FDde870fA63EF75Cc0aF72',
    decimals: 18,
    symbol: 'mBABA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8006.png',
  },
  {
    chainId: 1,
    name: 'Natural Farm Union Protocol',
    address: '0x26CBC7008cD879f4B63B69a915378f2D9b17bBF0',
    decimals: 18,
    symbol: 'NFUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8007.png',
  },
  {
    chainId: 1,
    name: 'Pros.Finance',
    address: '0x306dd7cd66d964f598b4d2ec92b5a9b275d7feb3',
    decimals: 18,
    symbol: 'PROS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8008.png',
  },
  {
    chainId: 1,
    name: 'Cryptoenter',
    address: '0xf644d4477cd8db7791cea3013cb053b3fec4beb3',
    decimals: 8,
    symbol: 'LION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8009.png',
  },
  {
    chainId: 1,
    name: 'Davincij15 Token',
    address: '0x5d269fac3b2e0552b0f34cdc253bdb427682a4b9',
    decimals: 9,
    symbol: 'DJ15',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8011.png',
  },
  {
    chainId: 1,
    name: 'PIRANHAS',
    address: '0x0e3c91ed7d966ff1f7b58ab739a55e3c4473cd27',
    decimals: 18,
    symbol: '$PIR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8013.png',
  },
  {
    chainId: 1,
    name: 'FNK wallet',
    address: '0xb5fe099475d3030dde498c3bb6f3854f762a48ad',
    decimals: 18,
    symbol: 'FNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8014.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Amazon',
    address: '0x0cae9e4d663793c2a2A0b211c1Cf4bBca2B9cAa7',
    decimals: 18,
    symbol: 'mAMZN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8016.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Microsoft',
    address: '0x41BbEDd7286dAab5910a1f15d12CBda839852BD7',
    decimals: 18,
    symbol: 'mMSFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8017.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Twitter',
    address: '0xEdb0414627E6f1e3F082DE65cD4F9C693D78CCA9',
    decimals: 18,
    symbol: 'mTWTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8018.png',
  },
  {
    chainId: 1,
    name: 'N3RD Finance',
    address: '0x32c868f6318d6334b2250f323d914bc2239e4eee',
    decimals: 18,
    symbol: 'N3RDz',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8019.png',
  },
  {
    chainId: 1,
    name: 'DeFiato',
    address: '0x1045f5ccb01daea4f8eab055f5fcbb7c0e7c89f0',
    decimals: 18,
    symbol: 'DFIAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8020.png',
  },
  {
    chainId: 1,
    name: 'HLand Token',
    address: '0xba7b2c094c1a4757f9534a37d296a3bed7f544dc',
    decimals: 18,
    symbol: 'HLAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8021.png',
  },
  {
    chainId: 1,
    name: 'SPICE',
    address: '0x1fdab294eda5112b7d066ed8f2e4e562d5bcc664',
    decimals: 18,
    symbol: 'SPICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8023.png',
  },
  {
    chainId: 1,
    name: 'Mirrored iShares Gold Trust',
    address: '0x1d350417d9787E000cc1b95d70E9536DcD91F373',
    decimals: 18,
    symbol: 'mIAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8024.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Invesco QQQ Trust',
    address: '0x13B02c8dE71680e71F0820c996E4bE43c2F57d15',
    decimals: 18,
    symbol: 'mQQQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8025.png',
  },
  {
    chainId: 1,
    name: 'Mirrored iShares Silver Trust',
    address: '0x9d1555d8cB3C846Bb4f7D5B1B1080872c3166676',
    decimals: 18,
    symbol: 'mSLV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8026.png',
  },
  {
    chainId: 1,
    name: 'Mirrored United States Oil Fund',
    address: '0x31c63146a635EB7465e5853020b39713AC356991',
    decimals: 18,
    symbol: 'mUSO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8027.png',
  },
  {
    chainId: 1,
    name: 'Mirrored ProShares VIX',
    address: '0xf72FCd9DCF0190923Fadd44811E240Ef4533fc86',
    decimals: 18,
    symbol: 'mVIXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8028.png',
  },
  {
    chainId: 1,
    name: 'Oxygen',
    address: '0x965697b4ef02f0de01384d0d4f9f782b1670c163',
    decimals: 6,
    symbol: 'OXY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8029.png',
  },
  {
    chainId: 1,
    name: 'LootBox.io',
    address: '0x7b3D36Eb606f873A75A6aB68f8c999848B04F935',
    decimals: 18,
    symbol: 'LOOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8030.png',
  },
  {
    chainId: 1,
    name: 'Absorber Protocol',
    address: '0xf4c05296c449edcee3e3f1524fac919510b168a2',
    decimals: 18,
    symbol: 'ABS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8032.png',
  },
  {
    chainId: 1,
    name: 'Cryptonits',
    address: '0x36a28c7c9b3dea22f07f4df67833cbe764feeeb4',
    decimals: 18,
    symbol: 'CRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8033.png',
  },
  {
    chainId: 1,
    name: 'BioPassport Token',
    address: '0xc07A150ECAdF2cc352f5586396e344A6b17625EB',
    decimals: 9,
    symbol: 'BIOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8034.png',
  },
  {
    chainId: 1,
    name: 'Grom',
    address: '0xcE593a29905951E8Fc579bC092ecA72577dA575c',
    decimals: 6,
    symbol: 'GR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8035.png',
  },
  {
    chainId: 1,
    name: 'YVS.Finance',
    address: '0xec681f28f4561c2a9534799aa38e0d36a83cf478',
    decimals: 18,
    symbol: 'YVS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8036.png',
  },
  {
    chainId: 1,
    name: 'Vanar Chain',
    address: '0x8DE5B80a0C1B02Fe4976851D030B36122dbb8624',
    decimals: 18,
    symbol: 'VANRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8037.png',
  },
  {
    chainId: 1,
    name: 'WallStreet.Finance',
    address: '0x4819a96eb4b22454d628cd683ae052c2c9076808',
    decimals: 18,
    symbol: 'WSF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8038.png',
  },
  {
    chainId: 1,
    name: 'Reflector.Finance',
    address: '0x16b1eb8b8e9058800bf0ba3684f805a6711a1d2c',
    decimals: 9,
    symbol: 'RFCTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8039.png',
  },
  {
    chainId: 1,
    name: 'R34P',
    address: '0xcaeaf8381d4b20b43afa42061d6f80319a8881f6',
    decimals: 8,
    symbol: 'R34P',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8040.png',
  },
  {
    chainId: 1,
    name: 'Refract',
    address: '0xe0bdaafd0aab238c55d68ad54e616305d4a21772',
    decimals: 9,
    symbol: 'RFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8041.png',
  },
  {
    chainId: 1,
    name: 'MahaDAO',
    address: '0x745407c86df8db893011912d3ab28e68b62e49b0',
    decimals: 18,
    symbol: 'MAHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8043.png',
  },
  {
    chainId: 1,
    name: 'Adappter Token',
    address: '0xc314b0e758d5ff74f63e307a86ebfe183c95767b',
    decimals: 18,
    symbol: 'ADP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8044.png',
  },
  {
    chainId: 1,
    name: 'APY Vision',
    address: '0xf406f7a9046793267bc276908778b29563323996',
    decimals: 18,
    symbol: 'VISION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8045.png',
  },
  {
    chainId: 1,
    name: 'Cybertronchain',
    address: '0x00b7db6b4431e345eee5cc23d21e8dbc1d5cada3',
    decimals: 18,
    symbol: 'CTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8046.png',
  },
  {
    chainId: 1,
    name: 'Everyonescrypto',
    address: '0xa8006e3ac1bd94e54e3136b8e5dd75db0163e6f4',
    decimals: 18,
    symbol: 'EOC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8048.png',
  },
  {
    chainId: 1,
    name: 'Tornado Cash',
    address: '0x77777feddddffc19ff86db637967013e6c6a116c',
    decimals: 18,
    symbol: 'TORN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8049.png',
  },
  {
    chainId: 1,
    name: 'UNION Protocol Governance Token',
    address: '0x226f7b842e0f0120b7e194d05432b3fd14773a9d',
    decimals: 18,
    symbol: 'UNN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8056.png',
  },
  {
    chainId: 1,
    name: 'AnRKey X',
    address: '0xcae72a7a0fd9046cf6b165ca54c9e3a3872109e0',
    decimals: 18,
    symbol: '$ANRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8057.png',
  },
  {
    chainId: 1,
    name: 'Golden Ratio Per Liquidity',
    address: '0x15e4132dcd932e8990e794d1300011a472819cbd',
    decimals: 18,
    symbol: 'GRPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8059.png',
  },
  {
    chainId: 1,
    name: 'B21 Invest',
    address: '0x6faa826af0568d1866fca570da79b318ef114dab',
    decimals: 18,
    symbol: 'B21',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8060.png',
  },
  {
    chainId: 1,
    name: '2Based Finance',
    address: '0x168E39f96A653Ce0A456560687241b0B2936E5Ff',
    decimals: 9,
    symbol: '2BASED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8064.png',
  },
  {
    chainId: 1,
    name: 'Yield App',
    address: '0xF94b5C5651c888d928439aB6514B93944eEE6F48',
    decimals: 18,
    symbol: 'YLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8066.png',
  },
  {
    chainId: 1,
    name: 'Chalice Finance',
    address: '0x1cc0744c5106bb47a61c4e41f517cb6f1c49b547',
    decimals: 18,
    symbol: 'CHAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8069.png',
  },
  {
    chainId: 1,
    name: 'OnX Finance',
    address: '0xe0ad1806fd3e7edf6ff52fdb822432e847411033',
    decimals: 18,
    symbol: 'ONX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8071.png',
  },
  {
    chainId: 1,
    name: 'xETH-G',
    address: '0x3863ea7577fc91bfbaeae6a6a3e403524afcf787',
    decimals: 18,
    symbol: 'XETH-G',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8072.png',
  },
  {
    chainId: 1,
    name: 'Astosch',
    address: '0xeAEe3a142aC4E0494Bfb60D493b804Ca9A739339',
    decimals: 18,
    symbol: 'ATC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8073.png',
  },
  {
    chainId: 1,
    name: 'Basis Dollar',
    address: '0x003e0af2916e598Fa5eA5Cb2Da4EDfdA9aEd9Fde',
    decimals: 18,
    symbol: 'BSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8074.png',
  },
  {
    chainId: 1,
    name: 'Rally',
    address: '0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b',
    decimals: 18,
    symbol: 'RLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8075.png',
  },
  {
    chainId: 1,
    name: 'Rootkit Finance',
    address: '0xCb5f72d37685C3D5aD0bB5F982443BC8FcdF570E',
    decimals: 18,
    symbol: 'ROOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8077.png',
  },
  {
    chainId: 1,
    name: 'Dexfin',
    address: '0x15Eabb7500E44B7Fdb6e4051cA8DecA430cF9FB8',
    decimals: 18,
    symbol: 'DXF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8079.png',
  },
  {
    chainId: 1,
    name: 'ETH.limiteD',
    address: '0xf0c6521b1f8ad9c33a99aaf056f6c6247a3862ba',
    decimals: 18,
    symbol: 'ELD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8081.png',
  },
  {
    chainId: 1,
    name: 'Tornado',
    address: '0x7A3D5d49D64E57DBd6FBB21dF7202bD3EE7A2253',
    decimals: 18,
    symbol: 'TCORE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8082.png',
  },
  {
    chainId: 1,
    name: 'Tokenlon Network Token',
    address: '0x0000000000095413afc295d19edeb1ad7b71c952',
    decimals: 18,
    symbol: 'LON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8083.png',
  },
  {
    chainId: 1,
    name: 'nHBTC',
    address: '0x1f832091faf289ed4f50fe7418cfbd2611225d46',
    decimals: 18,
    symbol: 'N0001',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8084.png',
  },
  {
    chainId: 1,
    name: 'Lido Staked ETH',
    address: '0xae7ab96520de3a18e5e111b5eaab095312d7fe84',
    decimals: 18,
    symbol: 'stETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8085.png',
  },
  {
    chainId: 1,
    name: 'FastSwap',
    address: '0xc888a0ab4831a29e6ca432babf52e353d23db3c2',
    decimals: 18,
    symbol: 'FAST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8087.png',
  },
  {
    chainId: 1,
    name: 'Restore',
    address: '0x6753795d67ed0b2b65b57fc45c7ac0f53b55f4fe',
    decimals: 18,
    symbol: 'REST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8089.png',
  },
  {
    chainId: 1,
    name: 'Trade Butler Bot',
    address: '0x4a7adcb083fe5e3d6b58edc3d260e2e61668e7a2',
    decimals: 18,
    symbol: 'TBB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8090.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Finance Europe.',
    address: '0xd35ce4fd815522ff52243eb587020d557617f4db',
    decimals: 18,
    symbol: 'DFE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8094.png',
  },
  {
    chainId: 1,
    name: 'Orient',
    address: '0xc0a25a24cce412e2fb407c08e3785437fee9ad1d',
    decimals: 18,
    symbol: 'OFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8095.png',
  },
  {
    chainId: 1,
    name: 'FerrariSwap',
    address: '0xebf698ede71af52ab1acb12975472ba2e302e810',
    decimals: 18,
    symbol: 'FERRARI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8096.png',
  },
  {
    chainId: 1,
    name: 'Globo Crypto',
    address: '0xe24f25746fff8b66ab6ac47de2b082012dca303d',
    decimals: 18,
    symbol: 'GLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8097.png',
  },
  {
    chainId: 1,
    name: '3XT TOKEN',
    address: '0x96cf107e446a6e528ffd045f4eb6dff3cdb6a666',
    decimals: 18,
    symbol: '3XT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8099.png',
  },
  {
    chainId: 1,
    name: 'Ankr Staked ETH',
    address: '0xe95a203b1a91a908f9b9ce46459d101078c2c3cb',
    decimals: 18,
    symbol: 'ankrETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8100.png',
  },
  {
    chainId: 1,
    name: 'CEZO',
    address: '0xfebc25f4c5fc3e90a7efae0b4d436a77c9e131b3',
    decimals: 18,
    symbol: 'CEZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8101.png',
  },
  {
    chainId: 1,
    name: 'unilock.network',
    address: '0x354e514c135c8603f840ffadb4c33cde6d2a37e0',
    decimals: 18,
    symbol: 'UNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8103.png',
  },
  {
    chainId: 1,
    name: '1inch Network',
    address: '0x111111111117dc0aa78b770fa6a738034120c302',
    decimals: 18,
    symbol: '1INCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8104.png',
  },
  {
    chainId: 1,
    name: 'ROCKI',
    address: '0xff44b937788215eca197baaf9af69dbdc214aa04',
    decimals: 18,
    symbol: 'ROCKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8105.png',
  },
  {
    chainId: 1,
    name: 'Dynamic Set Dollar',
    address: '0xbd2f0cd039e0bfcf88901c98c0bfac5ab27566e3',
    decimals: 18,
    symbol: 'DSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8106.png',
  },
  {
    chainId: 1,
    name: 'Cobak Token',
    address: '0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD',
    decimals: 18,
    symbol: 'CBK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8107.png',
  },
  {
    chainId: 1,
    name: 'DBLend',
    address: '0x3800544c0ad45e2222d67151ff08ee0c476f6221',
    decimals: 8,
    symbol: 'DBL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8109.png',
  },
  {
    chainId: 1,
    name: 'Tacoswap',
    address: '0x41c028a4c1f461ebfc3af91619b240004ebad216',
    decimals: 18,
    symbol: 'TACO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8110.png',
  },
  {
    chainId: 1,
    name: 'Neverlose money',
    address: '0x6a76fe028056717703f357d1d073b439e4d24b0e',
    decimals: 18,
    symbol: 'WRN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8114.png',
  },
  {
    chainId: 1,
    name: 'TokenSwap',
    address: '0xED6aAd9650815D1647480CaA1133043800d31533',
    decimals: 18,
    symbol: 'TOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8115.png',
  },
  {
    chainId: 1,
    name: 'Diffract Finance',
    address: '0x64db5e5280421789af5c253a5ab260278ffd40ed',
    decimals: 9,
    symbol: 'DFR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8116.png',
  },
  {
    chainId: 1,
    name: 'Dymmax',
    address: '0xf058501585023d040ea9493134ed72c083553eed',
    decimals: 18,
    symbol: 'DMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8117.png',
  },
  {
    chainId: 1,
    name: 'Global Utility Smart Digital Token',
    address: '0x3242aebcdcf8de491004b1c98e6595e9827f6c17',
    decimals: 18,
    symbol: 'GUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8118.png',
  },
  {
    chainId: 1,
    name: 'SafePal',
    address: '0x12e2b8033420270db2f3b328e32370cb5b2ca134',
    decimals: 18,
    symbol: 'SFP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8119.png',
  },
  {
    chainId: 1,
    name: 'Whiteheart',
    address: '0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44',
    decimals: 18,
    symbol: 'WHITE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8120.png',
  },
  {
    chainId: 1,
    name: 'Themis',
    address: '0xcd1cb16a67937ff8af5d726e2681010ce1e9891a',
    decimals: 8,
    symbol: 'MIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8121.png',
  },
  {
    chainId: 1,
    name: 'Shaka',
    address: '0x93a7174dafd31d13400cd9fa01f4e5b5baa00d39',
    decimals: 18,
    symbol: 'HAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8122.png',
  },
  {
    chainId: 1,
    name: 'Australian Dollar Token',
    address: '0xd7e0f80fb28233bdde0006c50568606a8feb964c',
    decimals: 6,
    symbol: 'AUDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8123.png',
  },
  {
    chainId: 1,
    name: 'DRC Mobility',
    address: '0xd7f5CABdF696D7d1bf384D7688926A4bdB092c67',
    decimals: 18,
    symbol: 'DRC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8124.png',
  },
  {
    chainId: 1,
    name: 'Unique One',
    address: '0x93dfaf57d986b9ca77df9376c50878e013d9c7c8',
    decimals: 18,
    symbol: 'RARE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8125.png',
  },
  {
    chainId: 1,
    name: 'Bitpower',
    address: '0x52d904eff2605463c2f0b338d34abc9b7c3e3b08',
    decimals: 18,
    symbol: 'BPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8126.png',
  },
  {
    chainId: 1,
    name: 'Dixt.Finance',
    address: '0x43e6228b5bf22eab754486082ca91fdd8585521a',
    decimals: 18,
    symbol: 'DIXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8127.png',
  },
  {
    chainId: 1,
    name: 'Fire Protocol',
    address: '0xF921ae2DAC5fa128DC0F6168Bf153ea0943d2D43',
    decimals: 8,
    symbol: 'FIRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8129.png',
  },
  {
    chainId: 1,
    name: 'Curio Governance',
    address: '0xF56b164efd3CFc02BA739b719B6526A6FA1cA32a',
    decimals: 18,
    symbol: 'CGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8131.png',
  },
  {
    chainId: 1,
    name: 'BiFi',
    address: '0x2791bfd60d232150bff86b39b7146c0eaaa2ba81',
    decimals: 18,
    symbol: 'BIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8132.png',
  },
  {
    chainId: 1,
    name: 'Skey Network',
    address: '0x06a01a4d579479dd5d884ebf61a31727a3d8d442',
    decimals: 18,
    symbol: 'SKEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8133.png',
  },
  {
    chainId: 1,
    name: 'WAXE',
    address: '0x7a2bc711e19ba6aff6ce8246c546e8c4b4944dfd',
    decimals: 8,
    symbol: 'WAXE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8136.png',
  },
  {
    chainId: 1,
    name: 'MITH Cash',
    address: '0x368b3a58b5f49392e5c9e4c998cb0bb966752e51',
    decimals: 18,
    symbol: 'MIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8137.png',
  },
  {
    chainId: 1,
    name: 'LinkBased',
    address: '0xb15ae165000c8d7b69d2a82e425e110668c73ad5',
    decimals: 9,
    symbol: 'LBD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8138.png',
  },
  {
    chainId: 1,
    name: 'Airmoon',
    address: '0x1874218462d9caaa217d1212dc260023b5df0838',
    decimals: 18,
    symbol: 'AIRMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8139.png',
  },
  {
    chainId: 1,
    name: 'Wifi Coin',
    address: '0xe202873079913858f9Ba8795BA957A4Ad561ca24',
    decimals: 18,
    symbol: 'WIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8140.png',
  },
  {
    chainId: 1,
    name: 'Mithril Share',
    address: '0x4b4d2e899658fb59b1d518b68fe836b100ee8958',
    decimals: 18,
    symbol: 'MIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8141.png',
  },
  {
    chainId: 1,
    name: 'IDL Token',
    address: '0x6febd6be8fa45be6a5eeb61a17c82d33b9addd41',
    decimals: 18,
    symbol: 'IDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8142.png',
  },
  {
    chainId: 1,
    name: 'Nord Finance',
    address: '0x6e9730ecffbed43fd876a264c982e254ef05a0de',
    decimals: 18,
    symbol: 'NORD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8143.png',
  },
  {
    chainId: 1,
    name: 'OVR',
    address: '0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697',
    decimals: 18,
    symbol: 'OVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8144.png',
  },
  {
    chainId: 1,
    name: 'Zipmex',
    address: '0xaa602de53347579f86b996d2add74bb6f79462b2',
    decimals: 18,
    symbol: 'ZMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8146.png',
  },
  {
    chainId: 1,
    name: 'DigiCol',
    address: '0x63B8b7d4A3EFD0735c4BFFBD95B332a55e4eB851',
    decimals: 18,
    symbol: 'DGCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8148.png',
  },
  {
    chainId: 1,
    name: 'Finance.Vote',
    address: '0x45080a6531d671DDFf20DB42f93792a489685e32',
    decimals: 18,
    symbol: 'FVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8149.png',
  },
  {
    chainId: 1,
    name: 'Utopia Genesis Foundation',
    address: '0xe4ae84448db5cfe1daf1e6fb172b469c161cb85f',
    decimals: 18,
    symbol: 'UOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8150.png',
  },
  {
    chainId: 1,
    name: 'CryptoWars',
    address: '0x75ABDbc10eEEe99CF708D3273e34de3c161428E4',
    decimals: 18,
    symbol: 'CWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8152.png',
  },
  {
    chainId: 1,
    name: 'Basiscoin Cash',
    address: '0xaE17f4F5CA32F77ea8e3786db7C0b2FE877aC176',
    decimals: 18,
    symbol: 'BCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8153.png',
  },
  {
    chainId: 1,
    name: 'Basiscoin Share',
    address: '0x03066dA434e5264ef0B32f787923f974A5726fDc',
    decimals: 18,
    symbol: 'BCS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8154.png',
  },
  {
    chainId: 1,
    name: 'GGDApp',
    address: '0xfa99a87b14b02e2240c79240c5a20f945ca5ef76',
    decimals: 18,
    symbol: 'GGTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8156.png',
  },
  {
    chainId: 1,
    name: 'Space Dollar',
    address: '0x4b5216498b646af3121840e7984d466878f2dbcf',
    decimals: 18,
    symbol: 'SPAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8158.png',
  },
  {
    chainId: 1,
    name: 'One Cash',
    address: '0xD90E69f67203EBE02c917B5128629E77B4cd92dc',
    decimals: 18,
    symbol: 'ONC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8159.png',
  },
  {
    chainId: 1,
    name: 'One Share',
    address: '0x5BB29c33C4A3C29f56F8ACa40B4dB91d8a5fe2c5',
    decimals: 18,
    symbol: 'ONS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8160.png',
  },
  {
    chainId: 1,
    name: 'Shopping',
    address: '0x9b02dd390a603add5c07f9fd9175b7dabe8d63b7',
    decimals: 18,
    symbol: 'SPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8161.png',
  },
  {
    chainId: 1,
    name: 'Exeedme',
    address: '0xee573a945b01b788b9287ce062a0cfc15be9fd86',
    decimals: 18,
    symbol: 'XED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8163.png',
  },
  {
    chainId: 1,
    name: 'MAPS',
    address: '0x2b915b505c017abb1547aa5ab355fbe69865cc6d',
    decimals: 6,
    symbol: 'MAPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8166.png',
  },
  {
    chainId: 1,
    name: 'Wise Token',
    address: '0x66a0f676479cee1d7373f3dc2e2952778bff5bd6',
    decimals: 18,
    symbol: 'WISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8167.png',
  },
  {
    chainId: 1,
    name: 'Polkainsure Finance',
    address: '0x834ce7ad163ab3be0c5fd4e0a81e67ac8f51e00c',
    decimals: 18,
    symbol: 'PIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8169.png',
  },
  {
    chainId: 1,
    name: 'Stand Share',
    address: '0x4c38d0e726b6c86f64c1b281348e725973542043',
    decimals: 18,
    symbol: 'SAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8170.png',
  },
  {
    chainId: 1,
    name: 'COVER Protocol',
    address: '0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713',
    decimals: 18,
    symbol: 'COVER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8175.png',
  },
  {
    chainId: 1,
    name: 'Firdaos',
    address: '0x361887c1d1b73557018c47c8001711168128cf69',
    decimals: 18,
    symbol: 'FDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8176.png',
  },
  {
    chainId: 1,
    name: 'My Crypto Play',
    address: '0x2186ecb39f1b765ba7d78f1c43c2e9d7fc0c1eca',
    decimals: 18,
    symbol: 'MCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8178.png',
  },
  {
    chainId: 1,
    name: 'DePay',
    address: '0xa0bed124a09ac2bd941b10349d8d224fe3c955eb',
    decimals: 18,
    symbol: 'DEPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8181.png',
  },
  {
    chainId: 1,
    name: 'True Seigniorage Dollar',
    address: '0x4846239fdf4d4c1aeb26729fa064b0205aca90e1',
    decimals: 18,
    symbol: 'TSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8183.png',
  },
  {
    chainId: 1,
    name: 'Havens Nook',
    address: '0x0e1fe60bc4ac0e3102343752ae7e49d01d444c0b',
    decimals: 18,
    symbol: 'HXN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8184.png',
  },
  {
    chainId: 1,
    name: 'Trism',
    address: '0x56b4f8c39e07d4d5d91692acf9d0f6d4d3493763',
    decimals: 18,
    symbol: 'TRISM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8185.png',
  },
  {
    chainId: 1,
    name: 'Shabu Shabu Finance',
    address: '0xCb4e8CafEDa995da5cEdfda5205BD5664a12b848',
    decimals: 18,
    symbol: 'KOBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8189.png',
  },
  {
    chainId: 1,
    name: 'NFTX',
    address: '0x87d73E916D7057945c9BcD8cdd94e42A6F47f776',
    decimals: 18,
    symbol: 'NFTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8191.png',
  },
  {
    chainId: 1,
    name: 'Zero Collateral Dai',
    address: '0x9d1233cc46795E94029fDA81aAaDc1455D510f15',
    decimals: 18,
    symbol: 'ZAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8192.png',
  },
  {
    chainId: 1,
    name: 'Tenet',
    address: '0x74159651a992952e2bf340d7628459aa4593fc05',
    decimals: 18,
    symbol: 'TEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8193.png',
  },
  {
    chainId: 1,
    name: 'BitDNS',
    address: '0x17c090f9a17e4e5a8ceb23bbe7e7e28e3c4ca196',
    decimals: 18,
    symbol: 'DNS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8194.png',
  },
  {
    chainId: 1,
    name: 'Definex',
    address: '0x3f344c88d823f180fb8b44a3c7cfc4edc92dfa35',
    decimals: 6,
    symbol: 'DSWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8195.png',
  },
  {
    chainId: 1,
    name: 'Securypto',
    address: '0x8B8d971C8bc37f65a93c4609644FeF0590Af2Fc7',
    decimals: 18,
    symbol: 'SCU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8199.png',
  },
  {
    chainId: 1,
    name: 'Shapeshift FOX Token',
    address: '0xc770eefad204b5180df6a14ee197d99d808ee52d',
    decimals: 18,
    symbol: 'FOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8200.png',
  },
  {
    chainId: 1,
    name: 'ZKBase',
    address: '0xBBBbbBBB46A1dA0F0C3F64522c275BAA4C332636',
    decimals: 18,
    symbol: 'ZKB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8202.png',
  },
  {
    chainId: 1,
    name: 'ZuCoinChain',
    address: '0x26548041e3a78fdc60f3cce21977e1f5e46561b7',
    decimals: 18,
    symbol: 'ZCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8208.png',
  },
  {
    chainId: 1,
    name: 'Rupt',
    address: '0x07cC353876aE94A361BbeFBFDe6a6AE4821A8cd3',
    decimals: 18,
    symbol: 'RUPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8209.png',
  },
  {
    chainId: 1,
    name: 'Earn Defi Coin',
    address: '0x68a0a1fef18dfcc422db8be6f0f486dea1999edc',
    decimals: 9,
    symbol: 'EDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8212.png',
  },
  {
    chainId: 1,
    name: 'Vaultz',
    address: '0x861b2456ac1a6ab5fb5c72aa456091f23ddec1cc',
    decimals: 18,
    symbol: 'VAULTZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8218.png',
  },
  {
    chainId: 1,
    name: 'Fission Cash',
    address: '0x0b66015bc42601d5986b540373b4e02d7383c7c1',
    decimals: 9,
    symbol: 'FCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8222.png',
  },
  {
    chainId: 1,
    name: 'YFST.Protocol',
    address: '0x32a18b15985a290604dd9b2ebc39a1035b1a6b9c',
    decimals: 18,
    symbol: 'YFST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8223.png',
  },
  {
    chainId: 1,
    name: 'Xdef Finance',
    address: '0x5166d4ce79b9bf7df477da110c560ce3045aa889',
    decimals: 9,
    symbol: 'XDEF2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8226.png',
  },
  {
    chainId: 1,
    name: 'Connect Financial',
    address: '0xeabb8996ea1662cad2f7fb715127852cd3262ae9',
    decimals: 18,
    symbol: 'CNFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8227.png',
  },
  {
    chainId: 1,
    name: 'UniMex Network',
    address: '0x10be9a8dae441d276a5027936c3aaded2d82bc15',
    decimals: 18,
    symbol: 'UMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8229.png',
  },
  {
    chainId: 1,
    name: 'AI Network',
    address: '0x3A810ff7211b40c4fA76205a14efe161615d0385',
    decimals: 18,
    symbol: 'AIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8230.png',
  },
  {
    chainId: 1,
    name: 'Roti Bank Coin',
    address: '0xF5078213B8D39E0eEC2011d9486C17ddF07eA003',
    decimals: 18,
    symbol: 'RBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8231.png',
  },
  {
    chainId: 1,
    name: 'Molten',
    address: '0x66E535e8D2ebf13F49F3D49e5c50395a97C137b1',
    decimals: 18,
    symbol: 'MOLTEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8232.png',
  },
  {
    chainId: 1,
    name: 'Daiquilibrium',
    address: '0x73D9E335669462Cbdd6aa3AdaFe9efeE86a37Fe9',
    decimals: 18,
    symbol: 'DAIQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8234.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Monero',
    address: '0x465e07d6028830124be2e4aa551fbe12805db0f5',
    decimals: 18,
    symbol: 'WXMR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8235.png',
  },
  {
    chainId: 1,
    name: 'Glitch',
    address: '0x038a68ff68c393373ec894015816e33ad41bd564',
    decimals: 18,
    symbol: 'GLCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8236.png',
  },
  {
    chainId: 1,
    name: 'Basis Dollar Share',
    address: '0xE7C9C188138f7D70945D420d75F8Ca7d8ab9c700',
    decimals: 18,
    symbol: 'BSDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8237.png',
  },
  {
    chainId: 1,
    name: 'Dynamic Supply Tracker',
    address: '0x55696efc7c9779d868ac34ac6b4a4c5fed61ac12',
    decimals: 18,
    symbol: 'DSTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8238.png',
  },
  {
    chainId: 1,
    name: 'Dynamic Supply',
    address: '0xfa9c3dc54baa9eefbe9453b1f3b3b93ad2af0a77',
    decimals: 18,
    symbol: 'DST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8239.png',
  },
  {
    chainId: 1,
    name: 'SOAR.FI',
    address: '0xbae5f2d8a1299e5c4963eaff3312399253f27ccb',
    decimals: 9,
    symbol: 'SOAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8240.png',
  },
  {
    chainId: 1,
    name: 'Prophecy',
    address: '0x3C81D482172cC273c3b91dD9D8eb212023D00521',
    decimals: 18,
    symbol: 'PRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8241.png',
  },
  {
    chainId: 1,
    name: 'Coinstox',
    address: '0x3aadc3bce49724ce299fd9f3850211211c399c8c',
    decimals: 18,
    symbol: 'CSX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8244.png',
  },
  {
    chainId: 1,
    name: 'PayYoda',
    address: '0x9f978aa425148cdd9223eb175446a877b86727ff',
    decimals: 6,
    symbol: 'YOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8247.png',
  },
  {
    chainId: 1,
    name: 'DEUS Finance DEA',
    address: '0x80ab141f324c3d6f2b18b030f1c4e95d4d658778',
    decimals: 18,
    symbol: 'DEA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8248.png',
  },
  {
    chainId: 1,
    name: 'LP 3pool Curve',
    address: '0x6c3f90f043a72fa612cbac8115ee7e52bde6e490',
    decimals: 18,
    symbol: '3CRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8249.png',
  },
  {
    chainId: 1,
    name: 'AGAr',
    address: '0xb453f1f2EE776dAF2586501361c457dB70e1ca0F',
    decimals: 8,
    symbol: 'AGAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8251.png',
  },
  {
    chainId: 1,
    name: 'pBTC35A',
    address: '0xA8b12Cc90AbF65191532a12bb5394A714A46d358',
    decimals: 18,
    symbol: 'pBTC35A',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8252.png',
  },
  {
    chainId: 1,
    name: 'Mars',
    address: '0x66C0DDEd8433c9EA86C8cf91237B14e10b4d70B7',
    decimals: 18,
    symbol: 'Mars',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8253.png',
  },
  {
    chainId: 1,
    name: 'Contribute DAO',
    address: '0x8e84ee8b28ddbe2b1d5e204e674460835d298815',
    decimals: 18,
    symbol: 'TDAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8254.png',
  },
  {
    chainId: 1,
    name: 'Prosper',
    address: '0x8642A849D0dcb7a15a974794668ADcfbe4794B56',
    decimals: 18,
    symbol: 'PROS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8255.png',
  },
  {
    chainId: 1,
    name: 'HollyGold',
    address: '0x0c93b616933b0cd03b201b29cd8a22681dd9e0d9',
    decimals: 8,
    symbol: 'HGOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8256.png',
  },
  {
    chainId: 1,
    name: 'Yearn Finance Money',
    address: '0x271EB4124a507483C2D38cE0859505E9CA231304',
    decimals: 18,
    symbol: 'YFIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8257.png',
  },
  {
    chainId: 1,
    name: 'CUDOS',
    address: '0x817bbDbC3e8A1204f3691d14bB44992841e3dB35',
    decimals: 18,
    symbol: 'CUDOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8258.png',
  },
  {
    chainId: 1,
    name: 'Furucombo',
    address: '0xfFffFffF2ba8F66D4e51811C5190992176930278',
    decimals: 18,
    symbol: 'COMBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8259.png',
  },
  {
    chainId: 1,
    name: 'Indexed Finance',
    address: '0x86772b1409b61c639eaac9ba0acfbb6e238e5f83',
    decimals: 18,
    symbol: 'NDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8260.png',
  },
  {
    chainId: 1,
    name: 'Basis Gold',
    address: '0xB34Ab2f65c6e4F764fFe740ab83F982021Faed6d',
    decimals: 18,
    symbol: 'BSG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8261.png',
  },
  {
    chainId: 1,
    name: 'PegsUSD',
    address: '0x412e5a36bde71aa2c38e1c0e26baaf7f2f0bc24a',
    decimals: 18,
    symbol: 'PUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8262.png',
  },
  {
    chainId: 1,
    name: 'PegsShares',
    address: '0x88bd6efe33bc82860278c044efa33364c6285032',
    decimals: 18,
    symbol: 'PEGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8263.png',
  },
  {
    chainId: 1,
    name: 'Mandala Exchange Token',
    address: '0x947AEb02304391f8fbE5B25D7D98D649b57b1788',
    decimals: 18,
    symbol: 'MDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8266.png',
  },
  {
    chainId: 1,
    name: 'Solomon Defi',
    address: '0x07a0ad7a9dfc3854466f8f29a173bf04bba5686e',
    decimals: 18,
    symbol: 'SLM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8268.png',
  },
  {
    chainId: 1,
    name: 'YFTether',
    address: '0x94f31ac896c9823d81cf9c2c93feceed4923218f',
    decimals: 18,
    symbol: 'YFTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8269.png',
  },
  {
    chainId: 1,
    name: 'Gera Coin',
    address: '0x80d4f13acc30968fd6225b1ea79f5779f09fee60',
    decimals: 18,
    symbol: 'GERA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8270.png',
  },
  {
    chainId: 1,
    name: 'Yearn Shark Finance',
    address: '0x9c664f20c0a00a4949dffca76748c02754c875aa',
    decimals: 18,
    symbol: 'YSKF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8274.png',
  },
  {
    chainId: 1,
    name: 'ISALCOIN',
    address: '0x8e12bd795d2608f90440c84dddd2d985240696d5',
    decimals: 7,
    symbol: 'ISAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8275.png',
  },
  {
    chainId: 1,
    name: 'Arianee',
    address: '0xedf6568618a00c6f0908bf7758a16f76b6e04af9',
    decimals: 18,
    symbol: 'ARIA20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8276.png',
  },
  {
    chainId: 1,
    name: 'stakedXEM',
    address: '0x0c63cae5fcc2ca3dde60a35e50362220651ebec8',
    decimals: 8,
    symbol: 'STXEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8277.png',
  },
  {
    chainId: 1,
    name: 'VEROX',
    address: '0x87DE305311D5788e8da38D19bb427645b09CB4e5',
    decimals: 18,
    symbol: 'VRX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8278.png',
  },
  {
    chainId: 1,
    name: 'e-Money',
    address: '0xed0d5747a9ab03a75fbfec3228cd55848245b75d',
    decimals: 6,
    symbol: 'NGM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8279.png',
  },
  {
    chainId: 1,
    name: 'Golden Goose',
    address: '0x40d1f63b5d2048e67e9bedb1b4c2f1a9fb4b6817',
    decimals: 18,
    symbol: 'GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8281.png',
  },
  {
    chainId: 1,
    name: 'TokenAsset',
    address: '0xbe393aa534f82c0ffac31bf06a23e283acb3352b',
    decimals: 18,
    symbol: 'NTB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8284.png',
  },
  {
    chainId: 1,
    name: 'Block Duelers NFT Battles',
    address: '0x7bce667ef12023dc5f8577d015a2f09d99a5ef58',
    decimals: 18,
    symbol: 'BDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8285.png',
  },
  {
    chainId: 1,
    name: 'Excavo Finance',
    address: '0x24ea9c1cfd77a8db3fb707f967309cf013cc1078',
    decimals: 18,
    symbol: 'CAVO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8286.png',
  },
  {
    chainId: 1,
    name: 'Universal Gold',
    address: '0x0557Df767419296474C3f551Bb0A0ED4c2DD3380',
    decimals: 5,
    symbol: 'UPXAU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8287.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Celo',
    address: '0xe452e6ea2ddeb012e20db73bf5d3863a3ac8d77a',
    decimals: 18,
    symbol: 'WCELO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8288.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Celo Dollar',
    address: '0xad3e3fc59dff318beceaab7d00eb4f68b1ecf195',
    decimals: 18,
    symbol: 'WCUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8289.png',
  },
  {
    chainId: 1,
    name: 'SuperVerse',
    address: '0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55',
    decimals: 18,
    symbol: 'SUPER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8290.png',
  },
  {
    chainId: 1,
    name: 'Router Protocol',
    address: '0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4',
    decimals: 18,
    symbol: 'ROUTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8292.png',
  },
  {
    chainId: 1,
    name: 'Zero Exchange',
    address: '0xf0939011a9bb95c3b791f0cb546377ed2693a574',
    decimals: 18,
    symbol: 'ZERO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8293.png',
  },
  {
    chainId: 1,
    name: 'Cometh',
    address: '0x9c78ee466d6cb57a4d01fd887d2b5dfb2d46288f',
    decimals: 18,
    symbol: 'MUST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8294.png',
  },
  {
    chainId: 1,
    name: 'CPUcoin',
    address: '0x6d52dfefb16bb9cdc78bfca09061e44574886626',
    decimals: 18,
    symbol: 'CPU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8295.png',
  },
  {
    chainId: 1,
    name: 'zzz.finance v2',
    address: '0x93ed140172ff226dad1f7f3650489b8daa07ae7f',
    decimals: 18,
    symbol: 'ZZZV2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8297.png',
  },
  {
    chainId: 1,
    name: 'Paralink Network',
    address: '0x3a8d5BC8A8948b68DfC0Ce9C14aC4150e083518c',
    decimals: 18,
    symbol: 'PARA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8298.png',
  },
  {
    chainId: 1,
    name: 'Stake DAO',
    address: '0x73968b9a57c6e53d41345fd57a6e6ae27d6cdb2f',
    decimals: 18,
    symbol: 'SDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8299.png',
  },
  {
    chainId: 1,
    name: 'CoverCompared',
    address: '0x3c03b4ec9477809072ff9cc9292c9b25d4a8e6c6',
    decimals: 18,
    symbol: 'CVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8300.png',
  },
  {
    chainId: 1,
    name: 'QFinance',
    address: '0x6fe88a211863d0d818608036880c9a4b0ea86795',
    decimals: 18,
    symbol: 'QFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8302.png',
  },
  {
    chainId: 1,
    name: 'Rigel Finance',
    address: '0x4ca0654f4fc1025cf1a17b7459c20ac0479522ad',
    decimals: 18,
    symbol: 'RIGEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8304.png',
  },
  {
    chainId: 1,
    name: 'Insured Finance',
    address: '0x159751323a9e0415dd3d6d42a1212fe9f4a0848c',
    decimals: 18,
    symbol: 'INFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8305.png',
  },
  {
    chainId: 1,
    name: 'Typhoon Cash',
    address: '0x79256db1bdb6259315a1a3d7dd237f69cadfd8fc',
    decimals: 18,
    symbol: 'PHOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8306.png',
  },
  {
    chainId: 1,
    name: 'DIGG',
    address: '0x798D1bE841a82a273720CE31c822C61a67a601C3',
    decimals: 9,
    symbol: 'DIGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8307.png',
  },
  {
    chainId: 1,
    name: 'TosDis',
    address: '0x220b71671b649c03714da9c621285943f3cbcdc6',
    decimals: 18,
    symbol: 'DIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8310.png',
  },
  {
    chainId: 1,
    name: 'StakeHound Staked Ether',
    address: '0xdfe66b14d37c77f4e9b180ceb433d1b164f0281d',
    decimals: 18,
    symbol: 'STETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8311.png',
  },
  {
    chainId: 1,
    name: 'Bitbot Protocol',
    address: '0xbb0a009ba1eb20c5062c790432f080f6597662af',
    decimals: 18,
    symbol: 'BBP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8312.png',
  },
  {
    chainId: 1,
    name: 'Recharge Finance',
    address: '0x13572851103bed49ff743af4c4bb5ace88b22e2f',
    decimals: 9,
    symbol: 'R3FI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8313.png',
  },
  {
    chainId: 1,
    name: 'Nydronia',
    address: '0xdB11F6Fc8E16c02719e9c2Eb3c4C762feE8F5C5b',
    decimals: 18,
    symbol: 'NIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8314.png',
  },
  {
    chainId: 1,
    name: 'HeroSwap',
    address: '0x3ba11cf73c2da5e87ae7bc159e12f7dfd9fde8c9',
    decimals: 18,
    symbol: 'HERO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8315.png',
  },
  {
    chainId: 1,
    name: 'XUSD Stable',
    address: '0x1c9BA9144505aaBa12f4b126Fda9807150b88f80',
    decimals: 18,
    symbol: 'XUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8316.png',
  },
  {
    chainId: 1,
    name: 'Naker',
    address: '0x597910a47067fced9e48286d39744b2b6d2cf913',
    decimals: 18,
    symbol: 'NKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8317.png',
  },
  {
    chainId: 1,
    name: 'Keeper Finance',
    address: '0x4e59dfe7c5d34c498cfe18f0b6db10941d6e1a8a',
    decimals: 18,
    symbol: 'KFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8318.png',
  },
  {
    chainId: 1,
    name: 'PolkaBridge',
    address: '0x298d492e8c1d909d3f63bc4a36c66c64acb3d695',
    decimals: 18,
    symbol: 'PBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8320.png',
  },
  {
    chainId: 1,
    name: 'STING',
    address: '0x592481A5F6b4F078cc303C2cDE4337dFA2d76fA0',
    decimals: 18,
    symbol: 'STN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8321.png',
  },
  {
    chainId: 1,
    name: 'RiveMont',
    address: '0x43ae53b8c920c6c69f4abf393fcb68a6dd4cbab4',
    decimals: 18,
    symbol: 'RVMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8322.png',
  },
  {
    chainId: 1,
    name: 'PieDAO Balanced Crypto Pie',
    address: '0xe4f726adc8e89c6a6017f01eada77865db22da14',
    decimals: 18,
    symbol: 'BCP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8323.png',
  },
  {
    chainId: 1,
    name: 'PieDAO Yearn Ecosystem Pie',
    address: '0x17525e4f4af59fbc29551bc4ece6ab60ed49ce31',
    decimals: 18,
    symbol: 'YPIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8324.png',
  },
  {
    chainId: 1,
    name: 'CURE Farm',
    address: '0x089a502032166e07ae83eb434c16790ca2fa4661',
    decimals: 18,
    symbol: 'CURE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8326.png',
  },
  {
    chainId: 1,
    name: 'Narwhale.finance',
    address: '0x7d529a5b3c41126760a0fa3c1a9652d8a7a07793',
    decimals: 18,
    symbol: 'NAWA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8327.png',
  },
  {
    chainId: 1,
    name: 'Armor NXM',
    address: '0x1337def18c680af1f9f45cbcab6309562975b1dd',
    decimals: 18,
    symbol: 'arNXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8328.png',
  },
  {
    chainId: 1,
    name: 'PAID Network',
    address: '0x1614F18Fc94f47967A3Fbe5FfcD46d4e7Da3D787',
    decimals: 18,
    symbol: 'PAID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8329.png',
  },
  {
    chainId: 1,
    name: 'Xstable.Protocol',
    address: '0x91383a15c391c142b80045d8b4730c1c37ac0378',
    decimals: 9,
    symbol: 'XST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8330.png',
  },
  {
    chainId: 1,
    name: 'Energy Ledger',
    address: '0x9048c33c7bae0bbe9ad702b17b4453a83900d154',
    decimals: 18,
    symbol: 'ELX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8331.png',
  },
  {
    chainId: 1,
    name: 'TECHNOLOGY INNOVATION PROJECT',
    address: '0x07dE533cBC72395C32eB8981DDccD2CC6a6E1c4E',
    decimals: 18,
    symbol: 'TIP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8332.png',
  },
  {
    chainId: 1,
    name: 'Nirvana DeFi',
    address: '0x790BaF0C914898C62163A61F150637D4bd180697',
    decimals: 18,
    symbol: 'VANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8333.png',
  },
  {
    chainId: 1,
    name: 'Interop',
    address: '0x2eC75589856562646afE393455986CaD26c4Cc5f',
    decimals: 18,
    symbol: 'TROP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8336.png',
  },
  {
    chainId: 1,
    name: 'Tokemon',
    address: '0x2b5016CeA1C425f915E13727f7657025de3208Fe',
    decimals: 18,
    symbol: 'TKMN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8338.png',
  },
  {
    chainId: 1,
    name: 'xFund',
    address: '0x892a6f9df0147e5f079b0993f486f9aca3c87881',
    decimals: 9,
    symbol: 'XFUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8339.png',
  },
  {
    chainId: 1,
    name: 'USDEX',
    address: '0x4726e9de74573255ea41e0d00b49b833c77a671e',
    decimals: 6,
    symbol: 'USDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8348.png',
  },
  {
    chainId: 1,
    name: 'Onooks',
    address: '0x69d9905b2e5f6f5433212b7f3c954433f23c1572',
    decimals: 18,
    symbol: 'OOKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8349.png',
  },
  {
    chainId: 1,
    name: 'Gasgains',
    address: '0xc58467b855401ef3ff8fda9216f236e29f0d6277',
    decimals: 18,
    symbol: 'GASG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8352.png',
  },
  {
    chainId: 1,
    name: 'Potentiam',
    address: '0x7c32DB0645A259FaE61353c1f891151A2e7f8c1e',
    decimals: 18,
    symbol: 'PTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8358.png',
  },
  {
    chainId: 1,
    name: 'Universal Dollar',
    address: '0x888888877A18532b78d259577d00057054C50Dd8',
    decimals: 18,
    symbol: 'U8D',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8361.png',
  },
  {
    chainId: 1,
    name: 'Gladius Finance',
    address: '0xf75c5d8ed3f556ca670c06c08079609da6374a10',
    decimals: 18,
    symbol: 'GLAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8362.png',
  },
  {
    chainId: 1,
    name: 'renDOGE',
    address: '0x3832d2F059E55934220881F831bE501D180671A7',
    decimals: 8,
    symbol: 'RENDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8363.png',
  },
  {
    chainId: 1,
    name: 'Bridge Mutual',
    address: '0x725c263e32c72ddc3a19bea12c5a0479a81ee688',
    decimals: 18,
    symbol: 'BMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8364.png',
  },
  {
    chainId: 1,
    name: 'World Token',
    address: '0xbf494f02ee3fde1f20bee6242bce2d1ed0c15e47',
    decimals: 18,
    symbol: 'WORLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8366.png',
  },
  {
    chainId: 1,
    name: 'Name Change Token',
    address: '0x8a9c4dfe8b9d8962b31e4e16f8321c44d48e246e',
    decimals: 18,
    symbol: 'NCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8367.png',
  },
  {
    chainId: 1,
    name: 'Xeno Token',
    address: '0xc03a652efbbacfabde37cd66c7a4ff4332f7186c',
    decimals: 18,
    symbol: 'XNO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8368.png',
  },
  {
    chainId: 1,
    name: 'Civitas Protocol',
    address: '0x88930072f583936f506ce1f1d5fe69290c2d6a2a',
    decimals: 18,
    symbol: 'CVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8369.png',
  },
  {
    chainId: 1,
    name: 'Elevate',
    address: '0x48be867b240d2ffaff69e0746130f2c027d8d3d2',
    decimals: 9,
    symbol: 'ELE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8371.png',
  },
  {
    chainId: 1,
    name: 'QUAI DAO',
    address: '0x40821cd074dfecb1524286923bc69315075b5c89',
    decimals: 18,
    symbol: 'QUAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8373.png',
  },
  {
    chainId: 1,
    name: 'protocol finance',
    address: '0x7b69d465c0f9fb22affae56aa86149973e9b0966',
    decimals: 18,
    symbol: 'PFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8374.png',
  },
  {
    chainId: 1,
    name: 'GOGO.finance',
    address: '0x9a96E767bFCcE8E80370BE00821ED5BA283D4A17',
    decimals: 18,
    symbol: 'GOGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8375.png',
  },
  {
    chainId: 1,
    name: 'MASQ',
    address: '0x06f3c323f0238c72bf35011071f2b5b7f43a054c',
    decimals: 18,
    symbol: 'MASQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8376.png',
  },
  {
    chainId: 1,
    name: 'SX Network',
    address: '0xbe9f61555f50dd6167f2772e9cf7519790d96624',
    decimals: 18,
    symbol: 'SX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8377.png',
  },
  {
    chainId: 1,
    name: 'Akita Inu',
    address: '0x3301ee63fb29f863f2333bd4466acb46cd8323e6',
    decimals: 18,
    symbol: 'AKITA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8378.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Shift',
    address: '0x4b4571925e94ccd8c546b39462a270cc9b3ed1e4',
    decimals: 18,
    symbol: 'WSHIFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8380.png',
  },
  {
    chainId: 1,
    name: 'CLV',
    address: '0x80C62FE4487E1351b47Ba49809EBD60ED085bf52',
    decimals: 18,
    symbol: 'CLV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8384.png',
  },
  {
    chainId: 1,
    name: 'Umbrella Network',
    address: '0x6fc13eace26590b80cccab1ba5d51890577d83b2',
    decimals: 18,
    symbol: 'UMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8385.png',
  },
  {
    chainId: 1,
    name: 'Gourmet Galaxy',
    address: '0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24',
    decimals: 18,
    symbol: 'GUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8386.png',
  },
  {
    chainId: 1,
    name: 'REDi',
    address: '0xebdf9a7ae0009b958c6d09501eb9ac1dafeb31ab',
    decimals: 18,
    symbol: 'REDI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8388.png',
  },
  {
    chainId: 1,
    name: 'BambooDeFi',
    address: '0xf56842Af3B56Fd72d17cB103f92d027bBa912e89',
    decimals: 18,
    symbol: 'BAMBOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8389.png',
  },
  {
    chainId: 1,
    name: 'Strudel Finance',
    address: '0x297d33e17e61c2ddd812389c2105193f8348188a',
    decimals: 18,
    symbol: '$TRDL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8390.png',
  },
  {
    chainId: 1,
    name: 'The Famous Token',
    address: '0xaef4f02e31cdbf007f8d98da4ae365188a0e9ecc',
    decimals: 8,
    symbol: 'TFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8391.png',
  },
  {
    chainId: 1,
    name: 'MoonDayPlus',
    address: '0xcb696c86917175dfb4f0037ddc4f2e877a9f081a',
    decimals: 18,
    symbol: 'MD+',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8392.png',
  },
  {
    chainId: 1,
    name: 'Zytara dollar',
    address: '0xbf0f3ccb8fa385a287106fba22e6bb722f94d686',
    decimals: 6,
    symbol: 'ZUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8393.png',
  },
  {
    chainId: 1,
    name: 'Anime Token',
    address: '0x75CB71325A44Fb102a742626B723054acb7E1394',
    decimals: 18,
    symbol: 'ANI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8394.png',
  },
  {
    chainId: 1,
    name: 'MoniBooks',
    address: '0x1981C31678Fb5f427AD3f15Ca08F0b1cb0c7504e',
    decimals: 18,
    symbol: 'MNBKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8395.png',
  },
  {
    chainId: 1,
    name: 'TheToken.Network',
    address: '0x3294b364a44f2f75c375fc8d8e2ccc59dd497fe4',
    decimals: 18,
    symbol: 'TTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8396.png',
  },
  {
    chainId: 1,
    name: 'Lotto',
    address: '0xb0dFd28d3CF7A5897C694904Ace292539242f858',
    decimals: 18,
    symbol: 'LOTTO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8399.png',
  },
  {
    chainId: 1,
    name: 'UniDexGas',
    address: '0xa5959e9412d27041194c3c3bcbe855face2864f7',
    decimals: 18,
    symbol: 'UNDG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8400.png',
  },
  {
    chainId: 1,
    name: 'Bitberry Token',
    address: '0x7671904eed7f10808B664fc30BB8693FD7237abF',
    decimals: 18,
    symbol: 'BBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8401.png',
  },
  {
    chainId: 1,
    name: 'YF Link USD',
    address: '0x7b760d06e401f85545f3b50c44bf5b05308b7b62',
    decimals: 18,
    symbol: 'YFLUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8402.png',
  },
  {
    chainId: 1,
    name: 'YFLink Synthetic',
    address: '0x8282df223AC402d04B2097d16f758Af4F70e7Db0',
    decimals: 18,
    symbol: 'sYFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8403.png',
  },
  {
    chainId: 1,
    name: 'Butterfly Protocol',
    address: '0xf680429328caaaCabee69b7A9FdB21a71419c063',
    decimals: 18,
    symbol: 'BFLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8405.png',
  },
  {
    chainId: 1,
    name: 'Defla',
    address: '0x70d47fd6c9497b11c1caf0e2a84a5e7661e66c1d',
    decimals: 9,
    symbol: 'DEFLA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8407.png',
  },
  {
    chainId: 1,
    name: 'Govi',
    address: '0xeeaa40b28a2d1b0b08f6f97bb1dd4b75316c6107',
    decimals: 18,
    symbol: 'GOVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8408.png',
  },
  {
    chainId: 1,
    name: 'Razor Network',
    address: '0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd',
    decimals: 18,
    symbol: 'RAZOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8409.png',
  },
  {
    chainId: 1,
    name: 'NFTX Hashmasks Index',
    address: '0x0fe629d1e84e171f8ff0c1ded2cc2221caa48a3f',
    decimals: 18,
    symbol: 'MASK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8410.png',
  },
  {
    chainId: 1,
    name: 'MP3',
    address: '0x018fb5af9d015af25592a014c4266a84143de7a0',
    decimals: 18,
    symbol: 'MP3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8412.png',
  },
  {
    chainId: 1,
    name: 'Rug Proof',
    address: '0xa0bb0027c28ade4ac628b7f81e7b93ec71b4e020',
    decimals: 18,
    symbol: 'RPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8413.png',
  },
  {
    chainId: 1,
    name: 'Finxflo',
    address: '0x8a40c222996f9f3431f63bf80244c36822060f12',
    decimals: 18,
    symbol: 'FXF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8416.png',
  },
  {
    chainId: 1,
    name: 'CryptoTask',
    address: '0x196c81385bc536467433014042788eb707703934',
    decimals: 18,
    symbol: 'CTASK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8418.png',
  },
  {
    chainId: 1,
    name: 'APYSwap',
    address: '0xf7413489c474ca4399eee604716c72879eea3615',
    decimals: 18,
    symbol: 'APYS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8419.png',
  },
  {
    chainId: 1,
    name: 'DAO Maker',
    address: '0x0f51bb10119727a7e5ea3538074fb341f56b09ad',
    decimals: 18,
    symbol: 'DAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8420.png',
  },
  {
    chainId: 1,
    name: 'Public Mint',
    address: '0x0CDF9acd87E940837ff21BB40c9fd55F68bba059',
    decimals: 18,
    symbol: 'MINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8423.png',
  },
  {
    chainId: 1,
    name: 'JasmyCoin',
    address: '0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC',
    decimals: 18,
    symbol: 'JASMY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8425.png',
  },
  {
    chainId: 1,
    name: 'Clash Token',
    address: '0x6fa0952355607dfb2d399138b7fe10eb90f245e4',
    decimals: 18,
    symbol: 'SCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8429.png',
  },
  {
    chainId: 1,
    name: 'DEFI Top 5 Tokens Index',
    address: '0xfa6de2697d59e88ed7fc4dfe5a33dac43565ea41',
    decimals: 18,
    symbol: 'DEFI5',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8430.png',
  },
  {
    chainId: 1,
    name: 'Chow Chow',
    address: '0x925f2c11b99c1a4c46606898ee91ed3d450cfeda',
    decimals: 9,
    symbol: 'CHOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8433.png',
  },
  {
    chainId: 1,
    name: 'Freeliquid',
    address: '0xfFED56a180f23fD32Bc6A1d8d3c09c283aB594A8',
    decimals: 18,
    symbol: 'FL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8436.png',
  },
  {
    chainId: 1,
    name: 'USDFreeLiquidity',
    address: '0x2b4200a8d373d484993c37d63ee14aee0096cd12',
    decimals: 18,
    symbol: 'USDFL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8437.png',
  },
  {
    chainId: 1,
    name: 'Hoge Finance',
    address: '0xfad45e47083e4607302aa43c65fb3106f1cd7607',
    decimals: 18,
    symbol: 'HOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8438.png',
  },
  {
    chainId: 1,
    name: 'Warp Finance',
    address: '0xed40834a13129509a89be39a9be9c0e96a0ddd71',
    decimals: 18,
    symbol: 'WARP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8439.png',
  },
  {
    chainId: 1,
    name: 'BlackFisk',
    address: '0x417ffdbc285dd2c4dc00937798ab901634137caa',
    decimals: 18,
    symbol: 'BLFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8440.png',
  },
  {
    chainId: 1,
    name: 'XCF Token',
    address: '0x010d14d36c3ea6570d240ae3ac9d660398f7c48e',
    decimals: 18,
    symbol: 'XCF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8441.png',
  },
  {
    chainId: 1,
    name: 'EthicHub',
    address: '0xfd09911130e6930bf87f2b0554c44f400bd80d3e',
    decimals: 18,
    symbol: 'ETHIX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8442.png',
  },
  {
    chainId: 1,
    name: 'LUXO',
    address: '0xD39a2CeCBA2657e125Ba6a5c98ad2F6b6D7E83FD',
    decimals: 18,
    symbol: 'LUXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8443.png',
  },
  {
    chainId: 1,
    name: 'Gains Farm',
    address: '0x831091dA075665168E01898c6DAC004A867f1e1B',
    decimals: 18,
    symbol: 'GFARM2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8444.png',
  },
  {
    chainId: 1,
    name: 'SharedStake',
    address: '0x24c19f7101c1731b85f1127eaa0407732e36ecdd',
    decimals: 18,
    symbol: 'SGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8445.png',
  },
  {
    chainId: 1,
    name: 'DeFiStarter',
    address: '0x46bFA3Bb807B5c3b3Ce7F7e0E667397020B6dc15',
    decimals: 18,
    symbol: 'DFST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8446.png',
  },
  {
    chainId: 1,
    name: 'Wrapped ILCOIN',
    address: '0xc98a910ede52e7d5308525845f19e17470dbccf7',
    decimals: 8,
    symbol: 'WILC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8447.png',
  },
  {
    chainId: 1,
    name: 'Fairpool',
    address: '0xd49EFA7BC0D339D74f487959C573d518BA3F8437',
    decimals: 18,
    symbol: 'FAIR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8450.png',
  },
  {
    chainId: 1,
    name: 'Radar',
    address: '0xf9fbe825bfb2bf3e387af0dc18cac8d87f29dea8',
    decimals: 18,
    symbol: 'RADAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8454.png',
  },
  {
    chainId: 1,
    name: 'TAMA EGG NiftyGotchi',
    address: '0x6e742e29395cf5736c358538f0f1372ab3dfe731',
    decimals: 18,
    symbol: 'TME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8455.png',
  },
  {
    chainId: 1,
    name: 'Starbugs Shards',
    address: '0xbc3ec4e491b835dce394a53e9a9a10ac19564839',
    decimals: 18,
    symbol: 'BUGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8456.png',
  },
  {
    chainId: 1,
    name: 'B20',
    address: '0xc4de189abf94c57f396bd4c52ab13b954febefd8',
    decimals: 18,
    symbol: 'B20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8457.png',
  },
  {
    chainId: 1,
    name: 'Peanut',
    address: '0x89bd2e7e388fab44ae88bef4e1ad12b4f1e0911c',
    decimals: 18,
    symbol: 'NUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8458.png',
  },
  {
    chainId: 1,
    name: 'Rise Protocol',
    address: '0x3fa807b6f8d4c407e6e605368f4372d14658b38c',
    decimals: 9,
    symbol: 'RISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8460.png',
  },
  {
    chainId: 1,
    name: 'Tapx',
    address: '0x7f1f2d3dfa99678675ece1c243d3f7bc3746db5d',
    decimals: 18,
    symbol: 'TAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8463.png',
  },
  {
    chainId: 1,
    name: 'YFBitcoin',
    address: '0xff034D12353867fC4228f4Ae3E689CD6dCAad120',
    decimals: 18,
    symbol: 'YFBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8464.png',
  },
  {
    chainId: 1,
    name: 'Ges Global',
    address: '0xd667d5a228cb09f190c4308cf89d39cab18a413c',
    decimals: 18,
    symbol: 'GES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8466.png',
  },
  {
    chainId: 1,
    name: 'Uberstate RIT 2.0',
    address: '0x2f115f7ae9a4c6ed075924752045bfe3f281335b',
    decimals: 18,
    symbol: 'RIT20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8467.png',
  },
  {
    chainId: 1,
    name: 'PolkaOracle',
    address: '0xf9f53a0d3baa86c9b70bdeb8ccf6691398c3a08e',
    decimals: 8,
    symbol: 'POT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8468.png',
  },
  {
    chainId: 1,
    name: 'SCV.finance Token',
    address: '0x282417b21236ac01a3a3d7ba304ed8d284f48b4d',
    decimals: 18,
    symbol: 'SCV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8470.png',
  },
  {
    chainId: 1,
    name: 'Mythic Finance',
    address: '0x9df4ac60379c6dc2b295ea04cf80dd60dca99944',
    decimals: 18,
    symbol: 'MYTHIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8472.png',
  },
  {
    chainId: 1,
    name: 'Polkabase',
    address: '0x44b537b6f94c73a54f7bf8a9b68f8125da3c330b',
    decimals: 9,
    symbol: 'PBASE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8475.png',
  },
  {
    chainId: 1,
    name: 'Premia',
    address: '0x6399C842dD2bE3dE30BF99Bc7D1bBF6Fa3650E70',
    decimals: 18,
    symbol: 'PREMIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8476.png',
  },
  {
    chainId: 1,
    name: 'DAOventures',
    address: '0x77dcE26c03a9B833fc2D7C31C22Da4f42e9d9582',
    decimals: 18,
    symbol: 'DVD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8478.png',
  },
  {
    chainId: 1,
    name: 'VAIOT',
    address: '0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c',
    decimals: 18,
    symbol: 'VAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8479.png',
  },
  {
    chainId: 1,
    name: 'mStable BTC',
    address: '0x945facb997494cc2570096c74b5f66a3507330a1',
    decimals: 18,
    symbol: 'MBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8482.png',
  },
  {
    chainId: 1,
    name: 'Olyverse',
    address: '0x6595b8fd9c920c81500dca94e53cdc712513fb1f',
    decimals: 18,
    symbol: 'OLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8484.png',
  },
  {
    chainId: 1,
    name: 'Parsiq Boost',
    address: '0xa211f450ce88deb31d3f12ae3c1ebf6b0e55a5d9',
    decimals: 18,
    symbol: 'PRQBOOST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8488.png',
  },
  {
    chainId: 1,
    name: 'XSGD',
    address: '0x70e8de73ce538da2beed35d14187f6959a8eca96',
    decimals: 18,
    symbol: 'XSGD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8489.png',
  },
  {
    chainId: 1,
    name: 'Punk',
    address: '0x9cea2ed9e47059260c97d697f82b8a14efa61ea5',
    decimals: 18,
    symbol: 'PUNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8490.png',
  },
  {
    chainId: 1,
    name: 'Vesper',
    address: '0x1b40183efb4dd766f11bda7a7c3ad8982e998421',
    decimals: 18,
    symbol: 'VSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8492.png',
  },
  {
    chainId: 1,
    name: 'Previse',
    address: '0xa36e59c08c9f251a6b7a9eb6be6e32fd6157acd0',
    decimals: 18,
    symbol: 'PRVS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8493.png',
  },
  {
    chainId: 1,
    name: 'Modefi',
    address: '0xea1ea0972fa092dd463f2968f9bb51cc4c981d71',
    decimals: 18,
    symbol: 'MOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8494.png',
  },
  {
    chainId: 1,
    name: 'Everest',
    address: '0xebd9d99a3982d547c5bb4db7e3b1f9f14b67eb83',
    decimals: 18,
    symbol: 'ID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8495.png',
  },
  {
    chainId: 1,
    name: 'Wolves of Wall Street',
    address: '0x672EF7E4Fe230B5cA1466C5fDD40588d30FdF90a',
    decimals: 18,
    symbol: 'WOWS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8496.png',
  },
  {
    chainId: 1,
    name: 'ApeSwap',
    address: '0x92DF60c51C710a1b1C20E42D85e221f3A1bFc7f2',
    decimals: 18,
    symbol: 'BANANA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8497.png',
  },
  {
    chainId: 1,
    name: 'Luxurious Pro Network Token',
    address: '0x6a4c76874e686a7d080d173987a35a9c48905583',
    decimals: 18,
    symbol: 'LPNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8501.png',
  },
  {
    chainId: 1,
    name: 'Mushroom',
    address: '0xea6412fb370e8d1605e6aeeaa21ad07c3c7e9f24',
    decimals: 18,
    symbol: 'MUSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8502.png',
  },
  {
    chainId: 1,
    name: 'MetaWhale BTC',
    address: '0x3521c85c3000bff57eac04489eb05bbd3193a531',
    decimals: 18,
    symbol: 'MWBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8504.png',
  },
  {
    chainId: 1,
    name: 'Metawhale Gold',
    address: '0x45128cb743951121fb70cb570c0784492732778a',
    decimals: 18,
    symbol: 'MWG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8505.png',
  },
  {
    chainId: 1,
    name: 'HASH Token',
    address: '0xeb1112ac78d537853150e2a07e8b765e29d3f019',
    decimals: 18,
    symbol: 'HASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8506.png',
  },
  {
    chainId: 1,
    name: 'PoolTogether',
    address: '0x0cec1a9154ff802e7934fc916ed7ca50bde6844e',
    decimals: 18,
    symbol: 'POOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8508.png',
  },
  {
    chainId: 1,
    name: 'XMON',
    address: '0x3aaDA3e213aBf8529606924d8D1c55CbDc70Bf74',
    decimals: 18,
    symbol: 'XMON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8509.png',
  },
  {
    chainId: 1,
    name: 'Basix',
    address: '0x23157662a9cb9be32d4d9bd019d9bcbaa040a62b',
    decimals: 18,
    symbol: 'BASX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8513.png',
  },
  {
    chainId: 1,
    name: 'DEVA TOKEN',
    address: '0x7ed621d37e30214d5e197454f08b1c5c9558517a',
    decimals: 18,
    symbol: 'DEVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8515.png',
  },
  {
    chainId: 1,
    name: 'BiTToken',
    address: '0x9f9913853f749b3fe6d6d4e16a1cc3c1656b6d51',
    decimals: 18,
    symbol: 'BITT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8517.png',
  },
  {
    chainId: 1,
    name: 'Xend Finance',
    address: '0x4563554284aA7148D6E6D0351519E954Ba3B6E02',
    decimals: 18,
    symbol: 'RWA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8519.png',
  },
  {
    chainId: 1,
    name: 'Our Pay',
    address: '0xdff3d69a00759449f091561a0af99a218982bd7f',
    decimals: 18,
    symbol: 'OUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8521.png',
  },
  {
    chainId: 1,
    name: 'TOZEX',
    address: '0x29239242A83479a4074Cb1c9e2A3e6705A4A4455',
    decimals: 18,
    symbol: 'TOZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8522.png',
  },
  {
    chainId: 1,
    name: 'Sea Road Token',
    address: '0x4202f32b18742acf0a566ea78726eac3bc93ec70',
    decimals: 18,
    symbol: 'SRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8523.png',
  },
  {
    chainId: 1,
    name: 'Rai Reflex Index',
    address: '0x03ab458634910aad20ef5f1c8ee96f1d6ac54919',
    decimals: 18,
    symbol: 'RAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8525.png',
  },
  {
    chainId: 1,
    name: 'Quantfury Token',
    address: '0x0fcbc31c503b4a9ed90e87f8ff46c318a4a14260',
    decimals: 8,
    symbol: 'QTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8531.png',
  },
  {
    chainId: 1,
    name: 'Hyper Credit Network',
    address: '0xF83d7fF2e4B43ebAd2fa534e621E31076f4d254C',
    decimals: 18,
    symbol: 'HPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8532.png',
  },
  {
    chainId: 1,
    name: 'Chintai',
    address: '0x9Ce84F6A69986a83d92C324df10bC8E64771030f',
    decimals: 18,
    symbol: 'CHEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8534.png',
  },
  {
    chainId: 1,
    name: 'Mask Network',
    address: '0x69af81e73a73b40adf4f3d4223cd9b1ece623074',
    decimals: 18,
    symbol: 'MASK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8536.png',
  },
  {
    chainId: 1,
    name: 'SifChain',
    address: '0x07bac35846e5ed502aa91adf6a9e7aa210f2dcbe',
    decimals: 18,
    symbol: 'erowan',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8541.png',
  },
  {
    chainId: 1,
    name: 'Kangal',
    address: '0x6e765d26388a17a6e86c49a8e41df3f58abcd337',
    decimals: 18,
    symbol: 'KANGAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8543.png',
  },
  {
    chainId: 1,
    name: 'Fractal ID',
    address: '0xf4d861575ecc9493420a3f5a14f85b13f0b50eb3',
    decimals: 18,
    symbol: 'FCL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8544.png',
  },
  {
    chainId: 1,
    name: 'Launchpool',
    address: '0x6149c26cd2f7b5ccdb32029af817123f6e37df5b',
    decimals: 18,
    symbol: 'LPOOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8545.png',
  },
  {
    chainId: 1,
    name: 'Aloha',
    address: '0x455f7ef6d8bcfc35f9337e85aee1b0600a59fabe',
    decimals: 18,
    symbol: 'ALOHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8548.png',
  },
  {
    chainId: 1,
    name: 'Polkacity',
    address: '0xaA8330FB2B4D5D07ABFE7A72262752a8505C6B37',
    decimals: 18,
    symbol: 'POLC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8549.png',
  },
  {
    chainId: 1,
    name: 'ShuttleOne',
    address: '0x5538ac3ce36e73bb851921f2a804b4657b5307bf',
    decimals: 18,
    symbol: 'SZO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8552.png',
  },
  {
    chainId: 1,
    name: 'HINT AI Project',
    address: '0xac9e0035dc040671e5646dc9b8896d7d78c48f85',
    decimals: 18,
    symbol: 'HINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8553.png',
  },
  {
    chainId: 1,
    name: 'PRivaCY Coin',
    address: '0xdfc3829b127761a3218bfcee7fc92e1232c9d116',
    decimals: 18,
    symbol: 'PRCY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8554.png',
  },
  {
    chainId: 1,
    name: 'Tcoin',
    address: '0x00ff902d4b2bfdbd0db38887412447c30b565aa0',
    decimals: 18,
    symbol: 'TCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8556.png',
  },
  {
    chainId: 1,
    name: 'DexMex',
    address: '0x0020d80229877b495d2bf3269a4c13f6f1e1b9d3',
    decimals: 18,
    symbol: 'DEXM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8557.png',
  },
  {
    chainId: 1,
    name: 'BT.Finance',
    address: '0x76c5449f4950f6338a393f53cda8b53b0cd3ca3a',
    decimals: 18,
    symbol: 'BT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8558.png',
  },
  {
    chainId: 1,
    name: 'Medican Coin',
    address: '0x72ba699f0f3c29d0f886c264ec7350533a32b3d5',
    decimals: 8,
    symbol: 'MCAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8559.png',
  },
  {
    chainId: 1,
    name: 'WhaleRoom',
    address: '0x2af72850c504ddd3c1876c66a914caee7ff8a46a',
    decimals: 18,
    symbol: 'WHL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8560.png',
  },
  {
    chainId: 1,
    name: 'KeyFi',
    address: '0xb8647e90c0645152fccf4d9abb6b59eb4aa99052',
    decimals: 18,
    symbol: 'KEYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8561.png',
  },
  {
    chainId: 1,
    name: 'Candy Protocol',
    address: '0x2029017f38128bFeFaA6C7B9cDd1b680cE8E5c03',
    decimals: 18,
    symbol: 'CAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8564.png',
  },
  {
    chainId: 1,
    name: 'Exen Coin',
    address: '0xe6cc10ef4de1ccfb821c99c04abfe1859d8eab8f',
    decimals: 2,
    symbol: 'EXEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8565.png',
  },
  {
    chainId: 1,
    name: 'Ballswap',
    address: '0xe51b8ab09008285a0380dd2680cd9dd5e13924d3',
    decimals: 18,
    symbol: 'BSP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8566.png',
  },
  {
    chainId: 1,
    name: 'HAPI Protocol',
    address: '0xd9c2d319cd7e6177336b0a9c93c21cb48d84fb54',
    decimals: 18,
    symbol: 'HAPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8567.png',
  },
  {
    chainId: 1,
    name: 'Pub Finance',
    address: '0xfecba472b2540c5a2d3700b2c9e06f0aa7dc6462',
    decimals: 18,
    symbol: 'PINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8571.png',
  },
  {
    chainId: 1,
    name: 'SOTA Finance',
    address: '0x0dde6f6e345bfd23f3f419f0dfe04e93143b44fb',
    decimals: 18,
    symbol: 'SOTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8576.png',
  },
  {
    chainId: 1,
    name: 'BigBoys Industry',
    address: '0x336c21557185079F42F6fFC098aB572c87AE9435',
    decimals: 18,
    symbol: 'BBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8578.png',
  },
  {
    chainId: 1,
    name: 'Polkamarkets',
    address: '0xd478161c952357f05f0292b56012cd8457f1cfbf',
    decimals: 18,
    symbol: 'POLK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8579.png',
  },
  {
    chainId: 1,
    name: 'Mirrored Facebook Inc',
    address: '0x0e99cC0535BB6251F6679Fa6E65d6d3b430e840B',
    decimals: 18,
    symbol: 'mFB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8585.png',
  },
  {
    chainId: 1,
    name: 'Cyclone Protocol',
    address: '0x8861cff2366c1128fd699b68304ad99a0764ef9a',
    decimals: 18,
    symbol: 'CYC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8590.png',
  },
  {
    chainId: 1,
    name: 'Mykonos coin',
    address: '0xc8645f0d6a622e2a9a66c1db9d33b1a46b4462dc',
    decimals: 18,
    symbol: 'MYK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8591.png',
  },
  {
    chainId: 1,
    name: 'Aave Enjin',
    address: '0xac6df26a590f08dcc95d5a4705ae8abbc88509ef',
    decimals: 18,
    symbol: 'aENJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8594.png',
  },
  {
    chainId: 1,
    name: 'Aave Ethereum',
    address: '0x3a3A65aAb0dd2A17E3F1947bA16138cd37d08c04',
    decimals: 18,
    symbol: 'aETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8595.png',
  },
  {
    chainId: 1,
    name: 'Aave LEND',
    address: '0x7D2D3688Df45Ce7C552E19c27e007673da9204B8',
    decimals: 18,
    symbol: 'aLEND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8596.png',
  },
  {
    chainId: 1,
    name: 'MP4',
    address: '0xe1a0da60f8802b49cc36313bafade3f9e12342fd',
    decimals: 18,
    symbol: 'MP4',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8597.png',
  },
  {
    chainId: 1,
    name: 'xSigma',
    address: '0x7777777777697cfeecf846a76326da79cc606517',
    decimals: 18,
    symbol: 'SIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8598.png',
  },
  {
    chainId: 1,
    name: 'xToken',
    address: '0x7f3edcdd180dbe4819bd98fee8929b5cedb3adeb',
    decimals: 18,
    symbol: 'XTK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8599.png',
  },
  {
    chainId: 1,
    name: 'Font',
    address: '0x4c25bdf026ea05f32713f00f73ca55857fbf6342',
    decimals: 18,
    symbol: 'FONT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8601.png',
  },
  {
    chainId: 1,
    name: 'Bounce Token',
    address: '0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096',
    decimals: 18,
    symbol: 'AUCTION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8602.png',
  },
  {
    chainId: 1,
    name: 'Bitune',
    address: '0x1fac00ccee478eced6a120a50ed2ab28ee7fe32b',
    decimals: 18,
    symbol: 'TUNE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8603.png',
  },
  {
    chainId: 1,
    name: 'Alchemix',
    address: '0xdbdb4d16eda451d0503b854cf79d55697f90c8df',
    decimals: 18,
    symbol: 'ALCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8613.png',
  },
  {
    chainId: 1,
    name: 'Alchemix USD',
    address: '0xBC6DA0FE9aD5f3b0d58160288917AA56653660E9',
    decimals: 18,
    symbol: 'ALUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8614.png',
  },
  {
    chainId: 1,
    name: 'Ethernity Chain',
    address: '0xbbc2ae13b23d715c30720f079fcd9b4a74093505',
    decimals: 18,
    symbol: 'ERN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8615.png',
  },
  {
    chainId: 1,
    name: 'Aurox',
    address: '0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b',
    decimals: 18,
    symbol: 'URUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8616.png',
  },
  {
    chainId: 1,
    name: 'Red Kite',
    address: '0x8b39b70e39aa811b69365398e0aace9bee238aeb',
    decimals: 18,
    symbol: 'PKF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8617.png',
  },
  {
    chainId: 1,
    name: 'TOWER',
    address: '0x1c9922314ed1415c95b9fd453c3818fd41867d0b',
    decimals: 18,
    symbol: 'TOWER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8620.png',
  },
  {
    chainId: 1,
    name: 'Flashstake',
    address: '0xB1f1F47061A7Be15C69f378CB3f69423bD58F2F8',
    decimals: 18,
    symbol: 'FLASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8627.png',
  },
  {
    chainId: 1,
    name: 'Stacker Ventures',
    address: '0xe0955f26515d22e347b17669993fcefcc73c3a0a',
    decimals: 18,
    symbol: 'STACK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8629.png',
  },
  {
    chainId: 1,
    name: 'Tranche Finance',
    address: '0x0aee8703d34dd9ae107386d3eff22ae75dd616d1',
    decimals: 18,
    symbol: 'SLICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8637.png',
  },
  {
    chainId: 1,
    name: 'Fei USD',
    address: '0x956F47F50A910163D8BF957Cf5846D573E7f87CA',
    decimals: 18,
    symbol: 'FEI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8642.png',
  },
  {
    chainId: 1,
    name: 'Shadows',
    address: '0x661ab0ed68000491d98c796146bcf28c20d7c559',
    decimals: 18,
    symbol: 'DOWS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8643.png',
  },
  {
    chainId: 1,
    name: 'Kylin',
    address: '0x5d07F52aE5f779422447C2A32F58c93A15E7d6F2',
    decimals: 18,
    symbol: 'KYL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8644.png',
  },
  {
    chainId: 1,
    name: 'Oiler Network',
    address: '0x0275e1001e293c46cfe158b3702aade0b99f88a5',
    decimals: 18,
    symbol: 'OIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8645.png',
  },
  {
    chainId: 1,
    name: 'MurAll',
    address: '0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042',
    decimals: 18,
    symbol: 'PAINT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8647.png',
  },
  {
    chainId: 1,
    name: 'ChainGuardians',
    address: '0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43',
    decimals: 18,
    symbol: 'CGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8648.png',
  },
  {
    chainId: 1,
    name: 'BSCStarter',
    address: '0x1d7Ca62F6Af49ec66f6680b8606E634E55Ef22C1',
    decimals: 18,
    symbol: 'START',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8662.png',
  },
  {
    chainId: 1,
    name: 'Parallel',
    address: '0x68037790A0229e9Ce6EaA8A99ea92964106C4703',
    decimals: 18,
    symbol: 'PAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8665.png',
  },
  {
    chainId: 1,
    name: 'DFX Finance',
    address: '0x888888435fde8e7d4c54cab67f206e4199454c60',
    decimals: 18,
    symbol: 'DFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8666.png',
  },
  {
    chainId: 1,
    name: 'Sovryn',
    address: '0xbdab72602e9ad40fc6a6852caf43258113b8f7a5',
    decimals: 18,
    symbol: 'SOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8669.png',
  },
  {
    chainId: 1,
    name: 'Vow',
    address: '0x1BBf25e71EC48B84d773809B4bA55B6F4bE946Fb',
    decimals: 18,
    symbol: 'VOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8670.png',
  },
  {
    chainId: 1,
    name: 'TotemFi',
    address: '0x6ff1bfa14a57594a5874b37ff6ac5efbd9f9599a',
    decimals: 18,
    symbol: 'TOTM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8673.png',
  },
  {
    chainId: 1,
    name: 'Unido EP',
    address: '0xea3983fc6d0fbbc41fb6f6091f68f3e08894dc06',
    decimals: 18,
    symbol: 'UDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8679.png',
  },
  {
    chainId: 1,
    name: 'Domani Protocol',
    address: '0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0',
    decimals: 18,
    symbol: 'DEXTF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8691.png',
  },
  {
    chainId: 1,
    name: 'BlockWallet',
    address: '0x41a3dba3d677e573636ba691a70ff2d606c29666',
    decimals: 18,
    symbol: 'BLANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8695.png',
  },
  {
    chainId: 1,
    name: 'Konomi Network',
    address: '0x850aAB69f0e0171A9a49dB8BE3E71351c8247Df4',
    decimals: 18,
    symbol: 'KONO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8697.png',
  },
  {
    chainId: 1,
    name: 'Siren',
    address: '0xD23Ac27148aF6A2f339BD82D0e3CFF380b5093de',
    decimals: 18,
    symbol: 'SI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8701.png',
  },
  {
    chainId: 1,
    name: 'Ares Protocol',
    address: '0x358AA737e033F34df7c54306960a38d09AaBd523',
    decimals: 18,
    symbol: 'ARES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8702.png',
  },
  {
    chainId: 1,
    name: 'Playcent',
    address: '0x657B83A0336561C8f64389a6f5aDE675C04b0C3b',
    decimals: 18,
    symbol: 'PCNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8704.png',
  },
  {
    chainId: 1,
    name: 'ETHA Lend',
    address: '0x59e9261255644c411afdd00bd89162d09d862e38',
    decimals: 18,
    symbol: 'ETHA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8709.png',
  },
  {
    chainId: 1,
    name: 'Pando',
    address: '0x252b9F56359901a0BDE52d0675b1f1130d86F471',
    decimals: 18,
    symbol: 'PANDO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8711.png',
  },
  {
    chainId: 1,
    name: 'keyTango',
    address: '0x182f4c4c97cd1c24e1df8fc4c053e5c47bf53bef',
    decimals: 18,
    symbol: 'TANGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8712.png',
  },
  {
    chainId: 1,
    name: 'Convergence',
    address: '0xc834fa996fa3bec7aad3693af486ae53d8aa8b50',
    decimals: 18,
    symbol: 'CONV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8716.png',
  },
  {
    chainId: 1,
    name: 'Oddz',
    address: '0xCd2828fc4D8E8a0eDe91bB38CF64B1a81De65Bf6',
    decimals: 18,
    symbol: 'ODDZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8717.png',
  },
  {
    chainId: 1,
    name: 'ECO',
    address: '0x8dBF9A4c99580fC7Fd4024ee08f3994420035727',
    decimals: 18,
    symbol: 'ECO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8718.png',
  },
  {
    chainId: 1,
    name: 'Illuvium',
    address: '0x767fe9edc9e0df98e07454847909b5e959d7ca0e',
    decimals: 18,
    symbol: 'ILV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8719.png',
  },
  {
    chainId: 1,
    name: 'Inverse Finance',
    address: '0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68',
    decimals: 18,
    symbol: 'INV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8720.png',
  },
  {
    chainId: 1,
    name: 'YEARNYFI NETWORK',
    address: '0xdeaa665ab71785ccf576dc76e5fcb5a2283ea0c6',
    decimals: 18,
    symbol: 'YNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8725.png',
  },
  {
    chainId: 1,
    name: 'Idavoll DAO',
    address: '0x45448E05020576929fcDEabC228E35b420098840',
    decimals: 18,
    symbol: 'IDV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8726.png',
  },
  {
    chainId: 1,
    name: 'PryvateCoin',
    address: '0xF91ee8732FA50A71C63cC677aC72e3afB29C6b35',
    decimals: 18,
    symbol: 'PVC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8727.png',
  },
  {
    chainId: 1,
    name: 'Pastel',
    address: '0xc775c0c30840cb9f51e21061b054ebf1a00acc29',
    decimals: 18,
    symbol: 'PSL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8738.png',
  },
  {
    chainId: 1,
    name: 'Sovi Finance',
    address: '0x2CD5C5705f587e3F794A91dFF6e86786BA0c18d5',
    decimals: 18,
    symbol: 'SOVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8741.png',
  },
  {
    chainId: 1,
    name: 'Toshimon',
    address: '0xf136d7b0b7ae5b86d21e7b78dfa95375a7360f19',
    decimals: 18,
    symbol: 'TOSHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8744.png',
  },
  {
    chainId: 1,
    name: 'A2A',
    address: '0x11c039f368606d91664bfd10137b00eee13cde77',
    decimals: 8,
    symbol: 'A2A',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8745.png',
  },
  {
    chainId: 1,
    name: 'Planet Inverse',
    address: '0x44f262622248027f8e2a8fb1090c4cf85072392c',
    decimals: 18,
    symbol: 'XIV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8746.png',
  },
  {
    chainId: 1,
    name: 'Prime Whiterock Company',
    address: '0xa3d93c0616dbc31fef1e112c7665a4ba4ddbf0be',
    decimals: 18,
    symbol: 'PWC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8750.png',
  },
  {
    chainId: 1,
    name: 'Landbox',
    address: '0x0e2ef8aecb3c01ad5d596f1b67134e178199984d',
    decimals: 18,
    symbol: 'LAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8752.png',
  },
  {
    chainId: 1,
    name: 'SafeMoon',
    address: '0x16631e53c20fd2670027c6d53efe2642929b285c',
    decimals: 18,
    symbol: 'SAFEMOON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8757.png',
  },
  {
    chainId: 1,
    name: 'EsportsPro',
    address: '0x29c56e7cb9c840d2b2371b17e28bab44ad3c3ead',
    decimals: 18,
    symbol: 'ESPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8760.png',
  },
  {
    chainId: 1,
    name: 'Decentralized Nations',
    address: '0x15f0eedf9ce24fc4b6826e590a8292ce5524a1da',
    decimals: 18,
    symbol: 'DENA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8761.png',
  },
  {
    chainId: 1,
    name: 'Revelation Finance',
    address: '0x71fbc1d795fcfbca43a3ebf6de0101952f31a410',
    decimals: 18,
    symbol: 'ADAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8762.png',
  },
  {
    chainId: 1,
    name: 'MyNeighborAlice',
    address: '0xAC51066d7bEC65Dc4589368da368b212745d63E8',
    decimals: 18,
    symbol: 'ALICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8766.png',
  },
  {
    chainId: 1,
    name: 'Unifund',
    address: '0x04b5e13000c6e9a3255dc057091f3e3eeee7b0f0',
    decimals: 18,
    symbol: 'IFUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8767.png',
  },
  {
    chainId: 1,
    name: 'MeetPle',
    address: '0x47481c1b44F2A1c0135c45AA402CE4F4dDE4D30e',
    decimals: 18,
    symbol: 'MPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8769.png',
  },
  {
    chainId: 1,
    name: 'GYEN',
    address: '0xC08512927D12348F6620a698105e1BAac6EcD911',
    decimals: 18,
    symbol: 'GYEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8771.png',
  },
  {
    chainId: 1,
    name: 'ZUSD',
    address: '0xc56c2b7e71B54d38Aab6d52E94a04Cbfa8F604fA',
    decimals: 18,
    symbol: 'ZUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8772.png',
  },
  {
    chainId: 1,
    name: 'Value Set Dollar',
    address: '0x35de3eccaccb02e627062b5d63aa941b137288fe',
    decimals: 18,
    symbol: 'VSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8775.png',
  },
  {
    chainId: 1,
    name: 'Grabity',
    address: '0x30634241d3a7fbcea55f0ba7df42dfd8cdd8b2cd',
    decimals: 18,
    symbol: 'GBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8776.png',
  },
  {
    chainId: 1,
    name: 'Umbria Network',
    address: '0xa4bbe66f151b22b167127c770016b15ff97dd35c',
    decimals: 18,
    symbol: 'UMBR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8780.png',
  },
  {
    chainId: 1,
    name: 'Transmute Protocol',
    address: '0xbC81BF5B3173BCCDBE62dba5f5b695522aD63559',
    decimals: 18,
    symbol: 'XPB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8783.png',
  },
  {
    chainId: 1,
    name: 'Crypto Heroes',
    address: '0xfa4cce6d38047abfe5cd07b76e3858bf54e7f1dc',
    decimals: 18,
    symbol: 'HEROES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8786.png',
  },
  {
    chainId: 1,
    name: 'EDDASwap',
    address: '0xfbbe9b1142c699512545f47937ee6fae0e4b0aa9',
    decimals: 18,
    symbol: 'EDDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8789.png',
  },
  {
    chainId: 1,
    name: 'KINE',
    address: '0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d',
    decimals: 18,
    symbol: 'KINE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8790.png',
  },
  {
    chainId: 1,
    name: 'Mute',
    address: '0xa49d7499271ae71cd8ab9ac515e6694c755d400c',
    decimals: 18,
    symbol: 'MUTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8795.png',
  },
  {
    chainId: 1,
    name: 'Chronicle',
    address: '0x06a00715e6f92210af9d7680b584931faf71a833',
    decimals: 18,
    symbol: 'XNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8797.png',
  },
  {
    chainId: 1,
    name: 'InsurAce',
    address: '0x544c42fbb96b39b21df61cf322b5edc285ee7429',
    decimals: 18,
    symbol: 'INSUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8799.png',
  },
  {
    chainId: 1,
    name: 'B26 Finance',
    address: '0x481de76d5ab31e28a33b0ea1c1063adcb5b1769a',
    decimals: 18,
    symbol: 'B26',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8803.png',
  },
  {
    chainId: 1,
    name: 'Carnomaly',
    address: '0x884ddbb5dc6c2cef77d3e74c6ccca315797d655b',
    decimals: 18,
    symbol: 'CARR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8806.png',
  },
  {
    chainId: 1,
    name: 'EXRT Network',
    address: '0xb20043F149817bff5322F1b928e89aBFC65A9925',
    decimals: 8,
    symbol: 'EXRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8807.png',
  },
  {
    chainId: 1,
    name: 'Shadetech',
    address: '0x8a8221628361fa25294a83a172dd4f0133207b37',
    decimals: 18,
    symbol: 'SHD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8815.png',
  },
  {
    chainId: 1,
    name: 'Grumpy.finance',
    address: '0x93b2fff814fcaeffb01406e80b4ecd89ca6a021b',
    decimals: 18,
    symbol: 'GRUMPY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8816.png',
  },
  {
    chainId: 1,
    name: 'Sad Cat Token',
    address: '0x8424c5ac326834b404742de0067bcb654e86be30',
    decimals: 18,
    symbol: 'SCAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8819.png',
  },
  {
    chainId: 1,
    name: 'Coffee Token',
    address: '0x5bf2390a68ab7db7d27ae81894c4e22e669af236',
    decimals: 18,
    symbol: 'CFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8821.png',
  },
  {
    chainId: 1,
    name: 'Moss Carbon Credit',
    address: '0xfc98e825a2264d890f9a1e68ed50e1526abccacd',
    decimals: 18,
    symbol: 'MCO2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8826.png',
  },
  {
    chainId: 1,
    name: 'Boson Protocol',
    address: '0xC477D038d5420C6A9e0b031712f61c5120090de9',
    decimals: 18,
    symbol: 'BOSON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8827.png',
  },
  {
    chainId: 1,
    name: 'Aurix',
    address: '0x6E98E5401ADCB0D76F4DEBfc3d794B3031F48790',
    decimals: 18,
    symbol: 'AUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8831.png',
  },
  {
    chainId: 1,
    name: 'AlgoVest',
    address: '0x94d916873b22c9c1b53695f1c002f78537b9b3b2',
    decimals: 18,
    symbol: 'AVS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8832.png',
  },
  {
    chainId: 1,
    name: 'DeGate',
    address: '0x53c8395465a84955c95159814461466053dedede',
    decimals: 18,
    symbol: 'DG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8833.png',
  },
  {
    chainId: 1,
    name: 'xMARK',
    address: '0x36b679bd64ed73dbfd88909cdcb892cb66bd4cbb',
    decimals: 9,
    symbol: 'XMARK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8835.png',
  },
  {
    chainId: 1,
    name: 'PWAY',
    address: '0x5a14fe6923e767A8238f29d3E1FB1a913975F0d7',
    decimals: 18,
    symbol: 'PWAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8838.png',
  },
  {
    chainId: 1,
    name: 'Arro Social',
    address: '0xE630943d2a62CfB48DBCd1be812f74f8DfA6EfF5',
    decimals: 18,
    symbol: 'ARRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8841.png',
  },
  {
    chainId: 1,
    name: 'SPRINK',
    address: '0xbef7cb91fe9cd57f0c60811b83ab5f8e0dab8795',
    decimals: 8,
    symbol: 'SPRINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8844.png',
  },
  {
    chainId: 1,
    name: 'Lepricon',
    address: '0xdef1da03061ddd2a5ef6c59220c135dec623116d',
    decimals: 18,
    symbol: 'L3P',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8845.png',
  },
  {
    chainId: 1,
    name: 'Fomo App',
    address: '0xddce093888c8dc636677cd29bc6c68d35cfdac33',
    decimals: 18,
    symbol: 'PAPER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8847.png',
  },
  {
    chainId: 1,
    name: 'AXIS Token',
    address: '0xF0c5831EC3Da15f3696B4DAd8B21c7Ce2f007f28',
    decimals: 18,
    symbol: 'AXIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8849.png',
  },
  {
    chainId: 1,
    name: 'FXT Token',
    address: '0xf83bf320a4a3f4bf365c3114b6f19fc3f6b1228c',
    decimals: 6,
    symbol: 'FXT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8854.png',
  },
  {
    chainId: 1,
    name: 'Anchor Protocol',
    address: '0x0F3ADC247E91c3c50bC08721355A41037E89Bc20',
    decimals: 18,
    symbol: 'ANC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8857.png',
  },
  {
    chainId: 1,
    name: 'Movement DAO',
    address: '0x3d46454212c61ecb7b31248047fa033120b88668',
    decimals: 18,
    symbol: 'MVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8861.png',
  },
  {
    chainId: 1,
    name: 'Rage Fan',
    address: '0x94804dc4948184ffd7355f62ccbb221c9765886f',
    decimals: 18,
    symbol: 'RAGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8862.png',
  },
  {
    chainId: 1,
    name: 'SHOPX',
    address: '0x7bef710a5759d197ec0bf621c3df802c2d60d848',
    decimals: 18,
    symbol: 'SHOPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8863.png',
  },
  {
    chainId: 1,
    name: 'DeHive',
    address: '0x62Dc4817588d53a056cBbD18231d91ffCcd34b2A',
    decimals: 18,
    symbol: 'DHV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8867.png',
  },
  {
    chainId: 1,
    name: '50x.com',
    address: '0x4049295fb42de67ccf028a2570b05564cb8cb785',
    decimals: 8,
    symbol: '50X',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8868.png',
  },
  {
    chainId: 1,
    name: 'DAFI Protocol',
    address: '0xfc979087305a826c2b2a0056cfaba50aad3e6439',
    decimals: 18,
    symbol: 'DAFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8874.png',
  },
  {
    chainId: 1,
    name: 'Uno Re',
    address: '0x474021845c4643113458ea4414bdb7fb74a01a77',
    decimals: 18,
    symbol: 'UNO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8875.png',
  },
  {
    chainId: 1,
    name: 'ASI finance',
    address: '0x705d6cbf5352b29b4f4ee0bbe0788721f961abcd',
    decimals: 18,
    symbol: 'ASI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8876.png',
  },
  {
    chainId: 1,
    name: 'Rocket Bunny',
    address: '0x3ea50b7ef6a7eaf7e966e2cb72b519c16557497c',
    decimals: 18,
    symbol: 'BUNNY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8878.png',
  },
  {
    chainId: 1,
    name: 'Pika',
    address: '0x60F5672A271C7E39E787427A18353ba59A4A3578',
    decimals: 18,
    symbol: 'PIKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8879.png',
  },
  {
    chainId: 1,
    name: 'USDP Stablecoin',
    address: '0x1456688345527bE1f37E9e627DA0837D6f08C925',
    decimals: 18,
    symbol: 'USDP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8886.png',
  },
  {
    chainId: 1,
    name: 'Cryptocurrency Top 10 Tokens Index',
    address: '0x17ac188e09a7890a1844e5e65471fe8b0ccfadf3',
    decimals: 18,
    symbol: 'CC10',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8887.png',
  },
  {
    chainId: 1,
    name: 'ASSY Index',
    address: '0xFA2562da1Bba7B954f26C74725dF51fb62646313',
    decimals: 18,
    symbol: 'ASSY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8888.png',
  },
  {
    chainId: 1,
    name: 'Oracle Top 5 Tokens Index',
    address: '0xd6cb2adf47655b1babddc214d79257348cbc39a7',
    decimals: 18,
    symbol: 'ORCL5',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8889.png',
  },
  {
    chainId: 1,
    name: 'Tourist Review Token',
    address: '0xc6d603a9df53d1542552058c382bf115aace70c7',
    decimals: 8,
    symbol: 'TRET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8890.png',
  },
  {
    chainId: 1,
    name: 'Klondike BTC',
    address: '0xE6C3502997f97F9BDe34CB165fBce191065E068f',
    decimals: 18,
    symbol: 'KBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8892.png',
  },
  {
    chainId: 1,
    name: 'Cream ETH 2',
    address: '0x49D72e3973900A195A155a46441F0C08179FdB64',
    decimals: 18,
    symbol: 'CRETH2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8893.png',
  },
  {
    chainId: 1,
    name: 'Deeper Network',
    address: '0xf3ae5d769e153ef72b4e3591ac004e89f48107a1',
    decimals: 18,
    symbol: 'DPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8894.png',
  },
  {
    chainId: 1,
    name: 'ORAO Network',
    address: '0xEE1CeA7665bA7aa97e982EdeaeCb26B59a04d035',
    decimals: 18,
    symbol: 'ORAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8895.png',
  },
  {
    chainId: 1,
    name: 'Unslashed Finance',
    address: '0xe0e05c43c097b0982db6c9d626c4eb9e95c3b9ce',
    decimals: 18,
    symbol: 'USF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8896.png',
  },
  {
    chainId: 1,
    name: 'xSUSHI',
    address: '0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272',
    decimals: 18,
    symbol: 'XSUSHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8899.png',
  },
  {
    chainId: 1,
    name: 'Cocaine Cowboy Shards',
    address: '0xa3a3f076413a362bb0d69eea1dc5b0e79c831edc',
    decimals: 18,
    symbol: 'COKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8900.png',
  },
  {
    chainId: 1,
    name: 'Rare Pepe',
    address: '0x0e9b56d2233ea2b5883861754435f9c51dbca141',
    decimals: 18,
    symbol: 'RPEPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8901.png',
  },
  {
    chainId: 1,
    name: 'FM Gallery',
    address: '0x2991341D28Eaea277785D20e1d878D478c7bA4C7',
    decimals: 18,
    symbol: 'FMG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8902.png',
  },
  {
    chainId: 1,
    name: 'renZEC',
    address: '0x1c5db575e2ff833e46a2e9864c22f4b22e0b37c2',
    decimals: 8,
    symbol: 'RENZEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8904.png',
  },
  {
    chainId: 1,
    name: 'Klondike Finance',
    address: '0xb97d5cf2864fb0d08b34a484ff48d5492b2324a0',
    decimals: 18,
    symbol: 'KLON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8906.png',
  },
  {
    chainId: 1,
    name: 'Farming Bad',
    address: '0x11003e410ca3fcd220765b3d2f343433a0b2bffd',
    decimals: 18,
    symbol: 'METH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8907.png',
  },
  {
    chainId: 1,
    name: 'ImpulseVen',
    address: '0xe14e06671702f0db50055388c29adc66821d933b',
    decimals: 18,
    symbol: 'VEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8908.png',
  },
  {
    chainId: 1,
    name: 'Stater',
    address: '0x84bb947fcedba6b9c7dcead42df07e113bb03007',
    decimals: 18,
    symbol: 'STR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8909.png',
  },
  {
    chainId: 1,
    name: 'Strike',
    address: '0x74232704659ef37c08995e386a2e26cc27a8d7b1',
    decimals: 18,
    symbol: 'STRK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8911.png',
  },
  {
    chainId: 1,
    name: 'Tidal Finance',
    address: '0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7',
    decimals: 18,
    symbol: 'TIDAL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8912.png',
  },
  {
    chainId: 1,
    name: 'Hello Pets',
    address: '0xb870679a7fa65b924026f496de7f27c1dd0e5c5f',
    decimals: 18,
    symbol: 'PET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8915.png',
  },
  {
    chainId: 1,
    name: 'Shyft Network',
    address: '0xb17C88bDA07D28B3838E0c1dE6a30eAfBCF52D85',
    decimals: 18,
    symbol: 'SHFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8917.png',
  },
  {
    chainId: 1,
    name: 'NFT Wars',
    address: '0x4d75D9e37667a2d4677Ec3d74bDD9049326Ad8d6',
    decimals: 18,
    symbol: 'WAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8927.png',
  },
  {
    chainId: 1,
    name: 'ebox',
    address: '0x33840024177a7daca3468912363bed8b425015c5',
    decimals: 18,
    symbol: 'EBOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8930.png',
  },
  {
    chainId: 1,
    name: 'Collective',
    address: '0x75739d5944534115d7c54ee8c73f186d793bae02',
    decimals: 18,
    symbol: 'CO2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8931.png',
  },
  {
    chainId: 1,
    name: 'FarSwap',
    address: '0xe8b2a3f60697f3c56fca44a9616b91fc9b99f98f',
    decimals: 18,
    symbol: 'FAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8932.png',
  },
  {
    chainId: 1,
    name: 'StakerDAO',
    address: '0x89dcff5fd892f2bfc8b75dba12804b651f769579',
    decimals: 18,
    symbol: 'STKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8934.png',
  },
  {
    chainId: 1,
    name: 'Woonkly Power',
    address: '0xaAD483F97f13C6A20B9D05d07c397CE85c42C393',
    decimals: 18,
    symbol: 'WOOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8937.png',
  },
  {
    chainId: 1,
    name: 'Nimbus',
    address: '0xEB58343b36C7528F23CAAe63a150240241310049',
    decimals: 18,
    symbol: 'NBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8939.png',
  },
  {
    chainId: 1,
    name: 'SafeStake',
    address: '0x29FA1fee0F4F0Ab0e36eF7Ab8d7a35439eC6be75',
    decimals: 18,
    symbol: 'DVT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8940.png',
  },
  {
    chainId: 1,
    name: 'StakedZEN',
    address: '0x31b595e7cfdb624d10a3e7a562ed98c3567e3865',
    decimals: 8,
    symbol: 'STZEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8945.png',
  },
  {
    chainId: 1,
    name: 'Habitat',
    address: '0x0ace32f6e87ac1457a5385f8eb0208f37263b415',
    decimals: 10,
    symbol: 'HBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8946.png',
  },
  {
    chainId: 1,
    name: 'COPS FINANCE',
    address: '0x14dfa5cfaafe89d81d7bf3df4e11eaeda0416618',
    decimals: 18,
    symbol: 'COPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8947.png',
  },
  {
    chainId: 1,
    name: 'IFToken',
    address: '0x2731d151cbdf84a8a4c6d9d0bae74012db51e428',
    decimals: 18,
    symbol: 'IFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8949.png',
  },
  {
    chainId: 1,
    name: 'Cash Tech',
    address: '0xa42f266684ac2ad6ecb00df95b1c76efbb6f136c',
    decimals: 18,
    symbol: 'CATE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8950.png',
  },
  {
    chainId: 1,
    name: 'MYFinance',
    address: '0x22FE5BcAdA4E30A7310eFB1DfF7f90168dC42b62',
    decimals: 18,
    symbol: 'MYFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8953.png',
  },
  {
    chainId: 1,
    name: 'LNAsolution Coin',
    address: '0xf8fa5874e68dbdfa74be1bc014eb473c5a37b78f',
    decimals: 18,
    symbol: 'LAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8960.png',
  },
  {
    chainId: 1,
    name: 'Futureswap',
    address: '0x0e192d382a36de7011f795acc4391cd302003606',
    decimals: 18,
    symbol: 'FST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8961.png',
  },
  {
    chainId: 1,
    name: 'UnMarshal',
    address: '0x5a666c7d92E5fA7Edcb6390E4efD6d0CDd69cF37',
    decimals: 18,
    symbol: 'MARSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8963.png',
  },
  {
    chainId: 1,
    name: 'Hue',
    address: '0xdcfe18bc46f5a0cd0d3af0c2155d2bcb5ade2fc5',
    decimals: 18,
    symbol: 'HUE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8967.png',
  },
  {
    chainId: 1,
    name: 'Polychain Monsters',
    address: '0x1796ae0b0fa4862485106a0de9b654eFE301D0b2',
    decimals: 18,
    symbol: 'PMON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8968.png',
  },
  {
    chainId: 1,
    name: 'Lokr',
    address: '0x80ce3027a70e0a928d9268994e9b85d03bd4cdcf',
    decimals: 18,
    symbol: 'LKR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8970.png',
  },
  {
    chainId: 1,
    name: 'MerchDAO',
    address: '0xbed4ab0019ff361d83ddeb74883dac8a70f5ea1e',
    decimals: 18,
    symbol: 'MRCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8971.png',
  },
  {
    chainId: 1,
    name: 'Seedify.fund',
    address: '0x560363BdA52BC6A44CA6C8c9B4a5FadbDa32fa60',
    decimals: 18,
    symbol: 'SFUND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8972.png',
  },
  {
    chainId: 1,
    name: 'Kool Bar',
    address: '0x9d695e811beb55c98b1b3668295e390d33de5930',
    decimals: 18,
    symbol: 'KOOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8980.png',
  },
  {
    chainId: 1,
    name: 'WardenSwap',
    address: '0x0b6f3c17e1626a7cbfa4302ce4e3c45522d23a83',
    decimals: 18,
    symbol: 'WAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8981.png',
  },
  {
    chainId: 1,
    name: 'Efinity Token',
    address: '0x656C00e1BcD96f256F224AD9112FF426Ef053733',
    decimals: 18,
    symbol: 'EFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8985.png',
  },
  {
    chainId: 1,
    name: 'InvictusCapital.com Token',
    address: '0xd83c569268930fadad4cde6d0cb64450fef32b65',
    decimals: 18,
    symbol: 'ICAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8987.png',
  },
  {
    chainId: 1,
    name: 'Memes Token',
    address: '0x112eba094E03dfAC405F3AfD2d3ec8Db883762A6',
    decimals: 18,
    symbol: 'MEMES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8991.png',
  },
  {
    chainId: 1,
    name: 'Cellframe',
    address: '0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099',
    decimals: 18,
    symbol: 'CELL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8992.png',
  },
  {
    chainId: 1,
    name: 'SafeBitcoin',
    address: '0x62d693fE5C13b5A5b24C9ec3F423E51C35F5624F',
    decimals: 18,
    symbol: 'SAFEBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8993.png',
  },
  {
    chainId: 1,
    name: 'Delta',
    address: '0x9ea3b5b4ec044b70375236a281986106457b20ef',
    decimals: 18,
    symbol: 'DELTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8994.png',
  },
  {
    chainId: 1,
    name: 'Mogul Productions',
    address: '0xc55c2175e90a46602fd42e931f62b3acc1a013ca',
    decimals: 18,
    symbol: 'STARS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8996.png',
  },
  {
    chainId: 1,
    name: 'Cook Finance',
    address: '0xff75ced57419bcaebe5f05254983b013b0646ef5',
    decimals: 18,
    symbol: 'COOK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8997.png',
  },
  {
    chainId: 1,
    name: 'Kong Defi',
    address: '0x7c3cf2d43b50e78e27a81293a43fcac45796fb54',
    decimals: 18,
    symbol: 'KONG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8998.png',
  },
  {
    chainId: 1,
    name: 'Collateral Pay',
    address: '0x957891c11616d3e0b0a76a76fb42724c382e0ef3',
    decimals: 18,
    symbol: 'COLL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8999.png',
  },
  {
    chainId: 1,
    name: 'Marko Finance',
    address: '0x577e7f9fa80ab33e87a01b701114257c8d9455a8',
    decimals: 9,
    symbol: 'MARKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9001.png',
  },
  {
    chainId: 1,
    name: 'Busy DAO',
    address: '0x5CB3ce6D081fB00d5f6677d196f2d70010EA3f4a',
    decimals: 18,
    symbol: 'BUSY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9002.png',
  },
  {
    chainId: 1,
    name: 'Connectico',
    address: '0x40d2025ed2e89632d3a41d8541df9ed2ac0e2b1c',
    decimals: 18,
    symbol: 'CON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9005.png',
  },
  {
    chainId: 1,
    name: 'AMMYI Coin',
    address: '0x72c14bC8e28f18e91a2E9551802d3fB2CB80E712',
    decimals: 18,
    symbol: 'AMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9008.png',
  },
  {
    chainId: 1,
    name: 'DAOhaus',
    address: '0xf2051511b9b121394fa75b8f7d4e7424337af687',
    decimals: 18,
    symbol: 'HAUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9016.png',
  },
  {
    chainId: 1,
    name: 'Polkadex',
    address: '0xF59ae934f6fe444afC309586cC60a84a0F89Aaea',
    decimals: 18,
    symbol: 'PDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9017.png',
  },
  {
    chainId: 1,
    name: 'GamyFi Platform',
    address: '0x65ad6A2288b2Dd23E466226397c8F5D1794e58fC',
    decimals: 18,
    symbol: 'GFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9018.png',
  },
  {
    chainId: 1,
    name: 'disBalancer',
    address: '0x7fbec0bb6a7152e77c30d005b5d49cbc08a602c3',
    decimals: 18,
    symbol: 'DDOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9024.png',
  },
  {
    chainId: 1,
    name: 'Tribe',
    address: '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B',
    decimals: 18,
    symbol: 'TRIBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9025.png',
  },
  {
    chainId: 1,
    name: 'Blind Boxes',
    address: '0xe796d6ca1ceb1b022ece5296226bf784110031cd',
    decimals: 18,
    symbol: 'BLES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9026.png',
  },
  {
    chainId: 1,
    name: 'Uhive',
    address: '0xd487892bb4c57edbe7ab401d9fe801c8fe6473f5',
    decimals: 18,
    symbol: 'HVE2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9027.png',
  },
  {
    chainId: 1,
    name: 'Co2B',
    address: '0x3D90fEeC1ec985a9F09d2269aF0f77195E542297',
    decimals: 18,
    symbol: 'CO2B',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9028.png',
  },
  {
    chainId: 1,
    name: 'Graphlinq Chain',
    address: '0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24',
    decimals: 18,
    symbol: 'GLQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9029.png',
  },
  {
    chainId: 1,
    name: 'Lukutex',
    address: '0x243c56E8e740025aC6b112D7B9Af59be8eEF6E33',
    decimals: 6,
    symbol: 'LKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9030.png',
  },
  {
    chainId: 1,
    name: 'DDS.Store',
    address: '0x25e4579f028e2629ed15c70a378d82209cfb5e7d',
    decimals: 18,
    symbol: 'DDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9032.png',
  },
  {
    chainId: 1,
    name: 'LCMS',
    address: '0x86911B82BfA596e9377836838AC1f0d9AD4Ecc19',
    decimals: 18,
    symbol: 'LCMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9033.png',
  },
  {
    chainId: 1,
    name: 'pETH18C',
    address: '0xa15690e9205de386ce849889831c1668c300c1ad',
    decimals: 18,
    symbol: 'pETH18C',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9034.png',
  },
  {
    chainId: 1,
    name: 'Vidiachange',
    address: '0xE35f19E4457A114A951781aaF421EC5266eF25Fe',
    decimals: 18,
    symbol: 'VIDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9035.png',
  },
  {
    chainId: 1,
    name: 'MU DANK',
    address: '0x9ea1ae46c15a4164b74463bc26f8aa3b0eea2e6e',
    decimals: 18,
    symbol: 'DANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9041.png',
  },
  {
    chainId: 1,
    name: 'Stone DeFi',
    address: '0xe63d6b308bce0f6193aec6b7e6eba005f41e36ab',
    decimals: 18,
    symbol: 'STN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9043.png',
  },
  {
    chainId: 1,
    name: 'JPY Coin v1',
    address: '0x2370f9d504c7a6e775bf6e14b3f12846b594cd53',
    decimals: 18,
    symbol: 'JPYC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9045.png',
  },
  {
    chainId: 1,
    name: '8PAY',
    address: '0x06DDb3a8BC0aBc14f85e974CF1A93a6f8d4909d9',
    decimals: 18,
    symbol: '8PAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9046.png',
  },
  {
    chainId: 1,
    name: 'Delta Exchange Token',
    address: '0xab93df617f51e1e415b5b4f8111f122d6b48e55c',
    decimals: 18,
    symbol: 'DETO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9050.png',
  },
  {
    chainId: 1,
    name: 'Bware',
    address: '0x013062189dc3dcc99e9Cee714c513033b8d99e3c',
    decimals: 18,
    symbol: 'INFRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9052.png',
  },
  {
    chainId: 1,
    name: 'UREEQA',
    address: '0x1735Db6AB5BAa19eA55d0AdcEeD7bcDc008B3136',
    decimals: 18,
    symbol: 'URQA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9053.png',
  },
  {
    chainId: 1,
    name: 'Robo Token',
    address: '0x6fc2f1044a3b9bb3e43a43ec8f840843ed753061',
    decimals: 18,
    symbol: 'ROBO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9054.png',
  },
  {
    chainId: 1,
    name: 'Rebasing Liquidity',
    address: '0xfcfc434ee5bff924222e084a8876eee74ea7cfba',
    decimals: 18,
    symbol: 'DELTA-RLP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9056.png',
  },
  {
    chainId: 1,
    name: 'BTA Protocol',
    address: '0x270371c58d9d775ed73971dd414656107384f235',
    decimals: 18,
    symbol: 'BTAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9060.png',
  },
  {
    chainId: 1,
    name: 'Rainicorn',
    address: '0xeb953eda0dc65e3246f43dc8fa13f35623bdd5ed',
    decimals: 18,
    symbol: 'RAINI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9061.png',
  },
  {
    chainId: 1,
    name: 'LinkPool',
    address: '0x99295f1141d58a99e939f7be6bbe734916a875b8',
    decimals: 18,
    symbol: 'LPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9062.png',
  },
  {
    chainId: 1,
    name: 'DCTDAO',
    address: '0xb566e883555aebf5b1db211070b530ab00a4b18a',
    decimals: 18,
    symbol: 'DCTD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9066.png',
  },
  {
    chainId: 1,
    name: 'Olympus v2',
    address: '0x64aa3364f17a4d01c6f1751fd97c2bd3d7e7f1d5',
    decimals: 18,
    symbol: 'OHM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9067.png',
  },
  {
    chainId: 1,
    name: 'Nodeseeds',
    address: '0x747f564d258612ec5c4e24742c5fd4110bcbe46b',
    decimals: 18,
    symbol: 'NDS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9068.png',
  },
  {
    chainId: 1,
    name: 'CFX Quantum',
    address: '0x0557E0d15aeC0b9026dD17aA874fDf7d182A2cEB',
    decimals: 18,
    symbol: 'CFXQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9070.png',
  },
  {
    chainId: 1,
    name: 'Chainge',
    address: '0xb712d62fE84258292d1961B5150a19bC4Ab49026',
    decimals: 18,
    symbol: 'XCHNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9071.png',
  },
  {
    chainId: 1,
    name: 'Popsicle Finance',
    address: '0xf16e81dce15b08f326220742020379b855b87df9',
    decimals: 18,
    symbol: 'ICE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9073.png',
  },
  {
    chainId: 1,
    name: 'ZUZ Protocol',
    address: '0x202f1877e1db1120ca3e9a98c5d505e7f035c249',
    decimals: 18,
    symbol: 'ZUZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9074.png',
  },
  {
    chainId: 1,
    name: 'WasabiX',
    address: '0x896e145568624a498c5a909187363ae947631503',
    decimals: 18,
    symbol: 'WASABI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9077.png',
  },
  {
    chainId: 1,
    name: 'SafeEarth',
    address: '0xe6f1966d04cfcb9cd1b1dc4e8256d8b501b11cba',
    decimals: 9,
    symbol: 'SAFEEARTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9081.png',
  },
  {
    chainId: 1,
    name: 'Equalizer',
    address: '0x1Da87b114f35E1DC91F72bF57fc07A768Ad40Bb0',
    decimals: 18,
    symbol: 'EQZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9083.png',
  },
  {
    chainId: 1,
    name: 'fBomb',
    address: '0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979',
    decimals: 18,
    symbol: 'BOMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9085.png',
  },
  {
    chainId: 1,
    name: 'Minter HUB',
    address: '0x8e9A29e7Ed21DB7c5B2E1cd75e676dA0236dfB45',
    decimals: 18,
    symbol: 'HUB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9086.png',
  },
  {
    chainId: 1,
    name: 'xDeFi',
    address: '0x000000000000d0151e748d25b766e77efe2a6c83',
    decimals: 18,
    symbol: 'XDEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9087.png',
  },
  {
    chainId: 1,
    name: 'XBE Token',
    address: '0x5de7cc4bcbca31c473f6d2f27825cfb09cc0bb16',
    decimals: 18,
    symbol: 'XBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9092.png',
  },
  {
    chainId: 1,
    name: 'Relite Finance',
    address: '0x0e58ed58e150dba5fd8e5d4a49f54c7e1e880124',
    decimals: 18,
    symbol: 'RELI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9095.png',
  },
  {
    chainId: 1,
    name: 'Try.Finance',
    address: '0xc12eCeE46ed65D970EE5C899FCC7AE133AfF9b03',
    decimals: 18,
    symbol: 'TRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9097.png',
  },
  {
    chainId: 1,
    name: 'dART Insurance',
    address: '0x5a4623F305A8d7904ED68638AF3B4328678edDBF',
    decimals: 18,
    symbol: 'dART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9098.png',
  },
  {
    chainId: 1,
    name: 'deprecated-XANALIA',
    address: '0x9d5dc3cc15E5618434A2737DBF76158C59CA1e65',
    decimals: 18,
    symbol: 'deprecated-ALIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9099.png',
  },
  {
    chainId: 1,
    name: 'GAMEE',
    address: '0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373',
    decimals: 18,
    symbol: 'GMEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9103.png',
  },
  {
    chainId: 1,
    name: 'AIOZ Network',
    address: '0x626E8036dEB333b408Be468F951bdB42433cBF18',
    decimals: 18,
    symbol: 'AIOZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9104.png',
  },
  {
    chainId: 1,
    name: 'ARTX',
    address: '0x741b0428efdf4372a8df6fb54b018db5e5ab7710',
    decimals: 18,
    symbol: 'ARTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9105.png',
  },
  {
    chainId: 1,
    name: 'RougeCoin',
    address: '0xa1c7d450130bb77c6a23ddfaecbc4a060215384b',
    decimals: 18,
    symbol: 'XRGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9106.png',
  },
  {
    chainId: 1,
    name: 'Method Finance',
    address: '0x84ba4aecfde39d69686a841bab434c32d179a169',
    decimals: 18,
    symbol: 'MTHD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9108.png',
  },
  {
    chainId: 1,
    name: 'Savix',
    address: '0xc434b27736a6882d33094d34792999702860a13c',
    decimals: 9,
    symbol: 'SVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9109.png',
  },
  {
    chainId: 1,
    name: 'Kattana',
    address: '0x491e136ff7ff03e6ab097e54734697bb5802fc1c',
    decimals: 18,
    symbol: 'KTN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9110.png',
  },
  {
    chainId: 1,
    name: 'Push Protocol',
    address: '0xf418588522d5dd018b425E472991E52EBBeEEEEE',
    decimals: 18,
    symbol: 'PUSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9111.png',
  },
  {
    chainId: 1,
    name: 'Force DAO',
    address: '0x2c31b10ca416b82cec4c5e93c615ca851213d48d',
    decimals: 18,
    symbol: 'FORCE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9112.png',
  },
  {
    chainId: 1,
    name: 'FrogDAO Dime',
    address: '0x14cfc7aeaa468e8c789785c39e0b753915aeb426',
    decimals: 18,
    symbol: '$FDD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9113.png',
  },
  {
    chainId: 1,
    name: 'WorkQuest Token',
    address: '0x06677dc4fe12d3ba3c7ccfd0df8cd45e4d4095bf',
    decimals: 18,
    symbol: 'WQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9115.png',
  },
  {
    chainId: 1,
    name: 'Finminity',
    address: '0x99c6e435eC259A7E8d65E1955C9423DB624bA54C',
    decimals: 18,
    symbol: 'FMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9116.png',
  },
  {
    chainId: 1,
    name: 'Scaleswap',
    address: '0x1FbD3dF007eB8A7477A1Eab2c63483dCc24EfFD6',
    decimals: 18,
    symbol: 'SCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9118.png',
  },
  {
    chainId: 1,
    name: 'Alien Worlds',
    address: '0x888888848B652B3E3a0f34c96E00EEC0F3a23F72',
    decimals: 4,
    symbol: 'TLM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9119.png',
  },
  {
    chainId: 1,
    name: 'Franklin',
    address: '0x85f6eb2bd5a062f5f8560be93fb7147e16c81472',
    decimals: 18,
    symbol: 'FLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9120.png',
  },
  {
    chainId: 1,
    name: 'Secret Finance',
    address: '0x773258b03c730f84af10dfcb1bfaa7487558b8ac',
    decimals: 18,
    symbol: 'SEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9123.png',
  },
  {
    chainId: 1,
    name: 'Gains',
    address: '0x056C1D42Fb1326f57da7f19eBB7dDA4673f1FF55',
    decimals: 18,
    symbol: 'GAINS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9125.png',
  },
  {
    chainId: 1,
    name: 'Wrapped ECOMI',
    address: '0x04969cd041c0cafb6ac462bd65b536a5bdb3a670',
    decimals: 18,
    symbol: 'WOMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9126.png',
  },
  {
    chainId: 1,
    name: 'Alchemist',
    address: '0x88acdd2a6425c3faae4bc9650fd7e27e0bebb7ab',
    decimals: 18,
    symbol: 'MIST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9131.png',
  },
  {
    chainId: 1,
    name: 'MobiFi',
    address: '0xb2dbf14d0b47ed3ba02bdb7c954e05a72deb7544',
    decimals: 18,
    symbol: 'MoFi',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9132.png',
  },
  {
    chainId: 1,
    name: 'NBX',
    address: '0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca',
    decimals: 18,
    symbol: 'BYN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9134.png',
  },
  {
    chainId: 1,
    name: 'EURxb',
    address: '0x0beAD9a1bcc1b84D06E3f2df67E3549Fd55aB054',
    decimals: 18,
    symbol: 'EURXB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9136.png',
  },
  {
    chainId: 1,
    name: 'Weiner Finance',
    address: '0xd3239cb876ae9d7da7918a3a076cba3b02eda652',
    decimals: 12,
    symbol: 'WENR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9143.png',
  },
  {
    chainId: 1,
    name: 'Sqrtle Finance',
    address: '0xC05cb5F1D51ac23Cfe9b4530DE72B11Ccf4C1377',
    decimals: 12,
    symbol: 'SQRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9146.png',
  },
  {
    chainId: 1,
    name: 'Cryptonovae',
    address: '0x4ee438be38f8682abb089f2bfea48851c5e71eaf',
    decimals: 18,
    symbol: 'YAE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9149.png',
  },
  {
    chainId: 1,
    name: 'ShardingDAO',
    address: '0x5845cd0205b5d43af695412a79cf7c1aeddb060f',
    decimals: 18,
    symbol: 'SHD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9151.png',
  },
  {
    chainId: 1,
    name: 'Interest Bearing Defi Pulse Index',
    address: '0x0309c98b1bffa350bcb3f9fb9780970ca32a5060',
    decimals: 18,
    symbol: 'BDPI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9153.png',
  },
  {
    chainId: 1,
    name: 'Elastic Governance',
    address: '0x2aa5ce395b00cc486159adbdd97c55b535cf2cf9',
    decimals: 18,
    symbol: 'EGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9154.png',
  },
  {
    chainId: 1,
    name: 'Space Hoge',
    address: '0x41933422dc4a1cb8c822e06f12f7b52fa5e7e094',
    decimals: 18,
    symbol: 'SOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9156.png',
  },
  {
    chainId: 1,
    name: 'Linkflow Finance',
    address: '0x88665a7556e1b3c939d6661248116886845249a8',
    decimals: 18,
    symbol: 'LF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9160.png',
  },
  {
    chainId: 1,
    name: 'Secure Pad',
    address: '0x10994aa2fb8e6ba5d9fb2bc127ff228c4fe6167f',
    decimals: 18,
    symbol: 'SEPA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9163.png',
  },
  {
    chainId: 1,
    name: 'MMAON',
    address: '0x8315472bae77f9a2b856a67eb0796480aafcd51c',
    decimals: 18,
    symbol: 'MMAON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9169.png',
  },
  {
    chainId: 1,
    name: 'Visor.Finance',
    address: '0xf938424f7210f31df2aee3011291b658f872e91e',
    decimals: 18,
    symbol: 'VISR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9170.png',
  },
  {
    chainId: 1,
    name: 'AMPnet Asset Platform and Exchange',
    address: '0xbfd815347d024f449886c171f78fa5b8e6790811',
    decimals: 18,
    symbol: 'AAPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9171.png',
  },
  {
    chainId: 1,
    name: 'Raze Network',
    address: '0x5Eaa69B29f99C84Fe5dE8200340b4e9b4Ab38EaC',
    decimals: 18,
    symbol: 'RAZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9173.png',
  },
  {
    chainId: 1,
    name: 'RocketX exchange',
    address: '0x2fb652314C3d850E9049057bBE9813F1eEe882d3',
    decimals: 18,
    symbol: 'RVF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9176.png',
  },
  {
    chainId: 1,
    name: 'YFS.FINANCE',
    address: '0x92d984ff5593fcc209adb525adef90d119eb0d9d',
    decimals: 18,
    symbol: 'YFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9181.png',
  },
  {
    chainId: 1,
    name: 'Dark Matter',
    address: '0x79126d32a86e6663f3aaac4527732d0701c1ae6c',
    decimals: 18,
    symbol: 'DMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9186.png',
  },
  {
    chainId: 1,
    name: 'MY IDENTITY COIN',
    address: '0x5273063725a43a323300c502478c22fbb4e92c2d',
    decimals: 18,
    symbol: 'MYID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9187.png',
  },
  {
    chainId: 1,
    name: 'Globe Derivative Exchange',
    address: '0xc67b12049c2d0cf6e476bc64c7f82fc6c63cffc5',
    decimals: 18,
    symbol: 'GDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9188.png',
  },
  {
    chainId: 1,
    name: 'Occam.Fi',
    address: '0x2f109021afe75b949429fe30523ee7c0d5b27207',
    decimals: 18,
    symbol: 'OCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9191.png',
  },
  {
    chainId: 1,
    name: 'Kambria Yield Tuning Engine',
    address: '0xa053c1b7013e77fe0a873ce0ca2bd5d0b7414c41',
    decimals: 18,
    symbol: 'KYTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9192.png',
  },
  {
    chainId: 1,
    name: 'Prostarter',
    address: '0x2341dd0a96a0dab62aa1efb93d59ff7f3bdb8932',
    decimals: 18,
    symbol: 'PROT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9193.png',
  },
  {
    chainId: 1,
    name: 'Saito',
    address: '0xFa14Fa6958401314851A17d6C5360cA29f74B57B',
    decimals: 18,
    symbol: 'SAITO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9194.png',
  },
  {
    chainId: 1,
    name: 'Genesis Shards',
    address: '0xe0b9a2c3e9f40cf74b2c7f591b2b0cca055c3112',
    decimals: 18,
    symbol: 'GS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9196.png',
  },
  {
    chainId: 1,
    name: 'Hord',
    address: '0x43a96962254855f16b925556f9e97be436a43448',
    decimals: 18,
    symbol: 'HORD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9198.png',
  },
  {
    chainId: 1,
    name: 'AgriChain',
    address: '0xa704fce7b309ec09df16e2f5ab8caf6fe8a4baa9',
    decimals: 18,
    symbol: 'AGRI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9202.png',
  },
  {
    chainId: 1,
    name: 'K21',
    address: '0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af',
    decimals: 18,
    symbol: 'K21',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9205.png',
  },
  {
    chainId: 1,
    name: 'Metaverse Index',
    address: '0x72e364f2abdc788b7e918bc238b21f109cd634d7',
    decimals: 18,
    symbol: 'MVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9207.png',
  },
  {
    chainId: 1,
    name: 'Unbox.Art',
    address: '0x817e2addceaa4907623666a7800b1553ca21192d',
    decimals: 18,
    symbol: 'UBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9211.png',
  },
  {
    chainId: 1,
    name: 'XFai',
    address: '0x4aa41bC1649C9C3177eD16CaaA11482295fC7441',
    decimals: 18,
    symbol: 'XFIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9217.png',
  },
  {
    chainId: 1,
    name: 'BasenjiDAO',
    address: '0x43901e05f08f48546fff8d6f8df108f60570498b',
    decimals: 18,
    symbol: 'BSJ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9219.png',
  },
  {
    chainId: 1,
    name: 'Rigel Protocol',
    address: '0x4af5ff1a60a6ef6c7c8f9c4e304cd9051fca3ec0',
    decimals: 18,
    symbol: 'RGP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9225.png',
  },
  {
    chainId: 1,
    name: 'ziot Coin',
    address: '0xfb22ced41b1267da411f68c879f4defd0bd4796a',
    decimals: 18,
    symbol: 'ZIOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9226.png',
  },
  {
    chainId: 1,
    name: 'Value Network',
    address: '0xd0f05d3d4e4d1243ac826d8c6171180c58eaa9bc',
    decimals: 18,
    symbol: 'VNTW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9230.png',
  },
  {
    chainId: 1,
    name: 'IQONIQ FanEcoSystem',
    address: '0x68a9d92fe19399feebed6a9a0980a7ea7638074c',
    decimals: 18,
    symbol: 'IQQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9233.png',
  },
  {
    chainId: 1,
    name: 'FrogeX',
    address: '0x5fa54fddf1870c344dbfabb37dfab8700ec0def1',
    decimals: 18,
    symbol: 'FROGEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9234.png',
  },
  {
    chainId: 1,
    name: 'TopBidder',
    address: '0x00000000000045166c45af0fc6e4cf31d9e14b9a',
    decimals: 18,
    symbol: 'BID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9236.png',
  },
  {
    chainId: 1,
    name: 'SENPAI',
    address: '0x5a705745373a780814c379ef17810630d529efe0',
    decimals: 18,
    symbol: 'SENPAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9242.png',
  },
  {
    chainId: 1,
    name: 'Signata',
    address: '0x3ebb4A4e91Ad83BE51F8d596533818b246F4bEe1',
    decimals: 18,
    symbol: 'SATA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9245.png',
  },
  {
    chainId: 1,
    name: 'Saren',
    address: '0xbd4a858139b155219e2c8d10135003fdef720b6b',
    decimals: 18,
    symbol: 'SAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9250.png',
  },
  {
    chainId: 1,
    name: 'Standard',
    address: '0x9040e237C3bF18347bb00957Dc22167D0f2b999d',
    decimals: 18,
    symbol: 'STND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9251.png',
  },
  {
    chainId: 1,
    name: 'Zignaly',
    address: '0xb2617246d0c6c0087f18703d576831899ca94f01',
    decimals: 18,
    symbol: 'ZIG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9260.png',
  },
  {
    chainId: 1,
    name: 'KelVPN',
    address: '0x4abb9cc67bd3da9eb966d1159a71a0e68bd15432',
    decimals: 18,
    symbol: 'KEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9261.png',
  },
  {
    chainId: 1,
    name: 'UniFarm',
    address: '0x40986a85b4cfcdb054a6cbfb1210194fee51af88',
    decimals: 18,
    symbol: 'UFARM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9262.png',
  },
  {
    chainId: 1,
    name: 'Unizen',
    address: '0xc52c326331e9ce41f04484d3b5e5648158028804',
    decimals: 18,
    symbol: 'ZCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9263.png',
  },
  {
    chainId: 1,
    name: 'PolkaDomain',
    address: '0xe1A4c5BBb704a92599FEdB191f451E0d3a1ed842',
    decimals: 18,
    symbol: 'NAME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9264.png',
  },
  {
    chainId: 1,
    name: 'Munch Token',
    address: '0x944eee930933be5e23b690c8589021ec8619a301',
    decimals: 9,
    symbol: 'MUNCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9272.png',
  },
  {
    chainId: 1,
    name: 'Revolution Populi',
    address: '0x17ef75aa22dd5f6c2763b8304ab24f40ee54d48a',
    decimals: 18,
    symbol: 'RVP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9277.png',
  },
  {
    chainId: 1,
    name: 'Bulldog Token',
    address: '0x92416e32042c9e67b0771a1b00bcdf92ecb64950',
    decimals: 18,
    symbol: 'BDOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9280.png',
  },
  {
    chainId: 1,
    name: 'Doge Killer',
    address: '0x27c70cd1946795b66be9d954418546998b546634',
    decimals: 18,
    symbol: 'LEASH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9286.png',
  },
  {
    chainId: 1,
    name: 'Uniqly',
    address: '0x3758e00b100876c854636ef8db61988931bb8025',
    decimals: 18,
    symbol: 'UNIQ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9287.png',
  },
  {
    chainId: 1,
    name: 'Chainswap',
    address: '0xcc665390b03c5d324d8faf81c15ecee29a73bcb4',
    decimals: 18,
    symbol: 'ASAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9289.png',
  },
  {
    chainId: 1,
    name: 'Ternoa',
    address: '0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2',
    decimals: 18,
    symbol: 'CAPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9291.png',
  },
  {
    chainId: 1,
    name: 'SAFESUN',
    address: '0xc61708603C7b317Eb4e84c923370f50eD9aD8077',
    decimals: 9,
    symbol: 'SAFESUN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9294.png',
  },
  {
    chainId: 1,
    name: 'Unique Fans',
    address: '0xd33d0eb1c0c0295c3a2409a9101dd511823bf217',
    decimals: 18,
    symbol: 'FANS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9301.png',
  },
  {
    chainId: 1,
    name: 'DAIN',
    address: '0xd7d706ED3598a354A4aDFce5D8C5383dF99a4461',
    decimals: 18,
    symbol: 'DAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9304.png',
  },
  {
    chainId: 1,
    name: 'Daxhund',
    address: '0x42891d10b550d0c5c4ac2e17bcd7e2a19c7230f0',
    decimals: 18,
    symbol: 'DXH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9317.png',
  },
  {
    chainId: 1,
    name: 'BeforeCoinMarketCap',
    address: '0xd5e2a54fef5f9e4a6b21ec646bbed7a160a00f18',
    decimals: 18,
    symbol: 'BCMC1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9318.png',
  },
  {
    chainId: 1,
    name: 'Vanilla',
    address: '0xbf900809f4c73e5a3476eb183d8b06a27e61f8e5',
    decimals: 18,
    symbol: 'VNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9319.png',
  },
  {
    chainId: 1,
    name: 'BondAppétit Governance Token',
    address: '0x28A06c02287e657ec3F8e151A13C36A1D43814b0',
    decimals: 18,
    symbol: 'BAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9322.png',
  },
  {
    chainId: 1,
    name: 'Crypto Excellence',
    address: '0x8f12dfc7981de79a8a34070a732471f2d335eece',
    decimals: 18,
    symbol: 'CE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9329.png',
  },
  {
    chainId: 1,
    name: 'Community Business Token',
    address: '0xfA93660C3f6a848556Bb8E265f994160A1F2B289',
    decimals: 18,
    symbol: 'CBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9342.png',
  },
  {
    chainId: 1,
    name: '1MillionNFTs',
    address: '0xa4ef4b0b23c1fc81d3f9ecf93510e64f58a4a016',
    decimals: 18,
    symbol: '1MIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9344.png',
  },
  {
    chainId: 1,
    name: 'NFTify',
    address: '0xacbd826394189cf2623c6df98a18b41fc8ffc16d',
    decimals: 18,
    symbol: 'N1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9346.png',
  },
  {
    chainId: 1,
    name: 'EmploymentCoin',
    address: '0x3fF426Ca07A9F589a80f18CCCC759E84CF06f0Eb',
    decimals: 18,
    symbol: 'EC2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9360.png',
  },
  {
    chainId: 1,
    name: 'Unlock Protocol',
    address: '0x90de74265a416e1393a450752175aed98fe11517',
    decimals: 18,
    symbol: 'UDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9364.png',
  },
  {
    chainId: 1,
    name: 'Stoner Doge Finance',
    address: '0x1296a923cd4f39116e0297d921fe25fe228552c6',
    decimals: 18,
    symbol: 'STOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9381.png',
  },
  {
    chainId: 1,
    name: 'Elastic Bitcoin',
    address: '0x64fB96d0395f6bf105F35233911e3dF2C5bf4Ce8',
    decimals: 8,
    symbol: 'XBT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9383.png',
  },
  {
    chainId: 1,
    name: 'Kishu Inu',
    address: '0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D',
    decimals: 18,
    symbol: 'KISHU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9386.png',
  },
  {
    chainId: 1,
    name: 'Husky',
    address: '0xd5281bb2d1ee94866b03a0fccdd4e900c8cb5091',
    decimals: 18,
    symbol: 'HUSKY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9387.png',
  },
  {
    chainId: 1,
    name: 'Chainsquare',
    address: '0xb41380174d0B06181513A5677b60200b93b5Efb4',
    decimals: 18,
    symbol: 'CHS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9390.png',
  },
  {
    chainId: 1,
    name: 'Ethersocks',
    address: '0x300a902513815028e97fc79e92082ce6a98d3b74',
    decimals: 18,
    symbol: 'SOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9397.png',
  },
  {
    chainId: 1,
    name: 'Maple',
    address: '0x33349b282065b0284d756f0577fb39c158f935e6',
    decimals: 18,
    symbol: 'MPL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9417.png',
  },
  {
    chainId: 1,
    name: 'BlockSwap Network',
    address: '0x7d4B1d793239707445305D8d2456D2c735F6B25B',
    decimals: 18,
    symbol: 'CBSN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9418.png',
  },
  {
    chainId: 1,
    name: 'SwapDEX',
    address: '0x6b5fec1351c9ff830db0ebe343a235976b6352ea',
    decimals: 18,
    symbol: 'SDX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9420.png',
  },
  {
    chainId: 1,
    name: 'Ampleforth Governance Token',
    address: '0x77fba179c79de5b7653f68b5039af940ada60ce0',
    decimals: 18,
    symbol: 'FORTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9421.png',
  },
  {
    chainId: 1,
    name: 'Phuture',
    address: '0xe1fc4455f62a6e89476f1072530c20cf1a0622da',
    decimals: 18,
    symbol: 'PHTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9423.png',
  },
  {
    chainId: 1,
    name: 'Gaugecash',
    address: '0x8ce7386fe7688417885adebcbfc01a5445226b2c',
    decimals: 18,
    symbol: 'GAUF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9424.png',
  },
  {
    chainId: 1,
    name: 'Alphr finance',
    address: '0xaa99199d1e9644b588796F3215089878440D58e0',
    decimals: 18,
    symbol: 'ALPHR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9430.png',
  },
  {
    chainId: 1,
    name: 'Crypto Kombat',
    address: '0x878cf148ccbb50426043a9affe54ba408221c7fa',
    decimals: 8,
    symbol: 'KOMBAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9432.png',
  },
  {
    chainId: 1,
    name: 'GazeTV',
    address: '0xd1e06952708771f71e6dd18f06ee418f6e8fc564',
    decimals: 18,
    symbol: 'GAZE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9433.png',
  },
  {
    chainId: 1,
    name: 'Dogelon Mars',
    address: '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3',
    decimals: 18,
    symbol: 'ELON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9436.png',
  },
  {
    chainId: 1,
    name: 'Mochi Market',
    address: '0xbd1848e1491d4308ad18287a745dd4db2a4bd55b',
    decimals: 18,
    symbol: 'MOMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9440.png',
  },
  {
    chainId: 1,
    name: 'Jigstack',
    address: '0x1f8a626883d7724dbd59ef51cbd4bf1cf2016d13',
    decimals: 18,
    symbol: 'STAK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9441.png',
  },
  {
    chainId: 1,
    name: 'Kyber Network Crystal v2',
    address: '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202',
    decimals: 18,
    symbol: 'KNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9444.png',
  },
  {
    chainId: 1,
    name: 'BLACKHOLE PROTOCOL',
    address: '0xd714d91A169127e11D8FAb3665d72E8b7ef9Dbe2',
    decimals: 18,
    symbol: 'BLACK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9450.png',
  },
  {
    chainId: 1,
    name: 'Lemond',
    address: '0xf45f6c8bb3d77ea762175b8f7ca4d251941649fa',
    decimals: 18,
    symbol: 'LEMD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9455.png',
  },
  {
    chainId: 1,
    name: 'HOKK Finance',
    address: '0xe87e15b9c7d989474cb6d8c56b3db4efad5b21e8',
    decimals: 18,
    symbol: 'HOKK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9458.png',
  },
  {
    chainId: 1,
    name: 'X World Games',
    address: '0x0a77ef9bf662d62fbf9ba4cf861eaa83f9cc4fec',
    decimals: 18,
    symbol: 'XWG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9461.png',
  },
  {
    chainId: 1,
    name: 'Unicly Genesis Collection',
    address: '0x3d9233f15bb93c78a4f07b5c5f7a018630217cb3',
    decimals: 18,
    symbol: 'UUNICLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9469.png',
  },
  {
    chainId: 1,
    name: 'Unicly Aavegotchi Astronauts Collection',
    address: '0x30c2a84aed6db30e31cf4d7059b1836c12c68068',
    decimals: 18,
    symbol: 'UGOTCHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9472.png',
  },
  {
    chainId: 1,
    name: 'Unicly CryptoPunks Collection',
    address: '0x8d2bffcbb19ff14a698c424fbcdcfd17aab9b905',
    decimals: 18,
    symbol: 'UPUNK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9473.png',
  },
  {
    chainId: 1,
    name: 'Unicly Doki Doki Collection',
    address: '0x7e6c38d007740931e4b419bf15a68c79a0fb0c66',
    decimals: 18,
    symbol: 'UDOKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9474.png',
  },
  {
    chainId: 1,
    name: 'Unicly Chris McCann Collection',
    address: '0x5fb99a3593d7088e44377a1beb27739bd928f269',
    decimals: 18,
    symbol: 'UCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9475.png',
  },
  {
    chainId: 1,
    name: 'Unicly Mystic Axies Collection',
    address: '0x68b1cadb8d5ab0c97fe9d9fbe0eb60acb329fe3f',
    decimals: 18,
    symbol: 'UAXIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9476.png',
  },
  {
    chainId: 1,
    name: 'Unicly Hashmasks Collection',
    address: '0x5872e64c3f93363822d2b1e4717be3398fdcea51',
    decimals: 18,
    symbol: 'UMASK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9477.png',
  },
  {
    chainId: 1,
    name: 'Pendle',
    address: '0x808507121b80c02388fad14726482e061b8da827',
    decimals: 18,
    symbol: 'PENDLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9481.png',
  },
  {
    chainId: 1,
    name: 'Lympo Market Token',
    address: '0x327673ae6b33bd3d90f0096870059994f30dc8af',
    decimals: 18,
    symbol: 'LMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9482.png',
  },
  {
    chainId: 1,
    name: 'E1337',
    address: '0x35872fea6a4843facbcdbce99e3b69596a3680b8',
    decimals: 4,
    symbol: '1337',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9484.png',
  },
  {
    chainId: 1,
    name: 'Ara Blocks',
    address: '0xa92e7c82b11d10716ab534051b271d2f6aef7df5',
    decimals: 18,
    symbol: 'ARA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9490.png',
  },
  {
    chainId: 1,
    name: 'Etherland',
    address: '0x33e07f5055173cf8febede8b21b12d1e2b523205',
    decimals: 18,
    symbol: 'ELAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9492.png',
  },
  {
    chainId: 1,
    name: 'Reflexer Ungovernance Token',
    address: '0x6243d8cea23066d098a15582d81a598b4e8391f4',
    decimals: 18,
    symbol: 'FLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9493.png',
  },
  {
    chainId: 1,
    name: 'EnreachDAO',
    address: '0x69fa8e7f6bf1ca1fb0de61e1366f7412b827cc51',
    decimals: 9,
    symbol: 'NRCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9498.png',
  },
  {
    chainId: 1,
    name: 'ACAB Token',
    address: '0xF754620784E797f3681F9f295b2528455D2fC0d0',
    decimals: 9,
    symbol: 'ACAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9499.png',
  },
  {
    chainId: 1,
    name: 'Super Algorithmic Token',
    address: '0xF6E6892325a74383A70570F1EBea9A476483a611',
    decimals: 18,
    symbol: 'SATO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9500.png',
  },
  {
    chainId: 1,
    name: 'NAOS Finance',
    address: '0x4a615bb7166210cce20e6642a6f8fb5d4d044496',
    decimals: 18,
    symbol: 'NAOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9504.png',
  },
  {
    chainId: 1,
    name: 'Lever Token',
    address: '0xbc194e6f748a222754c3e8b9946922c09e7d4e91',
    decimals: 18,
    symbol: 'LEV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9505.png',
  },
  {
    chainId: 1,
    name: 'Dfyn Network',
    address: '0x9695e0114e12c0d3a3636fab5a18e6b737529023',
    decimals: 18,
    symbol: 'DFYN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9511.png',
  },
  {
    chainId: 1,
    name: 'OPU Coin',
    address: '0x65e3c4a750a2e7cc7cce86d01587bbcbbe99042e',
    decimals: 18,
    symbol: 'OPU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9514.png',
  },
  {
    chainId: 1,
    name: 'LabraCoin',
    address: '0x106d3c66d22d2dd0446df23d7f5960752994d600',
    decimals: 9,
    symbol: 'LABRA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9519.png',
  },
  {
    chainId: 1,
    name: 'LOCGame',
    address: '0x60eb57d085c59932d5faa6c6026268a4386927d0',
    decimals: 18,
    symbol: 'LOCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9526.png',
  },
  {
    chainId: 1,
    name: 'Impermax',
    address: '0x7b35ce522cb72e4077baeb96cb923a5529764a00',
    decimals: 18,
    symbol: 'IMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9532.png',
  },
  {
    chainId: 1,
    name: 'CrossFi',
    address: '0x8848812bd31aeee33313c10a840ffc3169078c5b',
    decimals: 18,
    symbol: 'CRFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9535.png',
  },
  {
    chainId: 1,
    name: 'EpiK Protocol',
    address: '0xac5b038058bcd0424c9c252c6487c25f032e5ddc',
    decimals: 18,
    symbol: 'AIEPK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9537.png',
  },
  {
    chainId: 1,
    name: 'Anti-Lockdown',
    address: '0xc2bd7a597391f31d2e36c2cb769fce0e5bd6d482',
    decimals: 18,
    symbol: 'FREE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9538.png',
  },
  {
    chainId: 1,
    name: 'UnitedCrowd',
    address: '0x6d1dc3928604b00180bb570bdae94b9698d33b79',
    decimals: 18,
    symbol: 'UCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9539.png',
  },
  {
    chainId: 1,
    name: 'Ito Vault',
    address: '0x44e28f2acc84c36373badcd681749d38e01e2cc4',
    decimals: 18,
    symbol: 'VSPACEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9540.png',
  },
  {
    chainId: 1,
    name: 'Car Coin',
    address: '0xbc6669e7914a2b327ae428184086d8ac88d74efc',
    decimals: 18,
    symbol: 'CCM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9542.png',
  },
  {
    chainId: 1,
    name: 'Biconomy',
    address: '0xf17e65822b568b3903685a7c9f496cf7656cc6c2',
    decimals: 18,
    symbol: 'BICO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9543.png',
  },
  {
    chainId: 1,
    name: 'POLKARARE',
    address: '0x2C2f7e7C5604D162d75641256b80F1Bf6f4dC796',
    decimals: 18,
    symbol: 'PRARE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9544.png',
  },
  {
    chainId: 1,
    name: 'tSILVER',
    address: '0x34abce75d2f8f33940c721dca0f562617787bff3',
    decimals: 18,
    symbol: 'TXAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9547.png',
  },
  {
    chainId: 1,
    name: 'PERI Finance',
    address: '0x5d30aD9C6374Bf925D0A75454fa327AACf778492',
    decimals: 18,
    symbol: 'PERI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9550.png',
  },
  {
    chainId: 1,
    name: 'Digible',
    address: '0x3CbF23c081fAA5419810ce0F6BC1ECb73006d848',
    decimals: 18,
    symbol: 'DIGI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9551.png',
  },
  {
    chainId: 1,
    name: 'B-cube.ai',
    address: '0x93C9175E26F57d2888c7Df8B470C9eeA5C0b0A93',
    decimals: 18,
    symbol: 'BCUBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9553.png',
  },
  {
    chainId: 1,
    name: 'EtherSmart',
    address: '0xf3eb8b90c763b8b2b53e7819ac27eca8f94c8ec2',
    decimals: 18,
    symbol: 'ETM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9554.png',
  },
  {
    chainId: 1,
    name: 'UNILAYERX',
    address: '0xfe56e974c1c85e9351325fb2d62963a022ad624f',
    decimals: 18,
    symbol: 'LAYERX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9559.png',
  },
  {
    chainId: 1,
    name: 'Crypto Puzzles ERC20',
    address: '0xe0bdfe2ce51f44556309665d59818ccb541ff067',
    decimals: 18,
    symbol: 'CPTE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9561.png',
  },
  {
    chainId: 1,
    name: 'Coldstack',
    address: '0x675bbc7514013e2073db7a919f6e4cbef576de37',
    decimals: 18,
    symbol: 'CLS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9562.png',
  },
  {
    chainId: 1,
    name: 'TradeStars',
    address: '0x734c90044a0ba31b3f2e640c10dc5d3540499bfd',
    decimals: 18,
    symbol: 'TSX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9563.png',
  },
  {
    chainId: 1,
    name: 'CryptoCart',
    address: '0x9e547061a345015869d26c7b6ee4ab5b63424441',
    decimals: 18,
    symbol: 'CC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9564.png',
  },
  {
    chainId: 1,
    name: 'Liquity USD',
    address: '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    decimals: 18,
    symbol: 'LUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9566.png',
  },
  {
    chainId: 1,
    name: 'OXO.Farm',
    address: '0x47dac6bd80f024575a6d367af5ba8e89202a09fc',
    decimals: 18,
    symbol: 'OXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9569.png',
  },
  {
    chainId: 1,
    name: 'CoShi Inu',
    address: '0x668c50b1c7f46effbe3f242687071d7908aab00a',
    decimals: 9,
    symbol: 'COSHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9574.png',
  },
  {
    chainId: 1,
    name: 'Mycro',
    address: '0x50987e6be405ebac691f8988304562e5efc3b2ea',
    decimals: 18,
    symbol: 'MYO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9577.png',
  },
  {
    chainId: 1,
    name: 'Corra.Finance',
    address: '0x6a7260e44789aef24fdaf72d80ecdc253aaa079e',
    decimals: 18,
    symbol: 'CORA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9579.png',
  },
  {
    chainId: 1,
    name: 'Evolution Finance',
    address: '0x9af15d7b8776fa296019979e70a5be53c714a7ec',
    decimals: 18,
    symbol: 'EVN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9580.png',
  },
  {
    chainId: 1,
    name: 'MELX',
    address: '0xed0889f7e1c7c7267407222be277e1f1ef4d4892',
    decimals: 18,
    symbol: 'MEL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9583.png',
  },
  {
    chainId: 1,
    name: 'O3 Swap',
    address: '0xee9801669c6138e84bd50deb500827b776777d28',
    decimals: 18,
    symbol: 'O3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9588.png',
  },
  {
    chainId: 1,
    name: 'Obortech',
    address: '0xedadeb5faa413e6c8623461849dfd0b7c3790c32',
    decimals: 18,
    symbol: 'OBOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9590.png',
  },
  {
    chainId: 1,
    name: 'Arteon',
    address: '0x897abf83f0c44b86cb67ec56c006c00d56659517',
    decimals: 18,
    symbol: 'ARTEON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9591.png',
  },
  {
    chainId: 1,
    name: 'EQO',
    address: '0x46e9fe43470fafd690100c86037f9e566e24d480',
    decimals: 18,
    symbol: 'EQO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9593.png',
  },
  {
    chainId: 1,
    name: 'g9tro Crowdfunding Platform',
    address: '0xfc64c0adf4a08008e3fa2bf9c03540032b1c8288',
    decimals: 10,
    symbol: 'G9TRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9594.png',
  },
  {
    chainId: 1,
    name: 'CaliCoin',
    address: '0xb8fa12f8409da31a4fc43d15c4c78c33d8213b9b',
    decimals: 18,
    symbol: 'CALI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9595.png',
  },
  {
    chainId: 1,
    name: 'dFund',
    address: '0xd2adc1c84443ad06f0017adca346bd9b6fc52cab',
    decimals: 18,
    symbol: 'DFND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9597.png',
  },
  {
    chainId: 1,
    name: 'Lion Token',
    address: '0xc8ff6772f605a139c40b32d5d87d54994c705c6b',
    decimals: 18,
    symbol: 'LION',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9598.png',
  },
  {
    chainId: 1,
    name: 'Mixsome',
    address: '0x3e8ffc8c3cb0db3081df85dec91b63abbbe99f71',
    decimals: 18,
    symbol: 'SOME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9599.png',
  },
  {
    chainId: 1,
    name: 'Forefront',
    address: '0x7e9d8f07a64e363e97a648904a89fb4cd5fb94cd',
    decimals: 18,
    symbol: 'FF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9601.png',
  },
  {
    chainId: 1,
    name: 'Privapp Network',
    address: '0xa82e4aa4c8d0859b1dd333145b6dd488f23e9782',
    decimals: 18,
    symbol: 'bPRIVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9604.png',
  },
  {
    chainId: 1,
    name: 'TruePNL',
    address: '0x9fc8f0ca1668e87294941b7f627e9c15ea06b459',
    decimals: 18,
    symbol: 'PNL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9605.png',
  },
  {
    chainId: 1,
    name: 'Plethori',
    address: '0x3873965e73d9a21f88e645ce40b7db187fde4931',
    decimals: 18,
    symbol: 'PLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9606.png',
  },
  {
    chainId: 1,
    name: 'Bankless DAO',
    address: '0x2d94aa3e47d9d5024503ca8491fce9a2fb4da198',
    decimals: 18,
    symbol: 'BANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9607.png',
  },
  {
    chainId: 1,
    name: 'SpookySwap',
    address: '0x55af5865807b196bd0197e0902746f31fbccfa58',
    decimals: 18,
    symbol: 'BOO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9608.png',
  },
  {
    chainId: 1,
    name: 'CompliFi',
    address: '0x752efadc0a7e05ad1bcccda22c141d01a75ef1e4',
    decimals: 18,
    symbol: 'COMFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9609.png',
  },
  {
    chainId: 1,
    name: 'Ganesha Token',
    address: '0x7c5ff719a6c76fe643e9ecd0f11f146a2de05f14',
    decimals: 18,
    symbol: 'GNSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9616.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Statera',
    address: '0xedeec5691f23e4914cf0183a4196bbeb30d027a0',
    decimals: 18,
    symbol: 'WSTA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9620.png',
  },
  {
    chainId: 1,
    name: 'Nftfy',
    address: '0xbf6ff49ffd3d104302ef0ab0f10f5a84324c091c',
    decimals: 18,
    symbol: 'NFTFY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9622.png',
  },
  {
    chainId: 1,
    name: 'Emblem',
    address: '0xdb0acc14396d108b3c5574483acb817855c9dc8d',
    decimals: 8,
    symbol: 'EMB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9626.png',
  },
  {
    chainId: 1,
    name: 'Kally',
    address: '0xfd30c9bea1a952feeed2ef2c6b2ff8a8fc4aad07',
    decimals: 18,
    symbol: 'KALLY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9631.png',
  },
  {
    chainId: 1,
    name: 'UMI',
    address: '0x46943113ae84e732bb510b5f7686d8b76ff56774',
    decimals: 18,
    symbol: 'UMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9632.png',
  },
  {
    chainId: 1,
    name: 'SingularityDAO',
    address: '0x993864e43caa7f7f12953ad6feb1d1ca635b875f',
    decimals: 18,
    symbol: 'SDAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9638.png',
  },
  {
    chainId: 1,
    name: 'Pussy Financial',
    address: '0x9196e18bc349b1f64bc08784eae259525329a1ad',
    decimals: 18,
    symbol: 'PUSSY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9639.png',
  },
  {
    chainId: 1,
    name: 'Metis',
    address: '0x9E32b13ce7f2E80A01932B42553652E053D6ed8e',
    decimals: 18,
    symbol: 'METIS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png',
  },
  {
    chainId: 1,
    name: 'Don-key',
    address: '0x217ddead61a42369a266f1fb754eb5d3ebadc88a',
    decimals: 9,
    symbol: 'DON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9643.png',
  },
  {
    chainId: 1,
    name: 'CCSwap',
    address: '0xb7fbff4ce5200215c690cc95855e5d6c5236ee9f',
    decimals: 18,
    symbol: 'CC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9644.png',
  },
  {
    chainId: 1,
    name: 'Ethermon',
    address: '0xd6a5ab46ead26f49b03bbb1f9eb1ad5c1767974a',
    decimals: 18,
    symbol: 'EMON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9651.png',
  },
  {
    chainId: 1,
    name: 'Nabox',
    address: '0x03d1e72765545729a035e909edd9371a405f77fb',
    decimals: 18,
    symbol: 'NABOX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9653.png',
  },
  {
    chainId: 1,
    name: 'CateCoin',
    address: '0xf05897CfE3CE9BBBfE0751CBE6B1B2c686848DCb',
    decimals: 18,
    symbol: 'CATE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9656.png',
  },
  {
    chainId: 1,
    name: 'Pinknode',
    address: '0xAF691508BA57d416f895e32a1616dA1024e882D2',
    decimals: 18,
    symbol: 'PNODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9657.png',
  },
  {
    chainId: 1,
    name: 'Shield',
    address: '0x1ef6a7e2c966fb7c5403efefde38338b1a95a084',
    decimals: 18,
    symbol: 'SLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9662.png',
  },
  {
    chainId: 1,
    name: 'ArGo',
    address: '0x28cca76f6e8ec81e4550ecd761f899110b060e97',
    decimals: 18,
    symbol: 'ARGO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9663.png',
  },
  {
    chainId: 1,
    name: 'Terran Coin',
    address: '0x490e3f4af13e1616ec97a8c6600c1061a8d0253e',
    decimals: 18,
    symbol: 'TRR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9666.png',
  },
  {
    chainId: 1,
    name: 'GogolCoin',
    address: '0x083d41d6dd21ee938f0c055ca4fb12268df0efac',
    decimals: 18,
    symbol: 'GOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9670.png',
  },
  {
    chainId: 1,
    name: 'Loser Coin',
    address: '0x69e5C11a7C30f0bf84A9faECBd5161AA7a94decA',
    decimals: 18,
    symbol: 'LOWB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9673.png',
  },
  {
    chainId: 1,
    name: 'Wilder World',
    address: '0x2a3bff78b79a009976eea096a51a948a3dc00e34',
    decimals: 18,
    symbol: 'WILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9674.png',
  },
  {
    chainId: 1,
    name: 'Drops Ownership Power',
    address: '0x6bb61215298f296c55b19ad842d3df69021da2ef',
    decimals: 18,
    symbol: 'DOP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9675.png',
  },
  {
    chainId: 1,
    name: 'Total Crypto Market Cap Token',
    address: '0x16c52CeeCE2ed57dAd87319D91B5e3637d50aFa4',
    decimals: 18,
    symbol: 'TCAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9678.png',
  },
  {
    chainId: 1,
    name: 'Small Doge',
    address: '0x537edd52ebcb9f48ff2f8a28c51fcdb9d6a6e0d4',
    decimals: 18,
    symbol: 'SDOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9680.png',
  },
  {
    chainId: 1,
    name: 'Jomon Shiba',
    address: '0x1426cC6D52D1B14e2B3b1Cb04d57ea42B39c4c7c',
    decimals: 9,
    symbol: 'JSHIBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9685.png',
  },
  {
    chainId: 1,
    name: 'My Crypto Heroes',
    address: '0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3',
    decimals: 18,
    symbol: 'MCHC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9686.png',
  },
  {
    chainId: 1,
    name: 'Upfire',
    address: '0xf720e38f678b29b243f7d53b56acbf5de98f2385',
    decimals: 18,
    symbol: 'UPR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9694.png',
  },
  {
    chainId: 1,
    name: 'PGF500 Token',
    address: '0x9fadea1aff842d407893e21dbd0e2017b4c287b6',
    decimals: 18,
    symbol: 'PGF7T',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9697.png',
  },
  {
    chainId: 1,
    name: 'Tycoon',
    address: '0x3A82D3111aB5faF39d847D46023d9090261A658F',
    decimals: 18,
    symbol: 'TYC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9698.png',
  },
  {
    chainId: 1,
    name: 'Microtuber',
    address: '0x6876eba317272fe221c67405c5e8eb3b24535547',
    decimals: 18,
    symbol: 'MCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9700.png',
  },
  {
    chainId: 1,
    name: 'Jindoge',
    address: '0x3f4cd830543db25254ec0f05eac058d4d6e86166',
    decimals: 18,
    symbol: 'JINDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9701.png',
  },
  {
    chainId: 1,
    name: 'Shih Tzu',
    address: '0x841fb148863454a3b3570f515414759be9091465',
    decimals: 18,
    symbol: 'SHIH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9712.png',
  },
  {
    chainId: 1,
    name: 'Demodyfi',
    address: '0x5f6c5c2fb289db2228d159c69621215e354218d7',
    decimals: 18,
    symbol: 'DMOD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9713.png',
  },
  {
    chainId: 1,
    name: 'Kineko',
    address: '0x368c5290b13caa10284db58b4ad4f3e9ee8bf4c9',
    decimals: 18,
    symbol: 'KKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9718.png',
  },
  {
    chainId: 1,
    name: 'Woofy',
    address: '0xd0660cd418a64a1d44e9214ad8e459324d8157f1',
    decimals: 18,
    symbol: 'WOOFY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9719.png',
  },
  {
    chainId: 1,
    name: 'Blue Eyes White Doge',
    address: '0x37092DBF8C26DA9Cc805683B4Cc0B942E92DE2fd',
    decimals: 9,
    symbol: 'BDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9731.png',
  },
  {
    chainId: 1,
    name: 'Cryption Network',
    address: '0x429876c4a6f89fb470e92456b8313879df98b63c',
    decimals: 18,
    symbol: 'CNT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9747.png',
  },
  {
    chainId: 1,
    name: 'Renascent Finance',
    address: '0x56de8bc61346321d4f2211e3ac3c0a7f00db9b76',
    decimals: 18,
    symbol: 'RENASCENT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9748.png',
  },
  {
    chainId: 1,
    name: 'WallStreetBets DApp',
    address: '0xe1590A6FA0CFf9C960181cb77d8a873601772f64',
    decimals: 18,
    symbol: 'WSB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9749.png',
  },
  {
    chainId: 1,
    name: 'Virtue Poker',
    address: '0x5eeaa2dcb23056f4e8654a349e57ebe5e76b5e6e',
    decimals: 18,
    symbol: 'VPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9756.png',
  },
  {
    chainId: 1,
    name: 'Stratos',
    address: '0x08c32b0726C5684024ea6e141C50aDe9690bBdcc',
    decimals: 18,
    symbol: 'STOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9760.png',
  },
  {
    chainId: 1,
    name: 'MILC Platform',
    address: '0x9506d37f70eB4C3d79C398d326C871aBBf10521d',
    decimals: 18,
    symbol: 'MLT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9764.png',
  },
  {
    chainId: 1,
    name: 'Rentible',
    address: '0x20a62aca58526836165ca53fe67dd884288c8abf',
    decimals: 18,
    symbol: 'RNB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9766.png',
  },
  {
    chainId: 1,
    name: 'Papa Shiba',
    address: '0xc4d586ef7be9ebe80bd5ee4fbd228fe2db5f2c4e',
    decimals: 18,
    symbol: 'PHIBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9768.png',
  },
  {
    chainId: 1,
    name: 'Baby Shiba',
    address: '0x4a6be56a211a4c4e0dd4474d524138933c17f3e3',
    decimals: 9,
    symbol: 'BHIBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9769.png',
  },
  {
    chainId: 1,
    name: 'Lady Luck',
    address: '0x0955A73D014F0693aC7B53CFe77706dAb02b3ef9',
    decimals: 18,
    symbol: 'LUCK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9770.png',
  },
  {
    chainId: 1,
    name: 'LaikaProtocol',
    address: '0x0bfFc5692960Bb043D3216839bDD6e5E64ff1b4e',
    decimals: 9,
    symbol: 'LAIKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9776.png',
  },
  {
    chainId: 1,
    name: 'Sensitrust',
    address: '0x04E0Af0af1b7f0023c6B12af5a94Df59B0e8cF59',
    decimals: 18,
    symbol: 'SETS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9785.png',
  },
  {
    chainId: 1,
    name: 'Prism Network',
    address: '0xd46df541148932690b81092f600f35208afd4325',
    decimals: 18,
    symbol: 'PRISM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9788.png',
  },
  {
    chainId: 1,
    name: 'ETH 2x Flexible Leverage Index',
    address: '0xaa6e8127831c9de45ae56bb1b0d4d4da6e5665bd',
    decimals: 18,
    symbol: 'ETH2X-FLI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9789.png',
  },
  {
    chainId: 1,
    name: 'ACENT',
    address: '0xec5483804e637d45cde22fa0869656b64b5ab1ab',
    decimals: 18,
    symbol: 'ACE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9792.png',
  },
  {
    chainId: 1,
    name: 'Mozik',
    address: '0x7BD82B320EbC28D8EB3C4F5Fa2af7B14dA5b90C3',
    decimals: 18,
    symbol: 'MOZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9802.png',
  },
  {
    chainId: 1,
    name: 'CatJAM',
    address: '0x46F90D865E742B8e9a62FF8277B5cd70740CB916',
    decimals: 18,
    symbol: 'MEOW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9811.png',
  },
  {
    chainId: 1,
    name: 'APENFT',
    address: '0x198d14f2ad9ce69e76ea330b374de4957c3f850a',
    decimals: 18,
    symbol: 'NFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9816.png',
  },
  {
    chainId: 1,
    name: 'DeFIRE',
    address: '0xE74dC43867E0cbEB208F1a012fc60DcBbF0E3044',
    decimals: 18,
    symbol: 'CWAP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9817.png',
  },
  {
    chainId: 1,
    name: 'Metaverse NFT Index',
    address: '0x33e18a092a93ff21ad04746c7da12e35d34dc7c4',
    decimals: 18,
    symbol: 'PLAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9820.png',
  },
  {
    chainId: 1,
    name: 'SUNI',
    address: '0x4a22a69e45ab29f9f7276b0267797474daf1f27c',
    decimals: 18,
    symbol: 'SUNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9823.png',
  },
  {
    chainId: 1,
    name: 'NiiFi',
    address: '0x852e5427c86a3b46dd25e5fe027bb15f53c4bcb8',
    decimals: 15,
    symbol: 'NIIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9825.png',
  },
  {
    chainId: 1,
    name: 'Flux Protocol',
    address: '0x7645DdfEecedA57e41f92679c4aCd83c56A81D14',
    decimals: 18,
    symbol: 'FLUX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9837.png',
  },
  {
    chainId: 1,
    name: 'blockbank',
    address: '0xf4b5470523ccd314c6b9da041076e7d79e0df267',
    decimals: 18,
    symbol: 'BBANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9839.png',
  },
  {
    chainId: 1,
    name: 'Pleasure Coin',
    address: '0x8f006d1e1d9dc6c98996f50a4c810f17a47fbf19',
    decimals: 18,
    symbol: 'NSFW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9840.png',
  },
  {
    chainId: 1,
    name: 'Nami Corporation',
    address: '0x2f7B618993cc3848d6C7ed9CdD5e835E4Fe22b98',
    decimals: 18,
    symbol: 'NAMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9842.png',
  },
  {
    chainId: 1,
    name: 'CROP Finance',
    address: '0x54efda7fae8316c210cbd1bd85f8cb87bdbda461',
    decimals: 18,
    symbol: 'CROP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9850.png',
  },
  {
    chainId: 1,
    name: 'Tiger King Coin',
    address: '0x24e89bdf2f65326b94e36978a7edeac63623dafa',
    decimals: 18,
    symbol: 'TKING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9854.png',
  },
  {
    chainId: 1,
    name: 'EthereumMax',
    address: '0x15874d65e649880c2614e7a480cb7c9a55787ff6',
    decimals: 18,
    symbol: 'EMAX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9855.png',
  },
  {
    chainId: 1,
    name: 'Knit Finance',
    address: '0xef53462838000184f35f7d991452e5f25110b207',
    decimals: 18,
    symbol: 'KFT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9856.png',
  },
  {
    chainId: 1,
    name: 'Float Protocol: Float',
    address: '0xb05097849bca421a3f51b249ba6cca4af4b97cb9',
    decimals: 18,
    symbol: 'FLOAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9861.png',
  },
  {
    chainId: 1,
    name: 'Ispolink',
    address: '0xc8807f0f5ba3fa45ffbdc66928d71c5289249014',
    decimals: 18,
    symbol: 'ISP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9865.png',
  },
  {
    chainId: 1,
    name: 'FEAR',
    address: '0x88a9a52f944315d5b4e917b9689e65445c401e83',
    decimals: 18,
    symbol: 'FEAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9866.png',
  },
  {
    chainId: 1,
    name: 'Hot Cross',
    address: '0x4297394c20800e8a38a619a243e9bbe7681ff24e',
    decimals: 18,
    symbol: 'HOTCROSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9867.png',
  },
  {
    chainId: 1,
    name: 'XCAD Network',
    address: '0x7659ce147d0e714454073a5dd7003544234b6aa0',
    decimals: 18,
    symbol: 'XCAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9868.png',
  },
  {
    chainId: 1,
    name: 'Spherium',
    address: '0x8a0cdfab62ed35b836dc0633482798421c81b3ec',
    decimals: 18,
    symbol: 'SPHRI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9869.png',
  },
  {
    chainId: 1,
    name: 'Kesef Finance',
    address: '0x049e119413ab1f1b0fd836e657e3e4ba3ad9cab8',
    decimals: 18,
    symbol: 'KSF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9871.png',
  },
  {
    chainId: 1,
    name: 'Exohood',
    address: '0xbd8005612124DC30601E22D8B5d188A89767c640',
    decimals: 18,
    symbol: 'EXO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9879.png',
  },
  {
    chainId: 1,
    name: 'MILF Token',
    address: '0x0Dd1989e4B0E82f154b729FF47F8c9a4f4b2cC1C',
    decimals: 18,
    symbol: 'MILF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9884.png',
  },
  {
    chainId: 1,
    name: 'Oviex',
    address: '0x6b3760facdeb7f798cd13c0af2e4cd9ddc085122',
    decimals: 18,
    symbol: 'OVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9888.png',
  },
  {
    chainId: 1,
    name: 'Bistroo',
    address: '0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f',
    decimals: 18,
    symbol: 'BIST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9889.png',
  },
  {
    chainId: 1,
    name: 'Fundum Capital',
    address: '0xbe6c01a67bd0160fe3e731555ad014895b225dfa',
    decimals: 18,
    symbol: 'FND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9901.png',
  },
  {
    chainId: 1,
    name: 'Convex Finance',
    address: '0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b',
    decimals: 18,
    symbol: 'CVX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9903.png',
  },
  {
    chainId: 1,
    name: 'Low Orbit Crypto Cannon',
    address: '0x556938621C19e5eae58C94a806da9d237b969bd8',
    decimals: 18,
    symbol: 'LOCC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9907.png',
  },
  {
    chainId: 1,
    name: 'RUSH COIN',
    address: '0x382A1667C9062F0621362F49076Ef6e4fE4C9eC7',
    decimals: 18,
    symbol: 'RUSH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9920.png',
  },
  {
    chainId: 1,
    name: 'Corgi inu',
    address: '0xe50006781f435ae43096288334afd9ae5ba50065',
    decimals: 10,
    symbol: 'CORGI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9939.png',
  },
  {
    chainId: 1,
    name: 'American Shiba',
    address: '0xb893a8049f250b57efa8c62d51527a22404d7c9a',
    decimals: 18,
    symbol: 'USHIBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9943.png',
  },
  {
    chainId: 1,
    name: 'CenterPrime',
    address: '0x50eb3b7f3efd3fc8ece83e2012dc9367422b3f91',
    decimals: 18,
    symbol: 'CPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9945.png',
  },
  {
    chainId: 1,
    name: 'Your Future Exchange',
    address: '0xf55a93b613d172b86c2ba3981a849dae2aecde2f',
    decimals: 18,
    symbol: 'YFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9946.png',
  },
  {
    chainId: 1,
    name: 'Chihua Token',
    address: '0x26ff6d16549a00ba8b36ce3159b5277e6e798d18',
    decimals: 18,
    symbol: 'CHIHUA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9947.png',
  },
  {
    chainId: 1,
    name: 'Simba Inu',
    address: '0xea5b19c073f8074f9a8dcd693d01b6acb1c26ae4',
    decimals: 18,
    symbol: 'SIM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9948.png',
  },
  {
    chainId: 1,
    name: 'Zentachain',
    address: '0xc91f1EFFDdC4a727F4DE78E400137390779ec062',
    decimals: 18,
    symbol: 'CHAIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9950.png',
  },
  {
    chainId: 1,
    name: 'Netvrk',
    address: '0x52498F8d9791736f1D6398fE95ba3BD868114d10',
    decimals: 18,
    symbol: 'NETVR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9954.png',
  },
  {
    chainId: 1,
    name: 'SafeMoon Inu',
    address: '0xCd7492db29E2ab436e819b249452EE1bbDf52214',
    decimals: 18,
    symbol: 'SMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9958.png',
  },
  {
    chainId: 1,
    name: 'SafeBlast',
    address: '0x614D7f40701132E25fe6fc17801Fbd34212d2Eda',
    decimals: 18,
    symbol: 'BLAST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9967.png',
  },
  {
    chainId: 1,
    name: 'Freela',
    address: '0x29ceddcf0da3c1d8068a7dfbd0fb06c2e438ff70',
    decimals: 18,
    symbol: 'FREL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9976.png',
  },
  {
    chainId: 1,
    name: 'Redpanda Earth',
    address: '0x514cdb9cd8a2fb2bdcf7a3b8ddd098caf466e548',
    decimals: 9,
    symbol: 'REDPANDA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9980.png',
  },
  {
    chainId: 1,
    name: 'Hachiko Inu',
    address: '0xccac36423def6c19ee6b5679144e2976e309ca45',
    decimals: 18,
    symbol: 'HACHIKO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9988.png',
  },
  {
    chainId: 1,
    name: 'Bezoge Earth',
    address: '0xdc349913d53b446485e98b76800b6254f43df695',
    decimals: 18,
    symbol: 'BEZOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9996.png',
  },
  {
    chainId: 1,
    name: 'METANOA',
    address: '0x73474D0A549e32845F541e030C3d529de6ab8738',
    decimals: 18,
    symbol: 'NOA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9997.png',
  },
  {
    chainId: 1,
    name: 'Unicly',
    address: '0x94E0BAb2F6Ab1F19F4750E42d7349f2740513aD5',
    decimals: 18,
    symbol: 'UNIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9998.png',
  },
  {
    chainId: 1,
    name: 'Rielcoin',
    address: '0x5DC808549aB6D74815c93Fc9a2923C7fF95222CA',
    decimals: 18,
    symbol: 'RIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9999.png',
  },
  {
    chainId: 1,
    name: 'ApeHaven',
    address: '0x14dd7ebe6cb084cb73ef377e115554d47dc9d61e',
    decimals: 18,
    symbol: 'APES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10003.png',
  },
  {
    chainId: 1,
    name: 'Zoo Token',
    address: '0x1341a2257fa7b770420ef70616f888056f90926c',
    decimals: 9,
    symbol: 'ZOOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10005.png',
  },
  {
    chainId: 1,
    name: 'GTONCapital',
    address: '0x01e0e2e61f554ecaaec0cc933e739ad90f24a86d',
    decimals: 18,
    symbol: 'GTON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10006.png',
  },
  {
    chainId: 1,
    name: 'Snoop Doge',
    address: '0x072c46F392E729C1f0D92a307c2C6DBA06B5D078',
    decimals: 9,
    symbol: 'SNOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10007.png',
  },
  {
    chainId: 1,
    name: 'CoinWind',
    address: '0x34965f73Cfa05Bf8d8aF37cB4af64Fa950605Ea8',
    decimals: 18,
    symbol: 'COW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10011.png',
  },
  {
    chainId: 1,
    name: 'Panda Finance',
    address: '0x5bc52b5367b637bec5f818e69208eb9f03c426ee',
    decimals: 9,
    symbol: 'PAND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10014.png',
  },
  {
    chainId: 1,
    name: 'Dogey-Inu',
    address: '0xbb1ee07d6c7baeb702949904080eb61f5d5e7732',
    decimals: 18,
    symbol: 'DINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10021.png',
  },
  {
    chainId: 1,
    name: 'Tsuki Inu',
    address: '0xda23d301761e4e2bf474951f978f6dfb6f3c9f14',
    decimals: 9,
    symbol: 'TKINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10024.png',
  },
  {
    chainId: 1,
    name: 'Dick',
    address: '0x20af547291dfe691baf43658f2c8515076d18408',
    decimals: 18,
    symbol: 'DICK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10027.png',
  },
  {
    chainId: 1,
    name: 'NFTMart Token',
    address: '0xd81b71cbb89b2800cdb000aa277dc1491dc923c3',
    decimals: 18,
    symbol: 'NMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10033.png',
  },
  {
    chainId: 1,
    name: 'CARBON',
    address: '0xe74ac81b14021d0cfb835f269f48f25918c5cae6',
    decimals: 18,
    symbol: 'GEMS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10034.png',
  },
  {
    chainId: 1,
    name: 'Teslafan',
    address: '0x2d5bed63b0fe325ed3b865ae2cdaa3649eb25461',
    decimals: 18,
    symbol: 'TESLF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10035.png',
  },
  {
    chainId: 1,
    name: 'Alphawolf Finance',
    address: '0x0342ac5dfad866985dde477caa85027a3c01a334',
    decimals: 18,
    symbol: 'AWF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10043.png',
  },
  {
    chainId: 1,
    name: 'Cerby Token',
    address: '0xdef1fac7bf08f173d286bbbdcbeeade695129840',
    decimals: 18,
    symbol: 'CERBY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10044.png',
  },
  {
    chainId: 1,
    name: 'Polars',
    address: '0xc17fbe1d709dDf6C0B6665Dd0591046815AC7554',
    decimals: 18,
    symbol: 'POL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10045.png',
  },
  {
    chainId: 1,
    name: 'Dotmoovs',
    address: '0x4116f14b6d462b32a1c10f98049e4b1765e34fa9',
    decimals: 18,
    symbol: 'MOOV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10046.png',
  },
  {
    chainId: 1,
    name: 'EPIK Prime',
    address: '0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75',
    decimals: 18,
    symbol: 'EPIK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10047.png',
  },
  {
    chainId: 1,
    name: 'Keisuke Inu',
    address: '0xc0114f14638a333a4d5c3b04f09b96372348a842',
    decimals: 9,
    symbol: '$KEI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10048.png',
  },
  {
    chainId: 1,
    name: 'Gitcoin',
    address: '0xde30da39c46104798bb5aa3fe8b9e0e1f348163f',
    decimals: 18,
    symbol: 'GTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10052.png',
  },
  {
    chainId: 1,
    name: 'Crust Shadow',
    address: '0x2620638EDA99F9e7E902Ea24a285456EE9438861',
    decimals: 18,
    symbol: 'CSM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10055.png',
  },
  {
    chainId: 1,
    name: 'Chubby Inu',
    address: '0x910985Ffa7101Bf5801DD2e91555c465EFD9AAB3',
    decimals: 9,
    symbol: 'CHINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10056.png',
  },
  {
    chainId: 1,
    name: 'CumInu',
    address: '0xd6327ce1fb9d6020e8c2c0e124a1ec23dcab7536',
    decimals: 18,
    symbol: 'CUMINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10061.png',
  },
  {
    chainId: 1,
    name: 'BurnX 2.0',
    address: '0x1e950AF2F6f8505c09F0Ca42c4b38F10979cb22E',
    decimals: 18,
    symbol: 'BURNX20',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10072.png',
  },
  {
    chainId: 1,
    name: 'Island Coin',
    address: '0x1681bcB589b3cFCF0c0616B0cE9b19b240643dc1',
    decimals: 18,
    symbol: 'ISLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10080.png',
  },
  {
    chainId: 1,
    name: 'Friends With Benefits Pro',
    address: '0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8',
    decimals: 18,
    symbol: 'FWB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10090.png',
  },
  {
    chainId: 1,
    name: 'Apache',
    address: '0x27f8f34B33D92249a47347F83945c77b3a771974',
    decimals: 18,
    symbol: 'APACHE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10094.png',
  },
  {
    chainId: 1,
    name: 'Elk Finance',
    address: '0xeEeEEb57642040bE42185f49C52F7E9B38f8eeeE',
    decimals: 18,
    symbol: 'ELK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10095.png',
  },
  {
    chainId: 1,
    name: 'Kwikswap Protocol',
    address: '0x286c0936c7eaf6651099ab5dab9ee5a6cb5d229d',
    decimals: 18,
    symbol: 'KWIK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10101.png',
  },
  {
    chainId: 1,
    name: 'BankSocial',
    address: '0x0AF55d5fF28A3269d69B98680Fd034f115dd53Ac',
    decimals: 18,
    symbol: 'BSL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10102.png',
  },
  {
    chainId: 1,
    name: 'Lossless',
    address: '0x3b9be07d622accaed78f479bc0edabfd6397e320',
    decimals: 18,
    symbol: 'LSS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10103.png',
  },
  {
    chainId: 1,
    name: 'YaySwap',
    address: '0xa201fa1677498e61ac96c37823c7bd507086e2d0',
    decimals: 18,
    symbol: 'YAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10104.png',
  },
  {
    chainId: 1,
    name: 'Smart Trade Coin',
    address: '0x40e45890dff79e7d533797d964e64a2c0121f49a',
    decimals: 7,
    symbol: 'TRADE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10108.png',
  },
  {
    chainId: 1,
    name: 'Arche Network',
    address: '0xe293Bf6BcF1A72768dA0209F437491046359b9f2',
    decimals: 18,
    symbol: 'ARCHE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10118.png',
  },
  {
    chainId: 1,
    name: 'TeraBlock',
    address: '0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1',
    decimals: 18,
    symbol: 'TBC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10128.png',
  },
  {
    chainId: 1,
    name: 'Duet Protocol',
    address: '0xE8521b61f64Fc45A0bC3db36D2A524fe61a69b52',
    decimals: 18,
    symbol: 'DUET',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10132.png',
  },
  {
    chainId: 1,
    name: 'SIL Finance',
    address: '0x133Bb423d9248a336D2b3086b8F44A7DbFF3a13C',
    decimals: 18,
    symbol: 'SIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10136.png',
  },
  {
    chainId: 1,
    name: '0x_nodes',
    address: '0xaaca86b876ca011844b5798eca7a67591a9743c8',
    decimals: 18,
    symbol: 'BIOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10139.png',
  },
  {
    chainId: 1,
    name: 'DeFinity',
    address: '0x5F474906637bdCDA05f29C74653F6962bb0f8eDa',
    decimals: 18,
    symbol: 'DEFX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10145.png',
  },
  {
    chainId: 1,
    name: 'AstroElon',
    address: '0x97b65710d03e12775189f0d113202cc1443b0aa2',
    decimals: 9,
    symbol: 'ELONONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10166.png',
  },
  {
    chainId: 1,
    name: 'SpaceY',
    address: '0x58FaD9E3C3AE54c9BA98c3f0E4bF88aB3E8Cf3c5',
    decimals: 18,
    symbol: 'SPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10167.png',
  },
  {
    chainId: 1,
    name: 'Fire Inu',
    address: '0x60582805620370818967b32dc8cd709195b72fab',
    decimals: 18,
    symbol: 'FINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10173.png',
  },
  {
    chainId: 1,
    name: 'Gomining',
    address: '0x7Ddc52c4De30e94Be3A6A0A2b259b2850f421989',
    decimals: 18,
    symbol: 'Gomining',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10180.png',
  },
  {
    chainId: 1,
    name: 'Manifold Finance',
    address: '0xd084944d3c05CD115C09d072B9F44bA3E0E45921',
    decimals: 18,
    symbol: 'FOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10182.png',
  },
  {
    chainId: 1,
    name: 'DeSpace Protocol',
    address: '0x634239cfa331df0291653139d1a6083b9cf705e3',
    decimals: 18,
    symbol: 'DES',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10183.png',
  },
  {
    chainId: 1,
    name: 'Automata Network',
    address: '0xa2120b9e674d3fc3875f415a7df52e382f141225',
    decimals: 18,
    symbol: 'ATA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10188.png',
  },
  {
    chainId: 1,
    name: 'Hina Inu',
    address: '0xbd0a4bf098261673d5e6e600fd87ddcd756e6764',
    decimals: 9,
    symbol: 'HINA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10189.png',
  },
  {
    chainId: 1,
    name: 'Keanu Inu',
    address: '0x106552c11272420aad5d7e94f8acab9095a6c952',
    decimals: 9,
    symbol: 'KEANU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10196.png',
  },
  {
    chainId: 1,
    name: 'Erotica',
    address: '0xc1fa06e8596c3fa98ccd2113c38b6b60b6efa00d',
    decimals: 18,
    symbol: 'EROTICA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10197.png',
  },
  {
    chainId: 1,
    name: 'Dobermann',
    address: '0xe7ab45162f5979f09b0bda1cc7dfc97c270ea3d5',
    decimals: 18,
    symbol: 'DOBE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10205.png',
  },
  {
    chainId: 1,
    name: 'Vodra',
    address: '0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe',
    decimals: 18,
    symbol: 'VDR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10222.png',
  },
  {
    chainId: 1,
    name: 'Vega Protocol',
    address: '0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e',
    decimals: 18,
    symbol: 'VEGA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10223.png',
  },
  {
    chainId: 1,
    name: 'Omchain',
    address: '0x1f926b439fae4595e5951029d47616feca401b77',
    decimals: 18,
    symbol: 'OMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10228.png',
  },
  {
    chainId: 1,
    name: 'Bulk',
    address: '0xa143ac515dca260a46c742c7251ef3b268639593',
    decimals: 18,
    symbol: 'BULK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10235.png',
  },
  {
    chainId: 1,
    name: 'MAI',
    address: '0x8d6cebd76f18e1558d4db88138e2defb3909fad6',
    decimals: 18,
    symbol: 'MIMATIC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10238.png',
  },
  {
    chainId: 1,
    name: 'Pupper',
    address: '0x81dBc1c8e40C3095071949Eda9800C2209a7279A',
    decimals: 18,
    symbol: 'PUP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10242.png',
  },
  {
    chainId: 1,
    name: 'GIVE GLOBAL',
    address: '0xba8e5a4c64c1be42230910f7b39a6388f3d4297c',
    decimals: 18,
    symbol: 'GIVE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10253.png',
  },
  {
    chainId: 1,
    name: 'IBEX',
    address: '0xf655c8567e0f213e6c634cd2a68d992152161dc6',
    decimals: 18,
    symbol: 'IBEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10256.png',
  },
  {
    chainId: 1,
    name: 'Thorstarter',
    address: '0x69fa0fee221ad11012bab0fdb45d444d3d2ce71c',
    decimals: 18,
    symbol: 'XRUNE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10260.png',
  },
  {
    chainId: 1,
    name: 'KleeKai',
    address: '0xa67e9f021b9d208f7e3365b2a155e3c55b27de71',
    decimals: 18,
    symbol: 'KLEE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10262.png',
  },
  {
    chainId: 1,
    name: 'Charged Particles',
    address: '0x02d3a27ac3f55d5d91fb0f52759842696a864217',
    decimals: 18,
    symbol: 'IONX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10264.png',
  },
  {
    chainId: 1,
    name: 'Gold Fever',
    address: '0x2653891204f463fb2a2f4f412564b19e955166ae',
    decimals: 18,
    symbol: 'NGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10265.png',
  },
  {
    chainId: 1,
    name: 'Direwolf',
    address: '0xbdea5bb640dbfc4593809deec5cdb8f99b704cd2',
    decimals: 18,
    symbol: 'DIREWOLF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10266.png',
  },
  {
    chainId: 1,
    name: 'AladdinDAO',
    address: '0xb26C4B3Ca601136Daf98593feAeff9E0CA702a8D',
    decimals: 18,
    symbol: 'ALD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10272.png',
  },
  {
    chainId: 1,
    name: 'Less Network',
    address: '0x62786eeacc9246b4018e0146cb7a3efeacd9459d',
    decimals: 18,
    symbol: 'LESS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10279.png',
  },
  {
    chainId: 1,
    name: 'Bitspawn',
    address: '0xe516D78d784C77D479977BE58905B3f2b1111126',
    decimals: 18,
    symbol: 'SPWN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10285.png',
  },
  {
    chainId: 1,
    name: 'Daisy Launch Pad',
    address: '0x40955d77f87123b71b145098358a60573ac7be96',
    decimals: 18,
    symbol: 'DAISY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10289.png',
  },
  {
    chainId: 1,
    name: 'Convex CRV',
    address: '0x62b9c7356a2dc64a1969e19c23e4f579f9810aa7',
    decimals: 18,
    symbol: 'CVXCRV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10291.png',
  },
  {
    chainId: 1,
    name: 'Swarm',
    address: '0x19062190b1925b5b6689d7073fdfc8c2976ef8cb',
    decimals: 18,
    symbol: 'BZZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10293.png',
  },
  {
    chainId: 1,
    name: 'IOI Token',
    address: '0x8b3870df408ff4d7c3a26df852d41034eda11d81',
    decimals: 18,
    symbol: 'IOI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10295.png',
  },
  {
    chainId: 1,
    name: 'Sunder Goverance Token',
    address: '0xbdbf245c690d54b67c6e610a28486a2c6de08be6',
    decimals: 18,
    symbol: 'Sunder',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10298.png',
  },
  {
    chainId: 1,
    name: 'MIAMI',
    address: '0x74303d9d085a0d647ef47f9c0c424c73f3bfa6ca',
    decimals: 8,
    symbol: 'MIAMI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10299.png',
  },
  {
    chainId: 1,
    name: 'NFT STARS',
    address: '0x08037036451c768465369431da5c671ad9b37dbc',
    decimals: 18,
    symbol: 'NFTS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10311.png',
  },
  {
    chainId: 1,
    name: 'EscoinToken',
    address: '0xA2085073878152aC3090eA13D1e41bD69e60Dc99',
    decimals: 18,
    symbol: 'ELG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10312.png',
  },
  {
    chainId: 1,
    name: 'DragonBite',
    address: '0x4eed0fa8de12d5a86517f214c2f11586ba2ed88d',
    decimals: 18,
    symbol: 'BITE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10314.png',
  },
  {
    chainId: 1,
    name: 'Kombai Inu',
    address: '0x3fce6ae1f55656663ba6a5b0e0812463cf45c2ee',
    decimals: 9,
    symbol: 'KOMBAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10319.png',
  },
  {
    chainId: 1,
    name: 'PAMP.CC',
    address: '0x7f0f118d083d5175ab9d2d34c4c8fa4f43c3f47b',
    decimals: 8,
    symbol: 'PAMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10323.png',
  },
  {
    chainId: 1,
    name: 'Yuang Coin',
    address: '0x8ae005c97aa6853478c7f373b1d0f72aa92880a7',
    decimals: 18,
    symbol: 'YUANG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10327.png',
  },
  {
    chainId: 1,
    name: 'Dirty Finance',
    address: '0x4faB740779C73aA3945a5CF6025bF1b0e7F6349C',
    decimals: 18,
    symbol: 'DIRTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10328.png',
  },
  {
    chainId: 1,
    name: 'SafeSwap Governance Token',
    address: '0x2ecc48ba346a73d7d55aa5a46b5e314d9daa6161',
    decimals: 18,
    symbol: 'SSGT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10331.png',
  },
  {
    chainId: 1,
    name: 'PUGLIFE',
    address: '0xdb69c3f8977f78952303987E87153c1988CF65a9',
    decimals: 18,
    symbol: 'PUGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10333.png',
  },
  {
    chainId: 1,
    name: 'Cribnb Decentralized Renting and Sharing',
    address: '0x6767615a97a8204298bbac44c57ef1a615eed244',
    decimals: 18,
    symbol: 'CRB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10345.png',
  },
  {
    chainId: 1,
    name: 'Human',
    address: '0xd1ba9BAC957322D6e8c07a160a3A8dA11A0d2867',
    decimals: 18,
    symbol: 'HMT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10347.png',
  },
  {
    chainId: 1,
    name: 'Sarcophagus',
    address: '0x7697b462a7c4ff5f8b55bdbc2f4076c2af9cf51a',
    decimals: 18,
    symbol: 'SARCO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10348.png',
  },
  {
    chainId: 1,
    name: 'Holder Swap',
    address: '0x578301f78b7269261cea3c968f0643fb1a101e5e',
    decimals: 6,
    symbol: 'HFS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10354.png',
  },
  {
    chainId: 1,
    name: 'Peach.Finance',
    address: '0x31d939dc09a6bb55642fcbf9d56166ebc0bdec9a',
    decimals: 18,
    symbol: 'PEECH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10356.png',
  },
  {
    chainId: 1,
    name: 'Feyorra',
    address: '0xe8e06a5613dc86d459bc8fb989e173bb8b256072',
    decimals: 18,
    symbol: 'FEY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10361.png',
  },
  {
    chainId: 1,
    name: 'APWine Finance',
    address: '0x4104b135dbc9609fc1a9490e61369036497660c8',
    decimals: 18,
    symbol: 'APW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10364.png',
  },
  {
    chainId: 1,
    name: 'Cryptex Finance',
    address: '0x321c2fe4446c7c963dc41dd58879af648838f98d',
    decimals: 18,
    symbol: 'CTX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10368.png',
  },
  {
    chainId: 1,
    name: 'Global DeFi',
    address: '0xb5e88b229b18e748e3aa16a1c2bfefdfc8a5560d',
    decimals: 18,
    symbol: 'GDEFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10370.png',
  },
  {
    chainId: 1,
    name: 'Newinu',
    address: '0x1997830b5beb723f5089bb8fc38766d419a0444d',
    decimals: 9,
    symbol: 'NEWINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10371.png',
  },
  {
    chainId: 1,
    name: 'Dacxi',
    address: '0xefab7248d36585e2340e5d25f8a8d243e6e3193f',
    decimals: 18,
    symbol: 'DACXI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10372.png',
  },
  {
    chainId: 1,
    name: 'EthereumPay',
    address: '0x2b5ca2f9510cf1e3595ff219f24d75d4244585ea',
    decimals: 18,
    symbol: 'EPAY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10374.png',
  },
  {
    chainId: 1,
    name: 'dAppstore',
    address: '0x00d8318e44780edeefcf3020a5448f636788883c',
    decimals: 18,
    symbol: 'DAPPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10376.png',
  },
  {
    chainId: 1,
    name: 'Zild Finance',
    address: '0x006699d34aa3013605d468d2755a2fe59a16b12b',
    decimals: 18,
    symbol: 'ZILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10381.png',
  },
  {
    chainId: 1,
    name: 'DAO1',
    address: '0xce3f6f6672616c39d8b6858f8dac9902eca42c84',
    decimals: 18,
    symbol: 'DAO1',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10384.png',
  },
  {
    chainId: 1,
    name: 'Ally Direct Token',
    address: '0x9d561d63375672ABd02119b9Bc4FB90EB9E307Ca',
    decimals: 18,
    symbol: 'DRCT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10385.png',
  },
  {
    chainId: 1,
    name: 'Star Foxx',
    address: '0x31D457E7bcFf5Bc9A5Ef86E6a5eA1DB5b5C3BFB0',
    decimals: 18,
    symbol: 'FOXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10387.png',
  },
  {
    chainId: 1,
    name: 'Creator Platform',
    address: '0x923b83c26B3809d960fF80332Ed00aA46D7Ed375',
    decimals: 18,
    symbol: 'CTR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10391.png',
  },
  {
    chainId: 1,
    name: 'Kuma Inu',
    address: '0x48c276e8d03813224bb1e55f953adb6d02fd3e02',
    decimals: 18,
    symbol: 'KUMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10394.png',
  },
  {
    chainId: 1,
    name: 'ZKCHAOS',
    address: '0xb53de031602cd825febe9f2eedf962cd8cc3805d',
    decimals: 18,
    symbol: 'CHAOS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10401.png',
  },
  {
    chainId: 1,
    name: 'BlackPool',
    address: '0x0eC9F76202a7061eB9b3a7D6B59D36215A7e37da',
    decimals: 18,
    symbol: 'BPT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10402.png',
  },
  {
    chainId: 1,
    name: 'Integral',
    address: '0xd502f487e1841fdc805130e13eae80c61186bc98',
    decimals: 18,
    symbol: 'ITGR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10404.png',
  },
  {
    chainId: 1,
    name: 'Baby Doge Coin',
    address: '0xac57de9c1a09fec648e93eb98875b212db0d460b',
    decimals: 18,
    symbol: 'BabyDoge',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10407.png',
  },
  {
    chainId: 1,
    name: 'Formation Fi',
    address: '0x21381e026ad6d8266244f2a583b35f9e4413fa2a',
    decimals: 18,
    symbol: 'FORM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10408.png',
  },
  {
    chainId: 1,
    name: 'Opulous',
    address: '0x80d55c03180349fff4a229102f62328220a96444',
    decimals: 18,
    symbol: 'OPUL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10409.png',
  },
  {
    chainId: 1,
    name: 'Fat Doge',
    address: '0x76851a93977bea9264c32255b6457882035c7501',
    decimals: 9,
    symbol: 'FOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10416.png',
  },
  {
    chainId: 1,
    name: '2crazyNFT',
    address: '0x2c9c19ce3b15ae77c6d80aec3c1194cfd6f7f3fa',
    decimals: 18,
    symbol: '2CRZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10418.png',
  },
  {
    chainId: 1,
    name: 'sEUR',
    address: '0xd71ecff9342a5ced620049e616c5035f1db98620',
    decimals: 18,
    symbol: 'SEUR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10419.png',
  },
  {
    chainId: 1,
    name: 'UCoin',
    address: '0xa918897bd10d6dee614470c24a061b78b021b3a9',
    decimals: 18,
    symbol: 'UCOIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10420.png',
  },
  {
    chainId: 1,
    name: 'HollaEx Token',
    address: '0xD3c625F54dec647DB8780dBBe0E880eF21BA4329',
    decimals: 18,
    symbol: 'XHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10423.png',
  },
  {
    chainId: 1,
    name: 'Volatility Protocol Token',
    address: '0x5166E09628b696285E3A151e84FB977736a83575',
    decimals: 18,
    symbol: 'VOL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10424.png',
  },
  {
    chainId: 1,
    name: 'HaloDAO',
    address: '0xe94b97b6b43639e238c851a7e693f50033efd75c',
    decimals: 18,
    symbol: 'RNBW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10429.png',
  },
  {
    chainId: 1,
    name: 'Future Of Finance Fund',
    address: '0xabafa52d3d5a2c18a4c1ae24480d22b831fc0413',
    decimals: 18,
    symbol: 'FFF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10431.png',
  },
  {
    chainId: 1,
    name: 'Xiglute Coin',
    address: '0x89d3c0249307Ae570A316030764D12f53BB191FD',
    decimals: 14,
    symbol: 'XGC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10436.png',
  },
  {
    chainId: 1,
    name: 'StakeWise',
    address: '0x48c3399719b582dd63eb5aadf12a40b4c3f52fa2',
    decimals: 18,
    symbol: 'SWISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10439.png',
  },
  {
    chainId: 1,
    name: 'Jomon Inu',
    address: '0x439dd02bFd144A5d6A5967895358E0d25d5ab784',
    decimals: 9,
    symbol: 'JINU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10445.png',
  },
  {
    chainId: 1,
    name: 'EQIFI',
    address: '0xbd3de9a069648c84d27d74d701c9fa3253098b15',
    decimals: 18,
    symbol: 'EQX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10455.png',
  },
  {
    chainId: 1,
    name: 'Memecoin',
    address: '0x42dbbd5ae373fea2fc320f62d44c058522bb3758',
    decimals: 18,
    symbol: 'MEM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10461.png',
  },
  {
    chainId: 1,
    name: 'Polytrade',
    address: '0x6e5970DBd6fc7eb1f29C6D2eDF2bC4c36124C0C1',
    decimals: 18,
    symbol: 'TRADE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10465.png',
  },
  {
    chainId: 1,
    name: 'Bugg Inu',
    address: '0x1aabf9b575e4329b8c8f272428ad5e43ab4aefc8',
    decimals: 9,
    symbol: 'BUGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10479.png',
  },
  {
    chainId: 1,
    name: 'Credmark',
    address: '0x68cfb82eacb9f198d508b514d898a403c449533e',
    decimals: 18,
    symbol: 'CMK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10485.png',
  },
  {
    chainId: 1,
    name: 'Saitama V1',
    address: '0x8b3192f5eebd8579568a2ed41e6feb402f93f73f',
    decimals: 18,
    symbol: 'SAITAMA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10498.png',
  },
  {
    chainId: 1,
    name: 'BaconDAO',
    address: '0x34f797e7190c131cf630524655a618b5bd8738e7',
    decimals: 18,
    symbol: 'BACON',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10501.png',
  },
  {
    chainId: 1,
    name: 'HitBTC Token',
    address: '0x74b1af114274335598da72f5c6ed7b954a016eed',
    decimals: 18,
    symbol: 'HIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10506.png',
  },
  {
    chainId: 1,
    name: 'Instadapp',
    address: '0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb',
    decimals: 18,
    symbol: 'INST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10508.png',
  },
  {
    chainId: 1,
    name: 'Cavapoo',
    address: '0x456d8f0d25a4e787ee60c401f8b963a465148f70',
    decimals: 9,
    symbol: 'CAVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10511.png',
  },
  {
    chainId: 1,
    name: 'ARC Governance',
    address: '0x1321f1f1aa541a56c31682c57b80ecfccd9bb288',
    decimals: 18,
    symbol: 'ARCX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10515.png',
  },
  {
    chainId: 1,
    name: 'Curio Stable Coin',
    address: '0xfDcdfA378818AC358739621ddFa8582E6ac1aDcB',
    decimals: 18,
    symbol: 'CSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10519.png',
  },
  {
    chainId: 1,
    name: 'reBaked',
    address: '0xa4cb0dce4849bdcad2d553e9e68644cf40e26cce',
    decimals: 18,
    symbol: 'BAKED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10524.png',
  },
  {
    chainId: 1,
    name: 'TribeOne',
    address: '0xD85AD783cc94bd04196a13DC042A3054a9B52210',
    decimals: 18,
    symbol: 'HAKA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10526.png',
  },
  {
    chainId: 1,
    name: 'Lithium',
    address: '0x188e817b02e635d482ae4d81e25dda98a97c4a42',
    decimals: 18,
    symbol: 'LITH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10527.png',
  },
  {
    chainId: 1,
    name: 'Divergence',
    address: '0xfb782396c9b20e564a64896181c7ac8d8979d5f4',
    decimals: 18,
    symbol: 'DIVER',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10532.png',
  },
  {
    chainId: 1,
    name: 'Mindsync',
    address: '0x75387e1287Dd85482aB66102DA9f6577E027f609',
    decimals: 18,
    symbol: 'MAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10533.png',
  },
  {
    chainId: 1,
    name: 'AnimalHouse',
    address: '0xb125cceb9c6e349217d09b069a8d88dbeacf06e5',
    decimals: 9,
    symbol: 'AHOUSE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10541.png',
  },
  {
    chainId: 1,
    name: 'Ballbag Token',
    address: '0xdffdc00abf0ccd93723f56ba3179015ab4e5c1c8',
    decimals: 18,
    symbol: 'BALLBAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10543.png',
  },
  {
    chainId: 1,
    name: 'King Arthur',
    address: '0x1ca02dd95f3f1e33da7f5afe15ea866dab07af04',
    decimals: 9,
    symbol: 'BKING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10550.png',
  },
  {
    chainId: 1,
    name: 'Sekuritance',
    address: '0x887168120cb89fb06f3e74dc4af20d67df0977f6',
    decimals: 18,
    symbol: 'SKRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10554.png',
  },
  {
    chainId: 1,
    name: 'B.Protocol',
    address: '0xbbbbbbb5aa847a2003fbc6b5c16df0bd1e725f61',
    decimals: 18,
    symbol: 'BPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10556.png',
  },
  {
    chainId: 1,
    name: 'SoMee Advertising Token',
    address: '0xc9F1016d336ef77AeE75Fc11Ad64C5Ecf9121332',
    decimals: 18,
    symbol: 'SAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10560.png',
  },
  {
    chainId: 1,
    name: 'SubQuery Network',
    address: '0x09395a2A58DB45db0da254c7EAa5AC469D8bDc85',
    decimals: 18,
    symbol: 'SQT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10562.png',
  },
  {
    chainId: 1,
    name: 'Squirrel FInance 2.0',
    address: '0x84294FC9710e1252d407d3D80A84bC39001bd4A8',
    decimals: 18,
    symbol: 'NUTS2',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10564.png',
  },
  {
    chainId: 1,
    name: 'BlackHat',
    address: '0x8bcd06492416a749c9369009b3429861b7f27f6e',
    decimals: 8,
    symbol: 'BLKC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10566.png',
  },
  {
    chainId: 1,
    name: 'Binance Smart Chain Girl',
    address: '0x4E9A46EA6A22f3894aBEE2302Ad42fd3b69E21E2',
    decimals: 8,
    symbol: 'BSCGIRL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10570.png',
  },
  {
    chainId: 1,
    name: 'Be One',
    address: '0x437DAACCCF7bFafCE1aC5828804E2c792242Cd16',
    decimals: 18,
    symbol: 'BEONE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10572.png',
  },
  {
    chainId: 1,
    name: 'Jejudoge',
    address: '0x939a7a577d93ad29b64c1595b1284ce660a479b9',
    decimals: 18,
    symbol: 'JEJUDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10584.png',
  },
  {
    chainId: 1,
    name: 'Lith Token',
    address: '0x4B48068864F77261838C7849A12853FB94c77a91',
    decimals: 18,
    symbol: 'LITx',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10592.png',
  },
  {
    chainId: 1,
    name: 'Flurry Finance',
    address: '0x60F63B76E2Fc1649E57a3489162732A90ACf59FE',
    decimals: 18,
    symbol: 'FLURRY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10593.png',
  },
  {
    chainId: 1,
    name: 'LedgerScore',
    address: '0x72De803b67B6AB05B61EFab2Efdcd414D16eBF6D',
    decimals: 18,
    symbol: 'LED',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10598.png',
  },
  {
    chainId: 1,
    name: 'Immutable',
    address: '0xf57e7e7c23978c3caec3c3548e3d615c346e79ff',
    decimals: 18,
    symbol: 'IMX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10603.png',
  },
  {
    chainId: 1,
    name: 'ExPRO OLD',
    address: '0xba630d3ba20502ba07975b15c719beecc8e4ebb0',
    decimals: 18,
    symbol: 'ExPRO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10607.png',
  },
  {
    chainId: 1,
    name: 'Sake',
    address: '0xe9f84de264e91529af07fa2c746e934397810334',
    decimals: 18,
    symbol: 'SAK3',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10608.png',
  },
  {
    chainId: 1,
    name: 'SmartPad',
    address: '0x5067006f830224960fb419d7f25a3a53e9919bb0',
    decimals: 18,
    symbol: 'PAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10610.png',
  },
  {
    chainId: 1,
    name: 'Sakhalin Husky',
    address: '0x2b1fe2cea92436e8c34b7c215af66aaa2932a8b2',
    decimals: 9,
    symbol: 'SAHU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10612.png',
  },
  {
    chainId: 1,
    name: 'Empire Token',
    address: '0x9a2af0abb12bee5369b180976be01e8c80d0e7b6',
    decimals: 9,
    symbol: 'EMPIRE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10613.png',
  },
  {
    chainId: 1,
    name: 'XCarnival',
    address: '0x493CbBd4A5da462E3dbc3E5c8e2A1E37D1D03CAc',
    decimals: 18,
    symbol: 'XCV',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10622.png',
  },
  {
    chainId: 1,
    name: 'TINKU',
    address: '0x47FA4B26c1c52Bc35654F98D10Cd61b9f3E10267',
    decimals: 9,
    symbol: 'TINKU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10625.png',
  },
  {
    chainId: 1,
    name: 'Polkadog',
    address: '0xb16e967ff83de3f1e9fceafbc2c28c1c5c56ef91',
    decimals: 18,
    symbol: 'PDOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10626.png',
  },
  {
    chainId: 1,
    name: 'PussyCredit',
    address: '0xf184cdf2f96e21f4907b069ab85fb23f4b65ce7b',
    decimals: 9,
    symbol: 'PUSSC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10629.png',
  },
  {
    chainId: 1,
    name: 'Guild of Guardians',
    address: '0x9AB7bb7FdC60f4357ECFef43986818A2A3569c62',
    decimals: 18,
    symbol: 'GOG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10630.png',
  },
  {
    chainId: 1,
    name: 'Gods Unchained',
    address: '0xccc8cb5229b0ac8069c51fd58367fd1e622afd97',
    decimals: 18,
    symbol: 'GODS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10631.png',
  },
  {
    chainId: 1,
    name: 'Nimbus Governance Token',
    address: '0x639ae8f3eed18690bf451229d14953a5a5627b72',
    decimals: 18,
    symbol: 'GNBU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10632.png',
  },
  {
    chainId: 1,
    name: 'Raku Coin',
    address: '0x714599f7604144a3fE1737c440a70fc0fD6503ea',
    decimals: 18,
    symbol: 'RAKUC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10638.png',
  },
  {
    chainId: 1,
    name: 'Kawakami',
    address: '0x5552E5a89A70cB2eF5AdBbC45a6BE442fE7160Ec',
    decimals: 18,
    symbol: 'KAWA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10640.png',
  },
  {
    chainId: 1,
    name: 'GoldFarm',
    address: '0xf1b8762a7fa8C244e36F7234EDF40cFaE24394e3',
    decimals: 18,
    symbol: 'GOLD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10642.png',
  },
  {
    chainId: 1,
    name: 'Night Life Crypto',
    address: '0x1951ab088141e69a3713a351b0d55ba3acda192c',
    decimals: 8,
    symbol: 'NLIFE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10646.png',
  },
  {
    chainId: 1,
    name: 'AUTZ Token',
    address: '0x9aa53df7263a73b93ec6a5e2a767ee30da10c304',
    decimals: 9,
    symbol: 'AUTZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10660.png',
  },
  {
    chainId: 1,
    name: 'Catoshi DAO',
    address: '0xA10989335F3ba92bd43e60fBE8D42FE739412ac4',
    decimals: 18,
    symbol: 'CZATS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10663.png',
  },
  {
    chainId: 1,
    name: 'Rikkei Finance',
    address: '0xc8ef1460277ea47d179dec66d1c5f8b7f7ae5a28',
    decimals: 18,
    symbol: 'RIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10676.png',
  },
  {
    chainId: 1,
    name: 'Evanesco Network',
    address: '0xd6caf5bd23cf057f5fccce295dcc50c01c198707',
    decimals: 18,
    symbol: 'EVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10686.png',
  },
  {
    chainId: 1,
    name: 'Yield Guild Games',
    address: '0x25f8087ead173b73d6e8b84329989a8eea16cf73',
    decimals: 18,
    symbol: 'YGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10688.png',
  },
  {
    chainId: 1,
    name: 'MaticPad',
    address: '0x3bfce6d6f0d3d3f1326d86abdbe2845b4740dc2e',
    decimals: 18,
    symbol: 'MATPAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10696.png',
  },
  {
    chainId: 1,
    name: 'Musubi',
    address: '0x8ee04e1e9400d4e2091ff3a46509e246e2f34542',
    decimals: 9,
    symbol: 'MUSUBI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10708.png',
  },
  {
    chainId: 1,
    name: 'Flourishing AI',
    address: '0x6ab4ce36260f201e4e2391eca2fd7538f71e4131',
    decimals: 18,
    symbol: 'AI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10712.png',
  },
  {
    chainId: 1,
    name: 'Burp',
    address: '0x33f391f4c4fe802b70b77ae37670037a92114a7c',
    decimals: 18,
    symbol: 'BURP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10713.png',
  },
  {
    chainId: 1,
    name: 'Nobunaga Token',
    address: '0x9275e8386a5bdda160c0e621e9a6067b8fd88ea2',
    decimals: 18,
    symbol: 'NBNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10716.png',
  },
  {
    chainId: 1,
    name: 'Waves Ducks',
    address: '0xc2708a3a4ba7f64bddc1a49f92f941bc77cad23a',
    decimals: 18,
    symbol: 'EGG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10723.png',
  },
  {
    chainId: 1,
    name: 'UFO Gaming',
    address: '0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b',
    decimals: 18,
    symbol: 'UFO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10729.png',
  },
  {
    chainId: 1,
    name: 'The Yellow Blocks',
    address: '0x097b9959bfcf715513ecd30c4b1fb469ef32b743',
    decimals: 18,
    symbol: 'TYB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10733.png',
  },
  {
    chainId: 1,
    name: 'SOCIETY OF GALACTIC EXPLORATION',
    address: '0xab456bdb0a373bbac6c4a76176e9f159cacd5752',
    decimals: 9,
    symbol: 'SGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10735.png',
  },
  {
    chainId: 1,
    name: 'Kelpie Inu',
    address: '0x672d7b3333d0f069a28b73a268bc6eaec65f2e1a',
    decimals: 9,
    symbol: 'KELPIE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10736.png',
  },
  {
    chainId: 1,
    name: 'Epstein Token',
    address: '0x051cf5178f60e9def5d5a39b2a988a9f914107cb',
    decimals: 18,
    symbol: 'EPSTEIN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10738.png',
  },
  {
    chainId: 1,
    name: 'Liti Capital',
    address: '0x0b63128c40737b13647552e0c926bcfeccc35f93',
    decimals: 18,
    symbol: 'WLITI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10740.png',
  },
  {
    chainId: 1,
    name: 'zkRace',
    address: '0xf8428A5a99cb452Ea50B6Ea70b052DaA3dF4934F',
    decimals: 18,
    symbol: 'ZERC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10744.png',
  },
  {
    chainId: 1,
    name: 'ETHPad',
    address: '0x8dB1D28Ee0d822367aF8d220C0dc7cB6fe9DC442',
    decimals: 18,
    symbol: 'ETHPAD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10747.png',
  },
  {
    chainId: 1,
    name: 'Open Custody Protocol',
    address: '0x4123a133ae3c521fd134d7b13a2dec35b56c2463',
    decimals: 18,
    symbol: 'OPEN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10750.png',
  },
  {
    chainId: 1,
    name: 'Turtle',
    address: '0xf3afdc2525568ffe743801c8c54bdea1704c9adb',
    decimals: 18,
    symbol: 'TURTLE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10757.png',
  },
  {
    chainId: 1,
    name: 'rhino.fi',
    address: '0xdddddd4301a082e62e84e43f474f044423921918',
    decimals: 18,
    symbol: 'DVF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10759.png',
  },
  {
    chainId: 1,
    name: 'The Cosby Token',
    address: '0x3877de5f6f091c3500553b9b61d654ec4190fba9',
    decimals: 9,
    symbol: 'COSBY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10760.png',
  },
  {
    chainId: 1,
    name: 'SafeBreast Inu',
    address: '0x77a2bf0bda9775fb3524a6720dd3b16bd455e2c2',
    decimals: 9,
    symbol: 'BREAST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10770.png',
  },
  {
    chainId: 1,
    name: 'Locklet',
    address: '0xd9b89eee86b15634c70cab51baf85615a4ab91a1',
    decimals: 18,
    symbol: 'LKT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10775.png',
  },
  {
    chainId: 1,
    name: 'LOVE EARTH COIN',
    address: '0xFa30e62EEDcf80D47d42947fBCc034beeD5C09FE',
    decimals: 18,
    symbol: 'LEC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10779.png',
  },
  {
    chainId: 1,
    name: 'Wasder',
    address: '0x0c572544a4Ee47904d54aaA6A970AF96B6f00E1b',
    decimals: 18,
    symbol: 'WAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10781.png',
  },
  {
    chainId: 1,
    name: 'SWAPP Protocol',
    address: '0x8cb924583681cbfe487a62140a994a49f833c244',
    decimals: 18,
    symbol: 'SWAPP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10783.png',
  },
  {
    chainId: 1,
    name: 'Tether EURt',
    address: '0xc581b735a1688071a1746c968e0798d642ede491',
    decimals: 18,
    symbol: 'EURt',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10789.png',
  },
  {
    chainId: 1,
    name: "Arty's World",
    address: '0xD0549D3C59fACbD091e548600C1EC53D762AA66B',
    decimals: 9,
    symbol: 'ARTY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10790.png',
  },
  {
    chainId: 1,
    name: 'SCIFI Index',
    address: '0xfdc4a3fc36df16a78edcaf1b837d3acaaedb2cb4',
    decimals: 18,
    symbol: 'SCIFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10799.png',
  },
  {
    chainId: 1,
    name: 'FLOKI',
    address: '0xcf0c122c6b73ff809c693db761e7baebe62b6a2e',
    decimals: 18,
    symbol: 'FLOKI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10804.png',
  },
  {
    chainId: 1,
    name: 'Throne',
    address: '0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9',
    decimals: 18,
    symbol: 'THN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10805.png',
  },
  {
    chainId: 1,
    name: 'CoinW Token',
    address: '0x901ea3606d567f9f1e964639d5cbb8659080be8a',
    decimals: 18,
    symbol: 'CWT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10807.png',
  },
  {
    chainId: 1,
    name: 'Inari',
    address: '0xca75c43f8c9afd356c585ce7aa4490b48a95c466',
    decimals: 9,
    symbol: 'INARI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10809.png',
  },
  {
    chainId: 1,
    name: 'Yieldly',
    address: '0x88cb253d4c8cab8cdf7948a9251db85a13669e23',
    decimals: 18,
    symbol: 'YLDY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10820.png',
  },
  {
    chainId: 1,
    name: 'Starlink',
    address: '0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24',
    decimals: 18,
    symbol: 'STARL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10821.png',
  },
  {
    chainId: 1,
    name: 'ZORT',
    address: '0x88f63bad4ac839704616b63f677cecb165963b1f',
    decimals: 18,
    symbol: 'ZORTAI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10830.png',
  },
  {
    chainId: 1,
    name: 'Mimo Governance Token',
    address: '0x90b831fa3bebf58e9744a14d638e25b4ee06f9bc',
    decimals: 18,
    symbol: 'MIMO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10831.png',
  },
  {
    chainId: 1,
    name: 'Etherlite',
    address: '0x71abbd6b628da7874e9861b6a9e5d67b10eec729',
    decimals: 18,
    symbol: 'ETL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10832.png',
  },
  {
    chainId: 1,
    name: 'Zerogoki',
    address: '0x011864d37035439e078d64630777ec518138af05',
    decimals: 18,
    symbol: 'REI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10844.png',
  },
  {
    chainId: 1,
    name: 'Zerogoki USD',
    address: '0x76417e660df3e5c90c0361674c192da152a806e4',
    decimals: 18,
    symbol: 'zUSD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10845.png',
  },
  {
    chainId: 1,
    name: 'CFL 365 Finance',
    address: '0xcd6adc6b8bd396e2d53ccd7d7257b4de55be4fbe',
    decimals: 18,
    symbol: 'CFL365',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10850.png',
  },
  {
    chainId: 1,
    name: 'Railgun',
    address: '0xe76c6c83af64e4c60245d8c7de953df673a7a33d',
    decimals: 18,
    symbol: 'RAIL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10854.png',
  },
  {
    chainId: 1,
    name: 'Ponzu Inu',
    address: '0xda4c27a9fbdde1f5f3af0398396be4644dcec715',
    decimals: 18,
    symbol: 'PONZU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10859.png',
  },
  {
    chainId: 1,
    name: 'Collateral Pay Governance',
    address: '0xc92276872cd1907d2e00b58a81a9bbd275b0a4ba',
    decimals: 18,
    symbol: 'COLLG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10860.png',
  },
  {
    chainId: 1,
    name: 'Gamestarter',
    address: '0xD567B5F02b9073aD3a982a099a23Bf019FF11d1c',
    decimals: 5,
    symbol: 'GAME',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10861.png',
  },
  {
    chainId: 1,
    name: 'ARTH Valuecoin',
    address: '0x8cc0f052fff7ead7f2edcccac895502e884a8a71',
    decimals: 18,
    symbol: 'ARTH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10865.png',
  },
  {
    chainId: 1,
    name: 'Million',
    address: '0x6b4c7a5e3f0b99fcd83e9c089bddd6c7fce5c611',
    decimals: 18,
    symbol: 'MM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10866.png',
  },
  {
    chainId: 1,
    name: 'DOOR',
    address: '0x7d48fbe0a877bb1f511fcf9b57f12420c75841e9',
    decimals: 18,
    symbol: 'DOOR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10873.png',
  },
  {
    chainId: 1,
    name: 'Shiberus Inu',
    address: '0x2dfac6327dce9f88e31ff46de13049eca5a7dfcb',
    decimals: 9,
    symbol: 'SHIBERUS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10874.png',
  },
  {
    chainId: 1,
    name: 'Concern Poverty Chain',
    address: '0x35a23bc27c345b36dee700a256f69c6334030971',
    decimals: 9,
    symbol: 'CHY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10885.png',
  },
  {
    chainId: 1,
    name: 'YOLOrekt',
    address: '0x811648E10C9cD7f7517644928f3B45FB953c4db4',
    decimals: 18,
    symbol: 'YOLO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10890.png',
  },
  {
    chainId: 1,
    name: 'Brokoli Network',
    address: '0x4674a4F24C5f63D53F22490Fb3A08eAAAD739ff8',
    decimals: 18,
    symbol: 'BRKL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10893.png',
  },
  {
    chainId: 1,
    name: 'CumStar',
    address: '0xD7bCa643468C1B2141F3cB64D53Dd5Dc1138c9a0',
    decimals: 18,
    symbol: 'CUMSTAR',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10896.png',
  },
  {
    chainId: 1,
    name: 'Wrapped Centrifuge',
    address: '0xc221b7e65ffc80de234bbb6667abdd46593d34f0',
    decimals: 18,
    symbol: 'WCFG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10898.png',
  },
  {
    chainId: 1,
    name: 'Hachiko Inu',
    address: '0xf32aa187d5bc16a2c02a6afb7df1459d0d107574',
    decimals: 18,
    symbol: 'INU',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10900.png',
  },
  {
    chainId: 1,
    name: 'Coin98',
    address: '0xae12c5930881c53715b369cec7606b70d8eb229f',
    decimals: 18,
    symbol: 'C98',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10903.png',
  },
  {
    chainId: 1,
    name: 'Unicly Genesis MoonCats Collection',
    address: '0xd4f2249dd6c26446f1413f6d97f14fcaa7792545',
    decimals: 18,
    symbol: 'UGMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10909.png',
  },
  {
    chainId: 1,
    name: 'Crypto Village Accelerator',
    address: '0x72a66e54b66892ae3bbe54df7bb7dd5ae927a6f9',
    decimals: 18,
    symbol: 'CVAG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10918.png',
  },
  {
    chainId: 1,
    name: 'CoinsPaid',
    address: '0x9b31bb425d8263fa1b8b9d090b83cf0c31665355',
    decimals: 18,
    symbol: 'CPD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10919.png',
  },
  {
    chainId: 1,
    name: 'Impossible Finance',
    address: '0xb0e1fc65c1a741b4662b813eb787d369b8614af1',
    decimals: 18,
    symbol: 'IF',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10932.png',
  },
  {
    chainId: 1,
    name: 'Impossible Finance Launchpad',
    address: '0x0b15ddf19d47e6a86a56148fb4afffc6929bcb89',
    decimals: 18,
    symbol: 'IDIA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10933.png',
  },
  {
    chainId: 1,
    name: 'BulleX',
    address: '0xd8F78f74EbEEf253c05ed2910B4863722849E95A',
    decimals: 18,
    symbol: 'BLX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10939.png',
  },
  {
    chainId: 1,
    name: 'GODL',
    address: '0x7f509465c38b66bdecec2cfdc842e11809cc8357',
    decimals: 18,
    symbol: 'GODL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10947.png',
  },
  {
    chainId: 1,
    name: 'Baanx',
    address: '0x6b1a8f210ec6b7b6643cea3583fb0c079f367898',
    decimals: 18,
    symbol: 'BXX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10949.png',
  },
  {
    chainId: 1,
    name: 'GAT Network',
    address: '0x0A199B98fF450bBc883671382B21BDA3FA44b4Ae',
    decimals: 18,
    symbol: 'GAT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10950.png',
  },
  {
    chainId: 1,
    name: 'MContent',
    address: '0xD3c51de3E6DD9b53D7f37699AFB3EE3Bf9B9b3F4',
    decimals: 18,
    symbol: 'MCONTENT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10954.png',
  },
  {
    chainId: 1,
    name: 'QAO',
    address: '0x3402e15b3ea0f1aec2679c4be4c6d051cef93953',
    decimals: 18,
    symbol: 'QAO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10962.png',
  },
  {
    chainId: 1,
    name: 'Wolfystreetbets',
    address: '0x7dbbcae15d4db168e01673400d7844870cc1e36f',
    decimals: 9,
    symbol: 'WOLFY',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10963.png',
  },
  {
    chainId: 1,
    name: 'BabyDoge ETH',
    address: '0xac8e13ecc30da7ff04b842f21a62a1fb0f10ebd5',
    decimals: 9,
    symbol: 'BABYDOGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10970.png',
  },
  {
    chainId: 1,
    name: 'PureFi Protocol',
    address: '0xcDa4e840411C00a614aD9205CAEC807c7458a0E3',
    decimals: 18,
    symbol: 'UFI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10973.png',
  },
  {
    chainId: 1,
    name: 'Universe.XYZ',
    address: '0x618679df9efcd19694bb1daa8d00718eacfa2883',
    decimals: 18,
    symbol: 'XYZ',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10979.png',
  },
  {
    chainId: 1,
    name: 'Digies Coin',
    address: '0x7333cbf5b0b843b4129e234f791b0058347f671a',
    decimals: 9,
    symbol: 'DIGS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10980.png',
  },
  {
    chainId: 1,
    name: 'Witch Token',
    address: '0xdc524e3c6910257744c1f93cf15e9f472b5bd236',
    decimals: 18,
    symbol: 'WITCH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10984.png',
  },
  {
    chainId: 1,
    name: 'DAppNode',
    address: '0xDa007777D86AC6d989cC9f79A73261b3fC5e0DA0',
    decimals: 18,
    symbol: 'NODE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10990.png',
  },
  {
    chainId: 1,
    name: 'Baby Cuban',
    address: '0xd21730353086b0d6c34656ca74f4e4295dc9b8e0',
    decimals: 18,
    symbol: 'BABYCUBAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10995.png',
  },
  {
    chainId: 1,
    name: 'Aave AMM USDT',
    address: '0x17a79792Fe6fE5C95dFE95Fe3fCEE3CAf4fE4Cb7',
    decimals: 6,
    symbol: 'AAMMUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10996.png',
  },
  {
    chainId: 1,
    name: 'Wild Credit',
    address: '0x403d512AB96103562DCaFe4635545E8Ee2753f6e',
    decimals: 18,
    symbol: 'WILD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10998.png',
  },
  {
    chainId: 1,
    name: 'Projekt Diamond',
    address: '0x53109fe9e044f2c324d00ad85bfb0b13ce379480',
    decimals: 9,
    symbol: 'DIAMND',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11011.png',
  },
  {
    chainId: 1,
    name: 'CryptoArt.Ai',
    address: '0x5c8c8d560048f34e5f7f8ad71f2f81a89dbd273e',
    decimals: 18,
    symbol: 'CART',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11018.png',
  },
  {
    chainId: 1,
    name: 'Corite',
    address: '0x936B6659Ad0C1b244Ba8Efe639092acae30dc8d6',
    decimals: 18,
    symbol: 'CO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11021.png',
  },
  {
    chainId: 1,
    name: 'PackagePortal',
    address: '0x0c7c5b92893A522952EB4c939aA24B65FF910C48',
    decimals: 18,
    symbol: 'PORT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11022.png',
  },
  {
    chainId: 1,
    name: 'SafeBank ETH',
    address: '0x43acedd39ba4b0bfccd92897fce617fb90a971d8',
    decimals: 18,
    symbol: 'SBANK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11025.png',
  },
  {
    chainId: 1,
    name: 'Spacelens',
    address: '0xcc7ab8d78dba187dc95bf3bb86e65e0c26d0041f',
    decimals: 18,
    symbol: 'SPACE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11026.png',
  },
  {
    chainId: 1,
    name: 'TAIYO',
    address: '0x13db9034c9ca6cb739887288fce790544a476f8c',
    decimals: 9,
    symbol: 'TAIYO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11030.png',
  },
  {
    chainId: 1,
    name: 'Splintershards',
    address: '0x00813e3421e1367353bfe7615c7f7f133c89df74',
    decimals: 18,
    symbol: 'SPS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11035.png',
  },
  {
    chainId: 1,
    name: 'Alkimi',
    address: '0x3106a0a076BeDAE847652F42ef07FD58589E001f',
    decimals: 18,
    symbol: '$ADS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11036.png',
  },
  {
    chainId: 1,
    name: 'AMC FIGHT NIGHT',
    address: '0x7603de2ea4cbceb0250118de03fcb70fe1e8e935',
    decimals: 18,
    symbol: 'AMC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11039.png',
  },
  {
    chainId: 1,
    name: 'Gambler Shiba',
    address: '0xb892249939adbf6d7851864ca9a5c7d2d537af97',
    decimals: 18,
    symbol: 'GSHIBA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11043.png',
  },
  {
    chainId: 1,
    name: 'HODL Token',
    address: '0xe2a083397521968eb05585932750634bed4b7d56',
    decimals: 18,
    symbol: 'HODL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11044.png',
  },
  {
    chainId: 1,
    name: 'Shibmerican',
    address: '0x440238cc07186adea6653a2e8cb9a24737615609',
    decimals: 9,
    symbol: 'SHIBMERICAN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11048.png',
  },
  {
    chainId: 1,
    name: 'MultiMillion',
    address: '0x5b558564b57e4ff88c6b8d8e7eeee599bf79b368',
    decimals: 18,
    symbol: 'MMM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11049.png',
  },
  {
    chainId: 1,
    name: 'Cogecoin',
    address: '0xc382e04099a435439725bb40647e2b32dc136806',
    decimals: 18,
    symbol: 'COGE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11053.png',
  },
  {
    chainId: 1,
    name: 'SaveBritney',
    address: '0x606ce698aea1dca5a2627a4583da13a340667f09',
    decimals: 18,
    symbol: 'SBRT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11055.png',
  },
  {
    chainId: 1,
    name: 'Multiverse',
    address: '0xc91b523a59acc63a64f61fc7bbfb4bfc82dd25f2',
    decimals: 18,
    symbol: 'AI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11061.png',
  },
  {
    chainId: 1,
    name: 'bRing.Finance',
    address: '0x3ecb96039340630c8b82e5a7732bc88b2aeade82',
    decimals: 18,
    symbol: 'BRNG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11064.png',
  },
  {
    chainId: 1,
    name: 'DinoX',
    address: '0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a',
    decimals: 18,
    symbol: 'DNXC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11066.png',
  },
  {
    chainId: 1,
    name: 'Bumper',
    address: '0x785c34312dfa6b74f6f1829f79ade39042222168',
    decimals: 18,
    symbol: 'BUMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11069.png',
  },
  {
    chainId: 1,
    name: '1-UP Platform',
    address: '0xC86817249634ac209bc73fCa1712bBd75E37407d',
    decimals: 18,
    symbol: '1-UP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11074.png',
  },
  {
    chainId: 1,
    name: 'Bitgert',
    address: '0xF2B2f7b47715256Ce4eA43363a867fdce9353e3A',
    decimals: 18,
    symbol: 'BRISE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11079.png',
  },
  {
    chainId: 1,
    name: 'BitBase Token',
    address: '0x32E6C34Cd57087aBBD59B5A4AECC4cB495924356',
    decimals: 18,
    symbol: 'BTBS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11085.png',
  },
  {
    chainId: 1,
    name: 'Gamerse',
    address: '0x969786c4a8884013d1c9ff18dcca2aedbbbfaa8f',
    decimals: 18,
    symbol: 'LFG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11086.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Chain Token',
    address: '0x59d71082d8a5b18ebc6b653ae422ac4383cd2597',
    decimals: 9,
    symbol: 'ECT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11087.png',
  },
  {
    chainId: 1,
    name: 'Enjinstarter',
    address: '0x96610186F3ab8d73EBEe1CF950C750f3B1Fb79C2',
    decimals: 18,
    symbol: 'EJS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11088.png',
  },
  {
    chainId: 1,
    name: 'Invitoken',
    address: '0x356A5160F2B34BC8d88FB084745465eBBbed0174',
    decimals: 13,
    symbol: 'INVI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11090.png',
  },
  {
    chainId: 1,
    name: 'Bitget Token',
    address: '0x19de6b897ed14a376dda0fe53a5420d2ac828a28',
    decimals: 18,
    symbol: 'BGB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11092.png',
  },
  {
    chainId: 1,
    name: 'Strike WBTC',
    address: '0x9d1C2A187cf908aEd8CFAe2353Ef72F06223d54D',
    decimals: 8,
    symbol: 'sWBTC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11095.png',
  },
  {
    chainId: 1,
    name: 'Strike USDT',
    address: '0x69702cfd7DAd8bCcAA24D6B440159404AAA140F5',
    decimals: 8,
    symbol: 'sUSDT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11096.png',
  },
  {
    chainId: 1,
    name: 'Strike USDC',
    address: '0x3774E825d567125988Fb293e926064B6FAa71DAB',
    decimals: 8,
    symbol: 'sUSDC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11097.png',
  },
  {
    chainId: 1,
    name: 'Strike UNI',
    address: '0x280f76a218DDC8d56B490B5835e251E55a2e8F8d',
    decimals: 8,
    symbol: 'sUNI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11098.png',
  },
  {
    chainId: 1,
    name: 'Strike LINK',
    address: '0x3F3B3B269d9f7088B022290906acff8710914be1',
    decimals: 8,
    symbol: 'sLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11100.png',
  },
  {
    chainId: 1,
    name: 'Strike Compound',
    address: '0xb7E11002228D599F2a64b0C44D2299C9c644ff26',
    decimals: 8,
    symbol: 'sCOMP',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11101.png',
  },
  {
    chainId: 1,
    name: 'Strike STRK',
    address: '0x4164e5b047842Ad7dFf18fc6A6e63a1e40610f46',
    decimals: 8,
    symbol: 'sSTRK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11102.png',
  },
  {
    chainId: 1,
    name: 'Strike ETH',
    address: '0xbEe9Cf658702527b0AcB2719c1FAA29EdC006a92',
    decimals: 8,
    symbol: 'sETH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11103.png',
  },
  {
    chainId: 1,
    name: 'Spores Network',
    address: '0xcbE771323587EA16dACB6016e269D7F08A7ACC4E',
    decimals: 18,
    symbol: 'SPO',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11110.png',
  },
  {
    chainId: 1,
    name: 'Unipilot',
    address: '0x37c997b35c619c21323f3518b9357914e8b99525',
    decimals: 18,
    symbol: 'PILOT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11113.png',
  },
  {
    chainId: 1,
    name: 'Rewards',
    address: '0xd80f72a6558ec337e0d4cf76b8752b17fa770860',
    decimals: 18,
    symbol: 'RWD',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11121.png',
  },
  {
    chainId: 1,
    name: 'Hypersign Identity',
    address: '0xb14ebf566511b9e6002bb286016ab2497b9b9c9d',
    decimals: 18,
    symbol: 'HID',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11126.png',
  },
  {
    chainId: 1,
    name: 'Tenshi',
    address: '0x52662717e448be36cb54588499d5a8328bd95292',
    decimals: 18,
    symbol: 'TENSHI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11149.png',
  },
  {
    chainId: 1,
    name: 'DeFine',
    address: '0x62959c699a52ec647622c91e79ce73344e4099f5',
    decimals: 18,
    symbol: 'DFA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11150.png',
  },
  {
    chainId: 1,
    name: 'Shiba Link',
    address: '0x3de7148c41e3b3233f3310e794f68d8e70ca69af',
    decimals: 9,
    symbol: 'SLINK',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11151.png',
  },
  {
    chainId: 1,
    name: 'EmiSwap',
    address: '0x5a75a093747b72a0e14056352751edf03518031d',
    decimals: 18,
    symbol: 'ESW',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11153.png',
  },
  {
    chainId: 1,
    name: 'SubGame',
    address: '0x4b4eb5c44d50bfd44124688c6754633f7e258b01',
    decimals: 18,
    symbol: 'SGB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11158.png',
  },
  {
    chainId: 1,
    name: 'BOY X HIGHSPEED',
    address: '0xEb637A9Ab6Be83c7F8c79fdAA62E1043b65534F0',
    decimals: 18,
    symbol: 'BXH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11160.png',
  },
  {
    chainId: 1,
    name: 'Vabble',
    address: '0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04',
    decimals: 18,
    symbol: 'VAB',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11164.png',
  },
  {
    chainId: 1,
    name: 'Vent Finance',
    address: '0x5f0bc16d50f72d10b719dbf6845de2e599eb5624',
    decimals: 18,
    symbol: 'VENT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11168.png',
  },
  {
    chainId: 1,
    name: 'Wrapped LUNA Classic',
    address: '0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9',
    decimals: 18,
    symbol: 'WLUNC',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11178.png',
  },
  {
    chainId: 1,
    name: 'ViceToken',
    address: '0xdfd5bb6ce8716822b2c9b255560194ca3509bebc',
    decimals: 9,
    symbol: 'VICEX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11187.png',
  },
  {
    chainId: 1,
    name: 'Dopex',
    address: '0xeec2be5c91ae7f8a338e1e5f3b5de49d07afdc81',
    decimals: 18,
    symbol: 'DPX',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11188.png',
  },
  {
    chainId: 1,
    name: 'Bright Union',
    address: '0xbeab712832112bd7664226db7cd025b153d3af55',
    decimals: 18,
    symbol: 'BRIGHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11193.png',
  },
  {
    chainId: 1,
    name: 'Tokemak',
    address: '0x2e9d63788249371f1DFC918a52f8d799F4a38C94',
    decimals: 18,
    symbol: 'TOKE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11202.png',
  },
  {
    chainId: 1,
    name: 'Bitcoin Asia',
    address: '0x7dB02Aa39A3d0271e4c61C04D03857a10fc922c5',
    decimals: 18,
    symbol: 'BTCA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11207.png',
  },
  {
    chainId: 1,
    name: 'SumSwap',
    address: '0x043c308bb8a5ae96d0093444be7f56459f1340b1',
    decimals: 18,
    symbol: 'SUM',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11208.png',
  },
  {
    chainId: 1,
    name: 'TRAVA.FINANCE',
    address: '0x186d0ba3dfc3386c464eecd96a61fbb1e2da00bf',
    decimals: 18,
    symbol: 'TRAVA',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11209.png',
  },
  {
    chainId: 1,
    name: 'Ethereum Eagle',
    address: '0x1e83916ea2ef2d7a6064775662e163b2d4c330a7',
    decimals: 18,
    symbol: 'EGL',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11210.png',
  },
  {
    chainId: 1,
    name: 'Star Atlas',
    address: '0xb9F747162AB1E95d07361f9048BcDF6eDdA9eEA7',
    decimals: 18,
    symbol: 'ATLAS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11212.png',
  },
  {
    chainId: 1,
    name: 'Boost',
    address: '0x302cae5dcf8f051d0177043c3438020b89b33218',
    decimals: 18,
    symbol: 'BOOST',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11216.png',
  },
  {
    chainId: 1,
    name: 'Chronic Token',
    address: '0x19fab8f7dffff38268644eaebd3d538f68036000',
    decimals: 18,
    symbol: 'CHT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11217.png',
  },
  {
    chainId: 1,
    name: 'BoringDAO',
    address: '0xbc19712feb3a26080ebf6f2f7849b417fdd792ca',
    decimals: 18,
    symbol: 'BORING',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11218.png',
  },
  {
    chainId: 1,
    name: 'BitDAO',
    address: '0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5',
    decimals: 18,
    symbol: 'BIT',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11221.png',
  },
  {
    chainId: 1,
    name: 'Nine Chronicles',
    address: '0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817',
    decimals: 18,
    symbol: 'WNCG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11222.png',
  },
  {
    chainId: 1,
    name: 'BabyPunks',
    address: '0x095648BC80a7d1Dd16B85E9B84F07463a20f3536',
    decimals: 18,
    symbol: 'BPUNKS',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11226.png',
  },
  {
    chainId: 1,
    name: 'Puppies Network',
    address: '0x95f49ae439537e50CED0374c1B52C42AA899741C',
    decimals: 9,
    symbol: 'PPN',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11229.png',
  },
  {
    chainId: 1,
    name: 'Highstreet',
    address: '0x71Ab77b7dbB4fa7e017BC15090b2163221420282',
    decimals: 18,
    symbol: 'HIGH',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11232.png',
  },
  {
    chainId: 1,
    name: 'BabyPenguin',
    address: '0xbe46985ee59830e18c02dfa143000dba7ac967dd',
    decimals: 18,
    symbol: 'BPENG',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11238.png',
  },
  {
    chainId: 1,
    name: 'HI',
    address: '0xC4f6E93AEDdc11dc22268488465bAbcAF09399aC',
    decimals: 18,
    symbol: 'HI',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11240.png',
  },
  {
    chainId: 1,
    name: 'EveryApe',
    address: '0x69d1ff85004a445a892dfbd88df00d48fb0af638',
    decimals: 9,
    symbol: 'EVAPE',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11241.png',
  },
  {
    chainId: 1,
    address: '0xf250b1f6193941bb8bff4152d719edf1a59c0e69',
    name: 'AiRealm Tech',
    symbol: 'AIRM',
    decimals: 18,
    logoURI: 'https://assets.coingecko.com/coins/images/35066/thumb/IMG_20240203_120402_573.png?1707287784',
  },
  {
    chainId: 1,
    address: '0x9cAAe40DCF950aFEA443119e51E821D6FE2437ca',
    name: 'Blocjerk',
    symbol: 'BJ',
    decimals: 18,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/30181.png',
  },
]